webpackJsonp([2,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _main = __webpack_require__(377);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _vue = __webpack_require__(4);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(147);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vuex = __webpack_require__(930);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _vuexRouterSync = __webpack_require__(929);
	
	var _main3 = __webpack_require__(292);
	
	var _main4 = _interopRequireDefault(_main3);
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _qs = __webpack_require__(627);
	
	var _qs2 = _interopRequireDefault(_qs);
	
	var _imgReloader = __webpack_require__(290);
	
	var _imgReloader2 = _interopRequireDefault(_imgReloader);
	
	var _vueMeta = __webpack_require__(928);
	
	var _vueMeta2 = _interopRequireDefault(_vueMeta);
	
	var _vueGmaps = __webpack_require__(707);
	
	var _vueGmaps2 = _interopRequireDefault(_vueGmaps);
	
	__webpack_require__(311);
	
	__webpack_require__(310);
	
	__webpack_require__(10);
	
	var _store = __webpack_require__(309);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _router = __webpack_require__(30);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _Index = __webpack_require__(739);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(376).polyfill();
	
	_axios2.default.defaults.paramsSerializer = function (params) {
	    return _qs2.default.stringify(params, { arrayFormat: 'brackets' });
	};
	
	_vue2.default.use(_vueRouter2.default);
	_vue2.default.use(_vuex2.default);
	_vue2.default.use(_vueMeta2.default);
	
	 true ? _vue2.default.use(_main4.default, 'https://www.develteam.com/') : _vue2.default.use(_main4.default, 'http://127.0.0.1:1337/');
	
	_vue2.default.config.productionTip = false;
	
	_vue2.default.use(_vueGmaps2.default, {
	    key: 'AIzaSyCWfnTRxeRTJkkdtgzS7-1pDAxzIbKyTxI',
	    libraries: ['places']
	});
	
	var store = (0, _store2.default)({ Vue: _vue2.default, Vuex: _vuex2.default });
	
	(0, _vuexRouterSync.sync)(store, _router2.default);
	
	var app = new _vue2.default({
	    el: '#app',
	    router: _router2.default,
	    store: store,
	
	    render: function render(createElement) {
	        return createElement(_Index2.default);
	    },
	
	    mounted: function mounted() {
	        var self = this;
	
	        store.dispatch('loggedUserModel/getLoggedUserInfo', function (user) {
	            self.$socket.emit("setUserSocketData", user);
	        });
	
	        store.dispatch('develteamData/buildData');
	        store.dispatch('develteamData/getTotals');
	    },
	
	
	    sockets: {
	        'serverReconnect': function serverReconnect() {
	            var self = this;
	
	            store.dispatch('loggedUserModel/getLoggedUserInfo', function (user) {
	                self.$socket.emit("setUserSocketData", user);
	            });
	        },
	        'updateUserInfo': function updateUserInfo() {
	            var self = this;
	
	            store.dispatch('loggedUserModel/getLoggedUserInfo', function (user) {
	                self.$socket.emit("setUserSocketData", user);
	            });
	        },
	        'newDeveloperOrGameRegistered': function newDeveloperOrGameRegistered() {
	            store.dispatch('develteamData/getTotals');
	        },
	        'avatarUpdated': function avatarUpdated(data) {
	            (0, _imgReloader2.default)('/userdata/avatars/' + data.type + '_' + data.id + '.jpg');
	        },
	        'newPost': function newPost(data) {
	            this.$store.commit('feedPosts/appendPost', data);
	        },
	        'editedPost': function editedPost(data) {
	            if (data.commentData && data.parentData) {
	                this.$store.commit('feedPosts/updateComment', data);
	                this.$store.commit('medias/updateComment', data);
	            }
	
	            if (data.type === 'status' || data.type === 'media') {
	                this.$store.commit('feedPosts/updatePost', data);
	            }
	        },
	        'deletedPost': function deletedPost(data) {
	            if (data.type === 'comment') {
	                this.$store.commit('feedPosts/deleteComment', data);
	                this.$store.commit('medias/deleteComment', data);
	            }
	
	            if (data.type === 'status' || data.type === 'media') {
	                this.$store.commit('feedPosts/deletePost', data);
	            }
	        },
	        'pinnedPost': function pinnedPost(data) {
	            this.$store.commit('feedPosts/pinnedPost', data);
	        },
	        'newPostComment': function newPostComment(data) {
	            this.$store.commit('feedPosts/appendComment', data);
	            this.$store.commit('medias/appendComment', data);
	        },
	        'mediaAlbumAddOrEdit': function mediaAlbumAddOrEdit(data) {
	            this.$store.commit('medias/mediaAlbumAddOrEdit', data);
	        },
	        'mediaAlbumDelete': function mediaAlbumDelete(data) {
	            this.$store.commit('medias/mediaAlbumDelete', data);
	        },
	        'mediaPieceAddOrEdit': function mediaPieceAddOrEdit(data) {
	            this.$store.commit('medias/mediaPieceAddOrEdit', data);
	        },
	        'deletedMediaPiece': function deletedMediaPiece(data) {
	            this.$store.commit('medias/mediaPieceDelete', data);
	        },
	        'gameMembersUpdated': function gameMembersUpdated(data) {
	            this.$store.commit('gamePage/setGameMembersFromSocket', data);
	        },
	        'gameInformationUpdated': function gameInformationUpdated(data) {
	            this.$store.commit('gamePage/updateInformation', data);
	        },
	        'developerInformationUpdated': function developerInformationUpdated(data) {
	            this.$store.commit('developerPage/updateInformation', data);
	        },
	        'forumsNewCategory': function forumsNewCategory(data) {
	            this.$store.commit('forums/addCategory', data);
	        },
	        'forumsNewForum': function forumsNewForum(data) {
	            this.$store.commit('forums/addForum', data);
	        },
	        'onlineUsersUpdate': function onlineUsersUpdate(data) {
	            this.$store.commit('onlineUsers/setOnlineUsers', data);
	        },
	        'inboxConversationUpdated': function inboxConversationUpdated(data) {
	            this.$store.dispatch('InboxPage/updateConversation', data);
	        }
	    }
	});

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(4);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = new _vue2.default();

/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vueRouter = __webpack_require__(147);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _routes = __webpack_require__(308);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _vueGlobalEventBus = __webpack_require__(10);
	
	var _vueGlobalEventBus2 = _interopRequireDefault(_vueGlobalEventBus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var router = (0, _routes2.default)({ VueRouter: _vueRouter2.default });
	
	
	router.afterEach(function (to, from) {
	    if (router.app.$store) {
	        router.app.$store.dispatch('notificationsModel/markReadFromRoute', { to: to, from: from });
	    }
	});
	module.exports = router;

/***/ }),
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _map = __webpack_require__(312);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _classCallCheck2 = __webpack_require__(76);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(77);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = new (function () {
	    function _class() {
	        (0, _classCallCheck3.default)(this, _class);
	
	        this.listeners = new _map2.default();
	    }
	
	    (0, _createClass3.default)(_class, [{
	        key: 'addListener',
	        value: function addListener(label, callback, vm) {
	            if (typeof callback == 'function') {
	                this.listeners.has(label) || this.listeners.set(label, []);
	                this.listeners.get(label).push({ callback: callback, vm: vm });
	
	                return true;
	            }
	
	            return false;
	        }
	    }, {
	        key: 'removeListener',
	        value: function removeListener(label, callback, vm) {
	            var listeners = this.listeners.get(label),
	                index = void 0;
	
	            if (listeners && listeners.length) {
	                index = listeners.reduce(function (i, listener, index) {
	                    return typeof listener.callback == 'function' && listener.callback === callback && listener.vm == vm ? i = index : i;
	                }, -1);
	
	                if (index > -1) {
	                    listeners.splice(index, 1);
	                    this.listeners.set(label, listeners);
	                    return true;
	                }
	            }
	            return false;
	        }
	    }, {
	        key: 'emit',
	        value: function emit(label) {
	            for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	                args[_key - 1] = arguments[_key];
	            }
	
	            var listeners = this.listeners.get(label);
	
	            if (listeners && listeners.length) {
	                listeners.forEach(function (listener) {
	                    var _listener$callback;
	
	                    (_listener$callback = listener.callback).call.apply(_listener$callback, [listener.vm].concat(args));
	                });
	                return true;
	            }
	            return false;
	        }
	    }]);
	    return _class;
	}())();

/***/ }),
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(170)
	
	/* template */
	var __vue_template__ = __webpack_require__(905)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(175)
	
	/* template */
	var __vue_template__ = __webpack_require__(829)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(176)
	
	/* template */
	var __vue_template__ = __webpack_require__(835)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(178)
	
	/* template */
	var __vue_template__ = __webpack_require__(868)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(180)
	
	/* template */
	var __vue_template__ = __webpack_require__(848)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(181)
	
	/* template */
	var __vue_template__ = __webpack_require__(871)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(192)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	
	module.exports = __vue_exports__


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(200)
	
	/* template */
	var __vue_template__ = __webpack_require__(827)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(202)
	
	/* template */
	var __vue_template__ = __webpack_require__(895)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(203)
	
	/* template */
	var __vue_template__ = __webpack_require__(883)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: 'Avatar',
	    props: ['profileData', 'xp', 'size', 'profileType', 'showXpInfo'],
	
	    computed: {
	        imgSrc: function imgSrc() {
	            return this.profileData.hasAvatar ? 'https://www.develteam.com/userdata/avatars/' + this.profileType + '_' + this.profileData.id + '.jpg' : 'https://www.develteam.com/userdata/avatar_blank_100.jpg';
	        },
	        xpRingProperties: function xpRingProperties() {
	            var radiusChart = {
	                'very-small': 12,
	                'small': 17,
	                'large': 27,
	                'super-large': 72
	            };
	            var totalCircumference = radiusChart[this.size] * 2 * Math.PI;
	
	            return this.profileData.xpLevelData ? {
	                strokeDasharray: totalCircumference * this.profileData.xpLevelData.xpPercentGainedForThisLevel / 100 + ',10000',
	                cx: radiusChart[this.size] + 10,
	                cy: radiusChart[this.size] + 10,
	                r: radiusChart[this.size]
	            } : {};
	        },
	        linkUrl: function linkUrl() {
	            return '/' + this.profileType.charAt(0).toUpperCase() + this.profileType.substring(1) + '/' + this.profileData.stringUrl;
	        },
	        altText: function altText() {
	            if (this.profileType === 'developer') {
	                return this.profileData.alias + ' Game Developer Portfolio';
	            } else {
	                return this.profileData.alias + ' Game Project';
	            }
	        }
	    },
	
	    sockets: {
	        'avatarUpdated': function avatarUpdated(data) {
	            if (!this.profileData.hasAvatar && this.profileType === data.type && this.profileData.id === data.id) {
	                this.profileData.hasAvatar = true;
	            }
	        },
	        'xpUpdated': function xpUpdated(data) {
	            if (this.profileType === data.profileType && this.profileData.id === data.profileId) {
	                this.profileData.xpLevelData = data.xpLevelData;
	            }
	        }
	    }
	};

/***/ }),
/* 169 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: 'FakeYoutube',
	    props: ['src'],
	
	    data: function data() {
	        return {
	            expanded: false
	        };
	    },
	
	
	    computed: {
	        videoCode: function videoCode() {
	            var matched = this.src.match("v=([a-zA-Z0-9\_\-]+)&?");
	
	            if (matched && matched.length > 1) {
	                return matched[1];
	            } else {
	                return this.src.split('/')[this.src.split('/').length - 1];
	            }
	        }
	    }
	};

/***/ }),
/* 170 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: 'FeedGroupPost',
	    props: ['posts'],
	
	    data: function data() {
	        return {
	            selectedPost: 0
	        };
	    },
	
	
	    computed: {
	        prop: function prop() {
	            return {};
	        }
	    },
	
	    methods: {
	        selectPost: function selectPost(id) {
	            this.selectedPost = id - 1;
	        },
	        pieceType: function pieceType(type) {
	            if (type === 'Image') {
	                return 'image';
	            }
	
	            if (type === 'Video' || type === 'Youtube') {
	                return 'video';
	            }
	
	            if (type === 'Audio') {
	                return 'audio';
	            }
	
	            return 'link';
	        },
	        generateYoutubeBackgroundImageStyle: function generateYoutubeBackgroundImageStyle(src) {
	            if (!src) {
	                return '';
	            }
	
	            var matched = src.match("v=([a-zA-Z0-9\_\-]+)&?");
	            var code = void 0;
	
	            if (matched && matched.length > 1) {
	                code = matched[1];
	            } else {
	                code = src.split('/')[src.split('/').length - 1];
	            }
	
	            return 'background-image: url(\'https://img.youtube.com/vi/' + code + '/0.jpg\');';
	        }
	    }
	};

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'NormalFeedPost',
	    props: ['data'],
	
	    data: function data() {
	        return {
	            commentsVisible: false,
	            newCommentContent: '',
	            postAs: 'developer',
	            editMode: false,
	            deleteMode: false,
	            editPostTitle: this.data.title,
	            editPostContent: this.data.content
	        };
	    },
	
	
	    computed: {
	        canEdit: function canEdit() {
	            if (!this.$store.state.loggedUserModel.isLoggedIn) {
	                return false;
	            }
	
	            if (this.data.subPosterType === 'developer') {
	                return this.$store.state.loggedUserModel.info.id === this.data.posterDetails.id;
	            }
	
	            if (this.data.subPosterType === 'game') {
	
	                var isGameMember = false;
	
	                this.$store.state.loggedUserModel.games.forEach(function (game) {
	                    if (game.id === this.data.subPosterDetails.id) {
	                        isGameMember = true;
	                    }
	                }.bind(this));
	
	                return isGameMember;
	            }
	        },
	        isLoggedIn: function isLoggedIn() {
	            return this.$store.state.loggedUserModel.isLoggedIn;
	        },
	        commentCount: function commentCount() {
	            if ((0, _keys2.default)(this.data.comments || {}).length === 0) {
	                return this.data.commentCount;
	            } else {
	                return (0, _keys2.default)(this.data.comments).length;
	            }
	        },
	        postAsOptions: function postAsOptions() {
	            var postAsOptions = [{
	                value: 'developer',
	                text: this.$store.state.loggedUserModel.info.alias
	            }];
	
	            this.$store.state.loggedUserModel.games.forEach(function (game) {
	                postAsOptions.push({
	                    value: 'game|' + game.id,
	                    text: 'Game: ' + game.alias
	                });
	            });
	
	            return postAsOptions;
	        },
	        isMedia: function isMedia() {
	            return this.data.type === 'media';
	        },
	        isMediaImage: function isMediaImage() {
	            return this.isMedia && this.data.mediaData.mediaType === 'Image';
	        },
	        isMediaVideo: function isMediaVideo() {
	            return this.isMedia && (this.data.mediaData.mediaType === 'Youtube' || this.data.mediaData.mediaType === 'Video');
	        },
	        isMediaLink: function isMediaLink() {
	            if (!this.isMedia) {
	                return;
	            }
	
	            var mediaType = this.data.mediaData.mediaType;
	            return this.isMedia && (mediaType === 'Archive' || mediaType === 'Flash' || mediaType === 'External' || mediaType === 'Text');
	        },
	        isMediaAudio: function isMediaAudio() {
	            if (!this.isMedia) {
	                return;
	            }
	
	            var mediaType = this.data.mediaData.mediaType;
	            return this.isMedia && mediaType === 'Audio';
	        },
	        linkToPiece: function linkToPiece() {
	            var postUrl = void 0;
	
	            if (this.data.type === 'media') {
	                var posterType = this.$options.filters.capitalizeFirstLetter(this.data.mediaData.posterType);
	                var posterStringUrl = this.data.subPosterType === 'developer' ? this.data.posterDetails.stringUrl : this.data.subPosterDetails.stringUrl;
	                var urlPiece = posterType === 'Developer' ? 'Portfolio' : 'Media';
	                var albumStringUrl = this.data.mediaData.albumStringUrl;
	                var pieceStringUrl = this.data.mediaData.stringUrl;
	
	                postUrl = '/' + posterType + '/' + posterStringUrl + '/' + urlPiece + '/' + albumStringUrl + '/' + pieceStringUrl;
	            } else {
	                if (this.data.subPosterType === 'developer') {
	                    postUrl = '/Developer/' + this.data.posterDetails.stringUrl + '/Post/' + this.data.id;
	                }
	
	                if (this.data.subPosterType === 'game') {
	                    postUrl = '/Game/' + this.data.subPosterDetails.stringUrl + '/Post/' + this.data.id;
	                }
	            }
	
	            return postUrl;
	        }
	    },
	
	    methods: {
	        toggleComments: function toggleComments() {
	            this.commentsVisible = !this.commentsVisible;
	
	            if (this.commentsVisible) {
	                this.$store.dispatch('feedPosts/getComments', this.data);
	            }
	        },
	        submitComment: function submitComment() {
	            if (this.newCommentContent.trim !== '') {
	                this.$store.dispatch('feedPosts/addComment', {
	                    content: this.newCommentContent,
	                    post: this.data,
	                    postAs: this.postAs
	                });
	                this.newCommentContent = '';
	            }
	        },
	        enterEditMode: function enterEditMode() {
	            if (this.isMedia) {
	                var posterType = this.$options.filters.capitalizeFirstLetter(this.data.mediaData.posterType);
	                var posterStringUrl = this.data.subPosterType === 'developer' ? this.data.posterDetails.stringUrl : this.data.subPosterDetails.stringUrl;
	                var urlPiece = posterType === 'Developer' ? 'Portfolio' : 'Media';
	                var albumStringUrl = this.data.mediaData.albumStringUrl;
	                var pieceStringUrl = this.data.mediaData.stringUrl;
	
	                this.$router.push('/' + posterType + '/' + posterStringUrl + '/' + urlPiece + '/' + albumStringUrl + '/' + pieceStringUrl + '/Edit');
	            } else {
	                this.editMode = true;
	            }
	        },
	        exitEditMode: function exitEditMode() {
	            this.editMode = false;
	        },
	        cancelEditPost: function cancelEditPost() {
	            this.exitEditMode();
	        },
	        saveEditPost: function saveEditPost() {
	            this.$store.dispatch('feedPosts/editPostContent', {
	                id: this.data.id,
	                title: this.editPostTitle,
	                content: this.editPostContent
	            });
	
	            this.exitEditMode();
	        },
	        enterDeleteMode: function enterDeleteMode() {
	            this.deleteMode = true;
	        },
	        exitDeleteMode: function exitDeleteMode() {
	            this.deleteMode = false;
	        },
	        deletePost: function deletePost() {
	            this.$store.dispatch('feedPosts/deletePost', { id: this.data.id });
	            this.exitDeleteMode();
	            this.exitEditMode();
	        },
	        togglePin: function togglePin() {
	            this.$store.dispatch('feedPosts/pinPost', {
	                id: this.data.id
	            });
	        },
	        socialShare: function socialShare(site) {
	            var url = '';
	            var postUrl = 'https://www.develteam.com' + this.linkToPiece;
	
	            if (site === 'facebook') {
	                url = 'https://www.facebook.com/sharer/sharer.php?u=' + postUrl;
	            } else if (site === 'twitter') {
	                url = 'https://twitter.com/intent/tweet?text=' + postUrl + '%20%23gamedev%20%23indiegamedev';
	            } else if (site === 'linkedin') {
	                url = 'https://www.linkedin.com/shareArticle?mini=true&url=' + postUrl + '&title=&summary=&source=';
	            }
	
	            window.open(url, '_blank');
	        }
	    }
	};

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'MediaPost',
	    props: ['piece', 'classes', 'mediasId', 'canEdit'],
	
	    data: function data() {
	        return {
	            commentsVisible: false,
	            newCommentContent: '',
	            postAs: 'developer'
	        };
	    },
	
	
	    computed: {
	        isLoggedIn: function isLoggedIn() {
	            return this.$store.state.loggedUserModel.isLoggedIn;
	        },
	        postAsOptions: function postAsOptions() {
	            var postAsOptions = [{
	                value: 'developer',
	                text: this.$store.state.loggedUserModel.info.alias
	            }];
	
	            this.$store.state.loggedUserModel.games.forEach(function (game) {
	                postAsOptions.push({
	                    value: 'game|' + game.id,
	                    text: 'Game: ' + game.alias
	                });
	            });
	
	            return postAsOptions;
	        },
	        commentCount: function commentCount() {
	            if ((0, _keys2.default)(this.piece.comments || {}).length === 0) {
	                return this.piece.commentCount;
	            } else {
	                return (0, _keys2.default)(this.piece.comments).length;
	            }
	        },
	        linkToPiece: function linkToPiece() {
	            var posterType = this.$options.filters.capitalizeFirstLetter(this.piece.posterType),
	                posterStringUrl = this.piece.posterStringUrl || this.piece.subPosterStringUrl,
	                albumStringUrl = this.piece.albumStringUrl,
	                pieceStringUrl = this.piece.stringUrl,
	                urlPiece = posterType === 'Developer' ? 'Portfolio' : 'Media';
	
	            return '/' + posterType + '/' + posterStringUrl + '/' + urlPiece + '/' + albumStringUrl + '/' + pieceStringUrl;
	        }
	    },
	
	    methods: {
	        pieceType: function pieceType(type) {
	            if (type === 'Image') {
	                return 'image';
	            }
	
	            if (type === 'Video' || type === 'Youtube') {
	                return 'video';
	            }
	
	            if (type === 'Audio') {
	                return 'audio';
	            }
	
	            return 'link';
	        },
	        toggleComments: function toggleComments() {
	            this.commentsVisible = !this.commentsVisible;
	
	            if (this.commentsVisible) {
	                this.$store.dispatch('medias/getPieceComments', { piece: this.piece, mediasId: this.mediasId });
	            }
	        },
	        submitComment: function submitComment() {
	            if (this.newCommentContent.trim !== '') {
	                this.$store.dispatch('medias/addComment', { content: this.newCommentContent, piece: this.piece, postAs: this.postAs });
	                this.newCommentContent = '';
	            }
	        },
	        socialShare: function socialShare(site) {
	            var url = void 0,
	                link = 'https://www.develteam.com' + this.linkToPiece;
	
	            if (site === 'facebook') {
	                url = 'https://www.facebook.com/sharer/sharer.php?u=' + link;
	            } else if (site === 'twitter') {
	                url = 'https://twitter.com/intent/tweet?text=' + link + '%20%23gamedev%20%23indiegamedev';
	            } else if (site === 'linkedin') {
	                url = 'https://www.linkedin.com/shareArticle?mini=true&url=' + link + '&title=&summary=&source=';
	            }
	
	            window.open(url, '_blank');
	        }
	    }
	};

/***/ }),
/* 173 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: 'PostComment',
	    props: ['comment'],
	    data: function data() {
	        return {
	            editMode: false,
	            deleteMode: false,
	            editedContent: this.comment.content
	        };
	    },
	
	
	    components: {},
	
	    mounted: function mounted() {},
	
	
	    computed: {
	        canEdit: function canEdit() {
	            if (!this.$store.state.loggedUserModel.isLoggedIn) {
	                return;
	            }
	
	            return this.comment.poster.id == this.$store.state.loggedUserModel.info.id;
	        }
	    },
	
	    methods: {
	        enterEditMode: function enterEditMode() {
	            this.editMode = true;
	        },
	        exitEditMode: function exitEditMode() {
	            this.editMode = false;
	        },
	        enterDeleteMode: function enterDeleteMode() {
	            this.deleteMode = true;
	        },
	        exitDeleteMode: function exitDeleteMode() {
	            this.deleteMode = false;
	        },
	        deleteComment: function deleteComment() {
	            this.exitDeleteMode();
	            this.$store.dispatch('feedPosts/deleteComment', this.comment);
	        },
	        saveEditedComment: function saveEditedComment() {
	            if (this.comment.content !== this.editedContent) {
	                this.comment.content = this.editedContent;
	                this.$store.dispatch('feedPosts/editCommentContent', this.comment);
	            }
	
	            this.editMode = false;
	        }
	    }
	};

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'ForumsAddPost',
	    props: ['boardId', 'categoryId', 'threadId'],
	
	    data: function data() {
	        return {
	            postContent: '',
	            errorMessage: '',
	            isSaving: false,
	            showSavedMessage: false
	        };
	    },
	
	
	    components: {},
	
	    mounted: function mounted() {},
	
	
	    computed: {
	        prop: function prop() {
	            return {};
	        }
	    },
	
	    methods: {
	        submitPost: function submitPost() {
	            if (this.postContent.trim() === '') {
	                this.errorMessage = 'Please enter some content for your post';
	                return;
	            }
	
	            this.isSaving = true;
	
	            _axios2.default.post('/api/forumsActions/addPost', {
	                boardId: this.boardId,
	                categoryId: this.categoryId,
	                threadId: this.threadId,
	                content: this.postContent
	            });
	        }
	    },
	
	    sockets: {
	        'forumsNewPost': function forumsNewPost(data) {
	            if (this.$store.state.loggedUserModel.isLoggedIn && this.$store.state.loggedUserModel.info.id == data.posterId) {
	                this.isSaving = false;
	                this.showSavedMessage = true;
	                this.postContent = '';
	
	                setTimeout(function () {
	                    this.showSavedMessage = false;
	                }.bind(this), 3000);
	            }
	        }
	    }
	};

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _ForumsForumItem = __webpack_require__(714);
	
	var _ForumsForumItem2 = _interopRequireDefault(_ForumsForumItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'ForumsCategoryItem',
	    props: ['category', 'isModerator', 'boardId', 'root'],
	
	    data: function data() {
	        return {
	            editMode: false,
	            addForumMode: false,
	            newCategoryTitle: this.category.title,
	            editCategoryError: '',
	            isPrivate: false,
	            addForumTitle: '',
	            addForumDescription: '',
	            addForumError: '',
	            addForumSaving: false
	        };
	    },
	
	
	    components: {
	        'forum-item': _ForumsForumItem2.default
	    },
	
	    mounted: function mounted() {},
	
	
	    computed: {},
	
	    methods: {
	        editCategory: function editCategory() {
	            if (this.newCategoryTitle.trim() === '') {
	                this.editCategoryError = 'Please Enter a Title for your Category';
	                return;
	            }
	
	            _axios2.default.post('/api/forumsActions/editCategory', {
	                title: this.newCategoryTitle,
	                isPrivate: this.isPrivate,
	                boardId: this.boardId,
	                categoryId: this.category.id
	            });
	        },
	        addForum: function addForum() {
	            if (this.addForumTitle.trim() === '') {
	                this.addForumError = 'Please Enter a Title for your Forum';
	                return;
	            }
	
	            this.addForumSaving = true;
	
	            _axios2.default.post('/api/forumsActions/addForum', {
	                title: this.addForumTitle,
	                description: this.addForumDescription,
	                boardId: this.boardId,
	                categoryId: this.category.id
	            });
	        }
	    },
	
	    sockets: {
	        'forumsNewForum': function forumsNewForum(data) {
	            if (data.forum.category.id === this.category.id) {
	                this.addForumSaving = false;
	                this.addForumMode = false;
	                this.addForumTitle = '';
	                this.addForumDescription = '';
	            }
	        }
	    }
	};

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _ForumsCategoryItem = __webpack_require__(138);
	
	var _ForumsCategoryItem2 = _interopRequireDefault(_ForumsCategoryItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'ForumsCategoryList',
	    props: ['boardId', 'board', 'root', 'isModerator', 'canPost'],
	
	    data: function data() {
	        return {
	            showAddCategoryForm: false,
	            newCategoryTitle: '',
	            addCategoryError: '',
	            isPrivate: false,
	            savingAddCategory: false
	        };
	    },
	
	
	    components: {
	        'category-item': _ForumsCategoryItem2.default
	    },
	
	    mounted: function mounted() {},
	
	
	    computed: {
	        orderedCategories: function orderedCategories() {
	            return _lodash2.default.sortBy(this.board.categories, 'rank');
	        }
	    },
	
	    methods: {
	        addCategory: function addCategory() {
	            if (this.newCategoryTitle.trim() === '') {
	                this.addCategoryError = 'Please Enter a Title for your Category';
	                return;
	            }
	
	            _axios2.default.post('/api/forumsActions/addCategory', {
	                title: this.newCategoryTitle,
	                isPrivate: this.isPrivate,
	                boardId: this.boardId
	            });
	
	            this.savingAddCategory = true;
	        }
	    },
	
	    sockets: {
	        'forumsNewCategory': function forumsNewCategory(data) {
	            if (data.boardId === this.boardId) {
	                this.savingAddCategory = false;
	                this.showAddCategoryForm = false;
	                this.newCategoryTitle = '';
	            }
	        }
	    }
	};

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'ForumsForumItem',
	    props: ['category', 'forum', 'isModerator', 'boardId', 'root'],
	
	    data: function data() {
	        return {
	            editMode: false,
	            editForumTitle: this.forum.title,
	            editForumDescription: this.forum.description,
	            editForumErrorMessage: ''
	        };
	    },
	
	
	    components: {},
	
	    mounted: function mounted() {},
	
	
	    computed: {},
	
	    methods: {
	        saveForum: function saveForum() {
	            if (this.editForumTitle.trim() === '') {
	                this.editForumErrorMessage = 'Please Enter a Title for the Forum';
	                return;
	            }
	
	            _axios2.default.post('/api/forumsActions/editForum', {
	                boardId: this.boardId,
	                categoryId: this.category.id,
	                forumId: this.forum.id,
	                title: this.editForumTitle,
	                description: this.editForumDescription
	            });
	        }
	    }
	};

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _ForumsCategoryItem = __webpack_require__(138);
	
	var _ForumsCategoryItem2 = _interopRequireDefault(_ForumsCategoryItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'SiteForumsForumList',
	    props: ['boardId', 'board', 'root', 'isModerator', 'canPost'],
	
	    data: function data() {
	        return {};
	    },
	
	
	    components: {
	        'category-item': _ForumsCategoryItem2.default
	    },
	
	    mounted: function mounted() {},
	
	
	    computed: {
	        category: function category() {
	            return this.board.categories[this.$route.params.category];
	        }
	    },
	
	    methods: {}
	};

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vue = __webpack_require__(4);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'ForumsPost',
	    props: ['boardId', 'post'],
	
	    data: function data() {
	        return {
	            editPostContent: this.post.content,
	            editPostMode: false,
	            deletePostMode: false,
	            isSaving: false,
	            isDeleted: false
	        };
	    },
	
	
	    components: {},
	
	    mounted: function mounted() {},
	
	
	    computed: {
	        isPoster: function isPoster() {
	            return this.$store.state.loggedUserModel.isLoggedIn && this.$store.state.loggedUserModel.info.id === this.post.posterData.id;
	        }
	    },
	
	    methods: {
	        saveEditedPost: function saveEditedPost() {
	            if (this.editPostContent === '') {
	                this.editPostError = 'Please enter content for your Post';
	                return;
	            }
	
	            this.isSaving = true;
	            _axios2.default.post('/api/forumsActions/editPost', {
	                postId: this.post.id,
	                content: this.editPostContent
	            });
	        },
	        deletePost: function deletePost() {
	            _axios2.default.post('/api/forumsActions/deletePost', {
	                postId: this.post.id
	            });
	
	            this.isDeleted = true;
	        }
	    },
	
	    sockets: {
	        'forumsEditPost': function forumsEditPost(data) {
	            if (data.id === this.post.id) {
	                _vue2.default.set(this.$store.state.forumsModel.boards[this.boardId].categories[this.$route.params.category].forums[this.$route.params.forum].threads[this.$route.params.thread].posts[data.id], 'content', data.content);
	
	                this.post.editPostContent = data.content;
	                this.isSaving = false;
	                this.editPostMode = false;
	            }
	        },
	        'forumsDeletePost': function forumsDeletePost(data) {
	            if (data.id === this.post.id) {
	                _vue2.default.delete(this.$store.state.forumsModel.boards[this.boardId].categories[this.$route.params.category].forums[this.$route.params.forum].threads[this.$route.params.thread].posts, data.id);
	            }
	        }
	    }
	};

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vue = __webpack_require__(4);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _ForumsAddPost = __webpack_require__(713);
	
	var _ForumsAddPost2 = _interopRequireDefault(_ForumsAddPost);
	
	var _ForumsPost = __webpack_require__(715);
	
	var _ForumsPost2 = _interopRequireDefault(_ForumsPost);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'SiteForumsPostList',
	    props: ['boardId', 'board', 'root', 'isModerator', 'canPost'],
	    data: function data() {
	        return {
	            postsPerPage: 20,
	            currentPage: 1,
	            editMode: false,
	            deleteMode: false,
	            moveMode: false,
	            editThreadTitle: '',
	            moveToForumId: 0,
	            moveToForumErrorMessage: ''
	        };
	    },
	
	
	    components: {
	        'add-post-form': _ForumsAddPost2.default,
	        'post': _ForumsPost2.default
	    },
	
	    mounted: function mounted() {
	        if (this.forum) {
	            if (this.thread) {
	                this.fetchPosts();
	            } else {
	                this.fetchThread();
	            }
	        }
	    },
	
	
	    computed: {
	        category: function category() {
	            if (this.board.categories && this.board.categories[this.$route.params.category]) {
	                return this.board.categories[this.$route.params.category];
	            }
	        },
	        forum: function forum() {
	            if (this.board.categories && this.board.categories[this.$route.params.category] && this.board.categories[this.$route.params.category].forums && this.board.categories[this.$route.params.category].forums[this.$route.params.forum]) {
	                return this.board.categories[this.$route.params.category].forums[this.$route.params.forum];
	            }
	        },
	        thread: function thread() {
	            if (this.board.categories && this.board.categories[this.$route.params.category] && this.board.categories[this.$route.params.category].forums && this.board.categories[this.$route.params.category].forums[this.$route.params.forum] && this.board.categories[this.$route.params.category].forums[this.$route.params.forum].threads && this.board.categories[this.$route.params.category].forums[this.$route.params.forum].threads[this.$route.params.thread]) {
	                return this.board.categories[this.$route.params.category].forums[this.$route.params.forum].threads[this.$route.params.thread];
	            }
	        },
	        posts: function posts() {
	            if (this.board.categories && this.board.categories[this.$route.params.category] && this.board.categories[this.$route.params.category].forums && this.board.categories[this.$route.params.category].forums[this.$route.params.forum] && this.board.categories[this.$route.params.category].forums[this.$route.params.forum].threads && this.board.categories[this.$route.params.category].forums[this.$route.params.forum].threads[this.$route.params.thread] && this.board.categories[this.$route.params.category].forums[this.$route.params.forum].threads[this.$route.params.thread].posts) {
	                return this.board.categories[this.$route.params.category].forums[this.$route.params.forum].threads[this.$route.params.thread].posts;
	            }
	        },
	        totalPages: function totalPages() {
	            return this.thread ? Math.ceil(this.thread.totalPosts / this.postsPerPage) : 0;
	        },
	        isOriginalPoster: function isOriginalPoster() {
	            return this.thread && this.$store.state.loggedUserModel.isLoggedIn && this.$store.state.loggedUserModel.info.id === this.thread.threadStarterId;
	        },
	        moveModeForumsList: function moveModeForumsList() {
	            var list = [];
	
	            _lodash2.default.each(this.board.categories, function (category) {
	                _lodash2.default.each(category.forums, function (forum) {
	                    list.push({
	                        label: '[' + category.title + '] ' + forum.title,
	                        id: forum.id
	                    });
	                });
	            });
	
	            return list;
	        }
	    },
	
	    methods: {
	        fetchThread: function fetchThread() {
	            this.$store.dispatch('forums/getThread', {
	                boardId: this.boardId,
	                categoryStringUrl: this.$route.params.category,
	                forumStringUrl: this.$route.params.forum,
	                threadStringUrl: this.$route.params.thread,
	                forumId: this.forum.id
	            });
	        },
	        fetchPosts: function fetchPosts(data) {
	            this.$store.dispatch('forums/getPosts', {
	                boardId: this.boardId,
	                categoryStringUrl: this.$route.params.category,
	                forumStringUrl: this.$route.params.forum,
	                threadStringUrl: this.$route.params.thread,
	                threadId: this.thread.id,
	                page: this.currentPage,
	                perPage: this.postsPerPage,
	                noLoader: data && data.noLoader
	            });
	        },
	        switchToResultsPage: function switchToResultsPage(newPage) {
	            this.currentPage = newPage;
	            this.fetchPosts();
	        },
	        enterEditMode: function enterEditMode() {
	            this.editThreadTitle = this.thread.title;
	            this.editMode = true;
	        },
	        saveEditThread: function saveEditThread() {
	            _axios2.default.post('/api/forumsActions/editThread', {
	                boardId: this.boardId,
	                categoryId: this.category.id,
	                threadId: this.thread.id,
	                newTitle: this.editThreadTitle
	            });
	
	            this.editMode = false;
	        },
	        savePinnedStatus: function savePinnedStatus() {
	            _axios2.default.post('/api/forumsActions/pinThread', {
	                boardId: this.boardId,
	                categoryId: this.category.id,
	                threadId: this.thread.id
	            });
	        },
	        saveLockedStatus: function saveLockedStatus() {
	            _axios2.default.post('/api/forumsActions/lockThread', {
	                boardId: this.boardId,
	                categoryId: this.category.id,
	                threadId: this.thread.id
	            });
	        },
	        deleteThread: function deleteThread() {
	            _axios2.default.post('/api/forumsActions/deleteThread', {
	                boardId: this.boardId,
	                categoryId: this.category.id,
	                threadId: this.thread.id
	            });
	        },
	        moveThread: function moveThread() {
	            var _this = this;
	
	            if (this.moveToForumId === 0) {
	                this.moveToForumErrorMessage = 'Select a destination forum';
	                return;
	            }
	
	            _axios2.default.post('/api/forumsActions/moveThread', {
	                boardId: this.boardId,
	                categoryId: this.category.id,
	                threadId: this.thread.id,
	                moveToId: this.moveToForumId
	            }).then(function (response) {
	                _this.moveMode = false;
	            });
	        }
	    },
	
	    watch: {
	        'forum': function forum() {
	            if (!this.thread && this.forum && this.forum.fetchingStatus !== 'fetching' && this.forum.fetchingStatus !== 'fetched') {
	                this.fetchThread();
	            }
	        },
	        'thread': function thread() {
	            if (this.thread && this.thread.fetchingStatus !== 'fetching' && this.thread.fetchingStatus !== 'fetched') {
	                this.fetchPosts();
	            }
	        }
	    },
	
	    sockets: {
	        'forumsNewPost': function forumsNewPost(data) {
	            var _this2 = this;
	
	            if (data.threadId === this.thread.id) {
	                _axios2.default.get('/api/forums/thread', {
	                    params: {
	                        forumId: this.forum.id,
	                        threadStringUrl: this.$route.params.thread
	                    }
	                }).then(function (response) {
	                    if (!response.data.errors) {
	                        _vue2.default.set(_this2.$store.state.forumsModel.boards[_this2.boardId].categories[_this2.$route.params.category].forums[_this2.$route.params.forum].threads[_this2.$route.params.thread], 'totalPosts', response.data.totalPosts);
	                    }
	
	                    if (_this2.currentPage === _this2.totalPages) {
	                        _this2.fetchPosts({ noLoader: true });
	                    }
	                });
	            }
	        },
	        'forumsMoveThread': function forumsMoveThread(data) {
	            if (this.thread.id === data.threadId) {
	                this.$router.push('/' + this.root + '/' + data.categoryStringUrl + '/' + data.forumStringUrl + '/' + data.threadStringUrl);
	            }
	        }
	    }
	};

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'SiteForumsThreadList',
	    props: ['boardId', 'board', 'root', 'isModerator', 'canPost'],
	
	    data: function data() {
	        return {
	            threadsPerPage: 20,
	            currentPage: 1,
	            addThreadMode: false,
	            newThreadTitle: '',
	            newThreadContent: '',
	            newThreadErrorMessage: '',
	            newThreadSaving: false
	        };
	    },
	
	
	    components: {},
	
	    mounted: function mounted() {
	        if (this.forum) {
	            this.fetchThreads();
	        }
	    },
	
	
	    computed: {
	        category: function category() {
	            if (this.board.categories && this.board.categories[this.$route.params.category]) {
	                return this.board.categories[this.$route.params.category];
	            }
	        },
	        forum: function forum() {
	            if (this.board.categories && this.board.categories[this.$route.params.category] && this.board.categories[this.$route.params.category].forums && this.board.categories[this.$route.params.category].forums[this.$route.params.forum]) {
	                return this.board.categories[this.$route.params.category].forums[this.$route.params.forum];
	            }
	        },
	        threads: function threads() {
	            if (this.forum) {
	                return this.forum.threads;
	            }
	        },
	        totalPages: function totalPages() {
	            return this.forum ? Math.ceil(this.forum.totalThreads / this.threadsPerPage) : 0;
	        }
	    },
	
	    methods: {
	        fetchThreads: function fetchThreads() {
	            this.$store.dispatch('forums/getThreads', {
	                boardId: this.boardId,
	                forumId: this.forum.id,
	                categoryStringUrl: this.$route.params.category,
	                forumStringUrl: this.$route.params.forum,
	                page: this.currentPage,
	                perPage: this.threadsPerPage
	            });
	        },
	        switchToResultsPage: function switchToResultsPage(newPage) {
	            this.currentPage = newPage;
	            this.fetchThreads();
	        },
	        saveNewThread: function saveNewThread() {
	            if (this.newThreadTitle.trim() === '') {
	                this.newThreadErrorMessage = 'Please Enter a Subject for the Thread';
	                return;
	            }
	
	            if (this.newThreadContent.trim() === '') {
	                this.newThreadErrorMessage = 'Please submit content for the Post';
	                return;
	            }
	
	            this.newThreadErrorMessage = '';
	            this.newThreadSaving = true;
	
	            _axios2.default.post('/api/forumsActions/addThread', {
	                boardId: this.boardId,
	                categoryId: this.category.id,
	                forumId: this.forum.id,
	                title: this.newThreadTitle,
	                content: this.newThreadContent
	            }).then(function (response) {
	                this.addThreadMode = false;
	                this.newThreadSaving = false;
	                this.newThreadTitle = '';
	                this.newThreadContent = '';
	                this.newThreadErrorMessage = '';
	
	                if (!response.data.errors) {
	                    this.$router.push(this.$route.path + '/' + response.data.stringUrl);
	                }
	            }.bind(this));
	        }
	    },
	
	    watch: {
	        'forum': function forum() {
	            if (this.forum && this.forum.fetchingStatus !== 'fetching' && !this.forum.fetchingStatus !== 'fetched') {
	                this.fetchThreads();
	            }
	        }
	    },
	
	    sockets: {
	        'forumsAddThread': function forumsAddThread(data) {
	            if (this.forum && this.forum.id === data.forumId) {
	                this.fetchThreads();
	            }
	        }
	    }
	};

/***/ }),
/* 182 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: 'FourOhFour'
	};

/***/ }),
/* 183 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: 'IconChatBubble',
	    props: ['title']
	};

/***/ }),
/* 184 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: 'IconDeveloper',
	    props: ['title']
	};

/***/ }),
/* 185 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: 'IconDevteam',
	    props: ['title']
	};

/***/ }),
/* 186 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: 'IconEye',
	    props: ['title']
	};

/***/ }),
/* 187 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: 'IconGame',
	    props: ['title']
	};

/***/ }),
/* 188 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: 'IconUserPlus',
	    props: ['title']
	};

/***/ }),
/* 189 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: 'LoadingLarge'
	};

/***/ }),
/* 190 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: 'LoadingSmall'
	};

/***/ }),
/* 191 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: 'SavingLarge'
	};

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vue = __webpack_require__(4);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'MarkdownContent',
	    props: ['content', 'classes'],
	
	    render: function render(createElement) {
	        var _this = this;
	
	        var children = [];
	        var index = 0;
	
	        this.content.replace(/\[youtube:(.*)\]/g, function (segment, url, offset) {
	            if (offset > 0) {
	                children.push(createElement('div', {
	                    domProps: {
	                        innerHTML: _this.$options.filters.markdown(_this.content.slice(index, offset))
	                    }
	                }));
	            }
	
	            children.push(createElement('fake-youtube', {
	                props: {
	                    src: url
	                }
	            }));
	
	            index = offset + segment.length;
	            return segment;
	        });
	
	        if (index < this.content.length) {
	            children.push(createElement('div', {
	                domProps: {
	                    innerHTML: this.$options.filters.markdown(this.content.slice(index))
	                }
	            }));
	        }
	
	        return createElement('section', {
	            'class': this.classes
	        }, children);
	    }
	};

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'MarkdownEditor',
	    props: ['value', 'placeholder', 'disabled', 'classes'],
	    data: function data() {
	        return {
	            previewVisible: false,
	            formattingHelpVisible: false
	        };
	    },
	    created: function created() {
	        var self = this;
	    },
	
	
	    methods: {
	        togglePreview: function togglePreview() {
	            this.previewVisible = !this.previewVisible;
	        },
	        toggleHelp: function toggleHelp() {
	            this.formattingHelpVisible = !this.formattingHelpVisible;
	        },
	        updateContent: function updateContent(e) {
	            this.content = e.target.value;
	            this.$emit('input', e.target.value);
	        }
	    }
	};

/***/ }),
/* 194 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: 'MediaItemAudio',
	    props: ['data'],
	    computed: {
	        altText: function altText() {
	            var altString = '';
	            if (this.data.posterType === 'developer') {
	                altString += this.data.posterAlias + '\'s Game Developer Portfolio Piece - ';
	            } else {
	                altString += this.data.subPosterAlias + '\'s Game Media Piece - ';
	            }
	
	            altString += this.data.title;
	
	            return altString;
	        }
	    }
	};

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vueGlobalEventBus = __webpack_require__(10);
	
	var _vueGlobalEventBus2 = _interopRequireDefault(_vueGlobalEventBus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'MediaItemImage',
	    props: ['data'],
	
	    computed: {
	        altText: function altText() {
	            var altString = '';
	            if (this.data.posterType === 'developer') {
	                altString += this.data.posterAlias + '\'s Game Developer Portfolio Piece - ';
	            } else {
	                altString += this.data.subPosterAlias + '\'s Game Media Piece - ';
	            }
	
	            altString += this.data.title;
	
	            return altString;
	        }
	    },
	
	    methods: {
	        showInModal: function showInModal() {
	            _vueGlobalEventBus2.default.$emit('openModal', '<img src="https://www.develteam.com/userdata/media/' + this.data.mediaUrl + '"/>');
	        }
	    }
	};

/***/ }),
/* 196 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: 'MediaItemLink',
	    props: ['data'],
	    computed: {
	        altText: function altText() {
	            var altString = '';
	            if (this.data.posterType === 'developer') {
	                altString += this.data.posterAlias + '\'s Game Developer Portfolio Piece - ';
	            } else {
	                altString += this.data.subPosterAlias + '\'s Game Media Piece - ';
	            }
	
	            altString += this.data.title;
	
	            return altString;
	        }
	    }
	};

/***/ }),
/* 197 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: 'MediaItemVideo',
	    props: ['data']
	};

/***/ }),
/* 198 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: 'FormEditMediaAlbum',
	    props: ['album', 'mediasId'],
	
	    data: function data() {
	        return {
	            albumFile: undefined,
	            uploadedAlbumName: '',
	            uploadedImageSrc: '',
	            savingAlbum: false,
	            albumName: this.album.title,
	            deleteMode: false,
	            albumImageTooBig: false
	        };
	    },
	
	
	    components: {},
	
	    mounted: function mounted() {},
	
	
	    computed: {},
	
	    methods: {
	        isValidated: function isValidated() {
	            return !this.albumImageTooBig && this.albumName.trim() !== '';
	        },
	        editAlbum: function editAlbum() {
	            if (!this.isValidated()) {
	                return;
	            }
	
	            this.albumName = this.albumName.trim();
	            this.savingAlbum = true;
	
	            this.$store.dispatch('medias/editAlbum', {
	                albumId: this.album.id,
	                albumName: this.albumName,
	                albumFile: this.albumFile
	            });
	        },
	        updateUploadedAlbumName: function updateUploadedAlbumName(e) {
	            var input = e.target;
	            var reader = void 0;
	            var self = this;
	
	            if (input.files.length === 0) {
	                return;
	            }
	
	            if (input.files && input.files[0]) {
	                reader = new FileReader();
	
	                reader.onload = function (e) {
	                    self.uploadedImageSrc = e.target.result;
	                };
	
	                reader.readAsDataURL(input.files[0]);
	            }
	
	            this.uploadedAlbumName = e.target.files[0].name;
	            this.albumFile = e.target.files[0];
	            this.albumImageTooBig = e.target.files[0].size > 10 * 1024 * 1024;
	        },
	        enterDeleteMode: function enterDeleteMode() {
	            this.deleteMode = true;
	        },
	        exitDeleteMode: function exitDeleteMode() {
	            this.deleteMode = false;
	        },
	        deleteAlbum: function deleteAlbum() {
	            this.$store.dispatch('medias/deleteAlbum', {
	                albumId: this.album.id
	            });
	
	            this.exitDeleteMode();
	
	            if (this.mediasId.split('.')[0] === 'developer') {
	                this.$router.push('/Developer/' + this.$route.params.developer + '/Portfolio/');
	            }
	
	            if (this.mediasId.split('.')[0] === 'game') {
	                this.$router.push('/Game/' + this.$route.params.game + '/Media/');
	            }
	        }
	    }
	};

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _validator = __webpack_require__(19);
	
	var _validator2 = _interopRequireDefault(_validator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'FormEditMediaPiece',
	    props: ['piece'],
	    data: function data() {
	        return {
	            mediaTypes: {
	                'image': {
	                    id: 'image',
	                    name: 'Image',
	                    usesUploadFile: true,
	                    acceptedTypes: ['.jpg', '.jpeg', '.png', '.gif'],
	                    usesPreviewImage: false
	                },
	                'video': {
	                    id: 'video',
	                    name: 'Video',
	                    usesUploadFile: false,
	                    acceptedTypes: [],
	                    usesPreviewImage: false,
	                    usesYoutubeLink: true
	                },
	                'audio': {
	                    id: 'audio',
	                    name: 'Audio',
	                    usesUploadFile: true,
	                    acceptedTypes: ['.mp3'],
	                    usesPreviewImage: true
	                },
	                'flash': {
	                    id: 'flash',
	                    name: 'Flash',
	                    usesUploadFile: true,
	                    acceptedTypes: ['.swf'],
	                    usesPreviewImage: true
	                },
	                'archive': {
	                    id: 'archive',
	                    name: 'Archive',
	                    usesUploadFile: true,
	                    acceptedTypes: ['.zip', '.rar'],
	                    usesPreviewImage: true
	                },
	                'document': {
	                    id: 'document',
	                    name: 'Document',
	                    usesUploadFile: true,
	                    acceptedTypes: ['.txt', '.doc', '.docx', '.xsxl', '.pdf'],
	                    usesPreviewImage: true
	                },
	                'url': {
	                    id: 'url',
	                    name: 'External Url',
	                    usesUploadFile: false,
	                    acceptedTypes: [],
	                    usesPreviewImage: true,
	                    usesExternalUrl: true
	                }
	
	            },
	            title: this.piece.title,
	            description: this.piece.description,
	            selectedMediaType: { 'External': 'url', 'Image': 'image', 'Flash': 'flash', 'Archive': 'archive', 'Audio': 'audio', 'Text': 'document', 'Youtube': 'video' }[this.piece.mediaType],
	            mediaText: this.piece.mediaUrl,
	            formErrors: [],
	            savingForm: false,
	            deleteMode: false
	        };
	    },
	
	
	    components: {},
	
	    mounted: function mounted() {},
	
	
	    computed: {
	        selectedMediaData: function selectedMediaData() {
	            return this.mediaTypes[this.selectedMediaType];
	        }
	    },
	
	    methods: {
	        submitEditedPiece: function submitEditedPiece() {
	            this.validateForm();
	
	            if (this.formErrors.length > 0) {
	                return;
	            }
	
	            this.$store.dispatch('medias/editPiece', {
	                id: this.piece.id,
	                title: this.title,
	                description: this.description,
	                mediaText: this.mediaText
	            });
	
	            this.savingForm = true;
	        },
	        validateForm: function validateForm() {
	            var selectedMedia = this.mediaTypes[this.selectedMediaType];
	
	            this.formErrors = [];
	            this.title = this.title.trim();
	
	            if (this.title === '') {
	                this.formErrors.push('Give the piece a title');
	            }
	
	            if (selectedMedia.usesExternalUrl) {
	                this.mediaText = this.mediaText.trim();
	
	                if (this.mediaText === '') {
	                    this.formErrors.push('Enter a media url');
	                } else if (!_validator2.default.isURL(this.mediaText)) {
	                    this.formErrors.push('Enter a valid media url');
	                } else if (!/^(?:f|ht)tps?\:\/\//.test(this.mediaText)) {
	                    this.mediaText = "http://" + this.mediaText;
	                }
	            }
	
	            if (selectedMedia.usesYoutubeLink) {
	                this.mediaText = this.mediaText.trim();
	
	                if (this.mediaText === '') {
	                    this.formErrors.push('Enter a Youtube url');
	                } else if (!_validator2.default.isURL(this.mediaText)) {
	                    this.formErrors.push('Enter a valid Youtube url');
	                }
	            }
	        },
	        exitEditMode: function exitEditMode() {
	            this.redirectToPiece(this.piece);
	        },
	        enterDeleteMode: function enterDeleteMode() {
	            this.deleteMode = true;
	        },
	        exitDeleteMode: function exitDeleteMode() {
	            this.deleteMode = false;
	        },
	        deletePiece: function deletePiece() {
	            this.$store.dispatch('medias/deletePiece', {
	                id: this.piece.id
	            });
	
	            this.savingForm = true;
	        },
	        redirectToPiece: function redirectToPiece(data) {
	            if (data.id === this.piece.id) {
	                var posterType = this.$options.filters.capitalizeFirstLetter(data.posterType);
	                var posterStringUrl = data.posterStringUrl || data.subPosterStringUrl;
	                var albumStringUrl = data.albumStringUrl;
	                var pieceStringUrl = data.stringUrl;
	                var urlPiece = posterType === 'Developer' ? 'Portfolio' : 'Media';
	
	                this.$router.push('/' + posterType + '/' + posterStringUrl + '/' + urlPiece + '/' + albumStringUrl + '/' + pieceStringUrl);
	            }
	        }
	    },
	
	    sockets: {
	        'mediaPieceAddOrEdit': function mediaPieceAddOrEdit(data) {
	            this.redirectToPiece(data);
	        },
	        'deletedMediaPiece': function deletedMediaPiece(data) {
	            this.redirectToPiece(data);
	        }
	    }
	};

/***/ }),
/* 200 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: 'FormNewMediaAlbum',
	    props: ['pageType', 'pageId'],
	    data: function data() {
	        return {
	            albumName: '',
	            albumFile: undefined,
	            uploadedAlbumName: '',
	            uploadedImageSrc: '',
	            savingAlbum: false,
	            albumImageTooBig: false
	        };
	    },
	    mounted: function mounted() {},
	
	
	    computed: {},
	
	    methods: {
	        isValidated: function isValidated() {
	            return !this.albumImageTooBig && this.albumName.trim() !== '';
	        },
	        addAlbum: function addAlbum() {
	            if (!this.isValidated()) {
	                return;
	            }
	
	            this.albumName = this.albumName.trim();
	            this.savingAlbum = true;
	
	            this.$store.dispatch('medias/addAlbum', {
	                pageType: this.pageType,
	                pageId: this.pageId,
	                albumName: this.albumName,
	                albumFile: this.albumFile
	            });
	        },
	        updateUploadedAlbumName: function updateUploadedAlbumName(e) {
	            var input = e.target;
	            var reader = void 0;
	            var self = this;
	
	            if (input.files.length === 0) {
	                return;
	            }
	
	            if (input.files && input.files[0]) {
	                reader = new FileReader();
	
	                reader.onload = function (e) {
	                    self.uploadedImageSrc = e.target.result;
	                };
	
	                reader.readAsDataURL(input.files[0]);
	            }
	
	            this.uploadedAlbumName = e.target.files[0].name;
	            this.albumFile = e.target.files[0];
	            this.albumImageTooBig = e.target.files[0].size > 10 * 1024 * 1024;
	        },
	        cancel: function cancel() {
	            this.$emit('doneEditing');
	        }
	    }
	};

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _validator = __webpack_require__(19);
	
	var _validator2 = _interopRequireDefault(_validator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'FormNewMediaPiece',
	    props: ['album', 'pageType', 'pageId'],
	
	    data: function data() {
	        return {
	            mediaTypes: {
	                'image': {
	                    id: 'image',
	                    name: 'Image',
	                    usesUploadFile: true,
	                    acceptedTypes: ['.jpg', '.jpeg', '.png', '.gif'],
	                    usesPreviewImage: false
	                },
	                'video': {
	                    id: 'video',
	                    name: 'Video',
	                    usesUploadFile: false,
	                    acceptedTypes: [],
	                    usesPreviewImage: false,
	                    usesYoutubeLink: true
	                },
	                'audio': {
	                    id: 'audio',
	                    name: 'Audio',
	                    usesUploadFile: true,
	                    acceptedTypes: ['.mp3'],
	                    usesPreviewImage: true
	                },
	                'flash': {
	                    id: 'flash',
	                    name: 'Flash',
	                    usesUploadFile: true,
	                    acceptedTypes: ['.swf'],
	                    usesPreviewImage: true
	                },
	                'archive': {
	                    id: 'archive',
	                    name: 'Archive',
	                    usesUploadFile: true,
	                    acceptedTypes: ['.zip', '.rar'],
	                    usesPreviewImage: true
	                },
	                'document': {
	                    id: 'document',
	                    name: 'Document',
	                    usesUploadFile: true,
	                    acceptedTypes: ['.txt', '.doc', '.docx', '.xsxl', '.pdf'],
	                    usesPreviewImage: true
	                },
	                'url': {
	                    id: 'url',
	                    name: 'External Url',
	                    usesUploadFile: false,
	                    acceptedTypes: [],
	                    usesPreviewImage: true,
	                    usesExternalUrl: true
	                }
	
	            },
	            title: '',
	            description: '',
	            selectedMediaType: 'image',
	            mediaFile: undefined,
	            previewFile: undefined,
	            mediaText: '',
	            formErrors: [],
	            savingForm: false
	        };
	    },
	
	
	    computed: {
	        selectedMediaData: function selectedMediaData() {
	            return this.mediaTypes[this.selectedMediaType];
	        }
	    },
	
	    methods: {
	        setMediaFile: function setMediaFile(e) {
	            this.mediaFile = e.target.files[0];
	        },
	        setPreviewFile: function setPreviewFile(e) {
	            this.previewFile = e.target.files[0];
	        },
	        submitNewPiece: function submitNewPiece() {
	            this.validateForm();
	
	            if (this.formErrors.length > 0) {
	                return;
	            }
	
	            this.$store.dispatch('medias/addPiece', {
	                title: this.title,
	                description: this.description,
	                albumId: this.album.id,
	                mediaFile: this.mediaFile,
	                previewFile: this.previewFile,
	                selectedMediaType: this.selectedMediaType,
	                mediaText: this.mediaText,
	                pageType: this.pageType,
	                pageId: this.pageId
	            });
	
	            this.savingForm = true;
	        },
	        validateForm: function validateForm() {
	            var selectedMedia = this.mediaTypes[this.selectedMediaType];
	            var uploadedFileExtension = void 0;
	
	            this.formErrors = [];
	            this.title = this.title.trim();
	
	            if (this.title === '') {
	                this.formErrors.push('Give the piece a title');
	            }
	
	            if (selectedMedia.usesUploadFile) {
	                if (this.mediaFile === undefined) {
	                    this.formErrors.push('Upload a file');
	                } else {
	                    uploadedFileExtension = this.mediaFile.name.split('.');
	                    uploadedFileExtension = '.' + uploadedFileExtension[uploadedFileExtension.length - 1];
	
	                    if (selectedMedia.acceptedTypes.indexOf(uploadedFileExtension.toLowerCase()) === -1) {
	                        this.formErrors.push('Uploaded media file is not an acceptable type');
	                    }
	                }
	            }
	
	            if (selectedMedia.usesExternalUrl) {
	                this.mediaText = this.mediaText.trim();
	
	                if (this.mediaText === '') {
	                    this.formErrors.push('Enter a media url');
	                } else if (!_validator2.default.isURL(this.mediaText)) {
	                    this.formErrors.push('Enter a valid media url');
	                } else if (!/^(?:f|ht)tps?\:\/\//.test(this.mediaText)) {
	                    this.mediaText = "http://" + this.mediaText;
	                }
	            }
	
	            if (selectedMedia.usesYoutubeLink) {
	                this.mediaText = this.mediaText.trim();
	
	                if (this.mediaText === '') {
	                    this.formErrors.push('Enter a Youtube url');
	                } else if (!_validator2.default.isURL(this.mediaText)) {
	                    this.formErrors.push('Enter a valid Youtube url');
	                }
	            }
	
	            if (selectedMedia.usesPreviewImage && this.previewFile !== undefined) {
	                uploadedFileExtension = this.previewFile.name.split('.');
	                uploadedFileExtension = '.' + uploadedFileExtension[uploadedFileExtension.length - 1];
	
	                if (['.jpg', '.jpeg', '.png', '.gif'].indexOf(uploadedFileExtension.toLowerCase()) === -1) {
	                    this.formErrors.push('Uploaded preview image is not an acceptable type');
	                }
	            }
	        },
	        cancelPiece: function cancelPiece() {
	            this.$emit('doneEditing');
	        }
	    },
	
	    watch: {
	        'selectedMediaType': function selectedMediaType() {
	            this.mediaText = '';
	        }
	    }
	};

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _vue = __webpack_require__(4);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'FormReorderMediaAlbum',
	    props: ['pageType', 'pageId'],
	    data: function data() {
	        return {
	            isSaving: false,
	            albums: []
	        };
	    },
	    mounted: function mounted() {
	        var _this = this;
	
	        var portfolioData = this.$store.state.mediasModel.medias[this.pageType + '.' + this.pageId];
	
	        if (portfolioData) {
	            this.albums = [];
	
	            (0, _keys2.default)(portfolioData.albums).forEach(function (key) {
	                _this.albums.push(portfolioData.albums[key]);
	            });
	
	            this.albums.sort(function (a, b) {
	                return a.rank > b.rank ? 1 : -1;
	            });
	        }
	    },
	
	
	    computed: {},
	
	    methods: {
	        moveUp: function moveUp(index) {
	            var temp = this.albums[index];
	            _vue2.default.set(this.albums, index, this.albums[index - 1]);
	            _vue2.default.set(this.albums, index - 1, temp);
	        },
	        moveDown: function moveDown(index) {
	            var temp = this.albums[index];
	            _vue2.default.set(this.albums, index, this.albums[index + 1]);
	            _vue2.default.set(this.albums, index + 1, temp);
	        },
	        cancel: function cancel() {
	            this.$emit('doneEditing');
	        },
	        save: function save() {
	            var albumIds = [];
	            this.albums.forEach(function (album) {
	                albumIds.push(album.id);
	            });
	
	            this.$store.dispatch('medias/reorderAlbums', {
	                albums: albumIds,
	                pageType: this.pageType,
	                pageId: this.pageId
	            });
	        }
	    }
	};

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _FormEditMediaAlbum = __webpack_require__(731);
	
	var _FormEditMediaAlbum2 = _interopRequireDefault(_FormEditMediaAlbum);
	
	var _FormNewMediaPiece = __webpack_require__(733);
	
	var _FormNewMediaPiece2 = _interopRequireDefault(_FormNewMediaPiece);
	
	var _MediaPieceSingle = __webpack_require__(734);
	
	var _MediaPieceSingle2 = _interopRequireDefault(_MediaPieceSingle);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'MediaPieceList',
	    props: ['pageType', 'pageId', 'mediasId', 'canEdit'],
	
	    data: function data() {
	        return {
	            editAlbumMode: false,
	            addPieceMode: false
	        };
	    },
	
	
	    components: {
	        'edit-album-form': _FormEditMediaAlbum2.default,
	        'new-piece-form': _FormNewMediaPiece2.default,
	        'single-piece-listing': _MediaPieceSingle2.default
	    },
	
	    mounted: function mounted() {
	        if (this.album) {
	            this.getPieces();
	        }
	    },
	
	
	    computed: {
	        album: function album() {
	            var mediaData = this.$store.state.mediasModel.medias[this.mediasId];
	            var foundAlbum = void 0;
	
	            if (mediaData && mediaData.albums) {
	
	                _lodash2.default.each(mediaData.albums, function (album) {
	                    if (album.stringUrl === this.$route.params.album) {
	                        foundAlbum = album;
	                    }
	                }.bind(this));
	
	                return foundAlbum;
	            }
	        },
	        pieces: function pieces() {
	            var mediaData = this.$store.state.mediasModel.medias[this.mediasId];
	
	            if (mediaData && this.album && mediaData.albums[this.album.id]) {
	                return mediaData.albums[this.album.id].pieces || {};
	            }
	        },
	        piecesCount: function piecesCount() {
	            return (0, _keys2.default)(this.pieces || {}).length;
	        },
	        fetchingPieces: function fetchingPieces() {
	            return this.album && this.album.fetchStatus === 'fetching';
	        },
	        singlePieceMode: function singlePieceMode() {
	            return this.$route.params.piece !== undefined;
	        }
	    },
	
	    methods: {
	        getPieces: function getPieces() {
	            this.$store.dispatch('medias/getPieces', {
	                mediasId: this.mediasId,
	                albumId: this.album.id
	            });
	        },
	        enterEditAlbumMode: function enterEditAlbumMode() {
	            this.editAlbumMode = true;
	        },
	        exitEditAlbumMode: function exitEditAlbumMode() {
	            this.editAlbumMode = false;
	        },
	        enterAddPieceMode: function enterAddPieceMode() {
	            this.addPieceMode = true;
	        },
	        exitAddPieceMode: function exitAddPieceMode() {
	            this.addPieceMode = false;
	        }
	    },
	
	    watch: {
	        'album': function album() {
	            if (this.album && this.album.fetchStatus !== 'fetched' && this.album.fetchStatus !== 'fetching') {
	                this.getPieces();
	                this.exitEditAlbumMode();
	            }
	        },
	        '$route.params.album': function $routeParamsAlbum() {
	            this.exitEditAlbumMode();
	            this.exitAddPieceMode();
	        }
	    },
	
	    sockets: {
	        'mediaAlbumAddOrEdit': function mediaAlbumAddOrEdit(data) {
	            this.exitEditAlbumMode();
	
	            if (!this.album || data.id === this.album.id) {
	                if (this.pageType === 'developer') {
	                    this.$router.push('/Developer/' + this.$route.params.developer + '/Portfolio/' + data.stringUrl);
	                }
	
	                if (this.pageType === 'game') {
	                    this.$router.push('/Game/' + this.$route.params.game + '/Media/' + data.stringUrl);
	                }
	            }
	        },
	        'mediaPieceAddOrEdit': function mediaPieceAddOrEdit(data) {
	            this.exitAddPieceMode();
	        }
	    }
	};

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _FormEditMediaPiece = __webpack_require__(732);
	
	var _FormEditMediaPiece2 = _interopRequireDefault(_FormEditMediaPiece);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'MediaPieceSingle',
	    props: ['album', 'pieces', 'mediasId', 'canEdit'],
	
	    components: {
	        'edit-form': _FormEditMediaPiece2.default
	    },
	
	    computed: {
	        showLoader: function showLoader() {
	            return this.album && this.album.fetchStatus !== 'fetched';
	        },
	        showPiece: function showPiece() {
	            return this.album && this.pieces && this.album.fetchStatus === 'fetched' && (0, _keys2.default)(this.pieces).length > 0;
	        },
	        piece: function piece() {
	            var foundPiece = void 0;
	            if (this.album && this.pieces && this.album.fetchStatus === 'fetched' && (0, _keys2.default)(this.pieces).length > 0) {
	                _lodash2.default.each(this.pieces, function (piece) {
	                    if (piece.stringUrl === this.$route.params.piece) {
	
	                        foundPiece = piece;
	                    }
	                }.bind(this));
	            }
	
	            return foundPiece;
	        },
	        editMode: function editMode() {
	            return this.$route.params.edit !== undefined;
	        }
	    },
	
	    methods: {
	        exitSinglePieceView: function exitSinglePieceView() {
	            var posterType = this.$options.filters.capitalizeFirstLetter(this.piece.posterType);
	            var posterStringUrl = this.piece.posterStringUrl || this.piece.subPosterStringUrl;
	            var albumStringUrl = this.piece.albumStringUrl;
	            var urlPiece = posterType === 'Developer' ? 'Portfolio' : 'Media';
	
	            this.$router.push('/' + posterType + '/' + posterStringUrl + '/' + urlPiece + '/' + albumStringUrl);
	        }
	    }
	};

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vueGlobalEventBus = __webpack_require__(10);
	
	var _vueGlobalEventBus2 = _interopRequireDefault(_vueGlobalEventBus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'Modal',
	    data: function data() {
	        return {
	            showModal: false,
	            modalContent: undefined
	        };
	    },
	    created: function created() {
	        var _this = this;
	
	        _vueGlobalEventBus2.default.$on('openModal', function (content) {
	            _this.modalContent = content;
	            _this.showModal = true;
	        });
	    },
	
	
	    methods: {
	        closeModal: function closeModal() {
	            this.showModal = false;
	        }
	    }
	};

/***/ }),
/* 206 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: 'Pagination',
	    props: ['currentPage', 'maxPage', 'spread'],
	    data: function data() {
	        return {};
	    },
	
	
	    components: {},
	
	    mounted: function mounted() {},
	
	
	    computed: {
	        minPageToShow: function minPageToShow() {
	            if (this.currentPage - this.spread <= 1) {
	                return 1;
	            }
	
	            return this.currentPage - this.spread;
	        },
	        maxPageToShow: function maxPageToShow() {
	            if (this.maxPage - this.spread < this.currentPage) {
	                return this.maxPage;
	            }
	
	            return this.currentPage + this.spread;
	        },
	        showLeftEllipses: function showLeftEllipses() {
	            return this.minPageToShow > 1;
	        },
	        showRightEllipses: function showRightEllipses() {
	            return this.maxPageToShow < this.maxPage;
	        }
	    },
	
	    methods: {
	        switchToPage: function switchToPage(newPage) {
	            if (newPage <= 1) {
	                newPage = 1;
	            }
	
	            if (newPage >= this.maxPage) {
	                newPage = this.maxPage;
	            }
	
	            if (newPage !== this.currentPage) {
	                this.$emit('switchToPage', newPage);
	            }
	        }
	    }
	};

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'VotingWidget',
	    props: ['parentType', 'parentId', 'initialPoints'],
	
	    data: function data() {
	        return {
	            loggedVote: 0,
	            points: 0,
	            upVoters: [],
	            downVoters: [],
	            showTooltip: false
	        };
	    },
	
	
	    components: {},
	
	    mounted: function mounted() {
	        this.points = this.initialPoints;
	        this.fetchPoints({ parentType: this.parentType, parentId: this.parentId });
	    },
	
	
	    computed: {
	        isLoggedIn: function isLoggedIn() {
	            return this.$store.state.loggedUserModel.isLoggedIn;
	        }
	    },
	
	    methods: {
	        fetchPoints: function fetchPoints() {
	            var self = this;
	
	            _axios2.default.get('/api/voting', {
	                params: {
	                    parentType: self.parentType,
	                    parentId: self.parentId
	                }
	            }).then(function (response) {
	                self.loggedVote = response.data.loggedVote;
	                self.points = response.data.voteTotal;
	                self.upVoters = response.data.upVoters;
	                self.downVoters = response.data.downVoters;
	            });
	        },
	        vote: function vote(voteDirection) {
	            _axios2.default.post('/api/voting', {
	                parentType: this.parentType,
	                parentId: this.parentId,
	                direction: voteDirection
	            });
	        }
	    },
	
	    sockets: {
	        'voteWidgetUpdated': function voteWidgetUpdated(data) {
	            if (data.parentType === this.parentType && data.parentId == this.parentId) {
	                this.fetchPoints();
	            }
	        }
	    }
	};

/***/ }),
/* 208 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: 'Masonry',
	    props: ['minWidth', 'horizontalGutter', 'verticalGutter'],
	
	    data: function data() {
	        return {
	            parentWidth: 0
	        };
	    },
	    mounted: function mounted() {
	        this.$nextTick(function () {
	            this.setParentWidth();
	        });
	
	        window.addEventListener('resize', this.setParentWidth);
	    },
	    beforeDestroy: function beforeDestroy() {
	        window.removeEventListener('resize', this.setParentWidth);
	    },
	
	
	    methods: {
	        setParentWidth: function setParentWidth() {
	            this.$nextTick(function () {
	                this.parentWidth = this.$parent.$el ? this.$parent.$el.offsetWidth : 0;
	            });
	        }
	    },
	
	    render: function render(createElement) {
	        var masonryColumns = [],
	            columnCalculatedHeights = [],
	            reRender = false,
	            columnCount = void 0,
	            gutterCount = void 0,
	            columnWidth = void 0,
	            lastColumnWidth = void 0;
	
	        if (!this.parentWidth || this.parentWidth === 0 || !this.$slots.default) {
	            return;
	        }
	
	        gutterCount = Math.floor((this.parentWidth - this.minWidth) / (this.horizontalGutter + this.minWidth));
	        columnCount = gutterCount + 1;
	
	        if (columnCount <= 0) {
	            columnCount = 1;
	        }
	
	        columnWidth = (this.parentWidth - gutterCount * this.horizontalGutter) / columnCount + this.horizontalGutter;
	        columnWidth = Math.floor(columnWidth);
	
	        if (columnCount === 1) {
	            columnWidth = 0;
	        } else {
	            lastColumnWidth = 0;
	        }
	
	        for (var _i = 0; _i < columnCount; _i++) {
	            masonryColumns.push(createElement('div', {
	                'class': 'vue-masonry-column',
	                style: {
	                    'width': _i < columnCount - 1 ? columnWidth + 'px' : lastColumnWidth + 'px',
	                    'padding-right': _i < columnCount - 1 ? this.horizontalGutter + 'px' : '0'
	                }
	            }));
	
	            columnCalculatedHeights.push(0);
	        }
	
	        var i = 0;
	
	        this.$slots.default.forEach(function (element) {
	            if (!element.tag) {
	                return;
	            }
	
	            if (element.elm && element.elm.offsetHeight) {
	                var lowestColumn = void 0;
	                var lowestColumnHeight = Infinity;
	
	                for (var j = 0; j < masonryColumns.length; j++) {
	                    if (columnCalculatedHeights[j] < lowestColumnHeight) {
	                        lowestColumn = j;
	                        lowestColumnHeight = columnCalculatedHeights[j];
	                    }
	                }
	
	                if (masonryColumns[lowestColumn].children) {
	                    masonryColumns[lowestColumn].children.push(element);
	                } else {
	                    masonryColumns[lowestColumn].children = [element];
	                }
	
	                columnCalculatedHeights[lowestColumn] += element.elm.offsetHeight + this.verticalGutter;
	            } else {
	                if (masonryColumns[i].children) {
	                    masonryColumns[i].children.push(element);
	                } else {
	                    masonryColumns[i].children = [element];
	                }
	
	                i++;
	                if (i >= masonryColumns.length) {
	                    i = 0;
	                }
	                reRender = true;
	            }
	        }.bind(this));
	
	        if (reRender) {
	            this.$nextTick(function () {
	                this.$forceUpdate();
	            });
	        }
	
	        return createElement('div', {
	            'class': 'vue-masonry'
	        }, masonryColumns);
	    }
	};

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vueGlobalEventBus = __webpack_require__(10);
	
	var _vueGlobalEventBus2 = _interopRequireDefault(_vueGlobalEventBus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'main',
	    computed: {
	        isLoggedIn: function isLoggedIn() {
	            return this.$store.state.loggedUserModel.isLoggedIn;
	        }
	    },
	
	    methods: {}
	};

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _ChatRoom = __webpack_require__(751);
	
	var _ChatRoom2 = _interopRequireDefault(_ChatRoom);
	
	var _PrivateChat = __webpack_require__(810);
	
	var _PrivateChat2 = _interopRequireDefault(_PrivateChat);
	
	var _OnlineUsers = __webpack_require__(809);
	
	var _OnlineUsers2 = _interopRequireDefault(_OnlineUsers);
	
	var _vueGlobalEventBus = __webpack_require__(10);
	
	var _vueGlobalEventBus2 = _interopRequireDefault(_vueGlobalEventBus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: "ChatCompanion",
	    components: {
	        'chat-companion': _ChatRoom2.default,
	        'private-chat-companion': _PrivateChat2.default,
	        'online-users-companion': _OnlineUsers2.default
	    },
	    data: function data() {
	        return {
	            activeTab: 'Chatroom',
	            chatNotificationSound: new Audio('src/sounds/chatNotification.mp3'),
	            lastNotificationSoundTime: 0
	        };
	    },
	
	
	    computed: {
	        tabs: function tabs() {
	            return [{
	                label: 'Chatroom',
	                requiresLogin: false,
	                showNotification: false,
	                notificationType: 'badge'
	            }, {
	                label: 'Private Chat',
	                requiresLogin: true,
	                showNotification: this.hasUnreadPrivateChats,
	                notificationType: 'badge'
	            }, {
	                label: 'Online Users',
	                requiresLogin: false,
	                showNotification: true,
	                notificationType: 'total',
	                notificationCount: this.onlineUserCount
	            }];
	        },
	        isLoggedIn: function isLoggedIn() {
	            return this.$store.state.loggedUserModel.isLoggedIn;
	        },
	        totalGuests: function totalGuests() {
	            var onlineUsers = this.$store.state.onlineUsersModel.onlineUsers;
	            var guests = 0;
	
	            _.each(onlineUsers, function (user) {
	                if (!user.id) {
	                    guests++;
	                }
	            });
	
	            return guests;
	        },
	        onlineUserCount: function onlineUserCount() {
	            var onlineUserCount = this.$store.state.onlineUsersModel.onlineUsers.length - this.totalGuests;
	            if (onlineUserCount < 0) {
	                onlineUserCount = 0;
	            }
	
	            return onlineUserCount;
	        },
	        audioNotificationsEnabled: function audioNotificationsEnabled() {
	            return this.isLoggedIn ? this.$store.state.loggedUserModel.options.chatroomNotificationSound === 'on' : false;
	        },
	        selectedPrivateChatConversation: function selectedPrivateChatConversation() {
	            return this.$store.state.privateChatModel.selectedConversation;
	        },
	        hasUnreadPrivateChats: function hasUnreadPrivateChats() {
	            var conversations = this.$store.state.privateChatModel.conversations;
	
	            for (var i in conversations) {
	                var conversation = conversations[i];
	                var isUnread = !conversation.hasBeenRead;
	                var hasOpenConversation = this.selectedPrivateChatConversation;
	                var isActiveConversation = hasOpenConversation && this.activeTab === 'Private Chat' ? conversation.chatId === this.selectedPrivateChatConversation.chatId : false;
	
	                if (isUnread && !isActiveConversation) {
	                    return true;
	                }
	            }
	
	            return false;
	        }
	    },
	
	    sockets: {
	        'updateConversations': function updateConversations() {
	            this.$store.dispatch('privateChat/getConversations');
	        },
	        'receivedPrivateChatMessage': function receivedPrivateChatMessage(data) {
	            this.$store.dispatch('privateChat/getConversations');
	
	            this.$store.dispatch('privateChat/getMessages', {
	                chatId: data.chatId,
	                forceReFetch: true
	            });
	
	            var shouldPlaySound = document.visibilityState !== 'visible' && this.audioNotificationsEnabled && new Date().getTime() - this.lastNotificationSoundTime > 5000;
	
	            if (shouldPlaySound) {
	                this.chatNotificationSound.play();
	                this.lastNotificationSoundTime = new Date().getTime();
	            }
	        }
	    },
	
	    mounted: function mounted() {
	        this.$store.dispatch('privateChat/getConversations');
	
	        _vueGlobalEventBus2.default.$on('privateChatOpenConversation', function (participant) {
	            this.activeTab = 'Private Chat';
	
	            this.$nextTick(function () {
	                var userA = this.$store.state.loggedUserModel.info.id;
	                var userB = participant.id;
	                var matchingConversation = this.$refs.privateChat.getMatchingConversation(userA, userB);
	
	                if (matchingConversation !== undefined) {
	                    this.$refs.privateChat.selectConversation(matchingConversation);
	                } else {
	                    this.$refs.privateChat.createNewConversation(participant);
	                }
	            });
	        }.bind(this));
	    },
	
	
	    watch: {
	        'isLoggedIn': function isLoggedIn() {
	            this.$store.dispatch('privateChat/getConversations');
	        }
	    }
	};

/***/ }),
/* 211 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: "LayoutFooter"
	};

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _MainNav = __webpack_require__(743);
	
	var _MainNav2 = _interopRequireDefault(_MainNav);
	
	var _SubNav = __webpack_require__(745);
	
	var _SubNav2 = _interopRequireDefault(_SubNav);
	
	var _ChatCompanion = __webpack_require__(740);
	
	var _ChatCompanion2 = _interopRequireDefault(_ChatCompanion);
	
	var _LayoutFooter = __webpack_require__(741);
	
	var _LayoutFooter2 = _interopRequireDefault(_LayoutFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'layoutFullWithChat',
	    components: {
	        'main-nav': _MainNav2.default,
	        'sub-nav': _SubNav2.default,
	        'chat-companion': _ChatCompanion2.default,
	        'layout-footer': _LayoutFooter2.default
	    },
	    metaInfo: {
	        title: 'Develteam | Game Developer Community | Game dev team up'
	    },
	
	    data: function data() {
	        return {
	            chatRoomOpen: false
	        };
	    },
	
	
	    methods: {
	        toggleChatRoom: function toggleChatRoom() {
	            this.chatRoomOpen = !this.chatRoomOpen;
	        }
	    }
	};

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _SearchWidget = __webpack_require__(744);
	
	var _SearchWidget2 = _interopRequireDefault(_SearchWidget);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'mainNav',
	
	    components: {
	        'search-widget': _SearchWidget2.default
	    },
	
	    data: function data() {
	        return {
	            showNotificationsList: false
	        };
	    },
	
	
	    computed: {
	        isLoggedIn: function isLoggedIn() {
	            return this.$store.state.loggedUserModel.isLoggedIn;
	        },
	        showUserPanel: function showUserPanel() {
	            return this.$store.state.loggedUserModel.gotInitialLoggedUserInfo;
	        },
	        loggedUserDetails: function loggedUserDetails() {
	            if (this.isLoggedIn) {
	                return this.$store.state.loggedUserModel;
	            }
	        },
	        unreadInboxCount: function unreadInboxCount() {
	            var conversations = this.$store.state.inboxPageModel.conversations,
	                total = 0;
	
	            conversations.forEach(function (conversation) {
	                if (!conversation.hasBeenRead) {
	                    total++;
	                }
	            });
	
	            return total;
	        },
	        unreadInvitesNotificationCount: function unreadInvitesNotificationCount() {
	            var totalInvitationsToGames = this.$store.state.invitesModel.invitationsToGames.length;
	            var totalRequestsToJoin = this.$store.state.invitesModel.requestsToJoin.length;
	            var sentInvitationsToGames = this.$store.state.invitesModel.sentInvitationsToGames;
	            var sentRequestsToJoin = this.$store.state.invitesModel.sentRequestsToJoin;
	
	            var totalSentInvitationsToGames = _.filter(sentInvitationsToGames, function (sentInvite) {
	                return sentInvite.response !== 'noResponse';
	            }).length;
	
	            var totalSentRequestsToJoin = _.filter(sentRequestsToJoin, function (sentRequest) {
	                return sentRequest.response !== 'noResponse';
	            }).length;
	
	            return totalInvitationsToGames + totalRequestsToJoin + totalSentInvitationsToGames + totalSentRequestsToJoin;
	        },
	        notifications: function notifications() {
	            var allNotifications = this.$store.state.notificationsModel.notifications;
	            var unreadNotificationCount = _.filter(allNotifications, function (notification) {
	                return notification.hasBeenRead === 0;
	            }).length;
	
	            var truncateCount = unreadNotificationCount > 10 ? unreadNotificationCount : 10;
	
	            return this.$store.state.notificationsModel.notifications.slice(0, 1000);
	        },
	        unreadNotifications: function unreadNotifications() {
	            var allNotifications = this.$store.state.notificationsModel.notifications;
	
	            return _.filter(allNotifications, function (notification) {
	                return notification.hasBeenRead === 0;
	            }).length;
	        },
	        totalUnreadNotifications: function totalUnreadNotifications() {
	            return this.unreadInboxCount + this.unreadInvitesNotificationCount + this.unreadNotifications;
	        },
	        notificationsFetchingStatus: function notificationsFetchingStatus() {
	            return this.$store.state.notificationsModel.fetchingStatus;
	        }
	    },
	
	    methods: {
	        logOut: function logOut(e) {
	            this.$store.dispatch('loggedUserModel/logOut', function (user) {
	                this.$socket.emit("unsetUserSocketData", user);
	            }.bind(this));
	        },
	        socialShare: function socialShare(site) {
	            var url = '';
	            var postUrl = postUrl = 'https://www.develteam.com';
	
	            if (site === 'facebook') {
	                url = 'https://www.facebook.com/sharer/sharer.php?u=' + postUrl;
	            } else if (site === 'twitter') {
	                url = 'https://twitter.com/home?status=' + postUrl;
	            } else if (site === 'linkedin') {
	                url = 'https://www.linkedin.com/shareArticle?mini=true&url=' + postUrl + '&title=&summary=&source=';
	            }
	
	            window.open(url, '_blank');
	        }
	    },
	
	    watch: {
	        'isLoggedIn': function isLoggedIn() {
	            if (this.isLoggedIn) {
	                this.$store.dispatch('InboxPage/getConversations');
	                this.$store.dispatch('invites/fetchInvites');
	                this.$store.dispatch('notificationsModel/getNotifications');
	            }
	        }
	    },
	
	    sockets: {
	        'invitesUpdated': function invitesUpdated() {
	            this.$store.dispatch('invites/fetchInvites');
	        },
	        'notificationsUpdated': function notificationsUpdated() {
	            this.$store.dispatch('notificationsModel/getNotifications');
	        }
	    }
	};

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'SearchWidget',
	    data: function data() {
	        return {
	            searchString: '',
	            searchMessage: '',
	            devMatches: [],
	            gameMatches: [],
	            isHidden: false
	        };
	    },
	
	
	    components: {},
	
	    mounted: function mounted() {},
	
	
	    computed: {
	        prop: function prop() {
	            return {};
	        }
	    },
	
	    methods: {
	        getMatchingDevs: _.debounce(function () {
	            this.getMatches();
	            this.searchMessage = '';
	        }, 500),
	
	        getMatches: function getMatches() {
	            var _this = this;
	
	            _axios2.default.get('/api/searchDevelopersAndGamesByAlias', {
	                params: {
	                    search: this.searchString
	                }
	            }).then(function (response) {
	                _this.devMatches = response.data.developers;
	                _this.gameMatches = response.data.games;
	            }, function (response) {
	                console.log(response);
	            });
	        },
	        hide: function hide() {
	            setTimeout(function () {
	                this.isHidden = true;
	            }.bind(this), 500);
	        },
	        show: function show() {
	            this.isHidden = false;
	        }
	    },
	
	    watch: {
	        searchString: function searchString() {
	            if (this.searchString.length >= 3) {
	                this.searchMessage = 'Searching for matching developers...';
	                this.getMatchingDevs();
	            } else {
	                this.searchMessage = 'Enter three or more characters';
	                this.devMatches = [];
	                this.gameMatches = [];
	            }
	        }
	    }
	};

/***/ }),
/* 215 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: 'subNav',
	
	    computed: {
	        links: function links() {
	            var selectedRoute = this.$route.meta.subNavRoute;
	
	            return [{ to: '/', text: 'Home', style: 'top-content', selected: selectedRoute === 'homeDashboard' }, { to: '/Media', text: 'Media', style: 'posts-media', selected: selectedRoute === 'media', showBadge: !this.userInfo.caughtUpOnMedia }, { to: '/DevLogs', text: 'DevLogs', style: 'posts-devlogs', selected: selectedRoute === 'devlogs', showBadge: !this.userInfo.caughtUpOnDevlogs }, { to: '/Classifieds', text: 'Classifieds', style: 'posts-classifieds', selected: selectedRoute === 'classifieds', showBadge: !this.userInfo.caughtUpOnClassifieds }, { to: '/Forums/Develteam/Develteam', text: 'Forums', style: 'forums', selected: selectedRoute === 'forums', showBadge: !this.userInfo.caughtUpOnForums }, { to: '/Browse', text: 'Developers', style: 'browse-developers', selected: selectedRoute === 'browseDevs' }, { to: '/Browse/Games', text: 'Games', style: 'browse-games', selected: selectedRoute === 'browseGames' }, { to: '/Resources', text: 'Dev Tools', style: 'resource-devtools', selected: selectedRoute === 'resourcesDevTools' }, { to: '/Resources/Assets', text: 'Assets', style: 'resource-assets', selected: selectedRoute === 'resourcesAssets' }, { to: '/Donations', text: 'Donations', style: 'donations', selected: selectedRoute === 'donations' }];
	        },
	        userInfo: function userInfo() {
	            return this.$store.state.loggedUserModel.info;
	        },
	        isLoggedIn: function isLoggedIn() {
	            return this.$store.state.loggedUserModel.isLoggedIn;
	        }
	    }
	};

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _FeedGroupPost = __webpack_require__(137);
	
	var _FeedGroupPost2 = _interopRequireDefault(_FeedGroupPost);
	
	var _HomeFeedNewPostForm = __webpack_require__(791);
	
	var _HomeFeedNewPostForm2 = _interopRequireDefault(_HomeFeedNewPostForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'HomeFeedPage',
	    metaInfo: {
	        title: 'Develteam | Game Developer Community | Game dev team up'
	    },
	
	    data: function data() {
	        return {
	            feedPostsId: 'blogFeed'
	        };
	    },
	
	
	    components: {
	        'group-post': _FeedGroupPost2.default,
	        'new-post-form': _HomeFeedNewPostForm2.default
	    },
	
	    mounted: function mounted() {
	        if ((0, _keys2.default)(this.feedPosts).length === 0) {
	            this.getPosts();
	        }
	
	        this.$store.dispatch('loggedUserModel/CatchUpOnDevlogs');
	    },
	
	
	    computed: {
	        feedPosts: function feedPosts() {
	            var feedData = this.$store.state.feedPostsModel.feedPosts[this.feedPostsId],
	                feedPostArray = void 0,
	                outputArray = [];
	
	            if (!feedData) {
	                return [];
	            }
	
	            feedPostArray = _lodash2.default.values(feedData.posts).sort(function (a, b) {
	                var aDate = new Date(a.postDate),
	                    bDate = new Date(b.postDate);
	
	                return bDate - aDate;
	            });
	
	            for (var i = 0; i < feedPostArray.length; i++) {
	                var streakCount = 0,
	                    j = i,
	                    groupPost = [];
	
	                if (!feedPostArray[j].subPosterDetails) {
	                    feedPostArray[j].subPosterDetails = {};
	                }
	
	                while (j < feedPostArray.length - 1 && feedPostArray[j].subPosterType === feedPostArray[j + 1].subPosterType && feedPostArray[j].type === 'media' && feedPostArray[j + 1].type === 'media' && (feedPostArray[j].subPosterType === 'developer' && feedPostArray[j].posterDetails.id === feedPostArray[j + 1].posterDetails.id || feedPostArray[j].subPosterType !== 'developer' && feedPostArray[j].subPosterDetails.id === feedPostArray[j + 1].subPosterDetails.id)) {
	                    streakCount++;
	                    j++;
	                }
	
	                if (streakCount > 0) {
	                    streakCount++;
	                    groupPost = {
	                        type: 'groupPost',
	                        posts: []
	                    };
	
	                    for (var k = 0; k < streakCount; k++) {
	                        groupPost.posts.push(feedPostArray[k + i]);
	                    }
	
	                    outputArray.push(groupPost);
	                    i += streakCount;
	                    i--;
	                } else {
	                    outputArray.push({ type: 'singlePost', post: feedPostArray[i] });
	                }
	            }
	
	            return outputArray;
	        },
	        fetchingStatus: function fetchingStatus() {
	            var developerFeedData = this.$store.state.feedPostsModel.feedPosts[this.feedPostsId];
	            return developerFeedData ? developerFeedData.fetchingStatus : 'fetching';
	        },
	        gotInitialLoggedUserInfo: function gotInitialLoggedUserInfo() {
	            return this.$store.state.loggedUserModel.gotInitialLoggedUserInfo;
	        },
	        isLoggedIn: function isLoggedIn() {
	            return this.$store.state.loggedUserModel.isLoggedIn;
	        },
	        hasFetchedAll: function hasFetchedAll() {
	            var developerFeedData = this.$store.state.feedPostsModel.feedPosts[this.feedPostsId];
	            return developerFeedData ? developerFeedData.hasFetchedAll : true;
	        },
	        hasLoginCookies: function hasLoginCookies() {
	            var cookieEntries = document.cookie.split(';');
	            var cookies = {};
	
	            cookieEntries.forEach(function (cookie) {
	                var cookieSegments = cookie.split('=');
	                if (cookieSegments.length === 2 && cookieSegments[1].trim() !== '') {
	                    cookies[cookieSegments[0].trim()] = cookieSegments[1].trim();
	                }
	            });
	
	            return cookies.userid !== undefined && cookies.password !== undefined;
	        }
	    },
	
	    methods: {
	        getPosts: function getPosts() {
	            this.$store.dispatch('feedPosts/getBlogFeedPosts', {
	                feedPostsId: this.feedPostsId,
	                feedType: 'home',
	                limit: 20
	            });
	        }
	    }
	};

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _BrowsePageDeveloperItem = __webpack_require__(748);
	
	var _BrowsePageDeveloperItem2 = _interopRequireDefault(_BrowsePageDeveloperItem);
	
	var _BrowsePageGameItem = __webpack_require__(749);
	
	var _BrowsePageGameItem2 = _interopRequireDefault(_BrowsePageGameItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'BrowsePage',
	    metaInfo: {
	        title: 'Develteam | Game Developer Community | Game dev team up'
	    },
	
	    data: function data() {
	        return {
	            enteredSkill: '',
	            skillFilterId: 0
	        };
	    },
	
	
	    components: {
	        'browsePageDeveloperItem': _BrowsePageDeveloperItem2.default,
	        'browsePageGameItem': _BrowsePageGameItem2.default
	    },
	
	    mounted: function mounted() {
	        this.setInitialFilters();
	    },
	
	
	    computed: {
	        isLoggedIn: function isLoggedIn() {
	            return this.$store.state.loggedUserModel.isLoggedIn;
	        },
	        skillList: function skillList() {
	            return this.$store.state.develteamDataModel.skills;
	        },
	        pageId: function pageId() {
	            return this.$store.state.browsePageModel.pageId;
	        },
	        browseResults: function browseResults() {
	            return this.$store.state.browsePageModel.browseResults;
	        },
	        filterControls: function filterControls() {
	            return this.$store.state.browsePageModel.filterControls[this.pageId];
	        },
	        resultsPageCurrent: function resultsPageCurrent() {
	            return this.$store.state.browsePageModel.resultsPageCurrent;
	        },
	        resultsPageTotal: function resultsPageTotal() {
	            return this.$store.state.browsePageModel.resultsPageTotal;
	        },
	        isFetching: function isFetching() {
	            return this.$store.state.browsePageModel.isFetching;
	        },
	        showRecruitingOptions: function showRecruitingOptions() {
	            var isSeeking = false;
	
	            this.$store.state.browsePageModel.filterControls[this.pageId].filterOptions.forEach(function (option) {
	                if (option.id === 'filter|seeking' && option.selected === true) {
	                    isSeeking = true;
	                }
	            });
	
	            return isSeeking;
	        },
	        matchingSkills: function matchingSkills() {
	            var matchingSkills = [];
	
	            if (this.enteredSkill.length >= 1) {
	                for (var skillId in this.skillList) {
	                    var skill = this.skillList[skillId];
	                    var skillName = skill.category.toLowerCase() + ' ' + skill.skill.toLowerCase();
	
	                    if (skillName.toLowerCase().includes(this.enteredSkill.toLowerCase())) {
	                        matchingSkills.push(skill);
	                    }
	                }
	            }
	
	            matchingSkills = _.sortBy(matchingSkills, function (skill) {
	                return skill.skill;
	            });
	
	            return matchingSkills;
	        }
	    },
	
	    watch: {
	        '$route': function $route() {
	            this.setInitialFilters();
	        }
	    },
	
	    methods: {
	        setInitialFilters: function setInitialFilters() {
	            var seeking = this.$route.query.seeking,
	                showRole = this.$route.query.showRole,
	                seekingRole = this.$route.query.seekingRole,
	                seekingSkill = this.$route.query.seekingSkill;
	
	            this.$store.dispatch('browsePage/updatePageId', { blockPopulateResults: true });
	
	            if (seeking) {
	                this.$store.dispatch('browsePage/initializeFilterOption', 'filter|seeking');
	            }
	
	            if (showRole) {
	                this.$store.dispatch('browsePage/initializeFilterOption', 'show|' + showRole);
	            }
	
	            if (seekingRole) {
	                this.$store.dispatch('browsePage/initializeFilterOption', 'recruiting|' + seekingRole);
	                this.$store.dispatch('browsePage/initializeFilterOption', 'show|' + seekingRole);
	            }
	
	            if (seekingSkill) {
	                this.skillFilterId = seekingSkill;
	                this.$store.dispatch('browsePage/initializeFilterOption', 'skill|' + seekingSkill);
	            }
	
	            this.$store.dispatch('browsePage/populateResults');
	        },
	        setSkillId: function setSkillId(skillId) {
	            this.skillFilterId = skillId;
	            this.enteredSkill = '';
	            this.setOption('skill|' + skillId);
	        },
	        setOption: function setOption(id) {
	            this.$store.dispatch('browsePage/updateFilterOptions', id);
	        },
	        switchToResultsPage: function switchToResultsPage(newPage) {
	            this.$store.dispatch('browsePage/updateResultsPage', newPage);
	        }
	    }
	};

/***/ }),
/* 218 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: 'BrowsePageDeveloperItem',
	    props: ['details'],
	    computed: {
	        skillList: function skillList() {
	            return this.$store.state.develteamDataModel.skills;
	        },
	        isLoggedIn: function isLoggedIn() {
	            return this.$store.state.loggedUserModel.isLoggedIn;
	        },
	        developerIsOnline: function developerIsOnline() {
	            var onlineUsers = this.$store.state.onlineUsersModel.onlineUsers;
	            var developerIsOnline = false;
	            var developerId = this.details.id;
	
	            onlineUsers.forEach(function (onlineUser) {
	                if (onlineUser.id === developerId) {
	                    developerIsOnline = true;
	                }
	            });
	
	            return developerIsOnline;
	        }
	    }
	};

/***/ }),
/* 219 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: 'BrowsePageGameItem',
	    props: ['details'],
	
	    computed: {
	        skillList: function skillList() {
	            return this.$store.state.develteamDataModel.skills;
	        }
	    }
	};

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(75);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _MarkdownContent = __webpack_require__(143);
	
	var _MarkdownContent2 = _interopRequireDefault(_MarkdownContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    components: { MarkdownContent: _MarkdownContent2.default }, name: 'BugsAndSuggestions',
	    data: function data() {
	        return {
	            submitType: 'bug',
	            submitTitle: '',
	            submitDescription: '',
	            submitFormErrors: [],
	            submitIsSaving: false,
	            showSubmitForm: false,
	            showThankYouForm: false,
	            items: []
	        };
	    },
	    mounted: function mounted() {
	        this.fetchWorkItems();
	    },
	
	
	    computed: {
	        isModerator: function isModerator() {
	            return this.isLoggedIn && this.$store.state.loggedUserModel.info.id <= 2;
	        },
	        isLoggedIn: function isLoggedIn() {
	            return this.$store.state.loggedUserModel.isLoggedIn;
	        },
	        bugs: function bugs() {
	            return _lodash2.default.filter(this.items, function (item) {
	                return item.type === 'bug' && item.status === 'backlog';
	            });
	        },
	        suggestions: function suggestions() {
	            return _lodash2.default.filter(this.items, function (item) {
	                return item.type === 'suggestion' && item.status === 'backlog';
	            });
	        },
	        inProgress: function inProgress() {
	            return _lodash2.default.filter(this.items, function (item) {
	                return item.status === 'inProgress';
	            });
	        },
	        done: function done() {
	            return _lodash2.default.filter(this.items, function (item) {
	                return item.status === 'done';
	            });
	        }
	    },
	
	    methods: {
	        fetchWorkItems: function fetchWorkItems() {
	            var _this = this;
	
	            _axios2.default.get('/api/bugsAndSuggestions').then(function (response) {
	                _this.items = response.data.items;
	            }, function (response) {
	                console.log(response);
	            });
	        },
	        submitWorkItem: function submitWorkItem() {
	            var _this2 = this;
	
	            var errors = [];
	
	            if (this.submitTitle.trim() === '') {
	                errors.push('Please Submit a Title');
	            }
	
	            if (errors.length > 0) {
	                this.submitFormErrors = errors;
	                return;
	            }
	
	            this.submitIsSaving = true;
	
	            _axios2.default.post('/api/bugsAndSuggestions', {
	                title: this.submitTitle,
	                description: this.submitDescription,
	                type: this.submitType
	            }).then(function (response) {
	                _this2.submitIsSaving = false;
	
	                if (response.data.errors) {
	                    _this2.submitFormErrors = response.data.errors;
	                    return;
	                }
	
	                _this2.submitTitle = '';
	                _this2.submitDescription = '';
	                _this2.showThankYouForm = true;
	            }, function (response) {
	                _this2.submitFormErrors = ['There was a problem connecting to the server. Please Reload and try again'];
	                _this2.submitIsSaving = false;
	            });
	        },
	        moveTo: function moveTo(item, newStatus) {
	            _axios2.default.post('/api/bugsAndSuggestions/moderatorMove', {
	                item: JSON.parse((0, _stringify2.default)(item)),
	                newStatus: newStatus
	            }).then(function (response) {}, function (response) {
	                console.log(response);
	            });
	        }
	    },
	
	    sockets: {
	        'updatedBugsAndSuggestions': function updatedBugsAndSuggestions() {
	            this.fetchWorkItems();
	        }
	    }
	};

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: "Chatroom",
	
	    data: function data() {
	        return {
	            chatNotificationSound: new Audio('src/sounds/chatNotification.mp3'),
	            lastNotificationSoundTime: 0,
	            newMessage: '',
	            showingHistoryDates: false,
	            showingHistoryDateMessages: false,
	            selectedHistoryDate: undefined
	        };
	    },
	
	
	    sockets: {
	        chatroomUpdated: function chatroomUpdated() {
	            var self = this;
	            var shouldScrollAfter = self.$refs.chatMessages.scrollTop >= self.$refs.chatMessages.scrollHeight - self.$refs.chatMessages.clientHeight;
	
	            this.$store.dispatch('chatRoom/getMessages', function () {
	                if (shouldScrollAfter) {
	                    self.scrollDownMessages();
	                }
	            });
	
	            if (document.visibilityState !== 'visible' && this.audioNotificationsEnabled && new Date().getTime() - this.lastNotificationSoundTime > 5000) {
	                this.chatNotificationSound.play();
	                this.lastNotificationSoundTime = new Date().getTime();
	            }
	        },
	
	        chatroomRefreshed: function chatroomRefreshed() {
	            var self = this;
	            var shouldScrollAfter = self.$refs.chatMessages.scrollTop >= self.$refs.chatMessages.scrollHeight - self.$refs.chatMessages.clientHeight;
	
	            this.$store.dispatch('chatRoom/getMessages', function () {
	                if (shouldScrollAfter) {
	                    self.scrollDownMessages();
	                }
	            });
	        },
	
	        serverReconnect: function serverReconnect() {
	            this.joinRoom(this.selectedRoom.id);
	        }
	    },
	
	    computed: {
	        isLoggedIn: function isLoggedIn() {
	            if (this.$store.state.loggedUserModel.isLoggedIn && !this.selectedRoom) {
	                this.switchRooms('siteGeneral');
	            }
	
	            return this.$store.state.loggedUserModel.isLoggedIn;
	        },
	        rooms: function rooms() {
	            var rooms = this.$store.state.chatRoomModel.rooms,
	                games = void 0;
	
	            if (this.isLoggedIn) {
	                games = this.$store.state.loggedUserModel.games;
	                games.forEach(function (game) {
	                    var id = 'game.' + game.stringUrl;
	                    rooms[id] = {
	                        name: 'Game: ' + game.alias,
	                        id: id
	                    };
	                });
	            }
	
	            return this.$store.state.chatRoomModel.rooms;
	        },
	        audioNotificationsEnabled: function audioNotificationsEnabled() {
	            if (this.isLoggedIn) {
	                return this.$store.state.loggedUserModel.options.chatroomNotificationSound === 'on';
	            }
	        },
	        selectedRoom: function selectedRoom() {
	            return this.$store.state.chatRoomModel.selectedRoom;
	        },
	        messages: function messages() {
	            var messageGroups = [];
	
	            var messages = this.$store.state.chatRoomModel.messages;
	
	            if (this.showingHistoryDateMessages) {
	                messages = this.$store.state.chatRoomModel.historyMessages[this.selectedRoom.id + "_" + this.selectedHistoryDate.day] || [];
	            }
	
	            for (var i = 0; i < messages.length; i++) {
	                if (i > 0 && messages[i].from.id === messages[i - 1].from.id && messages[i].from.id !== null) {
	                    messageGroups[messageGroups.length - 1].messages.push(messages[i]);
	                } else {
	                    messageGroups.push({
	                        from: messages[i].from,
	                        timestamp: messages[i].timestamp,
	                        messages: [messages[i]],
	                        isSystemMessage: messages[i].isSystemMessage,
	                        systemMessageType: messages[i].systemMessageType,
	                        targetUrl: messages[i].systemMessageType === 'createdGame' ? '/Game/' + messages[i].systemMessageTargetGameStringUrl : '/Developer/' + messages[i].systemMessageTargetUserStringUrl,
	                        targetAlias: messages[i].systemMessageType === 'createdGame' ? messages[i].systemMessageTargetGameAlias : messages[i].systemMessageTargetUserAlias
	                    });
	                }
	            }
	
	            return messageGroups;
	        },
	        historyDates: function historyDates() {
	            return this.$store.state.chatRoomModel.historyDates || [];
	        },
	        showHistoryDatesLoader: function showHistoryDatesLoader() {
	            return this.$store.state.chatRoomModel.retrievingHistoryDates;
	        },
	        showHistoryMessagesLoader: function showHistoryMessagesLoader() {
	            return this.$store.state.chatRoomModel.retrievingHistoryMessages;
	        }
	    },
	
	    methods: {
	        sendMessage: function sendMessage() {
	            if (this.newMessage.trim() === '') {
	                return;
	            }
	
	            this.$store.dispatch('chatRoom/sendMessage', { message: this.newMessage });
	            this.newMessage = '';
	        },
	        switchRooms: function switchRooms(newRoomId) {
	            this.joinRoom(newRoomId);
	        },
	        chooseNewRoom: function chooseNewRoom(e) {
	            var newRoom = e.target.value;
	            this.switchRooms(newRoom);
	        },
	        joinRoom: function joinRoom(newRoomId) {
	            var self = this;
	
	            this.$store.dispatch('chatRoom/switchRooms', {
	                newRoomId: newRoomId,
	                callback: function callback() {
	                    self.scrollDownMessages();
	                }
	            });
	
	            this.$socket.emit('joinedRoom', newRoomId);
	        },
	        scrollDownMessages: function scrollDownMessages() {
	            this.$nextTick(function () {
	                if (this.$refs.chatMessages) {
	                    this.$refs.chatMessages.scrollTop = this.$refs.chatMessages.scrollHeight;
	                }
	            });
	        },
	        toggleAudioNotifications: function toggleAudioNotifications(state) {
	            this.$set(this.$store.state.loggedUserModel.options, 'chatroomNotificationSound', state);
	
	            _axios2.default.post('/api/userOptions/updateChatroomNotificationSound', {
	                state: state
	            });
	        },
	        toggleHistoryDates: function toggleHistoryDates() {
	            if (this.showingHistoryDates || this.showingHistoryDateMessages) {
	                this.showingHistoryDates = false;
	            } else {
	                this.showHistoryDates();
	            }
	
	            this.showingHistoryDateMessages = false;
	            this.selectedHistoryDate = undefined;
	        },
	        showHistoryDates: function showHistoryDates() {
	            this.showingHistoryDates = true;
	            this.$store.dispatch('chatRoom/getHistoryDates');
	        },
	        selectHistoryDate: function selectHistoryDate(selectedHistoryDate) {
	            var self = this;
	
	            this.$store.dispatch('chatRoom/getHistoryForDate', {
	                selectedHistoryDate: selectedHistoryDate, callback: function callback() {
	                    self.selectedHistoryDate = selectedHistoryDate;
	                    self.showingHistoryDates = false;
	                    self.showingHistoryDateMessages = true;
	                }
	            });
	        }
	    },
	
	    mounted: function mounted() {
	        if (!this.selectedRoom) {
	            this.switchRooms('siteGeneral');
	        } else {
	            this.joinRoom(this.selectedRoom.id);
	        }
	    }
	};

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vueGlobalEventBus = __webpack_require__(10);
	
	var _vueGlobalEventBus2 = _interopRequireDefault(_vueGlobalEventBus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: "Classifieds",
	
	    data: function data() {
	        return {
	            postTypes: ['Game Projects', 'Developers'],
	            selectedPostTypeId: 0,
	            roles: ['All', 'Designers', 'Artists', 'Programmers', 'Writers', 'Musicians', 'Sfx Artists', 'Testers', 'Producers'],
	            selectedRoleId: 0,
	            skillSearchText: '',
	            skillFilterId: 0,
	
	            isFetching: false,
	            editMode: false
	        };
	    },
	
	
	    computed: {
	        loggedUserId: function loggedUserId() {
	            return this.$store.state.loggedUserModel.info.id;
	        },
	        isLoggedIn: function isLoggedIn() {
	            return this.$store.state.loggedUserModel.isLoggedIn;
	        },
	        GameIdsOwned: function GameIdsOwned() {
	            var gameIds = [];
	
	            if (this.isLoggedIn) {
	                var games = this.$store.state.loggedUserModel.games;
	                for (var i = 0; i < games.length; i++) {
	                    gameIds.push(games[i].id);
	                }
	            }
	
	            return gameIds;
	        },
	        skillList: function skillList() {
	            return this.$store.state.develteamDataModel.skills;
	        },
	        posts: function posts() {
	            return this.$store.state.classifiedsModel.posts;
	        },
	        matchingSkills: function matchingSkills() {
	            var matchingSkills = [];
	
	            if (this.skillSearchText.length >= 1) {
	                for (var skillId in this.skillList) {
	                    var skill = this.skillList[skillId];
	                    var skillName = skill.category.toLowerCase() + ' ' + skill.skill.toLowerCase();
	
	                    if (skillName.toLowerCase().includes(this.skillSearchText.toLowerCase())) {
	                        matchingSkills.push(skill);
	                    }
	                }
	            }
	
	            matchingSkills = _.sortBy(matchingSkills, function (skill) {
	                return skill.skill;
	            });
	
	            return matchingSkills;
	        }
	    },
	
	    methods: {
	        getSkill: function getSkill(skillId) {
	            return this.skillList[skillId] ? this.skillList[skillId].skill : '';
	        },
	        setSkillId: function setSkillId(skillId) {
	            if (this.isFetching) {
	                return;
	            }
	
	            this.skillFilterId = skillId;
	            this.skillSearchText = '';
	            this.fetchNewResults();
	        },
	        setRoleId: function setRoleId(roleId) {
	            if (this.isFetching) {
	                return;
	            }
	
	            this.selectedRoleId = roleId;
	            this.fetchNewResults();
	        },
	        setPostTypeId: function setPostTypeId(postTypeId) {
	            if (this.isFetching) {
	                return;
	            }
	
	            this.selectedPostTypeId = postTypeId;
	            this.fetchNewResults();
	        },
	        fetchNewResults: function fetchNewResults() {
	            var self = this;
	            this.isFetching = true;
	
	            this.$store.dispatch('classifiedsPage/getClassifieds', {
	                postType: this.postTypes[this.selectedPostTypeId].toLowerCase(),
	                role: this.roles[this.selectedRoleId].toLowerCase(),
	                skillId: this.skillFilterId,
	
	                callback: function callback(responseData) {
	                    self.isFetching = false;
	                }
	            });
	        },
	        canEdit: function canEdit(post) {
	            var isDevEditable = post.posterType === 'developer' && post.posterDetails.id === this.loggedUserId;
	            var isGameEditable = post.posterType === 'game' && this.GameIdsOwned.includes(post.posterDetails.id);
	            return isDevEditable || isGameEditable;
	        },
	        sendMail: function sendMail(post) {
	            var query = {
	                toId: post.posterType === 'developer' ? post.posterDetails.id : post.posterDetails.ownerId,
	                toAlias: post.posterType === 'developer' ? post.posterDetails.alias : post.posterDetails.ownerAlias
	            };
	
	            this.$router.push({
	                path: '/Inbox/Compose',
	                query: query
	            });
	        },
	        openConversation: function openConversation(post) {
	            _vueGlobalEventBus2.default.$emit('privateChatOpenConversation', {
	                id: post.posterType === 'developer' ? post.posterDetails.id : post.posterDetails.ownerId,
	                alias: post.posterType === 'developer' ? post.posterDetails.alias : post.posterDetails.ownerAlias
	            });
	        }
	    },
	
	    mounted: function mounted() {
	        this.fetchNewResults();
	        this.$store.dispatch('loggedUserModel/CatchUpOnClassifieds');
	    }
	};

/***/ }),
/* 223 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: "ClassifiedsEdit",
	
	    data: function data() {
	        return {
	            isSaving: false,
	            isFetching: true,
	            postTitle: '',
	            postContent: '',
	            selectedGameId: 0,
	            fetchErrors: [],
	            saveErrors: []
	        };
	    },
	
	
	    computed: {
	        isLoggedIn: function isLoggedIn() {
	            return this.$store.state.loggedUserModel.isLoggedIn;
	        }
	    },
	
	    methods: {
	        cancelPost: function cancelPost() {
	            this.$router.push('/Classifieds');
	        },
	        submitPost: function submitPost() {
	            var self = this;
	
	            self.isSaving = true;
	
	            this.$store.dispatch('classifiedsPage/submitEditedClassifiedsPost', {
	                postId: this.$route.params.id,
	                postTitle: self.postTitle,
	                postContent: self.postContent,
	
	                callback: function callback(responseData) {
	                    if (responseData.errors) {
	                        self.saveErrors = responseData.errors;
	                        self.isSaving = false;
	                    } else {
	                        self.$router.push('/Classifieds');
	                    }
	                }
	            });
	        },
	        deletePost: function deletePost() {
	            var self = this;
	
	            self.isSaving = true;
	
	            this.$store.dispatch('classifiedsPage/deleteClassifiedsPost', {
	                postId: this.$route.params.id,
	                postTitle: self.postTitle,
	                postContent: self.postContent,
	
	                callback: function callback(responseData) {
	                    if (responseData.errors) {
	                        self.saveErrors = responseData.errors;
	                        self.isSaving = false;
	                    } else {
	                        self.$router.push('/Classifieds');
	                    }
	                }
	            });
	        }
	    },
	
	    mounted: function mounted() {
	        var self = this;
	
	        this.$store.dispatch('classifiedsPage/getClassifiedPost', {
	            postId: this.$route.params.id,
	
	            callback: function callback(responseData) {
	                if (responseData.errors) {
	                    self.fetchErrors = responseData.errors;
	                } else {
	                    self.postContent = responseData.post.postContent;
	                    self.postTitle = responseData.post.postTitle;
	                }
	
	                self.isFetching = false;
	            }
	        });
	    }
	};

/***/ }),
/* 224 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: "ClassifiedsNew",
	
	    data: function data() {
	        return {
	            isSaving: false,
	            newPostTitle: '',
	            newPostContent: '',
	            selectedGameId: 0,
	            errors: [],
	            helpShown: false
	        };
	    },
	
	
	    computed: {
	        isLoggedIn: function isLoggedIn() {
	            return this.$store.state.loggedUserModel.isLoggedIn;
	        },
	        ownAlias: function ownAlias() {
	            return this.$store.state.loggedUserModel.info.alias;
	        },
	        GamesOwned: function GamesOwned() {
	            if (this.isLoggedIn) {
	                return _.filter(this.$store.state.loggedUserModel.games, function (game) {
	                    return game.moderatorLevel === 'owner';
	                });
	            }
	        }
	    },
	
	    methods: {
	        showHelpRollout: function showHelpRollout() {
	            this.helpShown = true;
	        },
	        hideHelpRollout: function hideHelpRollout() {
	            this.helpShown = false;
	        },
	        submitPost: function submitPost() {
	            var self = this;
	
	            self.isSaving = true;
	
	            this.$store.dispatch('classifiedsPage/submitNewClassifiedsPost', {
	                selectedGameId: self.selectedGameId,
	                postTitle: self.newPostTitle,
	                postContent: self.newPostContent,
	
	                callback: function callback(responseData) {
	                    if (responseData.errors) {
	                        self.errors = responseData.errors;
	                        self.isSaving = false;
	                    } else {
	                        self.$router.push('/Classifieds');
	                    }
	                }
	            });
	        }
	    },
	
	    mounted: function mounted() {}
	};

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'CreateNewGameProject',
	    metaInfo: {
	        title: 'Develteam | Game Developer Community | Game dev team up'
	    },
	
	    data: function data() {
	        return {
	            isSaving: false,
	            projectTitle: '',
	            rating: 'everyone',
	            formErrors: [],
	            platforms: {},
	            genres: []
	        };
	    },
	
	
	    components: {},
	
	    mounted: function mounted() {
	        this.platforms = _lodash2.default.cloneDeep(this.$store.state.develteamDataModel.platforms);
	        this.genres = _lodash2.default.cloneDeep(this.$store.state.develteamDataModel.genres);
	    },
	
	
	    computed: {},
	
	    methods: {
	        generateCheckedGenres: function generateCheckedGenres() {
	            var checkedGenres = _lodash2.default.filter(this.genres, function (genre) {
	                return genre.checked;
	            });
	
	            return _lodash2.default.map(checkedGenres, 'id');
	        },
	        generateCheckedPlatforms: function generateCheckedPlatforms() {
	            var checkedPlatforms = [];
	
	            _lodash2.default.each(this.platforms, function (platformCategory) {
	                checkedPlatforms = _lodash2.default.concat(checkedPlatforms, _lodash2.default.filter(platformCategory.platforms, function (platform) {
	                    return platform.checked;
	                }));
	            });
	
	            return _lodash2.default.map(checkedPlatforms, 'id');
	        },
	        showHidden: function showHidden(category) {
	            this.$set(category, 'showHidden', true);
	        },
	        hideHidden: function hideHidden(category) {
	            this.$set(category, 'showHidden', false);
	        },
	        createProject: function createProject() {
	            var checkedGenres = this.generateCheckedGenres();
	            var checkedPlatforms = this.generateCheckedPlatforms();
	
	            this.projectTitle = this.projectTitle.trim();
	
	            if (this.projectTitle === '') {
	                this.formErrors.push('Enter a Project Title');
	            }
	
	            if (checkedPlatforms.length === 0) {
	                this.formErrors.push('Select at least one Platform');
	            }
	
	            if (checkedGenres.length === 0) {
	                this.formErrors.push('Select at least one Genre');
	            }
	
	            if (this.formErrors.length > 0) {
	                return;
	            }
	
	            this.isSaving = true;
	
	            setTimeout(function () {
	                var _this = this;
	
	                _axios2.default.post('/api/game', {
	                    alias: this.projectTitle,
	                    rating: this.rating,
	                    platforms: checkedPlatforms,
	                    genres: checkedGenres
	                }).then(function (response) {
	                    _this.isSaving = false;
	
	                    if (response.data.errors) {
	                        _this.formErrors = response.data.errors;
	                        return;
	                    }
	
	                    _this.$store.dispatch('loggedUserModel/getLoggedUserInfo');
	
	                    _this.$router.push('/Game/' + response.data.stringUrl);
	                }, function (response) {
	                    _this.isSaving = false;
	                    _this.formErrors = ['Something went wrong connecting to the server. Please wait a few minutes and try again'];
	                });
	            }.bind(this), 2000);
	        }
	    },
	
	    watch: {
	        '$store.state.develteamDataModel.genres': function $storeStateDevelteamDataModelGenres() {
	            this.genres = _lodash2.default.cloneDeep(this.$store.state.develteamDataModel.genres);
	        },
	        '$store.state.develteamDataModel.platforms': function $storeStateDevelteamDataModelPlatforms() {
	            this.platforms = _lodash2.default.cloneDeep(this.$store.state.develteamDataModel.platforms);
	        }
	    }
	};

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _vueGlobalEventBus = __webpack_require__(10);
	
	var _vueGlobalEventBus2 = _interopRequireDefault(_vueGlobalEventBus);
	
	var _EditAccountInfo = __webpack_require__(763);
	
	var _EditAccountInfo2 = _interopRequireDefault(_EditAccountInfo);
	
	var _EditDeveloperBasicDetails = __webpack_require__(764);
	
	var _EditDeveloperBasicDetails2 = _interopRequireDefault(_EditDeveloperBasicDetails);
	
	var _EditDeveloperRolesAndSkills = __webpack_require__(767);
	
	var _EditDeveloperRolesAndSkills2 = _interopRequireDefault(_EditDeveloperRolesAndSkills);
	
	var _EditDeveloperNetworking = __webpack_require__(766);
	
	var _EditDeveloperNetworking2 = _interopRequireDefault(_EditDeveloperNetworking);
	
	var _EditDeveloperWebsites = __webpack_require__(768);
	
	var _EditDeveloperWebsites2 = _interopRequireDefault(_EditDeveloperWebsites);
	
	var _EditDeveloperWorkHistory = __webpack_require__(769);
	
	var _EditDeveloperWorkHistory2 = _interopRequireDefault(_EditDeveloperWorkHistory);
	
	var _EditDeveloperEducationHistory = __webpack_require__(765);
	
	var _EditDeveloperEducationHistory2 = _interopRequireDefault(_EditDeveloperEducationHistory);
	
	var _BanDeveloper = __webpack_require__(762);
	
	var _BanDeveloper2 = _interopRequireDefault(_BanDeveloper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'DeveloperCompanionContent',
	    data: function data() {
	        return {
	            savingFollowingChange: false,
	            displayMode: 'normal',
	            websiteListMode: 'display',
	            roleSkillListMode: 'display',
	            workHistoryMode: 'display',
	            educationMode: 'display'
	        };
	    },
	
	
	    components: {
	        'edit-account-info': _EditAccountInfo2.default,
	        'edit-basic-details': _EditDeveloperBasicDetails2.default,
	        'edit-roles-and-skills': _EditDeveloperRolesAndSkills2.default,
	        'edit-networking': _EditDeveloperNetworking2.default,
	        'edit-websites': _EditDeveloperWebsites2.default,
	        'edit-work-history': _EditDeveloperWorkHistory2.default,
	        'edit-education-history': _EditDeveloperEducationHistory2.default,
	        'ban-developer': _BanDeveloper2.default
	    },
	
	    computed: {
	        skillList: function skillList() {
	            return this.$store.state.develteamDataModel.skills;
	        },
	        developer: function developer() {
	            return this.$store.state.developerPageModel.developerInformation;
	        },
	        showBasicInfo: function showBasicInfo() {
	            return this.developerFullName !== '';
	        },
	        developerFullName: function developerFullName() {
	            return [this.developer.firstName, this.developer.lastName].join(' ');
	        },
	        developerAge: function developerAge() {
	            var birthday = new Date(),
	                ageDate = void 0;
	
	            if (!this.developer.useBirth) {
	                return;
	            }
	
	            birthday.setYear(this.developer.birthYear);
	            birthday.setMonth(this.developer.birthMonth - 1);
	            birthday.setDate(this.developer.birthDay);
	
	            ageDate = new Date(Date.now() - birthday.getTime());
	            return Math.abs(ageDate.getUTCFullYear() - 1970);
	        },
	        developerBasicDetails: function developerBasicDetails() {
	            function capitalizeFirstLetter(string) {
	                return string.charAt(0).toUpperCase() + string.slice(1);
	            }
	
	            var details = [];
	            if (this.developer.useBirth) {
	                details.push(this.developerAge);
	            }
	
	            if (['male', 'female', 'nonbinary'].indexOf(this.developer.gender) > -1) {
	                details.push(capitalizeFirstLetter(this.developer.gender));
	            }
	
	            return details.join(' / ');
	        },
	        showRoleTags: function showRoleTags() {
	            return this.isSelf || this.developer.isProducer || this.developer.isDesigner || this.developer.isArtist || this.developer.isProgrammer || this.developer.isWriter || this.developer.isMusician || this.developer.isSfxArtist || this.developer.isTester;
	        },
	        showSkillTags: function showSkillTags() {
	            return this.isSelf || this.developer.skills.length > 0;
	        },
	        showContactOptions: function showContactOptions() {
	            return this.$store.state.loggedUserModel.isLoggedIn && this.$store.state.loggedUserModel.info.id !== this.developer.id;
	        },
	        showWebsites: function showWebsites() {
	            var developer = this.developer;
	
	            if (!developer) {
	                return false;
	            }
	
	            return this.isSelf || (0, _keys2.default)(developer.personalWebsites).length > 0;
	        },
	        showGames: function showGames() {
	            return this.developer.games.length > 0;
	        },
	        showFollowOption: function showFollowOption() {
	            return this.$store.state.developerPageModel.retrievedConnections;
	        },
	        isFollowing: function isFollowing() {
	            var connections = this.$store.state.developerPageModel.developerConnections,
	                foundSelf = false;
	
	            if (!this.$store.state.loggedUserModel.isLoggedIn) {
	                return false;
	            }
	
	            if (connections && connections.followers) {
	                connections.followers.forEach(function (follower) {
	                    if (follower.id === this.$store.state.loggedUserModel.info.id) {
	                        foundSelf = true;
	                    }
	                }.bind(this));
	            }
	
	            return foundSelf;
	        },
	        showInviteOption: function showInviteOption() {
	            var gamesOwnerOf = _lodash2.default.filter(this.$store.state.loggedUserModel.games, function (game) {
	                return game.moderatorLevel === 'owner';
	            });
	
	            return gamesOwnerOf && gamesOwnerOf.length > 0;
	        },
	        isSelf: function isSelf() {
	            return this.$store.state.loggedUserModel.isLoggedIn && this.developer && this.developer.id === this.$store.state.loggedUserModel.info.id;
	        },
	        canBan: function canBan() {
	            return this.$store.state.loggedUserModel.isLoggedIn && this.developer && !this.isSelf && this.$store.state.loggedUserModel.info.siteModCanBan;
	        },
	        developerIsOnline: function developerIsOnline() {
	            var onlineUsers = this.$store.state.onlineUsersModel.onlineUsers;
	            var developerIsOnline = false;
	            var developerId = this.developer.id;
	
	            onlineUsers.forEach(function (onlineUser) {
	                if (onlineUser.id === developerId) {
	                    developerIsOnline = true;
	                }
	            });
	
	            return developerIsOnline;
	        }
	    },
	
	    methods: {
	        getSkill: function getSkill(skillId) {
	            return this.skillList[skillId] ? this.skillList[skillId].skill : '';
	        },
	        sendMail: function sendMail() {
	            this.$router.push({
	                path: '/Inbox/Compose',
	                query: { toId: this.developer.id, toAlias: this.developer.alias }
	            });
	        },
	        sendInvite: function sendInvite() {
	            this.$router.push({ path: '/InviteToGame/' + this.developer.stringUrl });
	        },
	        openConversation: function openConversation() {
	            _vueGlobalEventBus2.default.$emit('privateChatOpenConversation', this.developer);
	        },
	        updateFollowStatus: function updateFollowStatus() {
	            if (this.savingFollowingChange) {
	                return;
	            }
	
	            this.savingFollowingChange = true;
	            this.$store.dispatch('developerPage/updateFollowStatus');
	        },
	        updateUploadedAvatarName: function updateUploadedAvatarName(e) {
	            var input = e.target,
	                reader = void 0,
	                self = this;
	
	            if (input.files.length === 0) {
	                return;
	            }
	
	            if (input.files && input.files[0]) {
	                reader = new FileReader();
	
	                reader.onload = function (e) {
	                    self.uploadedImageSrc = e.target.result;
	                };
	
	                reader.readAsDataURL(input.files[0]);
	            }
	
	            var avatarTooBig = e.target.files[0].size > 10 * 1024 * 1024;
	            this.formErrors = false;
	
	            if (avatarTooBig) {
	                alert("Maximum filesize for an Avatar is 10MB");
	            } else {
	                this.$store.dispatch('developerPage/SaveAvatar', e.target.files[0]);
	            }
	        },
	        toggleEditWebsites: function toggleEditWebsites() {
	            this.websiteListMode = this.websiteListMode === 'display' ? 'edit' : 'display';
	        },
	        toggleEditRolesSkills: function toggleEditRolesSkills() {
	            this.roleSkillListMode = this.roleSkillListMode === 'display' ? 'edit' : 'display';
	        },
	        toggleEditWorkHistory: function toggleEditWorkHistory() {
	            this.workHistoryMode = this.workHistoryMode === 'display' ? 'edit' : 'display';
	        },
	        toggleEditEducation: function toggleEditEducation() {
	            this.educationMode = this.educationMode === 'display' ? 'edit' : 'display';
	        },
	        getLinkIcon: function getLinkIcon(url) {
	            if (url.includes("facebook")) {
	                return 'fab fa-facebook-f';
	            }
	
	            if (url.includes("twitter")) {
	                return 'fab fa-twitter';
	            }
	
	            if (url.includes("discord")) {
	                return 'fab fa-discord';
	            }
	
	            if (url.includes("linkedin")) {
	                return 'fab fa-linkedin';
	            }
	
	            if (url.includes("instagram")) {
	                return 'fab fa-instagram';
	            }
	
	            return 'fas fa-link';
	        }
	    },
	
	    mounted: function mounted() {},
	
	
	    watch: {
	        'isFollowing': function isFollowing() {
	            this.savingFollowingChange = false;
	        }
	    }
	};

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _DeveloperDetails = __webpack_require__(756);
	
	var _DeveloperDetails2 = _interopRequireDefault(_DeveloperDetails);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'Developer',
	
	    metaInfo: function metaInfo() {
	        return {
	            title: this.title
	        };
	    },
	
	
	    components: {
	        'dev-details': _DeveloperDetails2.default
	    },
	
	    data: function data() {
	        return {};
	    },
	    mounted: function mounted() {
	        this.$store.dispatch('developerPage/getDeveloperInformation', this.$route.params.developer);
	    },
	
	
	    computed: {
	        title: function title() {
	            var pageData = this.$store.state.developerPageModel.developerInformation;
	
	            if (pageData && pageData.alias) {
	                return 'Develteam ' + pageData.alias + ' | Game developer community | Game dev team up';
	            }
	
	            return 'Develteam | Game Developer Community | Game dev team up';
	        },
	        selectedSubpage: function selectedSubpage() {
	            var subpage = this.$route.path.substring(1).split('/')[2];
	            return subpage || 'RecentActivity';
	        },
	        developerDoesntExist: function developerDoesntExist() {
	            return this.$store.state.developerPageModel.fetchError !== '';
	        }
	    },
	
	    watch: {
	        '$route': function $route() {
	            var model = this.$store.state.developerPageModel;
	            var currentDeveloper = this.$route.params.developer;
	            var differentDeveloper = false;
	
	            if (model.retrievedInformation && model.retrievedConnections) {
	                if (currentDeveloper && currentDeveloper.toLowerCase() !== model.developerInformation.stringUrl.toLowerCase()) {
	                    differentDeveloper = true;
	                }
	            }
	
	            if (!model.retrievedInformation || !model.retrievedConnections || differentDeveloper) {
	                this.$store.dispatch('developerPage/getDeveloperInformation', currentDeveloper);
	            }
	        }
	    },
	
	    methods: {}
	};

/***/ }),
/* 228 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: 'DeveloperConnections',
	    data: function data() {
	        return {
	            selectedFollowingCategory: 'developers'
	        };
	    },
	
	
	    components: {},
	
	    mounted: function mounted() {},
	
	
	    computed: {
	        hasData: function hasData() {
	            var model = this.$store.state.developerPageModel;
	            return model.retrievedInformation && model.retrievedConnections;
	        },
	        profileConnections: function profileConnections() {
	            return this.$store.state.developerPageModel.developerConnections;
	        },
	        profileAlias: function profileAlias() {
	            var profileInformation = this.$store.state.developerPageModel.developerInformation;
	            return profileInformation.alias ? profileInformation.alias : undefined;
	        }
	    },
	
	    methods: {
	        switchSelectedFollowingCategory: function switchSelectedFollowingCategory(newCategory) {
	            this.selectedFollowingCategory = newCategory;
	        }
	    }
	};

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'DeveloperFeed',
	    data: function data() {
	        return {
	            showNewPostForm: false,
	            postCountToFetch: 10,
	            newPostSubject: '',
	            newPostContent: ''
	        };
	    },
	    mounted: function mounted() {
	        if (this.developerId && (this.fetchingStatus !== 'fetched' || (0, _keys2.default)(this.feedPosts).length < this.postCountToFetch)) {
	            this.getPosts();
	        }
	    },
	
	
	    computed: {
	        isLoggedIn: function isLoggedIn() {
	            return this.$store.state.loggedUserModel.isLoggedIn;
	        },
	        layout: function layout() {
	            return 'single';
	            if (!this.isLoggedIn) {
	                return 'masonry';
	            }
	
	            return this.$store.state.loggedUserModel.options.feedLayoutStyle;
	        },
	        isOwner: function isOwner() {
	            return this.$store.state.loggedUserModel.isLoggedIn && this.$store.state.loggedUserModel.info.id === this.developerId;
	        },
	        feedPostsId: function feedPostsId() {
	            return 'developer.' + this.developerId;
	        },
	        developerId: function developerId() {
	            var pageData = this.$store.state.developerPageModel.developerInformation;
	
	            if (pageData && pageData.id) {
	                return pageData.id;
	            }
	        },
	        feedPosts: function feedPosts() {
	            var developerFeedData = this.$store.state.feedPostsModel.feedPosts[this.feedPostsId];
	
	            if (!developerFeedData) {
	                return {};
	            }
	
	            var allPosts = [];
	            var normalPosts = [];
	            var pinnedPosts = [];
	
	            (0, _keys2.default)(developerFeedData.posts).forEach(function (key) {
	                if (developerFeedData.posts[key].isPinned) {
	                    pinnedPosts.push(developerFeedData.posts[key]);
	                } else {
	                    normalPosts.push(developerFeedData.posts[key]);
	                }
	            });
	
	            normalPosts.sort(function (a, b) {
	                return new Date(a.postDate) > new Date(b.postDate) ? -1 : 1;
	            });
	            pinnedPosts.sort(function (a, b) {
	                return new Date(a.postDate) > new Date(b.postDate) ? -1 : 1;
	            });
	
	            pinnedPosts.forEach(function (post) {
	                allPosts.push(post);
	            });
	
	            normalPosts.forEach(function (post) {
	                allPosts.push(post);
	            });
	
	            return allPosts;
	        },
	        fetchingStatus: function fetchingStatus() {
	            var developerFeedData = this.$store.state.feedPostsModel.feedPosts[this.feedPostsId];
	            return developerFeedData ? developerFeedData.fetchingStatus : 'fetching';
	        },
	        hasFetchedAll: function hasFetchedAll() {
	            var developerFeedData = this.$store.state.feedPostsModel.feedPosts[this.feedPostsId];
	            return developerFeedData ? developerFeedData.hasFetchedAll : true;
	        }
	    },
	
	    methods: {
	        getPosts: function getPosts() {
	            this.$store.dispatch('feedPosts/getFeedPosts', {
	                feedPostsId: this.feedPostsId,
	                feedType: 'developer',
	                feedId: this.developerId,
	                limit: this.postCountToFetch
	            });
	        },
	        submitNewPost: function submitNewPost() {
	            if (this.newPostContent.trim() !== '') {
	                this.$store.dispatch('feedPosts/postNewPost', {
	                    subject: this.newPostSubject,
	                    content: this.newPostContent,
	                    parentType: 'developer',
	                    parentId: this.developerId
	                });
	
	                this.newPostContent = '';
	                this.newPostSubject = '';
	                this.showNewPostForm = false;
	            }
	        },
	        fetchMore: function fetchMore() {
	            this.$store.dispatch('feedPosts/getFeedPosts', {
	                feedPostsId: this.feedPostsId,
	                feedType: 'developer',
	                feedId: this.developerId
	            });
	        },
	        changeLayout: function changeLayout(style) {
	            if (!this.isLoggedIn) {
	                return;
	            }
	
	            this.$set(this.$store.state.loggedUserModel.options, 'feedLayoutStyle', style);
	
	            _axios2.default.post('/api/userOptions/updateFeedLayoutStyle', {
	                style: style
	            });
	        }
	    },
	
	    watch: {
	        '$store.state.developerPageModel.developerInformation': function $storeStateDeveloperPageModelDeveloperInformation() {
	            this.getPosts();
	        }
	    }
	};

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _FormNewMediaAlbum = __webpack_require__(144);
	
	var _FormNewMediaAlbum2 = _interopRequireDefault(_FormNewMediaAlbum);
	
	var _FormReorderMediaAlbums = __webpack_require__(145);
	
	var _FormReorderMediaAlbums2 = _interopRequireDefault(_FormReorderMediaAlbums);
	
	var _MediaPieceList = __webpack_require__(146);
	
	var _MediaPieceList2 = _interopRequireDefault(_MediaPieceList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'DeveloperPortfolio',
	
	    data: function data() {
	        return {
	            imageLoader: undefined,
	            selectedAlbum: undefined,
	            addAlbumMode: false,
	            editAlbumMode: false,
	            reorderAlbumMode: false
	        };
	    },
	
	
	    components: {
	        'new-album-form': _FormNewMediaAlbum2.default,
	        'reorder-album-form': _FormReorderMediaAlbums2.default,
	        'media-piece-list': _MediaPieceList2.default
	    },
	
	    mounted: function mounted() {
	        if (this.developerId && this.fetchingAlbumStatus !== 'fetched') {
	            this.getAlbums();
	        }
	    },
	
	
	    computed: {
	        canEdit: function canEdit() {
	            return this.$store.state.loggedUserModel.isLoggedIn && this.$store.state.loggedUserModel.info.id === this.developerId;
	        },
	        developerId: function developerId() {
	            var pageData = this.$store.state.developerPageModel.developerInformation;
	
	            if (pageData && pageData.id) {
	                return pageData.id;
	            }
	        },
	        mediasId: function mediasId() {
	            return 'developer.' + this.developerId;
	        },
	        fetchingAlbumStatus: function fetchingAlbumStatus() {
	            var developerPortfolioData = this.$store.state.mediasModel.medias[this.mediasId];
	            return developerPortfolioData ? developerPortfolioData.fetchingStatus : 'fetching';
	        },
	        albums: function albums() {
	            var developerPortfolioData = this.$store.state.mediasModel.medias[this.mediasId];
	
	            var albums = [];
	            if (developerPortfolioData) {
	                (0, _keys2.default)(developerPortfolioData.albums).forEach(function (key) {
	                    albums.push(developerPortfolioData.albums[key]);
	                });
	            }
	
	            albums.sort(function (a, b) {
	                return a.rank > b.rank ? 1 : -1;
	            });
	
	            return albums;
	        }
	    },
	
	    methods: {
	        getAlbums: function getAlbums() {
	            this.$store.dispatch('medias/getAlbums', {
	                mediasId: this.mediasId
	            });
	        },
	        enterAddAlbumMode: function enterAddAlbumMode() {
	            this.addAlbumMode = true;
	            this.$router.push('/Developer/' + this.$route.params.developer + '/Portfolio/');
	        },
	        exitAddAlbumMode: function exitAddAlbumMode() {
	            this.addAlbumMode = false;
	        },
	        exitSinglePieceView: function exitSinglePieceView() {
	            this.$router.push('/Developer/' + this.$route.params.developer + '/Portfolio/');
	        },
	        enterReorderAlbumMode: function enterReorderAlbumMode() {
	            this.reorderAlbumMode = true;
	            this.$router.push('/Developer/' + this.$route.params.developer + '/Portfolio/');
	        },
	        exitReorderAlbumMode: function exitReorderAlbumMode() {
	            this.reorderAlbumMode = false;
	        }
	    },
	
	    watch: {
	        '$store.state.developerPageModel.developerInformation': function $storeStateDeveloperPageModelDeveloperInformation() {
	            this.getAlbums();
	        },
	        '$route.params.album': function $routeParamsAlbum() {
	            if (this.$route.params.album) {
	                this.exitAddAlbumMode();
	            }
	        }
	    },
	
	    sockets: {
	        'mediaAlbumAddOrEdit': function mediaAlbumAddOrEdit(data) {
	            this.exitAddAlbumMode();
	        },
	        'mediaAlbumReorder': function mediaAlbumReorder(data) {
	            this.getAlbums();
	            this.exitReorderAlbumMode();
	        }
	    }
	};

/***/ }),
/* 231 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: 'DeveloperSinglePostView',
	
	    components: {},
	
	    mounted: function mounted() {
	        if (!this.postData && this.developerId) {
	            this.getPost();
	        }
	    },
	
	
	    computed: {
	        postId: function postId() {
	            return this.$route.params.id;
	        },
	        feedPostsId: function feedPostsId() {
	            return 'developer.' + this.developerId;
	        },
	        developerId: function developerId() {
	            var pageData = this.$store.state.developerPageModel.developerInformation;
	
	            if (pageData && pageData.id) {
	                return pageData.id;
	            }
	        },
	        postData: function postData() {
	            var feedData = this.$store.state.feedPostsModel.feedPosts[this.feedPostsId];
	
	            if (feedData) {
	                return feedData.posts[this.postId];
	            }
	        },
	        fetchingStatus: function fetchingStatus() {
	            var developerFeedData = this.$store.state.feedPostsModel.feedPosts[this.feedPostsId];
	            return developerFeedData ? developerFeedData.fetchingStatus : 'fetching';
	        }
	    },
	
	    methods: {
	        getPost: function getPost() {
	            this.$store.dispatch('feedPosts/getSingleFeedPost', {
	                feedPostsId: this.feedPostsId,
	                feedType: 'developer',
	                feedId: this.developerId,
	                postId: this.postId
	            });
	        }
	    },
	
	    watch: {
	        'developerId': function developerId() {
	            if (!this.postData) {
	                this.getPost();
	            }
	        },
	        'postId': function postId() {
	            if (!this.postData) {
	                this.getPost();
	            }
	        }
	    }
	};

/***/ }),
/* 232 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: 'BanDeveloper',
	
	    data: function data() {
	        return {
	            formData: _.clone(this.$store.state.developerPageModel.developerInformation)
	        };
	    },
	
	
	    methods: {
	        cancelChanges: function cancelChanges() {
	            this.$emit('doneEditing');
	        },
	        submitBan: function submitBan() {
	            this.$store.dispatch('developerPage/banDeveloper', {
	                developerId: this.formData.id
	            });
	        },
	        submitUnBan: function submitUnBan() {
	            this.$store.dispatch('developerPage/unBanDeveloper', {
	                developerId: this.formData.id
	            });
	        }
	    },
	
	    sockets: {
	        'developerInformationUpdated': function developerInformationUpdated(data) {
	            if (data.id === this.formData.id) {
	                this.$emit('doneEditing');
	            }
	        }
	    }
	};

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _validator = __webpack_require__(19);
	
	var _validator2 = _interopRequireDefault(_validator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'EditDeveloperBasicDetails',
	
	    data: function data() {
	        return {
	            formData: {
	                alias: this.$store.state.loggedUserModel.info.alias,
	                email: this.$store.state.loggedUserModel.info.email,
	                password: '',
	                passwordAgain: '',
	                delete: '',
	                receiveEmailNotifications: this.$store.state.loggedUserModel.info.receiveEmailNotifications,
	                receivePromoEmails: this.$store.state.loggedUserModel.info.receivePromoEmails
	            },
	            passwordsShown: false,
	            isSaving: false,
	            responseErrors: []
	        };
	    },
	
	
	    computed: {
	        showEmailError: function showEmailError() {
	            return !_validator2.default.isEmail(this.formData.email);
	        }
	    },
	
	    methods: {
	        cancelChanges: function cancelChanges() {
	            this.$emit('doneEditing');
	        },
	        submitChanges: function submitChanges() {
	            var _this = this;
	
	            this.isSaving = true;
	
	            this.$store.dispatch('loggedUserModel/updateLoggedUserInfo', {
	                data: this.formData,
	                callback: function callback(response) {
	                    _this.isSaving = false;
	                    if (response.errors && Array.isArray(response.errors) && response.errors.length > 0) {
	                        _this.responseErrors = response.errors;
	                    } else {
	                        location.reload();
	                    }
	                }
	            });
	        }
	    }
	};

/***/ }),
/* 234 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: 'EditDeveloperBasicDetails',
	
	    data: function data() {
	        return {
	            formData: _.clone(this.$store.state.developerPageModel.developerInformation),
	            userLocation: {
	                searchPlace: '',
	                location: {}
	            }
	        };
	    },
	
	
	    computed: {
	        birthYears: function birthYears() {
	            var years = [];
	            for (var i = new Date().getFullYear(); i >= 1900; i--) {
	                years.push(i);
	            }
	
	            return years;
	        }
	    },
	
	    methods: {
	        cancelChanges: function cancelChanges() {
	            this.$emit('doneEditing');
	        },
	        submitChanges: function submitChanges() {
	            this.$store.dispatch('developerPage/updateBasicInfo', {
	                developerId: this.formData.id,
	                firstName: this.formData.firstName,
	                lastName: this.formData.lastName,
	                gender: this.formData.gender,
	                location: this.formData.location,
	                locationLat: this.formData.locationLat,
	                locationLon: this.formData.locationLon,
	                useBirth: this.formData.useBirth,
	                birthMonth: this.formData.birthMonth,
	                birthDay: this.formData.birthDay,
	                birthYear: this.formData.birthYear
	            });
	        }
	    },
	
	    watch: {
	        '$store.state.developerPageModel.developerInformation': function $storeStateDeveloperPageModelDeveloperInformation() {
	            this.formData = _.clone(this.$store.state.developerPageModel.developerInformation);
	        },
	        'userLocation.place.geometry.location.lat': function userLocationPlaceGeometryLocationLat() {
	            this.formData.locationLat = this.userLocation.place.geometry.location.lat();
	        },
	        'userLocation.place.geometry.location.lng': function userLocationPlaceGeometryLocationLng() {
	            this.formData.locationLon = this.userLocation.place.geometry.location.lng();
	        },
	
	
	        'userLocation': {
	            handler: function handler(val, oldVal) {
	                if (this.formData.location) {
	                    this.formData.location = this.userLocation.place.formatted_address;
	                }
	            },
	            deep: true
	        }
	    },
	
	    sockets: {
	        'developerInformationUpdated': function developerInformationUpdated(data) {
	            if (data.id === this.formData.id) {
	                this.$emit('doneEditing');
	            }
	        }
	    }
	};

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vue = __webpack_require__(4);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'EditDeveloperEducationHistory',
	
	    data: function data() {
	        return {
	            formData: _.clone(this.$store.state.developerPageModel.developerInformation)
	        };
	    },
	
	
	    computed: {},
	
	    methods: {
	        cancelChanges: function cancelChanges() {
	            this.$emit('doneEditing');
	        },
	        validateAllEntries: function validateAllEntries() {
	            var isValid = true;
	
	            this.formData.educationHistory.forEach(function (educationItem) {
	                if (educationItem.place.trim() === '') {
	                    isValid = false;
	                }
	            });
	
	            return isValid;
	        },
	        submitChanges: function submitChanges() {
	            if (!this.validateAllEntries()) {
	                return;
	            }
	
	            this.$store.dispatch('developerPage/updateEducationHistory', {
	                developerId: this.formData.id,
	                educationHistory: this.formData.educationHistory
	            });
	        },
	        addEducationHistory: function addEducationHistory() {
	            this.formData.educationHistory.push({
	                place: '',
	                title: '',
	                start: '',
	                end: ''
	            });
	        },
	        removeEducationHistory: function removeEducationHistory(index) {
	            _vue2.default.delete(this.formData.educationHistory, index);
	        },
	        moveEducationUp: function moveEducationUp(index) {
	            var swapA = this.formData.educationHistory[index];
	            var swapB = this.formData.educationHistory[index - 1];
	            _vue2.default.set(this.formData.educationHistory, index, swapB);
	            _vue2.default.set(this.formData.educationHistory, index - 1, swapA);
	        },
	        moveEducationDown: function moveEducationDown(index) {
	            var swapA = this.formData.educationHistory[index];
	            var swapB = this.formData.educationHistory[index + 1];
	            _vue2.default.set(this.formData.educationHistory, index, swapB);
	            _vue2.default.set(this.formData.educationHistory, index + 1, swapA);
	        }
	    },
	
	    watch: {
	        '$store.state.developerPageModel.developerInformation': function $storeStateDeveloperPageModelDeveloperInformation() {
	            this.formData = _.clone(this.$store.state.developerPageModel.developerInformation);
	        }
	    },
	
	    sockets: {
	        'developerInformationUpdated': function developerInformationUpdated(data) {
	            if (data.id === this.formData.id) {
	                this.$emit('doneEditing');
	            }
	        }
	    }
	};

/***/ }),
/* 236 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: 'EditDeveloperNetworking',
	
	    data: function data() {
	        return {
	            formData: _.clone(this.$store.state.developerPageModel.developerInformation)
	        };
	    },
	
	
	    computed: {},
	
	    methods: {
	        cancelChanges: function cancelChanges() {
	            this.$emit('doneEditing');
	        },
	        submitChanges: function submitChanges() {
	            this.$store.dispatch('developerPage/updateNetworking', {
	                developerId: this.formData.id,
	                lookingForGame: this.formData.lookingForGame,
	                lookingForDescription: this.formData.lookingForDescription
	            });
	        }
	    },
	
	    watch: {
	        '$store.state.developerPageModel.developerInformation': function $storeStateDeveloperPageModelDeveloperInformation() {
	            this.formData = _.clone(this.$store.state.developerPageModel.developerInformation);
	        }
	    },
	
	    sockets: {
	        'developerInformationUpdated': function developerInformationUpdated(data) {
	            if (data.id === this.formData.id) {
	                this.$emit('doneEditing');
	            }
	        }
	    }
	};

/***/ }),
/* 237 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: 'EditDeveloperRolesAndSkills',
	
	    data: function data() {
	        return {
	            formData: _.clone(this.$store.state.developerPageModel.developerInformation),
	            enteredSkill: ''
	        };
	    },
	
	
	    computed: {
	        skillList: function skillList() {
	            return this.$store.state.develteamDataModel.skills;
	        },
	        matchingSkills: function matchingSkills() {
	            var matchingSkills = [];
	
	            if (this.enteredSkill.length >= 1) {
	                for (var skillId in this.skillList) {
	                    var skill = this.skillList[skillId];
	                    var skillName = skill.category.toLowerCase() + ' ' + skill.skill.toLowerCase();
	
	                    if (skillName.toLowerCase().includes(this.enteredSkill.toLowerCase())) {
	                        if (!this.formData.skills.includes(skill.id)) {
	                            matchingSkills.push(skill);
	                        }
	                    }
	                }
	            }
	
	            matchingSkills = _.sortBy(matchingSkills, function (skill) {
	                return skill.skill;
	            });
	
	            return matchingSkills;
	        }
	    },
	
	    methods: {
	        addSkill: function addSkill(skillId) {
	            this.formData.skills.push(skillId);
	        },
	        removeSkill: function removeSkill(skillId) {
	            this.formData.skills = _.remove(this.formData.skills, function (id) {
	                return id !== skillId;
	            });
	        },
	        cancelChanges: function cancelChanges() {
	            this.$emit('doneEditing');
	        },
	        submitChanges: function submitChanges() {
	            var skillIds = [];
	
	            this.formData.skills.forEach(function (skill) {
	                skillIds.push(skill.id);
	            });
	
	            this.$store.dispatch('developerPage/updateRolesAndSkills', {
	                developerId: this.formData.id,
	                role: this.formData.role,
	                isProducer: this.formData.isProducer,
	                isDesigner: this.formData.isDesigner,
	                isArtist: this.formData.isArtist,
	                isProgrammer: this.formData.isProgrammer,
	                isWriter: this.formData.isWriter,
	                isMusician: this.formData.isMusician,
	                isSfxArtist: this.formData.isSfxArtist,
	                isTester: this.formData.isTester,
	                skills: this.formData.skills
	            });
	        }
	    },
	
	    watch: {
	        '$store.state.developerPageModel.developerInformation': function $storeStateDeveloperPageModelDeveloperInformation() {
	            this.formData = _.clone(this.$store.state.developerPageModel.developerInformation);
	        }
	    },
	
	    sockets: {
	        'developerInformationUpdated': function developerInformationUpdated(data) {
	            if (data.id === this.formData.id) {
	                this.$emit('doneEditing');
	            }
	        }
	    }
	};

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _validator = __webpack_require__(19);
	
	var _validator2 = _interopRequireDefault(_validator);
	
	var _vue = __webpack_require__(4);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'EditDeveloperWebsites',
	
	    data: function data() {
	        return {
	            formData: _.clone(this.$store.state.developerPageModel.developerInformation),
	            newWebsiteName: '',
	            newWebsiteUrl: ''
	        };
	    },
	
	
	    computed: {},
	
	    methods: {
	        cancelChanges: function cancelChanges() {
	            this.$emit('doneEditing');
	        },
	        submitChanges: function submitChanges() {
	            var _this = this;
	
	            var isValid = this.allEntriesAreValid();
	
	            for (var i = 0; i < this.formData.personalWebsites.length; i++) {
	                if (this.formData.personalWebsites[i].url.slice(0, 4).toLowerCase() !== 'http') {
	                    _vue2.default.set(this.formData.personalWebsites[i], 'url', 'https://' + this.formData.personalWebsites[i].url);
	                }
	            }
	
	            this.formData.personalWebsites.forEach(function (site) {
	                if (site.name.trim() === '' || !_this.isValidUrl(site.url)) {
	                    isValid = false;
	                }
	            });
	
	            if (isValid) {
	                this.$store.dispatch('developerPage/updateWebsites', {
	                    developerId: this.formData.id,
	                    personalWebsites: this.formData.personalWebsites
	                });
	            }
	        },
	        allEntriesAreValid: function allEntriesAreValid() {
	            var _this2 = this;
	
	            var isValid = true;
	
	            this.formData.personalWebsites.forEach(function (site) {
	                if (site.name.trim() === '' || !_this2.isValidUrl(site.url)) {
	                    isValid = false;
	                }
	            });
	
	            return isValid;
	        },
	        addAnotherPersonalWebsite: function addAnotherPersonalWebsite() {
	            this.formData.personalWebsites.push({
	                name: '',
	                url: ''
	            });
	        },
	        removePersonalWebsite: function removePersonalWebsite(entry) {
	            _vue2.default.delete(this.formData.personalWebsites, entry);
	        },
	        moveWebsiteUp: function moveWebsiteUp(entry) {
	            var swapA = this.formData.personalWebsites[entry];
	            var swapB = this.formData.personalWebsites[entry - 1];
	            _vue2.default.set(this.formData.personalWebsites, entry, swapB);
	            _vue2.default.set(this.formData.personalWebsites, entry - 1, swapA);
	        },
	        moveWebsiteDown: function moveWebsiteDown(entry) {
	            var swapA = this.formData.personalWebsites[entry];
	            var swapB = this.formData.personalWebsites[entry + 1];
	            _vue2.default.set(this.formData.personalWebsites, entry, swapB);
	            _vue2.default.set(this.formData.personalWebsites, entry + 1, swapA);
	        },
	        isValidUrl: function isValidUrl(url) {
	            return _validator2.default.isURL(url);
	        }
	    },
	
	    watch: {
	        '$store.state.developerPageModel.developerInformation': function $storeStateDeveloperPageModelDeveloperInformation() {
	            this.formData = _.clone(this.$store.state.developerPageModel.developerInformation);
	        }
	    },
	
	    sockets: {
	        'developerInformationUpdated': function developerInformationUpdated(data) {
	            if (data.id === this.formData.id) {
	                this.$emit('doneEditing');
	            }
	        }
	    }
	};

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vue = __webpack_require__(4);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'EditDeveloperWorkHistory',
	
	    data: function data() {
	        return {
	            formData: _.clone(this.$store.state.developerPageModel.developerInformation)
	        };
	    },
	
	
	    computed: {},
	
	    methods: {
	        cancelChanges: function cancelChanges() {
	            this.$emit('doneEditing');
	        },
	        allEntriesAreValid: function allEntriesAreValid() {
	            var isValid = true;
	            this.formData.workHistory.forEach(function (workHistory) {
	                if (workHistory.place.trim() === '') {
	                    isValid = false;
	                }
	            });
	
	            return isValid;
	        },
	        submitChanges: function submitChanges() {
	            if (this.allEntriesAreValid()) {
	                this.$store.dispatch('developerPage/updateWorkHistory', {
	                    developerId: this.formData.id,
	                    workHistory: this.formData.workHistory
	                });
	            }
	        },
	        addWorkHistory: function addWorkHistory() {
	            this.formData.workHistory.push({
	                place: '',
	                title: '',
	                start: '',
	                end: ''
	            });
	        },
	        removeWorkHistory: function removeWorkHistory(index) {
	            _vue2.default.delete(this.formData.workHistory, index);
	        },
	        moveWorkHistoryUp: function moveWorkHistoryUp(index) {
	            var swapA = this.formData.workHistory[index];
	            var swapB = this.formData.workHistory[index - 1];
	            _vue2.default.set(this.formData.workHistory, index, swapB);
	            _vue2.default.set(this.formData.workHistory, index - 1, swapA);
	        },
	        moveWorkHistoryDown: function moveWorkHistoryDown(index) {
	            var swapA = this.formData.workHistory[index];
	            var swapB = this.formData.workHistory[index + 1];
	            _vue2.default.set(this.formData.workHistory, index, swapB);
	            _vue2.default.set(this.formData.workHistory, index + 1, swapA);
	        }
	    },
	
	    watch: {
	        '$store.state.developerPageModel.developerInformation': function $storeStateDeveloperPageModelDeveloperInformation() {
	            this.formData = _.clone(this.$store.state.developerPageModel.developerInformation);
	        }
	    },
	
	    sockets: {
	        'developerInformationUpdated': function developerInformationUpdated(data) {
	            if (data.id === this.formData.id) {
	                this.$emit('doneEditing');
	            }
	        }
	    }
	};

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _underscore = __webpack_require__(65);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: "DonationsPage",
	
	    data: function data() {
	        return {
	            sortType: 'amount'
	        };
	    },
	
	
	    computed: {
	        donors: function donors() {
	            var donors = this.$store.state.donationsModel.donors;
	
	            return this.sortType === 'amount' ? _underscore2.default.sortBy(donors, function (user) {
	                return user.amount;
	            }).reverse() : _underscore2.default.sortBy(donors, function (user) {
	                return new Date(user.date);
	            }).reverse();
	        }
	    },
	
	    methods: {
	        setSortType: function setSortType(sortType) {
	            this.sortType = sortType;
	        }
	    },
	    mounted: function mounted() {
	        if (this.donors && this.donors.length === 0) {
	            this.$store.dispatch('donationsPage/populateDonors');
	        }
	    }
	};

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vue = __webpack_require__(4);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _ForumsCategoryList = __webpack_require__(139);
	
	var _ForumsCategoryList2 = _interopRequireDefault(_ForumsCategoryList);
	
	var _ForumsForumList = __webpack_require__(140);
	
	var _ForumsForumList2 = _interopRequireDefault(_ForumsForumList);
	
	var _ForumsThreadList = __webpack_require__(142);
	
	var _ForumsThreadList2 = _interopRequireDefault(_ForumsThreadList);
	
	var _ForumsPostList = __webpack_require__(141);
	
	var _ForumsPostList2 = _interopRequireDefault(_ForumsPostList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'SiteForums',
	    metaInfo: {
	        title: 'Develteam Forums | Game developer community | Game dev team up'
	    },
	
	    data: function data() {
	        return {
	            parentType: 'site',
	            parentId: 0
	        };
	    },
	
	
	    components: {
	        'category-list': _ForumsCategoryList2.default,
	        'forum-list': _ForumsForumList2.default,
	        'thread-list': _ForumsThreadList2.default,
	        'post-list': _ForumsPostList2.default
	    },
	
	    mounted: function mounted() {
	        if (!this.board || this.board.fetchingStatus !== 'fetched') {
	            this.$store.dispatch('forums/getCategoriesAndForums', {
	                boardId: this.boardId
	            });
	        }
	
	        this.$store.dispatch('loggedUserModel/CatchUpOnForums');
	    },
	
	
	    computed: {
	        canPost: function canPost() {
	            return this.$store.state.loggedUserModel.isLoggedIn;
	        },
	        isModerator: function isModerator() {
	            return this.$store.state.loggedUserModel.isLoggedIn && this.$store.state.loggedUserModel.info.id <= 2;
	        },
	        isCategorySet: function isCategorySet() {
	            return this.$route.params.category !== undefined;
	        },
	        isForumSet: function isForumSet() {
	            return this.$route.params.forum !== undefined;
	        },
	        isThreadSet: function isThreadSet() {
	            return this.$route.params.thread !== undefined;
	        },
	        board: function board() {
	            return this.$store.state.forumsModel.boards[this.boardId];
	        },
	        boardId: function boardId() {
	            var isSite = this.parentType === 'site';
	
	            if (isSite) {
	                return 'site';
	            }
	
	            return this.parentType + '.' + this.parentId;
	        }
	    },
	
	    methods: {},
	
	    watch: {
	        'boardId': function boardId() {
	            if (!this.board) {
	                this.$store.dispatch('forums/getCategoriesAndForums', {
	                    boardId: this.boardId
	                });
	            }
	        }
	    },
	
	    sockets: {
	        'forumsLockThread': function forumsLockThread(data) {
	            var board = this.$store.state.forumsModel.boards[this.boardId];
	
	            if (board.categories && board.categories[this.$route.params.category] && board.categories[this.$route.params.category].forums && board.categories[this.$route.params.category].forums[this.$route.params.forum] && board.categories[this.$route.params.category].forums[this.$route.params.forum].threads && board.categories[this.$route.params.category].forums[this.$route.params.forum].threads[data.stringUrl]) {
	                _vue2.default.set(board.categories[this.$route.params.category].forums[this.$route.params.forum].threads[data.stringUrl], 'locked', data.isLocked);
	            }
	        },
	        'forumsPinThread': function forumsPinThread(data) {
	            var board = this.$store.state.forumsModel.boards[this.boardId];
	
	            if (board.categories && board.categories[this.$route.params.category] && board.categories[this.$route.params.category].forums && board.categories[this.$route.params.category].forums[this.$route.params.forum] && board.categories[this.$route.params.category].forums[this.$route.params.forum].threads && board.categories[this.$route.params.category].forums[this.$route.params.forum].threads[data.stringUrl]) {
	                _vue2.default.set(board.categories[this.$route.params.category].forums[this.$route.params.forum].threads[data.stringUrl], 'pinned', data.isPinned);
	            }
	        },
	        'forumsDeleteThread': function forumsDeleteThread(data) {
	            var board = this.$store.state.forumsModel.boards[this.boardId];
	
	            if (this.$route.params.thread) {
	                this.$router.push('/Forums/' + this.$route.params.category + '/' + this.$route.params.forum);
	            }
	
	            if (board.categories && board.categories[this.$route.params.category] && board.categories[this.$route.params.category].forums && board.categories[this.$route.params.category].forums[this.$route.params.forum] && board.categories[this.$route.params.category].forums[this.$route.params.forum].threads && board.categories[this.$route.params.category].forums[this.$route.params.forum].threads[data.stringUrl]) {
	                _vue2.default.delete(board.categories[this.$route.params.category].forums[this.$route.params.forum].threads, data.stringUrl);
	            }
	        },
	        'forumsEditCategory': function forumsEditCategory(data) {
	            this.$store.dispatch('forums/getCategoriesAndForums', {
	                boardId: this.boardId
	            });
	
	            if (data.oldStringUrl === this.$route.params.category) {
	                if (this.$route.params.thread) {
	                    this.$router.push('/Forums/' + data.stringUrl + '/' + this.$route.params.forum + '/' + this.$route.params.thread);
	                } else if (this.$route.params.forum) {
	                    this.$router.push('/Forums/' + data.stringUrl + '/' + this.$route.params.forum);
	                } else if (this.$route.params.category) {
	                    this.$router.push('/Forums/' + data.stringUrl);
	                }
	            }
	        },
	        'forumsEditForum': function forumsEditForum(data) {
	            this.$store.dispatch('forums/getCategoriesAndForums', {
	                boardId: this.boardId
	            });
	
	            if (data.oldStringUrl === this.$route.params.forum) {
	                if (this.$route.params.thread) {
	                    this.$router.push('/Forums/' + this.$route.params.category + '/' + data.stringUrl + '/' + this.$route.params.thread);
	                } else if (this.$route.params.forum) {
	                    this.$router.push('/Forums/' + this.$route.params.category + '/' + data.stringUrl);
	                }
	            }
	        },
	        'forumsEditThread': function forumsEditThread(data) {
	            this.$store.dispatch('forums/getCategoriesAndForums', {
	                boardId: this.boardId
	            });
	
	            if (data.oldStringUrl === this.$route.params.thread) {
	                if (this.$route.params.thread) {
	                    this.$router.push('/Forums/' + this.$route.params.category + '/' + this.$route.params.forum + '/' + data.stringUrl);
	                }
	            }
	        },
	        'forumsMoveThread': function forumsMoveThread(data) {
	            this.$store.dispatch('forums/getCategoriesAndForums', {
	                boardId: this.boardId
	            });
	        }
	    }
	};

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _EditGameWidget = __webpack_require__(784);
	
	var _EditGameWidget2 = _interopRequireDefault(_EditGameWidget);
	
	var _EditGameVitals = __webpack_require__(783);
	
	var _EditGameVitals2 = _interopRequireDefault(_EditGameVitals);
	
	var _EditGameRecruitment = __webpack_require__(782);
	
	var _EditGameRecruitment2 = _interopRequireDefault(_EditGameRecruitment);
	
	var _LeaveGame = __webpack_require__(785);
	
	var _LeaveGame2 = _interopRequireDefault(_LeaveGame);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'GameCompanionContent',
	    data: function data() {
	        return {
	            editDetailsMode: false,
	            editVitalsMode: false,
	            editRecruitmentMode: false,
	            leaveGameMode: false,
	            savingFollowingChange: false
	        };
	    },
	
	
	    components: {
	        'edit-game': _EditGameWidget2.default,
	        'edit-game-vitals': _EditGameVitals2.default,
	        'edit-game-recruitment': _EditGameRecruitment2.default,
	        'leave-game': _LeaveGame2.default
	    },
	
	    mounted: function mounted() {},
	
	
	    computed: {
	        game: function game() {
	            return this.$store.state.gamePageModel.gameInformation;
	        },
	        skillList: function skillList() {
	            return this.$store.state.develteamDataModel.skills;
	        },
	        showSkillTags: function showSkillTags() {
	            return this.game.skills.length > 0;
	        },
	        isSeeking: function isSeeking() {
	            return this.game.seekingProducers || this.game.seekingDesigners || this.game.seekingArtists || this.game.seekingProgrammers || this.game.seekingWriters || this.game.seekingMusicians || this.game.seekingSfxArtists || this.game.seekingTesters;
	        },
	        seekingRoles: function seekingRoles() {
	            return 'some roles';
	        },
	        gameId: function gameId() {
	            if (this.game) {
	                return this.game.id;
	            }
	        },
	        isMember: function isMember() {
	            if (!this.$store.state.loggedUserModel.isLoggedIn || (0, _keys2.default)(this.$store.state.gamePageModel.gameMembers).length === 0) {
	                return false;
	            }
	
	            var isGameMember = false;
	
	            this.$store.state.gamePageModel.gameMembers.forEach(function (member) {
	                if (member.id === this.$store.state.loggedUserModel.info.id && member.status === 'Current') {
	                    isGameMember = true;
	                }
	            }.bind(this));
	
	            return isGameMember;
	        },
	        isModerator: function isModerator() {
	            if (!this.isMember) {
	                return false;
	            }
	
	            var isModerator = false;
	
	            this.$store.state.gamePageModel.gameMembers.forEach(function (member) {
	                if (member.id === this.$store.state.loggedUserModel.info.id && member.modLevel !== 'member' && member.status === 'Current') {
	                    isModerator = true;
	                }
	            }.bind(this));
	
	            return isModerator;
	        },
	        isOwner: function isOwner() {
	            if (!this.isMember) {
	                return false;
	            }
	
	            var isOwner = false;
	
	            this.$store.state.gamePageModel.gameMembers.forEach(function (member) {
	                if (member.id === this.$store.state.loggedUserModel.info.id && member.modLevel === 'owner' && member.status === 'Current') {
	                    isOwner = true;
	                }
	            }.bind(this));
	
	            return isOwner;
	        },
	        showContactOptions: function showContactOptions() {
	            return this.$store.state.loggedUserModel.isLoggedIn;
	        },
	        showRequestOption: function showRequestOption() {
	            return !this.isMember;
	        },
	        isFollowing: function isFollowing() {
	            var connections = this.$store.state.gamePageModel.gameConnections;
	            var foundSelf = false;
	
	            if (!this.$store.state.loggedUserModel.isLoggedIn) {
	                return false;
	            }
	
	            if (connections && connections.followers) {
	                connections.followers.forEach(function (follower) {
	                    if (follower.id === this.$store.state.loggedUserModel.info.id) {
	                        foundSelf = true;
	                    }
	                }.bind(this));
	            }
	
	            return foundSelf;
	        },
	        showFollowOption: function showFollowOption() {
	            return this.$store.state.gamePageModel.retrievedConnections;
	        }
	    },
	
	    methods: {
	        getSkill: function getSkill(skillId) {
	            return this.skillList[skillId] ? this.skillList[skillId].skill : '';
	        },
	        sendRequestToJoin: function sendRequestToJoin() {
	            this.$router.push({ path: '/RequestToJoin/' + this.game.stringUrl });
	        },
	        updateFollowStatus: function updateFollowStatus() {
	            if (this.savingFollowingChange) {
	                return;
	            }
	
	            this.savingFollowingChange = true;
	            this.$store.dispatch('gamePage/updateFollowStatus');
	        },
	        getDevStatus: function getDevStatus(statusCode) {
	            if (statusCode === 'indevelopment') {
	                return 'In Development';
	            } else {
	                return statusCode.charAt(0).toUpperCase() + statusCode.slice(1);
	            }
	        }
	    },
	
	    watch: {
	        'isFollowing': function isFollowing() {
	            this.savingFollowingChange = false;
	        }
	    },
	
	    sockets: {
	        'gameAliasUpdated': function gameAliasUpdated(data) {
	            if (data.gameId == this.game.id) {
	                this.editDetailsMode = false;
	                this.editVitalsMode = false;
	                this.$router.push('/Game/' + data.stringUrl);
	            }
	        }
	    }
	};

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _GameDetails = __webpack_require__(772);
	
	var _GameDetails2 = _interopRequireDefault(_GameDetails);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'Game',
	    metaInfo: function metaInfo() {
	        return {
	            title: this.title
	        };
	    },
	
	
	    components: {
	        'game-details': _GameDetails2.default
	    },
	
	    data: function data() {
	        return {};
	    },
	    mounted: function mounted() {
	        this.$store.dispatch('gamePage/getGameInformation', this.$route.params.game);
	    },
	
	
	    computed: {
	        title: function title() {
	            var pageData = this.$store.state.gamePageModel.gameInformation;
	
	            if (pageData && pageData.alias) {
	                return 'Develteam ' + pageData.alias + ' | Game developer community | Game dev team up';
	            }
	
	            return 'Develteam | Game Developer Community | Game dev team up';
	        },
	        selectedSubpage: function selectedSubpage() {
	            var subpage = this.$route.path.substring(1).split('/')[2];
	            return subpage || 'RecentActivity';
	        },
	        gameId: function gameId() {
	            var pageData = this.$store.state.gamePageModel.gameInformation;
	
	            if (pageData && pageData.id) {
	                return pageData.id;
	            }
	        },
	        isMember: function isMember() {
	            if (!this.$store.state.loggedUserModel.isLoggedIn || (0, _keys2.default)(this.$store.state.gamePageModel.gameMembers).length === 0) {
	                return false;
	            }
	
	            var isGameMember = false;
	
	            this.$store.state.gamePageModel.gameMembers.forEach(function (member) {
	                if (member.id === this.$store.state.loggedUserModel.info.id && member.status === 'Current') {
	                    isGameMember = true;
	                }
	            }.bind(this));
	
	            return isGameMember;
	        },
	        isModerator: function isModerator() {
	            if (!this.isMember) {
	                return false;
	            }
	
	            var isModerator = false;
	
	            this.$store.state.gamePageModel.gameMembers.forEach(function (member) {
	                if (member.id === this.$store.state.loggedUserModel.info.id && member.modLevel !== 'member' && member.status === 'Current') {
	                    isModerator = true;
	                }
	            }.bind(this));
	
	            return isModerator;
	        },
	        isOwner: function isOwner() {
	            if (!this.isMember) {
	                return false;
	            }
	
	            var isOwner = false;
	
	            this.$store.state.gamePageModel.gameMembers.forEach(function (member) {
	                if (member.id === this.$store.state.loggedUserModel.info.id && member.modLevel === 'owner' && member.status === 'Current') {
	                    isOwner = true;
	                }
	            }.bind(this));
	
	            return isOwner;
	        },
	        gameDoesntExist: function gameDoesntExist() {
	            return this.$store.state.gamePageModel.fetchError !== '';
	        }
	    },
	
	    watch: {
	        '$route': function $route() {
	            var model = this.$store.state.gamePageModel;
	            var currentGame = this.$route.params.game;
	            var differentGame = false;
	
	            if (model.retrievedInformation && model.retrievedConnections && model.retrievedMembers) {
	                if (currentGame && currentGame.toLowerCase() !== model.gameInformation.stringUrl.toLowerCase()) {
	                    differentGame = true;
	                }
	            }
	
	            if (!model.retrievedInformation || !model.retrievedConnections || !model.retrievedMembers || differentGame) {
	                this.$store.dispatch('gamePage/getGameInformation', currentGame);
	            }
	        }
	    },
	
	    methods: {},
	
	    sockets: {
	        'gameProjectDeleted': function gameProjectDeleted(data) {
	            if (data.gameId == this.gameId) {
	                this.$store.dispatch('gamePage/getGameInformation', this.$route.params.game);
	            }
	        }
	    }
	};

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'DeveloperFeed',
	    props: ['gameId', 'isModerator', 'isMember'],
	
	    data: function data() {
	        return {
	            postCountToFetch: 10,
	            showNewPostForm: false,
	            newPostSubject: '',
	            newPostContent: ''
	        };
	    },
	    mounted: function mounted() {
	        if (this.gameId && (this.fetchingStatus !== 'fetched' || (0, _keys2.default)(this.feedPosts).length < this.postCountToFetch)) {
	            this.getPosts();
	        }
	    },
	
	
	    computed: {
	        isLoggedIn: function isLoggedIn() {
	            return this.$store.state.loggedUserModel.isLoggedIn;
	        },
	        layout: function layout() {
	            return 'single';
	
	            if (!this.isLoggedIn) {
	                return 'masonry';
	            }
	
	            return this.$store.state.loggedUserModel.options.feedLayoutStyle;
	        },
	        feedPostsId: function feedPostsId() {
	            return 'game.' + this.gameId;
	        },
	        feedPosts: function feedPosts() {
	            var gameFeedData = this.$store.state.feedPostsModel.feedPosts[this.feedPostsId];
	
	            if (!gameFeedData) {
	                return {};
	            }
	
	            var allPosts = [];
	            var normalPosts = [];
	            var pinnedPosts = [];
	
	            (0, _keys2.default)(gameFeedData.posts).forEach(function (key) {
	                if (gameFeedData.posts[key].isPinned) {
	                    pinnedPosts.push(gameFeedData.posts[key]);
	                } else {
	                    normalPosts.push(gameFeedData.posts[key]);
	                }
	            });
	
	            normalPosts.sort(function (a, b) {
	                return new Date(a.postDate) > new Date(b.postDate) ? -1 : 1;
	            });
	            pinnedPosts.sort(function (a, b) {
	                return new Date(a.postDate) > new Date(b.postDate) ? -1 : 1;
	            });
	
	            pinnedPosts.forEach(function (post) {
	                allPosts.push(post);
	            });
	
	            normalPosts.forEach(function (post) {
	                allPosts.push(post);
	            });
	
	            return allPosts;
	        },
	        fetchingStatus: function fetchingStatus() {
	            var developerFeedData = this.$store.state.feedPostsModel.feedPosts[this.feedPostsId];
	            return developerFeedData ? developerFeedData.fetchingStatus : 'fetching';
	        },
	        hasFetchedAll: function hasFetchedAll() {
	            var developerFeedData = this.$store.state.feedPostsModel.feedPosts[this.feedPostsId];
	            return developerFeedData ? developerFeedData.hasFetchedAll : true;
	        }
	    },
	
	    methods: {
	        getPosts: function getPosts() {
	            this.$store.dispatch('feedPosts/getFeedPosts', {
	                feedPostsId: this.feedPostsId,
	                feedType: 'game',
	                feedId: this.gameId,
	                limit: this.postCountToFetch
	            });
	        },
	        submitNewPost: function submitNewPost() {
	            if (this.newPostContent.trim() !== '') {
	                this.$store.dispatch('feedPosts/postNewPost', {
	                    subject: this.newPostSubject,
	                    content: this.newPostContent,
	                    parentType: 'game',
	                    parentId: this.gameId
	                });
	
	                this.newPostContent = '';
	                this.newPostSubject = '';
	                this.showNewPostForm = false;
	            }
	        },
	        fetchMore: function fetchMore() {
	            this.$store.dispatch('feedPosts/getFeedPosts', {
	                feedPostsId: this.feedPostsId,
	                feedType: 'game',
	                feedId: this.gameId
	            });
	        },
	        changeLayout: function changeLayout(style) {
	            if (!this.isLoggedIn) {
	                return;
	            }
	
	            this.$set(this.$store.state.loggedUserModel.options, 'feedLayoutStyle', style);
	
	            _axios2.default.post('/api/userOptions/updateFeedLayoutStyle', {
	                style: style
	            });
	        }
	    },
	
	    watch: {
	        '$store.state.gamePageModel.gameInformation': function $storeStateGamePageModelGameInformation() {
	            this.getPosts();
	        }
	    }
	};

/***/ }),
/* 245 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: 'GameFollowers',
	    data: function data() {
	        return {};
	    },
	
	
	    components: {},
	
	    mounted: function mounted() {},
	
	
	    computed: {
	        hasData: function hasData() {
	            var model = this.$store.state.gamePageModel;
	            return model.retrievedInformation && model.retrievedConnections;
	        },
	        profileConnections: function profileConnections() {
	            return this.$store.state.gamePageModel.gameConnections;
	        },
	        profileAlias: function profileAlias() {
	            var profileInformation = this.$store.state.gamePageModel.gameInformation;
	            return profileInformation.alias ? profileInformation.alias : undefined;
	        }
	    },
	
	    methods: {}
	};

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vue = __webpack_require__(4);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _ForumsCategoryList = __webpack_require__(139);
	
	var _ForumsCategoryList2 = _interopRequireDefault(_ForumsCategoryList);
	
	var _ForumsForumList = __webpack_require__(140);
	
	var _ForumsForumList2 = _interopRequireDefault(_ForumsForumList);
	
	var _ForumsThreadList = __webpack_require__(142);
	
	var _ForumsThreadList2 = _interopRequireDefault(_ForumsThreadList);
	
	var _ForumsPostList = __webpack_require__(141);
	
	var _ForumsPostList2 = _interopRequireDefault(_ForumsPostList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'GameForums',
	    props: ['gameId', 'isModerator', 'isMember'],
	
	    data: function data() {
	        return {};
	    },
	
	
	    components: {
	        'category-list': _ForumsCategoryList2.default,
	        'forum-list': _ForumsForumList2.default,
	        'thread-list': _ForumsThreadList2.default,
	        'post-list': _ForumsPostList2.default
	    },
	
	    mounted: function mounted() {
	        if ((!this.board || this.board.fetchingStatus !== 'fetched') && this.$store.state.gamePageModel.retrievedInformation) {
	            this.$store.dispatch('forums/getCategoriesAndForums', {
	                boardId: this.boardId
	            });
	        }
	    },
	
	
	    computed: {
	        canPost: function canPost() {
	            return this.$store.state.loggedUserModel.isLoggedIn;
	        },
	        isCategorySet: function isCategorySet() {
	            return this.$route.params.category !== undefined;
	        },
	        isForumSet: function isForumSet() {
	            return this.$route.params.forum !== undefined;
	        },
	        isThreadSet: function isThreadSet() {
	            return this.$route.params.thread !== undefined;
	        },
	        board: function board() {
	            return this.$store.state.forumsModel.boards[this.boardId];
	        },
	        boardId: function boardId() {
	            return 'game.' + this.$store.state.gamePageModel.gameInformation.id;
	        },
	        root: function root() {
	            var model = this.$store.state.gamePageModel;
	
	            return 'Game/' + model.gameInformation.stringUrl + '/Forums';
	        }
	    },
	
	    methods: {},
	
	    watch: {
	        'boardId': function boardId() {
	            if (!this.board && this.$store.state.gamePageModel.retrievedInformation) {
	                this.$store.dispatch('forums/getCategoriesAndForums', {
	                    boardId: this.boardId
	                });
	            }
	        }
	    },
	
	    sockets: {
	        'forumsLockThread': function forumsLockThread(data) {
	            var board = this.$store.state.forumsModel.boards[this.boardId];
	
	            if (board.categories && board.categories[this.$route.params.category] && board.categories[this.$route.params.category].forums && board.categories[this.$route.params.category].forums[this.$route.params.forum] && board.categories[this.$route.params.category].forums[this.$route.params.forum].threads && board.categories[this.$route.params.category].forums[this.$route.params.forum].threads[data.stringUrl]) {
	                _vue2.default.set(board.categories[this.$route.params.category].forums[this.$route.params.forum].threads[data.stringUrl], 'locked', data.isLocked);
	            }
	        },
	        'forumsPinThread': function forumsPinThread(data) {
	            var board = this.$store.state.forumsModel.boards[this.boardId];
	
	            if (board.categories && board.categories[this.$route.params.category] && board.categories[this.$route.params.category].forums && board.categories[this.$route.params.category].forums[this.$route.params.forum] && board.categories[this.$route.params.category].forums[this.$route.params.forum].threads && board.categories[this.$route.params.category].forums[this.$route.params.forum].threads[data.stringUrl]) {
	                _vue2.default.set(board.categories[this.$route.params.category].forums[this.$route.params.forum].threads[data.stringUrl], 'pinned', data.isPinned);
	            }
	        },
	        'forumsDeleteThread': function forumsDeleteThread(data) {
	            var board = this.$store.state.forumsModel.boards[this.boardId];
	
	            if (this.$route.params.thread) {
	                this.$router.push('/' + this.root + '/' + this.$route.params.category + '/' + this.$route.params.forum);
	            }
	
	            if (board.categories && board.categories[this.$route.params.category] && board.categories[this.$route.params.category].forums && board.categories[this.$route.params.category].forums[this.$route.params.forum] && board.categories[this.$route.params.category].forums[this.$route.params.forum].threads && board.categories[this.$route.params.category].forums[this.$route.params.forum].threads[data.stringUrl]) {
	                _vue2.default.delete(board.categories[this.$route.params.category].forums[this.$route.params.forum].threads, data.stringUrl);
	            }
	        },
	        'forumsEditCategory': function forumsEditCategory(data) {
	            this.$store.dispatch('forums/getCategoriesAndForums', {
	                boardId: this.boardId
	            });
	
	            if (data.oldStringUrl === this.$route.params.category) {
	                if (this.$route.params.thread) {
	                    this.$router.push('/' + this.root + '/' + data.stringUrl + '/' + this.$route.params.forum + '/' + this.$route.params.thread);
	                } else if (this.$route.params.forum) {
	                    this.$router.push('/' + this.root + '/' + data.stringUrl + '/' + this.$route.params.forum);
	                } else if (this.$route.params.category) {
	                    this.$router.push('/' + this.root + '/' + data.stringUrl);
	                }
	            }
	        },
	        'forumsEditForum': function forumsEditForum(data) {
	            this.$store.dispatch('forums/getCategoriesAndForums', {
	                boardId: this.boardId
	            });
	
	            if (data.oldStringUrl === this.$route.params.forum) {
	                if (this.$route.params.thread) {
	                    this.$router.push('/' + this.root + '/' + this.$route.params.category + '/' + data.stringUrl + '/' + this.$route.params.thread);
	                } else if (this.$route.params.forum) {
	                    this.$router.push('/' + this.root + '/' + this.$route.params.category + '/' + data.stringUrl);
	                }
	            }
	        },
	        'forumsEditThread': function forumsEditThread(data) {
	            this.$store.dispatch('forums/getCategoriesAndForums', {
	                boardId: this.boardId
	            });
	
	            if (data.oldStringUrl === this.$route.params.thread) {
	                if (this.$route.params.thread) {
	                    this.$router.push('/' + this.root + '/' + this.$route.params.category + '/' + this.$route.params.forum + '/' + data.stringUrl);
	                }
	            }
	        },
	        'forumsMoveThread': function forumsMoveThread(data) {
	            this.$store.dispatch('forums/getCategoriesAndForums', {
	                boardId: this.boardId
	            });
	        }
	    }
	};

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _FormNewMediaAlbum = __webpack_require__(144);
	
	var _FormNewMediaAlbum2 = _interopRequireDefault(_FormNewMediaAlbum);
	
	var _FormReorderMediaAlbums = __webpack_require__(145);
	
	var _FormReorderMediaAlbums2 = _interopRequireDefault(_FormReorderMediaAlbums);
	
	var _MediaPieceList = __webpack_require__(146);
	
	var _MediaPieceList2 = _interopRequireDefault(_MediaPieceList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'GameMedia',
	    props: ['gameId', 'isModerator', 'isMember'],
	
	    data: function data() {
	        return {
	            imageLoader: undefined,
	            selectedAlbum: undefined,
	            addAlbumMode: false,
	            editAlbumMode: false,
	            reorderAlbumMode: false
	        };
	    },
	
	
	    components: {
	        'new-album-form': _FormNewMediaAlbum2.default,
	        'reorder-album-form': _FormReorderMediaAlbums2.default,
	        'media-piece-list': _MediaPieceList2.default
	    },
	
	    mounted: function mounted() {
	        if (this.gameId && this.fetchingAlbumStatus !== 'fetched') {
	            this.getAlbums();
	        }
	    },
	
	
	    computed: {
	        canEdit: function canEdit() {
	            var foundMatchingGame = false;
	
	            if (!this.$store.state.loggedUserModel.isLoggedIn) {
	                return false;
	            }
	
	            this.$store.state.loggedUserModel.games.forEach(function (game) {
	                if (game.id === this.gameId) {
	                    foundMatchingGame = true;
	                }
	            }.bind(this));
	
	            return foundMatchingGame;
	        },
	        mediasId: function mediasId() {
	            return 'game.' + this.gameId;
	        },
	        fetchingAlbumStatus: function fetchingAlbumStatus() {
	            var gameMediaData = this.$store.state.mediasModel.medias[this.mediasId];
	            return gameMediaData ? gameMediaData.fetchingStatus : 'fetching';
	        },
	        albums: function albums() {
	            var gameMediaData = this.$store.state.mediasModel.medias[this.mediasId];
	
	            var albums = [];
	
	            if (gameMediaData) {
	                (0, _keys2.default)(gameMediaData.albums).forEach(function (key) {
	                    albums.push(gameMediaData.albums[key]);
	                });
	            }
	
	            albums.sort(function (a, b) {
	                return a.rank > b.rank ? 1 : -1;
	            });
	
	            return albums;
	        }
	    },
	
	    methods: {
	        getAlbums: function getAlbums() {
	            this.$store.dispatch('medias/getAlbums', {
	                mediasId: this.mediasId
	            });
	        },
	        enterAddAlbumMode: function enterAddAlbumMode() {
	            this.addAlbumMode = true;
	            this.$router.push('/Game/' + this.$route.params.game + '/Media/');
	        },
	        exitAddAlbumMode: function exitAddAlbumMode() {
	            this.addAlbumMode = false;
	        },
	        exitSinglePieceView: function exitSinglePieceView() {
	            this.$router.push('/Game/' + this.$route.params.game + '/Media/');
	        },
	        enterReorderAlbumMode: function enterReorderAlbumMode() {
	            this.reorderAlbumMode = true;
	            this.$router.push('/Game/' + this.$route.params.game + '/Media/');
	        },
	        exitReorderAlbumMode: function exitReorderAlbumMode() {
	            this.reorderAlbumMode = false;
	        }
	    },
	
	    watch: {
	        '$store.state.gamePageModel.gameInformation': function $storeStateGamePageModelGameInformation() {
	            this.getAlbums();
	        },
	        '$route.params.album': function $routeParamsAlbum() {
	            if (this.$route.params.album) {
	                this.exitAddAlbumMode();
	            }
	        }
	    },
	
	    sockets: {
	        'mediaAlbumAddOrEdit': function mediaAlbumAddOrEdit(data) {
	            this.exitAddAlbumMode();
	        },
	        'mediaAlbumReorder': function mediaAlbumReorder(data) {
	            this.getAlbums();
	            this.exitReorderAlbumMode();
	        }
	    }
	};

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _GameMembersEdit = __webpack_require__(779);
	
	var _GameMembersEdit2 = _interopRequireDefault(_GameMembersEdit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'GameMembers',
	    props: ['gameId', 'isMember', 'isModerator', 'isOwner'],
	
	    data: function data() {
	        return {
	            hasCurrentMembers: false,
	            hasFormerMembers: false,
	            editMembersMode: false
	        };
	    },
	
	
	    components: {
	        'edit-page': _GameMembersEdit2.default
	    },
	
	    mounted: function mounted() {},
	
	
	    computed: {
	        hasData: function hasData() {
	            var model = this.$store.state.gamePageModel;
	            return model.retrievedInformation && model.retrievedMembers;
	        },
	        members: function members() {
	            return this.$store.state.gamePageModel.gameMembers;
	        },
	        organizedMembers: function organizedMembers() {
	            this.hasCurrentMembers = false;
	            this.hasFormerMembers = false;
	
	            var organizedMembers = {
	                current: {
	                    'Production': { rank: 0, members: [] },
	                    'Design': { rank: 1, members: [] },
	                    'Art': { rank: 2, members: [] },
	                    'Programming': { rank: 3, members: [] },
	                    'Music': { rank: 4, members: [] },
	                    'Sound Effects': { rank: 5, members: [] },
	                    'Writing': { rank: 6, members: [] },
	                    'Testing': { rank: 7, members: [] },
	                    'Undefined Positions': { rank: 8, members: [] }
	                },
	                former: {
	                    'Production': { rank: 0, members: [] },
	                    'Design': { rank: 1, members: [] },
	                    'Art': { rank: 2, members: [] },
	                    'Programming': { rank: 3, members: [] },
	                    'Music': { rank: 4, members: [] },
	                    'Sound Effects': { rank: 5, members: [] },
	                    'Writing': { rank: 6, members: [] },
	                    'Testing': { rank: 7, members: [] },
	                    'Undefined Positions': { rank: 8, members: [] }
	                }
	            };
	
	            _lodash2.default.each(this.members, function (member) {
	                if (member.status === 'Current') {
	                    this.hasCurrentMembers = true;
	                    _lodash2.default.each(member.positions, function (position) {
	                        var memberData = _lodash2.default.cloneDeep(member);
	                        if (organizedMembers.current[position.positionType]) {
	                            memberData.positionTitle = position.positionTitle;
	                            organizedMembers.current[position.positionType].members.push(memberData);
	                        }
	                    });
	
	                    if ((0, _keys2.default)(member.positions).length === 0) {
	                        organizedMembers.current['Undefined Positions'].members.push(member);
	                    }
	                } else {
	                    this.hasFormerMembers = true;
	                    _lodash2.default.each(member.positions, function (position) {
	                        var memberData = _lodash2.default.cloneDeep(member);
	                        if (organizedMembers.former[position.positionType]) {
	                            memberData.positionTitle = position.positionTitle;
	                            organizedMembers.former[position.positionType].members.push(memberData);
	                        }
	                    });
	
	                    if ((0, _keys2.default)(member.positions).length === 0) {
	                        organizedMembers.former['Undefined Positions'].members.push(member);
	                    }
	                }
	            }.bind(this));
	
	            return organizedMembers;
	        }
	    },
	
	    methods: {}
	};

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _GameMembersEditItem = __webpack_require__(780);
	
	var _GameMembersEditItem2 = _interopRequireDefault(_GameMembersEditItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'GameMembersEdit',
	    props: ['gameId', 'members', 'isModerator'],
	
	    data: function data() {
	        return {
	            positions: ['Production', 'Design', 'Art', 'Programming', 'Music', 'Sound Effects', 'Writing', 'Testing']
	        };
	    },
	
	
	    components: {
	        'editable-member': _GameMembersEditItem2.default
	    },
	
	    mounted: function mounted() {},
	
	
	    computed: {
	        myId: function myId() {
	            return this.$store.state.loggedUserModel.info.id;
	        },
	        formData: function formData() {
	            var members = _lodash2.default.cloneDeep(this.members);
	
	            _lodash2.default.each(members, function (member) {
	                member.isModerator = member.modLevel === 'mod';
	
	                _lodash2.default.each(this.positions, function (position) {
	                    if (!member.positions[position]) {
	                        member.positions[position] = {
	                            positionType: position,
	                            positionTitle: '',
	                            checked: false
	                        };
	                    } else {
	                        member.positions[position].checked = true;
	                    }
	                }.bind(this));
	            }.bind(this));
	
	            members = _lodash2.default.sortBy(members, function (member) {
	                return member.id !== this.myId;
	            }.bind(this));
	
	            return members;
	        }
	    },
	
	    methods: {
	        exitEditMode: function exitEditMode() {
	            this.$emit('exitEditMode');
	        }
	    }
	};

/***/ }),
/* 250 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: 'GameMembersEditItem',
	    props: ['member', 'positions', 'myId', 'gameId'],
	
	    data: function data() {
	        return {
	            saveButtonEnabled: false,
	            isSaving: false,
	            removeMode: false
	        };
	    },
	
	
	    components: {},
	
	    mounted: function mounted() {},
	
	
	    computed: {
	        prop: function prop() {
	            return {};
	        }
	    },
	
	    methods: {
	        saveMember: function saveMember() {
	            this.isSaving = true;
	            this.$store.dispatch('gamePage/updateMember', {
	                member: this.member,
	                gameId: this.gameId
	            });
	        },
	        removeMember: function removeMember() {
	            this.isSaving = true;
	            this.removeMode = false;
	
	            this.$store.dispatch('gamePage/removeMember', {
	                member: this.member,
	                gameId: this.gameId
	            });
	        },
	        enableSaveButton: function enableSaveButton() {
	            this.saveButtonEnabled = true;
	        }
	    },
	
	    sockets: {
	        'gameMembersUpdated': function gameMembersUpdated() {
	            setTimeout(function () {
	                this.isSaving = false;
	            }.bind(this), 500);
	        }
	    }
	};

/***/ }),
/* 251 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: 'GameSinglePostView',
	
	    components: {},
	
	    mounted: function mounted() {
	        if (!this.postData && this.gameId) {
	            this.getPost();
	        }
	    },
	
	
	    computed: {
	        postId: function postId() {
	            return this.$route.params.id;
	        },
	        feedPostsId: function feedPostsId() {
	            return 'game.' + this.gameId;
	        },
	        gameId: function gameId() {
	            var pageData = this.$store.state.gamePageModel.gameInformation;
	
	            if (pageData && pageData.id) {
	                return pageData.id;
	            }
	        },
	        postData: function postData() {
	            var feedData = this.$store.state.feedPostsModel.feedPosts[this.feedPostsId];
	
	            if (feedData) {
	                return feedData.posts[this.postId];
	            }
	        },
	        fetchingStatus: function fetchingStatus() {
	            var gameFeedData = this.$store.state.feedPostsModel.feedPosts[this.feedPostsId];
	            return gameFeedData ? gameFeedData.fetchingStatus : 'fetching';
	        }
	    },
	
	    methods: {
	        getPost: function getPost() {
	            this.$store.dispatch('feedPosts/getSingleFeedPost', {
	                feedPostsId: this.feedPostsId,
	                feedType: 'game',
	                feedId: this.gameId,
	                postId: this.postId
	            });
	        }
	    },
	
	    watch: {
	        'gameId': function gameId() {
	            if (!this.postData) {
	                this.getPost();
	            }
	        },
	        'postId': function postId() {
	            if (!this.postData) {
	                this.getPost();
	            }
	        }
	    }
	};

/***/ }),
/* 252 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: 'EditGameRecruitment',
	    props: ['game'],
	
	    data: function data() {
	        return {
	            roleTitles: this.game.seekingRoles,
	            skills: _.clone(this.game.skills),
	            enteredSkill: '',
	
	            recruitingProducers: this.game.seekingProducers,
	            recruitingDesigners: this.game.seekingDesigners,
	            recruitingArtists: this.game.seekingArtists,
	            recruitingProgrammers: this.game.seekingProgrammers,
	            recruitingMusicians: this.game.seekingMusicians,
	            recruitingSfxArtists: this.game.seekingSfxArtists,
	            recruitingWriters: this.game.seekingWriters,
	            recruitingTesters: this.game.seekingTesters,
	            isSaving: false
	        };
	    },
	
	
	    computed: {
	        skillList: function skillList() {
	            return this.$store.state.develteamDataModel.skills;
	        },
	        matchingSkills: function matchingSkills() {
	            var matchingSkills = [];
	
	            if (this.enteredSkill.length >= 1) {
	                for (var skillId in this.skillList) {
	                    var skill = this.skillList[skillId];
	                    var skillName = skill.category.toLowerCase() + ' ' + skill.skill.toLowerCase();
	
	                    if (skillName.toLowerCase().includes(this.enteredSkill.toLowerCase())) {
	                        if (!this.skills.includes(skill.id)) {
	                            matchingSkills.push(skill);
	                        }
	                    }
	                }
	            }
	
	            matchingSkills = _.sortBy(matchingSkills, function (skill) {
	                return skill.skill;
	            });
	
	            return matchingSkills;
	        }
	    },
	    methods: {
	        addSkill: function addSkill(skillId) {
	            this.skills.push(skillId);
	        },
	        removeSkill: function removeSkill(skillId) {
	            this.skills = _.remove(this.skills, function (id) {
	                return id !== skillId;
	            });
	        },
	        cancelChanges: function cancelChanges() {
	            this.$emit('doneEditing');
	        },
	        submitChanges: function submitChanges() {
	            this.$store.dispatch('gamePage/updateRecruitment', {
	                gameId: this.game.id,
	                roleTitles: this.roleTitles,
	                skills: this.skills,
	                recruitingProducers: this.recruitingProducers,
	                recruitingDesigners: this.recruitingDesigners,
	                recruitingArtists: this.recruitingArtists,
	                recruitingProgrammers: this.recruitingProgrammers,
	                recruitingMusicians: this.recruitingMusicians,
	                recruitingSfxArtists: this.recruitingSfxArtists,
	                recruitingWriters: this.recruitingWriters,
	                recruitingTesters: this.recruitingTesters
	            });
	
	            this.isSaving = true;
	        }
	    },
	
	    sockets: {
	        'gameInformationUpdated': function gameInformationUpdated(data) {
	            if (data.gameId === this.game.id) {
	                this.$emit('doneEditing');
	            }
	        }
	    }
	};

/***/ }),
/* 253 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: 'EditGameVitals',
	    props: ['game'],
	
	    data: function data() {
	        return {
	            avatarFile: undefined,
	            uploadedAvatarName: '',
	            uploadedImageSrc: '',
	            localAlias: this.game.alias,
	            isSaving: false,
	            avatarTooBig: false
	        };
	    },
	
	
	    components: {},
	
	    mounted: function mounted() {},
	
	
	    computed: {
	        prop: function prop() {
	            return {};
	        }
	    },
	
	    methods: {
	        updateuploadedAvatarName: function updateuploadedAvatarName(e) {
	            var input = e.target;
	            var reader = void 0;
	            var self = this;
	
	            if (input.files.length === 0) {
	                return;
	            }
	
	            if (input.files && input.files[0]) {
	                reader = new FileReader();
	
	                reader.onload = function (e) {
	                    self.uploadedImageSrc = e.target.result;
	                };
	
	                reader.readAsDataURL(input.files[0]);
	            }
	
	            this.avatarTooBig = e.target.files[0].size > 10 * 1024 * 1024;
	            this.uploadedAvatarName = e.target.files[0].name;
	            this.avatarFile = e.target.files[0];
	        },
	        cancelChanges: function cancelChanges() {
	            this.$emit('doneEditing');
	        },
	        isValidated: function isValidated() {
	            return !this.avatarTooBig && this.localAlias.trim() !== '';
	        },
	        submitChanges: function submitChanges() {
	            if (!this.isValidated()) {
	                return;
	            }
	
	            this.$store.dispatch('gamePage/updateVitals', {
	                gameId: this.game.id,
	                alias: this.localAlias,
	                avatarFile: this.avatarFile
	            });
	
	            this.isSaving = true;
	        }
	    },
	
	    sockets: {
	        'gameVitalsWithoutAliasUpdated': function gameVitalsWithoutAliasUpdated(data) {
	            if (data.gameId === this.game.id) {
	                this.$emit('doneEditing');
	            }
	        }
	    }
	};

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'EditGameWidget',
	
	    data: function data() {
	        return {
	            genres: {},
	            platforms: {},
	            rating: '',
	            releaseDate: '',
	            devStatus: '',
	            platformsOpen: false,
	            genresOpen: false,
	            errorMessage: '',
	            isSaving: false,
	            alias: ''
	        };
	    },
	    mounted: function mounted() {
	        this.genres = _lodash2.default.cloneDeep(this.$store.state.develteamDataModel.genres);
	        this.platforms = _lodash2.default.cloneDeep(this.$store.state.develteamDataModel.platforms);
	        this.rating = this.$store.state.gamePageModel.gameInformation.rating;
	        this.releaseDate = this.$store.state.gamePageModel.gameInformation.releaseDate;
	        this.devStatus = this.$store.state.gamePageModel.gameInformation.devStatus;
	        this.alias = this.$store.state.gamePageModel.gameInformation.alias;
	        this.setChecked();
	    },
	
	
	    computed: {
	        game: function game() {
	            return this.$store.state.gamePageModel.gameInformation;
	        }
	    },
	
	    methods: {
	        showHidden: function showHidden(category) {
	            this.$set(category, 'showHidden', true);
	        },
	        setChecked: function setChecked() {
	            var gameGenres = this.game.genres ? this.game.genres.split(', ') : [];
	            var gamePlatforms = this.game.platforms ? this.game.platforms.split(', ') : [];
	
	            gamePlatforms.forEach(function (gamePlatform) {
	                _lodash2.default.each(this.platforms, function (platform) {
	                    _lodash2.default.each(platform.platforms, function (p) {
	                        if (gamePlatform === p.label) {
	                            p.checked = true;
	                        }
	                    }.bind(this));
	                }.bind(this));
	            }.bind(this));
	
	            gameGenres.forEach(function (gameGenre) {
	                _lodash2.default.each(this.genres, function (genre) {
	                    if (genre.label === gameGenre) {
	                        genre.checked = true;
	                    }
	                }.bind(this));
	            }.bind(this));
	        },
	        togglePlatforms: function togglePlatforms() {
	            this.platformsOpen = !this.platformsOpen;
	        },
	        toggleGenres: function toggleGenres() {
	            this.genresOpen = !this.genresOpen;
	        },
	        clearErrorMessage: function clearErrorMessage() {
	            this.errorMessage = '';
	        },
	        cancelChanges: function cancelChanges() {
	            document.getElementById('game-companion-content').scrollIntoView();
	            this.$emit('doneEditing');
	        },
	        saveChanges: function saveChanges() {
	            var genresSelected = [];
	            var platformsSelected = [];
	
	            _lodash2.default.each(this.platforms, function (category) {
	                _lodash2.default.each(category.platforms, function (platform) {
	                    if (platform.checked) {
	                        platformsSelected.push(platform.id);
	                    }
	                });
	            });
	
	            _lodash2.default.each(this.genres, function (genre) {
	                if (genre.checked) {
	                    genresSelected.push(genre.id);
	                }
	            });
	
	            if (genresSelected.length === 0) {
	                this.errorMessage = 'Select at least one Genre';
	                return;
	            }
	
	            if (platformsSelected.length === 0) {
	                this.errorMessage = 'Select at least one Platform';
	                return;
	            }
	
	            this.$store.dispatch('gamePage/updateGameInformation', {
	                gameId: this.game.id,
	                platforms: platformsSelected,
	                genres: genresSelected,
	                rating: this.rating,
	                releaseDate: this.releaseDate,
	                devStatus: this.devStatus
	            });
	
	            document.getElementById('game-companion-content').scrollIntoView();
	            this.isSaving = true;
	        }
	    },
	
	    watch: {
	        '$store.state.develteamDataModel.genres': function $storeStateDevelteamDataModelGenres() {
	            this.genres = _lodash2.default.cloneDeep(this.$store.state.develteamDataModel.genres);
	            this.setChecked();
	        },
	        '$store.state.develteamDataModel.platforms': function $storeStateDevelteamDataModelPlatforms() {
	            this.platforms = _lodash2.default.cloneDeep(this.$store.state.develteamDataModel.platforms);
	            this.setChecked();
	        }
	    },
	
	    sockets: {
	        'gameInformationUpdated': function gameInformationUpdated(data) {
	            if (data.gameId === this.game.id) {
	                this.$emit('doneEditing');
	            }
	        }
	    }
	};

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'LeaveGame',
	    props: ['game', 'isOwner'],
	
	    data: function data() {
	        return {
	            newOwnerId: 0,
	            formErrors: [],
	            isSaving: false
	        };
	    },
	
	
	    components: {},
	
	    mounted: function mounted() {},
	
	
	    computed: {
	        members: function members() {
	            return _lodash2.default.filter(this.$store.state.gamePageModel.gameMembers, function (member) {
	                return member.status === 'Current';
	            });
	        },
	        myId: function myId() {
	            return this.$store.state.loggedUserModel.isLoggedIn ? this.$store.state.loggedUserModel.info.id : 0;
	        }
	    },
	
	    methods: {
	        cancelLeaving: function cancelLeaving() {
	            this.$emit('doneEditing');
	        },
	        leaveProject: function leaveProject() {
	            var _this = this;
	
	            if (this.isOwner && this.members.length > 1 && this.newOwnerId === 0) {
	                return;
	            }
	
	            this.isSaving = true;
	            _axios2.default.post('/api/members/leave', {
	                gameId: this.game.id,
	                newOwnerId: this.newOwnerId
	            }).then(function (response) {
	                if (response.data.errors) {
	                    _this.formErrors = response.data.errors;
	                } else {
	                    _this.$emit('doneEditing');
	                }
	            }, function (response) {
	                _this.formErrors = ['An unknown problem occurred. Please wait a few minutes and try again.'];
	            });
	        }
	    }
	};

/***/ }),
/* 256 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: 'DevelteamAnnouncements',
	    data: function data() {
	        return {
	            announcements: [{
	                title: 'The Forums are Back!',
	                text: 'Come fill them up!',
	                link: '/Forums',
	                linkText: 'Develteam Game Dev Forums'
	            }, {
	                title: 'Develteam is in Beta',
	                text: 'Please Report your Bugs and Suggestions!',
	                link: '/BugsAndSuggestions',
	                linkText: 'Bugs and Suggestions Board'
	
	            }]
	        };
	    }
	};

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Pitches = __webpack_require__(788);
	
	var _Pitches2 = _interopRequireDefault(_Pitches);
	
	var _Announcements = __webpack_require__(786);
	
	var _Announcements2 = _interopRequireDefault(_Announcements);
	
	var _RecentlyOnForums = __webpack_require__(789);
	
	var _RecentlyOnForums2 = _interopRequireDefault(_RecentlyOnForums);
	
	var _TopContent = __webpack_require__(790);
	
	var _TopContent2 = _interopRequireDefault(_TopContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'HomeDashboard',
	
	    components: {
	        'pitch': _Pitches2.default,
	        'announcements': _Announcements2.default,
	        'forums': _RecentlyOnForums2.default,
	        'top-content': _TopContent2.default
	    },
	
	    data: function data() {
	        return {};
	    },
	
	
	    computed: {
	        gotInitialLoggedUserInfo: function gotInitialLoggedUserInfo() {
	            return this.$store.state.loggedUserModel.gotInitialLoggedUserInfo;
	        },
	        isLoggedIn: function isLoggedIn() {
	            return this.$store.state.loggedUserModel.isLoggedIn;
	        },
	        hasLoginCookies: function hasLoginCookies() {
	            var cookieEntries = document.cookie.split(';');
	            var cookies = {};
	
	            cookieEntries.forEach(function (cookie) {
	                var cookieSegments = cookie.split('=');
	                if (cookieSegments.length === 2 && cookieSegments[1].trim() !== '') {
	                    cookies[cookieSegments[0].trim()] = cookieSegments[1].trim();
	                }
	            });
	
	            return cookies.userid !== undefined && cookies.password !== undefined;
	        }
	    },
	
	    mounted: function mounted() {},
	
	
	    methods: {}
	};

/***/ }),
/* 258 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: 'HomepagePitch',
	    props: ['depth'],
	
	    data: function data() {
	        return {
	            features: [{
	                title: 'About Develteam',
	                content: 'Develteam is a community for Indie Game Developers, an <a href="/browse">indie game developer network</a>! Share your <a href="/browse">game developer portfolio</a>, post your game projects, find help making games, <a href="/browse">find game developers</a>, <a href="/browse">find a game development team</a>, chat about game design and development, post on forums, and browse a large collection of game tools and resources.',
	                short: true,
	                long: false
	            }, {
	                title: 'Game Dev Team Up!',
	                content: 'It can be hard to <a href="/browse">find game developers</a> to work with. You want to find the best of the best when you\'re <a href="/browse">looking for a game development team</a>, and that\'s where Develteam shines - You can browse <a href="/browse">game developer portfolio</a>s to gauge someone\'s work before even having to contact them! No where else on the internet makes it so easy when looking for game developers. You can also <a href="/browse">find a game development team</a> by browsing projects. You can join an indie game team that already exists, too. Form the perfect <a href="/browse">Indie team up and join an indie game team</a>!',
	                short: true,
	                long: false
	            }, {
	                title: 'Game Dev Tools and Assets',
	                content: 'Develteam hosts a user-generated and ranked list of tools and assets to help with your game development needs. There are tools to assist in <a href="/browse">game collaboration</a>, Programming, Audio Composition, and making any kind of Art, from pixel art to 3d modeling to animation. There is also a nice collection of assets for graphics, music, sound effects, and fonts.',
	                short: true,
	                long: false
	            }, {
	                title: 'Post Portfolios and get feedback',
	                content: 'Showing off your work is an important part of the gamedev process. Sometimes it\'s hard to tell if what you\'re doing is working or not, and sharing your Gamedev Portfolio with a community of like-minded hobbyists and professionals is a great way to get feedback on your progress. It also helps you <a href="/browse">find a game development team</a>. Don\'t be afraid to share your <a href="/browse">game developer portfolio</a>! It\'s hard to form an <a href="/browse">indie team up</a> without one.',
	                short: true,
	                long: false
	            }, {
	                title: 'Get Help',
	                content: 'Designing games and Programming games are both very challenging fields of study. When you run into problems, you can ask the members of this <a href="/browse">indie game developer network</a>. We have experts here in every field, whether you\'re looking for help with general game programming or a more specific engine like Unity Development, You\'ll be able to find someone who can help you figure out how best to design games. When indies team up for <a href="/browse">game collaboration</a>, everyone wins.',
	                short: false,
	                long: true
	            }, {
	                title: 'Game Project Management',
	                content: 'You can host your Game Projects on Develteam. By creating a Game Project, you can invite members to join. Each game developer on your team can have their role defined and can post to your feed, and share media. Each Game Project gets its own Chat Room and Forums. Forums can be private (only members can see and post) or public (anyone can join!).  Maybe you\'re what someone is looking for when <a href="/browse">looking for a game development team</a>!',
	                short: false,
	                long: true
	            }, {
	                title: 'Help Make Develteam Better',
	                content: 'Develteam is an active <a href="/browse">indie game developer network</a>, and the developers of this site go straight to you for suggestions and bugs. There\'s a forum set up to report bugs and request suggestions, with transparent and open progress and discussion. We like to cater to and <a href="/browse">find game developers</a> who really know what they want when looking for game developers.',
	                short: false,
	                long: true
	            }, {
	                title: 'The future!',
	                content: 'Develteam is always growing, with new features and interactions in the backlog for development. We can\'t wait to share the future with you! Enjoy our site and this community. We hope you\'ll take this journey with us. :) ',
	                short: false,
	                long: true
	            }]
	        };
	    },
	    mounted: function mounted() {},
	
	
	    computed: {
	        prop: function prop() {
	            return {};
	        }
	    },
	
	    methods: {}
	};

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'RecentlyOnForums',
	    data: function data() {
	        return {
	            recentForumPosts: []
	        };
	    },
	
	
	    methods: {
	        fetchRecentForumPosts: function fetchRecentForumPosts() {
	            var _this = this;
	
	            _axios2.default.get('/api/Forums/recentPosts').then(function (response) {
	                if (response.data.errors) {
	                    return;
	                }
	
	                _this.recentForumPosts = response.data;
	            });
	        }
	    },
	
	    mounted: function mounted() {
	        this.fetchRecentForumPosts();
	    }
	};

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'RecentlyOnForums',
	    data: function data() {
	        return {
	            topContent: []
	        };
	    },
	
	
	    methods: {
	        fetchTopContent: function fetchTopContent() {
	            var _this = this;
	
	            _axios2.default.get('/api/topContent').then(function (response) {
	                if (response.data.errors) {
	                    return;
	                }
	
	                _this.topContent = response.data;
	            });
	        }
	    },
	
	    mounted: function mounted() {
	        this.fetchTopContent();
	    }
	};

/***/ }),
/* 261 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: 'HomeFeedNewPostForm',
	
	    data: function data() {
	        return {
	            expanded: false,
	            newPostContent: '',
	            newPostSubject: '',
	            selectedPostAs: 'developer',
	            helpShown: false
	        };
	    },
	
	
	    computed: {
	        isClassifieds: function isClassifieds() {
	            return this.$route.fullPath.toLowerCase() === "/classifieds";
	        },
	        buttonLabel: function buttonLabel() {
	            return this.isClassifieds ? 'Submit a Classifieds Post' : 'Write a DevLog';
	        },
	        headlineLabel: function headlineLabel() {
	            return this.isClassifieds ? 'Submit a Classifieds Post' : 'Submit a new Post';
	        },
	        isOnAGameProject: function isOnAGameProject() {
	            return this.$store.state.loggedUserModel.games.length > 0;
	        },
	        gameProjects: function gameProjects() {
	            return this.$store.state.loggedUserModel.games;
	        },
	        developerAlias: function developerAlias() {
	            return this.$store.state.loggedUserModel.info.alias;
	        }
	    },
	
	    methods: {
	        showHelpRollout: function showHelpRollout() {
	            this.helpShown = true;
	        },
	        hideHelpRollout: function hideHelpRollout() {
	            this.helpShown = false;
	        },
	        submitNewPost: function submitNewPost() {
	            var postAs = this.selectedPostAs === 'developer' ? 'developer' : 'game';
	            var postAsId = this.selectedPostAs === 'developer' ? 0 : this.selectedPostAs;
	
	            if (this.newPostContent.trim() === '') {
	                return;
	            }
	
	            this.$store.dispatch('feedPosts/postNewPost', {
	                subject: this.newPostSubject,
	                content: this.newPostContent,
	                parentType: postAs,
	                parentId: postAsId,
	                type: this.isClassifieds ? 'classifieds' : 'status'
	            });
	
	            this.newPostContent = '';
	            this.newPostSubject = '';
	            this.expanded = false;
	        }
	    }
	};

/***/ }),
/* 262 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: 'InboxCompose',
	
	    data: function data() {
	        return {
	            newMessageSubject: '',
	            newMessageContent: '',
	            addedParticipantName: '',
	            addedParticipants: [],
	            validationMessage: '',
	            formSubmitted: false
	        };
	    },
	    mounted: function mounted() {
	        this.$store.state.inboxPageModel.matchingDevsResponse = [];
	        if (this.$route.query.toId && this.$route.query.toId) {
	            this.addParticipant({ id: this.$route.query.toId, alias: this.$route.query.toAlias });
	        }
	    },
	
	
	    computed: {
	        matchingDevsResponse: function matchingDevsResponse() {
	            return this.$store.state.inboxPageModel.matchingDevsResponse;
	        }
	    },
	
	    methods: {
	        addParticipant: function addParticipant(dev) {
	            this.addedParticipants.push(dev);
	        },
	        removeParticipant: function removeParticipant(dev) {
	            this.addedParticipants = _.filter(this.addedParticipants, function (participant) {
	                return participant.id != dev.id;
	            });
	        },
	
	
	        getMatchingDevs: _.debounce(function () {
	            this.$store.dispatch('InboxPage/getMatchingDevNames', this.addedParticipantName);
	            this.addParticipantMessage = '';
	        }, 500),
	
	        shouldShowDev: function shouldShowDev(dev) {
	            var foundMatch = false;
	
	            if (dev.id == this.$store.state.loggedUserModel.info.id) {
	                return false;
	            }
	
	            this.addedParticipants.forEach(function (participant) {
	                if (participant.id == dev.id) {
	                    foundMatch = true;
	                }
	            });
	
	            return !foundMatch;
	        },
	        submitNewConversation: function submitNewConversation() {
	
	            if (this.addedParticipants.length === 0) {
	                this.validationMessage = "You forgot to add recipients!";
	                return;
	            }
	            if (this.newMessageSubject.length === 0) {
	                this.validationMessage = "You forgot to set a subject!";
	                return;
	            }
	
	            if (this.newMessageContent.trim().length === 0) {
	                this.validationMessage = "You forgot to say something!";
	                return;
	            }
	
	            this.formSubmitted = true;
	
	            this.$store.dispatch('InboxPage/AddNewConversation', {
	                participants: this.addedParticipants,
	                subject: this.newMessageSubject,
	                message: this.newMessageContent
	            });
	        }
	    },
	
	    watch: {
	        addedParticipantName: function addedParticipantName() {
	            this.validationMessage = '';
	            if (this.addedParticipantName.length >= 3) {
	                this.addParticipantMessage = 'Searching for matching developers...';
	                this.getMatchingDevs();
	            } else {
	                this.addParticipantMessage = 'Enter three or more characters';
	                this.$store.commit('InboxPage/getMatchingDevNames', []);
	            }
	        },
	        newMessageContent: function newMessageContent() {
	            this.validationMessage = '';
	        }
	    }
	};

/***/ }),
/* 263 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: 'InboxConversation',
	
	    data: function data() {
	        return {
	            leaveConversationMode: false,
	            addParticipantFormVisible: false,
	            addedParticipantName: '',
	            addParticipantMessage: '',
	            confirmAddingParticipant: false,
	            addedParticipant: undefined,
	            newReplyContent: ''
	        };
	    },
	    mounted: function mounted() {
	        this.$store.state.inboxPageModel.matchingDevsResponse = [];
	
	        if (this.$store.state.inboxPageModel.retrievedConversations) {
	            this.$store.commit('InboxPage/setSelectedConversation', { conversationId: this.$route.params.id });
	            this.$store.dispatch('InboxPage/getMessages');
	        }
	    },
	
	
	    computed: {
	        conversation: function conversation() {
	            return this.$store.state.inboxPageModel.selectedConversation;
	        },
	        matchingDevsResponse: function matchingDevsResponse() {
	            return this.$store.state.inboxPageModel.matchingDevsResponse;
	        },
	        notAllowedToViewConversation: function notAllowedToViewConversation() {
	            return this.$store.state.inboxPageModel.notAllowedToViewConversation;
	        }
	    },
	
	    methods: {
	        leaveConversation: function leaveConversation() {
	            this.$store.dispatch('InboxPage/leaveConversation');
	        },
	
	
	        getMatchingDevs: _.debounce(function () {
	            this.$store.dispatch('InboxPage/getMatchingDevNames', this.addedParticipantName);
	            this.addParticipantMessage = '';
	        }, 500),
	
	        confirmParticipant: function confirmParticipant(participant) {
	            this.addedParticipant = participant;
	            this.confirmAddingParticipant = true;
	            this.addParticipantFormVisible = false;
	        },
	        addParticipant: function addParticipant() {
	            this.$store.dispatch('InboxPage/addParticipant', this.addedParticipant);
	            this.confirmAddingParticipant = false;
	        },
	        devInAliasList: function devInAliasList(dev) {
	            var foundMatch = false;
	
	            this.conversation.participants.forEach(function (participant) {
	                if (participant.id == dev.id) {
	                    foundMatch = true;
	                }
	            });
	
	            return !foundMatch;
	        },
	        submitReply: function submitReply() {
	            if (this.newReplyContent.trim() === '') {
	                return;
	            }
	
	            this.$store.dispatch('InboxPage/addReplyMessage', this.newReplyContent);
	            this.newReplyContent = '';
	        }
	    },
	
	    sockets: {
	        'inboxConversationMessagesUpdated': function inboxConversationMessagesUpdated(inboxId) {
	            this.$store.dispatch('InboxPage/getMessages', inboxId);
	        }
	    },
	
	    watch: {
	        addedParticipantName: function addedParticipantName() {
	            if (this.addedParticipantName.length >= 3) {
	                this.addParticipantMessage = 'Searching for matching developers...';
	                this.getMatchingDevs();
	            } else {
	                this.addParticipantMessage = 'Enter three or more characters';
	                this.$store.commit('InboxPage/getMatchingDevNames', []);
	            }
	        }
	    }
	};

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _InboxConversation = __webpack_require__(793);
	
	var _InboxConversation2 = _interopRequireDefault(_InboxConversation);
	
	var _InboxCompose = __webpack_require__(792);
	
	var _InboxCompose2 = _interopRequireDefault(_InboxCompose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'InboxHome',
	    metaInfo: {
	        title: 'Develteam | Game Developer Community | Game dev team up'
	    },
	    data: function data() {
	        return {};
	    },
	
	
	    components: {
	        'inbox-conversation': _InboxConversation2.default,
	        'inbox-compose': _InboxCompose2.default
	    },
	
	    computed: {
	        conversations: function conversations() {
	            return this.$store.state.inboxPageModel.conversations;
	        },
	        inboxView: function inboxView() {
	            return this.selectedConversationId === undefined;
	        },
	        composeView: function composeView() {
	            return this.selectedConversationId !== undefined && this.selectedConversationId.toLowerCase() === 'compose';
	        },
	        selectedConversationId: function selectedConversationId() {
	            return this.$route.params.id;
	        },
	        isLoggedIn: function isLoggedIn() {
	            return this.$store.state.loggedUserModel.isLoggedIn;
	        }
	    },
	
	    sockets: {
	        'inboxConversationUpdated': function inboxConversationUpdated(inboxId) {
	            this.$store.dispatch('InboxPage/updateConversation', inboxId);
	        }
	    },
	
	    methods: {}
	};

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'InviteToGame',
	    metaInfo: {
	        title: 'Develteam - Invite a Member to a Game Project | Game developer community | Game dev team up'
	    },
	
	    data: function data() {
	        return {
	            isSaving: false,
	            formErrors: [],
	            showSuccessMessage: false,
	            fetchingMember: true,
	            memberFound: false,
	            foundMember: {},
	            formData: {
	                selectedGame: 0,
	                selectedPositions: [],
	                positionTitles: '',
	                invitedMember: 0
	            }
	        };
	    },
	
	
	    components: {},
	
	    mounted: function mounted() {
	        if (this.$route.params.inviteMemberStringUrl) {
	            this.getDeveloperInfo();
	        } else {
	            this.fetchingMember = false;
	            this.memberFound = false;
	        }
	    },
	
	
	    computed: {
	        isLoggedIn: function isLoggedIn() {
	            return this.$store.state.loggedUserModel.isLoggedIn;
	        },
	        self: function self() {
	            if (this.isLoggedIn) {
	                return this.$store.state.loggedUserModel.info;
	            }
	        },
	        GamesOwned: function GamesOwned() {
	            if (this.isLoggedIn) {
	                return _lodash2.default.filter(this.$store.state.loggedUserModel.games, function (game) {
	                    return game.moderatorLevel === 'owner';
	                });
	            }
	        }
	    },
	
	    methods: {
	        getDeveloperInfo: function getDeveloperInfo() {
	            setTimeout(function () {
	                var _this = this;
	
	                _axios2.default.get('/api/developer', {
	                    params: {
	                        stringUrl: this.$route.params.inviteMemberStringUrl
	                    }
	                }).then(function (response) {
	                    _this.fetchingMember = false;
	
	                    _this.memberFound = !response.data.error;
	
	                    if (!response.data.error) {
	                        _this.foundMember = response.data;
	                        _this.formData.invitedMember = _this.foundMember.id;
	                    }
	                }, function (response) {
	                    _this.fetchingMember = false;
	                });
	            }.bind(this), 1000);
	        },
	        submitInvitation: function submitInvitation() {
	            this.formErrors = [];
	
	            if (this.formData.selectedGame === 0) {
	                this.formErrors.push('Choose a Game to invite this user to');
	            }
	
	            if (this.formData.selectedPositions.length === 0) {
	                this.formErrors.push('Choose at least one position type');
	            }
	
	            if (this.formData.positionTitles.trim() === '') {
	                this.formErrors.push('Enter at least Position Title');
	            }
	
	            if (this.formErrors.length > 0) {
	                return;
	            }
	
	            this.isSaving = true;
	
	            setTimeout(function () {
	                var _this2 = this;
	
	                _axios2.default.post('/api/invites/togame', this.formData).then(function (response) {
	                    _this2.isSaving = false;
	
	                    if (response.data.errors) {
	                        _this2.formErrors = response.data.errors;
	                        return;
	                    }
	
	                    _this2.showSuccessMessage = true;
	                }, function (response) {
	                    _this2.isSaving = false;
	                    _this2.formErrors = ['There was a problem connecting to the server. Please reload and try again.'];
	                });
	            }.bind(this), 1000);
	        }
	    }
	};

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'InvitationToGame',
	    props: ['invitation'],
	    data: function data() {
	        return {
	            isSaving: false,
	            serverResponse: '',
	            formErrors: []
	        };
	    },
	
	
	    components: {},
	
	    mounted: function mounted() {},
	
	
	    computed: {
	        prop: function prop() {
	            return {};
	        }
	    },
	
	    methods: {
	        sendResponse: function sendResponse(inviteResponse) {
	            this.isSaving = true;
	
	            setTimeout(function () {
	                var _this = this;
	
	                _axios2.default.post('/api/invites/respondToGameInvite', {
	                    inviteResponse: inviteResponse,
	                    inviteId: this.invitation.id
	                }).then(function (response) {
	                    _this.isSaving = false;
	
	                    if (response.data.errors) {
	                        _this.formErrors = response.data.errors;
	                        return;
	                    }
	
	                    _this.serverResponse = response.data.inviteResponse === 'accept' ? 'You Accepted this Invitation' : 'You Declined this Invitation';
	                }, function (response) {
	                    _this.isSaving = false;
	                    _this.formErrors = ['There was a problem connecting to the server. Please reload and try again.'];
	                });
	            }.bind(this), 1000);
	        }
	    }
	};

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _InviteToGameItem = __webpack_require__(796);
	
	var _InviteToGameItem2 = _interopRequireDefault(_InviteToGameItem);
	
	var _RequestToJoinItem = __webpack_require__(799);
	
	var _RequestToJoinItem2 = _interopRequireDefault(_RequestToJoinItem);
	
	var _SentRequestToJoinItem = __webpack_require__(801);
	
	var _SentRequestToJoinItem2 = _interopRequireDefault(_SentRequestToJoinItem);
	
	var _SentInviteToGameItem = __webpack_require__(800);
	
	var _SentInviteToGameItem2 = _interopRequireDefault(_SentInviteToGameItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'Invites',
	    metaInfo: {
	        title: 'Develteam | Game Developer Community | Game dev team up'
	    },
	
	    components: {
	        'invitation-to-game': _InviteToGameItem2.default,
	        'request-to-join': _RequestToJoinItem2.default,
	        'sent-invitation-to-game': _SentInviteToGameItem2.default,
	        'sent-request-join': _SentRequestToJoinItem2.default
	    },
	
	    computed: {
	        isLoggedIn: function isLoggedIn() {
	            return this.$store.state.loggedUserModel.isLoggedIn;
	        },
	        gamesOwned: function gamesOwned() {
	            if (this.isLoggedIn) {
	                return _.filter(this.$store.state.loggedUserModel.games, function (game) {
	                    return game.moderatorLevel === 'owner';
	                });
	            }
	        },
	        gamesOwnedIds: function gamesOwnedIds() {
	            if (this.gamesOwned) {
	                return _.map(this.gamesOwned, 'id');
	            }
	        },
	        invitationsToGames: function invitationsToGames() {
	            return this.$store.state.invitesModel.invitationsToGames;
	        },
	        requestsToJoin: function requestsToJoin() {
	            return this.$store.state.invitesModel.requestsToJoin;
	        },
	        sentInvitationsToGames: function sentInvitationsToGames() {
	            return this.$store.state.invitesModel.sentInvitationsToGames;
	        },
	        sentRequestsToJoin: function sentRequestsToJoin() {
	            return this.$store.state.invitesModel.sentRequestsToJoin;
	        },
	        formErrors: function formErrors() {
	            return this.$store.state.invitesModel.fetchErrors;
	        },
	        fetchStatus: function fetchStatus() {
	            return this.$store.state.invitesModel.fetchStatus;
	        },
	        isLoading: function isLoading() {
	            return this.fetchStatus === 'unfetched' || this.fetchStatus === 'fetching';
	        },
	        noPendingInvitations: function noPendingInvitations() {
	            return !this.isLoading && this.invitationsToGames.length === 0 && this.requestsToJoin.length === 0 && this.sentInvitationsToGames.length === 0 && this.sentRequestsToJoin.length === 0;
	        }
	    }
	};

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'RequestToJoin',
	    metaInfo: {
	        title: 'Develteam - Request to Join a Game Project | Game developer community | Game dev team up'
	    },
	    data: function data() {
	        return {
	            isSaving: false,
	            formErrors: [],
	            showSuccessMessage: false,
	            fetchingGame: true,
	            gameFound: false,
	            foundGame: {},
	            formData: {
	                selectedPositions: [],
	                positionTitles: '',
	                requestedGame: 0
	            }
	        };
	    },
	
	
	    components: {},
	
	    mounted: function mounted() {
	        if (this.$route.params.requestGameStringUrl) {
	            this.getDeveloperInfo();
	        } else {
	            this.fetchingGame = false;
	            this.gameFound = false;
	        }
	    },
	
	
	    computed: {
	        isLoggedIn: function isLoggedIn() {
	            return this.$store.state.loggedUserModel.isLoggedIn;
	        },
	        self: function self() {
	            if (this.isLoggedIn) {
	                return this.$store.state.loggedUserModel.info;
	            }
	        },
	        GamesOwned: function GamesOwned() {
	            if (this.isLoggedIn) {
	                return _lodash2.default.filter(this.$store.state.loggedUserModel.games, function (game) {
	                    return game.moderatorLevel === 'owner';
	                });
	            }
	        }
	    },
	
	    methods: {
	        getDeveloperInfo: function getDeveloperInfo() {
	            setTimeout(function () {
	                var _this = this;
	
	                _axios2.default.get('/api/game', {
	                    params: {
	                        stringUrl: this.$route.params.requestGameStringUrl
	                    }
	                }).then(function (response) {
	                    _this.fetchingGame = false;
	
	                    _this.gameFound = !response.data.error;
	
	                    if (!response.data.error) {
	                        _this.foundGame = response.data;
	                        _this.formData.requestedGame = _this.foundGame.id;
	                    }
	                }, function (response) {
	                    _this.fetchingGame = false;
	                });
	            }.bind(this), 1000);
	        },
	        submitRequest: function submitRequest() {
	            this.formErrors = [];
	
	            if (this.formData.selectedPositions.length === 0) {
	                this.formErrors.push('Choose at least one position type');
	            }
	
	            if (this.formData.positionTitles.trim() === '') {
	                this.formErrors.push('Enter at least Position Title');
	            }
	
	            if (this.formErrors.length > 0) {
	                return;
	            }
	
	            this.isSaving = true;
	
	            setTimeout(function () {
	                var _this2 = this;
	
	                _axios2.default.post('/api/invites/frommember', this.formData).then(function (response) {
	                    _this2.isSaving = false;
	
	                    if (response.data.errors) {
	                        _this2.formErrors = response.data.errors;
	                        return;
	                    }
	
	                    _this2.showSuccessMessage = true;
	                }, function (response) {
	                    _this2.isSaving = false;
	                    _this2.formErrors = ['There was a problem connecting to the server. Please reload and try again.'];
	                });
	            }.bind(this), 1000);
	        }
	    }
	};

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'RequestToJoinItem',
	    props: ['request'],
	    data: function data() {
	        return {
	            isSaving: false,
	            serverResponse: '',
	            formErrors: []
	        };
	    },
	
	
	    components: {},
	
	    mounted: function mounted() {},
	
	
	    computed: {
	        prop: function prop() {
	            return {};
	        }
	    },
	
	    methods: {
	        sendResponse: function sendResponse(inviteResponse) {
	            this.isSaving = true;
	
	            setTimeout(function () {
	                var _this = this;
	
	                _axios2.default.post('/api/invites/respondToRequestToJoin', {
	                    inviteResponse: inviteResponse,
	                    inviteId: this.request.id
	                }).then(function (response) {
	                    _this.isSaving = false;
	
	                    if (response.data.errors) {
	                        _this.formErrors = response.data.errors;
	                        return;
	                    }
	
	                    _this.serverResponse = response.data.inviteResponse === 'accept' ? 'You Accepted this request' : 'You Declined this request';
	                }, function (response) {
	                    _this.isSaving = false;
	                    _this.formErrors = ['There was a problem connecting to the server. Please reload and try again.'];
	                });
	            }.bind(this), 1000);
	        }
	    }
	};

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'InvitationToGame',
	    props: ['invitation'],
	    data: function data() {
	        return {
	            isSaving: false,
	            serverResponse: '',
	            formErrors: []
	        };
	    },
	
	
	    components: {},
	
	    mounted: function mounted() {},
	
	
	    computed: {
	        prop: function prop() {
	            return {};
	        }
	    },
	
	    methods: {
	        deleteInvitation: function deleteInvitation(deleteType) {
	            this.isSaving = true;
	
	            setTimeout(function () {
	                var _this = this;
	
	                _axios2.default.post('/api/invites/deleteInvitation', {
	                    inviteId: this.invitation.id
	                }).then(function (response) {
	                    _this.isSaving = false;
	
	                    if (response.data.errors) {
	                        _this.formErrors = response.data.errors;
	                        return;
	                    }
	
	                    _this.serverResponse = deleteType === 'dismiss' ? 'Dismissed' : 'Retracted';
	                }, function (response) {
	                    _this.isSaving = false;
	                    _this.formErrors = ['There was a problem connecting to the server. Please reload and try again.'];
	                });
	            }.bind(this), 1000);
	        }
	    }
	};

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'RequestToJoinItem',
	    props: ['request'],
	    data: function data() {
	        return {
	            isSaving: false,
	            serverResponse: '',
	            formErrors: []
	        };
	    },
	
	
	    components: {},
	
	    mounted: function mounted() {},
	
	
	    computed: {
	        prop: function prop() {
	            return {};
	        }
	    },
	
	    methods: {
	        deleteRequest: function deleteRequest(deleteType) {
	            this.isSaving = true;
	
	            setTimeout(function () {
	                var _this = this;
	
	                _axios2.default.post('/api/invites/deleteRequest', {
	                    requestId: this.request.id
	                }).then(function (response) {
	                    _this.isSaving = false;
	
	                    if (response.data.errors) {
	                        _this.formErrors = response.data.errors;
	                        return;
	                    }
	
	                    _this.serverResponse = deleteType === 'dismiss' ? 'Dismissed' : 'Retracted';
	                }, function (response) {
	                    _this.isSaving = false;
	                    _this.formErrors = ['There was a problem connecting to the server. Please reload and try again.'];
	                });
	            }.bind(this), 1000);
	        }
	    }
	};

/***/ }),
/* 272 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: "PrivacyPolicy"
	};

/***/ }),
/* 273 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: "Terms"
	};

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _validator = __webpack_require__(19);
	
	var _validator2 = _interopRequireDefault(_validator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'ForgotPassword',
	    metaInfo: {
	        title: 'Develteam Recover Your Password | Game developer community | Game dev team up'
	    },
	    data: function data() {
	        return {
	            isSaving: false,
	            email: '',
	            showConfirmation: false,
	            formErrors: []
	        };
	    },
	
	
	    components: {},
	
	    mounted: function mounted() {},
	
	
	    computed: {
	        prop: function prop() {
	            return {};
	        }
	    },
	
	    methods: {
	        sendRecoveryLink: function sendRecoveryLink() {
	
	            this.email = this.email.trim();
	
	            if (!_validator2.default.isEmail(this.email)) {
	                this.formErrors = ['Invalid Email Format'];
	                return;
	            }
	
	            this.isSaving = true;
	            setTimeout(function () {
	                var _this = this;
	
	                _axios2.default.post('/api/forgotPassword', {
	                    email: this.email,
	                    password: this.password
	                }).then(function (response) {
	                    _this.isSaving = false;
	                    if (response.data.errors) {
	                        _this.formErrors = response.data.errors;
	                    } else {
	                        _this.showConfirmation = true;
	                    }
	                }, function (response) {
	                    _this.isSaving = false;
	                    _this.formErrors = ['An unknown problem occurred. Please wait a few minutes and try again.'];
	                });
	            }.bind(this), 500);
	        }
	    }
	};

/***/ }),
/* 275 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: 'LoginPage',
	    metaInfo: {
	        title: 'Develteam | Game Developer Community | Game dev team up'
	    },
	    data: function data() {
	        return {
	            rememberMe: false
	        };
	    },
	
	
	    computed: {
	        email: {
	            get: function get() {
	                return this.$store.state.loginPageModel.email;
	            },
	            set: function set(value) {
	                this.$store.commit('loginPage/updateEmail', value);
	            }
	        },
	        password: {
	            get: function get() {
	                return this.$store.state.loginPageModel.password;
	            },
	            set: function set(value) {
	                this.$store.commit('loginPage/updatePassword', value);
	            }
	        },
	        remember: function remember() {
	            return this.$store.state.loginPageModel.rememberMe;
	        },
	        validationMessage: function validationMessage() {
	            return this.$store.state.loginPageModel.validationMessage;
	        },
	        isLoggedIn: function isLoggedIn() {
	            return this.$store.state.loggedUserModel.isLoggedIn;
	        }
	    },
	
	    methods: {
	        submit: function submit(e) {
	            var self = this;
	
	            this.$store.dispatch('loginPage/validateLogin', function (user) {
	                self.$socket.emit("setUserSocketData", user);
	            });
	        }
	    }
	};

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'UpdatePassword',
	    metaInfo: {
	        title: 'Develteam - Update Your Password | Game developer community | Game dev team up'
	    },
	
	    data: function data() {
	        return {
	            isLoading: true,
	            isSaving: false,
	            formErrors: [],
	            keycodeErrors: [],
	            recoveryEmail: '',
	            newPassword: '',
	            newPasswordVerify: '',
	            showConfirmation: false
	        };
	    },
	
	
	    components: {},
	
	    mounted: function mounted() {
	        this.getKeycodeData();
	    },
	
	
	    computed: {
	        keycode: function keycode() {
	            return this.$route.params.keycode;
	        }
	    },
	
	    methods: {
	        getKeycodeData: function getKeycodeData() {
	            setTimeout(function () {
	                var _this = this;
	
	                _axios2.default.get('/api/forgotPassword', {
	                    params: {
	                        keycode: this.keycode
	                    }
	                }).then(function (response) {
	                    _this.isLoading = false;
	
	                    if (response.data.errors) {
	                        _this.keycodeErrors = response.data.errors;
	                    } else {
	                        _this.recoveryEmail = response.data.email;
	                    }
	
	                    console.log(response.data);
	                }, function (response) {});
	            }.bind(this), 1000);
	        },
	        submitUpdatedPassword: function submitUpdatedPassword() {
	            if (this.newPassword === '') {
	                this.formErrors = ['Enter a Password'];
	                return;
	            }
	
	            if (this.newPassword !== this.newPasswordVerify) {
	                this.formErrors = ['Your passwords do not match'];
	                return;
	            }
	
	            this.isSaving = true;
	
	            setTimeout(function () {
	                var _this2 = this;
	
	                _axios2.default.post('/api/forgotPassword/recover', {
	                    keycode: this.keycode,
	                    password: this.newPassword
	                }).then(function (response) {
	                    _this2.isSaving = false;
	                    if (response.data.errors) {
	                        _this2.formErrors = response.data.errors;
	                    } else {
	                        _this2.showConfirmation = true;
	                    }
	                }, function (response) {
	                    _this2.isSaving = false;
	                    _this2.formErrors = ['An unknown problem occurred. Please wait a few minutes and try again.'];
	                });
	            }.bind(this), 1000);
	        }
	    }
	};

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _FeedGroupPost = __webpack_require__(137);
	
	var _FeedGroupPost2 = _interopRequireDefault(_FeedGroupPost);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'HomeFeedPage',
	    metaInfo: {
	        title: 'Develteam | Game Developer Community | Game dev team up'
	    },
	
	    data: function data() {
	        return {
	            feedPostsId: 'mediaFeed'
	        };
	    },
	
	
	    components: {
	        'group-post': _FeedGroupPost2.default
	    },
	
	    mounted: function mounted() {
	        if ((0, _keys2.default)(this.feedPosts).length === 0) {
	            this.getPosts();
	        }
	
	        this.$store.dispatch('loggedUserModel/CatchUpOnMedia');
	    },
	
	
	    computed: {
	        layout: function layout() {
	            return 'masonry';
	
	            if (!this.isLoggedIn) {
	                return 'masonry';
	            }
	
	            return this.$store.state.loggedUserModel.options.feedLayoutStyle;
	        },
	        feedPosts: function feedPosts() {
	            var feedData = this.$store.state.feedPostsModel.feedPosts[this.feedPostsId],
	                feedPostArray = void 0,
	                outputArray = [];
	
	            if (!feedData) {
	                return [];
	            }
	
	            feedPostArray = _lodash2.default.values(feedData.posts).sort(function (a, b) {
	                var aDate = new Date(a.postDate),
	                    bDate = new Date(b.postDate);
	
	                return bDate - aDate;
	            });
	
	            for (var i = 0; i < feedPostArray.length; i++) {
	                var streakCount = 0,
	                    j = i,
	                    groupPost = [];
	
	                if (!feedPostArray[j].subPosterDetails) {
	                    feedPostArray[j].subPosterDetails = {};
	                }
	
	                while (j < feedPostArray.length - 1 && feedPostArray[j].subPosterType === feedPostArray[j + 1].subPosterType && feedPostArray[j].type === 'media' && feedPostArray[j + 1].type === 'media' && (feedPostArray[j].subPosterType === 'developer' && feedPostArray[j].posterDetails.id === feedPostArray[j + 1].posterDetails.id || feedPostArray[j].subPosterType !== 'developer' && feedPostArray[j].subPosterDetails.id === feedPostArray[j + 1].subPosterDetails.id)) {
	                    streakCount++;
	                    j++;
	                }
	
	                if (streakCount > 0) {
	                    streakCount++;
	                    groupPost = {
	                        type: 'groupPost',
	                        posts: []
	                    };
	
	                    for (var k = 0; k < streakCount; k++) {
	                        groupPost.posts.push(feedPostArray[k + i]);
	                    }
	
	                    outputArray.push(groupPost);
	                    i += streakCount;
	                    i--;
	                } else {
	                    outputArray.push({ type: 'singlePost', post: feedPostArray[i] });
	                }
	            }
	
	            return outputArray;
	        },
	        fetchingStatus: function fetchingStatus() {
	            var developerFeedData = this.$store.state.feedPostsModel.feedPosts[this.feedPostsId];
	            return developerFeedData ? developerFeedData.fetchingStatus : 'fetching';
	        },
	        gotInitialLoggedUserInfo: function gotInitialLoggedUserInfo() {
	            return this.$store.state.loggedUserModel.gotInitialLoggedUserInfo;
	        },
	        isLoggedIn: function isLoggedIn() {
	            return this.$store.state.loggedUserModel.isLoggedIn;
	        },
	        hasFetchedAll: function hasFetchedAll() {
	            var developerFeedData = this.$store.state.feedPostsModel.feedPosts[this.feedPostsId];
	            return developerFeedData ? developerFeedData.hasFetchedAll : true;
	        },
	        hasLoginCookies: function hasLoginCookies() {
	            var cookieEntries = document.cookie.split(';');
	            var cookies = {};
	
	            cookieEntries.forEach(function (cookie) {
	                var cookieSegments = cookie.split('=');
	                if (cookieSegments.length === 2 && cookieSegments[1].trim() !== '') {
	                    cookies[cookieSegments[0].trim()] = cookieSegments[1].trim();
	                }
	            });
	
	            return cookies.userid !== undefined && cookies.password !== undefined;
	        }
	    },
	
	    methods: {
	        getPosts: function getPosts() {
	            this.$store.dispatch('feedPosts/getMediaFeedPosts', {
	                feedPostsId: this.feedPostsId,
	                feedType: 'home',
	                limit: 20
	            });
	        },
	        changeLayout: function changeLayout(style) {
	            if (!this.isLoggedIn) {
	                return;
	            }
	
	            this.$set(this.$store.state.loggedUserModel.options, 'feedLayoutStyle', style);
	
	            _axios2.default.post('/api/userOptions/updateFeedLayoutStyle', {
	                style: style
	            });
	        }
	    }
	};

/***/ }),
/* 278 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: 'NotificationsPage',
	    data: function data() {
	        return {};
	    },
	
	
	    components: {},
	
	    mounted: function mounted() {},
	
	
	    computed: {
	        notifications: function notifications() {
	            return this.$store.state.notificationsModel.notifications;
	        },
	        notificationsFetchingStatus: function notificationsFetchingStatus() {
	            return this.$store.state.notificationsModel.fetchingStatus;
	        }
	    },
	
	    methods: {}
	};

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vueGlobalEventBus = __webpack_require__(10);
	
	var _vueGlobalEventBus2 = _interopRequireDefault(_vueGlobalEventBus);
	
	var _underscore = __webpack_require__(65);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: "OnlineUsers",
	
	    data: function data() {
	        return {};
	    },
	
	
	    computed: {
	        isLoggedIn: function isLoggedIn() {
	            return this.$store.state.loggedUserModel.isLoggedIn;
	        },
	        loggedUser: function loggedUser() {
	            return this.isLoggedIn ? this.$store.state.loggedUserModel.info : undefined;
	        },
	        onlineUserList: function onlineUserList() {
	            var onlineUsers = this.$store.state.onlineUsersModel.onlineUsers;
	
	            onlineUsers = _underscore2.default.sortBy(onlineUsers, function (user) {
	                return user.alias;
	            });
	
	            return onlineUsers;
	        }
	    },
	
	    methods: {
	        openConversation: function openConversation(user) {
	            _vueGlobalEventBus2.default.$emit('privateChatOpenConversation', user);
	        }
	    },
	
	    mounted: function mounted() {}
	};

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _underscore = __webpack_require__(65);
	
	var _underscore2 = _interopRequireDefault(_underscore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: "PrivateChat",
	
	    data: function data() {
	        return {
	            newMessage: '',
	            showingHistoryDates: false,
	            selectedHistoryDate: undefined,
	            showingHistoryDateMessages: false,
	            newConversationMode: false,
	            newConversationParticipantId: undefined,
	            newConversationAlias: undefined
	        };
	    },
	
	
	    computed: {
	        conversations: function conversations() {
	            var conversations = this.$store.state.privateChatModel.conversations;
	
	            conversations = _underscore2.default.sortBy(conversations, function (conversation) {
	                return -conversation.lastMessageTime;
	            });
	
	            conversations = _underscore2.default.sortBy(conversations, function (conversation) {
	                return conversation.hasBeenRead;
	            });
	
	            return conversations;
	        },
	        messages: function messages() {
	            var messageGroups = [];
	            var messages = [];
	            if (!this.selectedConversation || !this.selectedConversation.chatId || !this.$store.state.privateChatModel.messages[this.selectedConversation.chatId]) {
	                return messages;
	            }
	
	            messages = this.$store.state.privateChatModel.messages[this.selectedConversation.chatId];
	
	            if (this.showingHistoryDateMessages) {
	                messages = this.$store.state.privateChatModel.historyMessages[this.selectedConversation.chatId + "_" + this.selectedHistoryDate.day] || [];
	            }
	
	            for (var i = 0; i < messages.length; i++) {
	                if (i > 0 && messages[i].from.id === messages[i - 1].from.id && messages[i].from.id !== null) {
	                    messageGroups[messageGroups.length - 1].messages.push(messages[i]);
	                } else {
	                    messageGroups.push({
	                        from: messages[i].from,
	                        timestamp: messages[i].timestamp,
	                        messages: [messages[i]]
	                    });
	                }
	            }
	
	            return messageGroups;
	        },
	        selectedConversation: function selectedConversation() {
	            return this.$store.state.privateChatModel.selectedConversation;
	        },
	        audioNotificationsEnabled: function audioNotificationsEnabled() {
	            return this.$store.state.loggedUserModel.options.chatroomNotificationSound === 'on';
	        },
	        historyDates: function historyDates() {
	            return this.$store.state.privateChatModel.historyDates[this.selectedConversation.chatId] || [];
	        }
	    },
	
	    methods: {
	        showNotification: function showNotification(conversation) {
	            var isUnread = !conversation.hasBeenRead;
	            var hasOpenConversation = this.selectedConversation;
	            var isActiveConversation = hasOpenConversation ? conversation.chatId === this.selectedConversation.chatId : false;
	
	            return isUnread && !isActiveConversation;
	        },
	        sendMessage: function sendMessage() {
	            this.newMessage = this.newMessage.trim();
	
	            if (this.newMessage === '') {
	                return;
	            }
	
	            this.$store.dispatch('privateChat/sendMessage', {
	                chatId: this.selectedConversation.chatId,
	                message: this.newMessage
	            });
	
	            this.newMessage = '';
	        },
	        selectConversation: function selectConversation(conversation) {
	            var self = this;
	
	            this.$store.dispatch('privateChat/getMessages', {
	                chatId: conversation.chatId,
	                callback: function callback() {
	                    self.showingHistoryDates = false;
	                    self.$store.commit('privateChat/setActiveConversation', conversation);
	                    self.$store.dispatch('privateChat/markReadConversation', conversation);
	                    self.scrollDownMessages();
	                }
	            });
	        },
	        scrollDownMessages: function scrollDownMessages() {
	            this.$nextTick(function () {
	                if (this.$refs.chatMessages) {
	                    this.$refs.chatMessages.scrollTop = this.$refs.chatMessages.scrollHeight;
	                }
	            });
	        },
	        toggleAudioNotifications: function toggleAudioNotifications(state) {
	            this.$set(this.$store.state.loggedUserModel.options, 'chatroomNotificationSound', state);
	
	            _axios2.default.post('/api/userOptions/updateChatroomNotificationSound', {
	                state: state
	            });
	        },
	        toggleHistoryDates: function toggleHistoryDates() {
	            if (this.showingHistoryDates || this.showingHistoryDateMessages) {
	                this.showingHistoryDates = false;
	            } else {
	                this.showHistoryDates();
	            }
	
	            this.showingHistoryDateMessages = false;
	            this.selectedHistoryDate = undefined;
	        },
	        showHistoryDates: function showHistoryDates() {
	            this.showingHistoryDates = true;
	            this.$store.dispatch('privateChat/getHistoryDates');
	        },
	        selectHistoryDate: function selectHistoryDate(historyDate) {
	            var self = this;
	
	            this.$store.dispatch('privateChat/getHistoryForDate', {
	                selectedHistoryDate: historyDate, callback: function callback() {
	                    self.selectedHistoryDate = historyDate;
	                    self.showingHistoryDates = false;
	                    self.showingHistoryDateMessages = true;
	                }
	            });
	        },
	        createNewConversation: function createNewConversation(participant) {
	            this.newConversationMode = true;
	            this.newConversationParticipantId = participant.id;
	            this.newConversationAlias = participant.alias;
	        },
	        sendNewConversationMessage: function sendNewConversationMessage() {
	            this.newMessage = this.newMessage.trim();
	
	            if (this.newMessage === '') {
	                return;
	            }
	
	            this.$store.dispatch('privateChat/sendNewConversation', {
	                participantId: this.newConversationParticipantId,
	                message: this.newMessage,
	                callback: function callback(response) {}
	            });
	
	            this.newMessage = '';
	            this.newConversationMode = false;
	        },
	        getMatchingConversation: function getMatchingConversation(userAId, userBId) {
	            var conversationIdA = userAId + '.' + userBId;
	            var conversationIdB = userBId + '.' + userAId;
	            var matchingConversation = undefined;
	
	            _underscore2.default.each(this.$store.state.privateChatModel.conversations, function (conversation) {
	                if (conversation.chatId === conversationIdA || conversation.chatId === conversationIdB) {
	                    matchingConversation = conversation;
	                }
	            });
	
	            return matchingConversation;
	        }
	    },
	
	    sockets: {
	        'receivedPrivateChatMessage': function receivedPrivateChatMessage(data) {
	            if (this.selectedConversation && this.selectedConversation.chatId === data.chatId) {
	                this.$store.dispatch('privateChat/markReadConversation', this.selectedConversation);
	            }
	        }
	    },
	
	    watch: {
	        'messages': function messages() {
	            var shouldScroll = this.$refs.chatMessages && this.$refs.chatMessages.scrollTop >= this.$refs.chatMessages.scrollHeight - this.$refs.chatMessages.clientHeight;
	
	            if (shouldScroll) {
	                this.scrollDownMessages();
	            }
	        }
	    },
	
	    mounted: function mounted() {
	        this.scrollDownMessages();
	
	        if (this.selectedConversation && this.selectedConversation.chatId) {
	            this.$store.dispatch('privateChat/markReadConversation', this.selectedConversation);
	        }
	    }
	};

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _validator = __webpack_require__(19);
	
	var _validator2 = _interopRequireDefault(_validator);
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'Register',
	    metaInfo: {
	        title: 'Develteam | Game Developer Community | Game dev team up',
	        script: [{ src: 'https://www.google.com/recaptcha/api.js' }]
	    },
	    data: function data() {
	        return {
	            isSaving: false,
	            formErrors: [],
	            alias: '',
	            aliasHasError: false,
	            email: '',
	            emailVerify: '',
	            emailHasError: false,
	            password: '',
	            passwordVerify: '',
	            passwordHasError: false,
	            rcapt_sig_key: '6LdvOxcUAAAAAGi4eOcWZgw-IyPy9zAAWpFX3ReC'
	
	        };
	    },
	
	
	    components: {},
	
	    mounted: function mounted() {},
	
	
	    computed: {
	        loggedUser: function loggedUser() {
	            if (this.$store.state.loggedUserModel.isLoggedIn) {
	                return this.$store.state.loggedUserModel.info;
	            } else {
	                {}
	            }
	        },
	        successfullyRegistered: function successfullyRegistered() {
	            return this.$store.state.loggedUserModel.isLoggedIn;
	        }
	    },
	
	    methods: {
	        submit: function submit() {
	            var recaptchaResponse = void 0;
	
	            if (window.grecaptcha) {
	                recaptchaResponse = window.grecaptcha.getResponse(0);
	            }
	
	            this.formErrors = [];
	
	            if (this.alias.trim() === '') {
	                this.formErrors.push('Enter a Screen Name');
	                this.aliasHasError = true;
	            }
	
	            this.email = this.email.trim();
	            this.emailVerify = this.emailVerify.trim();
	
	            if (!_validator2.default.isEmail(this.email)) {
	                this.formErrors.push('Enter a Valid Email Address');
	                this.emailHasError = true;
	            }
	
	            if (!_validator2.default.isEmail(this.email)) {
	                this.formErrors.push('Enter a Valid Email Address');
	                this.emailHasError = true;
	            }
	
	            if (this.email.toLowerCase() !== this.emailVerify.toLowerCase()) {
	                this.formErrors.push('Emails do not match');
	                this.emailHasError = true;
	            }
	
	            if (this.password === '') {
	                this.formErrors.push('Enter a Password');
	                this.passwordHasError = true;
	            }
	
	            if (this.password !== this.passwordVerify) {
	                this.formErrors.push('Passwords do not match');
	                this.passwordHasError = true;
	            }
	
	            if (this.formErrors.length > 0) {
	                return;
	            }
	
	            this.isSaving = true;
	
	            setTimeout(function () {
	                var _this = this;
	
	                _axios2.default.post('/api/registerAccount', {
	                    alias: this.alias,
	                    email: this.email,
	                    password: this.password,
	                    recaptchaResponse: recaptchaResponse
	                }).then(function (response) {
	                    if (response.data.errors) {
	                        _this.isSaving = false;
	                        _this.formErrors = response.data.errors;
	                    } else {
	                        _this.$store.dispatch('loggedUserModel/getLoggedUserInfo', function (user) {
	                            this.$socket.emit("setUserSocketData", user);
	                        }.bind(_this));
	                    }
	                }, function (response) {
	                    _this.formErrors = ['An unknown problem occurred. Please wait a few minutes and try again.'];
	                });
	            }.bind(this), 500);
	        }
	    }
	};

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _validator = __webpack_require__(19);
	
	var _validator2 = _interopRequireDefault(_validator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    name: 'ResourcesPage',
	    data: function data() {
	        return {
	            addResourceCategory: 'assets',
	            addResourceSectionAssets: 'graphics',
	            addResourceSectionDevtools: 'collaboration',
	            addResourceWebsiteName: '',
	            addResourceWebsiteUrl: '',
	            addResourceWebsiteNameInvalid: false,
	            addResourceWebsiteUrlInvalid: false
	        };
	    },
	    mounted: function mounted() {
	        if (this.resources.length === 0) {
	            this.$store.dispatch('resourcesPage/populateResources');
	        }
	    },
	
	
	    computed: {
	        resources: function resources() {
	            var resources = this.$store.state.resourcesPageModel.resources;
	
	            if (resources.length > 0) {
	                this.setSelected(resources);
	            }
	
	            return resources;
	        },
	        showSubmitResourceForm: function showSubmitResourceForm() {
	            return this.$store.state.loggedUserModel.isLoggedIn;
	        }
	    },
	
	    methods: {
	        addResource: function addResource(e) {
	            var addedResourceData = {
	                category: this.addResourceCategory,
	                websiteName: this.addResourceWebsiteName,
	                websiteUrl: this.addResourceWebsiteUrl
	            };
	
	            if (this.addResourceCategory === 'assets') {
	                addedResourceData.section = this.addResourceSectionAssets;
	            } else {
	                addedResourceData.section = this.addResourceSectionDevtools;
	            }
	
	            if (this.addResourceWebsiteName.trim().length === 0) {
	                this.addResourceWebsiteNameInvalid = true;
	            }
	
	            if (this.addResourceWebsiteUrl.trim().length === 0 || !_validator2.default.isURL(this.addResourceWebsiteUrl)) {
	                this.addResourceWebsiteUrlInvalid = true;
	            }
	
	            if (!/^(?:f|ht)tps?\:\/\//.test(this.addResourceWebsiteUrl)) {
	                this.addResourceWebsiteUrl = "http://" + this.addResourceWebsiteUrl;
	            }
	
	            if (!this.addResourceWebsiteNameInvalid && !this.addResourceWebsiteUrlInvalid) {
	                this.$store.dispatch('resourcesPage/submitResource', addedResourceData);
	            }
	
	            e.preventDefault();
	        },
	
	
	        setSelected: function setSelected(resources) {
	            var self = this,
	                path = self.$route.path.substring(1).split('/'),
	                selectedResourceIndex = -1,
	                selectedSectionIndex = -1;
	
	            if (!path[1]) {
	                path[1] = '';
	            }
	
	            if (!path[2]) {
	                path[2] = '';
	            }
	
	            resources.forEach(function (resource, index) {
	                self.$set(resource, 'selected', path[1].toLowerCase() === resource.id.toLowerCase());
	
	                if (resource.selected) {
	                    selectedResourceIndex = index;
	                }
	
	                resource.sections.forEach(function (section, index) {
	                    self.$set(section, 'selected', resource.selected && path[2].toLowerCase() === section.id.toLowerCase());
	
	                    if (section.selected) {
	                        selectedSectionIndex = index;
	                    }
	                });
	            });
	
	            if (selectedResourceIndex === -1) {
	                self.$set(resources[0], 'selected', true);
	                selectedResourceIndex = 0;
	            }
	
	            if (selectedSectionIndex === -1) {
	                self.$set(resources[selectedResourceIndex].sections[0], 'selected', true);
	                selectedResourceIndex = 0;
	            }
	        }
	
	    }
	};

/***/ }),
/* 283 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    name: "TheBoardPage",
	
	    data: function data() {
	        return {
	            sortTypes: [{
	                label: 'Hot',
	                icon: 'fas fa-fire'
	            }, {
	                label: 'New',
	                icon: 'fas fa-certificate'
	            }, {
	                label: 'Top',
	                icon: 'fas fa-chart-bar'
	            }],
	            sortModeIndex: 0,
	            posts: [{
	                title: 'Who likes stuff I like',
	                created: 'Jan 28, 2021',
	                updated: 'Jan 30, 2021',
	                authorStringUrl: 'Garmy',
	                authorAlias: 'Garmy',
	                commentCount: 38,
	                Votes: 38
	            }]
	        };
	    },
	
	
	    methods: {
	        setSortModeIndex: function setSortModeIndex(index) {
	            this.sortModeIndex = index;
	        }
	    }
	
	};

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _vue = __webpack_require__(4);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var publicFeeds = ['blogFeed', 'mediaFeed', 'classifiedsFeed'];
	
	exports.default = {
	    state: {
	        feedPosts: {}
	    },
	
	    actions: {
	        'feedPosts/getFeedPosts': function feedPostsGetFeedPosts(context, data) {
	            context.commit('feedPosts/initializeDeveloperFeedData', data);
	            context.commit('feedPosts/setFetchingStatus', { feedPostsId: data.feedPostsId, status: 'fetching' });
	
	            _axios2.default.get('/api/feedPosts', {
	                params: {
	                    feedType: data.feedType,
	                    feedId: data.feedId,
	                    startResult: context.state.feedPosts[data.feedPostsId] ? (0, _keys2.default)(context.state.feedPosts[data.feedPostsId].posts).length : 0,
	                    limit: data.limit || 10,
	                    direction: 'desc'
	                }
	            }).then(function (response) {
	                context.commit('feedPosts/setFeedPosts', {
	                    posts: response.data,
	                    feedPostsId: data.feedPostsId,
	                    limitFetched: 10
	                });
	                context.commit('feedPosts/setFetchingStatus', { feedPostsId: data.feedPostsId, status: 'fetched' });
	            });
	        },
	
	        'feedPosts/getMediaFeedPosts': function feedPostsGetMediaFeedPosts(context, data) {
	            context.commit('feedPosts/initializeDeveloperFeedData', data);
	            context.commit('feedPosts/setFetchingStatus', { feedPostsId: data.feedPostsId, status: 'fetching' });
	
	            _axios2.default.get('/api/feedPosts', {
	                params: {
	                    feedType: data.feedType,
	                    feedId: data.feedId,
	                    startResult: context.state.feedPosts[data.feedPostsId] ? (0, _keys2.default)(context.state.feedPosts[data.feedPostsId].posts).length : 0,
	                    limit: data.limit || 10,
	                    postType: 'media',
	                    direction: 'desc'
	                }
	            }).then(function (response) {
	                context.commit('feedPosts/setFeedPosts', {
	                    posts: response.data,
	                    feedPostsId: data.feedPostsId,
	                    limitFetched: 10
	                });
	                context.commit('feedPosts/setFetchingStatus', { feedPostsId: data.feedPostsId, status: 'fetched' });
	            });
	        },
	
	        'feedPosts/getBlogFeedPosts': function feedPostsGetBlogFeedPosts(context, data) {
	            context.commit('feedPosts/initializeDeveloperFeedData', data);
	            context.commit('feedPosts/setFetchingStatus', { feedPostsId: data.feedPostsId, status: 'fetching' });
	
	            _axios2.default.get('/api/feedPosts', {
	                params: {
	                    feedType: data.feedType,
	                    feedId: data.feedId,
	                    startResult: context.state.feedPosts[data.feedPostsId] ? (0, _keys2.default)(context.state.feedPosts[data.feedPostsId].posts).length : 0,
	                    limit: data.limit || 10,
	                    postType: 'blog',
	                    direction: 'desc'
	                }
	            }).then(function (response) {
	                context.commit('feedPosts/setFeedPosts', {
	                    posts: response.data,
	                    feedPostsId: data.feedPostsId,
	                    limitFetched: 10
	                });
	                context.commit('feedPosts/setFetchingStatus', { feedPostsId: data.feedPostsId, status: 'fetched' });
	            });
	        },
	
	        'feedPosts/getClassifiedsFeedPosts': function feedPostsGetClassifiedsFeedPosts(context, data) {
	            context.commit('feedPosts/initializeDeveloperFeedData', data);
	            context.commit('feedPosts/setFetchingStatus', { feedPostsId: data.feedPostsId, status: 'fetching' });
	
	            _axios2.default.get('/api/feedPosts', {
	                params: {
	                    feedType: data.feedType,
	                    feedId: data.feedId,
	                    startResult: context.state.feedPosts[data.feedPostsId] ? (0, _keys2.default)(context.state.feedPosts[data.feedPostsId].posts).length : 0,
	                    limit: data.limit || 10,
	                    postType: 'classifieds',
	                    direction: 'desc'
	                }
	            }).then(function (response) {
	                context.commit('feedPosts/setFeedPosts', {
	                    posts: response.data,
	                    feedPostsId: data.feedPostsId,
	                    limitFetched: 10
	                });
	                context.commit('feedPosts/setFetchingStatus', { feedPostsId: data.feedPostsId, status: 'fetched' });
	            });
	        },
	
	        'feedPosts/getSingleFeedPost': function feedPostsGetSingleFeedPost(context, data) {
	            context.commit('feedPosts/initializeDeveloperFeedData', data);
	            context.commit('feedPosts/setFetchingStatus', { feedPostsId: data.feedPostsId, status: 'fetching' });
	
	            _axios2.default.get('/api/feedPosts/' + data.postId, {
	                params: {
	                    feedType: data.feedType,
	                    feedId: data.feedId
	                }
	            }).then(function (response) {
	                if (response.data.parentType === data.feedType && response.data.parentId === data.feedId) {
	                    context.commit('feedPosts/setFeedPosts', {
	                        posts: [response.data],
	                        feedPostsId: data.feedPostsId,
	                        limitFetched: 10
	                    });
	                }
	
	                context.commit('feedPosts/setFetchingStatus', { feedPostsId: data.feedPostsId, status: 'fetched' });
	            });
	        },
	
	        'feedPosts/postNewPost': function feedPostsPostNewPost(context, data) {
	            _axios2.default.post('/api/feedPosts', {
	                subject: data.subject,
	                content: data.content,
	                postParentType: data.parentType,
	                postParentId: data.parentId,
	                type: data.type
	            });
	        },
	
	        'feedPosts/editPostContent': function feedPostsEditPostContent(context, postData) {
	            _axios2.default.post('/api/feedPosts/edit', {
	                postId: postData.id,
	                title: postData.title,
	                content: postData.content
	            });
	        },
	
	        'feedPosts/deletePost': function feedPostsDeletePost(context, commentData) {
	            _axios2.default.post('/api/feedPosts/delete', {
	                postId: commentData.id
	            });
	        },
	
	        'feedPosts/pinPost': function feedPostsPinPost(context, data) {
	            _axios2.default.post('/api/feedPosts/togglePin', {
	                postId: data.id
	            });
	        },
	
	        'feedPosts/getComments': function feedPostsGetComments(context, postData) {
	            var isMediaPost = postData.type === 'media';
	
	            _axios2.default.get('/api/feedPosts/comments', {
	                params: {
	                    postId: isMediaPost ? postData.mediaData.id : postData.id,
	                    isMediaPost: isMediaPost
	                }
	            }).then(function (response) {
	                context.commit('feedPosts/setComments', { postData: postData, comments: response.data });
	            });
	        },
	
	        'feedPosts/addComment': function feedPostsAddComment(context, data) {
	            var isMediaPost = data.post.type === 'media',
	                postAsType = data.postAs.split('|')[0],
	                postAsId = data.postAs.split('|')[1];
	
	            _axios2.default.post('/api/feedPosts/comments', {
	                content: data.content,
	                parentId: isMediaPost ? data.post.mediaData.id : data.post.id,
	                postAsType: postAsType,
	                postAsId: postAsId,
	                isMediaPost: isMediaPost
	            });
	        },
	
	        'feedPosts/editCommentContent': function feedPostsEditCommentContent(context, commentData) {
	            _axios2.default.post('/api/feedPosts/edit', {
	                content: commentData.content,
	                postId: commentData.id
	            });
	        },
	
	        'feedPosts/deleteComment': function feedPostsDeleteComment(context, commentData) {
	            _axios2.default.post('/api/feedPosts/delete', {
	                postId: commentData.id
	            });
	        }
	    },
	
	    mutations: {
	        'feedPosts/initializeDeveloperFeedData': function feedPostsInitializeDeveloperFeedData(state, data) {
	            if (!state.feedPosts[data.feedPostsId]) {
	                _vue2.default.set(state.feedPosts, data.feedPostsId, {
	                    posts: {},
	                    fetchingStatus: 'unfetched',
	                    hasFetchedAll: false
	                });
	            }
	        },
	
	        'feedPosts/setFetchingStatus': function feedPostsSetFetchingStatus(state, data) {
	            _vue2.default.set(state.feedPosts[data.feedPostsId], 'fetchingStatus', data.status);
	        },
	
	        'feedPosts/setFeedPosts': function feedPostsSetFeedPosts(state, data) {
	            if (data.posts.length < data.limitFetched) {
	                _vue2.default.set(state.feedPosts[data.feedPostsId], 'hasFetchedAll', true);
	            }
	
	            data.posts.forEach(function (post) {
	                _vue2.default.set(state.feedPosts[data.feedPostsId].posts, post.id, post);
	                _vue2.default.set(state.feedPosts[data.feedPostsId].posts[post.id], 'comments', {});
	            });
	        },
	
	        'feedPosts/appendPost': function feedPostsAppendPost(state, data) {
	            var feedPostsId = data.subPosterType + '.' + data.parentId;
	
	            if (state.feedPosts[feedPostsId]) {
	                _vue2.default.set(state.feedPosts[feedPostsId].posts, data.id, data);
	                _vue2.default.set(state.feedPosts[feedPostsId].posts[data.id], 'comments', {});
	            }
	
	            publicFeeds.forEach(function (feed) {
	                if (state.feedPosts[feed]) {
	                    var shouldAppendToThisFeed = feed === 'blogFeed' && data.type === 'status' || feed === 'mediaFeed' && data.type === 'media' || feed === 'classifiedsFeed' && data.type === 'classifieds';
	
	                    if (shouldAppendToThisFeed) {
	                        _vue2.default.set(state.feedPosts[feed].posts, data.id, data);
	                        _vue2.default.set(state.feedPosts[feed].posts[data.id], 'comments', {});
	                    }
	                }
	            });
	        },
	
	        'feedPosts/updatePost': function feedPostsUpdatePost(state, data) {
	            var feedPostsId = data.subPosterType + '.' + data.parentId;
	
	            if (state.feedPosts[feedPostsId] && state.feedPosts[feedPostsId].posts[data.id]) {
	                _vue2.default.set(state.feedPosts[feedPostsId].posts, data.id, data);
	            }
	
	            publicFeeds.forEach(function (feed) {
	                if (state.feedPosts[feed] && state.feedPosts[feed].posts[data.id]) {
	                    _vue2.default.set(state.feedPosts[feed].posts, data.id, data);
	                }
	            });
	        },
	
	        'feedPosts/deletePost': function feedPostsDeletePost(state, data) {
	            var feedPostsId = data.subPosterType + '.' + data.parentId;
	
	            if (state.feedPosts[feedPostsId] && state.feedPosts[feedPostsId].posts[data.id]) {
	                _vue2.default.delete(state.feedPosts[feedPostsId].posts, data.id);
	            }
	
	            publicFeeds.forEach(function (feed) {
	                if (state.feedPosts[feed] && state.feedPosts[feed].posts[data.id]) {
	                    _vue2.default.delete(state.feedPosts[feed].posts, data.id);
	                }
	            });
	        },
	
	        'feedPosts/pinnedPost': function feedPostsPinnedPost(state, data) {
	            var feedPostsId = data.subPosterType + '.' + data.parentId;
	
	            if (state.feedPosts[feedPostsId] && state.feedPosts[feedPostsId].posts[data.id]) {
	                _vue2.default.set(state.feedPosts[feedPostsId].posts[data.id], 'isPinned', data.isPinned);
	            }
	
	            publicFeeds.forEach(function (feed) {
	                if (state.feedPosts[feed] && state.feedPosts[feed].posts[data.id]) {
	                    _vue2.default.set(state.feedPosts[feed].posts[data.id], 'isPinned', data.isPinned);
	                }
	            });
	        },
	
	        'feedPosts/setComments': function feedPostsSetComments(state, data) {
	            var feedPostsId = void 0,
	                postId = data.postData.id;
	
	            if (data.postData.subPosterType === 'developer') {
	                feedPostsId = data.postData.subPosterType + '.' + data.postData.posterDetails.id;
	            }
	
	            if (data.postData.subPosterType === 'game') {
	                feedPostsId = data.postData.subPosterType + '.' + data.postData.subPosterDetails.id;
	            }
	
	            data.comments.forEach(function (comment) {
	                if (state.feedPosts[feedPostsId] && state.feedPosts[feedPostsId].posts[postId]) {
	                    _vue2.default.set(state.feedPosts[feedPostsId].posts[postId].comments, comment.id, comment);
	                }
	
	                publicFeeds.forEach(function (feed) {
	                    if (state.feedPosts[feed] && state.feedPosts[feed].posts[postId]) {
	                        _vue2.default.set(state.feedPosts[feed].posts[postId].comments, comment.id, comment);
	                    }
	                });
	            });
	        },
	
	        'feedPosts/appendComment': function feedPostsAppendComment(state, data) {
	            var feedPostsId = data.parentData.parentType + '.' + data.parentData.parentId;
	
	            if (state.feedPosts[feedPostsId] && state.feedPosts[feedPostsId].posts[data.parentData.id] && state.feedPosts[feedPostsId].posts[data.parentData.id].comments) {
	                _vue2.default.set(state.feedPosts[feedPostsId].posts[data.parentData.id].comments, data.commentData.id, data.commentData);
	            }
	
	            publicFeeds.forEach(function (feed) {
	                if (state.feedPosts[feed] && state.feedPosts[feed].posts[data.parentData.id] && state.feedPosts[feed].posts[data.parentData.id].comments) {
	                    _vue2.default.set(state.feedPosts[feed].posts[data.parentData.id].comments, data.commentData.id, data.commentData);
	                }
	            });
	        },
	
	        'feedPosts/updateComment': function feedPostsUpdateComment(state, data) {
	            var feedPostsId = data.parentData.parentType + '.' + data.parentData.parentId,
	                postId = data.parentData.id,
	                commentId = data.commentData.id,
	                newContent = data.commentData.content;
	
	            if (state.feedPosts[feedPostsId] && state.feedPosts[feedPostsId].posts[postId]) {
	                _vue2.default.set(state.feedPosts[feedPostsId].posts[postId].comments[commentId], 'content', newContent);
	            }
	
	            publicFeeds.forEach(function (feed) {
	                if (state.feedPosts[feed] && state.feedPosts[feed].posts[postId]) {
	                    _vue2.default.set(state.feedPosts[feed].posts[postId].comments[commentId], 'content', newContent);
	                }
	            });
	        },
	
	        'feedPosts/deleteComment': function feedPostsDeleteComment(state, data) {
	            var feedPostsId = data.parentData.parentType + '.' + data.parentData.parentId;
	
	            if (state.feedPosts[feedPostsId] && state.feedPosts[feedPostsId].posts[data.parentData.id]) {
	                _vue2.default.delete(state.feedPosts[feedPostsId].posts[data.parentData.id].comments, data.id);
	            }
	
	            publicFeeds.forEach(function (feed) {
	                if (state.feedPosts[feed] && state.feedPosts[feed].posts[data.parentData.id]) {
	                    _vue2.default.delete(state.feedPosts[feed].posts[data.parentData.id].comments, data.id);
	                }
	            });
	        }
	    }
	
	};

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vue = __webpack_require__(4);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    state: {
	        boards: {}
	    },
	
	    actions: {
	        'forums/getCategoriesAndForums': function forumsGetCategoriesAndForums(context, data) {
	            context.commit('forums/setInitialState', data);
	
	            _vue2.default.set(context.state.boards[data.boardId], 'fetchingStatus', 'fetching');
	
	            _axios2.default.get('/api/forums/categoriesAndForums', {
	                params: {
	                    parentType: data.boardId.split('.')[0],
	                    parentId: data.boardId.split('.')[1]
	                }
	            }).then(function (response) {
	                context.commit('forums/setCategories', { boardId: data.boardId, categories: response.data });
	            }, function (response) {
	                console.log(response);
	            });
	        },
	        'forums/getThreads': function forumsGetThreads(context, data) {
	            _vue2.default.set(context.state.boards[data.boardId].categories[data.categoryStringUrl].forums[data.forumStringUrl], 'fetchingStatus', 'fetching');
	
	            _axios2.default.get('/api/forums/threads', {
	                params: {
	                    forumId: data.forumId,
	                    page: data.page,
	                    perPage: data.perPage
	                }
	            }).then(function (response) {
	                context.commit('forums/setThreads', {
	                    boardId: data.boardId,
	                    categoryStringUrl: data.categoryStringUrl,
	                    forumStringUrl: data.forumStringUrl,
	                    threads: response.data
	                });
	            }, function (response) {
	                console.log(response);
	            });
	        },
	        'forums/getThread': function forumsGetThread(context, data) {
	            _axios2.default.get('/api/forums/thread', {
	                params: {
	                    forumId: data.forumId,
	                    threadStringUrl: data.threadStringUrl
	                }
	            }).then(function (response) {
	                if (!response.data.errors) {
	                    context.commit('forums/setThread', {
	                        boardId: data.boardId,
	                        categoryStringUrl: data.categoryStringUrl,
	                        forumStringUrl: data.forumStringUrl,
	                        threadStringUrl: data.threadStringUrl,
	                        thread: response.data
	                    });
	                }
	            }, function (response) {
	                console.log(response);
	            });
	        },
	        'forums/getPosts': function forumsGetPosts(context, data) {
	            if (!data.noLoader) {
	                _vue2.default.set(context.state.boards[data.boardId].categories[data.categoryStringUrl].forums[data.forumStringUrl].threads[data.threadStringUrl], 'fetchingStatus', 'fetching');
	            }
	
	            _axios2.default.get('/api/forums/posts', {
	                params: {
	                    threadId: data.threadId,
	                    page: data.page,
	                    perPage: data.perPage
	                }
	            }).then(function (response) {
	                context.commit('forums/setPosts', {
	                    boardId: data.boardId,
	                    categoryStringUrl: data.categoryStringUrl,
	                    forumStringUrl: data.forumStringUrl,
	                    threadStringUrl: data.threadStringUrl,
	                    posts: response.data
	                });
	            }, function (response) {
	                console.log(response);
	            });
	        }
	    },
	
	    mutations: {
	        'forums/setInitialState': function forumsSetInitialState(state, data) {
	            _vue2.default.set(state.boards, data.boardId, {});
	        },
	        'forums/setCategories': function forumsSetCategories(state, data) {
	            _vue2.default.set(state.boards[data.boardId], 'categories', data.categories);
	            _vue2.default.set(state.boards[data.boardId], 'fetchingStatus', 'fetched');
	        },
	        'forums/addCategory': function forumsAddCategory(state, data) {
	            if (state.boards[data.boardId] && state.boards[data.boardId].categories) {
	                _vue2.default.set(state.boards[data.boardId].categories, data.category.stringUrl, data.category);
	            }
	        },
	        'forums/addForum': function forumsAddForum(state, data) {
	            if (state.boards[data.boardId] && state.boards[data.boardId].categories && state.boards[data.boardId].categories[data.forum.category.stringUrl] && state.boards[data.boardId].categories[data.forum.category.stringUrl].forums) {
	                _vue2.default.set(state.boards[data.boardId].categories[data.forum.category.stringUrl].forums, data.forum.stringUrl, data.forum);
	            }
	        },
	        'forums/setThreads': function forumsSetThreads(state, data) {
	            _vue2.default.set(state.boards[data.boardId].categories[data.categoryStringUrl].forums[data.forumStringUrl], 'threads', data.threads);
	            _vue2.default.set(state.boards[data.boardId].categories[data.categoryStringUrl].forums[data.forumStringUrl], 'fetchingStatus', 'fetched');
	        },
	        'forums/setThread': function forumsSetThread(state, data) {
	            if (state.boards[data.boardId].categories[data.categoryStringUrl].forums[data.forumStringUrl].threads === undefined) {
	                _vue2.default.set(state.boards[data.boardId].categories[data.categoryStringUrl].forums[data.forumStringUrl], 'threads', {});
	            }
	
	            _vue2.default.set(state.boards[data.boardId].categories[data.categoryStringUrl].forums[data.forumStringUrl].threads, data.threadStringUrl, data.thread);
	        },
	        'forums/setPosts': function forumsSetPosts(state, data) {
	            _vue2.default.set(state.boards[data.boardId].categories[data.categoryStringUrl].forums[data.forumStringUrl].threads[data.threadStringUrl], 'posts', data.posts);
	            _vue2.default.set(state.boards[data.boardId].categories[data.categoryStringUrl].forums[data.forumStringUrl].threads[data.threadStringUrl], 'fetchingStatus', 'fetched');
	        }
	    }
	
	};

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vue = __webpack_require__(4);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    state: {
	        gotInitialLoggedUserInfo: false,
	        isLoggedIn: false,
	        info: [],
	        games: [],
	        options: {}
	    },
	
	    actions: {
	        'loggedUserModel/getLoggedUserInfo': function loggedUserModelGetLoggedUserInfo(context, callback) {
	            _axios2.default.get('/api/login').then(function (response) {
	                if (callback) {
	                    callback({
	                        status: response.data.isLoggedIn ? 'online' : 'offline',
	                        id: response.data.info.id,
	                        alias: response.data.info.alias,
	                        stringUrl: response.data.info.stringUrl,
	                        passkey: response.data.info.passkey,
	                        siteModCanBan: response.data.info.siteModCanBan
	                    });
	                }
	                context.commit('loggedUserModel/setLoggedUserInfo', response.data);
	            }, function (response) {
	                console.log(response);
	            });
	        },
	        'loggedUserModel/logOut': function loggedUserModelLogOut(context, callback) {
	            _axios2.default.get('/api/login', {
	                params: {
	                    logOut: true
	                }
	            }).then(function (response) {
	                callback({
	                    status: 'offline',
	                    id: context.state.info.id
	                });
	                context.commit('loggedUserModel/setLoggedUserInfo', response.data);
	                context.rootState.loginPageModel.validationMessage = "";
	            }, function (response) {
	                console.log(response);
	            });
	        },
	
	        'loggedUserModel/CatchUpOnMedia': function loggedUserModelCatchUpOnMedia(context) {
	            context.rootState.loggedUserModel.info.caughtUpOnMedia = 1;
	            _axios2.default.post('/api/developer/catchUpOnMedia');
	        },
	
	        'loggedUserModel/CatchUpOnDevlogs': function loggedUserModelCatchUpOnDevlogs(context) {
	            context.rootState.loggedUserModel.info.caughtUpOnDevlogs = 1;
	            _axios2.default.post('/api/developer/catchUpOnDevlogs');
	        },
	
	        'loggedUserModel/CatchUpOnClassifieds': function loggedUserModelCatchUpOnClassifieds(context) {
	            context.rootState.loggedUserModel.info.caughtUpOnClassifieds = 1;
	            _axios2.default.post('/api/developer/catchUpOnClassifieds');
	        },
	
	        'loggedUserModel/CatchUpOnForums': function loggedUserModelCatchUpOnForums(context) {
	            context.rootState.loggedUserModel.info.caughtUpOnForums = 1;
	            _axios2.default.post('/api/developer/catchUpOnForums');
	        },
	
	        'loggedUserModel/updateLoggedUserInfo': function loggedUserModelUpdateLoggedUserInfo(state, data) {
	            _axios2.default.post('/api/accountInformation', {
	                info: data.data
	            }).then(function (response) {
	                data.callback(response.data);
	            });
	        }
	    },
	
	    mutations: {
	        'loggedUserModel/setLoggedUserInfo': function loggedUserModelSetLoggedUserInfo(state, data) {
	            state.isLoggedIn = data.isLoggedIn;
	            state.info = data.info;
	            state.gotInitialLoggedUserInfo = true;
	            state.games = data.games;
	            state.options = data.options;
	        }
	    }
	
	};

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vue = __webpack_require__(4);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    state: {
	        medias: {}
	    },
	
	    actions: {
	        'medias/getAlbums': function mediasGetAlbums(context, data) {
	            context.commit('medias/initializeMediasData', { mediasId: data.mediasId });
	            context.commit('medias/setAlbumFetchingStatus', { mediasId: data.mediasId, status: 'fetching' });
	
	            _axios2.default.get('/api/media/albums', {
	                params: {
	                    pageId: data.mediasId.split('.')[1],
	                    pageType: data.mediasId.split('.')[0]
	                }
	            }).then(function (response) {
	                context.commit('medias/setAlbumFetchingStatus', { mediasId: data.mediasId, status: 'fetched' });
	
	                context.commit('medias/setAlbums', {
	                    albums: response.data,
	                    mediasId: data.mediasId
	                });
	            }, function (response) {
	                console.log(response);
	            });
	        },
	
	        'medias/getPieces': function mediasGetPieces(context, data) {
	            _vue2.default.set(context.state.medias[data.mediasId].albums[data.albumId], 'fetchStatus', 'fetching');
	
	            _axios2.default.get('/api/media/pieces', {
	                params: {
	                    albumId: data.albumId
	                }
	            }).then(function (response) {
	                context.commit('medias/setPieces', {
	                    mediasId: data.mediasId,
	                    albumId: data.albumId,
	                    pieces: response.data
	                });
	            }, function (response) {
	                console.log(response);
	            });
	        },
	
	        'medias/getPieceComments': function mediasGetPieceComments(context, data) {
	            _axios2.default.get('/api/media/pieces/comments', {
	                params: {
	                    pieceId: data.piece.id
	                }
	            }).then(function (response) {
	                context.commit('medias/setPieceComments', {
	                    comments: response.data,
	                    albumId: data.piece.albumId,
	                    mediasId: data.mediasId,
	                    pieceId: data.piece.id
	                });
	            }, function (response) {
	                console.log(response);
	            });
	        },
	
	        'medias/addComment': function mediasAddComment(context, data) {
	            var postAsType = data.postAs.split('|')[0],
	                postAsId = data.postAs.split('|')[1];
	
	            _axios2.default.post('/api/media/pieces/comments', {
	                content: data.content,
	                parentId: data.piece.id,
	                postAsType: postAsType,
	                postAsId: postAsId
	            }).then(function (response) {}, function (response) {
	                console.log(response.data);
	            });
	        },
	
	        'medias/addAlbum': function mediasAddAlbum(context, data) {
	            var formData = new FormData();
	            formData.append('albumName', data.albumName);
	            formData.append('albumAvatar', data.albumFile);
	            formData.append('pageType', data.pageType);
	            formData.append('pageId', data.pageId);
	
	            _axios2.default.post('/api/media/album', formData).then(function (response) {}, function (response) {});
	        },
	
	        'medias/editAlbum': function mediasEditAlbum(context, data) {
	            var formData = new FormData();
	            formData.append('albumId', data.albumId);
	            formData.append('newName', data.albumName);
	            formData.append('albumAvatar', data.albumFile);
	
	            _axios2.default.post('/api/media/album/edit', formData).then(function (response) {}, function (response) {});
	        },
	
	        'medias/deleteAlbum': function mediasDeleteAlbum(context, data) {
	            _axios2.default.post('/api/media/album/delete', {
	                albumId: data.albumId
	            }).then(function (response) {}, function (response) {});
	        },
	
	        'medias/reorderAlbums': function mediasReorderAlbums(context, data) {
	            _axios2.default.post('/api/media/albums/reorder', {
	                albums: data.albums,
	                pageType: data.pageType,
	                pageId: data.pageId
	            }).then(function (response) {}, function (response) {});
	        },
	
	        'medias/addPiece': function mediasAddPiece(context, data) {
	            var formData = new FormData();
	            formData.append('albumId', data.albumId);
	            formData.append('title', data.title);
	            formData.append('description', data.description);
	            formData.append('selectedMediaType', data.selectedMediaType);
	            formData.append('mediaFile', data.mediaFile);
	            formData.append('previewFile', data.previewFile);
	            formData.append('mediaText', data.mediaText);
	            formData.append('pageType', data.pageType);
	            formData.append('pageId', data.pageId);
	
	            _axios2.default.post('/api/media/piece', formData).then(function (response) {}, function (response) {});
	        },
	
	        'medias/editPiece': function mediasEditPiece(context, data) {
	            _axios2.default.post('/api/media/piece/edit', {
	                id: data.id,
	                title: data.title,
	                description: data.description,
	                mediaText: data.mediaText
	            }).then(function (response) {}, function (response) {});
	        },
	
	        'medias/deletePiece': function mediasDeletePiece(context, data) {
	            _axios2.default.post('/api/media/piece/delete', {
	                id: data.id
	            }).then(function (response) {}, function (response) {});
	        }
	    },
	
	    mutations: {
	        'medias/initializeMediasData': function mediasInitializeMediasData(state, data) {
	            if (!state.medias[data.mediasId]) {
	                _vue2.default.set(state.medias, data.mediasId, {
	                    albums: {},
	                    fetchingStatus: 'unfetched'
	                });
	            }
	        },
	
	        'medias/setAlbumFetchingStatus': function mediasSetAlbumFetchingStatus(state, data) {
	            _vue2.default.set(state.medias[data.mediasId], 'fetchingStatus', data.status);
	        },
	
	        'medias/setAlbums': function mediasSetAlbums(state, data) {
	            data.albums.forEach(function (album) {
	                _vue2.default.set(state.medias[data.mediasId].albums, album.id, album);
	            });
	        },
	
	        'medias/setPieces': function mediasSetPieces(state, data) {
	            _vue2.default.set(state.medias[data.mediasId].albums[data.albumId], 'pieces', {});
	
	            data.pieces.forEach(function (piece) {
	                _vue2.default.set(state.medias[data.mediasId].albums[data.albumId].pieces, piece.id, piece);
	            });
	
	            _vue2.default.set(state.medias[data.mediasId].albums[data.albumId], 'fetchStatus', 'fetched');
	        },
	
	        'medias/setPieceComments': function mediasSetPieceComments(state, data) {
	            _vue2.default.set(state.medias[data.mediasId].albums[data.albumId].pieces[data.pieceId], 'comments', {});
	
	            data.comments.forEach(function (comment) {
	                _vue2.default.set(state.medias[data.mediasId].albums[data.albumId].pieces[data.pieceId].comments, comment.id, comment);
	            });
	        },
	
	        'medias/appendComment': function mediasAppendComment(state, data) {
	            var mediasId = void 0;
	
	            if (!data.parentData || !data.albumData || !data.pieceData) {
	                return;
	            }
	
	            mediasId = data.parentData.parentType + '.' + data.parentData.parentId;
	
	            if (state.medias[mediasId] && state.medias[mediasId].albums && state.medias[mediasId].albums[data.albumData.id] && state.medias[mediasId].albums[data.albumData.id].pieces && state.medias[mediasId].albums[data.albumData.id].pieces[data.pieceData.id] && state.medias[mediasId].albums[data.albumData.id].pieces[data.pieceData.id].comments) {
	                _vue2.default.set(state.medias[mediasId].albums[data.albumData.id].pieces[data.pieceData.id].comments, data.commentData.id, data.commentData);
	            }
	        },
	
	        'medias/updateComment': function mediasUpdateComment(state, data) {
	            var mediasId = void 0;
	
	            if (!data.parentData || !data.albumData || !data.pieceData) {
	                return;
	            }
	
	            mediasId = data.parentData.parentType + '.' + data.parentData.parentId;
	
	            if (state.medias[mediasId] && state.medias[mediasId].albums && state.medias[mediasId].albums[data.albumData.id] && state.medias[mediasId].albums[data.albumData.id].pieces && state.medias[mediasId].albums[data.albumData.id].pieces[data.pieceData.id] && state.medias[mediasId].albums[data.albumData.id].pieces[data.pieceData.id].comments) {
	                _vue2.default.set(state.medias[mediasId].albums[data.albumData.id].pieces[data.pieceData.id].comments[data.commentData.id], 'content', data.commentData.content);
	            }
	        },
	
	        'medias/deleteComment': function mediasDeleteComment(state, data) {
	            var mediasId = void 0;
	
	            if (!data.parentData || !data.albumData || !data.pieceData) {
	                return;
	            }
	
	            mediasId = data.parentData.parentType + '.' + data.parentData.parentId;
	
	            if (state.medias[mediasId] && state.medias[mediasId].albums && state.medias[mediasId].albums[data.albumData.id] && state.medias[mediasId].albums[data.albumData.id].pieces && state.medias[mediasId].albums[data.albumData.id].pieces[data.pieceData.id] && state.medias[mediasId].albums[data.albumData.id].pieces[data.pieceData.id].comments) {
	                _vue2.default.delete(state.medias[mediasId].albums[data.albumData.id].pieces[data.pieceData.id].comments, [data.id]);
	            }
	        },
	
	        'medias/mediaAlbumAddOrEdit': function mediasMediaAlbumAddOrEdit(state, data) {
	            var mediasId = data.parentType + '.' + data.posterId;
	
	            if (state.medias[mediasId] && state.medias[mediasId].albums) {
	                _vue2.default.set(state.medias[mediasId].albums, data.id, data);
	            }
	        },
	
	        'medias/mediaAlbumDelete': function mediasMediaAlbumDelete(state, data) {
	            var mediasId = data.parentType + '.' + data.posterId;
	
	            if (state.medias[mediasId] && state.medias[mediasId].albums) {
	                _vue2.default.delete(state.medias[mediasId].albums, data.id);
	            }
	        },
	
	        'medias/mediaPieceAddOrEdit': function mediasMediaPieceAddOrEdit(state, data) {
	            var mediasId = data.posterType + '.' + data.posterId,
	                albumId = data.albumId,
	                pieceId = data.id;
	
	            if (state.medias[mediasId] && state.medias[mediasId].albums && state.medias[mediasId].albums[albumId] && state.medias[mediasId].albums[albumId].pieces) {
	                _vue2.default.set(state.medias[mediasId].albums[albumId].pieces, pieceId, data);
	            }
	        },
	
	        'medias/mediaPieceDelete': function mediasMediaPieceDelete(state, data) {
	            var mediasId = data.posterType + '.' + data.posterId;
	
	            if (state.medias[mediasId] && state.medias[mediasId].albums && state.medias[mediasId].albums[data.albumId] && state.medias[mediasId].albums[data.albumId].pieces && state.medias[mediasId].albums[data.albumId].pieces[data.id]) {
	                _vue2.default.delete(state.medias[mediasId].albums[data.albumId].pieces, data.id);
	            }
	        }
	    }
	
	};

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vue = __webpack_require__(4);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    state: {
	        voteData: {}
	    },
	
	    actions: {
	        'votingWidget/retrieve': function votingWidgetRetrieve(context, data) {
	
	            _axios2.default.get('/api/voting', {
	                params: {
	                    parentType: data.parentType,
	                    parentId: data.parentId
	                }
	            }).then(function (response) {
	                context.commit('votingWidget/setData', {
	                    voteTotal: response.data.voteTotal,
	                    id: data.parentType + '|' + data.parentId
	                });
	            });
	        }
	    },
	
	    mutations: {
	        'votingWidget/setData': function votingWidgetSetData(state, data) {
	            _vue2.default.set(state.voteData, data.id, data.voteTotal);
	        }
	    }
	
	};

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vue = __webpack_require__(4);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    state: {
	        genres: [],
	        platforms: {},
	        skills: [],
	        totals: {}
	    },
	
	    actions: {
	        'develteamData/buildData': function develteamDataBuildData(context) {
	            _axios2.default.get('/api/develteamData').then(function (response) {
	                context.commit('develteamData/setData', response.data);
	            }, function (response) {
	                console.log(response);
	            });
	        },
	
	        'develteamData/getTotals': function develteamDataGetTotals(context) {
	            _axios2.default.get('/api/totals').then(function (response) {
	                context.commit('develteamData/setTotals', response.data);
	            }, function (response) {
	                console.log(response);
	            });
	        }
	    },
	
	    mutations: {
	        'develteamData/setData': function develteamDataSetData(state, data) {
	            state.genres = data.genres;
	            state.platforms = data.platforms;
	            state.skills = data.skills;
	        },
	
	        'develteamData/setTotals': function develteamDataSetTotals(state, data) {
	            state.totals = data;
	        }
	    }
	
	};

/***/ }),
/* 290 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (src) {
	    var blankList = void 0,
	        step = 0,
	        iframe = window.document.createElement("iframe"),
	        loadCallback = function loadCallback(e) {
	        if (!step) {
	            step = 2;
	            blankList = imgReloadBlank(src);
	            iframe.contentWindow.location.reload(true);
	        } else if (step === 2) {
	            imgReloadRestore(src, blankList);
	            if (iframe.parentNode) iframe.parentNode.removeChild(iframe);
	        }
	    };
	
	    iframe.style.display = "none";
	    window.parent.document.body.appendChild(iframe);
	    iframe.addEventListener("load", loadCallback, false);
	    iframe.addEventListener("error", loadCallback, false);
	    iframe.src = src;
	};
	
	function imgReloadBlank(src) {
	
	    var blankList = [],
	        imgs = window.document.body.getElementsByTagName("img"),
	        img = void 0,
	        i = void 0,
	        srcSegments = void 0,
	        relativeSrc = void 0;
	
	    for (i = imgs.length; i--;) {
	        img = imgs[i];
	        srcSegments = img.src.split('/');
	        relativeSrc = '/' + srcSegments.slice(3).join('/');
	        if (relativeSrc === src) {
	            img.src = "/userdata/avatar_blank_100.jpg";
	            blankList.push(img);
	        }
	    }
	
	    return blankList;
	}
	
	function imgReloadRestore(src, blankList) {
	    var i = void 0,
	        img = void 0;
	
	    for (i = blankList.length; i--;) {
	        (img = blankList[i]).src = src;
	    }
	}

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _classCallCheck2 = __webpack_require__(76);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(77);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _Emitter = __webpack_require__(74);
	
	var _Emitter2 = _interopRequireDefault(_Emitter);
	
	var _socket = __webpack_require__(643);
	
	var _socket2 = _interopRequireDefault(_socket);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _class = function () {
	    function _class(connection) {
	        (0, _classCallCheck3.default)(this, _class);
	
	
	        if (typeof connection == 'string') {
	            this.Socket = (0, _socket2.default)(connection);
	        } else {
	            this.Socket = connection;
	        }
	
	        this.onEvent();
	    }
	
	    (0, _createClass3.default)(_class, [{
	        key: 'onEvent',
	        value: function onEvent() {
	            this.Socket.onevent = function (packet) {
	                _Emitter2.default.emit(packet.data[0], packet.data[1]);
	            };
	
	            var _this = this;
	
	            ["connect", "error", "disconnect", "reconnect", "reconnect_attempt", "reconnecting", "reconnect_error", "reconnect_failed"].forEach(function (value) {
	                _this.Socket.on(value, function (data) {
	                    _Emitter2.default.emit(value, data);
	                });
	            });
	        }
	    }]);
	    return _class;
	}();

	exports.default = _class;

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _keys = __webpack_require__(7);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _Observer = __webpack_require__(291);
	
	var _Observer2 = _interopRequireDefault(_Observer);
	
	var _Emitter = __webpack_require__(74);
	
	var _Emitter2 = _interopRequireDefault(_Emitter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    install: function install(Vue, connection) {
	
	        if (!connection) throw new Error("[Vue-Socket.io] cannot locate connection");
	
	        var observer = new _Observer2.default(connection);
	
	        Vue.prototype.$socket = observer.Socket;
	
	        Vue.mixin({
	            beforeCreate: function beforeCreate() {
	                var _this = this;
	                var sockets = this.$options['sockets'];
	
	                if (sockets) {
	                    (0, _keys2.default)(sockets).forEach(function (key) {
	                        _Emitter2.default.addListener(key, sockets[key], _this);
	                    });
	                }
	            },
	            beforeDestroy: function beforeDestroy() {
	                var _this = this;
	                var sockets = this.$options['sockets'];
	
	                if (sockets) {
	                    (0, _keys2.default)(sockets).forEach(function (key) {
	                        _Emitter2.default.removeListener(key, sockets[key], _this);
	                    });
	                }
	            }
	        });
	    }
	};

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Plugin = __webpack_require__(572);
	
	module.exports = function fontawesome_plugin(md) {
		md.use(Plugin(/\[icon:([\w\-]+)]/, function (match, utils) {
			return '<i class="fas fa-' + utils.escape(match[1]) + '"></i>';
		}));
	};

/***/ }),
/* 294 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function dtSmiley(md) {
	
	    var defaultRender = md.renderer.rules.link_open || function (tokens, idx, options, env, self) {
	        return self.renderToken(tokens, idx, options);
	    };
	
	    md.renderer.rules.link_open = function (tokens, idx, options, env, self) {
	        var aIndex = tokens[idx].attrIndex('target');
	
	        if (aIndex < 0) {
	            tokens[idx].attrPush(['target', '_blank']);
	        } else {
	            tokens[idx].attrs[aIndex][1] = '_blank';
	        }
	
	        return defaultRender(tokens, idx, options, env, self);
	    };
	};

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vue = __webpack_require__(4);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    state: {
	        notifications: [],
	        fetchingStatus: 'unfetched'
	    },
	
	    actions: {
	        'notificationsModel/getNotifications': function notificationsModelGetNotifications(context) {
	            context.state.fetchingStatus = 'fetching';
	
	            _axios2.default.get('/api/notifications').then(function (response) {
	                context.state.fetchingStatus = 'fetched';
	                context.commit('notificationsModel/setNotifications', response.data);
	            });
	        },
	
	        'notificationsModel/markReadFromRoute': function notificationsModelMarkReadFromRoute(context, data) {
	            context.state.notifications.forEach(function (notification) {
	                if (notification.hasBeenRead === 0 && (notification.link === data.to.fullPath || notification.link === data.from.fullPath)) {
	                    _axios2.default.post('/api/notifications/markRead', {
	                        notificationIdentifier: notification.notificationIdentifier
	                    }).then(function (response) {}, function (response) {});
	                }
	            });
	        }
	    },
	
	    mutations: {
	        'notificationsModel/setNotifications': function notificationsModelSetNotifications(state, data) {
	            state.notifications = data.notifications;
	        }
	    }
	
	};

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vue = __webpack_require__(4);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    state: {
	        pageId: 'developers',
	
	        skillFilterId: 0,
	        filterControls: {
	            developers: {
	                showOptions: [{
	                    id: 'show|all',
	                    label: 'All',
	                    selected: true,
	                    filterConditions: {}
	                }, {
	                    id: 'show|designers',
	                    label: 'Designers',
	                    filterConditions: [{ field: 'is_designer', value: 1 }]
	                }, {
	                    id: 'show|artists',
	                    label: 'Artists',
	                    filterConditions: [{ field: 'is_artist', value: 1 }]
	                }, {
	                    id: 'show|programmers',
	                    label: 'Programmers',
	                    filterConditions: [{ field: 'is_programmer', value: 1 }]
	                }, {
	                    id: 'show|musicians',
	                    label: 'Musicians',
	                    filterConditions: [{ field: 'is_musician', value: 1 }]
	                }, {
	                    id: 'show|sfx',
	                    label: 'SFX Artists',
	                    filterConditions: [{ field: 'is_sfx_artist', value: 1 }]
	                }, {
	                    id: 'show|writers',
	                    label: 'Writers',
	                    filterConditions: [{ field: 'is_writer', value: 1 }]
	                }, {
	                    id: 'show|producers',
	                    label: 'Producers',
	                    filterConditions: [{ field: 'is_producer', value: 1 }]
	                }, {
	                    id: 'show|testers',
	                    label: 'Testers',
	                    filterConditions: [{ field: 'is_tester', value: 1 }]
	                }],
	                recruitingOptions: [],
	                sortOptions: [{
	                    id: 'sort|lastOnilne',
	                    label: 'Last Online',
	                    selected: true,
	                    sortCondition: 'lastOnline',
	                    sortDirection: 'desc'
	                }, {
	                    id: 'sort|proximity',
	                    label: 'Proximity',
	                    sortCondition: 'proximity',
	                    sortDirection: 'asc'
	                }, {
	                    id: 'sort|xp',
	                    label: 'XP Level',
	                    sortCondition: 'xp',
	                    sortDirection: 'desc'
	                }, {
	                    id: 'sort|name',
	                    label: 'Name',
	                    sortCondition: 'alias',
	                    sortDirection: 'asc'
	                }, {
	                    id: 'sort|registrationDate',
	                    label: 'Registration Date',
	                    sortCondition: 'registrationDate',
	                    sortDirection: 'desc'
	                }],
	                filterOptions: [{
	                    id: 'filter|all',
	                    selected: true,
	                    label: 'All',
	                    filterConditions: {}
	                }, {
	                    id: 'filter|seeking',
	                    label: 'Wants to Join a Game Project',
	                    filterConditions: [{ field: 'looking_for_game', value: 1 }]
	                }],
	                showSkills: true
	            },
	
	            games: {
	                showOptions: [],
	                recruitingOptions: [{
	                    id: 'recruiting|all',
	                    selected: true,
	                    label: 'All',
	                    filterConditions: {}
	                }, {
	                    id: 'recruiting|designers',
	                    label: 'Designers',
	                    filterConditions: [{ field: 'seeking_designers', value: 1 }]
	                }, {
	                    id: 'recruiting|artists',
	                    label: 'Artists',
	                    filterConditions: [{ field: 'seeking_artists', value: 1 }]
	                }, {
	                    id: 'recruiting|programmers',
	                    label: 'Programmers',
	                    filterConditions: [{ field: 'seeking_programmers', value: 1 }]
	                }, {
	                    id: 'recruiting|musicians',
	                    label: 'Musicians',
	                    filterConditions: [{ field: 'seeking_musicians', value: 1 }]
	                }, {
	                    id: 'recruiting|sfx',
	                    label: 'SFX Artists',
	                    filterConditions: [{ field: 'seeking_sfx_artists', value: 1 }]
	                }, {
	                    id: 'recruiting|writers',
	                    label: 'Writers',
	                    filterConditions: [{ field: 'seeking_writers', value: 1 }]
	                }, {
	                    id: 'recruiting|producers',
	                    label: 'Producers',
	                    filterConditions: [{ field: 'seeking_producers', value: 1 }]
	                }, {
	                    id: 'recruiting|testers',
	                    label: 'Testers',
	                    filterConditions: [{ field: 'seeking_testers', value: 1 }]
	                }],
	                sortOptions: [{
	                    id: 'sort|lastActive',
	                    label: 'Last Active',
	                    selected: true,
	                    sortCondition: 'lastActive',
	                    sortDirection: 'desc'
	                }, {
	                    id: 'sort|created',
	                    label: 'Created',
	                    sortCondition: 'created',
	                    sortDirection: 'desc'
	                }, {
	                    id: 'sort|xp',
	                    label: 'XP Level',
	                    sortCondition: 'xp',
	                    sortDirection: 'desc'
	                }, {
	                    id: 'sort|name',
	                    label: 'Name',
	                    sortCondition: 'alias',
	                    sortDirection: 'asc'
	                }, {
	                    id: 'sort|teamSize',
	                    label: 'Team Size',
	                    sortCondition: 'memberCount',
	                    sortDirection: 'desc'
	                }],
	                filterOptions: [{
	                    id: 'filter|all',
	                    selected: true,
	                    label: 'All',
	                    filterConditions: {}
	                }, {
	                    id: 'filter|seeking',
	                    label: 'Currently Recruiting Members',
	                    filterConditions: [{ field: 'seeking_is', value: 1 }]
	                }],
	                showSkills: true
	            }
	        },
	
	        browseResults: [],
	        totalResults: 1,
	        resultsPageCurrent: 1,
	        resultsPageTotal: 1,
	        resultsPerPage: 20,
	        isFetching: true
	    },
	
	    actions: {
	        'browsePage/updatePageId': function browsePageUpdatePageId(context, data) {
	            var pathSegments = context.rootState.route.path.substring(1).split('/'),
	                pageId = '';
	
	            if (pathSegments.length <= 1 || pathSegments[1] === '') {
	                pageId = 'developers';
	            } else {
	                pageId = pathSegments[1].toLowerCase();
	            }
	
	            context.commit('browsePage/updatePageId', pageId);
	
	            if (data && !data.blockPopulateResults) {
	                context.dispatch('browsePage/populateResults');
	            }
	        },
	
	        'browsePage/initializeFilterOption': function browsePageInitializeFilterOption(context, data) {
	            var optionType = data.split('|')[0];
	            var controls = context.state.filterControls[context.state.pageId];
	            var options = [];
	            var skillId = context.state.skillFilterId;
	
	            if (optionType === 'sort') {
	                options = controls.sortOptions;
	            }
	
	            if (optionType === 'filter') {
	                options = controls.filterOptions;
	            }
	
	            if (optionType === 'show') {
	                options = controls.showOptions;
	            }
	
	            if (optionType === 'recruiting') {
	                options = controls.recruitingOptions;
	            }
	
	            if (optionType === 'skill') {
	                skillId = data.split('|')[1];
	            }
	
	            options.forEach(function (option) {
	                context.commit('browsePage/setFilterOption', { option: option, selected: option.id === data });
	            });
	
	            context.commit('browsePage/setSkillFilterId', skillId);
	        },
	
	        'browsePage/updateFilterOptions': function browsePageUpdateFilterOptions(context, data) {
	            var optionType = data.split('|')[0];
	            var controls = context.state.filterControls[context.state.pageId];
	            var options = [];
	            var skillId = context.state.skillFilterId;
	
	            if (optionType === 'sort') {
	                options = controls.sortOptions;
	            }
	
	            if (optionType === 'filter') {
	                options = controls.filterOptions;
	            }
	
	            if (optionType === 'show') {
	                options = controls.showOptions;
	            }
	
	            if (optionType === 'recruiting') {
	                options = controls.recruitingOptions;
	            }
	
	            if (optionType === 'skill') {
	                skillId = data.split('|')[1];
	            }
	
	            options.forEach(function (option) {
	                context.commit('browsePage/setFilterOption', { option: option, selected: option.id === data });
	            });
	
	            context.commit('browsePage/setSkillFilterId', skillId);
	
	            context.dispatch('browsePage/populateResults');
	        },
	
	        'browsePage/populateResults': function browsePagePopulateResults(context) {
	            var controls = context.state.filterControls[context.state.pageId],
	                sortCondition = void 0,
	                sortDiection = void 0,
	                filterOptions = void 0,
	                showOptions = void 0,
	                recruitingOptions = void 0,
	                payload = void 0;
	
	            context.state.isFetching = true;
	
	            controls.sortOptions.forEach(function (option) {
	                if (option.selected) {
	                    sortCondition = option.sortCondition;
	                    sortDiection = option.sortDirection;
	                }
	            });
	
	            controls.filterOptions.forEach(function (option) {
	                if (option.selected) {
	                    filterOptions = option.filterConditions;
	                }
	            });
	
	            controls.showOptions.forEach(function (option) {
	                if (option.selected) {
	                    showOptions = option.filterConditions;
	                }
	            });
	
	            controls.recruitingOptions.forEach(function (option) {
	                if (option.selected) {
	                    recruitingOptions = option.filterConditions;
	                }
	            });
	
	            payload = {
	                filteredConditions: {
	                    category: context.state.pageId,
	                    sortOptions: {
	                        sortCondition: sortCondition,
	                        sortDirection: sortDiection
	                    },
	                    filterOptions: filterOptions,
	                    showOptions: showOptions,
	                    recruitingOptions: recruitingOptions,
	                    skillFilterId: context.state.skillFilterId
	                },
	                pagination: {
	                    page: context.state.resultsPageCurrent,
	                    perPage: context.state.resultsPerPage
	                }
	            };
	
	            _axios2.default.get('/api/browseResults', {
	                params: payload
	            }).then(function (response) {
	                context.commit('browsePage/populateResults', response.data);
	            }, function (response) {
	                console.log(response);
	            });
	        },
	
	        'browsePage/updateResultsPage': function browsePageUpdateResultsPage(context, data) {
	            if (data <= 0) {
	                data = 1;
	            }
	
	            if (data >= context.state.resultsPageTotal) {
	                data = context.state.resultsPageTotal;
	            }
	
	            context.commit('browsePage/updateResultsPage', data);
	            context.dispatch('browsePage/populateResults');
	        }
	    },
	
	    mutations: {
	        'browsePage/updatePageId': function browsePageUpdatePageId(state, data) {
	            state.pageId = data;
	            state.resultsPageCurrent = 1;
	            state.resultsPageTotal = 0;
	        },
	
	        'browsePage/populateResults': function browsePagePopulateResults(state, data) {
	            state.browseResults = data.browseResults;
	            state.totalResults = data.totalResults;
	
	            if (state.browseResults.length > 0) {
	                _vue2.default.set(state, 'isFetching', false);
	                state.resultsPageTotal = Math.ceil(state.totalResults / state.resultsPerPage);
	            } else {
	                _vue2.default.set(state, 'isFetching', false);
	                state.resultsPageTotal = 0;
	            }
	        },
	
	        'browsePage/setFilterOption': function browsePageSetFilterOption(state, data) {
	            _vue2.default.set(data.option, 'selected', data.selected);
	            state.resultsPageCurrent = 1;
	            state.resultsPageTotal = 0;
	        },
	
	        'browsePage/setSkillFilterId': function browsePageSetSkillFilterId(state, data) {
	            _vue2.default.set(state, 'skillFilterId', data);
	        },
	
	        'browsePage/updateResultsPage': function browsePageUpdateResultsPage(state, data) {
	            _vue2.default.set(state, 'resultsPageCurrent', data);
	        }
	    }
	
	};

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vue = __webpack_require__(4);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    state: {
	        messages: [],
	        historyMessages: [],
	        historyDates: [],
	        retrievingHistoryDates: false,
	        retrievedHistoryDates: false,
	        selectedHistoryMessage: undefined,
	        retrievingHistoryMessages: false,
	
	        rooms: {
	            'siteGeneral': {
	                name: 'Develteam: General',
	                id: 'siteGeneral'
	            }
	        },
	        selectedRoom: undefined
	    },
	
	    actions: {
	        'chatRoom/getMessages': function chatRoomGetMessages(context, callback) {
	            if (context.state.selectedRoom === undefined) {
	                context.state.selectedRoom = context.state.rooms.siteGeneral;
	            }
	
	            _axios2.default.get('/api/chatrooms', {
	                params: {
	                    chatRoomId: context.state.selectedRoom.id
	                }
	            }).then(function (response) {
	                context.commit('chatRoom/setMessages', response.data);
	                if (callback) {
	                    callback();
	                }
	            });
	        },
	        'chatRoom/sendMessage': function chatRoomSendMessage(context, data) {
	            _axios2.default.post('/api/chatrooms', {
	                message: data.message,
	                chatRoomId: context.state.selectedRoom.id
	            }).then(function (response) {}, function (response) {});
	        },
	        'chatRoom/switchRooms': function chatRoomSwitchRooms(context, data) {
	            context.state.selectedRoom = context.state.rooms[data.newRoomId];
	
	            context.dispatch('chatRoom/getMessages', function () {
	                if (data.callback) {
	                    data.callback();
	                }
	            });
	        },
	        'chatRoom/getHistoryDates': function chatRoomGetHistoryDates(context) {
	            if (context.state.selectedRoom === undefined) {
	                return;
	            }
	
	            context.state.retrievedHistoryDates = false;
	            context.state.retrievingHistoryDates = true;
	
	            _axios2.default.get('/api/chatroomHistory/dates', {
	                params: {
	                    chatRoomId: context.state.selectedRoom.id
	                }
	            }).then(function (response) {
	                context.commit('chatRooms/setHistoryDates', response.data);
	            });
	        },
	        'chatRoom/getHistoryForDate': function chatRoomGetHistoryForDate(context, data) {
	            if (context.state.selectedRoom === undefined || data.selectedHistoryDate === undefined || data.callback === undefined) {
	                return;
	            }
	
	            if (context.state.historyMessages[context.state.selectedRoom.id + "_" + data.selectedHistoryDate.day]) {
	                data.callback();
	                return;
	            }
	
	            context.state.retrievingHistoryMessages = true;
	            _axios2.default.get('/api/chatroomHistory', {
	                params: {
	                    chatRoomId: context.state.selectedRoom.id,
	                    historyDate: data.selectedHistoryDate.day
	                }
	            }).then(function (response) {
	                context.commit('chatRoom/setHistoryMessages', { date: data.selectedHistoryDate.day, messages: response.data });
	                context.state.retrievingHistoryMessages = false;
	                data.callback();
	            });
	        }
	    },
	
	    mutations: {
	        'chatRoom/setMessages': function chatRoomSetMessages(state, data) {
	            state.messages = data.messages;
	        },
	        'chatRooms/setHistoryDates': function chatRoomsSetHistoryDates(state, data) {
	            state.historyDates = data.history;
	            state.retrievedHistoryDates = true;
	            state.retrievingHistoryDates = false;
	        },
	        'chatRoom/setHistoryMessages': function chatRoomSetHistoryMessages(state, data) {
	            state.historyMessages[state.selectedRoom.id + "_" + data.date] = data.messages;
	        }
	    }
	
	};

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    state: {
	        posts: []
	    },
	
	    actions: {
	        'classifiedsPage/getClassifieds': function classifiedsPageGetClassifieds(context, data) {
	            _axios2.default.get('/api/classifieds', {
	                params: {
	                    postType: data.postType,
	                    role: data.role,
	                    skillId: data.skillId
	                }
	            }).then(function (response) {
	                context.commit('classifiedsPage/setClassifieds', response.data.response);
	                if (data.callback) {
	                    data.callback();
	                }
	            });
	        },
	        'classifiedsPage/submitNewClassifiedsPost': function classifiedsPageSubmitNewClassifiedsPost(context, data) {
	            _axios2.default.post('/api/classifieds/new', {
	                selectedGameId: data.selectedGameId,
	                postTitle: data.postTitle,
	                postContent: data.postContent
	
	            }).then(function (response) {
	                if (data.callback) {
	                    data.callback(response.data);
	                }
	            });
	        },
	        'classifiedsPage/submitEditedClassifiedsPost': function classifiedsPageSubmitEditedClassifiedsPost(context, data) {
	            _axios2.default.post('/api/classifieds/edit', {
	                postId: data.postId,
	                postTitle: data.postTitle,
	                postContent: data.postContent
	            }).then(function (response) {
	                if (data.callback) {
	                    data.callback(response.data);
	                }
	            });
	        },
	        'classifiedsPage/deleteClassifiedsPost': function classifiedsPageDeleteClassifiedsPost(context, data) {
	            _axios2.default.post('/api/classifieds/delete', {
	                postId: data.postId
	            }).then(function (response) {
	                if (data.callback) {
	                    data.callback(response.data);
	                }
	            });
	        },
	        'classifiedsPage/getClassifiedPost': function classifiedsPageGetClassifiedPost(context, data) {
	            _axios2.default.get('/api/classifieds/post', {
	                params: {
	                    postId: data.postId
	                }
	            }).then(function (response) {
	                if (data.callback) {
	                    data.callback(response.data);
	                }
	            });
	        }
	    },
	
	    mutations: {
	        'classifiedsPage/setClassifieds': function classifiedsPageSetClassifieds(state, data) {
	            state.posts = data;
	        }
	    }
	
	};

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(75);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _vue = __webpack_require__(4);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _router = __webpack_require__(30);
	
	var _router2 = _interopRequireDefault(_router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    state: {
	        developerInformation: {},
	        developerConnections: {},
	        retrievedInformation: false,
	        retrievedConnections: false,
	        isSavingEdit: false,
	        fetchError: ''
	    },
	
	    actions: {
	        'developerPage/getDeveloperInformation': function developerPageGetDeveloperInformation(context, data) {
	            var payload = {
	                stringUrl: data.toLowerCase()
	            };
	
	            context.state.retrievedInformation = false;
	
	            _axios2.default.get('/api/developer', {
	                params: payload
	            }).then(function (response) {
	                context.commit('developerPage/setDeveloperInformation', response.data);
	                if (!response.data.error) {
	                    context.dispatch('developerPage/getDeveloperConnections', { id: response.data.id });
	                    context.state.fetchError = '';
	                } else {
	                    context.state.fetchError = response.data.error;
	                }
	            }, function (response) {
	                console.log(response);
	            });
	        },
	
	        'developerPage/getDeveloperConnections': function developerPageGetDeveloperConnections(context, data) {
	            _axios2.default.get('/api/follows', {
	                params: {
	                    followType: 'developer',
	                    id: data.id
	                }
	            }).then(function (response) {
	                context.commit('developerPage/setDeveloperConnections', response.data);
	            }, function (response) {});
	        },
	
	        'developerPage/SaveAvatar': function developerPageSaveAvatar(context, data) {
	            var formData = new FormData();
	            formData.append('avatarFile', data);
	
	            _axios2.default.post('/api/developer/uploadAvatar', formData).then(function (response) {
	                if (response.data.response === 'unsuccessful') {
	                    alert("Maximum filesize for an Avatar is 10MB");
	                } else {
	                    context.dispatch('developerPage/getDeveloperInformation', context.state.developerInformation.stringUrl);
	                }
	            }, function (response) {});
	        },
	        'developerPage/updateBasicInfo': function developerPageUpdateBasicInfo(context, data) {
	            _axios2.default.post('/api/developer/basicInfo', data).then(function (response) {
	                context.dispatch('developerPage/getDeveloperInformation', context.state.developerInformation.stringUrl);
	            }, function (response) {});
	        },
	        'developerPage/updateRolesAndSkills': function developerPageUpdateRolesAndSkills(context, data) {
	            _axios2.default.post('/api/developer/rolesAndSkills', data).then(function (response) {
	                context.dispatch('developerPage/getDeveloperInformation', context.state.developerInformation.stringUrl);
	            }, function (response) {});
	        },
	        'developerPage/updateNetworking': function developerPageUpdateNetworking(context, data) {
	            _axios2.default.post('/api/developer/networking', data).then(function (response) {
	                context.dispatch('developerPage/getDeveloperInformation', context.state.developerInformation.stringUrl);
	            }, function (response) {});
	        },
	        'developerPage/updateWebsites': function developerPageUpdateWebsites(context, data) {
	            data.personalWebsites = (0, _stringify2.default)(_lodash2.default.cloneDeep(data.personalWebsites));
	
	            _axios2.default.post('/api/developer/websites', data).then(function (response) {
	                context.dispatch('developerPage/getDeveloperInformation', context.state.developerInformation.stringUrl);
	            }, function (response) {});
	        },
	        'developerPage/updateWorkHistory': function developerPageUpdateWorkHistory(context, data) {
	            data.workHistory = (0, _stringify2.default)(_lodash2.default.cloneDeep(data.workHistory));
	
	            _axios2.default.post('/api/developer/workHistory', data).then(function (response) {
	                context.dispatch('developerPage/getDeveloperInformation', context.state.developerInformation.stringUrl);
	            }, function (response) {});
	        },
	        'developerPage/updateEducationHistory': function developerPageUpdateEducationHistory(context, data) {
	            data.educationHistory = (0, _stringify2.default)(_lodash2.default.cloneDeep(data.educationHistory));
	
	            _axios2.default.post('/api/developer/educationHistory', data).then(function (response) {
	                context.dispatch('developerPage/getDeveloperInformation', context.state.developerInformation.stringUrl);
	            }, function (response) {});
	        },
	        'developerPage/banDeveloper': function developerPageBanDeveloper(context, data) {
	            data.educationHistory = (0, _stringify2.default)(_lodash2.default.cloneDeep(data.educationHistory));
	
	            _axios2.default.post('/api/developer/ban', data).then(function (response) {
	                context.dispatch('developerPage/getDeveloperInformation', context.state.developerInformation.stringUrl);
	            }, function (response) {});
	        },
	        'developerPage/unBanDeveloper': function developerPageUnBanDeveloper(context, data) {
	            _axios2.default.post('/api/developer/unBan', data).then(function (response) {
	                context.dispatch('developerPage/getDeveloperInformation', context.state.developerInformation.stringUrl);
	            }, function (response) {});
	        },
	        'developerPage/updateFollowStatus': function developerPageUpdateFollowStatus(context, data) {
	            _axios2.default.post('/api/follows', {
	                parentType: 'developer',
	                parentId: context.state.developerInformation.id
	            }).then(function (response) {
	                context.dispatch('developerPage/getDeveloperConnections', { id: response.data.parentId });
	            }, function (response) {});
	        }
	    },
	
	    mutations: {
	        'developerPage/setDeveloperInformation': function developerPageSetDeveloperInformation(state, data) {
	            if (data.error) {
	                return;
	            }
	
	            state.developerInformation = data;
	            state.retrievedInformation = true;
	        },
	
	        'developerPage/setDeveloperConnections': function developerPageSetDeveloperConnections(state, data) {
	            if (data.error) {
	                return;
	            }
	
	            state.developerConnections = data;
	            state.retrievedConnections = true;
	        },
	
	        'developerPage/updateInformation': function developerPageUpdateInformation(state, data) {
	            if (!state.developerInformation.id || data.developerId !== state.developerInformation.id) {
	                return;
	            }
	
	            if (data.firstName !== undefined) {
	                _vue2.default.set(state.developerInformation, 'firstName', data.firstName);
	            }
	
	            if (data.lastName !== undefined) {
	                _vue2.default.set(state.developerInformation, 'lastName', data.lastName);
	            }
	
	            if (data.gender !== undefined) {
	                _vue2.default.set(state.developerInformation, 'gender', data.gender);
	            }
	
	            if (data.location !== undefined) {
	                _vue2.default.set(state.developerInformation, 'location', data.location);
	            }
	
	            if (data.locationLat !== undefined) {
	                _vue2.default.set(state.developerInformation, 'locationLat', data.locationLat);
	            }
	
	            if (data.locationLon !== undefined) {
	                _vue2.default.set(state.developerInformation, 'locationLon', data.locationLon);
	            }
	
	            if (data.useBirth !== undefined) {
	                _vue2.default.set(state.developerInformation, 'useBirth', data.useBirth);
	            }
	
	            if (data.birthMonth !== undefined) {
	                _vue2.default.set(state.developerInformation, 'birthMonth', data.birthMonth);
	            }
	
	            if (data.birthDay !== undefined) {
	                _vue2.default.set(state.developerInformation, 'birthDay', data.birthDay);
	            }
	
	            if (data.birthYear !== undefined) {
	                _vue2.default.set(state.developerInformation, 'birthYear', data.birthYear);
	            }
	
	            if (data.role !== undefined) {
	                _vue2.default.set(state.developerInformation, 'role', data.role);
	            }
	
	            if (data.skills !== undefined) {
	                _vue2.default.set(state.developerInformation, 'skills', data.skills);
	            }
	
	            if (data.isDesigner !== undefined) {
	                _vue2.default.set(state.developerInformation, 'isDesigner', data.isDesigner);
	            }
	
	            if (data.isDesigner !== undefined) {
	                _vue2.default.set(state.developerInformation, 'isDesigner', data.isDesigner);
	            }
	
	            if (data.isArtist !== undefined) {
	                _vue2.default.set(state.developerInformation, 'isArtist', data.isArtist);
	            }
	
	            if (data.isWriter !== undefined) {
	                _vue2.default.set(state.developerInformation, 'isWriter', data.isWriter);
	            }
	
	            if (data.isMusician !== undefined) {
	                _vue2.default.set(state.developerInformation, 'isMusician', data.isMusician);
	            }
	
	            if (data.isSfxArtist !== undefined) {
	                _vue2.default.set(state.developerInformation, 'isSfxArtist', data.isSfxArtist);
	            }
	
	            if (data.isProgrammer !== undefined) {
	                _vue2.default.set(state.developerInformation, 'isProgrammer', data.isProgrammer);
	            }
	
	            if (data.isTester !== undefined) {
	                _vue2.default.set(state.developerInformation, 'isTester', data.isTester);
	            }
	
	            if (data.isProducer !== undefined) {
	                _vue2.default.set(state.developerInformation, 'isProducer', data.isProducer);
	            }
	
	            if (data.lookingForDescription !== undefined) {
	                _vue2.default.set(state.developerInformation, 'lookingForDescription', data.lookingForDescription);
	            }
	
	            if (data.lookingForGame !== undefined) {
	                _vue2.default.set(state.developerInformation, 'lookingForGame', data.lookingForGame);
	            }
	
	            if (data.personalWebsites !== undefined) {
	                _vue2.default.set(state.developerInformation, 'personalWebsites', data.personalWebsites);
	            }
	
	            if (data.workHistory !== undefined) {
	                _vue2.default.set(state.developerInformation, 'workHistory', data.workHistory);
	            }
	
	            if (data.educationHistory !== undefined) {
	                _vue2.default.set(state.educationHistory, 'workHistory', data.educationHistory);
	            }
	        }
	    }
	
	};

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vue = __webpack_require__(4);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    state: {
	        donors: []
	    },
	
	    actions: {
	        'donationsPage/populateDonors': function donationsPagePopulateDonors(context) {
	            _axios2.default.get('/api/donors').then(function (response) {
	                context.commit('donationsPage/populateDonors', response.data);
	            }, function (response) {
	                console.log(response);
	            });
	        }
	    },
	
	    mutations: {
	        'donationsPage/populateDonors': function donationsPagePopulateDonors(state, data) {
	            state.donors = data.donors;
	        }
	    }
	
	};

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vue = __webpack_require__(4);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _lodash = __webpack_require__(6);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _router = __webpack_require__(30);
	
	var _router2 = _interopRequireDefault(_router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    state: {
	        gameInformation: {},
	        gameConnections: {},
	        gameMembers: {},
	        retrievedInformation: false,
	        retrievedConnections: false,
	        retrievedMembers: false,
	        isSavingEdit: false,
	        fetchError: ''
	    },
	
	    actions: {
	        'gamePage/getGameInformation': function gamePageGetGameInformation(context, data) {
	            context.state.retrievedInformation = false;
	            context.state.retrievedConnections = false;
	            context.state.retrievedMembers = false;
	
	            _axios2.default.get('/api/game', {
	                params: {
	                    stringUrl: data.toLowerCase()
	                }
	            }).then(function (response) {
	                if (!response.data.error) {
	                    context.commit('gamePage/setGameInformation', response.data);
	                    context.dispatch('gamePage/getGameConnections', { id: response.data.id });
	                    context.dispatch('gamePage/getGameMembers', { id: response.data.id });
	                    context.state.fetchError = '';
	                } else {
	                    context.state.fetchError = response.data.error;
	                }
	            }, function (response) {
	                console.log(response);
	            });
	        },
	
	        'gamePage/getGameConnections': function gamePageGetGameConnections(context, data) {
	            _axios2.default.get('/api/follows', {
	                params: {
	                    followType: 'game',
	                    id: data.id
	                }
	            }).then(function (response) {
	                context.commit('gamePage/setGameConnections', response.data);
	            }, function (response) {});
	        },
	
	        'gamePage/getGameMembers': function gamePageGetGameMembers(context, data) {
	            _axios2.default.get('/api/members', {
	                params: {
	                    parentId: data.id
	                }
	            }).then(function (response) {
	                context.commit('gamePage/setGameMembers', response.data);
	            }, function (response) {});
	        },
	
	        'gamePage/updateMember': function gamePageUpdateMember(context, data) {
	            _axios2.default.post('/api/members/update', {
	                member: data.member,
	                gameId: data.gameId
	            });
	        },
	
	        'gamePage/removeMember': function gamePageRemoveMember(context, data) {
	            _axios2.default.post('/api/members/remove', {
	                member: data.member,
	                gameId: data.gameId,
	                newOwnerId: data.newOwnerId
	            });
	        },
	
	        'gamePage/updateFollowStatus': function gamePageUpdateFollowStatus(context, data) {
	            _axios2.default.post('/api/follows', {
	                parentType: 'game',
	                parentId: context.state.gameInformation.id
	            }).then(function (response) {
	                context.dispatch('gamePage/getGameConnections', { id: response.data.parentId });
	            }, function (response) {});
	        },
	        'gamePage/updateGameInformation': function gamePageUpdateGameInformation(context, data) {
	            _axios2.default.post('/api/game/update', {
	                gameId: data.gameId,
	                platforms: data.platforms,
	                genres: data.genres,
	                rating: data.rating,
	                releaseDate: data.releaseDate,
	                devStatus: data.devStatus
	            });
	        },
	        'gamePage/updateVitals': function gamePageUpdateVitals(context, data) {
	            var formData = new FormData();
	            formData.append('gameId', data.gameId);
	            formData.append('avatarFile', data.avatarFile);
	            formData.append('alias', data.alias);
	
	            _axios2.default.post('/api/game/updateVitals', formData);
	        },
	        'gamePage/updateRecruitment': function gamePageUpdateRecruitment(context, data) {
	            _axios2.default.post('/api/game/updateRecruitment', data);
	        }
	    },
	
	    mutations: {
	        'gamePage/setGameInformation': function gamePageSetGameInformation(state, data) {
	            state.gameInformation = data;
	            state.retrievedInformation = true;
	        },
	
	        'gamePage/setGameConnections': function gamePageSetGameConnections(state, data) {
	            state.gameConnections = data;
	            state.retrievedConnections = true;
	        },
	
	        'gamePage/setGameMembers': function gamePageSetGameMembers(state, data) {
	            state.gameMembers = data;
	            state.retrievedMembers = true;
	        },
	
	        'gamePage/setGameMembersFromSocket': function gamePageSetGameMembersFromSocket(state, data) {
	            if (state.gameInformation.id === data.game) {
	                state.gameMembers = data.members;
	                state.retrievedMembers = true;
	            }
	        },
	
	        'gamePage/updateInformation': function gamePageUpdateInformation(state, data) {
	            if (!state.gameInformation.id || data.gameId !== state.gameInformation.id) {
	                return;
	            }
	
	            if (data.rating !== undefined) {
	                _vue2.default.set(state.gameInformation, 'rating', data.rating);
	            }
	
	            if (data.devStatus !== undefined) {
	                _vue2.default.set(state.gameInformation, 'devStatus', data.devStatus);
	            }
	
	            if (data.releaseDate !== undefined) {
	                _vue2.default.set(state.gameInformation, 'releaseDate', data.releaseDate);
	            }
	
	            if (data.platforms !== undefined) {
	                _vue2.default.set(state.gameInformation, 'platforms', data.platforms);
	            }
	
	            if (data.genres !== undefined) {
	                _vue2.default.set(state.gameInformation, 'genres', data.genres);
	            }
	
	            if (data.recruitingDescription !== undefined) {
	                _vue2.default.set(state.gameInformation, 'seekingDescription', data.recruitingDescription);
	            }
	
	            if (data.roleTitles !== undefined) {
	                _vue2.default.set(state.gameInformation, 'seekingRoles', data.roleTitles);
	            }
	
	            if (data.recruitingProducers !== undefined) {
	                _vue2.default.set(state.gameInformation, 'seekingProducers', data.recruitingProducers);
	            }
	
	            if (data.recruitingDesigners !== undefined) {
	                _vue2.default.set(state.gameInformation, 'seekingDesigners', data.recruitingDesigners);
	            }
	
	            if (data.recruitingArtists !== undefined) {
	                _vue2.default.set(state.gameInformation, 'seekingArtists', data.recruitingArtists);
	            }
	
	            if (data.recruitingProgrammers !== undefined) {
	                _vue2.default.set(state.gameInformation, 'seekingProgrammers', data.recruitingProgrammers);
	            }
	
	            if (data.recruitingMusicians !== undefined) {
	                _vue2.default.set(state.gameInformation, 'seekingMusicians', data.recruitingMusicians);
	            }
	
	            if (data.recruitingSfxArtists !== undefined) {
	                _vue2.default.set(state.gameInformation, 'seekingSfxArtists', data.recruitingSfxArtists);
	            }
	
	            if (data.recruitingWriters !== undefined) {
	                _vue2.default.set(state.gameInformation, 'seekingWriters', data.recruitingWriters);
	            }
	
	            if (data.recruitingTesters !== undefined) {
	                _vue2.default.set(state.gameInformation, 'seekingTesters', data.recruitingTesters);
	            }
	
	            if (data.skills !== undefined) {
	                _vue2.default.set(state.gameInformation, 'skills', data.skills);
	            }
	        },
	
	        'gamePage/updateVitals': function gamePageUpdateVitals(state, date) {
	            if (!state.gameInformation.id || data.gameId !== state.gameInformation.id) {
	                return;
	            }
	
	            _vue2.default.set(state.alias, 'genres', data.alias);
	            _vue2.default.set(state.stringUrl, 'genres', data.stringUrl);
	        }
	    }
	
	};

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vue = __webpack_require__(4);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _router = __webpack_require__(30);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    state: {
	        conversations: [],
	        selectedConversation: undefined,
	        retrievedConversations: false,
	        matchingDevsResponse: [],
	        notAllowedToViewConversation: false
	    },
	
	    actions: {
	        'InboxPage/getConversations': function InboxPageGetConversations(context) {
	            _axios2.default.get('/api/inbox').then(function (response) {
	                context.commit('InboxPage/setConversations', response.data);
	
	                if (context.rootState.route.params.id && context.rootState.route.params.id.toLowerCase() !== 'compose') {
	                    context.commit('InboxPage/setSelectedConversation', { conversationId: context.rootState.route.params.id });
	                    context.dispatch('InboxPage/getMessages');
	                }
	            }, function (response) {
	                console.log(response);
	            });
	        },
	        'InboxPage/updateConversation': function InboxPageUpdateConversation(context, conversationId) {
	            _axios2.default.get('/api/inbox/' + conversationId).then(function (response) {
	                var matchedConversation = void 0;
	
	                context.state.conversations.forEach(function (conversation) {
	                    if (conversation.id === conversationId) {
	                        matchedConversation = conversation;
	                        return false;
	                    }
	                });
	
	                if (matchedConversation) {
	                    _vue2.default.set(matchedConversation, 'participants', response.data.participants);
	                    _vue2.default.set(matchedConversation, 'hasBeenRead', response.data.hasBeenRead);
	                    _vue2.default.set(matchedConversation, 'lastMessageDate', response.data.lastMessageDate);
	                    _vue2.default.set(matchedConversation, 'subject', response.data.subject);
	                } else {
	                    context.dispatch('InboxPage/getConversations');
	                }
	            }, function (response) {
	                console.log(response);
	            });
	        },
	        'InboxPage/getMessages': function InboxPageGetMessages(context) {
	            if (!context.state.selectedConversation) {
	                return;
	            }
	
	            _axios2.default.get('/api/inboxMessages', {
	                params: {
	                    inboxId: context.state.selectedConversation.id
	                }
	            }).then(function (response) {
	                context.commit('InboxPage/setMessages', response.data);
	                context.dispatch('Inbox/setRead');
	            }, function (response) {
	                console.log(response);
	            });
	        },
	        'Inbox/setRead': function InboxSetRead(context) {
	            _axios2.default.post('/api/inboxSetRead', {
	                inboxId: context.state.selectedConversation.id
	            }).then(function (response) {
	                _vue2.default.set(context.state.selectedConversation, 'hasBeenRead', '1');
	            }, function (response) {
	                console.log(response);
	            });
	        },
	        'InboxPage/getMatchingDevNames': function InboxPageGetMatchingDevNames(context, search) {
	            _axios2.default.get('/api/searchDeveloperByAlias', {
	                params: {
	                    search: search
	                }
	            }).then(function (response) {
	                context.commit('InboxPage/getMatchingDevNames', response.data);
	            }, function (response) {
	                console.log(response);
	            });
	        },
	        'InboxPage/addParticipant': function InboxPageAddParticipant(context, participant) {
	            _axios2.default.post('/api/inboxAddParticipant', {
	                participantId: participant.id,
	                inboxId: context.state.selectedConversation.id
	            }).then(function (response) {
	                console.log(response);
	                context.dispatch('InboxPage/updateConversation', context.state.selectedConversation.id);
	            }, function (response) {
	                console.log(response);
	            });
	        },
	        'InboxPage/leaveConversation': function InboxPageLeaveConversation(context) {
	            _axios2.default.post('/api/inboxLeaveConversation', {
	                inboxId: context.state.selectedConversation.id
	            }).then(function (response) {
	                context.dispatch('InboxPage/getConversations');
	            }, function (response) {
	                console.log(response);
	            });
	        },
	        'InboxPage/addReplyMessage': function InboxPageAddReplyMessage(context, message) {
	            _axios2.default.post('/api/inboxMessages', {
	                inboxId: context.state.selectedConversation.id,
	                message: message
	            }).then(function (response) {}, function (response) {});
	        },
	        'InboxPage/AddNewConversation': function InboxPageAddNewConversation(context, data) {
	            _axios2.default.post('/api/inbox/new', {
	                participants: data.participants,
	                subject: data.subject,
	                message: data.message
	            }).then(function (response) {
	                _router2.default.push('/Inbox');
	            }, function (response) {});
	        }
	    },
	
	    mutations: {
	        'InboxPage/setConversations': function InboxPageSetConversations(state, data) {
	            state.conversations = data;
	            state.retrievedConversations = true;
	        },
	        'InboxPage/setSelectedConversation': function InboxPageSetSelectedConversation(state, data) {
	            var self = this,
	                allConvos = state.conversations,
	                selectedConvo = void 0;
	
	            state.notAllowedToViewConversation = false;
	
	            allConvos.forEach(function (convo) {
	                if (convo.id == data.conversationId) {
	                    selectedConvo = convo;
	                }
	            });
	
	            if (selectedConvo) {
	                state.selectedConversation = selectedConvo;
	            } else {
	                state.notAllowedToViewConversation = true;
	            }
	        },
	        'InboxPage/setMessages': function InboxPageSetMessages(state, data) {
	            _vue2.default.set(state.selectedConversation, 'messages', data);
	        },
	        'InboxPage/getMatchingDevNames': function InboxPageGetMatchingDevNames(state, data) {
	            state.matchingDevsResponse = data;
	        }
	    }
	
	};

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vue = __webpack_require__(4);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    state: {
	        invitationsToGames: [],
	        requestsToJoin: [],
	        sentInvitationsToGames: [],
	        sentRequestsToJoin: [],
	        fetchErrors: [],
	        fetchStatus: 'unfetched'
	    },
	
	    actions: {
	        'invites/fetchInvites': function invitesFetchInvites(context) {
	            context.state.fetchStatus = 'fetching';
	
	            _axios2.default.get('/api/invites').then(function (response) {
	                context.state.fetchStatus = 'fetched';
	
	                if (response.data.errors) {
	                    context.state.fetchErrors = response.data.errors;
	                    return;
	                }
	
	                context.state.invitationsToGames = response.data.invitationsToGames ? response.data.invitationsToGames : [];
	                context.state.requestsToJoin = response.data.requestsToJoin ? response.data.requestsToJoin : [];
	                context.state.sentInvitationsToGames = response.data.sentInvitationsToGames ? response.data.sentInvitationsToGames : [];
	                context.state.sentRequestsToJoin = response.data.sentRequestsToJoin ? response.data.sentRequestsToJoin : [];
	            }, function (response) {
	                context.state.fetchErrors = ['There was a problem connecting to the server. Please reload and try again.'];
	            });
	        }
	    },
	
	    mutations: {
	        'invites/setInvites': function invitesSetInvites(state, data) {}
	    }
	
	};

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vue = __webpack_require__(4);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _crypto = __webpack_require__(363);
	
	var _crypto2 = _interopRequireDefault(_crypto);
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    state: {
	        validationMessage: '',
	        email: '',
	        password: '',
	        rememberMe: false,
	        isLoggedIn: false
	    },
	
	    actions: {
	        'loginPage/validateLogin': function loginPageValidateLogin(context, callback) {
	            var sha256 = _crypto2.default.createHash('sha256'),
	                password = sha256.update(context.state.password).digest('hex'),
	                email = context.state.email;
	
	            var payload = {
	                email: email,
	                password: password
	            };
	
	            _axios2.default.post('/api/login', payload).then(function (response) {
	                callback({
	                    status: response.data.isLoggedIn ? 'online' : 'offline',
	                    id: response.data.isLoggedIn ? response.data.info.id : 0,
	                    alias: response.data.isLoggedIn ? response.data.info.alias : '',
	                    stringUrl: response.data.isLoggedIn ? response.data.info.stringUrl : '',
	                    passkey: response.data.isLoggedIn ? response.data.info.passkey : ''
	                });
	                context.state.validationMessage = response.data.validationMessage;
	                context.commit('loggedUserModel/setLoggedUserInfo', response.data);
	            }, function (response) {
	                console.log(response);
	            });
	        }
	    },
	
	    mutations: {
	        'loginPage/updateEmail': function loginPageUpdateEmail(state, data) {
	            state.email = data;
	        },
	
	        'loginPage/updatePassword': function loginPageUpdatePassword(state, data) {
	            state.password = data;
	        }
	    }
	
	};

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vue = __webpack_require__(4);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    state: {
	        onlineUsers: []
	    },
	
	    actions: {},
	
	    mutations: {
	        'onlineUsers/setOnlineUsers': function onlineUsersSetOnlineUsers(state, data) {
	            _vue2.default.set(state, 'onlineUsers', data);
	        }
	    }
	
	};

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vue = __webpack_require__(4);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    state: {
	        conversations: [],
	        selectedConversation: undefined,
	        messages: {},
	        historyMessages: {},
	        historyDates: {},
	        temporaryConversations: []
	    },
	
	    actions: {
	        'privateChat/getConversations': function privateChatGetConversations(context) {
	            _axios2.default.get('/api/privateChat/allConversations').then(function (response) {
	                context.commit('privateChat/setConversations', response.data);
	            });
	        },
	        'privateChat/getMessages': function privateChatGetMessages(context, data) {
	            if (context.state.messages[data.chatId] && !data.forceReFetch) {
	                context.commit('privateChat/setMessages', {
	                    chatId: data.chatId,
	                    messages: context.state.messages[data.chatId]
	                });
	
	                if (data.callback) {
	                    data.callback();
	                }
	                return;
	            }
	
	            _axios2.default.get('/api/privateChat/messages', {
	                params: {
	                    chatId: data.chatId
	                }
	            }).then(function (response) {
	                context.commit('privateChat/setMessages', {
	                    chatId: data.chatId,
	                    messages: response.data
	                });
	
	                if (data.callback) {
	                    data.callback();
	                }
	            });
	        },
	        'privateChat/sendMessage': function privateChatSendMessage(context, data) {
	            _axios2.default.post('/api/privateChat/message', data);
	        },
	        'privateChat/sendNewConversation': function privateChatSendNewConversation(context, data) {
	            _axios2.default.post('/api/privateChat/newConversation', {
	                participantId: data.participantId,
	                message: data.message
	            }).then(function (response) {
	                if (data.callback) {
	                    data.callback(response.data.newChatId);
	                }
	            });
	        },
	        'privateChat/markReadConversation': function privateChatMarkReadConversation(context, data) {
	            _axios2.default.post('/api/privateChat/markRead', { chatId: data.chatId });
	        },
	        'privateChat/getHistoryDates': function privateChatGetHistoryDates(context) {
	            if (context.state.selectedConversation === undefined) {
	                return;
	            }
	
	            _axios2.default.get('/api/privateChat/historyDates', {
	                params: {
	                    chatId: context.state.selectedConversation.chatId
	                }
	            }).then(function (response) {
	                context.commit('privateChat/setHistoryDates', {
	                    chatId: context.state.selectedConversation.chatId,
	                    history: response.data.history
	                });
	            });
	        },
	        'privateChat/getHistoryForDate': function privateChatGetHistoryForDate(context, data) {
	            if (context.state.selectedConversation === undefined || data.selectedHistoryDate === undefined || data.callback === undefined) {
	                return;
	            }
	
	            if (context.state.historyMessages[context.state.selectedConversation.chatId + "_" + data.selectedHistoryDate.day]) {
	                data.callback();
	                return;
	            }
	
	            _axios2.default.get('/api/privateChat/historyMessages', {
	                params: {
	                    chatId: context.state.selectedConversation.chatId,
	                    historyDate: data.selectedHistoryDate.day
	                }
	            }).then(function (response) {
	                context.commit('privateChat/setHistoryMessages', {
	                    date: data.selectedHistoryDate.day, messages: response.data
	                });
	                data.callback();
	            });
	        }
	    },
	
	    mutations: {
	        'privateChat/setConversations': function privateChatSetConversations(state, data) {
	            _vue2.default.set(state, 'conversations', data);
	        },
	        'privateChat/setActiveConversation': function privateChatSetActiveConversation(state, conversation) {
	            _vue2.default.set(state, 'selectedConversation', conversation);
	        },
	        'privateChat/setMessages': function privateChatSetMessages(state, data) {
	            _vue2.default.set(state.messages, data.chatId, data.messages);
	        },
	        'privateChat/setHistoryDates': function privateChatSetHistoryDates(state, data) {
	            _vue2.default.set(state.historyDates, data.chatId, data.history);
	        },
	        'privateChat/setHistoryMessages': function privateChatSetHistoryMessages(state, data) {
	            _vue2.default.set(state.historyMessages, state.selectedConversation.chatId + "_" + data.date, data.messages);
	        },
	        'privateChat/addTemporaryConversation': function privateChatAddTemporaryConversation(state, data) {
	            var x = state.temporaryConversations;
	            var z = {
	                chatId: data.self.id + "." + data.participant.id,
	                partnerAlias: data.participant.alias,
	                lastMessageTime: new Date().getTime()
	            };
	
	            x.push(z);
	            _vue2.default.set(state, 'temporaryConversations', x);
	        }
	    }
	
	};

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _vue = __webpack_require__(4);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _axios = __webpack_require__(2);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    state: {
	        resources: [],
	        submittedNewResource: false
	    },
	
	    actions: {
	        'resourcesPage/populateResources': function resourcesPagePopulateResources(context) {
	            _axios2.default.get('/api/resources').then(function (response) {
	                context.commit('resourcesPage/populateResources', response.data);
	            }, function (response) {
	                console.log(response);
	            });
	        },
	
	        'resourcesPage/submitResource': function resourcesPageSubmitResource(context, data) {
	            _axios2.default.post('/api/resources', data).then(function (response) {
	                context.dispatch('resourcesPage/populateResources');
	                context.state.submittedNewResource = true;
	            }, function (response) {
	                console.log(response);
	            });
	        }
	    },
	
	    mutations: {
	        'resourcesPage/populateResources': function resourcesPagePopulateResources(state, data) {
	            state.resources = data.resources;
	        }
	    }
	
	};

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (options) {
	    var VueRouter = options.VueRouter;
	
	    var routes = [{
	        path: '',
	        component: _LayoutFullWithChat2.default,
	        meta: { subNavRoute: 'homeDashboard' },
	        children: [{
	            path: '',
	            component: _HomeDashboard2.default,
	            meta: { subNavRoute: 'homeDashboard' }
	        }]
	    }, {
	        path: '/TermsAndConditions',
	        component: _LayoutFullWithChat2.default,
	        meta: { subNavRoute: 'terms' },
	        children: [{
	            path: '',
	            component: _Terms2.default,
	            meta: { subNavRoute: 'terms' }
	        }]
	    }, {
	        path: '/PrivacyPolicy',
	        component: _LayoutFullWithChat2.default,
	        meta: { subNavRoute: 'privacy' },
	        children: [{
	            path: '',
	            component: _PrivacyPolicy2.default,
	            meta: { subNavRoute: 'privacy' }
	        }]
	    }, {
	        path: '/Media',
	        component: _LayoutFullWithChat2.default,
	        meta: { subNavRoute: 'media' },
	        children: [{
	            path: '',
	            component: _MediaFeed2.default,
	            meta: { subNavRoute: 'media' }
	        }]
	    }, {
	        path: '/Classifieds',
	        component: _LayoutFullWithChat2.default,
	        meta: { subNavRoute: 'classifieds' },
	        children: [{
	            path: '',
	            component: _Classifieds2.default,
	            meta: { subNavRoute: 'classifieds' }
	        }, {
	            path: 'New',
	            component: _ClassifiedsNew2.default,
	            meta: { subNavRoute: 'classifieds' }
	        }, {
	            path: 'Edit/:id',
	            component: _ClassifiedsEdit2.default,
	            meta: { subNavRoute: 'classifieds' }
	        }]
	    }, {
	        path: '/Donations',
	        component: _LayoutFullWithChat2.default,
	        meta: { subNavRoute: 'donations' },
	        children: [{
	            path: '',
	            component: _DonationsPage2.default,
	            meta: { subNavRoute: 'donations' }
	        }]
	    }, {
	        path: '/DevLogs',
	        component: _LayoutFullWithChat2.default,
	        meta: { subNavRoute: 'devlogs' },
	        children: [{
	            path: '',
	            component: _BlogFeed2.default,
	            meta: { subNavRoute: 'devlogs' }
	        }]
	    }, {
	        path: '/BugsAndSuggestions',
	        component: _LayoutFullWithChat2.default,
	        children: [{
	            path: '',
	            component: _BugsAndSuggestions2.default
	        }]
	    }, {
	        path: '/inbox',
	        component: _LayoutFullWithChat2.default,
	        children: [{
	            path: '',
	            component: _InboxHome2.default
	        }, {
	            path: ':id',
	            component: _InboxHome2.default
	        }]
	    }, {
	        path: '/InviteToGame',
	        component: _LayoutFullWithChat2.default,
	        children: [{
	            path: '',
	            component: _InviteToGameForm2.default
	        }, {
	            path: ':inviteMemberStringUrl',
	            component: _InviteToGameForm2.default
	        }, {
	            path: '*',
	            component: _InviteToGameForm2.default
	        }]
	    }, {
	        path: '/RequestToJoin',
	        component: _LayoutFullWithChat2.default,
	        children: [{
	            path: '',
	            component: _RequestToJoinForm2.default
	        }, {
	            path: ':requestGameStringUrl',
	            component: _RequestToJoinForm2.default
	        }, {
	            path: '*',
	            component: _RequestToJoinForm2.default
	        }]
	    }, {
	        path: '/Invites',
	        component: _LayoutFullWithChat2.default,
	        children: [{
	            path: '',
	            component: _InvitesPage2.default
	        }, {
	            path: '*',
	            component: _InvitesPage2.default
	        }]
	    }, {
	        path: '/Notifications',
	        component: _LayoutFullWithChat2.default,
	        children: [{
	            path: '',
	            component: _Notifications2.default
	        }, {
	            path: '*',
	            component: _Notifications2.default
	        }]
	    }, {
	        path: '/Browse',
	        component: _LayoutFullWithChat2.default,
	        meta: { subNavRoute: 'browseDevs' },
	        children: [{
	            path: '',
	            component: _BrowsePage2.default,
	            meta: { subNavRoute: 'browseDevs' }
	        }, {
	            path: 'Games',
	            component: _BrowsePage2.default,
	            meta: { subNavRoute: 'browseGames' }
	        }, {
	            path: '*',
	            component: _BrowsePage2.default,
	            meta: { subNavRoute: 'browseDevs' }
	        }]
	    }, {
	        path: '/Forums/',
	        component: _LayoutFullWithChat2.default,
	        meta: { subNavRoute: 'forums' },
	        children: [{
	            path: '',
	            component: _ForumsPage2.default,
	            meta: { subNavRoute: 'forums' }
	        }, {
	            path: ':category',
	            component: _ForumsPage2.default,
	            meta: { subNavRoute: 'forums' }
	        }, {
	            path: ':category/:forum',
	            component: _ForumsPage2.default,
	            meta: { subNavRoute: 'forums' }
	        }, {
	            path: ':category/:forum/:thread',
	            component: _ForumsPage2.default,
	            meta: { subNavRoute: 'forums' }
	        }, {
	            path: '*',
	            component: _FourOhFour2.default,
	            meta: { subNavRoute: 'forums' }
	        }]
	    }, {
	        path: '/TheBoard/',
	        component: _LayoutFullWithChat2.default,
	        meta: { subNavRoute: 'theBoard' },
	        children: [{
	            path: '',
	            component: _TheBoardPage2.default,
	            meta: { subNavRoute: 'theBoard' }
	        }, {
	            path: ':post',
	            component: _TheBoardPage2.default,
	            meta: { subNavRoute: 'theBoard' }
	        }, {
	            path: '*',
	            component: _TheBoardPage2.default,
	            meta: { subNavRoute: 'theBoard' }
	        }]
	
	    }, {
	        path: '/Resources',
	        component: _LayoutFullWithChat2.default,
	        meta: { subNavRoute: 'resources' },
	        children: [{
	            path: '',
	            component: _ResourcesPage2.default,
	            meta: { subNavRoute: 'resourcesDevTools' }
	        }, {
	            path: 'DevTools',
	            component: _ResourcesPage2.default,
	            meta: { subNavRoute: 'resourcesDevTools' },
	            children: [{
	                path: '*',
	                component: _ResourcesPage2.default,
	                meta: { subNavRoute: 'resourcesDevTools' }
	            }]
	        }, {
	            path: 'Assets',
	            component: _ResourcesPage2.default,
	            meta: { subNavRoute: 'resourcesAssets' },
	            children: [{
	                path: '*',
	                component: _ResourcesPage2.default,
	                meta: { subNavRoute: 'resourcesAssets' }
	            }]
	        }, {
	            path: '*',
	            component: _ResourcesPage2.default,
	            meta: { subNavRoute: 'resources' }
	        }]
	    }, {
	        path: '/Login',
	        component: _LayoutFullWithChat2.default,
	        children: [{
	            path: '',
	            component: _LoginPage2.default
	        }, {
	            path: 'Forgot',
	            component: _ForgotPassword2.default
	        }, {
	            path: 'Update/:keycode',
	            component: _UpdatePassword2.default
	        }]
	    }, {
	        path: '/Register',
	        component: _LayoutFullWithChat2.default,
	        children: [{
	            path: '',
	            component: _Register2.default
	        }]
	    }, {
	        path: '/CreateNewGameProject',
	        component: _LayoutFullWithChat2.default,
	        children: [{
	            path: '',
	            component: _CreateGamePage2.default
	        }]
	    }, {
	        path: '/Game',
	        component: _LayoutFullWithChat2.default,
	        meta: { subNavRoute: 'browseGames', noScrollTag: 'gamePage' },
	        children: [{
	            path: '',
	            component: _FourOhFour2.default,
	            meta: { subNavRoute: 'browseGames', noScrollTag: 'gamePage' }
	        }, {
	            path: ':game/',
	            component: _GamePage2.default,
	            children: [{
	                path: 'Post/:id',
	                component: _GameSinglePost2.default,
	                meta: { subNavRoute: 'browseGames', noScrollTag: 'gamePage' }
	            }, {
	                path: 'Media',
	                component: _GameMedia2.default,
	                meta: { subNavRoute: 'browseGames', noScrollTag: 'gamePage' }
	            }, {
	                path: 'Media/:album',
	                component: _GameMedia2.default,
	                meta: { subNavRoute: 'browseGames', noScrollTag: 'gamePage' }
	            }, {
	                path: 'Media/:album/:piece',
	                component: _GameMedia2.default,
	                meta: { subNavRoute: 'browseGames', noScrollTag: 'gamePage' }
	            }, {
	                path: 'Media/:album/:piece/:edit',
	                component: _GameMedia2.default,
	                meta: { subNavRoute: 'browseGames', noScrollTag: 'gamePage' }
	            }, {
	                path: 'Members',
	                component: _GameMembers2.default,
	                meta: { subNavRoute: 'browseGames', noScrollTag: 'gamePage' }
	            }, {
	                path: 'Forums',
	                component: _GameForums2.default,
	                meta: { subNavRoute: 'browseGames', noScrollTag: 'gamePage' },
	                children: [{
	                    path: '',
	                    component: _GameForums2.default,
	                    meta: { subNavRoute: 'browseGames', noScrollTag: 'gamePage' }
	                }, {
	                    path: ':category',
	                    component: _GameForums2.default,
	                    meta: { subNavRoute: 'browseGames', noScrollTag: 'gamePage' }
	                }, {
	                    path: ':category/:forum',
	                    component: _GameForums2.default,
	                    meta: { subNavRoute: 'browseGames', noScrollTag: 'gamePage' }
	                }, {
	                    path: ':category/:forum/:thread',
	                    component: _GameForums2.default,
	                    meta: { subNavRoute: 'browseGames', noScrollTag: 'gamePage' }
	                }, {
	                    path: '*',
	                    component: _FourOhFour2.default,
	                    meta: { subNavRoute: 'browseGames', noScrollTag: 'gamePage' }
	                }]
	            }, {
	                path: 'Followers',
	                component: _GameFollowers2.default,
	                meta: { subNavRoute: 'browseGames', noScrollTag: 'gamePage' }
	            }, {
	                path: '',
	                component: _GameFeed2.default,
	                meta: { subNavRoute: 'browseGames', noScrollTag: 'gamePage' }
	            }, {
	                path: '*',
	                component: _GameFeed2.default,
	                meta: { subNavRoute: 'browseGames', noScrollTag: 'gamePage' }
	            }]
	        }]
	    }, {
	        path: '/Developer',
	        component: _LayoutFullWithChat2.default,
	        meta: { subNavRoute: 'browseDevs', noScrollTag: 'devPage' },
	        children: [{
	            path: '',
	            component: _FourOhFour2.default,
	            meta: { subNavRoute: 'browseDevs', noScrollTag: 'devPage' }
	        }, {
	            path: ':developer/',
	            component: _DeveloperPage2.default,
	            meta: { subNavRoute: 'browseDevs', noScrollTag: 'devPage' },
	            children: [{
	                path: 'Feed',
	                component: _DeveloperFeed2.default,
	                meta: { subNavRoute: 'browseDevs', noScrollTag: 'devPage' }
	            }, {
	                path: 'Post/:id',
	                component: _DeveloperSinglePost2.default,
	                meta: { subNavRoute: 'browseDevs', noScrollTag: 'devPage' }
	            }, {
	                path: 'Portfolio',
	                component: _DeveloperPortfolio2.default,
	                meta: { subNavRoute: 'browseDevs', noScrollTag: 'devPage' }
	            }, {
	                path: 'Portfolio/:album',
	                component: _DeveloperPortfolio2.default,
	                meta: { subNavRoute: 'browseDevs', noScrollTag: 'devPage' }
	            }, {
	                path: 'Portfolio/:album/:piece',
	                component: _DeveloperPortfolio2.default,
	                meta: { subNavRoute: 'browseDevs', noScrollTag: 'devPage' }
	            }, {
	                path: 'Portfolio/:album/:piece/:edit',
	                component: _DeveloperPortfolio2.default,
	                meta: { subNavRoute: 'browseDevs', noScrollTag: 'devPage' }
	            }, {
	                path: 'Connections',
	                component: _DeveloperConnections2.default,
	                meta: { subNavRoute: 'browseDevs', noScrollTag: 'devPage' }
	            }, {
	                path: '',
	                component: _DeveloperFeed2.default,
	                meta: { subNavRoute: 'browseDevs', noScrollTag: 'devPage' }
	            }, {
	                path: '*',
	                component: _DeveloperFeed2.default,
	                meta: { subNavRoute: 'browseDevs', noScrollTag: 'devPage' }
	            }]
	        }]
	    }, {
	        path: '*',
	        component: _LayoutFullWithChat2.default,
	        children: [{
	            path: '',
	            component: _FourOhFour2.default
	        }]
	    }];
	
	    return new VueRouter({
	        mode: 'history',
	        routes: routes,
	        scrollBehavior: function scrollBehavior(to, from, savedPosition) {
	            var shouldScrollToTop = !(to.meta.noScrollTag && from.meta.noScrollTag === to.meta.noScrollTag);
	
	            if (!shouldScrollToTop) {
	                return;
	            }
	
	            if (savedPosition) {
	                return savedPosition;
	            } else {
	                return { x: 0, y: 0 };
	            }
	        }
	    });
	};
	
	var _LayoutFullWithChat = __webpack_require__(742);
	
	var _LayoutFullWithChat2 = _interopRequireDefault(_LayoutFullWithChat);
	
	var _FourOhFour = __webpack_require__(716);
	
	var _FourOhFour2 = _interopRequireDefault(_FourOhFour);
	
	var _MediaFeed = __webpack_require__(807);
	
	var _MediaFeed2 = _interopRequireDefault(_MediaFeed);
	
	var _BlogFeed = __webpack_require__(746);
	
	var _BlogFeed2 = _interopRequireDefault(_BlogFeed);
	
	var _Classifieds = __webpack_require__(752);
	
	var _Classifieds2 = _interopRequireDefault(_Classifieds);
	
	var _ClassifiedsNew = __webpack_require__(754);
	
	var _ClassifiedsNew2 = _interopRequireDefault(_ClassifiedsNew);
	
	var _ClassifiedsEdit = __webpack_require__(753);
	
	var _ClassifiedsEdit2 = _interopRequireDefault(_ClassifiedsEdit);
	
	var _ResourcesPage = __webpack_require__(812);
	
	var _ResourcesPage2 = _interopRequireDefault(_ResourcesPage);
	
	var _InboxHome = __webpack_require__(794);
	
	var _InboxHome2 = _interopRequireDefault(_InboxHome);
	
	var _BrowsePage = __webpack_require__(747);
	
	var _BrowsePage2 = _interopRequireDefault(_BrowsePage);
	
	var _LoginPage = __webpack_require__(805);
	
	var _LoginPage2 = _interopRequireDefault(_LoginPage);
	
	var _ForgotPassword = __webpack_require__(804);
	
	var _ForgotPassword2 = _interopRequireDefault(_ForgotPassword);
	
	var _UpdatePassword = __webpack_require__(806);
	
	var _UpdatePassword2 = _interopRequireDefault(_UpdatePassword);
	
	var _Register = __webpack_require__(811);
	
	var _Register2 = _interopRequireDefault(_Register);
	
	var _DeveloperPage = __webpack_require__(757);
	
	var _DeveloperPage2 = _interopRequireDefault(_DeveloperPage);
	
	var _DeveloperFeed = __webpack_require__(759);
	
	var _DeveloperFeed2 = _interopRequireDefault(_DeveloperFeed);
	
	var _DeveloperSinglePost = __webpack_require__(761);
	
	var _DeveloperSinglePost2 = _interopRequireDefault(_DeveloperSinglePost);
	
	var _DeveloperPortfolio = __webpack_require__(760);
	
	var _DeveloperPortfolio2 = _interopRequireDefault(_DeveloperPortfolio);
	
	var _DeveloperConnections = __webpack_require__(758);
	
	var _DeveloperConnections2 = _interopRequireDefault(_DeveloperConnections);
	
	var _CreateGamePage = __webpack_require__(755);
	
	var _CreateGamePage2 = _interopRequireDefault(_CreateGamePage);
	
	var _GamePage = __webpack_require__(773);
	
	var _GamePage2 = _interopRequireDefault(_GamePage);
	
	var _GameFeed = __webpack_require__(774);
	
	var _GameFeed2 = _interopRequireDefault(_GameFeed);
	
	var _GameSinglePost = __webpack_require__(781);
	
	var _GameSinglePost2 = _interopRequireDefault(_GameSinglePost);
	
	var _GameFollowers = __webpack_require__(775);
	
	var _GameFollowers2 = _interopRequireDefault(_GameFollowers);
	
	var _GameForums = __webpack_require__(776);
	
	var _GameForums2 = _interopRequireDefault(_GameForums);
	
	var _GameMembers = __webpack_require__(778);
	
	var _GameMembers2 = _interopRequireDefault(_GameMembers);
	
	var _GameMedia = __webpack_require__(777);
	
	var _GameMedia2 = _interopRequireDefault(_GameMedia);
	
	var _InvitesPage = __webpack_require__(797);
	
	var _InvitesPage2 = _interopRequireDefault(_InvitesPage);
	
	var _InviteToGameForm = __webpack_require__(795);
	
	var _InviteToGameForm2 = _interopRequireDefault(_InviteToGameForm);
	
	var _RequestToJoinForm = __webpack_require__(798);
	
	var _RequestToJoinForm2 = _interopRequireDefault(_RequestToJoinForm);
	
	var _Notifications = __webpack_require__(808);
	
	var _Notifications2 = _interopRequireDefault(_Notifications);
	
	var _BugsAndSuggestions = __webpack_require__(750);
	
	var _BugsAndSuggestions2 = _interopRequireDefault(_BugsAndSuggestions);
	
	var _ForumsPage = __webpack_require__(771);
	
	var _ForumsPage2 = _interopRequireDefault(_ForumsPage);
	
	var _TheBoardPage = __webpack_require__(813);
	
	var _TheBoardPage2 = _interopRequireDefault(_TheBoardPage);
	
	var _HomeDashboard = __webpack_require__(787);
	
	var _HomeDashboard2 = _interopRequireDefault(_HomeDashboard);
	
	var _DonationsPage = __webpack_require__(770);
	
	var _DonationsPage2 = _interopRequireDefault(_DonationsPage);
	
	var _Terms = __webpack_require__(803);
	
	var _Terms2 = _interopRequireDefault(_Terms);
	
	var _PrivacyPolicy = __webpack_require__(802);
	
	var _PrivacyPolicy2 = _interopRequireDefault(_PrivacyPolicy);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (options) {
	    var Vuex = options.Vuex;
	
	    return new Vuex.Store({
	        state: {},
	        mutations: {},
	        actions: {},
	        getters: {},
	        modules: {
	            develteamDataModel: _develteamDataModel2.default,
	            onlineUsersModel: _onlineUserModel2.default,
	            loggedUserModel: _LoggedUserModel2.default,
	            votingWidgetModel: _VotingWidgetModel2.default,
	            resourcesPageModel: _ResourcesPageModel2.default,
	            browsePageModel: _BrowsePageModel2.default,
	            loginPageModel: _LoginPageModel2.default,
	            developerPageModel: _DeveloperPageModel2.default,
	            feedPostsModel: _FeedPostsModel2.default,
	            gamePageModel: _GamePageModel2.default,
	            mediasModel: _MediasModel2.default,
	            chatRoomModel: _ChatRoomModel2.default,
	            privateChatModel: _PrivateChatModel2.default,
	            inboxPageModel: _InboxPageModel2.default,
	            forumsModel: _ForumsModel2.default,
	            invitesModel: _InvitesModel2.default,
	            notificationsModel: _NotificationsModel2.default,
	            donationsModel: _DonationsPageModel2.default,
	            classifiedsModel: _ClassifiedsPageModel2.default
	        }
	    });
	};
	
	var _develteamDataModel = __webpack_require__(289);
	
	var _develteamDataModel2 = _interopRequireDefault(_develteamDataModel);
	
	var _onlineUserModel = __webpack_require__(305);
	
	var _onlineUserModel2 = _interopRequireDefault(_onlineUserModel);
	
	var _LoggedUserModel = __webpack_require__(286);
	
	var _LoggedUserModel2 = _interopRequireDefault(_LoggedUserModel);
	
	var _VotingWidgetModel = __webpack_require__(288);
	
	var _VotingWidgetModel2 = _interopRequireDefault(_VotingWidgetModel);
	
	var _ResourcesPageModel = __webpack_require__(307);
	
	var _ResourcesPageModel2 = _interopRequireDefault(_ResourcesPageModel);
	
	var _BrowsePageModel = __webpack_require__(296);
	
	var _BrowsePageModel2 = _interopRequireDefault(_BrowsePageModel);
	
	var _LoginPageModel = __webpack_require__(304);
	
	var _LoginPageModel2 = _interopRequireDefault(_LoginPageModel);
	
	var _DeveloperPageModel = __webpack_require__(299);
	
	var _DeveloperPageModel2 = _interopRequireDefault(_DeveloperPageModel);
	
	var _GamePageModel = __webpack_require__(301);
	
	var _GamePageModel2 = _interopRequireDefault(_GamePageModel);
	
	var _MediasModel = __webpack_require__(287);
	
	var _MediasModel2 = _interopRequireDefault(_MediasModel);
	
	var _FeedPostsModel = __webpack_require__(284);
	
	var _FeedPostsModel2 = _interopRequireDefault(_FeedPostsModel);
	
	var _ChatRoomModel = __webpack_require__(297);
	
	var _ChatRoomModel2 = _interopRequireDefault(_ChatRoomModel);
	
	var _PrivateChatModel = __webpack_require__(306);
	
	var _PrivateChatModel2 = _interopRequireDefault(_PrivateChatModel);
	
	var _InboxPageModel = __webpack_require__(302);
	
	var _InboxPageModel2 = _interopRequireDefault(_InboxPageModel);
	
	var _ForumsModel = __webpack_require__(285);
	
	var _ForumsModel2 = _interopRequireDefault(_ForumsModel);
	
	var _InvitesModel = __webpack_require__(303);
	
	var _InvitesModel2 = _interopRequireDefault(_InvitesModel);
	
	var _NotificationsModel = __webpack_require__(295);
	
	var _NotificationsModel2 = _interopRequireDefault(_NotificationsModel);
	
	var _DonationsPageModel = __webpack_require__(300);
	
	var _DonationsPageModel2 = _interopRequireDefault(_DonationsPageModel);
	
	var _ClassifiedsPageModel = __webpack_require__(298);
	
	var _ClassifiedsPageModel2 = _interopRequireDefault(_ClassifiedsPageModel);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(4);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _Avatar = __webpack_require__(708);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	var _Pagination = __webpack_require__(736);
	
	var _Pagination2 = _interopRequireDefault(_Pagination);
	
	var _VotingWidget = __webpack_require__(737);
	
	var _VotingWidget2 = _interopRequireDefault(_VotingWidget);
	
	var _IconDeveloper = __webpack_require__(718);
	
	var _IconDeveloper2 = _interopRequireDefault(_IconDeveloper);
	
	var _IconDevteam = __webpack_require__(719);
	
	var _IconDevteam2 = _interopRequireDefault(_IconDevteam);
	
	var _IconGame = __webpack_require__(721);
	
	var _IconGame2 = _interopRequireDefault(_IconGame);
	
	var _IconChatBubble = __webpack_require__(717);
	
	var _IconChatBubble2 = _interopRequireDefault(_IconChatBubble);
	
	var _IconEye = __webpack_require__(720);
	
	var _IconEye2 = _interopRequireDefault(_IconEye);
	
	var _IconUserPlus = __webpack_require__(722);
	
	var _IconUserPlus2 = _interopRequireDefault(_IconUserPlus);
	
	var _LoadingLarge = __webpack_require__(723);
	
	var _LoadingLarge2 = _interopRequireDefault(_LoadingLarge);
	
	var _LoadingSmall = __webpack_require__(724);
	
	var _LoadingSmall2 = _interopRequireDefault(_LoadingSmall);
	
	var _SavingLarge = __webpack_require__(725);
	
	var _SavingLarge2 = _interopRequireDefault(_SavingLarge);
	
	var _MarkdownEditor = __webpack_require__(726);
	
	var _MarkdownEditor2 = _interopRequireDefault(_MarkdownEditor);
	
	var _MarkdownContent = __webpack_require__(143);
	
	var _MarkdownContent2 = _interopRequireDefault(_MarkdownContent);
	
	var _FakeYoutube = __webpack_require__(709);
	
	var _FakeYoutube2 = _interopRequireDefault(_FakeYoutube);
	
	var _FeedStatusPost = __webpack_require__(710);
	
	var _FeedStatusPost2 = _interopRequireDefault(_FeedStatusPost);
	
	var _MediaPost = __webpack_require__(711);
	
	var _MediaPost2 = _interopRequireDefault(_MediaPost);
	
	var _PostComment = __webpack_require__(712);
	
	var _PostComment2 = _interopRequireDefault(_PostComment);
	
	var _MediaItemImage = __webpack_require__(728);
	
	var _MediaItemImage2 = _interopRequireDefault(_MediaItemImage);
	
	var _MediaItemVideo = __webpack_require__(730);
	
	var _MediaItemVideo2 = _interopRequireDefault(_MediaItemVideo);
	
	var _MediaItemLink = __webpack_require__(729);
	
	var _MediaItemLink2 = _interopRequireDefault(_MediaItemLink);
	
	var _MediaItemAudio = __webpack_require__(727);
	
	var _MediaItemAudio2 = _interopRequireDefault(_MediaItemAudio);
	
	var _Modal = __webpack_require__(735);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	var _VueMasonry = __webpack_require__(738);
	
	var _VueMasonry2 = _interopRequireDefault(_VueMasonry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.component('avatar', _Avatar2.default);
	
	_vue2.default.component('pagination', _Pagination2.default);
	
	_vue2.default.component('voting-widget', _VotingWidget2.default);
	
	_vue2.default.component('icon-developer', _IconDeveloper2.default);
	
	_vue2.default.component('icon-devteam', _IconDevteam2.default);
	
	_vue2.default.component('icon-game', _IconGame2.default);
	
	_vue2.default.component('icon-chat-bubble', _IconChatBubble2.default);
	
	_vue2.default.component('icon-eye', _IconEye2.default);
	
	_vue2.default.component('icon-user-plus', _IconUserPlus2.default);
	
	_vue2.default.component('loader-large', _LoadingLarge2.default);
	
	_vue2.default.component('loader-small', _LoadingSmall2.default);
	
	_vue2.default.component('saver-large', _SavingLarge2.default);
	
	_vue2.default.component('markdown-editor', _MarkdownEditor2.default);
	
	_vue2.default.component('markdown-content', _MarkdownContent2.default);
	
	_vue2.default.component('fake-youtube', _FakeYoutube2.default);
	
	_vue2.default.component('feed-status-post', _FeedStatusPost2.default);
	
	_vue2.default.component('media-post', _MediaPost2.default);
	
	_vue2.default.component('post-comment', _PostComment2.default);
	
	_vue2.default.component('media-item-image', _MediaItemImage2.default);
	
	_vue2.default.component('media-item-video', _MediaItemVideo2.default);
	
	_vue2.default.component('media-item-link', _MediaItemLink2.default);
	
	_vue2.default.component('media-item-audio', _MediaItemAudio2.default);
	
	_vue2.default.component('modal', _Modal2.default);
	
	_vue2.default.component('vue-masonry', _VueMasonry2.default);

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(4);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.filter('formatDate', function (datetime) {
	    var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sep", "Oct", "Nov", "Dec"],
	        outputDate = new Date(datetime),
	        hours = outputDate.getHours(),
	        ampm = 'am',
	        minutes = void 0;
	
	    if (hours > 12) {
	        ampm = 'pm';
	        hours -= 12;
	    }
	
	    if (hours == 0) {
	        hours = 12;
	    }
	
	    minutes = (outputDate.getMinutes() < 10 ? '0' : '') + outputDate.getMinutes();
	
	    return monthNames[outputDate.getMonth()] + " " + outputDate.getDate() + ", " + outputDate.getFullYear() + ' at ' + hours + ':' + minutes + ampm;
	});
	
	_vue2.default.filter('formatDateWithoutTime', function (datetime) {
	    var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sep", "Oct", "Nov", "Dec"],
	        outputDate = new Date(datetime);
	
	    return monthNames[outputDate.getMonth()] + " " + outputDate.getDate() + ", " + outputDate.getFullYear();
	});
	
	_vue2.default.filter('formatDateWithoutTimeRelative', function (datetime) {
	    var getDayOfYear = function getDayOfYear(date) {
	        var start = new Date(date.getFullYear(), 0, 0),
	            diff = date - start + (start.getTimezoneOffset() - date.getTimezoneOffset()) * 60 * 1000,
	            oneDay = 1000 * 60 * 60 * 24;
	
	        return Math.floor(diff / oneDay);
	    };
	
	    var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "June", "July", "Aug", "Sep", "Oct", "Nov", "Dec"],
	        outputDate = new Date(datetime),
	        rightNow = new Date();
	
	    var daysAgo = getDayOfYear(rightNow) - getDayOfYear(outputDate);
	
	    if (rightNow.getFullYear() === outputDate.getFullYear() && daysAgo === 0) {
	        return "Today";
	    } else if (rightNow.getFullYear() === outputDate.getFullYear() && daysAgo === 1) {
	        return "Yesterday";
	    } else if (rightNow.getFullYear() === outputDate.getFullYear() && daysAgo <= 3) {
	        return daysAgo + " Days ago";
	    } else {
	        return monthNames[outputDate.getMonth()] + " " + outputDate.getDate() + ", " + outputDate.getFullYear();
	    }
	});
	
	_vue2.default.filter('formatDateWithJustTime', function (datetime) {
	    var outputDate = new Date(datetime),
	        hours = outputDate.getHours(),
	        ampm = 'am',
	        minutes = void 0;
	
	    if (hours >= 12) {
	        ampm = 'pm';
	        hours -= 12;
	    }
	
	    if (hours == 0) {
	        hours = 12;
	    }
	
	    minutes = (outputDate.getMinutes() < 10 ? '0' : '') + outputDate.getMinutes();
	
	    return hours + ':' + minutes + ampm;
	});
	
	_vue2.default.filter('formatDateCondensed', function (datetime) {
	    var outputDate = new Date(datetime),
	        hours = outputDate.getHours(),
	        ampm = 'am',
	        minutes = void 0;
	
	    if (hours >= 12) {
	        ampm = 'pm';
	        hours -= 12;
	    }
	
	    if (hours === 0) {
	        hours = 12;
	    }
	
	    minutes = (outputDate.getMinutes() < 10 ? '0' : '') + outputDate.getMinutes();
	
	    return outputDate.getMonth() + 1 + '.' + outputDate.getDate() + "." + outputDate.getFullYear() + ' | ' + hours + ':' + minutes + ampm;
	});
	
	_vue2.default.filter('joinArray', function (input, subArr) {
	    var output = void 0;
	    var subArrCombined = [];
	
	    if (subArr) {
	        input.forEach(function (item) {
	            subArrCombined.push(item[subArr]);
	        });
	        output = subArrCombined.join(', ');
	    } else {
	        output = input.join(', ');
	    }
	
	    return output;
	});
	
	_vue2.default.filter('markdown', function (content, mode) {
	    var markdownHighlight = __webpack_require__(384);
	    var markdownFontAwesome = __webpack_require__(293);
	    var markdownEmoji = __webpack_require__(567);
	    var markdownTargetBlank = __webpack_require__(294);
	    var disabled = void 0;
	
	    if (mode && mode === 'limited') {
	        disabled = ['heading'];
	    }
	
	    var md = __webpack_require__(575)({
	        html: false,
	        linkify: true,
	        breaks: true,
	        typographer: true,
	        highlight: function highlight(str, lang) {
	            if (lang && markdownHighlight.getLanguage(lang)) {
	                try {
	                    return markdownHighlight.highlight(lang, str).value;
	                } catch (__) {}
	            }
	
	            return '';
	        }
	    }).use(markdownFontAwesome).use(markdownEmoji).use(markdownTargetBlank);
	
	    if (disabled) {
	        md.disable(disabled);
	    }
	
	    content = md.render(content);
	
	    return content;
	});
	
	_vue2.default.filter('capitalizeFirstLetter', function (content) {
	    if (!content) {
	        return '';
	    }
	
	    return content.charAt(0).toUpperCase() + content.slice(1);
	});

/***/ }),
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 378 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 379 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 380 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */
/***/ (function(module, exports) {

	module.exports = {"Aacute":"Á","aacute":"á","Abreve":"Ă","abreve":"ă","ac":"∾","acd":"∿","acE":"∾̳","Acirc":"Â","acirc":"â","acute":"´","Acy":"А","acy":"а","AElig":"Æ","aelig":"æ","af":"⁡","Afr":"𝔄","afr":"𝔞","Agrave":"À","agrave":"à","alefsym":"ℵ","aleph":"ℵ","Alpha":"Α","alpha":"α","Amacr":"Ā","amacr":"ā","amalg":"⨿","amp":"&","AMP":"&","andand":"⩕","And":"⩓","and":"∧","andd":"⩜","andslope":"⩘","andv":"⩚","ang":"∠","ange":"⦤","angle":"∠","angmsdaa":"⦨","angmsdab":"⦩","angmsdac":"⦪","angmsdad":"⦫","angmsdae":"⦬","angmsdaf":"⦭","angmsdag":"⦮","angmsdah":"⦯","angmsd":"∡","angrt":"∟","angrtvb":"⊾","angrtvbd":"⦝","angsph":"∢","angst":"Å","angzarr":"⍼","Aogon":"Ą","aogon":"ą","Aopf":"𝔸","aopf":"𝕒","apacir":"⩯","ap":"≈","apE":"⩰","ape":"≊","apid":"≋","apos":"'","ApplyFunction":"⁡","approx":"≈","approxeq":"≊","Aring":"Å","aring":"å","Ascr":"𝒜","ascr":"𝒶","Assign":"≔","ast":"*","asymp":"≈","asympeq":"≍","Atilde":"Ã","atilde":"ã","Auml":"Ä","auml":"ä","awconint":"∳","awint":"⨑","backcong":"≌","backepsilon":"϶","backprime":"‵","backsim":"∽","backsimeq":"⋍","Backslash":"∖","Barv":"⫧","barvee":"⊽","barwed":"⌅","Barwed":"⌆","barwedge":"⌅","bbrk":"⎵","bbrktbrk":"⎶","bcong":"≌","Bcy":"Б","bcy":"б","bdquo":"„","becaus":"∵","because":"∵","Because":"∵","bemptyv":"⦰","bepsi":"϶","bernou":"ℬ","Bernoullis":"ℬ","Beta":"Β","beta":"β","beth":"ℶ","between":"≬","Bfr":"𝔅","bfr":"𝔟","bigcap":"⋂","bigcirc":"◯","bigcup":"⋃","bigodot":"⨀","bigoplus":"⨁","bigotimes":"⨂","bigsqcup":"⨆","bigstar":"★","bigtriangledown":"▽","bigtriangleup":"△","biguplus":"⨄","bigvee":"⋁","bigwedge":"⋀","bkarow":"⤍","blacklozenge":"⧫","blacksquare":"▪","blacktriangle":"▴","blacktriangledown":"▾","blacktriangleleft":"◂","blacktriangleright":"▸","blank":"␣","blk12":"▒","blk14":"░","blk34":"▓","block":"█","bne":"=⃥","bnequiv":"≡⃥","bNot":"⫭","bnot":"⌐","Bopf":"𝔹","bopf":"𝕓","bot":"⊥","bottom":"⊥","bowtie":"⋈","boxbox":"⧉","boxdl":"┐","boxdL":"╕","boxDl":"╖","boxDL":"╗","boxdr":"┌","boxdR":"╒","boxDr":"╓","boxDR":"╔","boxh":"─","boxH":"═","boxhd":"┬","boxHd":"╤","boxhD":"╥","boxHD":"╦","boxhu":"┴","boxHu":"╧","boxhU":"╨","boxHU":"╩","boxminus":"⊟","boxplus":"⊞","boxtimes":"⊠","boxul":"┘","boxuL":"╛","boxUl":"╜","boxUL":"╝","boxur":"└","boxuR":"╘","boxUr":"╙","boxUR":"╚","boxv":"│","boxV":"║","boxvh":"┼","boxvH":"╪","boxVh":"╫","boxVH":"╬","boxvl":"┤","boxvL":"╡","boxVl":"╢","boxVL":"╣","boxvr":"├","boxvR":"╞","boxVr":"╟","boxVR":"╠","bprime":"‵","breve":"˘","Breve":"˘","brvbar":"¦","bscr":"𝒷","Bscr":"ℬ","bsemi":"⁏","bsim":"∽","bsime":"⋍","bsolb":"⧅","bsol":"\\","bsolhsub":"⟈","bull":"•","bullet":"•","bump":"≎","bumpE":"⪮","bumpe":"≏","Bumpeq":"≎","bumpeq":"≏","Cacute":"Ć","cacute":"ć","capand":"⩄","capbrcup":"⩉","capcap":"⩋","cap":"∩","Cap":"⋒","capcup":"⩇","capdot":"⩀","CapitalDifferentialD":"ⅅ","caps":"∩︀","caret":"⁁","caron":"ˇ","Cayleys":"ℭ","ccaps":"⩍","Ccaron":"Č","ccaron":"č","Ccedil":"Ç","ccedil":"ç","Ccirc":"Ĉ","ccirc":"ĉ","Cconint":"∰","ccups":"⩌","ccupssm":"⩐","Cdot":"Ċ","cdot":"ċ","cedil":"¸","Cedilla":"¸","cemptyv":"⦲","cent":"¢","centerdot":"·","CenterDot":"·","cfr":"𝔠","Cfr":"ℭ","CHcy":"Ч","chcy":"ч","check":"✓","checkmark":"✓","Chi":"Χ","chi":"χ","circ":"ˆ","circeq":"≗","circlearrowleft":"↺","circlearrowright":"↻","circledast":"⊛","circledcirc":"⊚","circleddash":"⊝","CircleDot":"⊙","circledR":"®","circledS":"Ⓢ","CircleMinus":"⊖","CirclePlus":"⊕","CircleTimes":"⊗","cir":"○","cirE":"⧃","cire":"≗","cirfnint":"⨐","cirmid":"⫯","cirscir":"⧂","ClockwiseContourIntegral":"∲","CloseCurlyDoubleQuote":"”","CloseCurlyQuote":"’","clubs":"♣","clubsuit":"♣","colon":":","Colon":"∷","Colone":"⩴","colone":"≔","coloneq":"≔","comma":",","commat":"@","comp":"∁","compfn":"∘","complement":"∁","complexes":"ℂ","cong":"≅","congdot":"⩭","Congruent":"≡","conint":"∮","Conint":"∯","ContourIntegral":"∮","copf":"𝕔","Copf":"ℂ","coprod":"∐","Coproduct":"∐","copy":"©","COPY":"©","copysr":"℗","CounterClockwiseContourIntegral":"∳","crarr":"↵","cross":"✗","Cross":"⨯","Cscr":"𝒞","cscr":"𝒸","csub":"⫏","csube":"⫑","csup":"⫐","csupe":"⫒","ctdot":"⋯","cudarrl":"⤸","cudarrr":"⤵","cuepr":"⋞","cuesc":"⋟","cularr":"↶","cularrp":"⤽","cupbrcap":"⩈","cupcap":"⩆","CupCap":"≍","cup":"∪","Cup":"⋓","cupcup":"⩊","cupdot":"⊍","cupor":"⩅","cups":"∪︀","curarr":"↷","curarrm":"⤼","curlyeqprec":"⋞","curlyeqsucc":"⋟","curlyvee":"⋎","curlywedge":"⋏","curren":"¤","curvearrowleft":"↶","curvearrowright":"↷","cuvee":"⋎","cuwed":"⋏","cwconint":"∲","cwint":"∱","cylcty":"⌭","dagger":"†","Dagger":"‡","daleth":"ℸ","darr":"↓","Darr":"↡","dArr":"⇓","dash":"‐","Dashv":"⫤","dashv":"⊣","dbkarow":"⤏","dblac":"˝","Dcaron":"Ď","dcaron":"ď","Dcy":"Д","dcy":"д","ddagger":"‡","ddarr":"⇊","DD":"ⅅ","dd":"ⅆ","DDotrahd":"⤑","ddotseq":"⩷","deg":"°","Del":"∇","Delta":"Δ","delta":"δ","demptyv":"⦱","dfisht":"⥿","Dfr":"𝔇","dfr":"𝔡","dHar":"⥥","dharl":"⇃","dharr":"⇂","DiacriticalAcute":"´","DiacriticalDot":"˙","DiacriticalDoubleAcute":"˝","DiacriticalGrave":"`","DiacriticalTilde":"˜","diam":"⋄","diamond":"⋄","Diamond":"⋄","diamondsuit":"♦","diams":"♦","die":"¨","DifferentialD":"ⅆ","digamma":"ϝ","disin":"⋲","div":"÷","divide":"÷","divideontimes":"⋇","divonx":"⋇","DJcy":"Ђ","djcy":"ђ","dlcorn":"⌞","dlcrop":"⌍","dollar":"$","Dopf":"𝔻","dopf":"𝕕","Dot":"¨","dot":"˙","DotDot":"⃜","doteq":"≐","doteqdot":"≑","DotEqual":"≐","dotminus":"∸","dotplus":"∔","dotsquare":"⊡","doublebarwedge":"⌆","DoubleContourIntegral":"∯","DoubleDot":"¨","DoubleDownArrow":"⇓","DoubleLeftArrow":"⇐","DoubleLeftRightArrow":"⇔","DoubleLeftTee":"⫤","DoubleLongLeftArrow":"⟸","DoubleLongLeftRightArrow":"⟺","DoubleLongRightArrow":"⟹","DoubleRightArrow":"⇒","DoubleRightTee":"⊨","DoubleUpArrow":"⇑","DoubleUpDownArrow":"⇕","DoubleVerticalBar":"∥","DownArrowBar":"⤓","downarrow":"↓","DownArrow":"↓","Downarrow":"⇓","DownArrowUpArrow":"⇵","DownBreve":"̑","downdownarrows":"⇊","downharpoonleft":"⇃","downharpoonright":"⇂","DownLeftRightVector":"⥐","DownLeftTeeVector":"⥞","DownLeftVectorBar":"⥖","DownLeftVector":"↽","DownRightTeeVector":"⥟","DownRightVectorBar":"⥗","DownRightVector":"⇁","DownTeeArrow":"↧","DownTee":"⊤","drbkarow":"⤐","drcorn":"⌟","drcrop":"⌌","Dscr":"𝒟","dscr":"𝒹","DScy":"Ѕ","dscy":"ѕ","dsol":"⧶","Dstrok":"Đ","dstrok":"đ","dtdot":"⋱","dtri":"▿","dtrif":"▾","duarr":"⇵","duhar":"⥯","dwangle":"⦦","DZcy":"Џ","dzcy":"џ","dzigrarr":"⟿","Eacute":"É","eacute":"é","easter":"⩮","Ecaron":"Ě","ecaron":"ě","Ecirc":"Ê","ecirc":"ê","ecir":"≖","ecolon":"≕","Ecy":"Э","ecy":"э","eDDot":"⩷","Edot":"Ė","edot":"ė","eDot":"≑","ee":"ⅇ","efDot":"≒","Efr":"𝔈","efr":"𝔢","eg":"⪚","Egrave":"È","egrave":"è","egs":"⪖","egsdot":"⪘","el":"⪙","Element":"∈","elinters":"⏧","ell":"ℓ","els":"⪕","elsdot":"⪗","Emacr":"Ē","emacr":"ē","empty":"∅","emptyset":"∅","EmptySmallSquare":"◻","emptyv":"∅","EmptyVerySmallSquare":"▫","emsp13":" ","emsp14":" ","emsp":" ","ENG":"Ŋ","eng":"ŋ","ensp":" ","Eogon":"Ę","eogon":"ę","Eopf":"𝔼","eopf":"𝕖","epar":"⋕","eparsl":"⧣","eplus":"⩱","epsi":"ε","Epsilon":"Ε","epsilon":"ε","epsiv":"ϵ","eqcirc":"≖","eqcolon":"≕","eqsim":"≂","eqslantgtr":"⪖","eqslantless":"⪕","Equal":"⩵","equals":"=","EqualTilde":"≂","equest":"≟","Equilibrium":"⇌","equiv":"≡","equivDD":"⩸","eqvparsl":"⧥","erarr":"⥱","erDot":"≓","escr":"ℯ","Escr":"ℰ","esdot":"≐","Esim":"⩳","esim":"≂","Eta":"Η","eta":"η","ETH":"Ð","eth":"ð","Euml":"Ë","euml":"ë","euro":"€","excl":"!","exist":"∃","Exists":"∃","expectation":"ℰ","exponentiale":"ⅇ","ExponentialE":"ⅇ","fallingdotseq":"≒","Fcy":"Ф","fcy":"ф","female":"♀","ffilig":"ﬃ","fflig":"ﬀ","ffllig":"ﬄ","Ffr":"𝔉","ffr":"𝔣","filig":"ﬁ","FilledSmallSquare":"◼","FilledVerySmallSquare":"▪","fjlig":"fj","flat":"♭","fllig":"ﬂ","fltns":"▱","fnof":"ƒ","Fopf":"𝔽","fopf":"𝕗","forall":"∀","ForAll":"∀","fork":"⋔","forkv":"⫙","Fouriertrf":"ℱ","fpartint":"⨍","frac12":"½","frac13":"⅓","frac14":"¼","frac15":"⅕","frac16":"⅙","frac18":"⅛","frac23":"⅔","frac25":"⅖","frac34":"¾","frac35":"⅗","frac38":"⅜","frac45":"⅘","frac56":"⅚","frac58":"⅝","frac78":"⅞","frasl":"⁄","frown":"⌢","fscr":"𝒻","Fscr":"ℱ","gacute":"ǵ","Gamma":"Γ","gamma":"γ","Gammad":"Ϝ","gammad":"ϝ","gap":"⪆","Gbreve":"Ğ","gbreve":"ğ","Gcedil":"Ģ","Gcirc":"Ĝ","gcirc":"ĝ","Gcy":"Г","gcy":"г","Gdot":"Ġ","gdot":"ġ","ge":"≥","gE":"≧","gEl":"⪌","gel":"⋛","geq":"≥","geqq":"≧","geqslant":"⩾","gescc":"⪩","ges":"⩾","gesdot":"⪀","gesdoto":"⪂","gesdotol":"⪄","gesl":"⋛︀","gesles":"⪔","Gfr":"𝔊","gfr":"𝔤","gg":"≫","Gg":"⋙","ggg":"⋙","gimel":"ℷ","GJcy":"Ѓ","gjcy":"ѓ","gla":"⪥","gl":"≷","glE":"⪒","glj":"⪤","gnap":"⪊","gnapprox":"⪊","gne":"⪈","gnE":"≩","gneq":"⪈","gneqq":"≩","gnsim":"⋧","Gopf":"𝔾","gopf":"𝕘","grave":"`","GreaterEqual":"≥","GreaterEqualLess":"⋛","GreaterFullEqual":"≧","GreaterGreater":"⪢","GreaterLess":"≷","GreaterSlantEqual":"⩾","GreaterTilde":"≳","Gscr":"𝒢","gscr":"ℊ","gsim":"≳","gsime":"⪎","gsiml":"⪐","gtcc":"⪧","gtcir":"⩺","gt":">","GT":">","Gt":"≫","gtdot":"⋗","gtlPar":"⦕","gtquest":"⩼","gtrapprox":"⪆","gtrarr":"⥸","gtrdot":"⋗","gtreqless":"⋛","gtreqqless":"⪌","gtrless":"≷","gtrsim":"≳","gvertneqq":"≩︀","gvnE":"≩︀","Hacek":"ˇ","hairsp":" ","half":"½","hamilt":"ℋ","HARDcy":"Ъ","hardcy":"ъ","harrcir":"⥈","harr":"↔","hArr":"⇔","harrw":"↭","Hat":"^","hbar":"ℏ","Hcirc":"Ĥ","hcirc":"ĥ","hearts":"♥","heartsuit":"♥","hellip":"…","hercon":"⊹","hfr":"𝔥","Hfr":"ℌ","HilbertSpace":"ℋ","hksearow":"⤥","hkswarow":"⤦","hoarr":"⇿","homtht":"∻","hookleftarrow":"↩","hookrightarrow":"↪","hopf":"𝕙","Hopf":"ℍ","horbar":"―","HorizontalLine":"─","hscr":"𝒽","Hscr":"ℋ","hslash":"ℏ","Hstrok":"Ħ","hstrok":"ħ","HumpDownHump":"≎","HumpEqual":"≏","hybull":"⁃","hyphen":"‐","Iacute":"Í","iacute":"í","ic":"⁣","Icirc":"Î","icirc":"î","Icy":"И","icy":"и","Idot":"İ","IEcy":"Е","iecy":"е","iexcl":"¡","iff":"⇔","ifr":"𝔦","Ifr":"ℑ","Igrave":"Ì","igrave":"ì","ii":"ⅈ","iiiint":"⨌","iiint":"∭","iinfin":"⧜","iiota":"℩","IJlig":"Ĳ","ijlig":"ĳ","Imacr":"Ī","imacr":"ī","image":"ℑ","ImaginaryI":"ⅈ","imagline":"ℐ","imagpart":"ℑ","imath":"ı","Im":"ℑ","imof":"⊷","imped":"Ƶ","Implies":"⇒","incare":"℅","in":"∈","infin":"∞","infintie":"⧝","inodot":"ı","intcal":"⊺","int":"∫","Int":"∬","integers":"ℤ","Integral":"∫","intercal":"⊺","Intersection":"⋂","intlarhk":"⨗","intprod":"⨼","InvisibleComma":"⁣","InvisibleTimes":"⁢","IOcy":"Ё","iocy":"ё","Iogon":"Į","iogon":"į","Iopf":"𝕀","iopf":"𝕚","Iota":"Ι","iota":"ι","iprod":"⨼","iquest":"¿","iscr":"𝒾","Iscr":"ℐ","isin":"∈","isindot":"⋵","isinE":"⋹","isins":"⋴","isinsv":"⋳","isinv":"∈","it":"⁢","Itilde":"Ĩ","itilde":"ĩ","Iukcy":"І","iukcy":"і","Iuml":"Ï","iuml":"ï","Jcirc":"Ĵ","jcirc":"ĵ","Jcy":"Й","jcy":"й","Jfr":"𝔍","jfr":"𝔧","jmath":"ȷ","Jopf":"𝕁","jopf":"𝕛","Jscr":"𝒥","jscr":"𝒿","Jsercy":"Ј","jsercy":"ј","Jukcy":"Є","jukcy":"є","Kappa":"Κ","kappa":"κ","kappav":"ϰ","Kcedil":"Ķ","kcedil":"ķ","Kcy":"К","kcy":"к","Kfr":"𝔎","kfr":"𝔨","kgreen":"ĸ","KHcy":"Х","khcy":"х","KJcy":"Ќ","kjcy":"ќ","Kopf":"𝕂","kopf":"𝕜","Kscr":"𝒦","kscr":"𝓀","lAarr":"⇚","Lacute":"Ĺ","lacute":"ĺ","laemptyv":"⦴","lagran":"ℒ","Lambda":"Λ","lambda":"λ","lang":"⟨","Lang":"⟪","langd":"⦑","langle":"⟨","lap":"⪅","Laplacetrf":"ℒ","laquo":"«","larrb":"⇤","larrbfs":"⤟","larr":"←","Larr":"↞","lArr":"⇐","larrfs":"⤝","larrhk":"↩","larrlp":"↫","larrpl":"⤹","larrsim":"⥳","larrtl":"↢","latail":"⤙","lAtail":"⤛","lat":"⪫","late":"⪭","lates":"⪭︀","lbarr":"⤌","lBarr":"⤎","lbbrk":"❲","lbrace":"{","lbrack":"[","lbrke":"⦋","lbrksld":"⦏","lbrkslu":"⦍","Lcaron":"Ľ","lcaron":"ľ","Lcedil":"Ļ","lcedil":"ļ","lceil":"⌈","lcub":"{","Lcy":"Л","lcy":"л","ldca":"⤶","ldquo":"“","ldquor":"„","ldrdhar":"⥧","ldrushar":"⥋","ldsh":"↲","le":"≤","lE":"≦","LeftAngleBracket":"⟨","LeftArrowBar":"⇤","leftarrow":"←","LeftArrow":"←","Leftarrow":"⇐","LeftArrowRightArrow":"⇆","leftarrowtail":"↢","LeftCeiling":"⌈","LeftDoubleBracket":"⟦","LeftDownTeeVector":"⥡","LeftDownVectorBar":"⥙","LeftDownVector":"⇃","LeftFloor":"⌊","leftharpoondown":"↽","leftharpoonup":"↼","leftleftarrows":"⇇","leftrightarrow":"↔","LeftRightArrow":"↔","Leftrightarrow":"⇔","leftrightarrows":"⇆","leftrightharpoons":"⇋","leftrightsquigarrow":"↭","LeftRightVector":"⥎","LeftTeeArrow":"↤","LeftTee":"⊣","LeftTeeVector":"⥚","leftthreetimes":"⋋","LeftTriangleBar":"⧏","LeftTriangle":"⊲","LeftTriangleEqual":"⊴","LeftUpDownVector":"⥑","LeftUpTeeVector":"⥠","LeftUpVectorBar":"⥘","LeftUpVector":"↿","LeftVectorBar":"⥒","LeftVector":"↼","lEg":"⪋","leg":"⋚","leq":"≤","leqq":"≦","leqslant":"⩽","lescc":"⪨","les":"⩽","lesdot":"⩿","lesdoto":"⪁","lesdotor":"⪃","lesg":"⋚︀","lesges":"⪓","lessapprox":"⪅","lessdot":"⋖","lesseqgtr":"⋚","lesseqqgtr":"⪋","LessEqualGreater":"⋚","LessFullEqual":"≦","LessGreater":"≶","lessgtr":"≶","LessLess":"⪡","lesssim":"≲","LessSlantEqual":"⩽","LessTilde":"≲","lfisht":"⥼","lfloor":"⌊","Lfr":"𝔏","lfr":"𝔩","lg":"≶","lgE":"⪑","lHar":"⥢","lhard":"↽","lharu":"↼","lharul":"⥪","lhblk":"▄","LJcy":"Љ","ljcy":"љ","llarr":"⇇","ll":"≪","Ll":"⋘","llcorner":"⌞","Lleftarrow":"⇚","llhard":"⥫","lltri":"◺","Lmidot":"Ŀ","lmidot":"ŀ","lmoustache":"⎰","lmoust":"⎰","lnap":"⪉","lnapprox":"⪉","lne":"⪇","lnE":"≨","lneq":"⪇","lneqq":"≨","lnsim":"⋦","loang":"⟬","loarr":"⇽","lobrk":"⟦","longleftarrow":"⟵","LongLeftArrow":"⟵","Longleftarrow":"⟸","longleftrightarrow":"⟷","LongLeftRightArrow":"⟷","Longleftrightarrow":"⟺","longmapsto":"⟼","longrightarrow":"⟶","LongRightArrow":"⟶","Longrightarrow":"⟹","looparrowleft":"↫","looparrowright":"↬","lopar":"⦅","Lopf":"𝕃","lopf":"𝕝","loplus":"⨭","lotimes":"⨴","lowast":"∗","lowbar":"_","LowerLeftArrow":"↙","LowerRightArrow":"↘","loz":"◊","lozenge":"◊","lozf":"⧫","lpar":"(","lparlt":"⦓","lrarr":"⇆","lrcorner":"⌟","lrhar":"⇋","lrhard":"⥭","lrm":"‎","lrtri":"⊿","lsaquo":"‹","lscr":"𝓁","Lscr":"ℒ","lsh":"↰","Lsh":"↰","lsim":"≲","lsime":"⪍","lsimg":"⪏","lsqb":"[","lsquo":"‘","lsquor":"‚","Lstrok":"Ł","lstrok":"ł","ltcc":"⪦","ltcir":"⩹","lt":"<","LT":"<","Lt":"≪","ltdot":"⋖","lthree":"⋋","ltimes":"⋉","ltlarr":"⥶","ltquest":"⩻","ltri":"◃","ltrie":"⊴","ltrif":"◂","ltrPar":"⦖","lurdshar":"⥊","luruhar":"⥦","lvertneqq":"≨︀","lvnE":"≨︀","macr":"¯","male":"♂","malt":"✠","maltese":"✠","Map":"⤅","map":"↦","mapsto":"↦","mapstodown":"↧","mapstoleft":"↤","mapstoup":"↥","marker":"▮","mcomma":"⨩","Mcy":"М","mcy":"м","mdash":"—","mDDot":"∺","measuredangle":"∡","MediumSpace":" ","Mellintrf":"ℳ","Mfr":"𝔐","mfr":"𝔪","mho":"℧","micro":"µ","midast":"*","midcir":"⫰","mid":"∣","middot":"·","minusb":"⊟","minus":"−","minusd":"∸","minusdu":"⨪","MinusPlus":"∓","mlcp":"⫛","mldr":"…","mnplus":"∓","models":"⊧","Mopf":"𝕄","mopf":"𝕞","mp":"∓","mscr":"𝓂","Mscr":"ℳ","mstpos":"∾","Mu":"Μ","mu":"μ","multimap":"⊸","mumap":"⊸","nabla":"∇","Nacute":"Ń","nacute":"ń","nang":"∠⃒","nap":"≉","napE":"⩰̸","napid":"≋̸","napos":"ŉ","napprox":"≉","natural":"♮","naturals":"ℕ","natur":"♮","nbsp":" ","nbump":"≎̸","nbumpe":"≏̸","ncap":"⩃","Ncaron":"Ň","ncaron":"ň","Ncedil":"Ņ","ncedil":"ņ","ncong":"≇","ncongdot":"⩭̸","ncup":"⩂","Ncy":"Н","ncy":"н","ndash":"–","nearhk":"⤤","nearr":"↗","neArr":"⇗","nearrow":"↗","ne":"≠","nedot":"≐̸","NegativeMediumSpace":"​","NegativeThickSpace":"​","NegativeThinSpace":"​","NegativeVeryThinSpace":"​","nequiv":"≢","nesear":"⤨","nesim":"≂̸","NestedGreaterGreater":"≫","NestedLessLess":"≪","NewLine":"\n","nexist":"∄","nexists":"∄","Nfr":"𝔑","nfr":"𝔫","ngE":"≧̸","nge":"≱","ngeq":"≱","ngeqq":"≧̸","ngeqslant":"⩾̸","nges":"⩾̸","nGg":"⋙̸","ngsim":"≵","nGt":"≫⃒","ngt":"≯","ngtr":"≯","nGtv":"≫̸","nharr":"↮","nhArr":"⇎","nhpar":"⫲","ni":"∋","nis":"⋼","nisd":"⋺","niv":"∋","NJcy":"Њ","njcy":"њ","nlarr":"↚","nlArr":"⇍","nldr":"‥","nlE":"≦̸","nle":"≰","nleftarrow":"↚","nLeftarrow":"⇍","nleftrightarrow":"↮","nLeftrightarrow":"⇎","nleq":"≰","nleqq":"≦̸","nleqslant":"⩽̸","nles":"⩽̸","nless":"≮","nLl":"⋘̸","nlsim":"≴","nLt":"≪⃒","nlt":"≮","nltri":"⋪","nltrie":"⋬","nLtv":"≪̸","nmid":"∤","NoBreak":"⁠","NonBreakingSpace":" ","nopf":"𝕟","Nopf":"ℕ","Not":"⫬","not":"¬","NotCongruent":"≢","NotCupCap":"≭","NotDoubleVerticalBar":"∦","NotElement":"∉","NotEqual":"≠","NotEqualTilde":"≂̸","NotExists":"∄","NotGreater":"≯","NotGreaterEqual":"≱","NotGreaterFullEqual":"≧̸","NotGreaterGreater":"≫̸","NotGreaterLess":"≹","NotGreaterSlantEqual":"⩾̸","NotGreaterTilde":"≵","NotHumpDownHump":"≎̸","NotHumpEqual":"≏̸","notin":"∉","notindot":"⋵̸","notinE":"⋹̸","notinva":"∉","notinvb":"⋷","notinvc":"⋶","NotLeftTriangleBar":"⧏̸","NotLeftTriangle":"⋪","NotLeftTriangleEqual":"⋬","NotLess":"≮","NotLessEqual":"≰","NotLessGreater":"≸","NotLessLess":"≪̸","NotLessSlantEqual":"⩽̸","NotLessTilde":"≴","NotNestedGreaterGreater":"⪢̸","NotNestedLessLess":"⪡̸","notni":"∌","notniva":"∌","notnivb":"⋾","notnivc":"⋽","NotPrecedes":"⊀","NotPrecedesEqual":"⪯̸","NotPrecedesSlantEqual":"⋠","NotReverseElement":"∌","NotRightTriangleBar":"⧐̸","NotRightTriangle":"⋫","NotRightTriangleEqual":"⋭","NotSquareSubset":"⊏̸","NotSquareSubsetEqual":"⋢","NotSquareSuperset":"⊐̸","NotSquareSupersetEqual":"⋣","NotSubset":"⊂⃒","NotSubsetEqual":"⊈","NotSucceeds":"⊁","NotSucceedsEqual":"⪰̸","NotSucceedsSlantEqual":"⋡","NotSucceedsTilde":"≿̸","NotSuperset":"⊃⃒","NotSupersetEqual":"⊉","NotTilde":"≁","NotTildeEqual":"≄","NotTildeFullEqual":"≇","NotTildeTilde":"≉","NotVerticalBar":"∤","nparallel":"∦","npar":"∦","nparsl":"⫽⃥","npart":"∂̸","npolint":"⨔","npr":"⊀","nprcue":"⋠","nprec":"⊀","npreceq":"⪯̸","npre":"⪯̸","nrarrc":"⤳̸","nrarr":"↛","nrArr":"⇏","nrarrw":"↝̸","nrightarrow":"↛","nRightarrow":"⇏","nrtri":"⋫","nrtrie":"⋭","nsc":"⊁","nsccue":"⋡","nsce":"⪰̸","Nscr":"𝒩","nscr":"𝓃","nshortmid":"∤","nshortparallel":"∦","nsim":"≁","nsime":"≄","nsimeq":"≄","nsmid":"∤","nspar":"∦","nsqsube":"⋢","nsqsupe":"⋣","nsub":"⊄","nsubE":"⫅̸","nsube":"⊈","nsubset":"⊂⃒","nsubseteq":"⊈","nsubseteqq":"⫅̸","nsucc":"⊁","nsucceq":"⪰̸","nsup":"⊅","nsupE":"⫆̸","nsupe":"⊉","nsupset":"⊃⃒","nsupseteq":"⊉","nsupseteqq":"⫆̸","ntgl":"≹","Ntilde":"Ñ","ntilde":"ñ","ntlg":"≸","ntriangleleft":"⋪","ntrianglelefteq":"⋬","ntriangleright":"⋫","ntrianglerighteq":"⋭","Nu":"Ν","nu":"ν","num":"#","numero":"№","numsp":" ","nvap":"≍⃒","nvdash":"⊬","nvDash":"⊭","nVdash":"⊮","nVDash":"⊯","nvge":"≥⃒","nvgt":">⃒","nvHarr":"⤄","nvinfin":"⧞","nvlArr":"⤂","nvle":"≤⃒","nvlt":"<⃒","nvltrie":"⊴⃒","nvrArr":"⤃","nvrtrie":"⊵⃒","nvsim":"∼⃒","nwarhk":"⤣","nwarr":"↖","nwArr":"⇖","nwarrow":"↖","nwnear":"⤧","Oacute":"Ó","oacute":"ó","oast":"⊛","Ocirc":"Ô","ocirc":"ô","ocir":"⊚","Ocy":"О","ocy":"о","odash":"⊝","Odblac":"Ő","odblac":"ő","odiv":"⨸","odot":"⊙","odsold":"⦼","OElig":"Œ","oelig":"œ","ofcir":"⦿","Ofr":"𝔒","ofr":"𝔬","ogon":"˛","Ograve":"Ò","ograve":"ò","ogt":"⧁","ohbar":"⦵","ohm":"Ω","oint":"∮","olarr":"↺","olcir":"⦾","olcross":"⦻","oline":"‾","olt":"⧀","Omacr":"Ō","omacr":"ō","Omega":"Ω","omega":"ω","Omicron":"Ο","omicron":"ο","omid":"⦶","ominus":"⊖","Oopf":"𝕆","oopf":"𝕠","opar":"⦷","OpenCurlyDoubleQuote":"“","OpenCurlyQuote":"‘","operp":"⦹","oplus":"⊕","orarr":"↻","Or":"⩔","or":"∨","ord":"⩝","order":"ℴ","orderof":"ℴ","ordf":"ª","ordm":"º","origof":"⊶","oror":"⩖","orslope":"⩗","orv":"⩛","oS":"Ⓢ","Oscr":"𝒪","oscr":"ℴ","Oslash":"Ø","oslash":"ø","osol":"⊘","Otilde":"Õ","otilde":"õ","otimesas":"⨶","Otimes":"⨷","otimes":"⊗","Ouml":"Ö","ouml":"ö","ovbar":"⌽","OverBar":"‾","OverBrace":"⏞","OverBracket":"⎴","OverParenthesis":"⏜","para":"¶","parallel":"∥","par":"∥","parsim":"⫳","parsl":"⫽","part":"∂","PartialD":"∂","Pcy":"П","pcy":"п","percnt":"%","period":".","permil":"‰","perp":"⊥","pertenk":"‱","Pfr":"𝔓","pfr":"𝔭","Phi":"Φ","phi":"φ","phiv":"ϕ","phmmat":"ℳ","phone":"☎","Pi":"Π","pi":"π","pitchfork":"⋔","piv":"ϖ","planck":"ℏ","planckh":"ℎ","plankv":"ℏ","plusacir":"⨣","plusb":"⊞","pluscir":"⨢","plus":"+","plusdo":"∔","plusdu":"⨥","pluse":"⩲","PlusMinus":"±","plusmn":"±","plussim":"⨦","plustwo":"⨧","pm":"±","Poincareplane":"ℌ","pointint":"⨕","popf":"𝕡","Popf":"ℙ","pound":"£","prap":"⪷","Pr":"⪻","pr":"≺","prcue":"≼","precapprox":"⪷","prec":"≺","preccurlyeq":"≼","Precedes":"≺","PrecedesEqual":"⪯","PrecedesSlantEqual":"≼","PrecedesTilde":"≾","preceq":"⪯","precnapprox":"⪹","precneqq":"⪵","precnsim":"⋨","pre":"⪯","prE":"⪳","precsim":"≾","prime":"′","Prime":"″","primes":"ℙ","prnap":"⪹","prnE":"⪵","prnsim":"⋨","prod":"∏","Product":"∏","profalar":"⌮","profline":"⌒","profsurf":"⌓","prop":"∝","Proportional":"∝","Proportion":"∷","propto":"∝","prsim":"≾","prurel":"⊰","Pscr":"𝒫","pscr":"𝓅","Psi":"Ψ","psi":"ψ","puncsp":" ","Qfr":"𝔔","qfr":"𝔮","qint":"⨌","qopf":"𝕢","Qopf":"ℚ","qprime":"⁗","Qscr":"𝒬","qscr":"𝓆","quaternions":"ℍ","quatint":"⨖","quest":"?","questeq":"≟","quot":"\"","QUOT":"\"","rAarr":"⇛","race":"∽̱","Racute":"Ŕ","racute":"ŕ","radic":"√","raemptyv":"⦳","rang":"⟩","Rang":"⟫","rangd":"⦒","range":"⦥","rangle":"⟩","raquo":"»","rarrap":"⥵","rarrb":"⇥","rarrbfs":"⤠","rarrc":"⤳","rarr":"→","Rarr":"↠","rArr":"⇒","rarrfs":"⤞","rarrhk":"↪","rarrlp":"↬","rarrpl":"⥅","rarrsim":"⥴","Rarrtl":"⤖","rarrtl":"↣","rarrw":"↝","ratail":"⤚","rAtail":"⤜","ratio":"∶","rationals":"ℚ","rbarr":"⤍","rBarr":"⤏","RBarr":"⤐","rbbrk":"❳","rbrace":"}","rbrack":"]","rbrke":"⦌","rbrksld":"⦎","rbrkslu":"⦐","Rcaron":"Ř","rcaron":"ř","Rcedil":"Ŗ","rcedil":"ŗ","rceil":"⌉","rcub":"}","Rcy":"Р","rcy":"р","rdca":"⤷","rdldhar":"⥩","rdquo":"”","rdquor":"”","rdsh":"↳","real":"ℜ","realine":"ℛ","realpart":"ℜ","reals":"ℝ","Re":"ℜ","rect":"▭","reg":"®","REG":"®","ReverseElement":"∋","ReverseEquilibrium":"⇋","ReverseUpEquilibrium":"⥯","rfisht":"⥽","rfloor":"⌋","rfr":"𝔯","Rfr":"ℜ","rHar":"⥤","rhard":"⇁","rharu":"⇀","rharul":"⥬","Rho":"Ρ","rho":"ρ","rhov":"ϱ","RightAngleBracket":"⟩","RightArrowBar":"⇥","rightarrow":"→","RightArrow":"→","Rightarrow":"⇒","RightArrowLeftArrow":"⇄","rightarrowtail":"↣","RightCeiling":"⌉","RightDoubleBracket":"⟧","RightDownTeeVector":"⥝","RightDownVectorBar":"⥕","RightDownVector":"⇂","RightFloor":"⌋","rightharpoondown":"⇁","rightharpoonup":"⇀","rightleftarrows":"⇄","rightleftharpoons":"⇌","rightrightarrows":"⇉","rightsquigarrow":"↝","RightTeeArrow":"↦","RightTee":"⊢","RightTeeVector":"⥛","rightthreetimes":"⋌","RightTriangleBar":"⧐","RightTriangle":"⊳","RightTriangleEqual":"⊵","RightUpDownVector":"⥏","RightUpTeeVector":"⥜","RightUpVectorBar":"⥔","RightUpVector":"↾","RightVectorBar":"⥓","RightVector":"⇀","ring":"˚","risingdotseq":"≓","rlarr":"⇄","rlhar":"⇌","rlm":"‏","rmoustache":"⎱","rmoust":"⎱","rnmid":"⫮","roang":"⟭","roarr":"⇾","robrk":"⟧","ropar":"⦆","ropf":"𝕣","Ropf":"ℝ","roplus":"⨮","rotimes":"⨵","RoundImplies":"⥰","rpar":")","rpargt":"⦔","rppolint":"⨒","rrarr":"⇉","Rrightarrow":"⇛","rsaquo":"›","rscr":"𝓇","Rscr":"ℛ","rsh":"↱","Rsh":"↱","rsqb":"]","rsquo":"’","rsquor":"’","rthree":"⋌","rtimes":"⋊","rtri":"▹","rtrie":"⊵","rtrif":"▸","rtriltri":"⧎","RuleDelayed":"⧴","ruluhar":"⥨","rx":"℞","Sacute":"Ś","sacute":"ś","sbquo":"‚","scap":"⪸","Scaron":"Š","scaron":"š","Sc":"⪼","sc":"≻","sccue":"≽","sce":"⪰","scE":"⪴","Scedil":"Ş","scedil":"ş","Scirc":"Ŝ","scirc":"ŝ","scnap":"⪺","scnE":"⪶","scnsim":"⋩","scpolint":"⨓","scsim":"≿","Scy":"С","scy":"с","sdotb":"⊡","sdot":"⋅","sdote":"⩦","searhk":"⤥","searr":"↘","seArr":"⇘","searrow":"↘","sect":"§","semi":";","seswar":"⤩","setminus":"∖","setmn":"∖","sext":"✶","Sfr":"𝔖","sfr":"𝔰","sfrown":"⌢","sharp":"♯","SHCHcy":"Щ","shchcy":"щ","SHcy":"Ш","shcy":"ш","ShortDownArrow":"↓","ShortLeftArrow":"←","shortmid":"∣","shortparallel":"∥","ShortRightArrow":"→","ShortUpArrow":"↑","shy":"­","Sigma":"Σ","sigma":"σ","sigmaf":"ς","sigmav":"ς","sim":"∼","simdot":"⩪","sime":"≃","simeq":"≃","simg":"⪞","simgE":"⪠","siml":"⪝","simlE":"⪟","simne":"≆","simplus":"⨤","simrarr":"⥲","slarr":"←","SmallCircle":"∘","smallsetminus":"∖","smashp":"⨳","smeparsl":"⧤","smid":"∣","smile":"⌣","smt":"⪪","smte":"⪬","smtes":"⪬︀","SOFTcy":"Ь","softcy":"ь","solbar":"⌿","solb":"⧄","sol":"/","Sopf":"𝕊","sopf":"𝕤","spades":"♠","spadesuit":"♠","spar":"∥","sqcap":"⊓","sqcaps":"⊓︀","sqcup":"⊔","sqcups":"⊔︀","Sqrt":"√","sqsub":"⊏","sqsube":"⊑","sqsubset":"⊏","sqsubseteq":"⊑","sqsup":"⊐","sqsupe":"⊒","sqsupset":"⊐","sqsupseteq":"⊒","square":"□","Square":"□","SquareIntersection":"⊓","SquareSubset":"⊏","SquareSubsetEqual":"⊑","SquareSuperset":"⊐","SquareSupersetEqual":"⊒","SquareUnion":"⊔","squarf":"▪","squ":"□","squf":"▪","srarr":"→","Sscr":"𝒮","sscr":"𝓈","ssetmn":"∖","ssmile":"⌣","sstarf":"⋆","Star":"⋆","star":"☆","starf":"★","straightepsilon":"ϵ","straightphi":"ϕ","strns":"¯","sub":"⊂","Sub":"⋐","subdot":"⪽","subE":"⫅","sube":"⊆","subedot":"⫃","submult":"⫁","subnE":"⫋","subne":"⊊","subplus":"⪿","subrarr":"⥹","subset":"⊂","Subset":"⋐","subseteq":"⊆","subseteqq":"⫅","SubsetEqual":"⊆","subsetneq":"⊊","subsetneqq":"⫋","subsim":"⫇","subsub":"⫕","subsup":"⫓","succapprox":"⪸","succ":"≻","succcurlyeq":"≽","Succeeds":"≻","SucceedsEqual":"⪰","SucceedsSlantEqual":"≽","SucceedsTilde":"≿","succeq":"⪰","succnapprox":"⪺","succneqq":"⪶","succnsim":"⋩","succsim":"≿","SuchThat":"∋","sum":"∑","Sum":"∑","sung":"♪","sup1":"¹","sup2":"²","sup3":"³","sup":"⊃","Sup":"⋑","supdot":"⪾","supdsub":"⫘","supE":"⫆","supe":"⊇","supedot":"⫄","Superset":"⊃","SupersetEqual":"⊇","suphsol":"⟉","suphsub":"⫗","suplarr":"⥻","supmult":"⫂","supnE":"⫌","supne":"⊋","supplus":"⫀","supset":"⊃","Supset":"⋑","supseteq":"⊇","supseteqq":"⫆","supsetneq":"⊋","supsetneqq":"⫌","supsim":"⫈","supsub":"⫔","supsup":"⫖","swarhk":"⤦","swarr":"↙","swArr":"⇙","swarrow":"↙","swnwar":"⤪","szlig":"ß","Tab":"\t","target":"⌖","Tau":"Τ","tau":"τ","tbrk":"⎴","Tcaron":"Ť","tcaron":"ť","Tcedil":"Ţ","tcedil":"ţ","Tcy":"Т","tcy":"т","tdot":"⃛","telrec":"⌕","Tfr":"𝔗","tfr":"𝔱","there4":"∴","therefore":"∴","Therefore":"∴","Theta":"Θ","theta":"θ","thetasym":"ϑ","thetav":"ϑ","thickapprox":"≈","thicksim":"∼","ThickSpace":"  ","ThinSpace":" ","thinsp":" ","thkap":"≈","thksim":"∼","THORN":"Þ","thorn":"þ","tilde":"˜","Tilde":"∼","TildeEqual":"≃","TildeFullEqual":"≅","TildeTilde":"≈","timesbar":"⨱","timesb":"⊠","times":"×","timesd":"⨰","tint":"∭","toea":"⤨","topbot":"⌶","topcir":"⫱","top":"⊤","Topf":"𝕋","topf":"𝕥","topfork":"⫚","tosa":"⤩","tprime":"‴","trade":"™","TRADE":"™","triangle":"▵","triangledown":"▿","triangleleft":"◃","trianglelefteq":"⊴","triangleq":"≜","triangleright":"▹","trianglerighteq":"⊵","tridot":"◬","trie":"≜","triminus":"⨺","TripleDot":"⃛","triplus":"⨹","trisb":"⧍","tritime":"⨻","trpezium":"⏢","Tscr":"𝒯","tscr":"𝓉","TScy":"Ц","tscy":"ц","TSHcy":"Ћ","tshcy":"ћ","Tstrok":"Ŧ","tstrok":"ŧ","twixt":"≬","twoheadleftarrow":"↞","twoheadrightarrow":"↠","Uacute":"Ú","uacute":"ú","uarr":"↑","Uarr":"↟","uArr":"⇑","Uarrocir":"⥉","Ubrcy":"Ў","ubrcy":"ў","Ubreve":"Ŭ","ubreve":"ŭ","Ucirc":"Û","ucirc":"û","Ucy":"У","ucy":"у","udarr":"⇅","Udblac":"Ű","udblac":"ű","udhar":"⥮","ufisht":"⥾","Ufr":"𝔘","ufr":"𝔲","Ugrave":"Ù","ugrave":"ù","uHar":"⥣","uharl":"↿","uharr":"↾","uhblk":"▀","ulcorn":"⌜","ulcorner":"⌜","ulcrop":"⌏","ultri":"◸","Umacr":"Ū","umacr":"ū","uml":"¨","UnderBar":"_","UnderBrace":"⏟","UnderBracket":"⎵","UnderParenthesis":"⏝","Union":"⋃","UnionPlus":"⊎","Uogon":"Ų","uogon":"ų","Uopf":"𝕌","uopf":"𝕦","UpArrowBar":"⤒","uparrow":"↑","UpArrow":"↑","Uparrow":"⇑","UpArrowDownArrow":"⇅","updownarrow":"↕","UpDownArrow":"↕","Updownarrow":"⇕","UpEquilibrium":"⥮","upharpoonleft":"↿","upharpoonright":"↾","uplus":"⊎","UpperLeftArrow":"↖","UpperRightArrow":"↗","upsi":"υ","Upsi":"ϒ","upsih":"ϒ","Upsilon":"Υ","upsilon":"υ","UpTeeArrow":"↥","UpTee":"⊥","upuparrows":"⇈","urcorn":"⌝","urcorner":"⌝","urcrop":"⌎","Uring":"Ů","uring":"ů","urtri":"◹","Uscr":"𝒰","uscr":"𝓊","utdot":"⋰","Utilde":"Ũ","utilde":"ũ","utri":"▵","utrif":"▴","uuarr":"⇈","Uuml":"Ü","uuml":"ü","uwangle":"⦧","vangrt":"⦜","varepsilon":"ϵ","varkappa":"ϰ","varnothing":"∅","varphi":"ϕ","varpi":"ϖ","varpropto":"∝","varr":"↕","vArr":"⇕","varrho":"ϱ","varsigma":"ς","varsubsetneq":"⊊︀","varsubsetneqq":"⫋︀","varsupsetneq":"⊋︀","varsupsetneqq":"⫌︀","vartheta":"ϑ","vartriangleleft":"⊲","vartriangleright":"⊳","vBar":"⫨","Vbar":"⫫","vBarv":"⫩","Vcy":"В","vcy":"в","vdash":"⊢","vDash":"⊨","Vdash":"⊩","VDash":"⊫","Vdashl":"⫦","veebar":"⊻","vee":"∨","Vee":"⋁","veeeq":"≚","vellip":"⋮","verbar":"|","Verbar":"‖","vert":"|","Vert":"‖","VerticalBar":"∣","VerticalLine":"|","VerticalSeparator":"❘","VerticalTilde":"≀","VeryThinSpace":" ","Vfr":"𝔙","vfr":"𝔳","vltri":"⊲","vnsub":"⊂⃒","vnsup":"⊃⃒","Vopf":"𝕍","vopf":"𝕧","vprop":"∝","vrtri":"⊳","Vscr":"𝒱","vscr":"𝓋","vsubnE":"⫋︀","vsubne":"⊊︀","vsupnE":"⫌︀","vsupne":"⊋︀","Vvdash":"⊪","vzigzag":"⦚","Wcirc":"Ŵ","wcirc":"ŵ","wedbar":"⩟","wedge":"∧","Wedge":"⋀","wedgeq":"≙","weierp":"℘","Wfr":"𝔚","wfr":"𝔴","Wopf":"𝕎","wopf":"𝕨","wp":"℘","wr":"≀","wreath":"≀","Wscr":"𝒲","wscr":"𝓌","xcap":"⋂","xcirc":"◯","xcup":"⋃","xdtri":"▽","Xfr":"𝔛","xfr":"𝔵","xharr":"⟷","xhArr":"⟺","Xi":"Ξ","xi":"ξ","xlarr":"⟵","xlArr":"⟸","xmap":"⟼","xnis":"⋻","xodot":"⨀","Xopf":"𝕏","xopf":"𝕩","xoplus":"⨁","xotime":"⨂","xrarr":"⟶","xrArr":"⟹","Xscr":"𝒳","xscr":"𝓍","xsqcup":"⨆","xuplus":"⨄","xutri":"△","xvee":"⋁","xwedge":"⋀","Yacute":"Ý","yacute":"ý","YAcy":"Я","yacy":"я","Ycirc":"Ŷ","ycirc":"ŷ","Ycy":"Ы","ycy":"ы","yen":"¥","Yfr":"𝔜","yfr":"𝔶","YIcy":"Ї","yicy":"ї","Yopf":"𝕐","yopf":"𝕪","Yscr":"𝒴","yscr":"𝓎","YUcy":"Ю","yucy":"ю","yuml":"ÿ","Yuml":"Ÿ","Zacute":"Ź","zacute":"ź","Zcaron":"Ž","zcaron":"ž","Zcy":"З","zcy":"з","Zdot":"Ż","zdot":"ż","zeetrf":"ℨ","ZeroWidthSpace":"​","Zeta":"Ζ","zeta":"ζ","zfr":"𝔷","Zfr":"ℨ","ZHcy":"Ж","zhcy":"ж","zigrarr":"⇝","zopf":"𝕫","Zopf":"ℤ","Zscr":"𝒵","zscr":"𝓏","zwj":"‍","zwnj":"‌"}

/***/ }),
/* 563 */
/***/ (function(module, exports) {

	module.exports = {"100":"💯","1234":"🔢","grinning":"😀","smiley":"😃","smile":"😄","grin":"😁","laughing":"😆","satisfied":"😆","sweat_smile":"😅","joy":"😂","rofl":"🤣","relaxed":"☺️","blush":"😊","innocent":"😇","slightly_smiling_face":"🙂","upside_down_face":"🙃","wink":"😉","relieved":"😌","heart_eyes":"😍","kissing_heart":"😘","kissing":"😗","kissing_smiling_eyes":"😙","kissing_closed_eyes":"😚","yum":"😋","stuck_out_tongue_winking_eye":"😜","stuck_out_tongue_closed_eyes":"😝","stuck_out_tongue":"😛","money_mouth_face":"🤑","hugs":"🤗","nerd_face":"🤓","sunglasses":"😎","clown_face":"🤡","cowboy_hat_face":"🤠","smirk":"😏","unamused":"😒","disappointed":"😞","pensive":"😔","worried":"😟","confused":"😕","slightly_frowning_face":"🙁","frowning_face":"☹️","persevere":"😣","confounded":"😖","tired_face":"😫","weary":"😩","triumph":"😤","angry":"😠","rage":"😡","pout":"😡","no_mouth":"😶","neutral_face":"😐","expressionless":"😑","hushed":"😯","frowning":"😦","anguished":"😧","open_mouth":"😮","astonished":"😲","dizzy_face":"😵","flushed":"😳","scream":"😱","fearful":"😨","cold_sweat":"😰","cry":"😢","disappointed_relieved":"😥","drooling_face":"🤤","sob":"😭","sweat":"😓","sleepy":"😪","sleeping":"😴","roll_eyes":"🙄","thinking":"🤔","lying_face":"🤥","grimacing":"😬","zipper_mouth_face":"🤐","nauseated_face":"🤢","sneezing_face":"🤧","mask":"😷","face_with_thermometer":"🤒","face_with_head_bandage":"🤕","smiling_imp":"😈","imp":"👿","japanese_ogre":"👹","japanese_goblin":"👺","hankey":"💩","poop":"💩","shit":"💩","ghost":"👻","skull":"💀","skull_and_crossbones":"☠️","alien":"👽","space_invader":"👾","robot":"🤖","jack_o_lantern":"🎃","smiley_cat":"😺","smile_cat":"😸","joy_cat":"😹","heart_eyes_cat":"😻","smirk_cat":"😼","kissing_cat":"😽","scream_cat":"🙀","crying_cat_face":"😿","pouting_cat":"😾","open_hands":"👐","raised_hands":"🙌","clap":"👏","pray":"🙏","handshake":"🤝","+1":"👍","thumbsup":"👍","-1":"👎","thumbsdown":"👎","fist_oncoming":"👊","facepunch":"👊","punch":"👊","fist_raised":"✊","fist":"✊","fist_left":"🤛","fist_right":"🤜","crossed_fingers":"🤞","v":"✌️","metal":"🤘","ok_hand":"👌","point_left":"👈","point_right":"👉","point_up_2":"👆","point_down":"👇","point_up":"☝️","hand":"✋","raised_hand":"✋","raised_back_of_hand":"🤚","raised_hand_with_fingers_splayed":"🖐","vulcan_salute":"🖖","wave":"👋","call_me_hand":"🤙","muscle":"💪","middle_finger":"🖕","fu":"🖕","writing_hand":"✍️","selfie":"🤳","nail_care":"💅","ring":"💍","lipstick":"💄","kiss":"💋","lips":"👄","tongue":"👅","ear":"👂","nose":"👃","footprints":"👣","eye":"👁","eyes":"👀","speaking_head":"🗣","bust_in_silhouette":"👤","busts_in_silhouette":"👥","baby":"👶","boy":"👦","girl":"👧","man":"👨","woman":"👩","blonde_woman":"👱‍♀","blonde_man":"👱","person_with_blond_hair":"👱","older_man":"👴","older_woman":"👵","man_with_gua_pi_mao":"👲","woman_with_turban":"👳‍♀","man_with_turban":"👳","policewoman":"👮‍♀","policeman":"👮","cop":"👮","construction_worker_woman":"👷‍♀","construction_worker_man":"👷","construction_worker":"👷","guardswoman":"💂‍♀","guardsman":"💂","female_detective":"🕵️‍♀️","male_detective":"🕵","detective":"🕵","woman_health_worker":"👩‍⚕","man_health_worker":"👨‍⚕","woman_farmer":"👩‍🌾","man_farmer":"👨‍🌾","woman_cook":"👩‍🍳","man_cook":"👨‍🍳","woman_student":"👩‍🎓","man_student":"👨‍🎓","woman_singer":"👩‍🎤","man_singer":"👨‍🎤","woman_teacher":"👩‍🏫","man_teacher":"👨‍🏫","woman_factory_worker":"👩‍🏭","man_factory_worker":"👨‍🏭","woman_technologist":"👩‍💻","man_technologist":"👨‍💻","woman_office_worker":"👩‍💼","man_office_worker":"👨‍💼","woman_mechanic":"👩‍🔧","man_mechanic":"👨‍🔧","woman_scientist":"👩‍🔬","man_scientist":"👨‍🔬","woman_artist":"👩‍🎨","man_artist":"👨‍🎨","woman_firefighter":"👩‍🚒","man_firefighter":"👨‍🚒","woman_pilot":"👩‍✈","man_pilot":"👨‍✈","woman_astronaut":"👩‍🚀","man_astronaut":"👨‍🚀","woman_judge":"👩‍⚖","man_judge":"👨‍⚖","mrs_claus":"🤶","santa":"🎅","princess":"👸","prince":"🤴","bride_with_veil":"👰","man_in_tuxedo":"🤵","angel":"👼","pregnant_woman":"🤰","bowing_woman":"🙇‍♀","bowing_man":"🙇","bow":"🙇","tipping_hand_woman":"💁","information_desk_person":"💁","sassy_woman":"💁","tipping_hand_man":"💁‍♂","sassy_man":"💁‍♂","no_good_woman":"🙅","no_good":"🙅","ng_woman":"🙅","no_good_man":"🙅‍♂","ng_man":"🙅‍♂","ok_woman":"🙆","ok_man":"🙆‍♂","raising_hand_woman":"🙋","raising_hand":"🙋","raising_hand_man":"🙋‍♂","woman_facepalming":"🤦‍♀","man_facepalming":"🤦‍♂","woman_shrugging":"🤷‍♀","man_shrugging":"🤷‍♂","pouting_woman":"🙎","person_with_pouting_face":"🙎","pouting_man":"🙎‍♂","frowning_woman":"🙍","person_frowning":"🙍","frowning_man":"🙍‍♂","haircut_woman":"💇","haircut":"💇","haircut_man":"💇‍♂","massage_woman":"💆","massage":"💆","massage_man":"💆‍♂","business_suit_levitating":"🕴","dancer":"💃","man_dancing":"🕺","dancing_women":"👯","dancers":"👯","dancing_men":"👯‍♂","walking_woman":"🚶‍♀","walking_man":"🚶","walking":"🚶","running_woman":"🏃‍♀","running_man":"🏃","runner":"🏃","running":"🏃","couple":"👫","two_women_holding_hands":"👭","two_men_holding_hands":"👬","couple_with_heart_woman_man":"💑","couple_with_heart":"💑","couple_with_heart_woman_woman":"👩‍❤️‍👩","couple_with_heart_man_man":"👨‍❤️‍👨","couplekiss_man_woman":"💏","couplekiss_woman_woman":"👩‍❤️‍💋‍👩","couplekiss_man_man":"👨‍❤️‍💋‍👨","family_man_woman_boy":"👪","family":"👪","family_man_woman_girl":"👨‍👩‍👧","family_man_woman_girl_boy":"👨‍👩‍👧‍👦","family_man_woman_boy_boy":"👨‍👩‍👦‍👦","family_man_woman_girl_girl":"👨‍👩‍👧‍👧","family_woman_woman_boy":"👩‍👩‍👦","family_woman_woman_girl":"👩‍👩‍👧","family_woman_woman_girl_boy":"👩‍👩‍👧‍👦","family_woman_woman_boy_boy":"👩‍👩‍👦‍👦","family_woman_woman_girl_girl":"👩‍👩‍👧‍👧","family_man_man_boy":"👨‍👨‍👦","family_man_man_girl":"👨‍👨‍👧","family_man_man_girl_boy":"👨‍👨‍👧‍👦","family_man_man_boy_boy":"👨‍👨‍👦‍👦","family_man_man_girl_girl":"👨‍👨‍👧‍👧","family_woman_boy":"👩‍👦","family_woman_girl":"👩‍👧","family_woman_girl_boy":"👩‍👧‍👦","family_woman_boy_boy":"👩‍👦‍👦","family_woman_girl_girl":"👩‍👧‍👧","family_man_boy":"👨‍👦","family_man_girl":"👨‍👧","family_man_girl_boy":"👨‍👧‍👦","family_man_boy_boy":"👨‍👦‍👦","family_man_girl_girl":"👨‍👧‍👧","womans_clothes":"👚","shirt":"👕","tshirt":"👕","jeans":"👖","necktie":"👔","dress":"👗","bikini":"👙","kimono":"👘","high_heel":"👠","sandal":"👡","boot":"👢","mans_shoe":"👞","shoe":"👞","athletic_shoe":"👟","womans_hat":"👒","tophat":"🎩","mortar_board":"🎓","crown":"👑","rescue_worker_helmet":"⛑","school_satchel":"🎒","pouch":"👝","purse":"👛","handbag":"👜","briefcase":"💼","eyeglasses":"👓","dark_sunglasses":"🕶","closed_umbrella":"🌂","open_umbrella":"☂️","dog":"🐶","cat":"🐱","mouse":"🐭","hamster":"🐹","rabbit":"🐰","fox_face":"🦊","bear":"🐻","panda_face":"🐼","koala":"🐨","tiger":"🐯","lion":"🦁","cow":"🐮","pig":"🐷","pig_nose":"🐽","frog":"🐸","monkey_face":"🐵","see_no_evil":"🙈","hear_no_evil":"🙉","speak_no_evil":"🙊","monkey":"🐒","chicken":"🐔","penguin":"🐧","bird":"🐦","baby_chick":"🐤","hatching_chick":"🐣","hatched_chick":"🐥","duck":"🦆","eagle":"🦅","owl":"🦉","bat":"🦇","wolf":"🐺","boar":"🐗","horse":"🐴","unicorn":"🦄","bee":"🐝","honeybee":"🐝","bug":"🐛","butterfly":"🦋","snail":"🐌","shell":"🐚","beetle":"🐞","ant":"🐜","spider":"🕷","spider_web":"🕸","turtle":"🐢","snake":"🐍","lizard":"🦎","scorpion":"🦂","crab":"🦀","squid":"🦑","octopus":"🐙","shrimp":"🦐","tropical_fish":"🐠","fish":"🐟","blowfish":"🐡","dolphin":"🐬","flipper":"🐬","shark":"🦈","whale":"🐳","whale2":"🐋","crocodile":"🐊","leopard":"🐆","tiger2":"🐅","water_buffalo":"🐃","ox":"🐂","cow2":"🐄","deer":"🦌","dromedary_camel":"🐪","camel":"🐫","elephant":"🐘","rhinoceros":"🦏","gorilla":"🦍","racehorse":"🐎","pig2":"🐖","goat":"🐐","ram":"🐏","sheep":"🐑","dog2":"🐕","poodle":"🐩","cat2":"🐈","rooster":"🐓","turkey":"🦃","dove":"🕊","rabbit2":"🐇","mouse2":"🐁","rat":"🐀","chipmunk":"🐿","feet":"🐾","paw_prints":"🐾","dragon":"🐉","dragon_face":"🐲","cactus":"🌵","christmas_tree":"🎄","evergreen_tree":"🌲","deciduous_tree":"🌳","palm_tree":"🌴","seedling":"🌱","herb":"🌿","shamrock":"☘️","four_leaf_clover":"🍀","bamboo":"🎍","tanabata_tree":"🎋","leaves":"🍃","fallen_leaf":"🍂","maple_leaf":"🍁","mushroom":"🍄","ear_of_rice":"🌾","bouquet":"💐","tulip":"🌷","rose":"🌹","wilted_flower":"🥀","sunflower":"🌻","blossom":"🌼","cherry_blossom":"🌸","hibiscus":"🌺","earth_americas":"🌎","earth_africa":"🌍","earth_asia":"🌏","full_moon":"🌕","waning_gibbous_moon":"🌖","last_quarter_moon":"🌗","waning_crescent_moon":"🌘","new_moon":"🌑","waxing_crescent_moon":"🌒","first_quarter_moon":"🌓","moon":"🌔","waxing_gibbous_moon":"🌔","new_moon_with_face":"🌚","full_moon_with_face":"🌝","sun_with_face":"🌞","first_quarter_moon_with_face":"🌛","last_quarter_moon_with_face":"🌜","crescent_moon":"🌙","dizzy":"💫","star":"⭐️","star2":"🌟","sparkles":"✨","zap":"⚡️","fire":"🔥","boom":"💥","collision":"💥","comet":"☄","sunny":"☀️","sun_behind_small_cloud":"🌤","partly_sunny":"⛅️","sun_behind_large_cloud":"🌥","sun_behind_rain_cloud":"🌦","rainbow":"🌈","cloud":"☁️","cloud_with_rain":"🌧","cloud_with_lightning_and_rain":"⛈","cloud_with_lightning":"🌩","cloud_with_snow":"🌨","snowman_with_snow":"☃️","snowman":"⛄️","snowflake":"❄️","wind_face":"🌬","dash":"💨","tornado":"🌪","fog":"🌫","ocean":"🌊","droplet":"💧","sweat_drops":"💦","umbrella":"☔️","green_apple":"🍏","apple":"🍎","pear":"🍐","tangerine":"🍊","orange":"🍊","mandarin":"🍊","lemon":"🍋","banana":"🍌","watermelon":"🍉","grapes":"🍇","strawberry":"🍓","melon":"🍈","cherries":"🍒","peach":"🍑","pineapple":"🍍","kiwi_fruit":"🥝","avocado":"🥑","tomato":"🍅","eggplant":"🍆","cucumber":"🥒","carrot":"🥕","corn":"🌽","hot_pepper":"🌶","potato":"🥔","sweet_potato":"🍠","chestnut":"🌰","peanuts":"🥜","honey_pot":"🍯","croissant":"🥐","bread":"🍞","baguette_bread":"🥖","cheese":"🧀","egg":"🥚","fried_egg":"🍳","bacon":"🥓","pancakes":"🥞","fried_shrimp":"🍤","poultry_leg":"🍗","meat_on_bone":"🍖","pizza":"🍕","hotdog":"🌭","hamburger":"🍔","fries":"🍟","stuffed_flatbread":"🥙","taco":"🌮","burrito":"🌯","green_salad":"🥗","shallow_pan_of_food":"🥘","spaghetti":"🍝","ramen":"🍜","stew":"🍲","fish_cake":"🍥","sushi":"🍣","bento":"🍱","curry":"🍛","rice":"🍚","rice_ball":"🍙","rice_cracker":"🍘","oden":"🍢","dango":"🍡","shaved_ice":"🍧","ice_cream":"🍨","icecream":"🍦","cake":"🍰","birthday":"🎂","custard":"🍮","lollipop":"🍭","candy":"🍬","chocolate_bar":"🍫","popcorn":"🍿","doughnut":"🍩","cookie":"🍪","milk_glass":"🥛","baby_bottle":"🍼","coffee":"☕️","tea":"🍵","sake":"🍶","beer":"🍺","beers":"🍻","clinking_glasses":"🥂","wine_glass":"🍷","tumbler_glass":"🥃","cocktail":"🍸","tropical_drink":"🍹","champagne":"🍾","spoon":"🥄","fork_and_knife":"🍴","plate_with_cutlery":"🍽","soccer":"⚽️","basketball":"🏀","football":"🏈","baseball":"⚾️","tennis":"🎾","volleyball":"🏐","rugby_football":"🏉","8ball":"🎱","ping_pong":"🏓","badminton":"🏸","goal_net":"🥅","ice_hockey":"🏒","field_hockey":"🏑","cricket":"🏏","golf":"⛳️","bow_and_arrow":"🏹","fishing_pole_and_fish":"🎣","boxing_glove":"🥊","martial_arts_uniform":"🥋","ice_skate":"⛸","ski":"🎿","skier":"⛷","snowboarder":"🏂","weight_lifting_woman":"🏋️‍♀️","weight_lifting_man":"🏋","person_fencing":"🤺","women_wrestling":"🤼‍♀","men_wrestling":"🤼‍♂","woman_cartwheeling":"🤸‍♀","man_cartwheeling":"🤸‍♂","basketball_woman":"⛹️‍♀️","basketball_man":"⛹","woman_playing_handball":"🤾‍♀","man_playing_handball":"🤾‍♂","golfing_woman":"🏌️‍♀️","golfing_man":"🏌","surfing_woman":"🏄‍♀","surfing_man":"🏄","surfer":"🏄","swimming_woman":"🏊‍♀","swimming_man":"🏊","swimmer":"🏊","woman_playing_water_polo":"🤽‍♀","man_playing_water_polo":"🤽‍♂","rowing_woman":"🚣‍♀","rowing_man":"🚣","rowboat":"🚣","horse_racing":"🏇","biking_woman":"🚴‍♀","biking_man":"🚴","bicyclist":"🚴","mountain_biking_woman":"🚵‍♀","mountain_biking_man":"🚵","mountain_bicyclist":"🚵","running_shirt_with_sash":"🎽","medal_sports":"🏅","medal_military":"🎖","1st_place_medal":"🥇","2nd_place_medal":"🥈","3rd_place_medal":"🥉","trophy":"🏆","rosette":"🏵","reminder_ribbon":"🎗","ticket":"🎫","tickets":"🎟","circus_tent":"🎪","woman_juggling":"🤹‍♀","man_juggling":"🤹‍♂","performing_arts":"🎭","art":"🎨","clapper":"🎬","microphone":"🎤","headphones":"🎧","musical_score":"🎼","musical_keyboard":"🎹","drum":"🥁","saxophone":"🎷","trumpet":"🎺","guitar":"🎸","violin":"🎻","game_die":"🎲","dart":"🎯","bowling":"🎳","video_game":"🎮","slot_machine":"🎰","car":"🚗","red_car":"🚗","taxi":"🚕","blue_car":"🚙","bus":"🚌","trolleybus":"🚎","racing_car":"🏎","police_car":"🚓","ambulance":"🚑","fire_engine":"🚒","minibus":"🚐","truck":"🚚","articulated_lorry":"🚛","tractor":"🚜","kick_scooter":"🛴","bike":"🚲","motor_scooter":"🛵","motorcycle":"🏍","rotating_light":"🚨","oncoming_police_car":"🚔","oncoming_bus":"🚍","oncoming_automobile":"🚘","oncoming_taxi":"🚖","aerial_tramway":"🚡","mountain_cableway":"🚠","suspension_railway":"🚟","railway_car":"🚃","train":"🚋","mountain_railway":"🚞","monorail":"🚝","bullettrain_side":"🚄","bullettrain_front":"🚅","light_rail":"🚈","steam_locomotive":"🚂","train2":"🚆","metro":"🚇","tram":"🚊","station":"🚉","helicopter":"🚁","small_airplane":"🛩","airplane":"✈️","flight_departure":"🛫","flight_arrival":"🛬","rocket":"🚀","artificial_satellite":"🛰","seat":"💺","canoe":"🛶","boat":"⛵️","sailboat":"⛵️","motor_boat":"🛥","speedboat":"🚤","passenger_ship":"🛳","ferry":"⛴","ship":"🚢","anchor":"⚓️","construction":"🚧","fuelpump":"⛽️","busstop":"🚏","vertical_traffic_light":"🚦","traffic_light":"🚥","world_map":"🗺","moyai":"🗿","statue_of_liberty":"🗽","fountain":"⛲️","tokyo_tower":"🗼","european_castle":"🏰","japanese_castle":"🏯","stadium":"🏟","ferris_wheel":"🎡","roller_coaster":"🎢","carousel_horse":"🎠","parasol_on_ground":"⛱","beach_umbrella":"🏖","desert_island":"🏝","mountain":"⛰","mountain_snow":"🏔","mount_fuji":"🗻","volcano":"🌋","desert":"🏜","camping":"🏕","tent":"⛺️","railway_track":"🛤","motorway":"🛣","building_construction":"🏗","factory":"🏭","house":"🏠","house_with_garden":"🏡","houses":"🏘","derelict_house":"🏚","office":"🏢","department_store":"🏬","post_office":"🏣","european_post_office":"🏤","hospital":"🏥","bank":"🏦","hotel":"🏨","convenience_store":"🏪","school":"🏫","love_hotel":"🏩","wedding":"💒","classical_building":"🏛","church":"⛪️","mosque":"🕌","synagogue":"🕍","kaaba":"🕋","shinto_shrine":"⛩","japan":"🗾","rice_scene":"🎑","national_park":"🏞","sunrise":"🌅","sunrise_over_mountains":"🌄","stars":"🌠","sparkler":"🎇","fireworks":"🎆","city_sunrise":"🌇","city_sunset":"🌆","cityscape":"🏙","night_with_stars":"🌃","milky_way":"🌌","bridge_at_night":"🌉","foggy":"🌁","watch":"⌚️","iphone":"📱","calling":"📲","computer":"💻","keyboard":"⌨️","desktop_computer":"🖥","printer":"🖨","computer_mouse":"🖱","trackball":"🖲","joystick":"🕹","clamp":"🗜","minidisc":"💽","floppy_disk":"💾","cd":"💿","dvd":"📀","vhs":"📼","camera":"📷","camera_flash":"📸","video_camera":"📹","movie_camera":"🎥","film_projector":"📽","film_strip":"🎞","telephone_receiver":"📞","phone":"☎️","telephone":"☎️","pager":"📟","fax":"📠","tv":"📺","radio":"📻","studio_microphone":"🎙","level_slider":"🎚","control_knobs":"🎛","stopwatch":"⏱","timer_clock":"⏲","alarm_clock":"⏰","mantelpiece_clock":"🕰","hourglass":"⌛️","hourglass_flowing_sand":"⏳","satellite":"📡","battery":"🔋","electric_plug":"🔌","bulb":"💡","flashlight":"🔦","candle":"🕯","wastebasket":"🗑","oil_drum":"🛢","money_with_wings":"💸","dollar":"💵","yen":"💴","euro":"💶","pound":"💷","moneybag":"💰","credit_card":"💳","gem":"💎","balance_scale":"⚖️","wrench":"🔧","hammer":"🔨","hammer_and_pick":"⚒","hammer_and_wrench":"🛠","pick":"⛏","nut_and_bolt":"🔩","gear":"⚙️","chains":"⛓","gun":"🔫","bomb":"💣","hocho":"🔪","knife":"🔪","dagger":"🗡","crossed_swords":"⚔️","shield":"🛡","smoking":"🚬","coffin":"⚰️","funeral_urn":"⚱️","amphora":"🏺","crystal_ball":"🔮","prayer_beads":"📿","barber":"💈","alembic":"⚗️","telescope":"🔭","microscope":"🔬","hole":"🕳","pill":"💊","syringe":"💉","thermometer":"🌡","toilet":"🚽","potable_water":"🚰","shower":"🚿","bathtub":"🛁","bath":"🛀","bellhop_bell":"🛎","key":"🔑","old_key":"🗝","door":"🚪","couch_and_lamp":"🛋","bed":"🛏","sleeping_bed":"🛌","framed_picture":"🖼","shopping":"🛍","shopping_cart":"🛒","gift":"🎁","balloon":"🎈","flags":"🎏","ribbon":"🎀","confetti_ball":"🎊","tada":"🎉","dolls":"🎎","izakaya_lantern":"🏮","lantern":"🏮","wind_chime":"🎐","email":"✉️","envelope":"✉️","envelope_with_arrow":"📩","incoming_envelope":"📨","e-mail":"📧","love_letter":"💌","inbox_tray":"📥","outbox_tray":"📤","package":"📦","label":"🏷","mailbox_closed":"📪","mailbox":"📫","mailbox_with_mail":"📬","mailbox_with_no_mail":"📭","postbox":"📮","postal_horn":"📯","scroll":"📜","page_with_curl":"📃","page_facing_up":"📄","bookmark_tabs":"📑","bar_chart":"📊","chart_with_upwards_trend":"📈","chart_with_downwards_trend":"📉","spiral_notepad":"🗒","spiral_calendar":"🗓","calendar":"📆","date":"📅","card_index":"📇","card_file_box":"🗃","ballot_box":"🗳","file_cabinet":"🗄","clipboard":"📋","file_folder":"📁","open_file_folder":"📂","card_index_dividers":"🗂","newspaper_roll":"🗞","newspaper":"📰","notebook":"📓","notebook_with_decorative_cover":"📔","ledger":"📒","closed_book":"📕","green_book":"📗","blue_book":"📘","orange_book":"📙","books":"📚","book":"📖","open_book":"📖","bookmark":"🔖","link":"🔗","paperclip":"📎","paperclips":"🖇","triangular_ruler":"📐","straight_ruler":"📏","pushpin":"📌","round_pushpin":"📍","scissors":"✂️","pen":"🖊","fountain_pen":"🖋","black_nib":"✒️","paintbrush":"🖌","crayon":"🖍","memo":"📝","pencil":"📝","pencil2":"✏️","mag":"🔍","mag_right":"🔎","lock_with_ink_pen":"🔏","closed_lock_with_key":"🔐","lock":"🔒","unlock":"🔓","heart":"❤️","yellow_heart":"💛","green_heart":"💚","blue_heart":"💙","purple_heart":"💜","black_heart":"🖤","broken_heart":"💔","heavy_heart_exclamation":"❣️","two_hearts":"💕","revolving_hearts":"💞","heartbeat":"💓","heartpulse":"💗","sparkling_heart":"💖","cupid":"💘","gift_heart":"💝","heart_decoration":"💟","peace_symbol":"☮️","latin_cross":"✝️","star_and_crescent":"☪️","om":"🕉","wheel_of_dharma":"☸️","star_of_david":"✡️","six_pointed_star":"🔯","menorah":"🕎","yin_yang":"☯️","orthodox_cross":"☦️","place_of_worship":"🛐","ophiuchus":"⛎","aries":"♈️","taurus":"♉️","gemini":"♊️","cancer":"♋️","leo":"♌️","virgo":"♍️","libra":"♎️","scorpius":"♏️","sagittarius":"♐️","capricorn":"♑️","aquarius":"♒️","pisces":"♓️","id":"🆔","atom_symbol":"⚛️","accept":"🉑","radioactive":"☢️","biohazard":"☣️","mobile_phone_off":"📴","vibration_mode":"📳","eight_pointed_black_star":"✴️","vs":"🆚","white_flower":"💮","ideograph_advantage":"🉐","secret":"㊙️","congratulations":"㊗️","u6e80":"🈵","a":"🅰️","b":"🅱️","ab":"🆎","cl":"🆑","o2":"🅾️","sos":"🆘","x":"❌","o":"⭕️","stop_sign":"🛑","no_entry":"⛔️","name_badge":"📛","no_entry_sign":"🚫","anger":"💢","hotsprings":"♨️","no_pedestrians":"🚷","do_not_litter":"🚯","no_bicycles":"🚳","non-potable_water":"🚱","underage":"🔞","no_mobile_phones":"📵","no_smoking":"🚭","exclamation":"❗️","heavy_exclamation_mark":"❗️","grey_exclamation":"❕","question":"❓","grey_question":"❔","bangbang":"‼️","interrobang":"⁉️","low_brightness":"🔅","high_brightness":"🔆","part_alternation_mark":"〽️","warning":"⚠️","children_crossing":"🚸","trident":"🔱","fleur_de_lis":"⚜️","beginner":"🔰","recycle":"♻️","white_check_mark":"✅","chart":"💹","sparkle":"❇️","eight_spoked_asterisk":"✳️","negative_squared_cross_mark":"❎","globe_with_meridians":"🌐","diamond_shape_with_a_dot_inside":"💠","m":"Ⓜ️","cyclone":"🌀","zzz":"💤","atm":"🏧","wc":"🚾","wheelchair":"♿️","parking":"🅿️","sa":"🈂️","passport_control":"🛂","customs":"🛃","baggage_claim":"🛄","left_luggage":"🛅","mens":"🚹","womens":"🚺","baby_symbol":"🚼","restroom":"🚻","put_litter_in_its_place":"🚮","cinema":"🎦","signal_strength":"📶","koko":"🈁","symbols":"🔣","information_source":"ℹ️","abc":"🔤","abcd":"🔡","capital_abcd":"🔠","ng":"🆖","ok":"🆗","up":"🆙","cool":"🆒","new":"🆕","free":"🆓","zero":"0️⃣","one":"1️⃣","two":"2️⃣","three":"3️⃣","four":"4️⃣","five":"5️⃣","six":"6️⃣","seven":"7️⃣","eight":"8️⃣","nine":"9️⃣","keycap_ten":"🔟","hash":"#️⃣","asterisk":"*️⃣","arrow_forward":"▶️","pause_button":"⏸","play_or_pause_button":"⏯","stop_button":"⏹","record_button":"⏺","next_track_button":"⏭","previous_track_button":"⏮","fast_forward":"⏩","rewind":"⏪","arrow_double_up":"⏫","arrow_double_down":"⏬","arrow_backward":"◀️","arrow_up_small":"🔼","arrow_down_small":"🔽","arrow_right":"➡️","arrow_left":"⬅️","arrow_up":"⬆️","arrow_down":"⬇️","arrow_upper_right":"↗️","arrow_lower_right":"↘️","arrow_lower_left":"↙️","arrow_upper_left":"↖️","arrow_up_down":"↕️","left_right_arrow":"↔️","arrow_right_hook":"↪️","leftwards_arrow_with_hook":"↩️","arrow_heading_up":"⤴️","arrow_heading_down":"⤵️","twisted_rightwards_arrows":"🔀","repeat":"🔁","repeat_one":"🔂","arrows_counterclockwise":"🔄","arrows_clockwise":"🔃","musical_note":"🎵","notes":"🎶","heavy_plus_sign":"➕","heavy_minus_sign":"➖","heavy_division_sign":"➗","heavy_multiplication_x":"✖️","heavy_dollar_sign":"💲","currency_exchange":"💱","tm":"™️","copyright":"©️","registered":"®️","wavy_dash":"〰️","curly_loop":"➰","loop":"➿","end":"🔚","back":"🔙","on":"🔛","top":"🔝","soon":"🔜","heavy_check_mark":"✔️","ballot_box_with_check":"☑️","radio_button":"🔘","white_circle":"⚪️","black_circle":"⚫️","red_circle":"🔴","large_blue_circle":"🔵","small_red_triangle":"🔺","small_red_triangle_down":"🔻","small_orange_diamond":"🔸","small_blue_diamond":"🔹","large_orange_diamond":"🔶","large_blue_diamond":"🔷","white_square_button":"🔳","black_square_button":"🔲","black_small_square":"▪️","white_small_square":"▫️","black_medium_small_square":"◾️","white_medium_small_square":"◽️","black_medium_square":"◼️","white_medium_square":"◻️","black_large_square":"⬛️","white_large_square":"⬜️","speaker":"🔈","mute":"🔇","sound":"🔉","loud_sound":"🔊","bell":"🔔","no_bell":"🔕","mega":"📣","loudspeaker":"📢","eye_speech_bubble":"👁‍🗨","speech_balloon":"💬","thought_balloon":"💭","right_anger_bubble":"🗯","spades":"♠️","clubs":"♣️","hearts":"♥️","diamonds":"♦️","black_joker":"🃏","flower_playing_cards":"🎴","mahjong":"🀄️","clock1":"🕐","clock2":"🕑","clock3":"🕒","clock4":"🕓","clock5":"🕔","clock6":"🕕","clock7":"🕖","clock8":"🕗","clock9":"🕘","clock10":"🕙","clock11":"🕚","clock12":"🕛","clock130":"🕜","clock230":"🕝","clock330":"🕞","clock430":"🕟","clock530":"🕠","clock630":"🕡","clock730":"🕢","clock830":"🕣","clock930":"🕤","clock1030":"🕥","clock1130":"🕦","clock1230":"🕧","white_flag":"🏳️","black_flag":"🏴","checkered_flag":"🏁","triangular_flag_on_post":"🚩","rainbow_flag":"🏳️‍🌈","afghanistan":"🇦🇫","aland_islands":"🇦🇽","albania":"🇦🇱","algeria":"🇩🇿","american_samoa":"🇦🇸","andorra":"🇦🇩","angola":"🇦🇴","anguilla":"🇦🇮","antarctica":"🇦🇶","antigua_barbuda":"🇦🇬","argentina":"🇦🇷","armenia":"🇦🇲","aruba":"🇦🇼","australia":"🇦🇺","austria":"🇦🇹","azerbaijan":"🇦🇿","bahamas":"🇧🇸","bahrain":"🇧🇭","bangladesh":"🇧🇩","barbados":"🇧🇧","belarus":"🇧🇾","belgium":"🇧🇪","belize":"🇧🇿","benin":"🇧🇯","bermuda":"🇧🇲","bhutan":"🇧🇹","bolivia":"🇧🇴","caribbean_netherlands":"🇧🇶","bosnia_herzegovina":"🇧🇦","botswana":"🇧🇼","brazil":"🇧🇷","british_indian_ocean_territory":"🇮🇴","british_virgin_islands":"🇻🇬","brunei":"🇧🇳","bulgaria":"🇧🇬","burkina_faso":"🇧🇫","burundi":"🇧🇮","cape_verde":"🇨🇻","cambodia":"🇰🇭","cameroon":"🇨🇲","canada":"🇨🇦","canary_islands":"🇮🇨","cayman_islands":"🇰🇾","central_african_republic":"🇨🇫","chad":"🇹🇩","chile":"🇨🇱","cn":"🇨🇳","christmas_island":"🇨🇽","cocos_islands":"🇨🇨","colombia":"🇨🇴","comoros":"🇰🇲","congo_brazzaville":"🇨🇬","congo_kinshasa":"🇨🇩","cook_islands":"🇨🇰","costa_rica":"🇨🇷","cote_divoire":"🇨🇮","croatia":"🇭🇷","cuba":"🇨🇺","curacao":"🇨🇼","cyprus":"🇨🇾","czech_republic":"🇨🇿","denmark":"🇩🇰","djibouti":"🇩🇯","dominica":"🇩🇲","dominican_republic":"🇩🇴","ecuador":"🇪🇨","egypt":"🇪🇬","el_salvador":"🇸🇻","equatorial_guinea":"🇬🇶","eritrea":"🇪🇷","estonia":"🇪🇪","ethiopia":"🇪🇹","eu":"🇪🇺","european_union":"🇪🇺","falkland_islands":"🇫🇰","faroe_islands":"🇫🇴","fiji":"🇫🇯","finland":"🇫🇮","fr":"🇫🇷","french_guiana":"🇬🇫","french_polynesia":"🇵🇫","french_southern_territories":"🇹🇫","gabon":"🇬🇦","gambia":"🇬🇲","georgia":"🇬🇪","de":"🇩🇪","ghana":"🇬🇭","gibraltar":"🇬🇮","greece":"🇬🇷","greenland":"🇬🇱","grenada":"🇬🇩","guadeloupe":"🇬🇵","guam":"🇬🇺","guatemala":"🇬🇹","guernsey":"🇬🇬","guinea":"🇬🇳","guinea_bissau":"🇬🇼","guyana":"🇬🇾","haiti":"🇭🇹","honduras":"🇭🇳","hong_kong":"🇭🇰","hungary":"🇭🇺","iceland":"🇮🇸","india":"🇮🇳","indonesia":"🇮🇩","iran":"🇮🇷","iraq":"🇮🇶","ireland":"🇮🇪","isle_of_man":"🇮🇲","israel":"🇮🇱","it":"🇮🇹","jamaica":"🇯🇲","jp":"🇯🇵","crossed_flags":"🎌","jersey":"🇯🇪","jordan":"🇯🇴","kazakhstan":"🇰🇿","kenya":"🇰🇪","kiribati":"🇰🇮","kosovo":"🇽🇰","kuwait":"🇰🇼","kyrgyzstan":"🇰🇬","laos":"🇱🇦","latvia":"🇱🇻","lebanon":"🇱🇧","lesotho":"🇱🇸","liberia":"🇱🇷","libya":"🇱🇾","liechtenstein":"🇱🇮","lithuania":"🇱🇹","luxembourg":"🇱🇺","macau":"🇲🇴","macedonia":"🇲🇰","madagascar":"🇲🇬","malawi":"🇲🇼","malaysia":"🇲🇾","maldives":"🇲🇻","mali":"🇲🇱","malta":"🇲🇹","marshall_islands":"🇲🇭","martinique":"🇲🇶","mauritania":"🇲🇷","mauritius":"🇲🇺","mayotte":"🇾🇹","mexico":"🇲🇽","micronesia":"🇫🇲","moldova":"🇲🇩","monaco":"🇲🇨","mongolia":"🇲🇳","montenegro":"🇲🇪","montserrat":"🇲🇸","morocco":"🇲🇦","mozambique":"🇲🇿","myanmar":"🇲🇲","namibia":"🇳🇦","nauru":"🇳🇷","nepal":"🇳🇵","netherlands":"🇳🇱","new_caledonia":"🇳🇨","new_zealand":"🇳🇿","nicaragua":"🇳🇮","niger":"🇳🇪","nigeria":"🇳🇬","niue":"🇳🇺","norfolk_island":"🇳🇫","northern_mariana_islands":"🇲🇵","north_korea":"🇰🇵","norway":"🇳🇴","oman":"🇴🇲","pakistan":"🇵🇰","palau":"🇵🇼","palestinian_territories":"🇵🇸","panama":"🇵🇦","papua_new_guinea":"🇵🇬","paraguay":"🇵🇾","peru":"🇵🇪","philippines":"🇵🇭","pitcairn_islands":"🇵🇳","poland":"🇵🇱","portugal":"🇵🇹","puerto_rico":"🇵🇷","qatar":"🇶🇦","reunion":"🇷🇪","romania":"🇷🇴","ru":"🇷🇺","rwanda":"🇷🇼","st_barthelemy":"🇧🇱","st_helena":"🇸🇭","st_kitts_nevis":"🇰🇳","st_lucia":"🇱🇨","st_pierre_miquelon":"🇵🇲","st_vincent_grenadines":"🇻🇨","samoa":"🇼🇸","san_marino":"🇸🇲","sao_tome_principe":"🇸🇹","saudi_arabia":"🇸🇦","senegal":"🇸🇳","serbia":"🇷🇸","seychelles":"🇸🇨","sierra_leone":"🇸🇱","singapore":"🇸🇬","sint_maarten":"🇸🇽","slovakia":"🇸🇰","slovenia":"🇸🇮","solomon_islands":"🇸🇧","somalia":"🇸🇴","south_africa":"🇿🇦","south_georgia_south_sandwich_islands":"🇬🇸","kr":"🇰🇷","south_sudan":"🇸🇸","es":"🇪🇸","sri_lanka":"🇱🇰","sudan":"🇸🇩","suriname":"🇸🇷","swaziland":"🇸🇿","sweden":"🇸🇪","switzerland":"🇨🇭","syria":"🇸🇾","taiwan":"🇹🇼","tajikistan":"🇹🇯","tanzania":"🇹🇿","thailand":"🇹🇭","timor_leste":"🇹🇱","togo":"🇹🇬","tokelau":"🇹🇰","tonga":"🇹🇴","trinidad_tobago":"🇹🇹","tunisia":"🇹🇳","tr":"🇹🇷","turkmenistan":"🇹🇲","turks_caicos_islands":"🇹🇨","tuvalu":"🇹🇻","uganda":"🇺🇬","ukraine":"🇺🇦","united_arab_emirates":"🇦🇪","gb":"🇬🇧","uk":"🇬🇧","us":"🇺🇸","us_virgin_islands":"🇻🇮","uruguay":"🇺🇾","uzbekistan":"🇺🇿","vanuatu":"🇻🇺","vatican_city":"🇻🇦","venezuela":"🇻🇪","vietnam":"🇻🇳","wallis_futuna":"🇼🇫","western_sahara":"🇪🇭","yemen":"🇾🇪","zambia":"🇿🇲","zimbabwe":"🇿🇼"}

/***/ }),
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(168)
	
	/* template */
	var __vue_template__ = __webpack_require__(834)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(169)
	
	/* template */
	var __vue_template__ = __webpack_require__(854)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(171)
	
	/* template */
	var __vue_template__ = __webpack_require__(882)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(172)
	
	/* template */
	var __vue_template__ = __webpack_require__(852)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(173)
	
	/* template */
	var __vue_template__ = __webpack_require__(851)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(174)
	
	/* template */
	var __vue_template__ = __webpack_require__(830)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(177)
	
	/* template */
	var __vue_template__ = __webpack_require__(880)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(179)
	
	/* template */
	var __vue_template__ = __webpack_require__(866)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(182)
	
	/* template */
	var __vue_template__ = __webpack_require__(920)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(183)
	
	/* template */
	var __vue_template__ = __webpack_require__(841)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(184)
	
	/* template */
	var __vue_template__ = __webpack_require__(903)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(185)
	
	/* template */
	var __vue_template__ = __webpack_require__(878)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(186)
	
	/* template */
	var __vue_template__ = __webpack_require__(916)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(187)
	
	/* template */
	var __vue_template__ = __webpack_require__(876)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(188)
	
	/* template */
	var __vue_template__ = __webpack_require__(836)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(189)
	
	/* template */
	var __vue_template__ = __webpack_require__(923)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(190)
	
	/* template */
	var __vue_template__ = __webpack_require__(814)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(191)
	
	/* template */
	var __vue_template__ = __webpack_require__(907)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(193)
	
	/* template */
	var __vue_template__ = __webpack_require__(906)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(194)
	
	/* template */
	var __vue_template__ = __webpack_require__(816)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(195)
	
	/* template */
	var __vue_template__ = __webpack_require__(891)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(196)
	
	/* template */
	var __vue_template__ = __webpack_require__(885)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(197)
	
	/* template */
	var __vue_template__ = __webpack_require__(865)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(198)
	
	/* template */
	var __vue_template__ = __webpack_require__(890)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(199)
	
	/* template */
	var __vue_template__ = __webpack_require__(898)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(201)
	
	/* template */
	var __vue_template__ = __webpack_require__(821)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(204)
	
	/* template */
	var __vue_template__ = __webpack_require__(815)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(205)
	
	/* template */
	var __vue_template__ = __webpack_require__(844)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(206)
	
	/* template */
	var __vue_template__ = __webpack_require__(914)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(207)
	
	/* template */
	var __vue_template__ = __webpack_require__(911)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(380)
	
	/* script */
	__vue_exports__ = __webpack_require__(208)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	
	module.exports = __vue_exports__


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(209)
	
	/* template */
	var __vue_template__ = __webpack_require__(823)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(210)
	
	/* template */
	var __vue_template__ = __webpack_require__(850)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(211)
	
	/* template */
	var __vue_template__ = __webpack_require__(922)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(212)
	
	/* template */
	var __vue_template__ = __webpack_require__(897)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(213)
	
	/* template */
	var __vue_template__ = __webpack_require__(913)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(214)
	
	/* template */
	var __vue_template__ = __webpack_require__(870)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(215)
	
	/* template */
	var __vue_template__ = __webpack_require__(918)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(216)
	
	/* template */
	var __vue_template__ = __webpack_require__(909)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(217)
	
	/* template */
	var __vue_template__ = __webpack_require__(924)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(218)
	
	/* template */
	var __vue_template__ = __webpack_require__(896)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(219)
	
	/* template */
	var __vue_template__ = __webpack_require__(859)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(220)
	
	/* template */
	var __vue_template__ = __webpack_require__(927)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(221)
	
	/* template */
	var __vue_template__ = __webpack_require__(899)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(222)
	
	/* template */
	var __vue_template__ = __webpack_require__(915)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(223)
	
	/* template */
	var __vue_template__ = __webpack_require__(838)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(224)
	
	/* template */
	var __vue_template__ = __webpack_require__(887)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(225)
	
	/* template */
	var __vue_template__ = __webpack_require__(855)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(226)
	
	/* template */
	var __vue_template__ = __webpack_require__(840)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(227)
	
	/* template */
	var __vue_template__ = __webpack_require__(875)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(228)
	
	/* template */
	var __vue_template__ = __webpack_require__(921)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(229)
	
	/* template */
	var __vue_template__ = __webpack_require__(857)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(230)
	
	/* template */
	var __vue_template__ = __webpack_require__(912)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(231)
	
	/* template */
	var __vue_template__ = __webpack_require__(908)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(232)
	
	/* template */
	var __vue_template__ = __webpack_require__(860)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(233)
	
	/* template */
	var __vue_template__ = __webpack_require__(824)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(234)
	
	/* template */
	var __vue_template__ = __webpack_require__(845)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(235)
	
	/* template */
	var __vue_template__ = __webpack_require__(879)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(236)
	
	/* template */
	var __vue_template__ = __webpack_require__(831)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(237)
	
	/* template */
	var __vue_template__ = __webpack_require__(874)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(238)
	
	/* template */
	var __vue_template__ = __webpack_require__(843)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(239)
	
	/* template */
	var __vue_template__ = __webpack_require__(863)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(240)
	
	/* template */
	var __vue_template__ = __webpack_require__(853)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(241)
	
	/* template */
	var __vue_template__ = __webpack_require__(877)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(242)
	
	/* template */
	var __vue_template__ = __webpack_require__(902)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(243)
	
	/* template */
	var __vue_template__ = __webpack_require__(826)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(244)
	
	/* template */
	var __vue_template__ = __webpack_require__(869)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(245)
	
	/* template */
	var __vue_template__ = __webpack_require__(904)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(246)
	
	/* template */
	var __vue_template__ = __webpack_require__(888)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(247)
	
	/* template */
	var __vue_template__ = __webpack_require__(910)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(248)
	
	/* template */
	var __vue_template__ = __webpack_require__(886)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(249)
	
	/* template */
	var __vue_template__ = __webpack_require__(872)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(250)
	
	/* template */
	var __vue_template__ = __webpack_require__(819)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(251)
	
	/* template */
	var __vue_template__ = __webpack_require__(837)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(252)
	
	/* template */
	var __vue_template__ = __webpack_require__(832)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(253)
	
	/* template */
	var __vue_template__ = __webpack_require__(825)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(254)
	
	/* template */
	var __vue_template__ = __webpack_require__(901)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(255)
	
	/* template */
	var __vue_template__ = __webpack_require__(893)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(256)
	
	/* template */
	var __vue_template__ = __webpack_require__(881)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(257)
	
	/* template */
	var __vue_template__ = __webpack_require__(884)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(258)
	
	/* template */
	var __vue_template__ = __webpack_require__(858)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(259)
	
	/* template */
	var __vue_template__ = __webpack_require__(846)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(260)
	
	/* template */
	var __vue_template__ = __webpack_require__(862)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(261)
	
	/* template */
	var __vue_template__ = __webpack_require__(833)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(262)
	
	/* template */
	var __vue_template__ = __webpack_require__(889)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(263)
	
	/* template */
	var __vue_template__ = __webpack_require__(847)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(264)
	
	/* template */
	var __vue_template__ = __webpack_require__(856)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(265)
	
	/* template */
	var __vue_template__ = __webpack_require__(820)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(266)
	
	/* template */
	var __vue_template__ = __webpack_require__(849)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(267)
	
	/* template */
	var __vue_template__ = __webpack_require__(919)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(268)
	
	/* template */
	var __vue_template__ = __webpack_require__(917)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(269)
	
	/* template */
	var __vue_template__ = __webpack_require__(894)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(270)
	
	/* template */
	var __vue_template__ = __webpack_require__(867)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(271)
	
	/* template */
	var __vue_template__ = __webpack_require__(925)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(378)
	
	/* script */
	__vue_exports__ = __webpack_require__(272)
	
	/* template */
	var __vue_template__ = __webpack_require__(822)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-0d1e976e"
	
	module.exports = __vue_exports__


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(379)
	
	/* script */
	__vue_exports__ = __webpack_require__(273)
	
	/* template */
	var __vue_template__ = __webpack_require__(828)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-15689114"
	
	module.exports = __vue_exports__


/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(274)
	
	/* template */
	var __vue_template__ = __webpack_require__(839)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(275)
	
	/* template */
	var __vue_template__ = __webpack_require__(900)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(276)
	
	/* template */
	var __vue_template__ = __webpack_require__(817)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(277)
	
	/* template */
	var __vue_template__ = __webpack_require__(892)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(278)
	
	/* template */
	var __vue_template__ = __webpack_require__(842)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(279)
	
	/* template */
	var __vue_template__ = __webpack_require__(873)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(280)
	
	/* template */
	var __vue_template__ = __webpack_require__(926)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(281)
	
	/* template */
	var __vue_template__ = __webpack_require__(861)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(282)
	
	/* template */
	var __vue_template__ = __webpack_require__(864)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* script */
	__vue_exports__ = __webpack_require__(283)
	
	/* template */
	var __vue_template__ = __webpack_require__(818)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),
/* 814 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "loading small"
	  }, [_c('i', {
	    staticClass: "fas fa-sync fa-spin"
	  }), _vm._v(" "), _c('p', [_vm._v("Loading")])])
	}]}

/***/ }),
/* 815 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    attrs: {
	      "id": "media-piece"
	    }
	  }, [(_vm.showLoader) ? _c('loader-large') : _vm._e(), _vm._v(" "), (_vm.showPiece && _vm.piece) ? [(!_vm.canEdit && _vm.editMode) ? _c('div', {
	    staticClass: "validation-messages error"
	  }, [_c('h1', [_vm._v("You cannot edit this")])]) : [(_vm.editMode) ? _c('edit-form', {
	    attrs: {
	      "piece": _vm.piece
	    }
	  }) : _vm._e(), _vm._v(" "), (!_vm.editMode) ? _c('media-post', {
	    attrs: {
	      "piece": _vm.piece,
	      "medias-id": _vm.mediasId,
	      "can-edit": _vm.canEdit,
	      "classes": "centered"
	    }
	  }) : _vm._e()]] : _vm._e(), _vm._v(" "), (_vm.showPiece && !_vm.piece) ? _c('div', {
	    staticClass: "validation-messages friendly"
	  }, [_c('h1', [_vm._v("This piece doesn't exist")])]) : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 816 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "media-item-audio"
	  }, [(_vm.data.previewImageUrl) ? _c('div', {
	    staticClass: "image-wrapper"
	  }, [_c('a', {
	    attrs: {
	      "href": ("https://www.develteam.com/userdata/media/" + (_vm.data.mediaUrl)),
	      "target": "_blank"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": ("https://www.develteam.com/userdata/media/" + (_vm.data.previewImageUrl)),
	      "alt": _vm.data.title + ' preview image',
	      "title": _vm.data.title + ' preview image'
	    }
	  })])]) : _vm._e(), _vm._v(" "), _c('audio', {
	    attrs: {
	      "controls": ""
	    }
	  }, [_c('source', {
	    attrs: {
	      "src": ("https://www.develteam.com/userdata/media/" + (_vm.data.mediaUrl)),
	      "type": "audio/mpeg"
	    }
	  }), _vm._v("\n        Your browser does not support the video tag.\n    ")])])
	},staticRenderFns: []}

/***/ }),
/* 817 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    attrs: {
	      "id": "update-password"
	    }
	  }, [(!_vm.showConfirmation) ? _c('form', [_c('h2', [_vm._v("Update your Password")]), _vm._v(" "), (_vm.isLoading) ? _c('loader-large') : _vm._e(), _vm._v(" "), (_vm.isSaving) ? _c('saver-large') : _vm._e(), _vm._v(" "), (_vm.keycodeErrors.length > 0) ? _c('div', {
	    staticClass: "validation-messages error"
	  }, _vm._l((_vm.keycodeErrors), function(error) {
	    return _c('span', [_vm._v(_vm._s(error))])
	  })) : _vm._e(), _vm._v(" "), (_vm.formErrors.length > 0) ? _c('div', {
	    staticClass: "validation-messages error"
	  }, _vm._l((_vm.formErrors), function(error) {
	    return _c('span', [_vm._v(_vm._s(error))])
	  })) : _vm._e(), _vm._v(" "), (!_vm.isLoading && !_vm.isSaving && _vm.keycodeErrors.length === 0) ? [_c('h3', [_vm._v("For " + _vm._s(_vm.recoveryEmail))]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newPassword),
	      expression: "newPassword"
	    }],
	    attrs: {
	      "type": "password",
	      "placeholder": "Password"
	    },
	    domProps: {
	      "value": (_vm.newPassword)
	    },
	    on: {
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newPassword = $event.target.value
	      }, function($event) {
	        _vm.formErrors = []
	      }]
	    }
	  }), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newPasswordVerify),
	      expression: "newPasswordVerify"
	    }],
	    attrs: {
	      "type": "password",
	      "placeholder": "Verify Password"
	    },
	    domProps: {
	      "value": (_vm.newPasswordVerify)
	    },
	    on: {
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newPasswordVerify = $event.target.value
	      }, function($event) {
	        _vm.formErrors = []
	      }]
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "button-container"
	  }, [_c('button', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.submitUpdatedPassword($event)
	      }
	    }
	  }, [_vm._v("Update Password")])])] : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.showConfirmation) ? _c('div', {
	    staticClass: "confirmation"
	  }, [_c('h2', [_vm._v("Your password has been updated!")]), _vm._v(" "), _c('span', [_c('router-link', {
	    attrs: {
	      "to": "/Login"
	    }
	  }, [_vm._v("Log In")])], 1)]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 818 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('article', {
	    attrs: {
	      "id": "the-board-page"
	    }
	  }, [_c('h1', [_vm._v("The Board")]), _vm._v(" "), _c('div', {
	    staticClass: "sort-mode-selector"
	  }, [_c('label', {
	    staticClass: "switch"
	  }, [_c('button', {
	    class: [{
	      active: 0 === _vm.sortModeIndex
	    }],
	    on: {
	      "click": function($event) {
	        _vm.sortModeIndex = 0
	      }
	    }
	  }, [_vm._v("Activity")]), _vm._v(" "), _c('button', {
	    class: [{
	      active: 1 === _vm.sortModeIndex
	    }],
	    on: {
	      "click": function($event) {
	        _vm.sortModeIndex = 1
	      }
	    }
	  }, [_vm._v("New")]), _vm._v(" "), _c('button', {
	    class: [{
	      active: 2 === _vm.sortModeIndex
	    }],
	    on: {
	      "click": function($event) {
	        _vm.sortModeIndex = 2
	      }
	    }
	  }, [_vm._v("Top")])])]), _vm._v(" "), _vm._l((_vm.posts), function(post) {
	    return _c('div', {
	      staticClass: "content-box board-post"
	    }, [_c('section', {
	      staticClass: "votes"
	    }), _vm._v(" "), _c('header', [_c('section', {
	      staticClass: "post-info"
	    }, [_vm._v("Posted by\n                "), _c('router-link', {
	      attrs: {
	        "to": ("/Developer/" + (post.authorStringUrl))
	      }
	    }, [_c('i', {
	      staticClass: "fas fa-user"
	    }), _vm._v(" " + _vm._s(post.authorAlias))]), _vm._v("\n                on " + _vm._s(post.created) + ". Last activity at " + _vm._s(post.updated) + "\n            ")], 1), _vm._v(" "), _c('section', {
	      staticClass: "title"
	    }, [_vm._v(_vm._s(post.title))]), _vm._v(" "), _c('footer', [_c('i', {
	      staticClass: "far fa-comment-alt"
	    }), _vm._v(" " + _vm._s(post.commentCount) + " Comments")])])])
	  })], 2)
	},staticRenderFns: []}

/***/ }),
/* 819 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "member-edit-form"
	  }, [(!_vm.isSaving && !_vm.removeMode) ? [_c('div', {
	    staticClass: "avatar-container"
	  }, [_c('avatar', {
	    attrs: {
	      "profile-data": _vm.member,
	      "profile-type": "developer",
	      "size": "large",
	      "show-xp-info": true
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "member-actions"
	  }, [_c('span', {
	    staticClass: "alias"
	  }, [_vm._v(_vm._s(_vm.member.alias))]), _vm._v(" "), (_vm.member.modLevel !== 'owner') ? _c('label', {
	    staticClass: "is-moderator"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.member.isModerator),
	      expression: "member.isModerator"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.member.isModerator) ? _vm._i(_vm.member.isModerator, null) > -1 : (_vm.member.isModerator)
	    },
	    on: {
	      "change": function($event) {
	        _vm.saveButtonEnabled = true
	      },
	      "__c": function($event) {
	        var $$a = _vm.member.isModerator,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.member.isModerator = $$a.concat($$v))
	          } else {
	            $$i > -1 && (_vm.member.isModerator = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.member.isModerator = $$c
	        }
	      }
	    }
	  }), _vm._v(" Is a Moderator\n            ")]) : _vm._e(), _vm._v(" "), _c('button', {
	    staticClass: "button save",
	    attrs: {
	      "disabled": !_vm.saveButtonEnabled
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.saveMember($event)
	      }
	    }
	  }, [_vm._v("Save Member Info")]), _vm._v(" "), (_vm.member.id !== _vm.myId) ? _c('button', {
	    staticClass: "button remove",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.removeMode = true
	      }
	    }
	  }, [_vm._v("Remove from Game")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "member-positions"
	  }, _vm._l((_vm.positions), function(position) {
	    return _c('div', {
	      staticClass: "position"
	    }, [_c('label', [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.member.positions[position].checked),
	        expression: "member.positions[position].checked"
	      }],
	      attrs: {
	        "type": "checkbox"
	      },
	      domProps: {
	        "checked": Array.isArray(_vm.member.positions[position].checked) ? _vm._i(_vm.member.positions[position].checked, null) > -1 : (_vm.member.positions[position].checked)
	      },
	      on: {
	        "change": function($event) {
	          _vm.saveButtonEnabled = true
	        },
	        "__c": function($event) {
	          var $$a = _vm.member.positions[position].checked,
	            $$el = $event.target,
	            $$c = $$el.checked ? (true) : (false);
	          if (Array.isArray($$a)) {
	            var $$v = null,
	              $$i = _vm._i($$a, $$v);
	            if ($$el.checked) {
	              $$i < 0 && (_vm.member.positions[position].checked = $$a.concat($$v))
	            } else {
	              $$i > -1 && (_vm.member.positions[position].checked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	            }
	          } else {
	            _vm.member.positions[position].checked = $$c
	          }
	        }
	      }
	    }), _vm._v(" " + _vm._s(position))]), _vm._v(" "), _c('label', [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.member.positions[position].positionTitle),
	        expression: "member.positions[position].positionTitle"
	      }],
	      attrs: {
	        "type": "text",
	        "placeholder": "Role Title"
	      },
	      domProps: {
	        "value": (_vm.member.positions[position].positionTitle)
	      },
	      on: {
	        "input": [function($event) {
	          if ($event.target.composing) { return; }
	          _vm.member.positions[position].positionTitle = $event.target.value
	        }, function($event) {
	          _vm.saveButtonEnabled = true
	        }]
	      }
	    })])])
	  }))] : _vm._e(), _vm._v(" "), (!_vm.isSaving && _vm.removeMode) ? [_c('section', {
	    staticClass: "remove-user"
	  }, [_c('h1', [_vm._v("Remove " + _vm._s(_vm.member.alias) + " from this game project?")]), _vm._v(" "), _c('button', {
	    staticClass: "button minor",
	    on: {
	      "click": function($event) {
	        _vm.removeMode = false
	      }
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
	    staticClass: "button",
	    on: {
	      "click": _vm.removeMember
	    }
	  }, [_vm._v("Yes, Remove This User")])])] : _vm._e(), _vm._v(" "), (_vm.isSaving) ? _c('saver-large') : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 820 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('article', {
	    attrs: {
	      "id": "invite-to-game"
	    }
	  }, [_c('form', [(_vm.fetchingMember) ? _c('loader-large') : _vm._e(), _vm._v(" "), (_vm.showSuccessMessage) ? [_c('div', {
	    staticClass: "validation-messages friendly success-message"
	  }, [_vm._v("Invitation Successfully Sent to\n                "), _c('router-link', {
	    attrs: {
	      "to": ("/Developer/" + (_vm.foundMember.stringUrl))
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-user"
	  }), _vm._v(" " + _vm._s(_vm.foundMember.alias))])], 1)] : _vm._e(), _vm._v(" "), (!_vm.fetchingMember && !_vm.showSuccessMessage) ? [(_vm.memberFound && _vm.isLoggedIn) ? _c('div', [_c('h2', [_vm._v("\n                    Invite\n                    "), _c('router-link', {
	    attrs: {
	      "to": ("/Developer/" + (_vm.foundMember.stringUrl))
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-user"
	  }), _vm._v(" " + _vm._s(_vm.foundMember.alias))]), _vm._v("\n                    to a Game\n                ")], 1), _vm._v(" "), _c('div', {
	    staticClass: "field"
	  }, [_c('label', {
	    attrs: {
	      "for": "selected-game"
	    }
	  }, [_vm._v("Invite to Join")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formData.selectedGame),
	      expression: "formData.selectedGame"
	    }],
	    attrs: {
	      "id": "selected-game",
	      "disabled": _vm.isSaving
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.formData.selectedGame = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm.GamesOwned), function(game) {
	    return _c('option', {
	      domProps: {
	        "value": game.id
	      }
	    }, [_vm._v(_vm._s(game.alias))])
	  }))]), _vm._v(" "), _c('div', {
	    staticClass: "field"
	  }, [_c('label', {
	    attrs: {
	      "for": "position-titles"
	    }
	  }, [_vm._v("Position Title(s)")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formData.positionTitles),
	      expression: "formData.positionTitles"
	    }],
	    attrs: {
	      "id": "position-titles",
	      "type": "text",
	      "disabled": _vm.isSaving
	    },
	    domProps: {
	      "value": (_vm.formData.positionTitles)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.formData.positionTitles = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "field"
	  }, [_c('span', [_vm._v("Position Types")]), _vm._v(" "), _c('div', {
	    staticClass: "checkbox-container"
	  }, [_c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formData.selectedPositions),
	      expression: "formData.selectedPositions"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "value": "Designer",
	      "disabled": _vm.isSaving
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.formData.selectedPositions) ? _vm._i(_vm.formData.selectedPositions, "Designer") > -1 : (_vm.formData.selectedPositions)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.formData.selectedPositions,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = "Designer",
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.formData.selectedPositions = $$a.concat($$v))
	          } else {
	            $$i > -1 && (_vm.formData.selectedPositions = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.formData.selectedPositions = $$c
	        }
	      }
	    }
	  }), _c('span', [_vm._v("Designer")])]), _vm._v(" "), _c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formData.selectedPositions),
	      expression: "formData.selectedPositions"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "value": "Artist",
	      "disabled": _vm.isSaving
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.formData.selectedPositions) ? _vm._i(_vm.formData.selectedPositions, "Artist") > -1 : (_vm.formData.selectedPositions)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.formData.selectedPositions,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = "Artist",
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.formData.selectedPositions = $$a.concat($$v))
	          } else {
	            $$i > -1 && (_vm.formData.selectedPositions = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.formData.selectedPositions = $$c
	        }
	      }
	    }
	  }), _c('span', [_vm._v("Artist")])]), _vm._v(" "), _c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formData.selectedPositions),
	      expression: "formData.selectedPositions"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "value": "Programmer",
	      "disabled": _vm.isSaving
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.formData.selectedPositions) ? _vm._i(_vm.formData.selectedPositions, "Programmer") > -1 : (_vm.formData.selectedPositions)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.formData.selectedPositions,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = "Programmer",
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.formData.selectedPositions = $$a.concat($$v))
	          } else {
	            $$i > -1 && (_vm.formData.selectedPositions = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.formData.selectedPositions = $$c
	        }
	      }
	    }
	  }), _c('span', [_vm._v("Programmer")])]), _vm._v(" "), _c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formData.selectedPositions),
	      expression: "formData.selectedPositions"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "value": "Musician",
	      "disabled": _vm.isSaving
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.formData.selectedPositions) ? _vm._i(_vm.formData.selectedPositions, "Musician") > -1 : (_vm.formData.selectedPositions)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.formData.selectedPositions,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = "Musician",
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.formData.selectedPositions = $$a.concat($$v))
	          } else {
	            $$i > -1 && (_vm.formData.selectedPositions = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.formData.selectedPositions = $$c
	        }
	      }
	    }
	  }), _c('span', [_vm._v("Musician")])]), _vm._v(" "), _c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formData.selectedPositions),
	      expression: "formData.selectedPositions"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "value": "SFX Artist",
	      "disabled": _vm.isSaving
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.formData.selectedPositions) ? _vm._i(_vm.formData.selectedPositions, "SFX Artist") > -1 : (_vm.formData.selectedPositions)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.formData.selectedPositions,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = "SFX Artist",
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.formData.selectedPositions = $$a.concat($$v))
	          } else {
	            $$i > -1 && (_vm.formData.selectedPositions = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.formData.selectedPositions = $$c
	        }
	      }
	    }
	  }), _c('span', [_vm._v("SFX Artist")])]), _vm._v(" "), _c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formData.selectedPositions),
	      expression: "formData.selectedPositions"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "value": "Writer",
	      "disabled": _vm.isSaving
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.formData.selectedPositions) ? _vm._i(_vm.formData.selectedPositions, "Writer") > -1 : (_vm.formData.selectedPositions)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.formData.selectedPositions,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = "Writer",
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.formData.selectedPositions = $$a.concat($$v))
	          } else {
	            $$i > -1 && (_vm.formData.selectedPositions = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.formData.selectedPositions = $$c
	        }
	      }
	    }
	  }), _c('span', [_vm._v("Writer")])]), _vm._v(" "), _c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formData.selectedPositions),
	      expression: "formData.selectedPositions"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "value": "Producer",
	      "disabled": _vm.isSaving
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.formData.selectedPositions) ? _vm._i(_vm.formData.selectedPositions, "Producer") > -1 : (_vm.formData.selectedPositions)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.formData.selectedPositions,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = "Producer",
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.formData.selectedPositions = $$a.concat($$v))
	          } else {
	            $$i > -1 && (_vm.formData.selectedPositions = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.formData.selectedPositions = $$c
	        }
	      }
	    }
	  }), _c('span', [_vm._v("Producer")])]), _vm._v(" "), _c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formData.selectedPositions),
	      expression: "formData.selectedPositions"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "value": "Tester",
	      "disabled": _vm.isSaving
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.formData.selectedPositions) ? _vm._i(_vm.formData.selectedPositions, "Tester") > -1 : (_vm.formData.selectedPositions)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.formData.selectedPositions,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = "Tester",
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.formData.selectedPositions = $$a.concat($$v))
	          } else {
	            $$i > -1 && (_vm.formData.selectedPositions = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.formData.selectedPositions = $$c
	        }
	      }
	    }
	  }), _c('span', [_vm._v("Tester")])])])]), _vm._v(" "), (_vm.formErrors.length > 0) ? _c('div', {
	    staticClass: "validation-messages error"
	  }, _vm._l((_vm.formErrors), function(error) {
	    return _c('span', [_vm._v(_vm._s(error))])
	  })) : _vm._e(), _vm._v(" "), (_vm.isSaving) ? _c('saver-large') : _vm._e(), _vm._v(" "), (!_vm.isSaving) ? _c('div', {
	    staticClass: "button-container"
	  }, [_c('button', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.submitInvitation($event)
	      }
	    }
	  }, [_vm._v("Send Invitation")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.memberFound || !_vm.isLoggedIn) ? _c('div', [_c('h2', [_vm._v("Error")]), _vm._v(" "), (!_vm.memberFound && _vm.isLoggedIn) ? _c('span', [_vm._v("Invited member was not found")]) : _vm._e(), _vm._v(" "), (!_vm.isLoggedIn) ? _c('span', [_vm._v("You must be logged in to do this")]) : _vm._e()]) : _vm._e()] : _vm._e()], 2)])
	},staticRenderFns: []}

/***/ }),
/* 821 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    attrs: {
	      "id": "media-add-piece"
	    }
	  }, [_c('h2', [_vm._v("Add a Piece")]), _vm._v(" "), (!_vm.savingForm) ? _c('form', [_c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.title),
	      expression: "title"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "Piece Title"
	    },
	    domProps: {
	      "value": (_vm.title)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.title = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('fieldset', _vm._l((_vm.mediaTypes), function(mediaType) {
	    return _c('label', [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (_vm.selectedMediaType),
	        expression: "selectedMediaType"
	      }],
	      attrs: {
	        "type": "radio",
	        "name": "mediaType"
	      },
	      domProps: {
	        "value": mediaType.id,
	        "checked": _vm._q(_vm.selectedMediaType, mediaType.id)
	      },
	      on: {
	        "__c": function($event) {
	          _vm.selectedMediaType = mediaType.id
	        }
	      }
	    }), _vm._v(" " + _vm._s(mediaType.name))])
	  })), _vm._v(" "), _c('label', [_c('markdown-editor', {
	    attrs: {
	      "placeholder": "Description (Optional)"
	    },
	    model: {
	      value: (_vm.description),
	      callback: function($$v) {
	        _vm.description = $$v
	      },
	      expression: "description"
	    }
	  })], 1), _vm._v(" "), _c('fieldset', [_c('label', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.selectedMediaData.usesUploadFile),
	      expression: "selectedMediaData.usesUploadFile"
	    }]
	  }, [_vm._v("\n                Media (" + _vm._s(_vm.selectedMediaData.name) + ")\n                "), _c('input', {
	    attrs: {
	      "type": "file",
	      "id": "mediaPieceFile",
	      "name": "mediaPieceFile",
	      "accept": _vm.selectedMediaData.acceptedTypes.join(',')
	    },
	    on: {
	      "change": _vm.setMediaFile
	    }
	  }), _vm._v(" "), _c('span', [_vm._v("Accepted File Types: " + _vm._s(_vm.selectedMediaData.acceptedTypes.join(', ')))])]), _vm._v(" "), _c('label', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.selectedMediaData.usesExternalUrl),
	      expression: "selectedMediaData.usesExternalUrl"
	    }]
	  }, [_vm._v("\n                Media (External Url) "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.mediaText),
	      expression: "mediaText"
	    }],
	    attrs: {
	      "type": "text",
	      "name": "mediaPieceText",
	      "placeholder": "http://..."
	    },
	    domProps: {
	      "value": (_vm.mediaText)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.mediaText = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('label', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.selectedMediaData.usesYoutubeLink),
	      expression: "selectedMediaData.usesYoutubeLink"
	    }]
	  }, [_vm._v("\n                Youtube Link "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.mediaText),
	      expression: "mediaText"
	    }],
	    attrs: {
	      "type": "text",
	      "name": "mediaPieceText",
	      "placeholder": "http://..."
	    },
	    domProps: {
	      "value": (_vm.mediaText)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.mediaText = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('label', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.selectedMediaData.usesPreviewImage),
	      expression: "selectedMediaData.usesPreviewImage"
	    }]
	  }, [_vm._v("\n                Preview Image (optional)\n                "), _c('input', {
	    attrs: {
	      "type": "file",
	      "id": "previewFile",
	      "name": "previewFile",
	      "accept": ".jpg,.jpeg,.gif,.png"
	    },
	    on: {
	      "change": _vm.setPreviewFile
	    }
	  }), _vm._v(" "), _c('span', [_vm._v("Accepted File Types: .jpg, .jpeg, .png, .gif")])])]), _vm._v(" "), _c('fieldset', [_c('button', {
	    staticClass: "button minor",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.cancelPiece($event)
	      }
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.submitNewPiece($event)
	      }
	    }
	  }, [_vm._v("Submit")])]), _vm._v(" "), (_vm.formErrors.length > 0) ? _c('fieldset', [_c('ul', {
	    staticClass: "validation-messages error"
	  }, _vm._l((_vm.formErrors), function(formError) {
	    return _c('li', [_vm._v(_vm._s(formError))])
	  }))]) : _vm._e()]) : _c('saver-large')], 1)
	},staticRenderFns: []}

/***/ }),
/* 822 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('article', {
	    attrs: {
	      "id": "privacy-policy"
	    }
	  }, [_c('h1', [_vm._v("Privacy Policy for Develteam")]), _vm._v(" "), _c('p', [_vm._v("At Develteam, accessible from https://www.develteam.com, one of our main priorities is the privacy of our\n        visitors. This Privacy Policy document contains types of information that is collected and recorded by\n        Develteam and how we use it.")]), _vm._v(" "), _c('p', [_vm._v("If you have additional questions or require more information about our Privacy Policy, do not hesitate to\n        contact us.")]), _vm._v(" "), _c('p', [_vm._v("This Privacy Policy applies only to our online activities and is valid for visitors to our website with\n        regards to the information that they shared and/or collect in Develteam. This policy is not applicable to\n        any information collected offline or via channels other than this website.")]), _vm._v(" "), _c('h2', [_vm._v("Consent")]), _vm._v(" "), _c('p', [_vm._v("By using our website, you hereby consent to our Privacy Policy and agree to its terms.")]), _vm._v(" "), _c('h2', [_vm._v("Information we collect")]), _vm._v(" "), _c('p', [_vm._v("The personal information that you are asked to provide, and the reasons why you are asked to provide it, will\n        be made clear to you at the point we ask you to provide your personal information.")]), _vm._v(" "), _c('p', [_vm._v("If you contact us directly, we may receive additional information about you such as your name, email address,\n        phone number, the contents of the message and/or attachments you may send us, and any other information you\n        may choose to provide.")]), _vm._v(" "), _c('p', [_vm._v("When you register for an Account, we may ask for your contact information, including items such as name,\n        company name, address, email address, and telephone number.")]), _vm._v(" "), _c('h2', [_vm._v("How we use your information")]), _vm._v(" "), _c('p', [_vm._v("We use the information we collect in various ways, including to:")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h2', [_vm._v("Log Files")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('h2', [_vm._v("Cookies and Web Beacons")]), _vm._v(" "), _c('p', [_vm._v("Like any other website, Develteam uses 'cookies'. These cookies are used to store information including\n        visitors' preferences, and the pages on the website that the visitor accessed or visited. The information is\n        used to optimize the users' experience by customizing our web page content based on visitors' browser type\n        and/or other information.")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('h2', [_vm._v("Google DoubleClick DART Cookie")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('h2', [_vm._v("Advertising Partners Privacy Policies")]), _vm._v(" "), _c('P', [_vm._v("You may consult this list to find the Privacy Policy for each of the advertising partners of Develteam.")]), _vm._v(" "), _c('p', [_vm._v("Third-party ad servers or ad networks uses technologies like cookies, JavaScript, or Web Beacons that are\n        used in their respective advertisements and links that appear on Develteam, which are sent directly to\n        users' browser. They automatically receive your IP address when this occurs. These technologies are used to\n        measure the effectiveness of their advertising campaigns and/or to personalize the advertising content that\n        you see on websites that you visit.")]), _vm._v(" "), _c('p', [_vm._v("Note that Develteam has no access to or control over these cookies that are used by third-party\n        advertisers.")]), _vm._v(" "), _c('h2', [_vm._v("Third Party Privacy Policies")]), _vm._v(" "), _c('p', [_vm._v("Develteam's Privacy Policy does not apply to other advertisers or websites. Thus, we are advising you to\n        consult the respective Privacy Policies of these third-party ad servers for more detailed information. It\n        may include their practices and instructions about how to opt-out of certain options. ")]), _vm._v(" "), _c('p', [_vm._v("You can choose to disable cookies through your individual browser options. To know more detailed information\n        about cookie management with specific web browsers, it can be found at the browsers' respective\n        websites.")]), _vm._v(" "), _c('h2', [_vm._v("CCPA Privacy Rights (Do Not Sell My Personal Information)")]), _vm._v(" "), _c('p', [_vm._v("Under the CCPA, among other rights, California consumers have the right to:")]), _vm._v(" "), _c('p', [_vm._v("Request that a business that collects a consumer's personal data disclose the categories and specific pieces\n        of personal data that a business has collected about consumers.")]), _vm._v(" "), _c('p', [_vm._v("Request that a business delete any personal data about the consumer that a business has collected.")]), _vm._v(" "), _c('p', [_vm._v("Request that a business that sells a consumer's personal data, not sell the consumer's personal data.")]), _vm._v(" "), _c('p', [_vm._v("If you make a request, we have one month to respond to you. If you would like to exercise any of these\n        rights, please contact us.")]), _vm._v(" "), _c('h2', [_vm._v("GDPR Data Protection Rights")]), _vm._v(" "), _c('p', [_vm._v("We would like to make sure you are fully aware of all of your data protection rights. Every user is entitled\n        to the following:")]), _vm._v(" "), _c('p', [_vm._v("The right to access – You have the right to request copies of your personal data. We may charge you a small\n        fee for this service.")]), _vm._v(" "), _c('p', [_vm._v("The right to rectification – You have the right to request that we correct any information you believe is\n        inaccurate. You also have the right to request that we complete the information you believe is\n        incomplete.")]), _vm._v(" "), _c('p', [_vm._v("The right to erasure – You have the right to request that we erase your personal data, under certain\n        conditions.")]), _vm._v(" "), _c('p', [_vm._v("The right to restrict processing – You have the right to request that we restrict the processing of your\n        personal data, under certain conditions.")]), _vm._v(" "), _c('p', [_vm._v("The right to object to processing – You have the right to object to our processing of your personal data,\n        under certain conditions.")]), _vm._v(" "), _c('p', [_vm._v("The right to data portability – You have the right to request that we transfer the data that we have\n        collected to another organization, or directly to you, under certain conditions.")]), _vm._v(" "), _c('p', [_vm._v("If you make a request, we have one month to respond to you. If you would like to exercise any of these\n        rights, please contact us.")]), _vm._v(" "), _c('h2', [_vm._v("Children's Information")]), _vm._v(" "), _c('p', [_vm._v("Another part of our priority is adding protection for children while using the internet. We encourage parents\n        and guardians to observe, participate in, and/or monitor and guide their online activity.")]), _vm._v(" "), _c('p', [_vm._v("Develteam does not knowingly collect any Personal Identifiable Information from children under the age of 13.\n        If you think that your child provided this kind of information on our website, we strongly encourage you to\n        contact us immediately and we will do our best efforts to promptly remove such information from our\n        records.")])], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('ul', [_c('li', [_vm._v("Provide, operate, and maintain our webste")]), _vm._v(" "), _c('li', [_vm._v("Improve, personalize, and expand our webste")]), _vm._v(" "), _c('li', [_vm._v("Understand and analyze how you use our webste")]), _vm._v(" "), _c('li', [_vm._v("Develop new products, services, features, and functionality")]), _vm._v(" "), _c('li', [_vm._v("Communicate with you, either directly or through one of our partners, including for customer service, to\n            provide you with updates and other information relating to the webste, and for marketing and promotional\n            purposes\n        ")]), _vm._v(" "), _c('li', [_vm._v("Send you emails")]), _vm._v(" "), _c('li', [_vm._v("Find and prevent fraud")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_vm._v("Develteam follows a standard procedure of using log files. These files log visitors when they visit websites.\n        All hosting companies do this and a part of hosting services' analytics. The information collected by log\n        files include internet protocol (IP) addresses, browser type, Internet Service Provider (ISP), date and time\n        stamp, referring/exit pages, and possibly the number of clicks. These are not linked to any information that\n        is personally identifiable. The purpose of the information is for analyzing trends, administering the site,\n        tracking users' movement on the website, and gathering demographic information. Our Privacy Policy was\n        created with the help of the "), _c('a', {
	    attrs: {
	      "href": "https://www.privacypolicygenerator.info"
	    }
	  }, [_vm._v("Privacy Policy Generator")]), _vm._v("\n        and the "), _c('a', {
	    attrs: {
	      "href": "https://www.disclaimergenerator.org/"
	    }
	  }, [_vm._v("Disclaimer Generator")]), _vm._v(".")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_vm._v("For more general information on cookies, please read "), _c('a', {
	    attrs: {
	      "href": "https://www.cookieconsent.com/what-are-cookies/"
	    }
	  }, [_vm._v("\"What Are Cookies\"")]), _vm._v(".")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_vm._v("Google is one of a third-party vendor on our site. It also uses cookies, known as DART cookies, to serve ads\n        to our site visitors based upon their visit to www.website.com and other sites on the internet. However,\n        visitors may choose to decline the use of DART cookies by visiting the Google ad and content network Privacy\n        Policy at the following URL – "), _c('a', {
	    attrs: {
	      "href": "https://policies.google.com/technologies/ads"
	    }
	  }, [_vm._v("https://policies.google.com/technologies/ads")])])
	}]}

/***/ }),
/* 823 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('router-view'), _vm._v(" "), _c('modal')], 1)
	},staticRenderFns: []}

/***/ }),
/* 824 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    attrs: {
	      "id": "edit-developer-basic-info"
	    }
	  }, [_c('div', {
	    staticClass: "basic-info edit-container"
	  }, [(_vm.formData.delete !== 'DELETE') ? [_c('h1', [_vm._v("Account Settings")]), _vm._v(" "), _c('div', {
	    staticClass: "set"
	  }, [_c('label', [_vm._v("Username")]), _vm._v(" "), _c('div', {
	    staticClass: "container"
	  }, [_c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formData.alias),
	      expression: "formData.alias"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "Username",
	      "disabled": _vm.isSaving
	    },
	    domProps: {
	      "value": (_vm.formData.alias)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.formData.alias = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), _c('label', [_vm._v("Email Address")]), _vm._v(" "), _c('div', {
	    staticClass: "container"
	  }, [_c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formData.email),
	      expression: "formData.email"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "Email Address",
	      "disabled": _vm.isSaving
	    },
	    domProps: {
	      "value": (_vm.formData.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.formData.email = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), (_vm.showEmailError) ? _c('div', {
	    staticClass: "validation-messages friendly"
	  }, [_vm._v("\n                    Not a valid Email Address\n                ")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "set"
	  }, [_c('label', [_vm._v("Emails")]), _vm._v(" "), _c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formData.receiveEmailNotifications),
	      expression: "formData.receiveEmailNotifications"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "disabled": _vm.isSaving
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.formData.receiveEmailNotifications) ? _vm._i(_vm.formData.receiveEmailNotifications, null) > -1 : (_vm.formData.receiveEmailNotifications)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.formData.receiveEmailNotifications,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.formData.receiveEmailNotifications = $$a.concat($$v))
	          } else {
	            $$i > -1 && (_vm.formData.receiveEmailNotifications = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.formData.receiveEmailNotifications = $$c
	        }
	      }
	    }
	  }), _vm._v("Receive Email Notifications")]), _vm._v(" "), _c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formData.receivePromoEmails),
	      expression: "formData.receivePromoEmails"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "disabled": _vm.isSaving
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.formData.receivePromoEmails) ? _vm._i(_vm.formData.receivePromoEmails, null) > -1 : (_vm.formData.receivePromoEmails)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.formData.receivePromoEmails,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.formData.receivePromoEmails = $$a.concat($$v))
	          } else {
	            $$i > -1 && (_vm.formData.receivePromoEmails = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.formData.receivePromoEmails = $$c
	        }
	      }
	    }
	  }), _vm._v("Receive Official Emails")])]), _vm._v(" "), _c('div', {
	    staticClass: "set"
	  }, [_c('label', [_vm._v("Change Password\n                    "), (!_vm.passwordsShown) ? _c('a', {
	    on: {
	      "click": function($event) {
	        _vm.passwordsShown = true
	      }
	    }
	  }, [_vm._v("Show")]) : _vm._e(), _vm._v(" "), (_vm.passwordsShown) ? _c('a', {
	    on: {
	      "click": function($event) {
	        _vm.passwordsShown = false
	      }
	    }
	  }, [_vm._v("Hide")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "container"
	  }, [_c('div', [(!_vm.passwordsShown) ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formData.password),
	      expression: "formData.password"
	    }],
	    attrs: {
	      "type": "password",
	      "placeholder": "New Password",
	      "disabled": _vm.isSaving,
	      "autocomplete": "new-password"
	    },
	    domProps: {
	      "value": (_vm.formData.password)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.formData.password = $event.target.value
	      }
	    }
	  }) : _vm._e()]), _vm._v(" "), _c('div', [(_vm.passwordsShown) ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formData.password),
	      expression: "formData.password"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "New Password",
	      "disabled": _vm.isSaving,
	      "autocomplete": "new-password"
	    },
	    domProps: {
	      "value": (_vm.formData.password)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.formData.password = $event.target.value
	      }
	    }
	  }) : _vm._e()]), _vm._v(" "), _c('div', [(!_vm.passwordsShown) ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formData.passwordAgain),
	      expression: "formData.passwordAgain"
	    }],
	    attrs: {
	      "type": "password",
	      "placeholder": "New Password Again",
	      "disabled": _vm.isSaving,
	      "autocomplete": "new-password"
	    },
	    domProps: {
	      "value": (_vm.formData.passwordAgain)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.formData.passwordAgain = $event.target.value
	      }
	    }
	  }) : _vm._e()]), _vm._v(" "), _c('div', [(_vm.passwordsShown) ? _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formData.passwordAgain),
	      expression: "formData.passwordAgain"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "New Password Again",
	      "disabled": _vm.isSaving,
	      "autocomplete": "new-password"
	    },
	    domProps: {
	      "value": (_vm.formData.passwordAgain)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.formData.passwordAgain = $event.target.value
	      }
	    }
	  }) : _vm._e()])])]), _vm._v(" "), (_vm.formData.password.length > 0 && _vm.formData.password !== _vm.formData.passwordAgain) ? _c('div', {
	    staticClass: "validation-messages friendly"
	  }, [_vm._v("\n                Passwords do not match\n            ")]) : _vm._e()] : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "set"
	  }, [_c('label', [_vm._v("Delete Account")]), _vm._v(" "), _c('div', {
	    staticClass: "container"
	  }, [_c('div', [_vm._v("Type DELETE and press Save")]), _vm._v(" "), _c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formData.delete),
	      expression: "formData.delete"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "delete?",
	      "disabled": _vm.isSaving
	    },
	    domProps: {
	      "value": (_vm.formData.delete)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.formData.delete = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), (_vm.formData.delete === 'DELETE') ? _c('div', {
	    staticClass: "validation-messages friendly",
	    attrs: {
	      "disabled": _vm.isSaving
	    }
	  }, [_vm._v("\n                If you press SAVE, your account will be deleted. This cannot be undone.\n            ")]) : _vm._e(), _vm._v(" "), (_vm.responseErrors.length > 0) ? _c('div', {
	    staticClass: "validation-messages error"
	  }, _vm._l((_vm.responseErrors), function(error) {
	    return _c('span', [_vm._v(_vm._s(error))])
	  })) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "buttons"
	  }, [_c('button', {
	    staticClass: "button minor",
	    attrs: {
	      "disabled": _vm.isSaving
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.cancelChanges($event)
	      }
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
	    staticClass: "button",
	    attrs: {
	      "disabled": _vm.isSaving
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.submitChanges($event)
	      }
	    }
	  }, [_vm._v("Save")])])], 2)])
	},staticRenderFns: []}

/***/ }),
/* 825 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "edit-container",
	    attrs: {
	      "id": "edit-game-vitals"
	    }
	  }, [(_vm.isSaving) ? _c('div', {
	    staticClass: "companion-content-subsection"
	  }, [_c('saver-large')], 1) : _vm._e(), _vm._v(" "), (!_vm.isSaving) ? _c('div', {
	    staticClass: "companion-content-subsection vitals"
	  }, [_c('div', {
	    staticClass: "edit-alias"
	  }, [_c('h1', [_vm._v("Game Title")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.localAlias),
	      expression: "localAlias"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "Game Title"
	    },
	    domProps: {
	      "value": (_vm.localAlias)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.localAlias = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('span', [_vm._v("Note: Changing your game's title will change the URL to this page")])]), _vm._v(" "), _c('div', {
	    staticClass: "edit-avatar"
	  }, [_c('h1', [_vm._v("Avatar Image")]), _vm._v(" "), _c('input', {
	    attrs: {
	      "type": "file",
	      "name": "avatar",
	      "accept": "image/jpeg, image/png"
	    },
	    on: {
	      "change": _vm.updateuploadedAvatarName
	    }
	  }), _vm._v(" "), (_vm.uploadedImageSrc) ? _c('div', {
	    staticClass: "avatar-preview",
	    style: (("background-image: url('" + _vm.uploadedImageSrc + "')"))
	  }) : _vm._e(), _vm._v(" "), (_vm.avatarTooBig) ? _c('div', {
	    staticClass: "validation-messages error"
	  }, [_vm._v("Maximum filesize for an Avatar is 10Mb")]) : _vm._e(), _vm._v(" "), (_vm.localAlias.trim() === '') ? _c('div', {
	    staticClass: "validation-messages error"
	  }, [_vm._v("Set a Title for this Game")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "buttons"
	  }, [_c('button', {
	    staticClass: "button minor",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.cancelChanges($event)
	      }
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
	    staticClass: "button",
	    attrs: {
	      "disabled": !_vm.isValidated()
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.submitChanges($event)
	      }
	    }
	  }, [_vm._v("Save")])])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 826 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('article', {
	    attrs: {
	      "id": "game-page"
	    }
	  }, [_c('div', {
	    attrs: {
	      "id": "profile-details-container"
	    }
	  }, [(!_vm.gameDoesntExist) ? _c('game-details') : _vm._e()], 1), _vm._v(" "), (!_vm.gameDoesntExist) ? _c('section', {
	    attrs: {
	      "id": "game-page-content"
	    }
	  }, [(!_vm.gameDoesntExist) ? _c('nav', {
	    staticClass: "switch profile-page-navigation",
	    attrs: {
	      "id": "game-page-navigation"
	    }
	  }, [_c('router-link', {
	    class: {
	      active: _vm.selectedSubpage === 'RecentActivity'
	    },
	    attrs: {
	      "to": '/Game/' + _vm.$route.params.game,
	      "title": "Recent Activity"
	    }
	  }, [_vm._v("Recent Activity")]), _vm._v(" "), _c('router-link', {
	    class: {
	      active: _vm.selectedSubpage === 'Media'
	    },
	    attrs: {
	      "to": '/Game/' + _vm.$route.params.game + '/Media',
	      "title": "Media"
	    }
	  }, [_vm._v("Media")]), _vm._v(" "), _c('router-link', {
	    class: {
	      active: _vm.selectedSubpage === 'Members'
	    },
	    attrs: {
	      "to": '/Game/' + _vm.$route.params.game + '/Members',
	      "title": "Members"
	    }
	  }, [_vm._v("Members")]), _vm._v(" "), _c('router-link', {
	    class: {
	      active: _vm.selectedSubpage === 'Forums'
	    },
	    attrs: {
	      "to": '/Game/' + _vm.$route.params.game + '/Forums',
	      "title": "Forums"
	    }
	  }, [_vm._v("Forums")]), _vm._v(" "), _c('router-link', {
	    class: {
	      active: _vm.selectedSubpage === 'Followers'
	    },
	    attrs: {
	      "to": '/Game/' + _vm.$route.params.game + '/Followers',
	      "title": "Followers"
	    }
	  }, [_vm._v("Followers")])], 1) : _vm._e(), _vm._v(" "), _c('router-view', {
	    attrs: {
	      "game-id": _vm.gameId,
	      "is-member": _vm.isMember,
	      "is-moderator": _vm.isModerator,
	      "is-owner": _vm.isOwner
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.gameDoesntExist) ? _c('div', {
	    staticClass: "validation-messages error"
	  }, [_vm._v("This Game Doesn't Exist")]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 827 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "media-add-album"
	    }
	  }, [_c('h2', [_vm._v("Add an Album")]), _vm._v(" "), (!_vm.savingAlbum) ? _c('form', [_c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.albumName),
	      expression: "albumName"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "Album Name"
	    },
	    domProps: {
	      "value": (_vm.albumName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.albumName = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('label', [_vm._v("\n            Album Cover Art "), _c('input', {
	    attrs: {
	      "type": "file",
	      "name": "avatar",
	      "accept": "image/jpeg, image/png"
	    },
	    on: {
	      "change": _vm.updateUploadedAlbumName
	    }
	  }), _vm._v(" "), (_vm.uploadedImageSrc) ? _c('div', {
	    staticClass: "albumPreview",
	    style: (("background-image: url('" + _vm.uploadedImageSrc + "')"))
	  }) : _vm._e(), _vm._v(" "), (_vm.albumImageTooBig) ? _c('div', {
	    staticClass: "validation-messages error"
	  }, [_vm._v("Maximum filesize of an Album Icon is 10Mb")]) : _vm._e()]), _vm._v(" "), _c('button', {
	    staticClass: "button minor",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.cancel($event)
	      }
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
	    staticClass: "button",
	    attrs: {
	      "disabled": !_vm.isValidated()
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.addAlbum($event)
	      }
	    }
	  }, [_vm._v("Create")])]) : _c('saver-large')], 1)
	},staticRenderFns: []}

/***/ }),
/* 828 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('article', {
	    attrs: {
	      "id": "toc-page"
	    }
	  }, [_c('h1', [_vm._v("Terms and Conditions for Develteam")]), _vm._v(" "), _c('h2', [_vm._v("Introduction")]), _vm._v(" "), _c('p', [_vm._v("These Website Standard Terms and Conditions written on this webpage shall manage your use of our website,\n        Develteam accessible at https://www.develteam.com.")]), _vm._v(" "), _c('p', [_vm._v("These Terms will be applied fully and affect to your use of this Website. By using this Website, you agreed\n        to accept all terms and conditions written in here. You must not use this Website if you disagree with any\n        of these Website Standard Terms and Conditions. These Terms and Conditions have been generated with the help\n        of the "), _c('a', {
	    attrs: {
	      "href": "https://www.termsandcondiitionssample.com"
	    }
	  }, [_vm._v("Terms And Conditions Template")]), _vm._v(" and the "), _c('a', {
	    attrs: {
	      "href": "https://www.terms-conditions-generator.com"
	    }
	  }, [_vm._v("Terms and Conditions Generator")]), _vm._v(".")]), _vm._v(" "), _c('h2', [_vm._v("Intellectual Property Rights")]), _vm._v(" "), _c('p', [_vm._v("Other than the content you own, under these Terms, Storm Garden Studio and/or its licensors own all the\n        intellectual property rights and materials contained in this Website.")]), _vm._v(" "), _c('p', [_vm._v("You are granted limited license only for purposes of viewing the material contained on this Website.")]), _vm._v(" "), _c('h2', [_vm._v("Restrictions")]), _vm._v(" "), _c('p', [_vm._v("You are specifically restricted from all of the following:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("publishing any Website material in any other media;")]), _vm._v(" "), _c('li', [_vm._v("selling, sublicensing and/or otherwise commercializing any Website material;")]), _vm._v(" "), _c('li', [_vm._v("publicly performing and/or showing any Website material;")]), _vm._v(" "), _c('li', [_vm._v("using this Website in any way that is or may be damaging to this Website;")]), _vm._v(" "), _c('li', [_vm._v("using this Website in any way that impacts user access to this Website;")]), _vm._v(" "), _c('li', [_vm._v("using this Website contrary to applicable laws and regulations, or in any way may cause harm to the\n            Website, or to any person or business entity;\n        ")]), _vm._v(" "), _c('li', [_vm._v("engaging in any data mining, data harvesting, data extracting or any other similar activity in relation\n            to this Website;\n        ")]), _vm._v(" "), _c('li', [_vm._v("using this Website to engage in any advertising or marketing.")])]), _vm._v(" "), _c('p', [_vm._v("Certain areas of this Website are restricted from being access by you and Storm Garden Studio may further\n        restrict access by you to any areas of this Website, at any time, in absolute discretion. Any user ID and\n        password you may have for this Website are confidential and you must maintain confidentiality as well.")]), _vm._v(" "), _c('h2', [_vm._v("Your Content")]), _vm._v(" "), _c('p', [_vm._v("In these Website Standard Terms and Conditions, \"Your Content\" shall mean any audio, video text, images or\n        other material you choose to display on this Website. By displaying Your Content, you grant Storm Garden\n        Studio a non-exclusive, worldwide irrevocable, sub licensable license to use, reproduce, adapt, publish,\n        translate and distribute it in any and all media.")]), _vm._v(" "), _c('p', [_vm._v("Your Content must be your own and must not be invading any third-party’s rights. Storm Garden Studio reserves\n        the right to remove any of Your Content from this Website at any time without notice.")]), _vm._v(" "), _c('h2', [_vm._v("Your Privacy")]), _vm._v(" "), _c('p', [_vm._v("Please read Privacy Policy.")]), _vm._v(" "), _c('h2', [_vm._v("No warranties")]), _vm._v(" "), _c('p', [_vm._v("This Website is provided \"as is,\" with all faults, and Storm Garden Studio express no representations or\n        warranties, of any kind related to this Website or the materials contained on this Website. Also, nothing\n        contained on this Website shall be interpreted as advising you.")]), _vm._v(" "), _c('h2', [_vm._v("Limitation of liability")]), _vm._v(" "), _c('p', [_vm._v("In no event shall Storm Garden Studio, nor any of its officers, directors and employees, shall be held liable\n        for anything arising out of or in any way connected with your use of this Website whether such liability is\n        under contract.  Storm Garden Studio, including its officers, directors and employees shall not be held\n        liable for any indirect, consequential or special liability arising out of or in any way related to your use\n        of this Website.")]), _vm._v(" "), _c('h2', [_vm._v("Indemnification")]), _vm._v(" "), _c('p', [_vm._v("You hereby indemnify to the fullest extent Storm Garden Studio from and against any and/or all liabilities,\n        costs, demands, causes of action, damages and expenses arising in any way related to your breach of any of\n        the provisions of these Terms.")]), _vm._v(" "), _c('h2', [_vm._v("Severability")]), _vm._v(" "), _c('p', [_vm._v("If any provision of these Terms is found to be invalid under any applicable law, such provisions shall be\n        deleted without affecting the remaining provisions herein.")]), _vm._v(" "), _c('h2', [_vm._v("Variation of Terms")]), _vm._v(" "), _c('p', [_vm._v("Storm Garden Studio is permitted to revise these Terms at any time as it sees fit, and by using this Website\n        you are expected to review these Terms on a regular basis.")]), _vm._v(" "), _c('h2', [_vm._v("Assignment")]), _vm._v(" "), _c('p', [_vm._v("The Storm Garden Studio is allowed to assign, transfer, and subcontract its rights and/or obligations under\n        these Terms without any notification. However, you are not allowed to assign, transfer, or subcontract any\n        of your rights and/or obligations under these Terms.")]), _vm._v(" "), _c('h2', [_vm._v("Entire Agreement")]), _vm._v(" "), _c('p', [_vm._v("These Terms constitute the entire agreement between Storm Garden Studio and you in relation to your use of\n        this Website, and supersede all prior agreements and understandings.")]), _vm._v(" "), _c('h2', [_vm._v("Governing Law & Jurisdiction")]), _vm._v(" "), _c('p', [_vm._v("These Terms will be governed by and interpreted in accordance with the laws of the State of us, and you\n        submit to the non-exclusive jurisdiction of the state and federal courts located in us for the resolution of\n        any disputes.")])])
	}]}

/***/ }),
/* 829 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "category"
	  }, [_c('h2', [_vm._v(_vm._s(_vm.category.title) + " "), (_vm.category.isPrivate) ? _c('span', {
	    staticClass: "members-only"
	  }, [_vm._v("Members Only")]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.category.forums), function(forum) {
	    return (!_vm.editMode) ? _c('forum-item', {
	      attrs: {
	        "root": _vm.root,
	        "category": _vm.category,
	        "is-moderator": _vm.isModerator,
	        "board-id": _vm.boardId,
	        "forum": forum
	      }
	    }) : _vm._e()
	  }), _vm._v(" "), (Object.keys(_vm.category.forums).length === 0 && !_vm.editMode) ? _c('div', {
	    staticClass: "no-forums-message"
	  }, [_c('div', [_vm._v("No Forums have been created for this Category")])]) : _vm._e(), _vm._v(" "), (_vm.addForumMode) ? _c('div', {
	    staticClass: "forum add-forum-form"
	  }, [(_vm.addForumSaving) ? _c('saver-large') : _vm._e(), _vm._v(" "), (!_vm.addForumSaving) ? _c('div', [(_vm.addForumError) ? _c('div', {
	    staticClass: "validation-messages error"
	  }, [_vm._v(_vm._s(_vm.addForumError))]) : _vm._e(), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.addForumTitle),
	      expression: "addForumTitle"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "Forum Title"
	    },
	    domProps: {
	      "value": (_vm.addForumTitle)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.addForumTitle = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.addForumDescription),
	      expression: "addForumDescription"
	    }],
	    attrs: {
	      "placeholder": "Forum Description"
	    },
	    domProps: {
	      "value": (_vm.addForumDescription)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.addForumDescription = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "button minor",
	    on: {
	      "click": function($event) {
	        _vm.addForumMode = false
	      }
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
	    staticClass: "button",
	    on: {
	      "click": _vm.addForum
	    }
	  }, [_vm._v("Add Forum")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('section', {
	    staticClass: "edit-category-form"
	  }, [(_vm.editCategoryError) ? _c('div', {
	    staticClass: "validation-messages error"
	  }, [_vm._v(_vm._s(_vm.editCategoryError))]) : _vm._e(), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newCategoryTitle),
	      expression: "newCategoryTitle"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "Category Title"
	    },
	    domProps: {
	      "value": (_vm.newCategoryTitle)
	    },
	    on: {
	      "focus": function($event) {
	        _vm.editCategoryError = ''
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newCategoryTitle = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.isPrivate),
	      expression: "isPrivate"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.isPrivate) ? _vm._i(_vm.isPrivate, null) > -1 : (_vm.isPrivate)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.isPrivate,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.isPrivate = $$a.concat($$v))
	          } else {
	            $$i > -1 && (_vm.isPrivate = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.isPrivate = $$c
	        }
	      }
	    }
	  }), _vm._v(" Members Only Category")]), _vm._v(" "), _c('button', {
	    staticClass: "button minor",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.editMode = false
	      }
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.editCategory($event)
	      }
	    }
	  }, [_vm._v("Edit Category")])]) : _vm._e(), _vm._v(" "), (_vm.isModerator && !_vm.editMode && !_vm.addForumMode) ? _c('div', {
	    staticClass: "moderator-controls"
	  }, [_c('div', {
	    on: {
	      "click": function($event) {
	        _vm.editMode = true
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-pencil-alt"
	  }), _vm._v(" Edit Category")]), _vm._v(" "), _c('div', {
	    on: {
	      "click": function($event) {
	        _vm.addForumMode = true
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-plus"
	  }), _vm._v(" Add a Forum")])]) : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 830 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "add-post-form"
	  }, [(_vm.isSaving) ? _c('saver-large') : _vm._e(), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fade",
	      "mode": "out-in"
	    }
	  }, [(_vm.showSavedMessage) ? _c('div', {
	    staticClass: "validation-messages friendly"
	  }, [_vm._v("Your Post has Successfully been added.")]) : _vm._e()]), _vm._v(" "), (!_vm.isSaving) ? [_c('h3', [_vm._v("Add a Post")]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fade",
	      "mode": "out-in"
	    }
	  }, [(_vm.errorMessage) ? _c('div', {
	    staticClass: "validation-messages error"
	  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e()]), _vm._v(" "), _c('markdown-editor', {
	    attrs: {
	      "placeholder": "Post Content"
	    },
	    on: {
	      "input": function($event) {
	        _vm.errorMessage = ''
	      }
	    },
	    model: {
	      value: (_vm.postContent),
	      callback: function($$v) {
	        _vm.postContent = $$v
	      },
	      expression: "postContent"
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "button",
	    on: {
	      "click": _vm.submitPost
	    }
	  }, [_vm._v("Submit")])] : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 831 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    attrs: {
	      "id": "edit-networking"
	    }
	  }, [_c('div', {
	    staticClass: "networking edit-container"
	  }, [_c('h1', [_vm._v("Networking")]), _vm._v(" "), _c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formData.lookingForGame),
	      expression: "formData.lookingForGame"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.formData.lookingForGame) ? _vm._i(_vm.formData.lookingForGame, null) > -1 : (_vm.formData.lookingForGame)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.formData.lookingForGame,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.formData.lookingForGame = $$a.concat($$v))
	          } else {
	            $$i > -1 && (_vm.formData.lookingForGame = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.formData.lookingForGame = $$c
	        }
	      }
	    }
	  }), _vm._v("I want to join a Game Project")]), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formData.lookingForDescription),
	      expression: "formData.lookingForDescription"
	    }],
	    attrs: {
	      "placeholder": "What I'm looking for in a team"
	    },
	    domProps: {
	      "value": (_vm.formData.lookingForDescription)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.formData.lookingForDescription = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "buttons"
	  }, [_c('button', {
	    staticClass: "button minor",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.cancelChanges($event)
	      }
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.submitChanges($event)
	      }
	    }
	  }, [_vm._v("Save")])])])])
	},staticRenderFns: []}

/***/ }),
/* 832 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    attrs: {
	      "id": "edit-game-recruitment"
	    }
	  }, [_c('div', {
	    staticClass: "edit-container"
	  }, [(_vm.isSaving) ? _c('saver-large') : _vm._e(), _vm._v(" "), (!_vm.isSaving) ? _c('div', {
	    staticClass: "recruiting-roles"
	  }, [_c('h1', [_vm._v("Recruiting Role Titles")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.roleTitles),
	      expression: "roleTitles"
	    }],
	    attrs: {
	      "type": "text",
	      "maxlength": "250"
	    },
	    domProps: {
	      "value": (_vm.roleTitles)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.roleTitles = $event.target.value
	      }
	    }
	  })]) : _vm._e(), _vm._v(" "), (!_vm.isSaving) ? _c('div', {
	    staticClass: "recruiting-role-types"
	  }, [_c('h1', [_vm._v("Recruiting Role Types")]), _vm._v(" "), _c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.recruitingProducers),
	      expression: "recruitingProducers"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.recruitingProducers) ? _vm._i(_vm.recruitingProducers, null) > -1 : (_vm.recruitingProducers)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.recruitingProducers,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.recruitingProducers = $$a.concat($$v))
	          } else {
	            $$i > -1 && (_vm.recruitingProducers = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.recruitingProducers = $$c
	        }
	      }
	    }
	  }), _vm._v(" Producers")]), _vm._v(" "), _c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.recruitingDesigners),
	      expression: "recruitingDesigners"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.recruitingDesigners) ? _vm._i(_vm.recruitingDesigners, null) > -1 : (_vm.recruitingDesigners)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.recruitingDesigners,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.recruitingDesigners = $$a.concat($$v))
	          } else {
	            $$i > -1 && (_vm.recruitingDesigners = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.recruitingDesigners = $$c
	        }
	      }
	    }
	  }), _vm._v(" Designers")]), _vm._v(" "), _c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.recruitingArtists),
	      expression: "recruitingArtists"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.recruitingArtists) ? _vm._i(_vm.recruitingArtists, null) > -1 : (_vm.recruitingArtists)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.recruitingArtists,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.recruitingArtists = $$a.concat($$v))
	          } else {
	            $$i > -1 && (_vm.recruitingArtists = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.recruitingArtists = $$c
	        }
	      }
	    }
	  }), _vm._v(" Artists")]), _vm._v(" "), _c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.recruitingProgrammers),
	      expression: "recruitingProgrammers"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.recruitingProgrammers) ? _vm._i(_vm.recruitingProgrammers, null) > -1 : (_vm.recruitingProgrammers)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.recruitingProgrammers,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.recruitingProgrammers = $$a.concat($$v))
	          } else {
	            $$i > -1 && (_vm.recruitingProgrammers = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.recruitingProgrammers = $$c
	        }
	      }
	    }
	  }), _vm._v(" Programmers")]), _vm._v(" "), _c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.recruitingMusicians),
	      expression: "recruitingMusicians"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.recruitingMusicians) ? _vm._i(_vm.recruitingMusicians, null) > -1 : (_vm.recruitingMusicians)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.recruitingMusicians,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.recruitingMusicians = $$a.concat($$v))
	          } else {
	            $$i > -1 && (_vm.recruitingMusicians = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.recruitingMusicians = $$c
	        }
	      }
	    }
	  }), _vm._v(" Musicians")]), _vm._v(" "), _c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.recruitingSfxArtists),
	      expression: "recruitingSfxArtists"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.recruitingSfxArtists) ? _vm._i(_vm.recruitingSfxArtists, null) > -1 : (_vm.recruitingSfxArtists)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.recruitingSfxArtists,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.recruitingSfxArtists = $$a.concat($$v))
	          } else {
	            $$i > -1 && (_vm.recruitingSfxArtists = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.recruitingSfxArtists = $$c
	        }
	      }
	    }
	  }), _vm._v(" SFX Artists")]), _vm._v(" "), _c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.recruitingWriters),
	      expression: "recruitingWriters"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.recruitingWriters) ? _vm._i(_vm.recruitingWriters, null) > -1 : (_vm.recruitingWriters)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.recruitingWriters,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.recruitingWriters = $$a.concat($$v))
	          } else {
	            $$i > -1 && (_vm.recruitingWriters = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.recruitingWriters = $$c
	        }
	      }
	    }
	  }), _vm._v(" Writers")]), _vm._v(" "), _c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.recruitingTesters),
	      expression: "recruitingTesters"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.recruitingTesters) ? _vm._i(_vm.recruitingTesters, null) > -1 : (_vm.recruitingTesters)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.recruitingTesters,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.recruitingTesters = $$a.concat($$v))
	          } else {
	            $$i > -1 && (_vm.recruitingTesters = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.recruitingTesters = $$c
	        }
	      }
	    }
	  }), _vm._v(" Testers")])]) : _vm._e(), _vm._v(" "), _c('label', [_vm._v("Skills")]), _vm._v(" "), _c('div', {
	    staticClass: "existing-skill-list"
	  }, [_vm._l((_vm.skills), function(skillId) {
	    return (_vm.skills && _vm.skills.length > 0) ? _c('span', {
	      staticClass: "matching-skill-tag",
	      on: {
	        "click": function($event) {
	          _vm.removeSkill(skillId)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fas fa-minus-circle"
	    }), _vm._v("  " + _vm._s(_vm.skillList[skillId].skill) + "\n                ")]) : _vm._e()
	  }), _vm._v(" "), (_vm.skills && _vm.skills.length === 0) ? _c('span', [_vm._v("No skills entered")]) : _vm._e()], 2), _vm._v(" "), _c('label', [_vm._v("Add Skill")]), _vm._v(" "), _c('div', {
	    staticClass: "add-skill-form"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.enteredSkill),
	      expression: "enteredSkill"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "Search for Skill Tags..."
	    },
	    domProps: {
	      "value": (_vm.enteredSkill)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.enteredSkill = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (_vm.enteredSkill.length > 0) ? _c('button', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        _vm.enteredSkill = ''
	      }
	    }
	  }, [_vm._v("X")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "matching-skill-list"
	  }, [(_vm.matchingSkills.length === 0) ? _c('span', [_vm._v("No matching tags... Search by skill name, or type a category to see all entries.")]) : _vm._e(), _vm._v(" "), (_vm.matchingSkills.length === 0) ? _c('span', [_vm._v("Categories: Art, Software, Development, Engine, Writing, Production, Testing")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.matchingSkills), function(skill) {
	    return _c('span', {
	      staticClass: "matching-skill-tag",
	      on: {
	        "click": function($event) {
	          _vm.addSkill(skill.id)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fas fa-plus-circle"
	    }), _vm._v(" " + _vm._s(skill.skill) + "\n                ")])
	  })], 2), _vm._v(" "), (!_vm.isSaving) ? _c('div', {
	    staticClass: "vitals"
	  }, [_c('div', {
	    staticClass: "buttons"
	  }, [_c('button', {
	    staticClass: "button minor",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.cancelChanges($event)
	      }
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.submitChanges($event)
	      }
	    }
	  }, [_vm._v("Save")])])]) : _vm._e()], 1)])
	},staticRenderFns: []}

/***/ }),
/* 833 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(!_vm.expanded) ? _c('button', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.expanded = true
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.buttonLabel))]) : _vm._e(), _vm._v(" "), (_vm.expanded) ? _c('div', {
	    staticClass: "feed-post",
	    attrs: {
	      "id": "feed-add-new"
	    }
	  }, [_c('h2', [_vm._v(_vm._s(_vm.headlineLabel))]), _vm._v(" "), _c('form', [(_vm.isOnAGameProject) ? [_c('label', [_c('span', [_vm._v("Post As")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectedPostAs),
	      expression: "selectedPostAs"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.selectedPostAs = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "developer"
	    }
	  }, [_vm._v(_vm._s(_vm.developerAlias))]), _vm._v(" "), _vm._l((_vm.gameProjects), function(game) {
	    return _c('option', {
	      domProps: {
	        "value": game.id
	      }
	    }, [_vm._v("Game: " + _vm._s(game.alias))])
	  })], 2)])] : _vm._e(), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newPostSubject),
	      expression: "newPostSubject"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "Subject (optional)"
	    },
	    domProps: {
	      "value": (_vm.newPostSubject)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newPostSubject = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('markdown-editor', {
	    attrs: {
	      "placeholder": "Post Content"
	    },
	    model: {
	      value: (_vm.newPostContent),
	      callback: function($$v) {
	        _vm.newPostContent = $$v
	      },
	      expression: "newPostContent"
	    }
	  }), _vm._v(" "), (!_vm.helpShown) ? _c('div', {
	    staticClass: "help-button",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        _vm.showHelpRollout()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-question-circle"
	  }), _vm._v(" Help submitting a DevLog\n            ")]) : _c('div', {
	    staticClass: "help-rollout"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "help-button",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        _vm.hideHelpRollout()
	      }
	    }
	  }, [_vm._v("Hide Help")])]), _vm._v(" "), _c('button', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.submitNewPost($event)
	      }
	    }
	  }, [_vm._v("Submit")]), _vm._v(" "), _c('button', {
	    staticClass: "button minor",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.expanded = false
	      }
	    }
	  }, [_vm._v("Cancel")])], 2)]) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_vm._v("\n                    A Developer's Log (or "), _c('em', [_vm._v("DevLog")]), _vm._v(" for short) is a bit like a diary or Blog post for your game\n                    development related topics. It's not a recruitment tool (that is what Classifieds are for)\n                    but anything else about your game dev journey that you want to write about is fair game.\n                    Some might use it to write about an interesting thing they worked on, or a gamedev challenge\n                    they faced and how they solved it, or something they just learned.\n                ")])
	}]}

/***/ }),
/* 834 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('router-link', {
	    class: 'avatar ' + _vm.size,
	    attrs: {
	      "to": _vm.linkUrl,
	      "tag": "a",
	      "title": _vm.profileData.alias
	    }
	  }, [(_vm.showXpInfo) ? _c('svg', {
	    attrs: {
	      "viewPort": "0 0 200 300",
	      "version": "1.1",
	      "xmlns": "http://www.w3.org/2000/svg"
	    }
	  }, [_c('circle', {
	    staticClass: "xp-ring",
	    attrs: {
	      "stroke-dasharray": _vm.xpRingProperties.strokeDasharray,
	      "cx": _vm.xpRingProperties.cx,
	      "cy": _vm.xpRingProperties.cy,
	      "r": _vm.xpRingProperties.r
	    }
	  })]) : _vm._e(), _vm._v(" "), _c('img', {
	    staticClass: "inner",
	    attrs: {
	      "src": _vm.imgSrc + '?v=' + _vm.profileData.avatarId,
	      "alt": _vm.altText,
	      "title": _vm.altText
	    }
	  }), _vm._v(" "), (_vm.showXpInfo) ? _c('div', {
	    staticClass: "level"
	  }, [_vm._v(_vm._s(_vm.profileData.xpLevelData.xpLevel))]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 835 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(_vm.board.fetchingStatus === 'fetching') ? _c('loader-large') : [(Object.keys(_vm.orderedCategories || {}).length === 0) ? _c('div', {
	    staticClass: "no-forums"
	  }, [_vm._v("This Group doesn't have any forums set up")]) : _vm._l((_vm.orderedCategories), function(category) {
	    return _c('category-item', {
	      attrs: {
	        "category": category,
	        "is-moderator": _vm.isModerator,
	        "board-id": _vm.boardId,
	        "root": _vm.root
	      }
	    })
	  }), _vm._v(" "), (_vm.isModerator && !_vm.showAddCategoryForm) ? _c('section', {
	    staticClass: "add-category",
	    on: {
	      "click": function($event) {
	        _vm.showAddCategoryForm = true
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-plus"
	  }), _vm._v(" Add a Category\n        ")]) : _vm._e(), _vm._v(" "), (_vm.isModerator && _vm.showAddCategoryForm && _vm.savingAddCategory) ? _c('saver-large') : _vm._e(), _vm._v(" "), (_vm.isModerator && _vm.showAddCategoryForm && !_vm.savingAddCategory) ? _c('section', {
	    staticClass: "add-category-form"
	  }, [_c('h2', [_vm._v("Add Category")]), _vm._v(" "), (_vm.addCategoryError) ? _c('div', {
	    staticClass: "validation-messages error"
	  }, [_vm._v(_vm._s(_vm.addCategoryError))]) : _vm._e(), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newCategoryTitle),
	      expression: "newCategoryTitle"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "Category Title"
	    },
	    domProps: {
	      "value": (_vm.newCategoryTitle)
	    },
	    on: {
	      "focus": function($event) {
	        _vm.addCategoryError = ''
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newCategoryTitle = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.isPrivate),
	      expression: "isPrivate"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.isPrivate) ? _vm._i(_vm.isPrivate, null) > -1 : (_vm.isPrivate)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.isPrivate,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.isPrivate = $$a.concat($$v))
	          } else {
	            $$i > -1 && (_vm.isPrivate = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.isPrivate = $$c
	        }
	      }
	    }
	  }), _vm._v(" Members Only Category")]), _vm._v(" "), _c('button', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.addCategory($event)
	      }
	    }
	  }, [_vm._v("Add Category")])]) : _vm._e()]], 2)
	},staticRenderFns: []}

/***/ }),
/* 836 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('svg', {
	    staticClass: "dt-icon icon-user-plus",
	    attrs: {
	      "version": "1.1",
	      "id": "Layer_1",
	      "xmlns": "http://www.w3.org/2000/svg",
	      "xmlns:xlink": "http://www.w3.org/1999/xlink",
	      "x": "0px",
	      "y": "0px",
	      "width": "600px",
	      "height": "400px",
	      "viewBox": "0 0 600 400",
	      "enable-background": "new 0 0 600 400",
	      "xml:space": "preserve"
	    }
	  }, [_c('g', [_c('title', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('rect', {
	    staticStyle: {
	      "fill": "white",
	      "stroke": "1px red solid"
	    },
	    attrs: {
	      "x": "0",
	      "y": "0",
	      "width": "600",
	      "height": "400"
	    }
	  })]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
	    attrs: {
	      "fill": "#010101",
	      "d": "M436.091,206.911c-4.74-12.324-11.657-23.717-21.086-33.616c-8.869-9.313-19.962-16.752-31.573-22.187\n\t\t\tc-7.406-3.466-16.115-2.145-20.522,5.381c-3.847,6.565-2.025,17.057,5.38,20.523l0,0c4.443,2.08,8.732,4.41,12.873,7.044\n\t\t\tc2.023,1.289,3.974,2.69,5.893,4.129c-2.91-2.183,0.235,0.271,0.676,0.64c1.213,1.017,2.377,2.092,3.533,3.175\n\t\t\tc1.733,1.625,3.361,3.358,4.949,5.125c0.797,0.887,1.555,1.808,2.313,2.729c2.553,3.103-1.813-2.483,0.563,0.778\n\t\t\tc2.375,3.261,4.445,6.729,6.292,10.312c0.597,1.157,1.169,2.326,1.722,3.504c1.793,3.822-1.102-2.852,0.487,1.115\n\t\t\tc0.484,1.211,0.917,2.439,1.352,3.668"
	    }
	  })])]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
	    attrs: {
	      "fill": "#010101",
	      "d": "M234.814,296.467c-15.118,1.572-30.632,4.954-45.876,4.656c-1.042-0.021-2.08-0.1-3.114-0.214\n\t\t\tc5.975,0.659,2.361,0.334,0.875-0.068c-3.468-0.937,3.473,1.763,0.985,0.479c-3.419-1.764,2.418,2.287,0.64,0.57\n\t\t\tc-2.443-2.356,2.197,3.312,0.698,0.905c-0.219-0.351-0.404-0.722-0.59-1.091c-0.983-1.954,1.619,4.053,0.825,1.951\n\t\t\tc-0.349-0.926-0.6-1.887-0.833-2.846c-0.345-1.42-1.019-6.527-0.254-0.601c-0.895-6.933-0.807-14.013-0.82-20.989\n\t\t\tc-0.021-11.021-0.245-22.115,0.283-33.123c0.144-3,0.435-5.99,0.783-8.972c-0.374,3.206,0.256-1.438,0.301-1.709\n\t\t\tc0.229-1.381,0.509-2.754,0.789-4.125c1.149-5.624,2.853-11.121,4.956-16.457c-1.29,3.272,0.282-0.563,0.495-1.026\n\t\t\tc0.518-1.123,1.083-2.223,1.648-3.32c1.11-2.159,2.359-4.244,3.653-6.297c0.638-1.012,1.319-1.995,2-2.979\n\t\t\tc0.332-0.479,2.76-3.651,0.496-0.761c1.692-2.161,3.538-4.197,5.437-6.176c2.166-2.257,4.503-4.343,6.903-6.346\n\t\t\tc1.304-1.042,1.215-0.99-0.266,0.157c0.627-0.476,1.26-0.943,1.899-1.402c1.6-1.166,3.258-2.248,4.928-3.31\n\t\t\tc2.711-1.724,5.537-3.265,8.397-4.725c1.454-0.743,2.937-1.428,4.422-2.106c1.561-0.682,1.503-0.668-0.173,0.042\n\t\t\tc1.153-0.483,2.321-0.93,3.488-1.377c7.627-2.924,12.805-9.986,10.477-18.452c-2.009-7.303-10.808-13.407-18.452-10.477\n\t\t\tc-21.586,8.276-39.919,20.853-53.459,39.792c-14.246,19.927-18.917,45.335-18.928,69.359c-0.007,17.129-1.296,34.787,1.733,51.743\n\t\t\tc1.057,5.914,3.774,11.588,7.952,15.929c5.075,5.272,11.761,6.905,18.713,7.806c6.093,0.788,12.476-0.159,18.53-0.854\n\t\t\tc10.158-1.163,20.29-2.531,30.46-3.59c8.13-0.846,15-6.184,15-15C249.814,303.932,242.962,295.619,234.814,296.467\n\t\t\tL234.814,296.467z"
	    }
	  })])]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
	    attrs: {
	      "fill": "#010101",
	      "d": "M379.614,111.269c-0.022,2.735-0.153,5.452-0.397,8.177c-0.398,4.45,0.521-3.043-0.16,1.345\n\t\t\tc-0.203,1.318-0.473,2.625-0.74,3.93c-0.53,2.589-1.246,5.137-2.021,7.662c-0.386,1.254-0.83,2.489-1.273,3.723\n\t\t\tc-0.301,0.818-0.615,1.631-0.942,2.439c0.674-1.576,0.66-1.573-0.04,0.008c-2.137,4.737-4.814,9.213-7.775,13.475\n\t\t\tc-0.234,0.336-2.846,3.737-0.771,1.105c-0.803,1.018-1.65,2-2.497,2.98c-1.979,2.293-4.13,4.436-6.336,6.51\n\t\t\tc-0.948,0.891-1.937,1.74-2.923,2.588c-0.297,0.255-3.688,2.923-1.043,0.908c-2.084,1.588-4.271,3.036-6.486,4.434\n\t\t\tc-2.23,1.407-4.553,2.664-6.898,3.867c-1.18,0.605-2.386,1.158-3.592,1.71c-1.59,0.7-1.623,0.714-0.098,0.043\n\t\t\tc-0.829,0.329-1.662,0.645-2.501,0.949c-5.091,1.889-10.382,3.194-15.724,4.138c-4.479,0.791,3.056-0.303-1.494,0.219\n\t\t\tc-1.39,0.159-2.783,0.255-4.178,0.351c-3.297,0.226-6.604,0.201-9.904,0.075c-1.4-0.053-2.798-0.17-4.196-0.288\n\t\t\tc-0.381-0.032-4.937-0.635-1.521-0.138c-2.71-0.395-5.39-0.972-8.052-1.61c-2.627-0.63-5.209-1.436-7.767-2.299\n\t\t\tc-1.269-0.428-2.518-0.913-3.766-1.396c3.07,1.191-1.97-0.913-2.503-1.167c-4.754-2.264-9.246-5.048-13.521-8.111\n\t\t\tc-3.512-2.516,2.257,1.863-1.094-0.85c-1.012-0.82-1.988-1.684-2.962-2.547c-2.27-2.01-4.387-4.185-6.435-6.417\n\t\t\tc-0.877-0.956-1.71-1.95-2.542-2.943c-2.755-3.287,1.719,2.387-0.833-1.059c-1.544-2.084-2.944-4.27-4.292-6.484\n\t\t\tc-1.351-2.22-2.547-4.531-3.688-6.864c-0.188-0.386-1.902-4.349-0.594-1.187c-0.667-1.613-1.246-3.262-1.811-4.914\n\t\t\tc-0.854-2.497-1.529-5.05-2.141-7.615c-0.309-1.294-0.555-2.602-0.802-3.909c-0.085-0.452-0.674-4.839-0.244-1.319\n\t\t\tc-0.718-5.871-0.669-11.816-0.143-17.698c0.205-1.783,0.19-1.791-0.045-0.022c0.184-1.324,0.431-2.638,0.679-3.951\n\t\t\tc0.49-2.603,1.167-5.167,1.904-7.708c0.73-2.52,1.639-4.983,2.603-7.421c-1.256,3.174,0.408-0.792,0.594-1.188\n\t\t\tc0.553-1.177,1.16-2.328,1.767-3.478c1.211-2.296,2.579-4.505,3.994-6.679c0.707-1.086,1.463-2.14,2.219-3.192\n\t\t\tc2.5-3.484-1.873,2.269,0.833-1.059c3.278-4.033,7.002-7.688,10.939-11.072c0.663-0.563,1.334-1.113,2.014-1.655\n\t\t\tc-2.581,2.09,0.822-0.56,1.144-0.79c2.135-1.529,4.368-2.915,6.628-4.249c2.277-1.344,4.641-2.534,7.027-3.67\n\t\t\tc0.35-0.167,4.396-1.849,1.306-0.596c1.241-0.503,2.503-0.95,3.766-1.396c5.13-1.816,10.452-3.044,15.819-3.908\n\t\t\tc-3.401,0.548,1.133-0.099,1.521-0.138c1.396-0.139,2.797-0.213,4.197-0.288c2.83-0.151,5.666-0.108,8.498,0\n\t\t\tc2.328,0.088,4.649,0.318,6.964,0.583c-3.412-0.391,1.079,0.231,1.467,0.3c1.347,0.238,2.683,0.537,4.017,0.835\n\t\t\tc2.642,0.591,5.239,1.36,7.816,2.186c1.277,0.409,2.535,0.876,3.792,1.342c4.135,1.533-2.676-1.243,1.344,0.526\n\t\t\tc4.831,2.126,9.413,4.782,13.787,7.725c1.086,0.73,2.138,1.508,3.19,2.285c-2.67-1.972,0.736,0.653,1.043,0.907\n\t\t\tc1.996,1.667,3.881,3.464,5.722,5.3c1.531,1.527,2.972,3.143,4.384,4.779c0.266,0.307,2.93,3.676,0.895,1.01\n\t\t\tc0.785,1.03,1.525,2.095,2.266,3.159c2.967,4.269,5.438,8.864,7.572,13.598c-1.404-3.115,0.294,0.853,0.447,1.26\n\t\t\tc0.463,1.227,0.869,2.476,1.273,3.723c0.814,2.515,1.45,5.084,2.021,7.663c0.289,1.302,0.516,2.616,0.74,3.93\n\t\t\tc0.752,4.377-0.311-3.097,0.16,1.346C379.504,105.807,379.592,108.54,379.614,111.269c0.065,8.176,6.772,15,15,15\n\t\t\tc8.127,0,15.065-6.823,15-15c-0.203-25.044-9.682-48.393-26.271-67.031c-16.59-18.639-40.217-29.661-64.69-32.844\n\t\t\tc-49.691-6.462-98.545,25.167-112.5,73.306c-7.006,24.172-3.552,50.257,7.748,72.502c11.089,21.829,30.953,38.303,53.402,47.399\n\t\t\tc46.813,18.969,102.278,0.061,128.396-42.864c9.181-15.087,13.771-32.877,13.914-50.469c0.065-8.177-6.873-15-15-15\n\t\t\tC386.387,96.269,379.682,103.093,379.614,111.269z"
	    }
	  })])]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
	    attrs: {
	      "fill": "#010101",
	      "d": "M362.666,352.113c-0.143,2.768-0.348,5.531-0.637,8.289c-0.471,4.475,0.521-3.276,0.012-0.011\n\t\t\tc-0.171,1.096-0.389,2.182-0.646,3.259c-0.174,0.732-0.396,1.455-0.656,2.162c1.848-5.051,1.621-3.652,1.019-2.486\n\t\t\tc-0.567,1.101-2.136,2.647,1.806-2.231c-1.319,1.634,4.142-2.682,1.61-1.305c-1.974,1.073,4.685-1.646,0.812-0.438\n\t\t\tc-2.021,0.632-4.117,1.024-6.198,1.391c-1.316,0.23-6.313,0.909-0.619,0.151c-1.742,0.231-3.49,0.422-5.239,0.601\n\t\t\tc-7.535,0.771-15.109,1.156-22.679,1.435c-17.367,0.639-34.782,0.511-52.143-0.258c-7.433-0.329-14.864-0.81-22.265-1.583\n\t\t\tc-1.464-0.151-2.926-0.328-4.387-0.515c5.721,0.729,0.798,0.09-0.53-0.129c-2.16-0.355-4.314-0.79-6.415-1.414\n\t\t\tc-3.292-0.979,1.672,0.814,1.338,0.656c-2.48-1.185,3.088,2.894,1.739,1.426c3.247,3.531,2.558,3.567,1.876,2.309\n\t\t\tc-0.862-1.593,1.743,4.356,1.083,2.564c-0.292-0.793-0.479-1.625-0.659-2.448c-0.197-0.9-0.339-1.813-0.477-2.726\n\t\t\tc0.928,6.177,0.225,1.604,0.078,0.142c-0.294-2.934-0.459-5.878-0.596-8.821c-1.796-38.597,0.795-77.681,3.212-116.211\n\t\t\tc0.512-8.169-7.211-15-15-15c-8.564,0-14.488,6.844-15,15c-1.432,22.824-2.469,45.686-3.12,68.544\n\t\t\tc-0.444,15.621-0.762,31.287-0.125,46.908c0.49,12.021,0.387,26.2,11.171,33.831c3.7,2.618,9.122,3.544,13.522,4.268\n\t\t\tc7.374,1.213,14.833,1.947,22.283,2.491c16.966,1.24,34.021,1.502,51.025,1.289c16.05-0.201,32.119-0.903,48.01-3.275\n\t\t\tc11.813-1.764,21.816-6.561,24.652-19.204"
	    }
	  })])]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
	    attrs: {
	      "fill": "#010101",
	      "d": "M117.477,295.25c-8.678,0.902-17.323,2.064-25.99,3.059c-2.951,0.338-5.909,0.627-8.877,0.768\n\t\t\tc-1.185,0.056-2.372,0.059-3.558,0.025c-0.527-0.016-1.052-0.056-1.577-0.099c-2.377-0.19,4.353,0.671,2.082,0.278\n\t\t\tc-0.843-0.146-1.662-0.391-2.461-0.689c4.832,1.811,3.357,1.494,2.189,0.83c-1.083-0.615-2.463-2.092,1.824,1.471\n\t\t\tc-2.578-2.144,2.144,3.334,0.626,0.991c-1.949-3.01,1.271,3.726,0.246,0.824c-0.343-0.972-0.568-1.983-0.776-2.99\n\t\t\tc-0.889-4.313,0.317,3.441-0.068-0.299c-0.326-3.172-0.403-6.371-0.465-9.558c-0.189-9.647-0.039-19.314,0.022-28.965\n\t\t\tc0.019-3.088,0.212-6.174,0.475-9.25c0.02-0.236,0.629-5.076,0.167-1.834c0.2-1.402,0.461-2.797,0.724-4.188\n\t\t\tc0.984-5.228,2.542-10.328,4.506-15.265c-1.303,3.272,0.313-0.524,0.537-0.991c0.531-1.107,1.12-2.188,1.708-3.267\n\t\t\tc1.154-2.115,2.471-4.137,3.84-6.117c0.339-0.49,2.806-3.604,0.518-0.742c0.735-0.92,1.518-1.801,2.3-2.68\n\t\t\tc1.56-1.754,3.252-3.386,4.98-4.971c0.866-0.793,1.77-1.544,2.673-2.294c3.049-2.53-2.505,1.821,0.709-0.521\n\t\t\tc1.926-1.401,3.947-2.67,5.99-3.893c2.08-1.244,4.238-2.353,6.413-3.419c1.105-0.542,2.231-1.039,3.356-1.537\n\t\t\tc-3.299,1.46,0.547-0.174,1.039-0.362c7.625-2.932,12.807-9.98,10.477-18.452c-2.008-7.298-10.811-13.415-18.452-10.477\n\t\t\tc-21.413,8.233-40.08,21.788-50.902,42.483c-11.566,22.119-11.157,46.54-11.131,70.813c0.016,14.825-0.307,30.977,12.598,40.751\n\t\t\tc10.11,7.658,26.246,3.897,37.664,2.479c5.527-0.688,11.057-1.34,16.596-1.917c8.129-0.847,15-6.183,15-15\n\t\t\tC132.477,302.715,125.625,294.4,117.477,295.25L117.477,295.25z"
	    }
	  })])]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
	    attrs: {
	      "fill": "#010101",
	      "d": "M176.647,200.21c-2.369-0.022-4.721-0.129-7.082-0.326c-4.583-0.381,2.964,0.53-1.542-0.182\n\t\t\tc-1.361-0.215-2.71-0.504-4.058-0.794c-2.663-0.572-5.273-1.361-7.856-2.22c-1.278-0.425-2.532-0.919-3.785-1.413\n\t\t\tc3.078,1.212-0.958-0.505-1.301-0.67c-1.996-0.958-3.92-2.056-5.821-3.188c-1.135-0.676-2.233-1.412-3.329-2.146\n\t\t\tc-0.312-0.208-3.804-2.806-1.199-0.775c-4.129-3.218-7.811-6.975-11.151-10.995c1.962,2.361-1.765-2.537-2.26-3.285\n\t\t\tc-1.441-2.18-2.698-4.476-3.887-6.8c-0.189-0.37-1.971-4.327-0.654-1.192c-0.51-1.214-0.95-2.456-1.39-3.697\n\t\t\tc-0.887-2.503-1.557-5.077-2.149-7.663c-0.191-0.873-0.365-1.748-0.522-2.627c-0.824-4.367,0.278,3.084-0.205-1.365\n\t\t\tc-0.297-2.735-0.35-5.491-0.323-8.239c0.014-1.374,0.108-2.745,0.202-4.115c0.031-0.445,0.621-4.896,0.102-1.397\n\t\t\tc0.393-2.646,1.016-5.251,1.712-7.83c0.575-2.126,1.312-4.205,2.086-6.265c1.526-4.06-1.258,2.684,0.566-1.238\n\t\t\tc0.552-1.186,1.17-2.34,1.787-3.493c1.232-2.302,2.654-4.497,4.132-6.646c0.23-0.334,2.877-3.712,0.802-1.122\n\t\t\tc0.816-1.019,1.686-1.992,2.555-2.964c1.452-1.624,3.019-3.141,4.61-4.626c0.958-0.894,1.962-1.736,2.966-2.578\n\t\t\tc3.313-2.777-2.372,1.692,1.138-0.847c2.142-1.549,4.405-2.922,6.699-4.232c1.155-0.66,2.344-1.256,3.532-1.853\n\t\t\tc0.333-0.167,4.365-1.94,1.301-0.669c4.61-1.912,9.447-3.227,14.337-4.184c0.374-0.073,4.884-0.686,1.509-0.28\n\t\t\tc1.397-0.168,2.802-0.259,4.206-0.35c3.133-0.203,6.275-0.122,9.407,0.053c4.652,0.259,11.002,1.783,17.03,3.931\n\t\t\tc3.377,1.204,10.134,5.038,14.698,8.32c6.651,4.784,16.685,1.171,20.523-5.381c4.428-7.559,1.242-15.759-5.381-20.523\n\t\t\tc-22.961-16.513-53.746-20.824-80.519-11.927c-24.525,8.15-43.873,26.491-53.832,50.2c-9.795,23.32-7.444,50.166,4.382,72.257\n\t\t\tc11.604,21.677,33.557,37.401,57.305,42.962c6.725,1.573,13.756,2.311,20.656,2.373c8.177,0.075,15-6.88,15-15\n\t\t\tC191.647,206.977,184.823,200.286,176.647,200.21L176.647,200.21z"
	    }
	  })])]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
	    attrs: {
	      "fill": "#010101",
	      "d": "M220.808,349.358c-0.25,1.531-0.538,3.016-0.938,4.516c0.713-2.672,2.904-4.501,5.069-5.997\n\t\t\tc-2.468,1.704,4.123-1.491,1.446-0.544c-2.137,0.757-4.418,1.14-6.647,1.508c-4.617,0.761,3.048-0.34-0.826,0.121\n\t\t\tc-1.564,0.188-3.132,0.336-4.701,0.479c-3.876,0.354-7.764,0.584-11.651,0.775c-17.136,0.849-34.362,0.72-51.494-0.16\n\t\t\tc-3.621-0.186-7.238-0.432-10.851-0.733c-1.602-0.136-3.202-0.293-4.801-0.463c-0.738-0.078-1.476-0.166-2.213-0.255\n\t\t\tc-2.697-0.322,4.336,0.629,0.609,0.078c-2.122-0.313-4.239-0.701-6.309-1.269c-3.318-0.909,1.374,0.721,1.253,0.664\n\t\t\tc-0.231-0.109-0.445-0.245-0.657-0.388c2.032,1.181,3.638,2.786,4.819,4.818c-0.085-0.124-0.163-0.253-0.231-0.387\n\t\t\tc2.537,4.544,0.764,1.893,0.289-0.981c-0.387-2.341,0.559,4.398,0.252,1.934c-0.071-0.572-0.128-1.146-0.187-1.72\n\t\t\tc-0.153-1.519-0.257-3.041-0.352-4.563c-0.438-7.043-0.463-14.114-0.439-21.168c0.09-26.041,1.331-52.118,2.959-78.104\n\t\t\tc0.512-8.17-7.21-15-15-15c-8.563,0-14.489,6.842-15,15c-1.548,24.703-2.669,49.471-2.932,74.222\n\t\t\tc-0.138,13.016-0.838,27.147,2.274,39.905c3.661,15.009,19.755,16.084,32.41,17.374c20.745,2.117,41.866,2.149,62.683,1.326\n\t\t\tc9.602-0.38,19.202-1.117,28.69-2.682c11.555-1.905,19.399-8.088,21.402-20.333c1.318-8.063-1.973-16.112-10.477-18.451\n\t\t\tC232.02,336.89,222.129,341.278,220.808,349.358L220.808,349.358z"
	    }
	  })])]), _vm._v(" "), _c('g', [_c('g', [_c('g', [_c('path', {
	    attrs: {
	      "fill": "#010101",
	      "d": "M508.758,319.17c14.988,1.561,4.878,11.643,19.935,9.04c15.497-2.678,19.802-18.286,20.676-31.653\n\t\t\t\tc0.558-8.527,0.291-17.125,0.253-25.662c-0.059-13.033-0.472-25.881-3.689-38.595c-5.714-22.581-20.47-41.428-40.34-53.316\n\t\t\t\tc-5.667-3.39-11.828-5.979-17.978-8.343c-7.643-2.937-16.444,3.178-18.451,10.477c-2.33,8.471,2.852,15.521,10.477,18.452\n\t\t\t\tc0.483,0.186,4.362,1.782,1.039,0.362c1.132,0.484,2.245,1.009,3.357,1.537c2.189,1.038,4.315,2.205,6.414,3.42\n\t\t\t\tc2.063,1.193,4.045,2.521,5.992,3.893c3.251,2.291-2.38-1.963,0.711,0.52c0.916,0.735,1.795,1.516,2.674,2.295\n\t\t\t\tc1.756,1.557,3.393,3.243,4.981,4.969c0.798,0.867,1.551,1.773,2.302,2.681c-2.328-2.808,0.165,0.249,0.519,0.741\n\t\t\t\tc1.405,1.959,2.651,4.025,3.842,6.119c0.607,1.067,1.158,2.168,1.708,3.266c0.229,0.454,1.9,4.251,0.538,0.99\n\t\t\t\tc2.05,4.906,3.446,10.063,4.508,15.266c0.283,1.389,0.504,2.788,0.725,4.188c-0.509-3.229,0.143,1.594,0.167,1.834\n\t\t\t\tc0.306,3.074,0.417,6.164,0.476,9.252c0.184,9.642,0.175,19.322,0.021,28.964c-0.053,3.19-0.173,6.38-0.467,9.558\n\t\t\t\tc-0.349,3.749,0.744-4.033-0.069,0.299c-0.19,1.014-0.459,2.01-0.776,2.99c-0.953,2.941,2.083-3.918,0.244-0.824\n\t\t\t\tc-1.436,2.414,3.116-3.258,0.625-0.992c3.557-3.233,3.016-2.215,1.823-1.47c-1.021,0.64-3.17,1.407,2.188-0.829\n\t\t\t\tc-0.788,0.328-1.629,0.521-2.463,0.688c-2.259,0.452,4.454-0.519,2.082-0.278c-0.523,0.055-1.052,0.074-1.577,0.098\n\t\t\t\tc-1.186,0.054-2.374,0.019-3.559-0.024c-2.968-0.108-5.929-0.438-8.878-0.767c-8.669-0.971,9.049,9.275,0.373,8.371\n\t\t\t\tc-8.147-0.849-7.659-2.718-7.659,4.816c-0.002,8.814-8.132,7.968-0.002,8.814L508.758,319.17z"
	    }
	  })])]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
	    attrs: {
	      "fill": "#010101",
	      "d": "M422.868,228.713c25.169-0.222,49.815-10.115,67.096-28.637c18.081-19.38,24.648-45.07,20.811-70.931\n\t\t\t\tc-3.609-24.314-20.015-45.709-40.561-58.436c-11.134-6.897-23.81-10.694-36.726-12.249c-11.153-1.343-24.229-1.457-34.823,2.698\n\t\t\t\tc-6.007,2.356-11.187,5.542-16.382,9.334c-6.592,4.81-9.831,12.928-5.383,20.523c3.817,6.516,13.904,10.212,20.522,5.381\n\t\t\t\tc3.772-2.753,7.588-5.416,11.829-7.404c-3.618,1.696-0.487,0.312,0.342,0.049c1.021-0.322,2.07-0.54,3.115-0.759\n\t\t\t\tc3.75-0.79-3.447,0.312,0.643-0.103c1.328-0.135,2.664-0.188,3.997-0.25c12.144-0.563,17.647-0.029,29.351,4.335\n\t\t\t\tc1.622,0.647,1.667,0.657,0.134,0.029c1.224,0.533,2.416,1.132,3.608,1.73c2.369,1.189,4.639,2.566,6.864,4.001\n\t\t\t\tc1.107,0.714,2.177,1.486,3.243,2.258c-2.659-1.923,0.774,0.664,1.077,0.917c2.006,1.681,3.872,3.52,5.686,5.405\n\t\t\t\tc0.602,0.625,4.603,5.388,2.71,2.935c1.595,2.066,3.016,4.259,4.373,6.486c1.36,2.235,2.533,4.579,3.637,6.949\n\t\t\t\tc-1.427-3.066,0.323,0.873,0.478,1.282c0.465,1.237,0.859,2.499,1.253,3.759c0.661,2.12,1.157,4.287,1.611,6.458\n\t\t\t\tc0.092,0.438,0.756,4.833,0.307,1.334c0.175,1.353,0.269,2.713,0.361,4.073c0.189,2.75,0.137,5.512-0.003,8.262\n\t\t\t\tc-0.068,1.356-0.219,2.707-0.369,4.055c0.394-3.515-0.235,0.834-0.325,1.297c-0.42,2.161-1.012,4.284-1.645,6.391\n\t\t\t\tc-0.377,1.252-0.828,2.481-1.278,3.709c-1.48,4.039,1.272-2.692-0.516,1.205c-1.079,2.353-2.361,4.607-3.703,6.818\n\t\t\t\tc-0.671,1.104-1.402,2.168-2.134,3.232c-2.415,3.512,1.895-2.245-0.777,1.078c-2.982,3.71-6.436,7.019-10.089,10.057\n\t\t\t\tc-3.311,2.751,2.377-1.702-1.13,0.814c-1.067,0.766-2.176,1.475-3.281,2.183c-2.231,1.428-4.571,2.676-6.938,3.86\n\t\t\t\tc-0.335,0.167-4.362,1.943-1.297,0.668c-1.242,0.517-2.513,0.969-3.78,1.42c-2.565,0.913-5.199,1.621-7.846,2.259\n\t\t\t\tc-1.34,0.324-2.694,0.576-4.049,0.829c-4.485,0.837,3.039-0.28-1.526,0.244c-2.817,0.323-5.654,0.422-8.487,0.447\n\t\t\t\tc-8.176,0.072-15,6.769-15,15C407.868,221.835,414.69,228.785,422.868,228.713L422.868,228.713z"
	    }
	  })])])]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
	    attrs: {
	      "fill": "#010101",
	      "d": "M429.415,230.646c2.782,0.022,5.545,0.162,8.315,0.42c4.506,0.418-3.013-0.519,1.426,0.197\n\t\t\tc1.336,0.217,2.659,0.498,3.981,0.78c2.62,0.56,5.194,1.313,7.743,2.129c1.266,0.404,2.509,0.871,3.752,1.338\n\t\t\tc1.614,0.647,1.642,0.648,0.08,0.003c0.804,0.354,1.602,0.723,2.393,1.104c4.736,2.235,9.188,5.038,13.4,8.138\n\t\t\tc-2.677-1.97,0.726,0.646,1.034,0.905c0.997,0.836,1.954,1.72,2.91,2.603c2.229,2.062,4.294,4.295,6.281,6.59\n\t\t\tc0.26,0.299,2.922,3.686,0.904,1.033c0.79,1.038,1.529,2.113,2.269,3.188c1.481,2.157,2.808,4.418,4.074,6.706\n\t\t\tc0.637,1.148,1.217,2.328,1.796,3.507c0.179,0.362,1.91,4.358,0.622,1.239c1.186,2.871,2.134,5.832,2.98,8.815\n\t\t\tc0.736,2.595,1.277,5.24,1.751,7.894c0.791,4.426-0.297-3.072,0.198,1.426c0.15,1.373,0.231,2.752,0.313,4.13\n\t\t\tc0.164,2.788,0.117,5.583,0,8.371c-0.059,1.38-0.187,2.756-0.313,4.131c-0.207,1.79-0.201,1.817,0.019,0.082\n\t\t\tc-0.137,0.896-0.288,1.788-0.455,2.678c-0.94,5.27-2.533,10.402-4.493,15.374c1.233-3.132-0.446,0.868-0.622,1.241\n\t\t\tc-0.562,1.188-1.18,2.348-1.796,3.507c-1.437,2.694-3.086,5.269-4.813,7.781c-0.224,0.326-2.835,3.759-0.776,1.139\n\t\t\tc-0.805,1.024-1.656,2.01-2.51,2.992c-1.704,1.968-3.547,3.812-5.429,5.605c-0.942,0.897-1.927,1.751-2.91,2.603\n\t\t\tc-0.3,0.26-3.686,2.922-1.034,0.905c-2.427,1.846-4.996,3.493-7.611,5.054c-2.257,1.346-4.605,2.525-6.979,3.646\n\t\t\tc-3.938,1.857,2.782-1.059-1.281,0.545c-1.234,0.486-2.494,0.913-3.752,1.338c-2.537,0.858-5.135,1.526-7.743,2.129\n\t\t\tc-1.317,0.305-2.65,0.543-3.981,0.78c-1.771,0.271-1.79,0.288-0.063,0.048c-0.91,0.107-1.82,0.201-2.733,0.277\n\t\t\tc-5.531,0.516-11.111,0.329-16.625-0.277c3.459,0.381-0.974-0.211-1.396-0.286c-1.329-0.237-2.645-0.541-3.959-0.845\n\t\t\tc-3.036-0.701-6.01-1.651-8.941-2.698c-0.829-0.304-1.653-0.621-2.473-0.951c3.132,1.234-0.868-0.446-1.241-0.622\n\t\t\tc-1.979-0.934-3.894-1.994-5.788-3.084c-1.89-1.086-3.705-2.292-5.5-3.524c-0.713-0.498-1.416-1.009-2.112-1.528\n\t\t\tc2.677,1.969-0.726-0.646-1.034-0.905c-3.325-2.789-6.354-5.915-9.191-9.191c-0.563-0.659-1.115-1.329-1.656-2.009\n\t\t\tc2.096,2.581-0.543-0.81-0.776-1.139c-1.263-1.775-2.41-3.63-3.524-5.499c-1.121-1.879-2.119-3.827-3.084-5.789\n\t\t\tc-0.383-0.792-0.75-1.589-1.105-2.392c1.39,3.071-0.324-0.938-0.469-1.322c-1.569-4.182-2.685-8.521-3.543-12.901\n\t\t\tc-0.166-0.89-0.317-1.781-0.455-2.678c0.558,3.448-0.068-1.031-0.108-1.453c-0.215-2.309-0.272-4.628-0.292-6.945\n\t\t\ts0.116-4.635,0.292-6.944c0.077-0.913,0.17-1.824,0.278-2.734c-0.381,3.459,0.211-0.973,0.285-1.396\n\t\t\tc0.785-4.397,2.043-8.698,3.543-12.9c0.305-0.829,0.621-1.652,0.951-2.473c-1.233,3.133,0.446-0.868,0.623-1.24\n\t\t\tc0.934-1.979,1.994-3.895,3.084-5.789c1.086-1.889,2.291-3.705,3.524-5.5c0.498-0.712,1.008-1.416,1.528-2.111\n\t\t\tc-1.971,2.676,0.646-0.726,0.904-1.035c2.789-3.324,5.916-6.354,9.191-9.19c0.66-0.563,1.33-1.115,2.008-1.657\n\t\t\tc-2.58,2.096,0.811-0.543,1.141-0.775c1.774-1.264,3.629-2.41,5.498-3.525c1.88-1.121,3.827-2.119,5.79-3.084\n\t\t\tc0.79-0.382,1.588-0.75,2.392-1.105c-3.073,1.391,0.938-0.324,1.321-0.468c4.183-1.569,8.521-2.685,12.9-3.543\n\t\t\tc0.891-0.167,1.782-0.317,2.679-0.455c-3.448,0.558,1.031-0.069,1.452-0.108C424.778,230.725,427.098,230.666,429.415,230.646\n\t\t\tc8.176-0.069,15-6.771,15-15c0-8.125-6.822-15.069-15-15c-25.17,0.211-48.987,9.947-67.19,27.303\n\t\t\tc-18.07,17.229-28.051,41.486-29.096,66.232c-1.061,25.104,8.889,49.545,25.477,68.091c16.649,18.614,40.62,28.979,65.241,30.853\n\t\t\tc25.189,1.916,49.81-7.596,68.908-23.615c19.163-16.072,29.878-39.723,32.573-64.215c2.78-25.26-6.288-50.003-21.727-69.646\n\t\t\tc-15.312-19.482-38.888-31.176-63.15-34.26c-3.671-0.466-7.336-0.711-11.036-0.742c-8.178-0.068-15,6.875-15,15\n\t\t\tC414.415,223.875,421.239,230.577,429.415,230.646z"
	    }
	  })])]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
	    attrs: {
	      "fill": "#010101",
	      "d": "M422.474,327.821c0.144-2.869-1.204,2.213,0.331-0.791c2.822-5.522,10.64-4.278,14.464-1.146\n\t\t\tc0.751,0.614,1.796,4.146,0.967,0.936c0.294,1.14,0.238,1.332,0.238,0.917c0-1.426,0-2.85,0-4.273c0-6.78,0-13.561,0-20.341\n\t\t\tc0-12.183,0-24.364,0-36.546c0-0.375,0.017-0.771-0.238,0.917c0.445-2.949-0.104-0.026-0.967,0.935\n\t\t\tc-3.822,4.26-11.454,3.295-14.464-1.146c-1.671-2.466-0.207,1.694-0.331-0.791c0.056,1.104,0,2.224,0,3.327\n\t\t\tc0,6.474,0,12.945,0,19.42c0,12.748,0,25.498,0,38.247C422.474,327.596,422.474,327.709,422.474,327.821c0,19.346,30,19.346,30,0\n\t\t\tc0-11.553,0-23.104,0-34.656c0-7.056,0-14.11,0-21.167c0-7.277-0.17-14.553-4.456-20.879c-5.159-7.618-14.486-11.979-23.553-8.99\n\t\t\tc-9.765,3.221-15.422,12.905-15.915,22.833c-0.196,3.948-0.076,7.919-0.076,11.871c0,14.954,0,29.909,0,44.863\n\t\t\tc0,7.481,0.037,14.973,4.456,21.495c5.938,8.765,17.468,12.92,27.137,7.479c8.397-4.727,11.948-13.626,12.407-22.849\n\t\t\tc0.406-8.173-7.131-15-15-15C428.989,312.821,422.88,319.657,422.474,327.821z"
	    }
	  })])]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
	    attrs: {
	      "fill": "#010101",
	      "d": "M399.808,289.154c2.87,0.143-2.212-1.205,0.792,0.33c5.522,2.822,4.278,10.64,1.146,14.465\n\t\t\tc-0.614,0.751-4.147,1.795-0.936,0.966c-1.141,0.294-1.334,0.239-0.918,0.239c1.426,0,2.85,0,4.273,0c6.78,0,13.561,0,20.341,0\n\t\t\tc12.183,0,24.364,0,36.546,0c0.375,0,0.771,0.016-0.917-0.239c2.949,0.446,0.026-0.103-0.935-0.966\n\t\t\tc-4.259-3.823-3.295-11.455,1.146-14.465c2.467-1.67-1.694-0.207,0.791-0.33c-1.104,0.055-2.224,0-3.328,0\n\t\t\tc-6.473,0-12.944,0-19.419,0c-12.749,0-25.498,0-38.247,0C400.033,289.154,399.92,289.154,399.808,289.154\n\t\t\tc-19.346,0-19.346,30,0,30c11.553,0,23.104,0,34.656,0c7.056,0,14.111,0,21.167,0c7.278,0,14.553-0.17,20.879-4.456\n\t\t\tc7.618-5.16,11.979-14.487,8.99-23.554c-3.22-9.765-12.905-15.422-22.833-15.914c-3.948-0.196-7.919-0.076-11.871-0.076\n\t\t\tc-14.954,0-29.909,0-44.863,0c-7.481,0-14.973,0.037-21.493,4.455c-8.766,5.938-12.92,17.467-7.479,27.137\n\t\t\tc4.726,8.397,13.625,11.949,22.848,12.408c8.174,0.405,15-7.131,15-15C414.808,295.67,407.972,289.561,399.808,289.154z"
	    }
	  })])])])
	},staticRenderFns: []}

/***/ }),
/* 837 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(_vm.fetchingStatus === 'fetching') ? _c('loader-large') : _vm._e(), _vm._v(" "), (_vm.postData && _vm.fetchingStatus === 'fetched') ? _c('feed-status-post', {
	    key: _vm.postData.id,
	    attrs: {
	      "data": _vm.postData
	    }
	  }) : _vm._e(), _vm._v(" "), (!_vm.postData && _vm.fetchingStatus === 'fetched') ? _c('div', {
	    staticClass: "validation-messages error"
	  }, [_vm._v("This post doesn't exist")]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 838 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('article', {
	    attrs: {
	      "id": "classifieds-new"
	    }
	  }, [_c('div', {
	    staticClass: "new-post-form"
	  }, [(!_vm.isFetching) ? [(_vm.fetchErrors.length === 0) ? [_c('h1', [_vm._v("Edit Classifieds Post")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.postTitle),
	      expression: "postTitle"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "Post Title",
	      "disabled": _vm.isSaving
	    },
	    domProps: {
	      "value": (_vm.postTitle)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.postTitle = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('markdown-editor', {
	    attrs: {
	      "placeholder": "Post Content",
	      "disabled": _vm.isSaving
	    },
	    model: {
	      value: (_vm.postContent),
	      callback: function($$v) {
	        _vm.postContent = $$v
	      },
	      expression: "postContent"
	    }
	  }), _vm._v(" "), _vm._l((_vm.saveErrors), function(error) {
	    return _c('div', {
	      staticClass: "validation-messages error"
	    }, [_vm._v(_vm._s(error))])
	  }), _vm._v(" "), _c('button', {
	    staticClass: "button minor",
	    on: {
	      "click": _vm.cancelPost
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
	    staticClass: "button",
	    on: {
	      "click": _vm.deletePost
	    }
	  }, [_vm._v("Delete")]), _vm._v(" "), _c('button', {
	    staticClass: "button",
	    on: {
	      "click": _vm.submitPost
	    }
	  }, [_vm._v("Submit")])] : _vm._e(), _vm._v(" "), _vm._l((_vm.fetchErrors), function(error) {
	    return _c('div', {
	      staticClass: "validation-messages error"
	    }, [_vm._v(_vm._s(error))])
	  })] : _vm._e(), _vm._v(" "), (_vm.isFetching) ? _c('loader-large') : _vm._e()], 2)])
	},staticRenderFns: []}

/***/ }),
/* 839 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('article', {
	    attrs: {
	      "id": "forgot-password"
	    }
	  }, [_c('form', [(_vm.isSaving) ? _c('saver-large') : _vm._e(), _vm._v(" "), (!_vm.isSaving) ? [_c('h1', [_vm._v("Recover your Password")]), _vm._v(" "), (!_vm.showConfirmation) ? [(_vm.formErrors.length > 0) ? _c('div', {
	    staticClass: "validation-messages error"
	  }, _vm._l((_vm.formErrors), function(error) {
	    return _c('span', [_vm._v(_vm._s(error))])
	  })) : _vm._e(), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.email),
	      expression: "email"
	    }],
	    attrs: {
	      "type": "email",
	      "placeholder": "Email Address"
	    },
	    domProps: {
	      "value": (_vm.email)
	    },
	    on: {
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.email = $event.target.value
	      }, function($event) {
	        _vm.formErrors = []
	      }]
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.sendRecoveryLink($event)
	      }
	    }
	  }, [_vm._v("Send Recovery Link")])] : _vm._e(), _vm._v(" "), (_vm.showConfirmation) ? [_c('p', [_vm._v("An email has been sent to " + _vm._s(_vm.email) + ". Wait a few minutes and check your spam folder.")])] : _vm._e()] : _vm._e()], 2)])
	},staticRenderFns: []}

/***/ }),
/* 840 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.$store.state.developerPageModel.retrievedInformation) ? _c('section', {
	    ref: "echo",
	    attrs: {
	      "id": "developer-companion-content"
	    }
	  }, [_c('div', {
	    staticClass: "main-details"
	  }, [_c('div', {
	    staticClass: "avatar-container"
	  }, [_c('avatar', {
	    attrs: {
	      "profile-data": _vm.developer,
	      "profile-type": "developer",
	      "size": "super-large",
	      "show-xp-info": true
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "details-container"
	  }, [(_vm.developer.siteModCanBan || _vm.developer.donatedAmount > 0 || _vm.developer.isBanned) ? _c('div', {
	    staticClass: "special-developer-banners"
	  }, [(_vm.developer.siteModCanBan) ? _c('div', {
	    staticClass: "special-developer-banner"
	  }, [_c('i', {
	    staticClass: "fas fa-crown mod-icon"
	  }), _vm._v(" Site Moderator\n                ")]) : _vm._e(), _vm._v(" "), (_vm.developer.donatedAmount > 0 && _vm.developer.donatedAmount < 40) ? _c('div', {
	    staticClass: "special-developer-banner"
	  }, [_c('i', {
	    staticClass: "fas fa-heartbeat donor-icon"
	  }), _vm._v(" Develteam Supporter\n                ")]) : _vm._e(), _vm._v(" "), (_vm.developer.donatedAmount >= 40) ? _c('div', {
	    staticClass: "special-developer-banner"
	  }, [_c('i', {
	    staticClass: "fas fa-heartbeat donor-icon  gold"
	  }), _vm._v(" Develteam Supporter\n                ")]) : _vm._e(), _vm._v(" "), (_vm.developer.isBanned) ? _c('div', {
	    staticClass: "special-developer-banner"
	  }, [_c('i', {
	    staticClass: "fas fa-skull banned-icon"
	  }), _vm._v(" BANNED\n                ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('h1', {
	    staticClass: "dev-alias"
	  }, [_c('i', {
	    class: [{
	      'fas fa-user': true,
	      'online': _vm.developerIsOnline
	    }]
	  }), _vm._v(_vm._s(_vm.developer.alias) + "\n            ")]), _vm._v(" "), (_vm.developerIsOnline) ? _c('div', {
	    staticClass: "last-online"
	  }, [_c('i', {
	    staticClass: "fa fa-circle online"
	  }), _vm._v(" Online")]) : _vm._e(), _vm._v(" "), (!_vm.developerIsOnline) ? _c('div', {
	    staticClass: "last-online"
	  }, [_c('i', {
	    staticClass: "fa fa-circle"
	  }), _vm._v(" Offline (" + _vm._s(_vm._f("formatDate")(_vm.developer.lastOnline)) + ")")]) : _vm._e(), _vm._v(" "), (_vm.showBasicInfo) ? _c('ul', {
	    staticClass: "basic-info"
	  }, [(_vm.developerFullName !== '') ? _c('li', [_vm._v(_vm._s(_vm.developerFullName))]) : _vm._e(), _vm._v(" "), (_vm.developerBasicDetails !== '') ? _c('li', [_vm._v(_vm._s(_vm.developerBasicDetails))]) : _vm._e(), _vm._v(" "), (_vm.developer.location) ? _c('li', [_vm._v(_vm._s(_vm.developer.location))]) : _vm._e(), _vm._v(" "), (_vm.developer.role) ? _c('li', [_vm._v(_vm._s(_vm.developer.role))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showContactOptions) ? _c('div', {
	    staticClass: "connect-options"
	  }, [_c('span', {
	    on: {
	      "click": _vm.sendMail
	    }
	  }, [_c('i', {
	    staticClass: "far fa-envelope"
	  }), _vm._v(" Mail")]), _vm._v(" "), _c('span', {
	    on: {
	      "click": _vm.openConversation
	    }
	  }, [_c('i', {
	    staticClass: "far fa-comment-alt"
	  }), _vm._v(" Chat")]), _vm._v(" "), (_vm.showInviteOption) ? _c('span', {
	    on: {
	      "click": _vm.sendInvite
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-gamepad"
	  }), _vm._v(" Invite")]) : _vm._e(), _vm._v(" "), (!_vm.isFollowing && _vm.showFollowOption && !_vm.savingFollowingChange) ? _c('span', {
	    on: {
	      "click": _vm.updateFollowStatus
	    }
	  }, [_c('i', {
	    staticClass: "far fa-paper-plane"
	  }), _vm._v(" Follow")]) : _vm._e(), _vm._v(" "), (_vm.isFollowing && _vm.showFollowOption && !_vm.savingFollowingChange) ? _c('span', {
	    on: {
	      "click": _vm.updateFollowStatus
	    }
	  }, [_c('i', {
	    staticClass: "far fa-times-circle"
	  }), _vm._v(" Un follow")]) : _vm._e(), _vm._v(" "), (_vm.savingFollowingChange) ? _c('span', [_c('i', {
	    staticClass: "fas fa-sync fa-spin"
	  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.developer.lookingForGame) ? _c('div', {
	    staticClass: "wants-to-collab"
	  }, [_c('div', {
	    staticClass: "badge"
	  }, [_vm._v("Wants to join a Game Project")]), _vm._v(" "), (_vm.developer.lookingForDescription) ? _c('div', {
	    staticClass: "description"
	  }, [_c('h3', [_vm._v("What I'm looking for in a team")]), _vm._v("\n                    " + _vm._s(_vm.developer.lookingForDescription) + "\n                ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.showRoleTags && _vm.roleSkillListMode === 'display') ? _c('div', {
	    staticClass: "roles"
	  }, [_c('h3', [_vm._v("\n                    Roles\n                    "), (_vm.isSelf) ? _c('i', {
	    staticClass: "fas fa-pencil-alt edit-icon",
	    on: {
	      "click": function($event) {
	        _vm.toggleEditRolesSkills()
	      }
	    }
	  }) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "role-list"
	  }, [(_vm.developer.isProducer) ? _c('router-link', {
	    staticClass: "role-tag",
	    attrs: {
	      "to": '/Browse/Developers?seekingRole=producers'
	    }
	  }, [_c('span', [_vm._v("Producer")])]) : _vm._e(), _vm._v(" "), (_vm.developer.isDesigner) ? _c('router-link', {
	    staticClass: "role-tag",
	    attrs: {
	      "to": '/Browse/Developers?seekingRole=designers'
	    }
	  }, [_c('span', [_vm._v("Designer")])]) : _vm._e(), _vm._v(" "), (_vm.developer.isArtist) ? _c('router-link', {
	    staticClass: "role-tag",
	    attrs: {
	      "to": '/Browse/Developers?seekingRole=artists'
	    }
	  }, [_c('span', [_vm._v("Artist")])]) : _vm._e(), _vm._v(" "), (_vm.developer.isProgrammer) ? _c('router-link', {
	    staticClass: "role-tag",
	    attrs: {
	      "to": '/Browse/Developers?seekingRole=programmers'
	    }
	  }, [_c('span', [_vm._v("Programmer")])]) : _vm._e(), _vm._v(" "), (_vm.developer.isWriter) ? _c('router-link', {
	    staticClass: "role-tag",
	    attrs: {
	      "to": '/Browse/Developers?seekingRole=writers'
	    }
	  }, [_c('span', [_vm._v("Writer")])]) : _vm._e(), _vm._v(" "), (_vm.developer.isMusician) ? _c('router-link', {
	    staticClass: "role-tag",
	    attrs: {
	      "to": '/Browse/Developers?seekingRole=musicians'
	    }
	  }, [_c('span', [_vm._v("Musician")])]) : _vm._e(), _vm._v(" "), (_vm.developer.isSfxArtist) ? _c('router-link', {
	    staticClass: "role-tag",
	    attrs: {
	      "to": '/Browse/Developers?seekingRole=sfx'
	    }
	  }, [_c('span', [_vm._v("SFX Artist")])]) : _vm._e(), _vm._v(" "), (_vm.developer.isTester) ? _c('router-link', {
	    staticClass: "role-tag",
	    attrs: {
	      "to": '/Browse/Developers?seekingRole=testers'
	    }
	  }, [_c('span', [_vm._v("Tester")])]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.showSkillTags && _vm.roleSkillListMode === 'display') ? _c('div', {
	    staticClass: "skills"
	  }, [_c('h3', [_vm._v("\n                    Skills\n                    "), (_vm.isSelf) ? _c('i', {
	    staticClass: "fas fa-pencil-alt edit-icon",
	    on: {
	      "click": function($event) {
	        _vm.toggleEditRolesSkills()
	      }
	    }
	  }) : _vm._e()]), _vm._v(" "), (_vm.roleSkillListMode === 'display' && _vm.developer.skills) ? _c('div', {
	    staticClass: "skill-list"
	  }, _vm._l((_vm.developer.skills), function(skillId) {
	    return _c('router-link', {
	      staticClass: "skill-tag",
	      attrs: {
	        "to": '/Browse/Developers?seekingSkill=' + skillId
	      }
	    }, [_vm._v("\n                        " + _vm._s(_vm.getSkill(skillId)) + "\n                    ")])
	  })) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.roleSkillListMode === 'edit') ? _c('edit-roles-and-skills', {
	    on: {
	      "doneEditing": function($event) {
	        _vm.roleSkillListMode = 'display'
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.showGames || _vm.isSelf) ? _c('div', {
	    staticClass: "game-projects companion-content-subsection"
	  }, [_c('h3', [_vm._v(_vm._s(_vm.developer.alias) + "'s Game Projects")]), _vm._v(" "), _vm._l((_vm.developer.games), function(game) {
	    return _c('router-link', {
	      staticClass: "avatar-container",
	      attrs: {
	        "to": ("/Game/" + (game.stringUrl))
	      }
	    }, [_c('avatar', {
	      attrs: {
	        "profile-data": game,
	        "profile-type": "game",
	        "size": "large",
	        "show-xp-info": false
	      }
	    }), _vm._v("\n\n                    " + _vm._s(game.alias) + "\n\n                ")], 1)
	  }), _vm._v(" "), (_vm.isSelf) ? _c('router-link', {
	    staticClass: "avatar-container",
	    attrs: {
	      "to": "/CreateNewGameProject"
	    }
	  }, [_c('div', {
	    staticClass: "icon-container"
	  }, [_c('i', {
	    staticClass: "fas fa-fw fa-plus"
	  })]), _vm._v(" "), _c('span', [_vm._v("Create a New Game")])]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.showWebsites) ? _c('div', {
	    staticClass: "websites companion-content-subsection"
	  }, [_c('h3', [_vm._v("\n                    Websites\n                    "), (_vm.isSelf && _vm.websiteListMode === 'display') ? _c('i', {
	    staticClass: "fas fa-pencil-alt edit-icon",
	    on: {
	      "click": function($event) {
	        _vm.toggleEditWebsites()
	      }
	    }
	  }) : _vm._e()]), _vm._v(" "), (_vm.websiteListMode === 'display') ? [_c('ul', {
	    staticClass: "website-list"
	  }, _vm._l((_vm.developer.personalWebsites), function(website) {
	    return _c('li', [_c('a', {
	      attrs: {
	        "href": website.url,
	        "target": "_blank"
	      }
	    }, [_c('i', {
	      class: ['fa-fw', _vm.getLinkIcon(website.url)]
	    }), _vm._v(" " + _vm._s(website.name) + "\n                            ")])])
	  }))] : _vm._e(), _vm._v(" "), (_vm.websiteListMode === 'edit') ? _c('edit-websites', {
	    on: {
	      "doneEditing": function($event) {
	        _vm.websiteListMode = 'display'
	      }
	    }
	  }) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.isSelf || Object.keys(_vm.developer.workHistory || []).length > 0) ? _c('div', {
	    staticClass: "work-history"
	  }, [_c('h3', [_vm._v("\n                    Work History\n                    "), (_vm.isSelf && _vm.workHistoryMode === 'display') ? _c('i', {
	    staticClass: "fas fa-pencil-alt edit-icon",
	    on: {
	      "click": function($event) {
	        _vm.toggleEditWorkHistory()
	      }
	    }
	  }) : _vm._e()]), _vm._v(" "), _vm._l((_vm.developer.workHistory), function(workItem) {
	    return (_vm.workHistoryMode === 'display') ? _c('ul', [_c('li', [_vm._v(_vm._s(workItem.place))]), _vm._v(" "), (workItem.title) ? _c('li', [_vm._v(_vm._s(workItem.title))]) : _vm._e(), _vm._v(" "), (workItem.start) ? _c('li', [_vm._v(_vm._s(workItem.start) + " "), (workItem.end) ? [_vm._v("- " + _vm._s(workItem.end))] : _vm._e()], 2) : _vm._e()]) : _vm._e()
	  }), _vm._v(" "), (_vm.workHistoryMode === 'edit') ? _c('edit-work-history', {
	    on: {
	      "doneEditing": function($event) {
	        _vm.workHistoryMode = 'display'
	      }
	    }
	  }) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.isSelf || Object.keys(_vm.developer.educationHistory || {}).length > 0) ? _c('div', {
	    staticClass: "education-history"
	  }, [_c('h3', [_vm._v("\n                    Education History\n                    "), (_vm.isSelf && _vm.educationMode === 'display') ? _c('i', {
	    staticClass: "fas fa-pencil-alt edit-icon",
	    on: {
	      "click": function($event) {
	        _vm.toggleEditEducation()
	      }
	    }
	  }) : _vm._e()]), _vm._v(" "), _vm._l((_vm.developer.educationHistory), function(educationItem) {
	    return (_vm.educationMode === 'display') ? _c('ul', [_c('li', [_vm._v(_vm._s(educationItem.place))]), _vm._v(" "), (educationItem.title) ? _c('li', [_vm._v(_vm._s(educationItem.title))]) : _vm._e(), _vm._v(" "), (educationItem.start) ? _c('li', [_vm._v(_vm._s(educationItem.start) + " "), (educationItem.end) ? [_vm._v("- " + _vm._s(educationItem.end))] : _vm._e()], 2) : _vm._e()]) : _vm._e()
	  }), _vm._v(" "), (_vm.educationMode === 'edit') ? _c('edit-education-history', {
	    on: {
	      "doneEditing": function($event) {
	        _vm.educationMode = 'display'
	      }
	    }
	  }) : _vm._e()], 2) : _vm._e()], 1), _vm._v(" "), (_vm.isSelf) ? _c('div', {
	    staticClass: "edit-options"
	  }, [(_vm.displayMode === 'normal') ? [_c('div', {
	    staticClass: "upload-avatar"
	  }, [_c('input', {
	    attrs: {
	      "type": "file",
	      "name": "avatar",
	      "accept": "image/jpeg, image/png"
	    },
	    on: {
	      "change": _vm.updateUploadedAvatarName
	    }
	  })]), _vm._v(" "), _c('button', {
	    on: {
	      "click": function($event) {
	        _vm.displayMode = 'editAccountInformation'
	      }
	    }
	  }, [_vm._v("Edit Account Settings")]), _vm._v(" "), _c('button', {
	    on: {
	      "click": function($event) {
	        _vm.displayMode = 'editBasicDetails'
	      }
	    }
	  }, [_vm._v("Edit Bio Details")]), _vm._v(" "), _c('button', {
	    on: {
	      "click": function($event) {
	        _vm.displayMode = 'editNetworking'
	      }
	    }
	  }, [_vm._v("Edit Networking Details")])] : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.displayMode === 'editAccountInformation') ? _c('edit-account-info', {
	    on: {
	      "doneEditing": function($event) {
	        _vm.displayMode = 'normal'
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.displayMode === 'editBasicDetails') ? _c('edit-basic-details', {
	    on: {
	      "doneEditing": function($event) {
	        _vm.displayMode = 'normal'
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.displayMode === 'editNetworking') ? _c('edit-networking', {
	    on: {
	      "doneEditing": function($event) {
	        _vm.displayMode = 'normal'
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.displayMode !== 'banDeveloper') ? [(_vm.canBan && !_vm.developer.isBanned) ? _c('button', {
	    staticClass: "ban-button",
	    on: {
	      "click": function($event) {
	        _vm.displayMode = 'banDeveloper'
	      }
	    }
	  }, [_vm._v("\n                Ban " + _vm._s(_vm.developer.alias) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.canBan && _vm.developer.isBanned) ? _c('button', {
	    staticClass: "ban-button",
	    on: {
	      "click": function($event) {
	        _vm.displayMode = 'banDeveloper'
	      }
	    }
	  }, [_vm._v("\n                Un-Ban " + _vm._s(_vm.developer.alias) + "\n            ")]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.displayMode === 'banDeveloper') ? _c('ban-developer', {
	    on: {
	      "doneEditing": function($event) {
	        _vm.displayMode = 'normal'
	      }
	    }
	  }) : _vm._e()], 2)]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 841 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('svg', {
	    staticClass: "dt-icon icon-chat-bubble",
	    attrs: {
	      "version": "1.1",
	      "id": "Layer_1",
	      "xmlns": "http://www.w3.org/2000/svg",
	      "xmlns:xlink": "http://www.w3.org/1999/xlink",
	      "x": "0px",
	      "y": "0px",
	      "width": "600px",
	      "height": "400px",
	      "viewBox": "0 0 600 400",
	      "enable-background": "new 0 0 600 400",
	      "xml:space": "preserve"
	    }
	  }, [_c('g', [_c('title', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('rect', {
	    staticStyle: {
	      "fill": "white",
	      "stroke": "1px red solid"
	    },
	    attrs: {
	      "x": "0",
	      "y": "0",
	      "width": "600",
	      "height": "400"
	    }
	  })]), _vm._v(" "), _c('g', [_c('g', [_c('g', [_c('path', {
	    attrs: {
	      "fill": "#010101",
	      "d": "M233.793,200.469c-0.26,9.639-7.646,17.038-17.288,17.299c-9.648,0.261-17.061-8.037-17.311-17.299\n\t\t\t\tc-0.26-9.651,8.053-17.051,17.311-17.301C226.146,182.908,233.543,191.22,233.793,200.469c0.261,9.653,15.261,9.679,15,0\n\t\t\t\tc-0.483-17.908-14.376-31.817-32.288-32.301c-17.913-0.484-31.847,15.108-32.311,32.301\n\t\t\t\tc-0.483,17.916,15.122,31.835,32.311,32.299c17.906,0.482,31.824-15.119,32.288-32.299\n\t\t\t\tC249.054,190.79,234.054,190.815,233.793,200.469z"
	    }
	  })])]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
	    attrs: {
	      "fill": "#010101",
	      "d": "M318.018,200.469c-0.26,9.638-7.646,17.038-17.287,17.299c-9.648,0.261-17.063-8.036-17.313-17.299\n\t\t\t\tc-0.261-9.652,8.055-17.051,17.313-17.301C310.371,182.908,317.768,191.222,318.018,200.469c0.261,9.653,15.262,9.679,15,0\n\t\t\t\tc-0.483-17.907-14.377-31.817-32.287-32.301c-17.913-0.484-31.85,15.108-32.313,32.301\n\t\t\t\tc-0.483,17.916,15.125,31.835,32.313,32.299c17.905,0.482,31.823-15.12,32.287-32.299\n\t\t\t\tC333.279,190.79,318.278,190.815,318.018,200.469z"
	    }
	  })])]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
	    attrs: {
	      "fill": "#010101",
	      "d": "M402.218,200.469c-0.26,9.65-7.64,17.039-17.288,17.299s-17.04-8.042-17.289-17.299\n\t\t\t\tc-0.26-9.65,8.028-17.051,17.289-17.301C394.578,182.908,401.969,191.212,402.218,200.469c0.26,9.653,15.261,9.679,15,0\n\t\t\t\tc-0.482-17.913-14.369-31.817-32.288-32.301c-17.913-0.483-31.826,15.114-32.289,32.301\n\t\t\t\tc-0.482,17.908,15.099,31.835,32.289,32.299c17.913,0.483,31.825-15.112,32.288-32.299\n\t\t\t\tC417.479,190.79,402.478,190.815,402.218,200.469z"
	    }
	  })])])]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
	    attrs: {
	      "fill": "#010101",
	      "d": "M538,202c-0.021,4.699-0.27,9.379-0.748,14.054c-0.073,0.71-0.598,4.655-0.041,0.632\n\t\t\tc-0.159,1.15-0.349,2.296-0.538,3.441c-0.44,2.668-0.997,5.315-1.6,7.95c-1.031,4.517-2.354,8.963-3.84,13.349\n\t\t\tc-0.745,2.2-1.572,4.371-2.425,6.53c-1.451,3.675,1.285-2.917-0.287,0.714c-0.619,1.429-1.278,2.841-1.942,4.249\n\t\t\tc-4.221,8.948-9.439,17.404-15.261,25.394c-0.315,0.433-2.771,3.666-0.574,0.825c-0.744,0.963-1.509,1.91-2.273,2.856\n\t\t\tc-1.54,1.908-3.139,3.768-4.756,5.61c-3.561,4.058-7.34,7.921-11.232,11.659c-3.676,3.529-7.519,6.88-11.447,10.123\n\t\t\tc-0.995,0.822-2.006,1.626-3.017,2.43c-3.371,2.684,2.37-1.782-1.079,0.83c-2.442,1.85-4.938,3.626-7.454,5.374\n\t\t\tc-9.253,6.43-19.024,12.094-29.073,17.181c-4.987,2.524-10.074,4.847-15.211,7.052c2.864-1.229-1.453,0.574-1.653,0.655\n\t\t\tc-1.321,0.535-2.651,1.05-3.98,1.564c-3.129,1.212-6.288,2.343-9.458,3.441c-11.627,4.032-23.535,7.228-35.567,9.791\n\t\t\tc-5.95,1.268-11.946,2.316-17.96,3.234c-0.066,0.011-5.063,0.714-2.112,0.321c-1.535,0.204-3.073,0.386-4.61,0.567\n\t\t\tc-3.616,0.429-7.242,0.769-10.87,1.074c-13.653,1.15-27.33,1.127-41.021,1.079c-12.136-0.043-24.286-0.194-36.39-1.139\n\t\t\tc-2.515-0.196-5.025-0.454-7.532-0.74c-4.14-0.472,3.213,0.479-0.868-0.101c-1.194-0.17-2.383-0.365-3.573-0.562\n\t\t\tc-5.086-0.84-10.112-2.001-15.074-3.392c-4.714-1.321-9.333-2.965-13.881-4.771c-3.95-1.569,2.808,1.241-1.16-0.486\n\t\t\tc-1.215-0.529-2.418-1.087-3.621-1.644c-2.951-1.367-5.849-2.845-8.729-4.354c-7.097-3.719-12.866-7.4-21.133-6.956\n\t\t\tc-14.245,0.766-28.559,4.737-42.364,8.059c-16.632,4.001-33.19,8.32-49.887,12.053c-6.532,1.46-13.097,2.841-19.725,3.789\n\t\t\tc6.043-0.865-1.358,0.074-3.159,0.116c-0.795,0.019-1.589-0.013-2.38-0.087c5.566,0.521,4.077,0.629,2.759,0.326\n\t\t\tc-2.24-0.516,3.945,1.921,2.479,1.068c3.442,2.002,5.007,4.883,5.592,6.896c-0.742-2.556,0.263,4.945,0.268,1.234\n\t\t\tc0.001-1.442,0.661-5.508-0.198,0.369c0.215-1.473,0.537-2.93,0.873-4.379c1.595-6.893,3.995-13.613,6.381-20.263\n\t\t\tc5.6-15.605,12.021-30.914,17.296-46.637c2.257-6.728,3.905-13.324,4.825-20.361c1.275-9.753-4.6-15.725-10.322-22.741\n\t\t\tc-3.05-3.74,1.569,2.16-1.159-1.497c-0.789-1.058-1.539-2.144-2.287-3.231c-1.361-1.979-2.598-4.04-3.769-6.136\n\t\t\tc-0.577-1.032-3.297-7.275-1.686-3.245c-0.878-2.196-1.54-4.473-2.114-6.766c-0.287-1.146-1.319-7.684-0.713-3.025\n\t\t\tc-0.278-2.138-0.424-4.292-0.549-6.443c-0.314-5.421-0.246-10.866-0.217-16.293c0.03-5.51-0.043-11.027,0.178-16.533\n\t\t\tc0.094-2.339,0.281-4.673,0.499-7.003c0.109-1.16,0.248-2.317,0.387-3.474c-0.505,4.198,0.18-0.972,0.311-1.76\n\t\t\tc1.575-9.533,4.318-18.85,7.864-27.829c1.451-3.674-1.285,2.917,0.287-0.714c0.464-1.071,0.954-2.131,1.443-3.191\n\t\t\tc0.983-2.128,2.043-4.221,3.125-6.301c2.372-4.554,5.026-8.957,7.834-13.254c1.313-2.008,2.691-3.973,4.09-5.922\n\t\t\tc0.704-0.981,1.429-1.947,2.154-2.913c-2.158,2.875,0.305-0.376,0.638-0.795c3.321-4.175,6.875-8.161,10.55-12.026\n\t\t\tc3.467-3.646,7.114-7.119,10.851-10.487c1.899-1.711,3.847-3.37,5.808-5.009c0.989-0.827,1.993-1.635,2.997-2.444\n\t\t\tc0.674-0.54,1.351-1.075,2.031-1.606c-1.324,1.02-1.304,1.011,0.061-0.029c8.868-6.716,18.293-12.68,28.017-18.073\n\t\t\tc4.829-2.678,9.765-5.156,14.755-7.518c2.535-1.2,5.098-2.339,7.669-3.458c4.265-1.857-2.686,1.096,1.634-0.679\n\t\t\tc1.757-0.722,3.526-1.412,5.297-2.098c11.345-4.392,23.001-7.957,34.801-10.897c25.527-6.361,47.337-8.691,74.375-8.626\n\t\t\tc13.146,0.032,26.283,0.932,39.327,2.539c5.031,0.62-2.873-0.422,2.127,0.292c1.519,0.217,3.034,0.456,4.549,0.695\n\t\t\tc3.01,0.475,6.009,1.015,9.003,1.577c6.392,1.2,12.735,2.646,19.036,4.249c10.829,2.755,21.479,6.191,31.917,10.171\n\t\t\tc1.332,0.508,2.656,1.036,3.98,1.564c0.2,0.08,4.524,1.871,1.653,0.656c2.588,1.095,5.149,2.25,7.702,3.425\n\t\t\tc5.023,2.313,9.955,4.822,14.82,7.452c9.421,5.092,18.471,10.858,27.118,17.17c1.055,0.77,2.096,1.558,3.136,2.346\n\t\t\tc-2.665-2.019,0.743,0.601,1.054,0.848c2.012,1.601,3.979,3.255,5.932,4.928c3.841,3.292,7.528,6.76,11.108,10.333\n\t\t\tc3.506,3.5,6.841,7.167,10.057,10.934c1.584,1.856,3.11,3.76,4.616,5.679c-2.216-2.824,0.255,0.394,0.574,0.825\n\t\t\tc0.716,0.968,1.411,1.951,2.106,2.935c5.465,7.732,10.174,15.985,14.144,24.578c0.489,1.059,0.953,2.13,1.416,3.2\n\t\t\tc-1.516-3.5,0.017,0.131,0.251,0.725c0.853,2.159,1.626,4.349,2.37,6.547c1.485,4.388,2.694,8.865,3.726,13.379\n\t\t\tc0.517,2.26,0.944,4.539,1.342,6.822c0.199,1.144,0.369,2.293,0.538,3.442c-0.592-4.015-0.039-0.081,0.041,0.632\n\t\t\tC537.771,192.612,537.979,197.308,538,202c0.086,19.342,30.086,19.35,30,0c-0.422-94.833-86.903-158.935-170.938-181.199\n\t\t\tc-95.827-25.389-210.554-7.742-284.92,60.992C80.77,110.789,59.58,149.725,56.334,192.6c-0.823,10.875-0.586,22.004-0.303,32.901\n\t\t\tc0.251,9.667,1.363,19.577,4.973,28.609c4.708,11.78,12.047,21.651,20.292,31.225c3.566,4.141-1.771-2.927-0.819-1.123\n\t\t\tc-2.17-4.115-1.472-3.9-1.154-2.429c-1.208-5.597-0.33-3.131-0.419-1.219c-0.188,4.008,0.679-3.819,0.063-0.356\n\t\t\tc-0.262,1.478-0.62,2.938-0.989,4.39c-3.839,15.104-10.183,29.642-15.703,44.179c-5.276,13.898-11.202,28.133-12.608,43.064\n\t\t\tc-0.68,7.222,2.365,16.083,9.307,19.428c5.512,2.656,11.216,2.875,17.176,2.179c15.54-1.816,30.787-5.671,45.96-9.375\n\t\t\tc16.279-3.974,32.505-8.208,48.899-11.691c3.106-0.66,6.223-1.273,9.351-1.824c1.342-0.235,2.688-0.448,4.036-0.646\n\t\t\tc2.654-0.391-4.134,0.527-1.569,0.218c0.727-0.088,1.455-0.157,2.184-0.22c2.152-0.188,8.128,0.578,1.297-0.496\n\t\t\tc3.045,0.479-5.414-2.904-0.841-0.295c2.986,1.703,6.018,3.324,9.073,4.899c20.448,10.546,41.644,16.434,64.492,18.605\n\t\t\tc25.272,2.403,51.525,2.285,76.826,0.521c90.71-6.327,192.428-52.137,224.306-143.742c5.263-15.124,7.767-31.411,7.838-47.401\n\t\t\tC568.086,182.65,538.086,182.659,538,202z"
	    }
	  })])])])
	},staticRenderFns: []}

/***/ }),
/* 842 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('article', {
	    attrs: {
	      "id": "notifications"
	    }
	  }, [_c('h2', [_vm._v("Notifications")]), _vm._v(" "), (_vm.notificationsFetchingStatus !== 'fetched') ? _c('loader-large') : _vm._e(), _vm._v(" "), (_vm.notificationsFetchingStatus === 'fetched') ? [_vm._l((_vm.notifications), function(notification) {
	    return (_vm.notifications.length > 0 && notification.text && notification.link) ? _c('router-link', {
	      class: {
	        new: notification.hasBeenRead === 0
	      },
	      attrs: {
	        "to": notification.link
	      }
	    }, [_c('span', {
	      staticClass: "text"
	    }, [(!notification.hasBeenRead) ? _c('i', {
	      staticClass: "fas fa-bell"
	    }) : _vm._e(), _vm._v(" " + _vm._s(notification.text))]), _vm._v(" "), _c('span', {
	      staticClass: "time-stamp"
	    }, [_vm._v(_vm._s(_vm._f("formatDate")(notification.created)))])]) : _vm._e()
	  }), _vm._v(" "), (_vm.notifications.length === 0) ? _c('span', {
	    staticClass: "no-notifications-message"
	  }, [_vm._v("You don't have any notifications")]) : _vm._e()] : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 843 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    attrs: {
	      "id": "edit-developer-websites"
	    }
	  }, [_c('div', {
	    staticClass: "edit-container"
	  }, [_c('div', {
	    staticClass: "website-list"
	  }, [_vm._l((_vm.formData.personalWebsites), function(website, index) {
	    return _c('div', {
	      staticClass: "set entered"
	    }, [_c('span', [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (website.name),
	        expression: "website.name"
	      }],
	      class: [{
	        invalid: website.name === ''
	      }],
	      attrs: {
	        "type": "text",
	        "placeholder": "Website Name"
	      },
	      domProps: {
	        "value": (website.name)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          website.name = $event.target.value
	        }
	      }
	    })]), _vm._v(" "), _c('span', [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (website.url),
	        expression: "website.url"
	      }],
	      class: [{
	        invalid: !_vm.isValidUrl(website.url)
	      }],
	      attrs: {
	        "type": "text",
	        "placeholder": "Website URL"
	      },
	      domProps: {
	        "value": (website.url)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          website.url = $event.target.value
	        }
	      }
	    })]), _vm._v(" "), _c('button', {
	      staticClass: "button small-button",
	      on: {
	        "click": function($event) {
	          $event.preventDefault();
	          _vm.removePersonalWebsite(index)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa-trash fas"
	    })]), _vm._v(" "), (index > 0) ? _c('button', {
	      staticClass: "button small-button",
	      on: {
	        "click": function($event) {
	          $event.preventDefault();
	          _vm.moveWebsiteUp(index)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa-arrow-up fas"
	    })]) : _vm._e(), _vm._v(" "), (index !== _vm.formData.personalWebsites.length - 1) ? _c('button', {
	      staticClass: "button small-button",
	      on: {
	        "click": function($event) {
	          $event.preventDefault();
	          _vm.moveWebsiteDown(index)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa-arrow-down fas"
	    })]) : _vm._e()])
	  }), _vm._v(" "), _c('div', {
	    staticClass: "set entered"
	  }, [_c('button', {
	    staticClass: "button small-button",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.addAnotherPersonalWebsite($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-plus"
	  })])])], 2), _vm._v(" "), _c('div', {
	    staticClass: "buttons"
	  }, [_c('button', {
	    staticClass: "button minor",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.cancelChanges($event)
	      }
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
	    staticClass: "button",
	    attrs: {
	      "disabled": !_vm.allEntriesAreValid()
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.submitChanges($event)
	      }
	    }
	  }, [_vm._v("Save")])])])])
	},staticRenderFns: []}

/***/ }),
/* 844 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.showModal) ? _c('div', {
	    attrs: {
	      "id": "modal"
	    }
	  }, [_c('div', {
	    staticClass: "wrapper",
	    on: {
	      "click": _vm.closeModal
	    }
	  }, [_c('div', {
	    staticClass: "content",
	    domProps: {
	      "innerHTML": _vm._s(_vm.modalContent)
	    }
	  })])]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 845 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    attrs: {
	      "id": "edit-developer-basic-info"
	    }
	  }, [_c('div', {
	    staticClass: "basic-info edit-container"
	  }, [_c('h1', [_vm._v("Bio Details")]), _vm._v(" "), _c('label', [_vm._v("Name")]), _vm._v(" "), _c('div', {
	    staticClass: "container"
	  }, [_c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formData.firstName),
	      expression: "formData.firstName"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "First Name"
	    },
	    domProps: {
	      "value": (_vm.formData.firstName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.formData.firstName = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formData.lastName),
	      expression: "formData.lastName"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "Last Name"
	    },
	    domProps: {
	      "value": (_vm.formData.lastName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.formData.lastName = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), _c('label', [_vm._v("Gender")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formData.gender),
	      expression: "formData.gender"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.formData.gender = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "nospec"
	    }
	  }, [_vm._v("Prefer not to say")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "male"
	    }
	  }, [_vm._v("Male")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "female"
	    }
	  }, [_vm._v("Female")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "nonbinary"
	    }
	  }, [_vm._v("Nonbinary")])]), _vm._v(" "), _c('label', [_vm._v("Location")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formData.location),
	      expression: "formData.location"
	    }, {
	      name: "gmaps-searchbox",
	      rawName: "v-gmaps-searchbox",
	      value: (_vm.userLocation),
	      expression: "userLocation"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.formData.location)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.formData.location = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('label', [_vm._v("Birthday")]), _vm._v(" "), _c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formData.useBirth),
	      expression: "formData.useBirth"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.formData.useBirth) ? _vm._i(_vm.formData.useBirth, null) > -1 : (_vm.formData.useBirth)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.formData.useBirth,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.formData.useBirth = $$a.concat($$v))
	          } else {
	            $$i > -1 && (_vm.formData.useBirth = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.formData.useBirth = $$c
	        }
	      }
	    }
	  }), _vm._v("Share Age")]), _vm._v(" "), _c('div', {
	    staticClass: "container"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formData.birthMonth),
	      expression: "formData.birthMonth"
	    }],
	    attrs: {
	      "disabled": !_vm.formData.useBirth
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.formData.birthMonth = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "1"
	    }
	  }, [_vm._v("January")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "2"
	    }
	  }, [_vm._v("February")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "3"
	    }
	  }, [_vm._v("March")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "4"
	    }
	  }, [_vm._v("April")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "5"
	    }
	  }, [_vm._v("May")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "6"
	    }
	  }, [_vm._v("June")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "7"
	    }
	  }, [_vm._v("July")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "8"
	    }
	  }, [_vm._v("August")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "9"
	    }
	  }, [_vm._v("September")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "10"
	    }
	  }, [_vm._v("October")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "11"
	    }
	  }, [_vm._v("November")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "12"
	    }
	  }, [_vm._v("December")])]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formData.birthDay),
	      expression: "formData.birthDay"
	    }],
	    attrs: {
	      "disabled": !_vm.formData.useBirth
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.formData.birthDay = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((31), function(n) {
	    return _c('option', {
	      domProps: {
	        "value": n
	      }
	    }, [_vm._v(_vm._s(n))])
	  })), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formData.birthYear),
	      expression: "formData.birthYear"
	    }],
	    attrs: {
	      "disabled": !_vm.formData.useBirth
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.formData.birthYear = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm.birthYears), function(year) {
	    return _c('option', {
	      domProps: {
	        "value": year
	      }
	    }, [_vm._v(_vm._s(year))])
	  }))]), _vm._v(" "), _c('div', {
	    staticClass: "buttons"
	  }, [_c('button', {
	    staticClass: "button minor",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.cancelChanges($event)
	      }
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.submitChanges($event)
	      }
	    }
	  }, [_vm._v("Save")])])])])
	},staticRenderFns: []}

/***/ }),
/* 846 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    attrs: {
	      "id": "recently-on-forums"
	    }
	  }, [_c('h1', [_vm._v("Latest Forum Activity")]), _vm._v(" "), _c('div', {
	    staticClass: "recent-forum-posts"
	  }, _vm._l((_vm.recentForumPosts), function(forumPost) {
	    return _c('div', {
	      staticClass: "recent-forum-post"
	    }, [_c('h2', [(forumPost.gameAlias) ? _c('router-link', {
	      attrs: {
	        "to": ("/Game/" + (forumPost.gameStringUrl) + "/Forums/" + (forumPost.categoryStringUrl) + "/" + (forumPost.forumStringUrl) + "/" + (forumPost.threadStringUrl))
	      }
	    }, [_c('i', {
	      staticClass: "fas fa-gamepad"
	    }), _vm._v(_vm._s(forumPost.gameAlias) + "\n                    "), _vm._v(" "), _c('i', {
	      staticClass: "fa fa-chevron-right"
	    }), _vm._v("\n                    " + _vm._s(forumPost.threadAlias) + "\n                ")]) : _vm._e(), _vm._v(" "), (!forumPost.gameAlias) ? _c('router-link', {
	      attrs: {
	        "to": ("/Forums/" + (forumPost.categoryStringUrl) + "/" + (forumPost.forumStringUrl) + "/" + (forumPost.threadStringUrl))
	      }
	    }, [_vm._v("\n                    Devleteam Site Forums\n                    "), _vm._v(" "), _c('i', {
	      staticClass: "fa fa-chevron-right"
	    }), _vm._v("\n                    " + _vm._s(forumPost.threadAlias) + "\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('span', {
	      staticClass: "posted-by"
	    }, [_c('i', {
	      staticClass: "fa fa-comment-o"
	    }), _vm._v("\n                Posted by "), _c('router-link', {
	      attrs: {
	        "to": ("/Developer/" + (forumPost.posterStringUrl))
	      }
	    }, [_vm._v(_vm._s(forumPost.posterAlias))]), _vm._v(",\n                "), _c('span', [_vm._v(_vm._s(_vm._f("formatDate")(forumPost.postDate)))])], 1)])
	  }))])
	},staticRenderFns: []}

/***/ }),
/* 847 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    attrs: {
	      "id": "conversation-view"
	    }
	  }, [_c('router-link', {
	    staticClass: "return-to-inbox",
	    attrs: {
	      "to": "/Inbox"
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-arrow-circle-left"
	  }), _vm._v(" Back to Inbox\n    ")]), _vm._v(" "), (_vm.notAllowedToViewConversation) ? _c('div', [_c('h1', [_vm._v("You don't have access to this Conversation")])]) : _vm._e(), _vm._v(" "), (!_vm.notAllowedToViewConversation && _vm.conversation) ? _c('div', [_c('h1', [_vm._v(_vm._s(_vm.conversation.subject))]), _vm._v(" "), _c('div', {
	    staticClass: "participants"
	  }, [_vm._v("\n\n            Participants:\n\n            "), _vm._l((_vm.conversation.participants), function(participant) {
	    return _c('span', [_c('router-link', {
	      attrs: {
	        "to": ("/Developer/" + (participant.stringUrl))
	      }
	    }, [_vm._v(_vm._s(participant.alias))])], 1)
	  }), _vm._v(" "), (!_vm.addParticipantFormVisible && !_vm.confirmAddingParticipant) ? _c('a', {
	    staticClass: "add-participant",
	    on: {
	      "click": function($event) {
	        _vm.addParticipantFormVisible = true
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-plus-circle"
	  }), _vm._v(" Add Participant")]) : _vm._e(), _vm._v(" "), (_vm.addParticipantFormVisible) ? _c('form', {
	    attrs: {
	      "autocomplete": "off"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	      }
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.addedParticipantName),
	      expression: "addedParticipantName"
	    }],
	    attrs: {
	      "id": "newParticipant",
	      "type": "text",
	      "placeholder": "Search for a Developer"
	    },
	    domProps: {
	      "value": (_vm.addedParticipantName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.addedParticipantName = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (_vm.addParticipantMessage) ? _c('p', {
	    staticClass: "add-participant-message"
	  }, [_vm._v(_vm._s(_vm.addParticipantMessage))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.matchingDevsResponse), function(dev) {
	    return (_vm.devInAliasList(dev)) ? _c('p', {
	      staticClass: "new-participant",
	      on: {
	        "click": function($event) {
	          _vm.confirmParticipant(dev)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fas fa-plus-circle"
	    }), _vm._v(" " + _vm._s(dev.alias))]) : _vm._e()
	  })], 2) : _vm._e(), _vm._v(" "), (_vm.confirmAddingParticipant) ? _c('div', {
	    staticClass: "confirm-adding-participant"
	  }, [_c('h1', [_vm._v("Confirm to add " + _vm._s(_vm.addedParticipant.alias) + "?")]), _vm._v(" "), _c('form', [_c('input', {
	    attrs: {
	      "type": "submit",
	      "value": "Cancel"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.confirmAddingParticipant = false;
	        _vm.addParticipantFormVisible = true
	      }
	    }
	  }), _vm._v(" "), _c('input', {
	    attrs: {
	      "type": "submit"
	    },
	    domProps: {
	      "value": ("Yes, add " + (_vm.addedParticipant.alias))
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.addParticipant($event)
	      }
	    }
	  })])]) : _vm._e()], 2), _vm._v(" "), (_vm.conversation.messages) ? _c('div', [_c('ul', {
	    attrs: {
	      "id": "conversation-messages"
	    }
	  }, _vm._l((_vm.conversation.messages), function(message) {
	    return _c('li', [_c('div', {
	      staticClass: "avatar-container"
	    }, [_c('avatar', {
	      attrs: {
	        "profile-data": message.from,
	        "profile-type": "developer",
	        "size": "large",
	        "show-xp-info": false
	      }
	    })], 1), _vm._v(" "), _c('div', {
	      staticClass: "message-details"
	    }, [_c('span', {
	      staticClass: "message-from"
	    }, [_c('router-link', {
	      attrs: {
	        "to": '/Developer/' + message.from.stringUrl
	      }
	    }, [_vm._v(_vm._s(message.from.alias))])], 1), _vm._v(" "), _c('span', {
	      staticClass: "message-date"
	    }, [_vm._v(_vm._s(_vm._f("formatDate")(message.timestamp)))]), _vm._v(" "), _c('markdown-content', {
	      attrs: {
	        "classes": "message-message",
	        "content": message.message
	      }
	    })], 1)])
	  })), _vm._v(" "), (!_vm.leaveConversationMode) ? _c('section', {
	    attrs: {
	      "id": "new-reply"
	    }
	  }, [_c('h1', [_vm._v("Add Reply")]), _vm._v(" "), _c('form', [_c('markdown-editor', {
	    attrs: {
	      "placeholder": "Enter a reply"
	    },
	    model: {
	      value: (_vm.newReplyContent),
	      callback: function($$v) {
	        _vm.newReplyContent = $$v
	      },
	      expression: "newReplyContent"
	    }
	  }), _vm._v(" "), _c('input', {
	    attrs: {
	      "type": "submit"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.submitReply($event)
	      }
	    }
	  })], 1), _vm._v(" "), _c('a', {
	    staticClass: "leave-conversation",
	    on: {
	      "click": function($event) {
	        _vm.leaveConversationMode = true
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-trash"
	  }), _vm._v(" Leave Conversation")])]) : _c('section', {
	    attrs: {
	      "id": "leave-conversation-form"
	    }
	  }, [_c('h1', [_vm._v("Are you sure you want to leave this conversation?")]), _vm._v(" "), _c('p', [_vm._v("You will no longer be allowed to view this conversation or participate in it.")]), _vm._v(" "), _c('form', [_c('input', {
	    attrs: {
	      "type": "submit",
	      "value": "Cancel"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.leaveConversationMode = false
	      }
	    }
	  }), _vm._v(" "), _c('input', {
	    attrs: {
	      "type": "submit",
	      "value": "Yes, leave this conversation"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.leaveConversation($event)
	      }
	    }
	  })])])]) : _c('div', [_c('loader-large')], 1)]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 848 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(!_vm.thread) ? _c('loader-large') : _vm._e(), _vm._v(" "), (_vm.thread) ? _c('section', {
	    staticClass: "posts"
	  }, [_c('h2', [_c('router-link', {
	    attrs: {
	      "to": ("/" + _vm.root)
	    }
	  }, [_vm._v(_vm._s(_vm.category.title))]), _vm._v(" "), _c('i', {
	    staticClass: "fas fa-chevron-right"
	  }), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "to": ("/" + _vm.root + "/" + (_vm.category.stringUrl) + "/" + (_vm.forum.stringUrl))
	    }
	  }, [_vm._v(_vm._s(_vm.forum.title))]), _vm._v(" "), _c('i', {
	    staticClass: "fas fa-chevron-right"
	  }), _vm._v(" "), (_vm.thread.locked) ? _c('i', {
	    staticClass: "fas fa-lock"
	  }) : _vm._e(), _vm._v(" "), (_vm.thread.pinned) ? _c('i', {
	    staticClass: "fas fa-thumbtack"
	  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.thread.title) + "\n        ")], 1), _vm._v(" "), ((_vm.isModerator || _vm.isOriginalPoster) && !_vm.editMode && !_vm.deleteMode) ? _c('section', {
	    staticClass: "controls"
	  }, [_c('div', {
	    on: {
	      "click": _vm.enterEditMode
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-pencil-alt"
	  }), _vm._v(" Edit")]), _vm._v(" "), (_vm.isModerator && !_vm.thread.pinned) ? _c('div', {
	    on: {
	      "click": _vm.savePinnedStatus
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-thumbtack"
	  }), _vm._v(" Pin")]) : _vm._e(), _vm._v(" "), (_vm.isModerator && _vm.thread.pinned) ? _c('div', {
	    on: {
	      "click": _vm.savePinnedStatus
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-thumbtack fa-rotate-270"
	  }), _vm._v(" Unpin")]) : _vm._e(), _vm._v(" "), (_vm.isModerator && !_vm.thread.locked) ? _c('div', {
	    on: {
	      "click": _vm.saveLockedStatus
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-lock"
	  }), _vm._v(" Lock")]) : _vm._e(), _vm._v(" "), (_vm.isModerator && _vm.thread.locked) ? _c('div', {
	    on: {
	      "click": _vm.saveLockedStatus
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-unlock"
	  }), _vm._v(" Unlock")]) : _vm._e(), _vm._v(" "), (_vm.isModerator) ? _c('div', {
	    on: {
	      "click": function($event) {
	        _vm.deleteMode = true
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-times"
	  }), _vm._v(" Delete")]) : _vm._e(), _vm._v(" "), (_vm.isModerator) ? _c('div', {
	    on: {
	      "click": function($event) {
	        _vm.moveMode = true
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-long-arrow-alt-right"
	  }), _vm._v(" Move")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.editMode) ? _c('section', {
	    staticClass: "thread-controls-form"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.editThreadTitle),
	      expression: "editThreadTitle"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "Thread Subject"
	    },
	    domProps: {
	      "value": (_vm.editThreadTitle)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.editThreadTitle = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "button minor",
	    on: {
	      "click": function($event) {
	        _vm.editMode = false
	      }
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
	    staticClass: "button",
	    on: {
	      "click": _vm.saveEditThread
	    }
	  }, [_vm._v("Save")])]) : _vm._e(), _vm._v(" "), (_vm.deleteMode) ? _c('section', {
	    staticClass: "thread-controls-form"
	  }, [_c('h3', [_vm._v("Are you sure you want to delete this thread and all the posts in it?")]), _vm._v(" "), _c('button', {
	    staticClass: "button minor",
	    on: {
	      "click": function($event) {
	        _vm.deleteMode = false
	      }
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
	    staticClass: "button",
	    on: {
	      "click": _vm.deleteThread
	    }
	  }, [_vm._v("Delete")])]) : _vm._e(), _vm._v(" "), (_vm.moveMode) ? _c('section', {
	    staticClass: "thread-controls-form"
	  }, [_c('h3', [_vm._v("Move To")]), _vm._v(" "), (_vm.moveToForumErrorMessage) ? _c('div', {
	    staticClass: "validation-messages error"
	  }, [_vm._v(_vm._s(_vm.moveToForumErrorMessage))]) : _vm._e(), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.moveToForumId),
	      expression: "moveToForumId"
	    }],
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.moveToForumId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }, function($event) {
	        _vm.moveToForumErrorMessage = ''
	      }]
	    }
	  }, _vm._l((_vm.moveModeForumsList), function(moveToForum) {
	    return (moveToForum.id !== _vm.forum.id) ? _c('option', {
	      domProps: {
	        "value": moveToForum.id
	      }
	    }, [_vm._v(_vm._s(moveToForum.label))]) : _vm._e()
	  })), _vm._v(" "), _c('button', {
	    staticClass: "button minor",
	    on: {
	      "click": function($event) {
	        _vm.moveMode = false
	      }
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
	    staticClass: "button",
	    on: {
	      "click": _vm.moveThread
	    }
	  }, [_vm._v("Move")])]) : _vm._e(), _vm._v(" "), _c('section', {
	    staticClass: "pagination"
	  }, [_c('label', [_vm._v("page")]), _vm._v(" "), _c('pagination', {
	    attrs: {
	      "max-page": _vm.totalPages,
	      "current-page": _vm.currentPage,
	      "spread": 5
	    },
	    on: {
	      "switchToPage": _vm.switchToResultsPage
	    }
	  })], 1), _vm._v(" "), (_vm.thread.fetchingStatus === 'fetching') ? _c('loader-large') : _vm._e(), _vm._v(" "), _vm._l((_vm.posts), function(post) {
	    return (_vm.thread.fetchingStatus === 'fetched') ? _c('post', {
	      attrs: {
	        "post": post,
	        "board-id": _vm.boardId
	      }
	    }) : _vm._e()
	  }), _vm._v(" "), (!_vm.thread.locked) ? _c('add-post-form', {
	    attrs: {
	      "board-id": _vm.boardId,
	      "category-id": _vm.category.id,
	      "thread-id": _vm.thread.id
	    }
	  }) : _vm._e(), _vm._v(" "), _c('section', {
	    staticClass: "pagination"
	  }, [_c('label', [_vm._v("page")]), _vm._v(" "), _c('pagination', {
	    attrs: {
	      "max-page": _vm.totalPages,
	      "current-page": _vm.currentPage,
	      "spread": 5
	    },
	    on: {
	      "switchToPage": _vm.switchToResultsPage
	    }
	  })], 1)], 2) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 849 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "invitation"
	  }, [(_vm.isSaving) ? _c('saver-large') : _vm._e(), _vm._v(" "), (!_vm.isSaving && !_vm.serverResponse) ? [_c('div', {
	    staticClass: "avatar-container"
	  }, [_c('avatar', {
	    attrs: {
	      "profile-data": _vm.invitation.gameDetails,
	      "profile-type": "game",
	      "size": "large",
	      "show-xp-info": false
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "details"
	  }, [_c('span', [_c('router-link', {
	    attrs: {
	      "to": ("/Game/" + (_vm.invitation.gameDetails.stringUrl))
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-gamepad"
	  }), _vm._v(" " + _vm._s(_vm.invitation.gameDetails.alias))])], 1), _vm._v(" "), _c('span', [_vm._v("Recruiting for "), _c('span', {
	    staticClass: "position-titles"
	  }, [_vm._v(_vm._s(_vm.invitation.positionTitles))])]), _vm._v(" "), _c('ul', _vm._l((_vm.invitation.positions), function(position) {
	    return _c('li', [_vm._v(_vm._s(position))])
	  })), _vm._v(" "), _c('button', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.sendResponse('decline')
	      }
	    }
	  }, [_vm._v("Decline")]), _vm._v(" "), _c('button', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.sendResponse('accept')
	      }
	    }
	  }, [_vm._v("Accept")]), _vm._v(" "), _c('router-link', {
	    staticClass: "button",
	    attrs: {
	      "tag": "button",
	      "to": ("/Inbox/Compose?toId=" + (_vm.invitation.gameDetails.ownerDetails.id) + "&toAlias=" + (_vm.invitation.gameDetails.ownerDetails.alias))
	    }
	  }, [_vm._v("\n                Contact Game Project Owner\n            ")]), _vm._v(" "), (_vm.formErrors.length > 0) ? _c('div', {
	    staticClass: "validation-messages error"
	  }, _vm._l((_vm.formErrors), function(error) {
	    return _c('span', [_vm._v(_vm._s(error))])
	  })) : _vm._e()], 1)] : _vm._e(), _vm._v(" "), (_vm.serverResponse) ? [_c('div', {
	    staticClass: "validation-messages friendly"
	  }, [_vm._v(_vm._s(_vm.serverResponse))])] : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 850 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('aside', {
	    attrs: {
	      "id": "chat-companion"
	    }
	  }, [_c('ul', {
	    attrs: {
	      "id": "chat-companion-switcher"
	    }
	  }, _vm._l((_vm.tabs), function(tab) {
	    return (!tab.requiresLogin || _vm.isLoggedIn) ? _c('li', {
	      class: {
	        selected: _vm.activeTab === tab.label
	      },
	      on: {
	        "click": function($event) {
	          _vm.activeTab = tab.label
	        }
	      }
	    }, [_vm._v("\n            " + _vm._s(tab.label) + "\n            "), (tab.notificationType === 'badge' && tab.showNotification) ? _c('i', {
	      staticClass: "fas fa-bell"
	    }) : _vm._e(), _vm._v(" "), (tab.notificationType === 'total' && tab.showNotification) ? _c('i', {
	      staticClass: "total-notification"
	    }, [_vm._v(_vm._s(tab.notificationCount))]) : _vm._e()]) : _vm._e()
	  })), _vm._v(" "), (_vm.activeTab === 'Chatroom') ? _c('chat-companion') : _vm._e(), _vm._v(" "), (_vm.activeTab === 'Private Chat') ? _c('private-chat-companion', {
	    ref: "privateChat"
	  }) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'Online Users') ? _c('online-users-companion') : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 851 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('li', [_c('div', {
	    staticClass: "avatar-container"
	  }, [(_vm.comment.subPosterType === 'developer') ? _c('avatar', {
	    attrs: {
	      "profile-data": _vm.comment.poster,
	      "profile-type": "developer",
	      "size": "small",
	      "show-xp-info": true
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.comment.subPosterType === 'game') ? _c('avatar', {
	    attrs: {
	      "profile-data": _vm.comment.subPoster,
	      "profile-type": "game",
	      "size": "small",
	      "show-xp-info": true
	    }
	  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "comment-details"
	  }, [(_vm.comment.subPosterType === 'developer') ? _c('span', {
	    staticClass: "comment-from"
	  }, [_c('router-link', {
	    attrs: {
	      "to": '/Developer/' + _vm.comment.poster.stringUrl
	    }
	  }, [_vm._v(_vm._s(_vm.comment.poster.alias))])], 1) : _vm._e(), _vm._v(" "), (_vm.comment.subPosterType === 'game') ? _c('span', {
	    staticClass: "comment-from"
	  }, [_c('router-link', {
	    attrs: {
	      "to": '/Game/' + _vm.comment.subPoster.stringUrl
	    }
	  }, [_vm._v(_vm._s(_vm.comment.subPoster.alias))]), _vm._v(" by\n            "), _c('router-link', {
	    attrs: {
	      "to": '/Developer/' + _vm.comment.poster.stringUrl
	    }
	  }, [_vm._v(_vm._s(_vm.comment.poster.alias))])], 1) : _vm._e(), _vm._v(" "), _c('span', {
	    staticClass: "comment-date"
	  }, [_vm._v(_vm._s(_vm._f("formatDateCondensed")(_vm.comment.timestamp)))]), _vm._v(" "), (!_vm.editMode && !_vm.deleteMode && _vm.canEdit) ? _c('span', {
	    staticClass: "comment-options"
	  }, [_c('span', {
	    on: {
	      "click": _vm.enterEditMode
	    }
	  }, [_vm._v("Edit")]), _vm._v(" | "), _c('span', {
	    on: {
	      "click": _vm.enterDeleteMode
	    }
	  }, [_vm._v("Delete")])]) : _vm._e(), _vm._v(" "), (!_vm.editMode && !_vm.deleteMode) ? _c('markdown-content', {
	    attrs: {
	      "classes": "comment-content",
	      "content": _vm.comment.content
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.editMode && _vm.canEdit) ? _c('div', {
	    staticClass: "edit-mode"
	  }, [_c('markdown-editor', {
	    attrs: {
	      "classes": "comment-content"
	    },
	    model: {
	      value: (_vm.editedContent),
	      callback: function($$v) {
	        _vm.editedContent = $$v
	      },
	      expression: "editedContent"
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "button minor",
	    on: {
	      "click": _vm.exitEditMode
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
	    staticClass: "button",
	    on: {
	      "click": _vm.saveEditedComment
	    }
	  }, [_vm._v("Save")])], 1) : _vm._e(), _vm._v(" "), (_vm.deleteMode && _vm.canEdit) ? _c('div', {
	    staticClass: "delete-mode"
	  }, [_c('div', {
	    staticClass: "validation-messages friendly"
	  }, [_vm._v("Are you sure you want to delete this comment?")]), _vm._v(" "), _c('button', {
	    staticClass: "button minor",
	    on: {
	      "click": _vm.exitDeleteMode
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
	    staticClass: "button",
	    on: {
	      "click": _vm.deleteComment
	    }
	  }, [_vm._v("Delete")])]) : _vm._e(), _vm._v(" "), (!_vm.editMode && !_vm.deleteMode) ? _c('voting-widget', {
	    attrs: {
	      "parent-type": "post",
	      "parent-id": _vm.comment.id,
	      "initial-points": "0"
	    }
	  }) : _vm._e()], 1)])
	},staticRenderFns: []}

/***/ }),
/* 852 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: ['media-post ', _vm.classes]
	  }, [(_vm.pieceType(_vm.piece.mediaType) === 'image') ? _c('media-item-image', {
	    attrs: {
	      "data": _vm.piece
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.pieceType(_vm.piece.mediaType) === 'video') ? _c('media-item-video', {
	    attrs: {
	      "data": _vm.piece
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.pieceType(_vm.piece.mediaType) === 'audio') ? _c('media-item-audio', {
	    attrs: {
	      "data": _vm.piece
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.pieceType(_vm.piece.mediaType) === 'link') ? _c('media-item-link', {
	    attrs: {
	      "data": _vm.piece
	    }
	  }) : _vm._e(), _vm._v(" "), _c('h2', [_c('router-link', {
	    attrs: {
	      "to": _vm.linkToPiece
	    }
	  }, [_vm._v(_vm._s(_vm.piece.title))])], 1), _vm._v(" "), (_vm.piece.description.length > 0) ? _c('markdown-content', {
	    attrs: {
	      "classes": "content",
	      "content": _vm.piece.description
	    }
	  }) : _vm._e(), _vm._v(" "), _c('footer', [_c('ul', [_c('li', [_c('voting-widget', {
	    attrs: {
	      "parent-type": "media",
	      "parent-id": _vm.piece.id,
	      "initial-points": "0"
	    }
	  })], 1), _vm._v(" "), _c('li', [_c('a', {
	    class: ['show-comments', {
	      selected: _vm.commentsVisible
	    }],
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.toggleComments($event)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.commentCount) + "\n                comments")])]), _vm._v(" "), _c('li', {
	    staticClass: "social-sharing"
	  }, [_c('i', {
	    staticClass: "fab fa-facebook-f",
	    on: {
	      "click": function($event) {
	        _vm.socialShare('facebook')
	      }
	    }
	  }), _vm._v(" "), _c('i', {
	    staticClass: "fab fa-twitter",
	    on: {
	      "click": function($event) {
	        _vm.socialShare('twitter')
	      }
	    }
	  }), _vm._v(" "), _c('i', {
	    staticClass: "fab fa-linkedin-in",
	    on: {
	      "click": function($event) {
	        _vm.socialShare('linkedin')
	      }
	    }
	  })]), _vm._v(" "), (_vm.canEdit) ? _c('router-link', {
	    attrs: {
	      "tag": "li",
	      "to": _vm.linkToPiece + '/Edit'
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-pencil-alt edit-button"
	  })]) : _vm._e()], 1)]), _vm._v(" "), (_vm.commentsVisible) ? _c('section', {
	    staticClass: "comments"
	  }, [(Object.keys(_vm.piece.comments || {}).length > 0) ? _c('ul', {
	    staticClass: "post-comments"
	  }, _vm._l((_vm.piece.comments), function(comment) {
	    return _c('post-comment', {
	      attrs: {
	        "comment": comment
	      }
	    })
	  })) : _vm._e(), _vm._v(" "), (_vm.isLoggedIn) ? _c('form', {
	    staticClass: "new-comment"
	  }, [_c('markdown-editor', {
	    attrs: {
	      "placeholder": "Add a comment"
	    },
	    model: {
	      value: (_vm.newCommentContent),
	      callback: function($$v) {
	        _vm.newCommentContent = $$v
	      },
	      expression: "newCommentContent"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "submit-row"
	  }, [(_vm.postAsOptions.length > 1) ? _c('label', [_c('span', [_vm._v("Post as ")]), _vm._v(" "), _c('span', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.postAs),
	      expression: "postAs"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.postAs = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm.postAsOptions), function(postAsOption) {
	    return _c('option', {
	      domProps: {
	        "value": postAsOption.value
	      }
	    }, [_vm._v(_vm._s(postAsOption.text))])
	  }))])]) : _vm._e(), _vm._v(" "), _c('span', [_c('button', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.submitComment($event)
	      }
	    }
	  }, [_vm._v("Submit")])])])], 1) : _c('div', [_c('h1', [_c('router-link', {
	    attrs: {
	      "to": "/Login"
	    }
	  }, [_vm._v("Log in")]), _vm._v("\n                to reply\n            ")], 1)])]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 853 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('article', {
	    attrs: {
	      "id": "donations-page"
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "donations-list"
	  }, [_c('div', {
	    staticClass: "classifieds-type-selector"
	  }, [_c('label', {
	    staticClass: "switch"
	  }, [_c('button', {
	    class: [{
	      active: _vm.sortType === 'amount'
	    }],
	    on: {
	      "click": function($event) {
	        _vm.setSortType('amount')
	      }
	    }
	  }, [_vm._v("Amount")]), _vm._v(" "), _c('button', {
	    class: [{
	      active: _vm.sortType === 'date'
	    }],
	    on: {
	      "click": function($event) {
	        _vm.setSortType('date')
	      }
	    }
	  }, [_vm._v("Date")])])]), _vm._v(" "), _vm._l((_vm.donors), function(donor) {
	    return _c('div', {
	      key: donor.id,
	      staticClass: "donor"
	    }, [_c('div', {
	      staticClass: "avatar-container"
	    }, [_c('avatar', {
	      attrs: {
	        "profile-data": donor,
	        "profile-type": "developer",
	        "size": "large",
	        "show-xp-info": false
	      }
	    })], 1), _vm._v(" "), _c('div', {
	      staticClass: "donation-details"
	    }, [_c('span', {
	      staticClass: "poster-alias"
	    }, [_c('router-link', {
	      attrs: {
	        "to": ("/Developer/" + (donor.stringUrl))
	      }
	    }, [_vm._v(_vm._s(donor.alias))])], 1), _vm._v(" "), _c('span', {
	      staticClass: "donation-amount"
	    }, [_vm._v("$" + _vm._s(donor.amount))]), _vm._v(" "), _c('span', {
	      staticClass: "donation-date"
	    }, [_vm._v(_vm._s(_vm._f("formatDateWithoutTime")(donor.date)))])])])
	  })], 2)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "donation-pitch"
	  }, [_c('h1', [_vm._v("Thank you for considering a donation to Develteam!")]), _vm._v(" "), _c('p', [_vm._v("Develteam is a labor of love, with no on-site ads or subscription fees. Your donation helps keep\n            pay for operation costs, and encourages the continued development of features and fixes.")]), _vm._v(" "), _c('p', [_vm._v("Users who donate will also receive a special badge next to their name in chat and on their profile.")]), _vm._v(" "), _c('form', {
	    attrs: {
	      "action": "https://www.paypal.com/cgi-bin/webscr",
	      "method": "post",
	      "target": "_blank"
	    }
	  }, [_c('input', {
	    attrs: {
	      "type": "hidden",
	      "name": "cmd",
	      "value": "_s-xclick"
	    }
	  }), _vm._v(" "), _c('input', {
	    attrs: {
	      "type": "hidden",
	      "name": "hosted_button_id",
	      "value": "HHA7JMWKQ834E"
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "button",
	    attrs: {
	      "type": "submit",
	      "value": "Donate on Paypal",
	      "title": "PayPal - The safer, easier way to pay online!"
	    }
	  }, [_c('i', {
	    staticClass: "fab fa-paypal"
	  }), _vm._v(" Donate on Paypal\n            ")])]), _vm._v(" "), _c('p', {
	    staticClass: "disclaimer"
	  }, [_vm._v("Donations are manually entered into the database, so if you don't see your name right\n            away, please be patient. If you wish to remain anonymous, leave a note on the Paypal form.")])])
	}]}

/***/ }),
/* 854 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(!_vm.expanded) ? _c('div', {
	    staticClass: "fake-youtube-container",
	    on: {
	      "click": function($event) {
	        _vm.expanded = true
	      }
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": ("https://img.youtube.com/vi/" + _vm.videoCode + "/0.jpg"),
	      "alt": "Youtube Video",
	      "title": "Youtube Video"
	    }
	  }), _vm._v(" "), _c('i', {
	    staticClass: "fab fa-youtube fa-stack-1x"
	  }), _vm._v(" "), _c('i', {
	    staticClass: "fab fa-youtube fa-stack-1x"
	  })]) : _vm._e(), _vm._v(" "), (_vm.expanded) ? _c('div', {
	    staticClass: "youtube-iframe-wrapper"
	  }, [_c('iframe', {
	    staticClass: "real-youtube-container",
	    attrs: {
	      "src": ("https://www.youtube.com/embed/" + _vm.videoCode + "?autoplay=1&mute=1"),
	      "frameborder": "0",
	      "allowfullscreen": ""
	    }
	  })]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 855 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('article', {
	    attrs: {
	      "id": "create-game-page"
	    }
	  }, [_c('h2', [_vm._v("Create a new Game Project")]), _vm._v(" "), _c('section', {
	    staticClass: "project-field"
	  }, [_c('h1', [_vm._v("Basic Info")]), _vm._v(" "), _c('div', {
	    staticClass: "fields"
	  }, [_c('label', [_c('span', [_vm._v("Game Project Title")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.projectTitle),
	      expression: "projectTitle"
	    }],
	    attrs: {
	      "type": "text",
	      "disabled": _vm.isSaving
	    },
	    domProps: {
	      "value": (_vm.projectTitle)
	    },
	    on: {
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.projectTitle = $event.target.value
	      }, function($event) {
	        _vm.formErrors = []
	      }]
	    }
	  })]), _vm._v(" "), _c('label', [_c('span', [_vm._v("Maturity Rating")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.rating),
	      expression: "rating"
	    }],
	    attrs: {
	      "disabled": _vm.isSaving
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.rating = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "everyone"
	    }
	  }, [_vm._v("Everyone")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "teen"
	    }
	  }, [_vm._v("Teen")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "mature"
	    }
	  }, [_vm._v("Mature")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "adult"
	    }
	  }, [_vm._v("Adult")])])])])]), _vm._v(" "), (Object.keys(_vm.platforms).length > 0) ? _c('section', {
	    staticClass: "project-field"
	  }, [_c('h1', [_vm._v("Platforms ")]), _vm._v(" "), _c('div', {
	    staticClass: "fields"
	  }, _vm._l((_vm.platforms), function(category) {
	    return _c('div', {
	      staticClass: "platform-fields"
	    }, [_c('h1', [_vm._v(_vm._s(category.label))]), _vm._v(" "), _c('div', {
	      staticClass: "platforms"
	    }, [_vm._l((category.platforms), function(platform) {
	      return _c('label', {
	        directives: [{
	          name: "show",
	          rawName: "v-show",
	          value: (!platform.initiallyHidden || category.showHidden),
	          expression: "!platform.initiallyHidden || category.showHidden"
	        }]
	      }, [_c('input', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (platform.checked),
	          expression: "platform.checked"
	        }],
	        attrs: {
	          "type": "checkbox",
	          "disabled": _vm.isSaving
	        },
	        domProps: {
	          "checked": Array.isArray(platform.checked) ? _vm._i(platform.checked, null) > -1 : (platform.checked)
	        },
	        on: {
	          "change": function($event) {
	            _vm.formErrors = []
	          },
	          "__c": function($event) {
	            var $$a = platform.checked,
	              $$el = $event.target,
	              $$c = $$el.checked ? (true) : (false);
	            if (Array.isArray($$a)) {
	              var $$v = null,
	                $$i = _vm._i($$a, $$v);
	              if ($$el.checked) {
	                $$i < 0 && (platform.checked = $$a.concat($$v))
	              } else {
	                $$i > -1 && (platform.checked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	              }
	            } else {
	              platform.checked = $$c
	            }
	          }
	        }
	      }), _vm._v(" "), _c('span', [_vm._v(_vm._s(platform.label))])])
	    }), _vm._v(" "), (!category.showHidden && category.hasHidden) ? _c('label', [_c('a', {
	      on: {
	        "click": function($event) {
	          $event.preventDefault();
	          _vm.showHidden(category)
	        }
	      }
	    }, [_vm._v("Show All " + _vm._s(category.label))])]) : _vm._e(), _vm._v(" "), (category.showHidden && category.hasHidden) ? _c('label', [_c('a', {
	      on: {
	        "click": function($event) {
	          $event.preventDefault();
	          _vm.hideHidden(category)
	        }
	      }
	    }, [_vm._v("Hide Extra " + _vm._s(category.label))])]) : _vm._e()], 2)])
	  }))]) : _vm._e(), _vm._v(" "), (_vm.genres.length > 0) ? _c('section', {
	    staticClass: "project-field genres"
	  }, [_c('h1', [_vm._v("Genres")]), _vm._v(" "), _c('div', {
	    staticClass: "fields"
	  }, _vm._l((_vm.genres), function(genre) {
	    return _c('label', [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (genre.checked),
	        expression: "genre.checked"
	      }],
	      attrs: {
	        "type": "checkbox",
	        "disabled": _vm.isSaving
	      },
	      domProps: {
	        "checked": Array.isArray(genre.checked) ? _vm._i(genre.checked, null) > -1 : (genre.checked)
	      },
	      on: {
	        "change": function($event) {
	          _vm.formErrors = []
	        },
	        "__c": function($event) {
	          var $$a = genre.checked,
	            $$el = $event.target,
	            $$c = $$el.checked ? (true) : (false);
	          if (Array.isArray($$a)) {
	            var $$v = null,
	              $$i = _vm._i($$a, $$v);
	            if ($$el.checked) {
	              $$i < 0 && (genre.checked = $$a.concat($$v))
	            } else {
	              $$i > -1 && (genre.checked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	            }
	          } else {
	            genre.checked = $$c
	          }
	        }
	      }
	    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(genre.label))])])
	  }))]) : _vm._e(), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "fade",
	      "mode": "out-in"
	    }
	  }, [(_vm.formErrors.length > 0) ? _c('div', {
	    staticClass: "validation-messages error"
	  }, _vm._l((_vm.formErrors), function(error) {
	    return _c('span', [_vm._v(_vm._s(error))])
	  })) : _vm._e()]), _vm._v(" "), (_vm.isSaving) ? _c('saver-large') : _vm._e(), _vm._v(" "), (!_vm.isSaving) ? _c('section', {
	    staticClass: "project-field"
	  }, [_c('div', {
	    staticClass: "button-container"
	  }, [_c('button', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.createProject($event)
	      }
	    }
	  }, [_vm._v("Create Game Project")])])]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 856 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('article', {
	    attrs: {
	      "id": "inbox"
	    }
	  }, [(!_vm.isLoggedIn) ? _c('div', [_c('div', {
	    staticClass: "not-logged"
	  }, [_c('h1', [_c('router-link', {
	    attrs: {
	      "to": "/Login"
	    }
	  }, [_vm._v("Log in")]), _vm._v(" to view your inbox.")], 1)])]) : _c('div', [_c('ul', {
	    attrs: {
	      "id": "section-switcher"
	    }
	  }, [(!_vm.composeView) ? _c('li', {
	    staticClass: "selected"
	  }, [_c('span', [_vm._v("Inbox")])]) : _c('li', [_c('router-link', {
	    attrs: {
	      "to": "/Inbox",
	      "title": "Compose"
	    }
	  }, [_vm._v("Inbox")])], 1), _vm._v(" "), (_vm.composeView) ? _c('li', {
	    staticClass: "selected"
	  }, [_c('span', [_vm._v("Compose New")])]) : _c('li', [_c('router-link', {
	    attrs: {
	      "to": "/Inbox/Compose",
	      "title": "Compose"
	    }
	  }, [_vm._v("Compose New")])], 1)]), _vm._v(" "), (_vm.inboxView) ? _c('section', {
	    attrs: {
	      "id": "conversations"
	    }
	  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.conversations), function(conversation) {
	    return _c('router-link', {
	      class: {
	        unread: !conversation.hasBeenRead
	      },
	      attrs: {
	        "to": ("/Inbox/" + (conversation.id))
	      }
	    }, [_c('span', [_vm._v(_vm._s(conversation.subject))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("joinArray")(conversation.participants, 'alias')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("formatDate")(conversation.lastMessageDate)))])])
	  })], 2) : _vm._e(), _vm._v(" "), (!_vm.inboxView && !_vm.composeView) ? _c('inbox-conversation') : _vm._e(), _vm._v(" "), (_vm.composeView) ? _c('inbox-compose') : _vm._e()], 1)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('nav', [_c('span', [_vm._v("Subject")]), _vm._v(" "), _c('span', [_vm._v("Participants")]), _vm._v(" "), _c('span', [_vm._v("Last Message")])])
	}]}

/***/ }),
/* 857 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('article', {
	    attrs: {
	      "id": "feed-posts-page"
	    }
	  }, [(Object.keys(_vm.feedPosts || {}).length === 0) ? [(_vm.fetchingStatus === 'fetched') ? _c('div', {
	    staticClass: "content-box feed-post"
	  }, [_vm._v("This user has made no posts")]) : _c('loader-large')] : _vm._e(), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "feed-post-collection"
	    }
	  }, [(_vm.layout === 'masonry') ? _c('vue-masonry', {
	    attrs: {
	      "min-width": 450,
	      "horizontal-gutter": 40,
	      "vertical-gutter": 40
	    }
	  }, [(_vm.isOwner && !_vm.showNewPostForm) ? _c('button', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        _vm.showNewPostForm = true
	      }
	    }
	  }, [_vm._v("Submit a New\n                Post\n            ")]) : _vm._e(), _vm._v(" "), (_vm.isOwner && _vm.showNewPostForm) ? _c('div', {
	    staticClass: "feed-post",
	    attrs: {
	      "id": "feed-add-new"
	    }
	  }, [_c('h2', [_vm._v("Submit a new Post")]), _vm._v(" "), _c('form', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newPostSubject),
	      expression: "newPostSubject"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "Subject (optional)"
	    },
	    domProps: {
	      "value": (_vm.newPostSubject)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newPostSubject = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('markdown-editor', {
	    attrs: {
	      "placeholder": "Post Content"
	    },
	    model: {
	      value: (_vm.newPostContent),
	      callback: function($$v) {
	        _vm.newPostContent = $$v
	      },
	      expression: "newPostContent"
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.submitNewPost($event)
	      }
	    }
	  }, [_vm._v("Submit")]), _vm._v(" "), _c('button', {
	    staticClass: "button minor",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.showNewPostForm = false
	      }
	    }
	  }, [_vm._v("Cancel")])], 1)]) : _vm._e(), _vm._v(" "), (Object.keys(_vm.feedPosts || {}).length > 0) ? _vm._l((_vm.feedPosts), function(feedPost) {
	    return _c('feed-status-post', {
	      key: feedPost.id,
	      attrs: {
	        "data": feedPost
	      }
	    })
	  }) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.layout === 'single') ? _c('div', {
	    staticClass: "single-column-container"
	  }, [(_vm.isOwner && !_vm.showNewPostForm) ? _c('button', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        _vm.showNewPostForm = true
	      }
	    }
	  }, [_vm._v("Submit a New\n                Post\n            ")]) : _vm._e(), _vm._v(" "), (_vm.isOwner && _vm.showNewPostForm) ? _c('div', {
	    staticClass: "feed-post",
	    attrs: {
	      "id": "feed-add-new"
	    }
	  }, [_c('h2', [_vm._v("Submit a new Post")]), _vm._v(" "), _c('form', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newPostSubject),
	      expression: "newPostSubject"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "Subject (optional)"
	    },
	    domProps: {
	      "value": (_vm.newPostSubject)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newPostSubject = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('markdown-editor', {
	    attrs: {
	      "placeholder": "Post Content"
	    },
	    model: {
	      value: (_vm.newPostContent),
	      callback: function($$v) {
	        _vm.newPostContent = $$v
	      },
	      expression: "newPostContent"
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.submitNewPost($event)
	      }
	    }
	  }, [_vm._v("Submit")]), _vm._v(" "), _c('button', {
	    staticClass: "button minor",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.showNewPostForm = false
	      }
	    }
	  }, [_vm._v("Cancel")])], 1)]) : _vm._e(), _vm._v(" "), (Object.keys(_vm.feedPosts || {}).length > 0) ? _vm._l((_vm.feedPosts), function(feedPost) {
	    return _c('feed-status-post', {
	      key: feedPost.id,
	      attrs: {
	        "data": feedPost
	      }
	    })
	  }) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.layout === 'double') ? _c('div', {
	    staticClass: "double-column-container"
	  }, [_c('vue-masonry', {
	    attrs: {
	      "min-width": 500,
	      "horizontal-gutter": 40,
	      "vertical-gutter": 40
	    }
	  }, [(_vm.isOwner && !_vm.showNewPostForm) ? _c('button', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        _vm.showNewPostForm = true
	      }
	    }
	  }, [_vm._v("Submit a\n                    New Post\n                ")]) : _vm._e(), _vm._v(" "), (_vm.isOwner && _vm.showNewPostForm) ? _c('div', {
	    staticClass: "feed-post",
	    attrs: {
	      "id": "feed-add-new"
	    }
	  }, [_c('h2', [_vm._v("Submit a new Post")]), _vm._v(" "), _c('form', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newPostSubject),
	      expression: "newPostSubject"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "Subject (optional)"
	    },
	    domProps: {
	      "value": (_vm.newPostSubject)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newPostSubject = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('markdown-editor', {
	    attrs: {
	      "placeholder": "Post Content"
	    },
	    model: {
	      value: (_vm.newPostContent),
	      callback: function($$v) {
	        _vm.newPostContent = $$v
	      },
	      expression: "newPostContent"
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.submitNewPost($event)
	      }
	    }
	  }, [_vm._v("Submit")]), _vm._v(" "), _c('button', {
	    staticClass: "button minor",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.showNewPostForm = false
	      }
	    }
	  }, [_vm._v("Cancel")])], 1)]) : _vm._e(), _vm._v(" "), (Object.keys(_vm.feedPosts || {}).length > 0) ? _vm._l((_vm.feedPosts), function(feedPost) {
	    return _c('feed-status-post', {
	      key: feedPost.id,
	      attrs: {
	        "data": feedPost
	      }
	    })
	  }) : _vm._e()], 2)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "load-more-button-container"
	  }, [(_vm.fetchingStatus === 'fetched' && Object.keys(_vm.feedPosts || {}).length > 0 && !_vm.hasFetchedAll) ? _c('button', {
	    attrs: {
	      "id": "feed-fetch-more"
	    },
	    on: {
	      "click": _vm.fetchMore
	    }
	  }, [_vm._v("Load more posts\n        ")]) : _vm._e()])], 2)
	},staticRenderFns: []}

/***/ }),
/* 858 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "pitch-mission-statement"
	  }, [_c('h1', [_vm._v("Develteam Features")]), _vm._v(" "), _c('div', {
	    staticClass: "features"
	  }, _vm._l((_vm.features), function(feature) {
	    return ((_vm.depth === 'short' && feature.short) || (_vm.depth === 'long' && feature.long) || _vm.depth === 'both') ? _c('div', {
	      staticClass: "feature"
	    }, [_c('h1', [_vm._v(_vm._s(feature.title))]), _vm._v(" "), _c('p', {
	      domProps: {
	        "innerHTML": _vm._s(feature.content)
	      }
	    })]) : _vm._e()
	  }))])
	},staticRenderFns: []}

/***/ }),
/* 859 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('article', {
	    staticClass: "browse-item"
	  }, [_c('section', {
	    staticClass: "avatar-container"
	  }, [_c('avatar', {
	    attrs: {
	      "profile-data": _vm.details,
	      "profile-type": "game",
	      "size": "large",
	      "show-xp-info": true
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "overview"
	  }, [_c('span', {
	    staticClass: "name"
	  }, [_c('router-link', {
	    attrs: {
	      "to": '/Game/' + _vm.details.stringUrl
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-gamepad"
	  }), _vm._v(" " + _vm._s(_vm.details.alias))])], 1), _vm._v(" "), _c('span', {
	    staticClass: "platform"
	  }, [_vm._v("Platform: " + _vm._s(_vm.details.platforms))]), _vm._v(" "), _c('span', {
	    staticClass: "genre"
	  }, [_vm._v("Genre: " + _vm._s(_vm.details.genres))]), _vm._v(" "), _c('span', {
	    staticClass: "rated"
	  }, [_vm._v("Rated " + _vm._s(_vm.details.rating))]), _vm._v(" "), _c('span', {
	    staticClass: "created"
	  }, [_vm._v("Created: " + _vm._s(_vm._f("formatDate")(_vm.details.created)))]), _vm._v(" "), (_vm.details.lookingForMembers) ? _c('span', {
	    staticClass: "wants-to-collab"
	  }, [_vm._v("Currently Recruiting Developers")]) : _vm._e(), _vm._v(" "), (_vm.details.lookingForMembers) ? _c('ul', {
	    staticClass: "seeking-roles"
	  }, [(_vm.details.seekingDesigners) ? _c('li', [_vm._v("Designers")]) : _vm._e(), _vm._v(" "), (_vm.details.seekingArtists) ? _c('li', [_vm._v("Artists")]) : _vm._e(), _vm._v(" "), (_vm.details.seekingProgrammers) ? _c('li', [_vm._v("Programmers")]) : _vm._e(), _vm._v(" "), (_vm.details.seekingWriters) ? _c('li', [_vm._v("Writers")]) : _vm._e(), _vm._v(" "), (_vm.details.seekingMusicians) ? _c('li', [_vm._v("Musicians")]) : _vm._e(), _vm._v(" "), (_vm.details.seekingSfxArtists) ? _c('li', [_vm._v("SFX Artists")]) : _vm._e(), _vm._v(" "), (_vm.details.seekingTesters) ? _c('li', [_vm._v("Testers")]) : _vm._e(), _vm._v(" "), (_vm.details.seekingProducers) ? _c('li', [_vm._v("Producers")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.details.skills.length > 0) ? _c('ul', {
	    staticClass: "seeking-roles"
	  }, _vm._l((_vm.details.skills), function(skill) {
	    return _c('li', [_vm._v(_vm._s(_vm.skillList[skill].skill))])
	  })) : _vm._e()]), _vm._v(" "), _c('section', {
	    staticClass: "about"
	  }, [_c('span', [_vm._v("Members")]), _vm._v(" "), _c('ul', {
	    staticClass: "members"
	  }, _vm._l((_vm.details.memberList), function(member) {
	    return _c('li', [_c('avatar', {
	      attrs: {
	        "profile-data": member,
	        "profile-type": "developer",
	        "size": "small",
	        "show-xp-info": true
	      }
	    })], 1)
	  }))])])
	},staticRenderFns: []}

/***/ }),
/* 860 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    attrs: {
	      "id": "ban-developer"
	    }
	  }, [_c('div', {
	    staticClass: "ban-developer-form"
	  }, [(_vm.formData.isBanned) ? _c('label', [_vm._v("Un-Ban this developer?")]) : _vm._e(), _vm._v(" "), (!_vm.formData.isBanned) ? _c('label', [_vm._v("Ban this developer?")]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "buttons"
	  }, [_c('button', {
	    staticClass: "button minor",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.cancelChanges($event)
	      }
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), (!_vm.formData.isBanned) ? _c('button', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.submitBan($event)
	      }
	    }
	  }, [_vm._v("Yes, Ban")]) : _vm._e(), _vm._v(" "), (_vm.formData.isBanned) ? _c('button', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.submitUnBan($event)
	      }
	    }
	  }, [_vm._v("Un-Ban")]) : _vm._e()])])])
	},staticRenderFns: []}

/***/ }),
/* 861 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('article', {
	    attrs: {
	      "id": "register-page"
	    }
	  }, [(!_vm.successfullyRegistered) ? _c('form', {
	    attrs: {
	      "id": "register-form"
	    }
	  }, [_c('h2', [_vm._v("Register a New Account")]), _vm._v(" "), _c('div', {
	    staticClass: "register-form-fields"
	  }, [(_vm.isSaving) ? _c('saver-large') : _vm._e(), _vm._v(" "), (!_vm.isSaving) ? [_c('label', [_vm._v("Screen Name ")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.alias),
	      expression: "alias"
	    }],
	    class: {
	      invalid: _vm.aliasHasError
	    },
	    attrs: {
	      "type": "text",
	      "placeholder": "Screen Name"
	    },
	    domProps: {
	      "value": (_vm.alias)
	    },
	    on: {
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.alias = $event.target.value
	      }, function($event) {
	        _vm.aliasHasError = false
	      }]
	    }
	  }), _vm._v(" "), _c('label', [_vm._v("Email")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.email),
	      expression: "email"
	    }],
	    class: {
	      invalid: _vm.emailHasError
	    },
	    attrs: {
	      "type": "email",
	      "placeholder": "Email Address"
	    },
	    domProps: {
	      "value": (_vm.email)
	    },
	    on: {
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.email = $event.target.value
	      }, function($event) {
	        _vm.emailHasError = false
	      }]
	    }
	  }), _vm._v(" "), _c('label', [_vm._v("Verify Email")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.emailVerify),
	      expression: "emailVerify"
	    }],
	    class: {
	      invalid: _vm.emailHasError
	    },
	    attrs: {
	      "type": "email",
	      "placeholder": "Confirm Email Address"
	    },
	    domProps: {
	      "value": (_vm.emailVerify)
	    },
	    on: {
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.emailVerify = $event.target.value
	      }, function($event) {
	        _vm.emailHasError = false
	      }]
	    }
	  }), _vm._v(" "), _c('label', [_vm._v("Password")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.password),
	      expression: "password"
	    }],
	    class: {
	      invalid: _vm.passwordHasError
	    },
	    attrs: {
	      "type": "password",
	      "placeholder": "Password"
	    },
	    domProps: {
	      "value": (_vm.password)
	    },
	    on: {
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.password = $event.target.value
	      }, function($event) {
	        _vm.passwordHasError = false
	      }]
	    }
	  }), _vm._v(" "), _c('label', [_vm._v("Verify Password")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.passwordVerify),
	      expression: "passwordVerify"
	    }],
	    class: {
	      invalid: _vm.passwordHasError
	    },
	    attrs: {
	      "type": "password",
	      "placeholder": "Confiirm Password"
	    },
	    domProps: {
	      "value": (_vm.passwordVerify)
	    },
	    on: {
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.passwordVerify = $event.target.value
	      }, function($event) {
	        _vm.passwordHasError = false
	      }]
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "recaptcha-container"
	  }, [_c('div', {
	    staticClass: "recpatcha-inner-container"
	  }, [_c('div', {
	    ref: "recaptchaContainer",
	    staticClass: "g-recaptcha",
	    attrs: {
	      "data-sitekey": _vm.rcapt_sig_key
	    }
	  })])]), _vm._v(" "), (_vm.formErrors.length > 0) ? _c('div', {
	    staticClass: "validation-messages error"
	  }, _vm._l((_vm.formErrors), function(error) {
	    return _c('span', [_vm._v(_vm._s(error))])
	  })) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "button-container"
	  }, [_c('button', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.submit($event)
	      }
	    }
	  }, [_vm._v("Register Account")])])] : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (_vm.successfullyRegistered) ? _c('div', {
	    attrs: {
	      "id": "successful-registration"
	    }
	  }, [_c('h2', [_vm._v("Welcome to Develteam!")]), _vm._v(" "), _c('p', [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_vm._v("Return to the Home Page")]), _vm._v("\n            |\n            "), _c('router-link', {
	    attrs: {
	      "to": ("/Developer/" + (_vm.loggedUser.stringUrl))
	    }
	  }, [_vm._v("Edit your Profile")])], 1)]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 862 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    attrs: {
	      "id": "top-content"
	    }
	  }, [_c('h1', [_vm._v("Top Content")]), _vm._v(" "), _c('div', {
	    staticClass: "items"
	  }, _vm._l((_vm.topContent), function(media) {
	    return _c('div', {
	      staticClass: "item"
	    }, [(media.posterStringUrl && media.mediaType === 'Image') ? _c('router-link', {
	      attrs: {
	        "to": ("/Developer/" + (media.posterStringUrl) + "/Portfolio/" + (media.albumStringUrl) + "/" + (media.pieceStringUrl))
	      }
	    }, [_c('div', {
	      staticClass: "thumb",
	      style: (("background-image: url('https://www.develteam.com/userdata/mediaThumbs/" + (media.mediaUrl) + "')"))
	    })]) : _vm._e(), _vm._v(" "), (media.subPosterStringUrl && media.mediaType === 'Image') ? _c('router-link', {
	      attrs: {
	        "to": ("/Game/" + (media.subPosterStringUrl) + "/Media/" + (media.albumStringUrl) + "/" + (media.pieceStringUrl))
	      }
	    }, [_c('div', {
	      staticClass: "thumb",
	      style: (("background-image: url('https://www.develteam.com/userdata/mediaThumbs/" + (media.mediaUrl) + "')"))
	    })]) : _vm._e(), _vm._v(" "), (media.posterStringUrl && media.mediaType !== 'Image' && media.previewUrl) ? _c('router-link', {
	      attrs: {
	        "to": ("/Developer/" + (media.posterStringUrl) + "/Portfolio/" + (media.albumStringUrl) + "/" + (media.pieceStringUrl))
	      }
	    }, [_c('div', {
	      staticClass: "thumb",
	      style: (("background-image: url('https://www.develteam.com/userdata/mediaThumbs/" + (media.previewUrl) + "')"))
	    })]) : _vm._e(), _vm._v(" "), (media.subPosterStringUrl && media.mediaType !== 'Image' && media.previewUrl) ? _c('router-link', {
	      attrs: {
	        "to": ("/Game/" + (media.subPosterStringUrl) + "/Media/" + (media.albumStringUrl) + "/" + (media.pieceStringUrl))
	      }
	    }, [_c('div', {
	      staticClass: "thumb",
	      style: (("background-image: url('https://www.develteam.com/userdata/mediaThumbs/" + (media.previewUrl) + "')"))
	    })]) : _vm._e(), _vm._v(" "), (media.posterStringUrl && media.mediaType !== 'Image' && !media.previewUrl) ? _c('router-link', {
	      attrs: {
	        "to": ("/Developer/" + (media.posterStringUrl) + "/Portfolio/" + (media.albumStringUrl) + "/" + (media.pieceStringUrl))
	      }
	    }, [(media.mediaType === 'Audio') ? _c('div', {
	      staticClass: "thumb icon-thumb"
	    }, [_c('div', {
	      staticClass: "icon-container"
	    }, [_c('i', {
	      staticClass: "fas fa-volume-up"
	    })])]) : _vm._e(), _vm._v(" "), (media.mediaType === 'External') ? _c('div', {
	      staticClass: "thumb icon-thumb"
	    }, [_c('div', {
	      staticClass: "icon-container"
	    }, [_c('i', {
	      staticClass: "fas fa-link"
	    })])]) : _vm._e(), _vm._v(" "), (media.mediaType === 'Flash') ? _c('div', {
	      staticClass: "thumb icon-thumb"
	    }, [_c('div', {
	      staticClass: "icon-container"
	    }, [_c('i', {
	      staticClass: "fas fa-rocket"
	    })])]) : _vm._e(), _vm._v(" "), (media.mediaType === 'Archive') ? _c('div', {
	      staticClass: "thumb icon-thumb"
	    }, [_c('div', {
	      staticClass: "icon-container"
	    }, [_c('i', {
	      staticClass: "fas fa-download"
	    })])]) : _vm._e(), _vm._v(" "), (media.mediaType === 'Text') ? _c('div', {
	      staticClass: "thumb icon-thumb"
	    }, [_c('div', {
	      staticClass: "icon-container"
	    }, [_c('i', {
	      staticClass: "fas fa-download"
	    })])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (media.subPosterStringUrl && media.mediaType !== 'Image' && media.previewUrl) ? _c('router-link', {
	      attrs: {
	        "to": ("/Game/" + (media.subPosterStringUrl) + "/Media/" + (media.albumStringUrl) + "/" + (media.pieceStringUrl))
	      }
	    }, [(media.mediaType === 'Audio') ? _c('div', {
	      staticClass: "thumb icon-thumb"
	    }, [_c('div', {
	      staticClass: "icon-container"
	    }, [_c('i', {
	      staticClass: "fas fa-volume-up"
	    })])]) : _vm._e(), _vm._v(" "), (media.mediaType === 'External') ? _c('div', {
	      staticClass: "thumb icon-thumb"
	    }, [_c('div', {
	      staticClass: "icon-container"
	    }, [_c('i', {
	      staticClass: "fas fa-link"
	    })])]) : _vm._e(), _vm._v(" "), (media.mediaType === 'Flash') ? _c('div', {
	      staticClass: "thumb icon-thumb"
	    }, [_c('div', {
	      staticClass: "icon-container"
	    }, [_c('i', {
	      staticClass: "fas fa-rocket"
	    })])]) : _vm._e(), _vm._v(" "), (media.mediaType === 'Archive') ? _c('div', {
	      staticClass: "thumb icon-thumb"
	    }, [_c('div', {
	      staticClass: "icon-container"
	    }, [_c('i', {
	      staticClass: "fas fa-download"
	    })])]) : _vm._e(), _vm._v(" "), (media.mediaType === 'Text') ? _c('div', {
	      staticClass: "thumb icon-thumb"
	    }, [_c('div', {
	      staticClass: "icon-container"
	    }, [_c('i', {
	      staticClass: "fas fa-download"
	    })])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (media.mediaType === 'Audio') ? _c('div', {
	      staticClass: "audio-container thumb"
	    }, [_c('audio', {
	      attrs: {
	        "controls": ""
	      }
	    }, [_c('source', {
	      attrs: {
	        "src": ("https://www.develteam.com/userdata/media/" + (media.mediaUrl)),
	        "type": "audio/mpeg"
	      }
	    }), _vm._v("\n                Your browser does not support the audio tag.\n            ")])]) : _vm._e(), _vm._v(" "), (media.mediaType === 'Youtube') ? _c('fake-youtube', {
	      attrs: {
	        "src": media.mediaUrl
	      }
	    }) : _vm._e(), _vm._v(" "), _c('div', {
	      staticClass: "details"
	    }, [(media.posterStringUrl) ? _c('h2', [_c('router-link', {
	      attrs: {
	        "to": ("/Developer/" + (media.posterStringUrl) + "/Portfolio/" + (media.albumStringUrl) + "/" + (media.pieceStringUrl))
	      }
	    }, [_vm._v("\n                        " + _vm._s(media.title) + "\n                    ")])], 1) : _vm._e(), _vm._v(" "), (media.subPosterStringUrl) ? _c('h2', [_c('router-link', {
	      attrs: {
	        "to": ("/Game/" + (media.subPosterStringUrl) + "/Media/" + (media.albumStringUrl) + "/" + (media.pieceStringUrl))
	      }
	    }, [_vm._v("\n                        " + _vm._s(media.title) + "\n                    ")])], 1) : _vm._e(), _vm._v(" "), _c('span', {
	      staticClass: "poster"
	    }, [(media.subPosterStringUrl) ? [_c('i', {
	      staticClass: "fas fa-gamepad"
	    }), _vm._v(" "), _c('router-link', {
	      attrs: {
	        "to": ("/Game/" + (media.subPosterStringUrl))
	      }
	    }, [_vm._v("\n                            " + _vm._s(media.subPosterAlias) + "\n                        ")])] : _vm._e(), _vm._v(" "), (media.posterStringUrl) ? [_c('i', {
	      staticClass: "fas fa-user"
	    }), _vm._v(" "), _c('router-link', {
	      attrs: {
	        "to": ("/Developer/" + (media.posterStringUrl))
	      }
	    }, [_vm._v("\n                            " + _vm._s(media.posterAlias) + "\n                        ")])] : _vm._e()], 2), _vm._v(" "), (media.subPosterStringUrl) ? _c('div', {
	      staticClass: "media-stats"
	    }, [_c('router-link', {
	      attrs: {
	        "to": ("/Game/" + (media.subPosterStringUrl) + "/Media/" + (media.albumStringUrl) + "/" + (media.pieceStringUrl))
	      }
	    }, [_c('i', {
	      staticClass: "far fa-heart"
	    }), _vm._v(" " + _vm._s(media.voteTotal) + "\n                    ")]), _vm._v(" "), _c('router-link', {
	      attrs: {
	        "to": ("/Game/" + (media.subPosterStringUrl) + "/Media/" + (media.albumStringUrl) + "/" + (media.pieceStringUrl))
	      }
	    }, [_c('i', {
	      staticClass: "far fa-comment-alt"
	    }), _vm._v(" " + _vm._s(media.commentCount) + "\n                    ")])], 1) : _vm._e(), _vm._v(" "), (media.posterStringUrl) ? _c('div', {
	      staticClass: "media-stats"
	    }, [_c('router-link', {
	      attrs: {
	        "to": ("/Developer/" + (media.posterStringUrl) + "/Portfolio/" + (media.albumStringUrl) + "/" + (media.pieceStringUrl))
	      }
	    }, [_c('i', {
	      staticClass: "far fa-heart"
	    }), _vm._v(" " + _vm._s(media.voteTotal) + "\n                    ")]), _vm._v(" "), _c('router-link', {
	      attrs: {
	        "to": ("/Developer/" + (media.posterStringUrl) + "/Portfolio/" + (media.albumStringUrl) + "/" + (media.pieceStringUrl))
	      }
	    }, [_c('i', {
	      staticClass: "far fa-comment-alt"
	    }), _vm._v(" " + _vm._s(media.commentCount) + "\n                    ")])], 1) : _vm._e()])], 1)
	  }))])
	},staticRenderFns: []}

/***/ }),
/* 863 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    attrs: {
	      "id": "edit-developer-work-history"
	    }
	  }, [_c('div', {
	    staticClass: "work-history edit-container"
	  }, [_vm._l((_vm.formData.workHistory), function(workItem, index) {
	    return _c('div', {
	      staticClass: "container"
	    }, [_c('div', {
	      staticClass: "set"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (workItem.place),
	        expression: "workItem.place"
	      }],
	      class: [{
	        invalid: workItem.place.trim() === ''
	      }],
	      attrs: {
	        "type": "text",
	        "placeholder": "Company"
	      },
	      domProps: {
	        "value": (workItem.place)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          workItem.place = $event.target.value
	        }
	      }
	    }), _vm._v(" "), _c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (workItem.title),
	        expression: "workItem.title"
	      }],
	      attrs: {
	        "type": "text",
	        "placeholder": "Position"
	      },
	      domProps: {
	        "value": (workItem.title)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          workItem.title = $event.target.value
	        }
	      }
	    }), _vm._v(" "), _c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (workItem.start),
	        expression: "workItem.start"
	      }],
	      attrs: {
	        "type": "text",
	        "placeholder": "Start Date"
	      },
	      domProps: {
	        "value": (workItem.start)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          workItem.start = $event.target.value
	        }
	      }
	    }), _vm._v(" "), _c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (workItem.end),
	        expression: "workItem.end"
	      }],
	      attrs: {
	        "type": "text",
	        "placeholder": "End Date"
	      },
	      domProps: {
	        "value": (workItem.end)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          workItem.end = $event.target.value
	        }
	      }
	    }), _vm._v(" "), _c('button', {
	      staticClass: "button small-button",
	      on: {
	        "click": function($event) {
	          $event.preventDefault();
	          _vm.removeWorkHistory(index)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa-trash fas"
	    })]), _vm._v(" "), (index > 0) ? _c('button', {
	      staticClass: "button small-button",
	      on: {
	        "click": function($event) {
	          $event.preventDefault();
	          _vm.moveWorkHistoryUp(index)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa-arrow-up fas"
	    })]) : _vm._e(), _vm._v(" "), (index !== _vm.formData.workHistory.length - 1) ? _c('button', {
	      staticClass: "button small-button",
	      on: {
	        "click": function($event) {
	          $event.preventDefault();
	          _vm.moveWorkHistoryDown(index)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa-arrow-down fas"
	    })]) : _vm._e()])])
	  }), _vm._v(" "), _c('div', {
	    staticClass: "set container"
	  }, [_c('button', {
	    staticClass: "button small-button",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.addWorkHistory($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-plus"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "buttons"
	  }, [_c('button', {
	    staticClass: "button minor",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.cancelChanges($event)
	      }
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
	    staticClass: "button",
	    attrs: {
	      "disabled": !_vm.allEntriesAreValid()
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.submitChanges($event)
	      }
	    }
	  }, [_vm._v("Save")])])], 2)])
	},staticRenderFns: []}

/***/ }),
/* 864 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('article', {
	    attrs: {
	      "id": "resources-page"
	    }
	  }, [_c('transition', {
	    attrs: {
	      "name": "fade",
	      "mode": "out-in"
	    }
	  }, [(_vm.resources.length === 0) ? _c('div', {
	    key: "still-loading"
	  }, [_c('loader-large')], 1) : _c('div', {
	    key: "done-loading"
	  }, [_vm._l((_vm.resources), function(resource) {
	    return (resource.selected) ? _c('ul', {
	      attrs: {
	        "id": "resource-category-switcher"
	      }
	    }, _vm._l((resource.sections), function(section) {
	      return _c('li', {
	        class: {
	          selected: section.selected
	        }
	      }, [(!section.selected) ? _c('router-link', {
	        attrs: {
	          "to": '/Resources/' + resource.id + '/' + section.id,
	          "title": section.text
	        }
	      }, [_c('i', {
	        class: 'fa ' + section.icon
	      }), _vm._v(" " + _vm._s(section.text) + "\n                    ")]) : _c('span', [_c('i', {
	        class: 'fa ' + section.icon
	      }), _vm._v(" " + _vm._s(section.text))])], 1)
	    })) : _vm._e()
	  }), _vm._v(" "), _vm._l((_vm.resources), function(resource) {
	    return (resource.selected) ? _c('div', {
	      attrs: {
	        "id": "resource-list"
	      }
	    }, _vm._l((resource.sections), function(section) {
	      return (section.selected) ? _c('ul', {
	        staticClass: "resource-items"
	      }, _vm._l((section.resourceItems), function(resourceItem) {
	        return (resourceItem.allVotes > -2) ? _c('li', {
	          staticClass: "resource-item",
	          attrs: {
	            "id": 'resource-item-' + resourceItem.id
	          }
	        }, [_c('h4', [_c('a', {
	          attrs: {
	            "href": resourceItem.url,
	            "target": "_blank"
	          }
	        }, [_vm._v(_vm._s(resourceItem.text))])]), _vm._v(" "), _c('voting-widget', {
	          attrs: {
	            "parent-type": "resource",
	            "parent-id": resourceItem.id,
	            "initial-points": resourceItem.allVotes
	          }
	        })], 1) : _vm._e()
	      })) : _vm._e()
	    })) : _vm._e()
	  }), _vm._v(" "), (_vm.showSubmitResourceForm) ? _c('div', {
	    attrs: {
	      "id": "submit-new-resource"
	    }
	  }, [_c('h2', [_vm._v("Submit a New Resource")]), _vm._v(" "), (!_vm.$store.state.resourcesPageModel.submittedNewResource) ? _c('form', [_c('div', {
	    staticClass: "container"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.addResourceWebsiteName),
	      expression: "addResourceWebsiteName"
	    }],
	    class: {
	      invalid: _vm.addResourceWebsiteNameInvalid
	    },
	    attrs: {
	      "type": "text",
	      "id": "new-resource-name",
	      "placeholder": "Website Name"
	    },
	    domProps: {
	      "value": (_vm.addResourceWebsiteName)
	    },
	    on: {
	      "keyup": function($event) {
	        _vm.addResourceWebsiteNameInvalid = false
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.addResourceWebsiteName = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.addResourceWebsiteUrl),
	      expression: "addResourceWebsiteUrl"
	    }],
	    class: {
	      invalid: _vm.addResourceWebsiteUrlInvalid
	    },
	    attrs: {
	      "type": "text",
	      "id": "new-resource-url",
	      "placeholder": "Website URL"
	    },
	    domProps: {
	      "value": (_vm.addResourceWebsiteUrl)
	    },
	    on: {
	      "keyup": function($event) {
	        _vm.addResourceWebsiteUrlInvalid = false
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.addResourceWebsiteUrl = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "container"
	  }, [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.addResourceCategory),
	      expression: "addResourceCategory"
	    }],
	    attrs: {
	      "id": "new-resource-category"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.addResourceCategory = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "assets"
	    }
	  }, [_vm._v("Assets")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "devtools"
	    }
	  }, [_vm._v("Dev Tools")])]), _vm._v(" "), (_vm.addResourceCategory === 'assets') ? _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.addResourceSectionAssets),
	      expression: "addResourceSectionAssets"
	    }],
	    attrs: {
	      "id": "new-resource-section-assets"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.addResourceSectionAssets = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "graphics"
	    }
	  }, [_vm._v("Graphics")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "fonts"
	    }
	  }, [_vm._v("Fonts")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "sfx"
	    }
	  }, [_vm._v("Sound Effects")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "music"
	    }
	  }, [_vm._v("Music")])]) : _vm._e(), _vm._v(" "), (_vm.addResourceCategory === 'devtools') ? _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.addResourceSectionDevtools),
	      expression: "addResourceSectionDevtools"
	    }],
	    attrs: {
	      "id": "new-resource-section-devtools"
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.addResourceSectionDevtools = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "collaboration"
	    }
	  }, [_vm._v("Collaboration")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "engines"
	    }
	  }, [_vm._v("Game Engines")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "programming"
	    }
	  }, [_vm._v("Programming")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "graphics"
	    }
	  }, [_vm._v("Graphics")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "audio"
	    }
	  }, [_vm._v("Audio")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "video"
	    }
	  }, [_vm._v("Video")])]) : _vm._e()]), _vm._v(" "), _c('input', {
	    attrs: {
	      "type": "submit",
	      "value": "Submit",
	      "id": "submit-form"
	    },
	    on: {
	      "click": _vm.addResource
	    }
	  })]) : _c('div', [_c('p', [_vm._v("Thank you for submitting a new Resource. "), _c('a', {
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.$store.state.resourcesPageModel.submittedNewResource = false
	      }
	    }
	  }, [_vm._v("Submit Another")]), _vm._v("?")])])]) : _vm._e()], 2)])], 1)
	},staticRenderFns: []}

/***/ }),
/* 865 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "media-item-video"
	  }, [_c('div', {
	    staticClass: "video-container"
	  }, [(_vm.data.mediaType === 'Video') ? _c('div', {
	    staticClass: "video-wrapper"
	  }, [_c('video', {
	    attrs: {
	      "controls": "",
	      "onclick": "this.paused?this.play():this.pause();"
	    }
	  }, [_c('source', {
	    attrs: {
	      "src": ("https://www.develteam.com/userdata/media/" + (_vm.data.mediaUrl)),
	      "type": "video/mp4"
	    }
	  }), _vm._v("\n                Your browser does not support the video tag.\n            ")])]) : _vm._e(), _vm._v(" "), (_vm.data.mediaType === 'Youtube') ? _c('fake-youtube', {
	    attrs: {
	      "src": _vm.data.mediaUrl
	    }
	  }) : _vm._e()], 1)])
	},staticRenderFns: []}

/***/ }),
/* 866 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (!_vm.isDeleted) ? _c('section', {
	    staticClass: "post"
	  }, [_c('div', {
	    staticClass: "poster-details"
	  }, [_c('span', {
	    staticClass: "poster-alias"
	  }, [_c('router-link', {
	    attrs: {
	      "to": ("/Developer/" + (_vm.post.posterData.stringUrl))
	    }
	  }, [_vm._v(_vm._s(_vm.post.posterData.alias))])], 1), _vm._v(" "), _c('div', {
	    staticClass: "avatar-container"
	  }, [_c('avatar', {
	    attrs: {
	      "profile-data": _vm.post.posterData,
	      "profile-type": "developer",
	      "size": "large",
	      "show-xp-info": true
	    }
	  })], 1)]), _vm._v(" "), (!_vm.editPostMode && !_vm.deletePostMode) ? _c('div', {
	    staticClass: "content-details"
	  }, [_c('markdown-content', {
	    attrs: {
	      "content": _vm.post.content,
	      "classes": "content"
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "time-stamp"
	  }, [_vm._v("Posted " + _vm._s(_vm._f("formatDate")(_vm.post.created)))]), _vm._v(" "), _c('div', {
	    staticClass: "post-details"
	  }, [_c('span', [(!_vm.editPostMode && !_vm.deletePostMode) ? _c('voting-widget', {
	    attrs: {
	      "parent-type": "forum",
	      "parent-id": _vm.post.id,
	      "initial-points": "0"
	    }
	  }) : _vm._e()], 1), _vm._v(" "), (_vm.isPoster) ? _c('span', {
	    staticClass: "edit-post",
	    on: {
	      "click": function($event) {
	        _vm.editPostMode = true
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-pencil-alt"
	  }), _vm._v(" Edit Post")]) : _vm._e(), _vm._v(" "), (_vm.isPoster) ? _c('span', {
	    staticClass: "delete-post",
	    on: {
	      "click": function($event) {
	        _vm.deletePostMode = true
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-times"
	  }), _vm._v(" Delete Post")]) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.editPostMode) ? _c('div', {
	    staticClass: "edit-post-form"
	  }, [(_vm.isSaving) ? _c('saver-large') : _vm._e(), _vm._v(" "), (!_vm.isSaving) ? [_c('markdown-editor', {
	    model: {
	      value: (_vm.editPostContent),
	      callback: function($$v) {
	        _vm.editPostContent = $$v
	      },
	      expression: "editPostContent"
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "button minor",
	    on: {
	      "click": function($event) {
	        _vm.editPostMode = false
	      }
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
	    staticClass: "button",
	    on: {
	      "click": _vm.saveEditedPost
	    }
	  }, [_vm._v("Save Changes")])] : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.deletePostMode) ? _c('div', {
	    staticClass: "delete-post-form"
	  }, [_c('button', {
	    staticClass: "button minor",
	    on: {
	      "click": function($event) {
	        _vm.deletePostMode = false
	      }
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
	    staticClass: "button",
	    on: {
	      "click": _vm.deletePost
	    }
	  }, [_vm._v("Delete Post")])]) : _vm._e()]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 867 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "invitation"
	  }, [(_vm.isSaving) ? _c('saver-large') : _vm._e(), _vm._v(" "), (!_vm.isSaving && !_vm.serverResponse) ? [_c('div', {
	    staticClass: "avatar-container"
	  }, [_c('avatar', {
	    attrs: {
	      "profile-data": _vm.invitation.devDetails,
	      "profile-type": "developer",
	      "size": "large",
	      "show-xp-info": false
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "details"
	  }, [_c('span', [_vm._v("\n                Invited\n                "), _c('router-link', {
	    attrs: {
	      "to": ("/Developer/" + (_vm.invitation.devDetails.stringUrl))
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-user"
	  }), _vm._v(" " + _vm._s(_vm.invitation.devDetails.alias))]), _vm._v("\n                to Join\n                "), _c('router-link', {
	    attrs: {
	      "to": ("/Game/" + (_vm.invitation.gameDetails.stringUrl))
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-gamepad"
	  }), _vm._v(" " + _vm._s(_vm.invitation.gameDetails.alias))])], 1), _vm._v(" "), _c('span', [_vm._v("Recruiting for "), _c('span', {
	    staticClass: "position-titles"
	  }, [_vm._v(_vm._s(_vm.invitation.positionTitles))])]), _vm._v(" "), _c('ul', _vm._l((_vm.invitation.positions), function(position) {
	    return _c('li', [_vm._v(_vm._s(position))])
	  })), _vm._v(" "), (_vm.invitation.response === 'noResponse') ? _c('span', [_vm._v("Invitation is pending.")]) : _vm._e(), _vm._v(" "), (_vm.invitation.response === 'accept') ? _c('span', [_vm._v("Your Invitation has been Accepted!")]) : _vm._e(), _vm._v(" "), (_vm.invitation.response === 'decline') ? _c('span', [_vm._v("Your Invitation has been Declined.")]) : _vm._e(), _vm._v(" "), (_vm.invitation.response === 'noResponse') ? _c('button', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.deleteInvitation('retract')
	      }
	    }
	  }, [_vm._v("Retract")]) : _vm._e(), _vm._v(" "), (_vm.invitation.response !== 'noResponse') ? _c('button', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.deleteInvitation('dismiss')
	      }
	    }
	  }, [_vm._v("Dismiss")]) : _vm._e(), _vm._v(" "), (_vm.invitation.response === 'noResponse') ? _c('router-link', {
	    staticClass: "button",
	    attrs: {
	      "tag": "button",
	      "to": ("/Inbox/Compose?toId=" + (_vm.invitation.devDetails.id) + "&toAlias=" + (_vm.invitation.devDetails.alias))
	    }
	  }, [_vm._v("\n                Contact Developer\n            ")]) : _vm._e(), _vm._v(" "), (_vm.formErrors.length > 0) ? _c('div', {
	    staticClass: "validation-messages error"
	  }, _vm._l((_vm.formErrors), function(error) {
	    return _c('span', [_vm._v(_vm._s(error))])
	  })) : _vm._e()], 1)] : _vm._e(), _vm._v(" "), (_vm.serverResponse) ? [_c('div', {
	    staticClass: "validation-messages friendly"
	  }, [_vm._v(_vm._s(_vm.serverResponse))])] : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 868 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(_vm.board.fetchingStatus === 'fetching') ? _c('loader-large') : [(!_vm.category) ? _c('div', {
	    staticClass: "no-forums"
	  }, [_vm._v("This Category Doesn't Exist")]) : _c('category-item', {
	    attrs: {
	      "category": _vm.category,
	      "is-moderator": _vm.isModerator,
	      "board-id": _vm.boardId,
	      "root": _vm.root
	    }
	  })]], 2)
	},staticRenderFns: []}

/***/ }),
/* 869 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('article', {
	    attrs: {
	      "id": "feed-posts-page"
	    }
	  }, [(Object.keys(_vm.feedPosts || {}).length === 0) ? [(_vm.fetchingStatus === 'fetched') ? _c('div', {
	    staticClass: "content-box feed-post"
	  }, [_vm._v("This user has made no posts")]) : _c('loader-large')] : _vm._e(), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "feed-post-collection"
	    }
	  }, [(_vm.layout === 'masonry') ? _c('vue-masonry', {
	    attrs: {
	      "min-width": 450,
	      "horizontal-gutter": 40,
	      "vertical-gutter": 40
	    }
	  }, [(_vm.isMember && !_vm.showNewPostForm) ? _c('button', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        _vm.showNewPostForm = true
	      }
	    }
	  }, [_vm._v("Submit a New Post")]) : _vm._e(), _vm._v(" "), (_vm.isMember && _vm.showNewPostForm) ? _c('div', {
	    staticClass: "feed-post",
	    attrs: {
	      "id": "feed-add-new"
	    }
	  }, [_c('h2', [_vm._v("Submit a new Post")]), _vm._v(" "), _c('form', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newPostSubject),
	      expression: "newPostSubject"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "Subject (optional)"
	    },
	    domProps: {
	      "value": (_vm.newPostSubject)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newPostSubject = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('markdown-editor', {
	    attrs: {
	      "placeholder": "Post Content"
	    },
	    model: {
	      value: (_vm.newPostContent),
	      callback: function($$v) {
	        _vm.newPostContent = $$v
	      },
	      expression: "newPostContent"
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.submitNewPost($event)
	      }
	    }
	  }, [_vm._v("Submit")]), _vm._v(" "), _c('button', {
	    staticClass: "button minor",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.showNewPostForm = false
	      }
	    }
	  }, [_vm._v("Cancel")])], 1)]) : _vm._e(), _vm._v(" "), (Object.keys(_vm.feedPosts || {}).length > 0) ? _vm._l((_vm.feedPosts), function(feedPost) {
	    return _c('feed-status-post', {
	      key: feedPost.id,
	      attrs: {
	        "data": feedPost
	      }
	    })
	  }) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.layout === 'single') ? _c('div', {
	    staticClass: "single-column-container"
	  }, [(_vm.isMember && !_vm.showNewPostForm) ? _c('button', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        _vm.showNewPostForm = true
	      }
	    }
	  }, [_vm._v("Submit a New Post")]) : _vm._e(), _vm._v(" "), (_vm.isMember && _vm.showNewPostForm) ? _c('div', {
	    staticClass: "feed-post",
	    attrs: {
	      "id": "feed-add-new"
	    }
	  }, [_c('h2', [_vm._v("Submit a new Post")]), _vm._v(" "), _c('form', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newPostSubject),
	      expression: "newPostSubject"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "Subject (optional)"
	    },
	    domProps: {
	      "value": (_vm.newPostSubject)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newPostSubject = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('markdown-editor', {
	    attrs: {
	      "placeholder": "Post Content"
	    },
	    model: {
	      value: (_vm.newPostContent),
	      callback: function($$v) {
	        _vm.newPostContent = $$v
	      },
	      expression: "newPostContent"
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.submitNewPost($event)
	      }
	    }
	  }, [_vm._v("Submit")]), _vm._v(" "), _c('button', {
	    staticClass: "button minor",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.showNewPostForm = false
	      }
	    }
	  }, [_vm._v("Cancel")])], 1)]) : _vm._e(), _vm._v(" "), (Object.keys(_vm.feedPosts || {}).length > 0) ? _vm._l((_vm.feedPosts), function(feedPost) {
	    return _c('feed-status-post', {
	      key: feedPost.id,
	      attrs: {
	        "data": feedPost
	      }
	    })
	  }) : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.layout === 'double') ? _c('div', {
	    staticClass: "double-column-container"
	  }, [(_vm.isMember && !_vm.showNewPostForm) ? _c('button', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        _vm.showNewPostForm = true
	      }
	    }
	  }, [_vm._v("Submit a New Post")]) : _vm._e(), _vm._v(" "), _c('vue-masonry', {
	    attrs: {
	      "min-width": 500,
	      "horizontal-gutter": 40,
	      "vertical-gutter": 40
	    }
	  }, [(_vm.isMember && _vm.showNewPostForm) ? _c('div', {
	    staticClass: "feed-post",
	    attrs: {
	      "id": "feed-add-new"
	    }
	  }, [_c('h2', [_vm._v("Submit a new Post")]), _vm._v(" "), _c('form', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newPostSubject),
	      expression: "newPostSubject"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "Subject (optional)"
	    },
	    domProps: {
	      "value": (_vm.newPostSubject)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newPostSubject = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('markdown-editor', {
	    attrs: {
	      "placeholder": "Post Content"
	    },
	    model: {
	      value: (_vm.newPostContent),
	      callback: function($$v) {
	        _vm.newPostContent = $$v
	      },
	      expression: "newPostContent"
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.submitNewPost($event)
	      }
	    }
	  }, [_vm._v("Submit")]), _vm._v(" "), _c('button', {
	    staticClass: "button minor",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.showNewPostForm = false
	      }
	    }
	  }, [_vm._v("Cancel")])], 1)]) : _vm._e(), _vm._v(" "), (Object.keys(_vm.feedPosts || {}).length > 0) ? _vm._l((_vm.feedPosts), function(feedPost) {
	    return _c('feed-status-post', {
	      key: feedPost.id,
	      attrs: {
	        "data": feedPost
	      }
	    })
	  }) : _vm._e()], 2)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
	    staticClass: "load-more-button-container"
	  }, [(_vm.fetchingStatus === 'fetched' && Object.keys(_vm.feedPosts || {}).length > 0 && !_vm.hasFetchedAll) ? _c('button', {
	    attrs: {
	      "id": "feed-fetch-more"
	    },
	    on: {
	      "click": _vm.fetchMore
	    }
	  }, [_vm._v("Load more posts")]) : _vm._e()])], 2)
	},staticRenderFns: []}

/***/ }),
/* 870 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "search-widget"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.searchString),
	      expression: "searchString"
	    }],
	    staticClass: "search-box",
	    attrs: {
	      "type": "text",
	      "placeholder": "Search for Developers & Games"
	    },
	    domProps: {
	      "value": (_vm.searchString)
	    },
	    on: {
	      "blur": _vm.hide,
	      "focus": _vm.show,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.searchString = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (!_vm.isHidden && (_vm.devMatches.length > 0 || _vm.gameMatches.length > 0 || _vm.searchMessage)) ? _c('div', {
	    staticClass: "search-results"
	  }, [(_vm.searchMessage) ? _c('span', [_vm._v(_vm._s(_vm.searchMessage))]) : _vm._e(), _vm._v(" "), (_vm.devMatches.length > 0) ? _c('h3', [_vm._v("Developers")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.devMatches), function(developer) {
	    return _c('router-link', {
	      staticClass: "match",
	      attrs: {
	        "to": ("/Developer/" + (developer.stringUrl))
	      }
	    }, [_c('div', {
	      staticClass: "avatar-container"
	    }, [_c('avatar', {
	      attrs: {
	        "profile-data": developer,
	        "profile-type": "developer",
	        "size": "small",
	        "show-xp-info": false
	      }
	    })], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(developer.alias))])])
	  }), _vm._v(" "), (_vm.gameMatches.length > 0) ? _c('h3', [_vm._v("Games")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.gameMatches), function(game) {
	    return _c('router-link', {
	      staticClass: "match",
	      attrs: {
	        "to": ("/Game/" + (game.stringUrl))
	      }
	    }, [_c('div', {
	      staticClass: "avatar-container"
	    }, [_c('avatar', {
	      attrs: {
	        "profile-data": game,
	        "profile-type": "game",
	        "size": "small",
	        "show-xp-info": false
	      }
	    })], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(game.alias))])])
	  })], 2) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 871 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(!_vm.forum) ? _c('loader-large') : _vm._e(), _vm._v(" "), (_vm.forum) ? _c('section', {
	    staticClass: "threads"
	  }, [_c('h2', [_c('router-link', {
	    attrs: {
	      "to": ("/" + _vm.root)
	    }
	  }, [_vm._v(_vm._s(_vm.category.title))]), _vm._v(" "), _c('i', {
	    staticClass: "fas fa-chevron-right"
	  }), _vm._v(" " + _vm._s(_vm.forum.title) + "\n        ")], 1), _vm._v(" "), _c('section', {
	    staticClass: "pagination"
	  }, [_c('label', [_vm._v("page")]), _vm._v(" "), _c('pagination', {
	    attrs: {
	      "max-page": _vm.totalPages,
	      "current-page": _vm.currentPage,
	      "spread": 5
	    },
	    on: {
	      "switchToPage": _vm.switchToResultsPage
	    }
	  })], 1), _vm._v(" "), (_vm.canPost && !_vm.addThreadMode) ? _c('section', {
	    staticClass: "controls"
	  }, [_c('div', {
	    on: {
	      "click": function($event) {
	        _vm.addThreadMode = true
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-plus"
	  }), _vm._v(" Create a new Thread")])]) : _vm._e(), _vm._v(" "), (_vm.addThreadMode) ? _c('section', {
	    staticClass: "add-thread-form"
	  }, [(_vm.newThreadSaving) ? _c('saver-large') : _vm._e(), _vm._v(" "), (!_vm.newThreadSaving) ? [_c('h3', [_vm._v("Create a Thread")]), _vm._v(" "), (_vm.newThreadErrorMessage) ? _c('div', {
	    staticClass: "validation-messages error"
	  }, [_vm._v(_vm._s(_vm.newThreadErrorMessage))]) : _vm._e(), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newThreadTitle),
	      expression: "newThreadTitle"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "Thread Subject"
	    },
	    domProps: {
	      "value": (_vm.newThreadTitle)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newThreadTitle = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('markdown-editor', {
	    attrs: {
	      "placeholder": "Post Content"
	    },
	    model: {
	      value: (_vm.newThreadContent),
	      callback: function($$v) {
	        _vm.newThreadContent = $$v
	      },
	      expression: "newThreadContent"
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "button minor",
	    on: {
	      "click": function($event) {
	        _vm.addThreadMode = false
	      }
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
	    staticClass: "button",
	    on: {
	      "click": _vm.saveNewThread
	    }
	  }, [_vm._v("Save")])] : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('section', {
	    staticClass: "thread-list"
	  }, [_vm._m(0), _vm._v(" "), (_vm.forum.fetchingStatus !== 'fetched') ? _c('loader-large') : _vm._e(), _vm._v(" "), (_vm.forum.fetchingStatus === 'fetched' && _vm.threads.length === 0) ? _c('div', {
	    staticClass: "no-threads"
	  }, [_vm._v("No one has posted a thread in this forum yet")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.threads), function(thread) {
	    return (_vm.forum.fetchingStatus === 'fetched') ? _c('router-link', {
	      staticClass: "thread",
	      attrs: {
	        "to": ("/" + _vm.root + "/" + (_vm.$route.params.category) + "/" + (_vm.$route.params.forum) + "/" + (thread.stringUrl))
	      }
	    }, [_c('div', {
	      staticClass: "title"
	    }, [(thread.locked) ? _c('i', {
	      staticClass: "fas fa-lock"
	    }) : _vm._e(), (thread.pinned) ? _c('i', {
	      staticClass: "fas fa-thumbtack"
	    }) : _vm._e(), _vm._v(_vm._s(thread.title))]), _vm._v(" "), _c('div', {
	      staticClass: "last-reply"
	    }, [_vm._v(_vm._s(_vm._f("formatDate")(thread.lastPostTime)))]), _vm._v(" "), _c('div', {
	      staticClass: "stats"
	    }, [_c('span', [_vm._v(_vm._s(thread.totalPosts) + " posts")]), _c('span', [_vm._v(_vm._s(thread.views) + " views")])])]) : _vm._e()
	  })], 2), _vm._v(" "), _c('section', {
	    staticClass: "pagination"
	  }, [_c('label', [_vm._v("page")]), _vm._v(" "), _c('pagination', {
	    attrs: {
	      "max-page": _vm.totalPages,
	      "current-page": _vm.currentPage,
	      "spread": 5
	    },
	    on: {
	      "switchToPage": _vm.switchToResultsPage
	    }
	  })], 1)]) : _vm._e()], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "thread-list-header"
	  }, [_c('div', [_vm._v("Subject")]), _vm._v(" "), _c('div', [_vm._v("Last Reply")]), _vm._v(" "), _c('div', [_vm._v("Stats")])])
	}]}

/***/ }),
/* 872 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    attrs: {
	      "id": "game-content-members-edit"
	    }
	  }, [_c('h2', [_c('span', {
	    staticClass: "label"
	  }, [_vm._v("Manage Members")]), _vm._v(" "), _c('span', {
	    staticClass: "enter-edit-mode"
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.exitEditMode($event)
	      }
	    }
	  }, [_vm._v("Exit Manage Mode")])])]), _vm._v(" "), _vm._l((_vm.formData), function(member) {
	    return (member.status === 'Current') ? _c('editable-member', {
	      attrs: {
	        "member": member,
	        "positions": _vm.positions,
	        "my-id": _vm.myId,
	        "game-id": _vm.gameId
	      }
	    }) : _vm._e()
	  })], 2)
	},staticRenderFns: []}

/***/ }),
/* 873 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('article', {
	    attrs: {
	      "id": "online-users"
	    }
	  }, [_c('ul', {
	    attrs: {
	      "id": "online-users-list"
	    }
	  }, _vm._l((_vm.onlineUserList), function(user) {
	    return (user.id) ? _c('li', [(_vm.isLoggedIn) ? [(_vm.loggedUser.id !== user.id) ? _c('span', {
	      staticClass: "message-user",
	      on: {
	        "click": function($event) {
	          _vm.openConversation(user)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "far fa-comment-alt"
	    }), _vm._v(" Chat\n                ")]) : _vm._e(), _vm._v(" "), (_vm.loggedUser.id === user.id) ? _c('span', {
	      staticClass: "self-user-message-space"
	    }) : _vm._e()] : _vm._e(), _vm._v(" "), _c('span', {
	      staticClass: "alias"
	    }, [_c('router-link', {
	      attrs: {
	        "to": ("/Developer/" + (user.stringUrl))
	      }
	    }, [_c('i', {
	      staticClass: "fas fa-user"
	    }), _vm._v(" " + _vm._s(user.alias))])], 1)], 2) : _vm._e()
	  }))])
	},staticRenderFns: []}

/***/ }),
/* 874 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    attrs: {
	      "id": "edit-developer-roles-and-skills"
	    }
	  }, [_c('div', {
	    staticClass: "edit-container roles-and-skills"
	  }, [_c('label', [_vm._v("Developer Role")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formData.role),
	      expression: "formData.role"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "Developer Roles (e.x: Pixel Artist, Engine Programmer, 3D Modeler...)"
	    },
	    domProps: {
	      "value": (_vm.formData.role)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.formData.role = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "developer-roles"
	  }, [_c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formData.isProducer),
	      expression: "formData.isProducer"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.formData.isProducer) ? _vm._i(_vm.formData.isProducer, null) > -1 : (_vm.formData.isProducer)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.formData.isProducer,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.formData.isProducer = $$a.concat($$v))
	          } else {
	            $$i > -1 && (_vm.formData.isProducer = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.formData.isProducer = $$c
	        }
	      }
	    }
	  }), _vm._v("Producer")]), _vm._v(" "), _c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formData.isDesigner),
	      expression: "formData.isDesigner"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.formData.isDesigner) ? _vm._i(_vm.formData.isDesigner, null) > -1 : (_vm.formData.isDesigner)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.formData.isDesigner,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.formData.isDesigner = $$a.concat($$v))
	          } else {
	            $$i > -1 && (_vm.formData.isDesigner = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.formData.isDesigner = $$c
	        }
	      }
	    }
	  }), _vm._v("Designer")]), _vm._v(" "), _c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formData.isArtist),
	      expression: "formData.isArtist"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.formData.isArtist) ? _vm._i(_vm.formData.isArtist, null) > -1 : (_vm.formData.isArtist)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.formData.isArtist,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.formData.isArtist = $$a.concat($$v))
	          } else {
	            $$i > -1 && (_vm.formData.isArtist = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.formData.isArtist = $$c
	        }
	      }
	    }
	  }), _vm._v("Artist")]), _vm._v(" "), _c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formData.isProgrammer),
	      expression: "formData.isProgrammer"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.formData.isProgrammer) ? _vm._i(_vm.formData.isProgrammer, null) > -1 : (_vm.formData.isProgrammer)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.formData.isProgrammer,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.formData.isProgrammer = $$a.concat($$v))
	          } else {
	            $$i > -1 && (_vm.formData.isProgrammer = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.formData.isProgrammer = $$c
	        }
	      }
	    }
	  }), _vm._v("Programmer")]), _vm._v(" "), _c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formData.isWriter),
	      expression: "formData.isWriter"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.formData.isWriter) ? _vm._i(_vm.formData.isWriter, null) > -1 : (_vm.formData.isWriter)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.formData.isWriter,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.formData.isWriter = $$a.concat($$v))
	          } else {
	            $$i > -1 && (_vm.formData.isWriter = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.formData.isWriter = $$c
	        }
	      }
	    }
	  }), _vm._v("Writer")]), _vm._v(" "), _c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formData.isMusician),
	      expression: "formData.isMusician"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.formData.isMusician) ? _vm._i(_vm.formData.isMusician, null) > -1 : (_vm.formData.isMusician)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.formData.isMusician,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.formData.isMusician = $$a.concat($$v))
	          } else {
	            $$i > -1 && (_vm.formData.isMusician = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.formData.isMusician = $$c
	        }
	      }
	    }
	  }), _vm._v("Musician")]), _vm._v(" "), _c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formData.isSfxArtist),
	      expression: "formData.isSfxArtist"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.formData.isSfxArtist) ? _vm._i(_vm.formData.isSfxArtist, null) > -1 : (_vm.formData.isSfxArtist)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.formData.isSfxArtist,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.formData.isSfxArtist = $$a.concat($$v))
	          } else {
	            $$i > -1 && (_vm.formData.isSfxArtist = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.formData.isSfxArtist = $$c
	        }
	      }
	    }
	  }), _vm._v("SFX Artist")]), _vm._v(" "), _c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formData.isTester),
	      expression: "formData.isTester"
	    }],
	    attrs: {
	      "type": "checkbox"
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.formData.isTester) ? _vm._i(_vm.formData.isTester, null) > -1 : (_vm.formData.isTester)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.formData.isTester,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = null,
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.formData.isTester = $$a.concat($$v))
	          } else {
	            $$i > -1 && (_vm.formData.isTester = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.formData.isTester = $$c
	        }
	      }
	    }
	  }), _vm._v("Tester")])]), _vm._v(" "), _c('label', [_vm._v("Skills")]), _vm._v(" "), _c('div', {
	    staticClass: "existing-skill-list"
	  }, [_vm._l((_vm.formData.skills), function(skillId) {
	    return (_vm.formData.skills && _vm.formData.skills.length > 0) ? _c('span', {
	      staticClass: "matching-skill-tag",
	      on: {
	        "click": function($event) {
	          _vm.removeSkill(skillId)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fas fa-minus-circle"
	    }), _vm._v("  " + _vm._s(_vm.skillList[skillId].skill) + "\n            ")]) : _vm._e()
	  }), _vm._v(" "), (_vm.formData.skills && _vm.formData.skills.length === 0) ? _c('span', [_vm._v("No skills entered")]) : _vm._e()], 2), _vm._v(" "), _c('label', [_vm._v("Add Skill")]), _vm._v(" "), _c('div', {
	    staticClass: "add-skill-form"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.enteredSkill),
	      expression: "enteredSkill"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "Search for Skill Tags..."
	    },
	    domProps: {
	      "value": (_vm.enteredSkill)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.enteredSkill = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (_vm.enteredSkill.length > 0) ? _c('button', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        _vm.enteredSkill = ''
	      }
	    }
	  }, [_vm._v("X")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "matching-skill-list"
	  }, [(_vm.matchingSkills.length === 0) ? _c('span', [_vm._v("No matching tags... Search by skill name, or type a category to see all entries.")]) : _vm._e(), _vm._v(" "), (_vm.matchingSkills.length === 0) ? _c('span', [_vm._v("Categories: Art, Software, Development, Engine, Writing, Production, Testing")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.matchingSkills), function(skill) {
	    return _c('span', {
	      staticClass: "matching-skill-tag",
	      on: {
	        "click": function($event) {
	          _vm.addSkill(skill.id)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fas fa-plus-circle"
	    }), _vm._v(" " + _vm._s(skill.skill) + "\n            ")])
	  })], 2), _vm._v(" "), _c('div', {
	    staticClass: "buttons"
	  }, [_c('button', {
	    staticClass: "button minor",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.cancelChanges($event)
	      }
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.submitChanges($event)
	      }
	    }
	  }, [_vm._v("Save")])])])])
	},staticRenderFns: []}

/***/ }),
/* 875 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('article', {
	    attrs: {
	      "id": "developer-page"
	    }
	  }, [_c('div', {
	    attrs: {
	      "id": "profile-details-container"
	    }
	  }, [(!_vm.developerDoesntExist) ? _c('dev-details') : _vm._e()], 1), _vm._v(" "), (!_vm.developerDoesntExist) ? _c('section', {
	    attrs: {
	      "id": "developer-page-content"
	    }
	  }, [(!_vm.developerDoesntExist) ? _c('nav', {
	    staticClass: "switch profile-page-navigation",
	    attrs: {
	      "id": "developer-page-navigation"
	    }
	  }, [_c('router-link', {
	    class: {
	      active: _vm.selectedSubpage === 'RecentActivity'
	    },
	    attrs: {
	      "to": '/Developer/' + _vm.$route.params.developer,
	      "title": "Recent Activity"
	    }
	  }, [_vm._v("Recent Activity")]), _vm._v(" "), _c('router-link', {
	    class: {
	      active: _vm.selectedSubpage === 'Portfolio'
	    },
	    attrs: {
	      "to": '/Developer/' + _vm.$route.params.developer + '/Portfolio',
	      "title": "Portfolio"
	    }
	  }, [_vm._v("Portfolio")]), _vm._v(" "), _c('router-link', {
	    class: {
	      active: _vm.selectedSubpage === 'Connections'
	    },
	    attrs: {
	      "to": '/Developer/' + _vm.$route.params.developer + '/Connections',
	      "title": "Connections"
	    }
	  }, [_vm._v("Connections")])], 1) : _vm._e(), _vm._v(" "), _c('router-view')], 1) : _vm._e(), _vm._v(" "), (_vm.developerDoesntExist) ? _c('div', {
	    staticClass: "validation-messages error"
	  }, [_vm._v("This Developer Doesn't Exist")]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 876 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('svg', {
	    staticClass: "dt-icon icon-game",
	    attrs: {
	      "version": "1.1",
	      "id": "Layer_1",
	      "xmlns": "http://www.w3.org/2000/svg",
	      "xmlns:xlink": "http://www.w3.org/1999/xlink",
	      "x": "0px",
	      "y": "0px",
	      "width": "600px",
	      "height": "400px",
	      "viewBox": "0 0 600 400",
	      "enable-background": "new 0 0 600 400",
	      "xml:space": "preserve"
	    }
	  }, [_c('g', [_c('g', [_c('path', {
	    attrs: {
	      "fill": "#010101",
	      "d": "M169.18,99.833c0,38.212,0,76.425,0,114.638c0,19.346,30,19.346,30,0c0-38.212,0-76.425,0-114.638\n\t\t\tC199.18,80.487,169.18,80.487,169.18,99.833L169.18,99.833z"
	    }
	  })])]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
	    attrs: {
	      "fill": "#010101",
	      "d": "M120.036,172.152c42.763,0,85.525,0,128.288,0c19.346,0,19.346-30,0-30c-42.763,0-85.525,0-128.288,0\n\t\t\tC100.69,142.152,100.69,172.152,120.036,172.152L120.036,172.152z"
	    }
	  })])]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
	    attrs: {
	      "fill": "#010101",
	      "d": "M332.07,84.833c-22.4,0-44.801,0-67.202,0c-19.346,0-19.346,30,0,30c22.401,0,44.802,0,67.202,0\n\t\t\tC351.416,114.833,351.416,84.833,332.07,84.833L332.07,84.833z"
	    }
	  })])]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
	    attrs: {
	      "fill": "#010101",
	      "d": "M264.868,218.302c22.401,0,44.802,0,67.202,0c19.346,0,19.346-30,0-30c-22.4,0-44.801,0-67.202,0\n\t\t\tC245.522,188.302,245.522,218.302,264.868,218.302L264.868,218.302z"
	    }
	  })])]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
	    attrs: {
	      "fill": "#010101",
	      "d": "M300,264.2c2.003,0.016,3.994,0.106,5.99,0.273c0.919,0.077,4.397,0.581-0.049-0.058\n\t\t\tc0.979,0.141,1.953,0.324,2.926,0.507c4.236,0.796,8.374,2.068,12.409,3.571c0.779,0.29,4.027,1.658,0.15,0.004\n\t\t\tc0.935,0.398,1.855,0.828,2.775,1.258c1.862,0.868,3.683,1.824,5.487,2.805c4.018,2.182,7.864,4.669,11.612,7.281\n\t\t\tc1.778,1.239,3.516,2.537,5.239,3.851c-3.2-2.438,2.149,1.787,2.985,2.482c3.761,3.126,7.382,6.416,10.938,9.771\n\t\t\tc7.029,6.628,13.694,13.638,20.244,20.735c12.742,13.808,24.899,28.165,38.132,41.516c12.181,12.289,25.518,23.673,41.616,30.368\n\t\t\tc16.64,6.92,35.537,4.223,51.6-2.923c14.96-6.654,26.529-20.372,33.721-34.755c11.626-23.255,15.562-50.45,15.229-76.26\n\t\t\tc-0.146-11.303-3.548-22.706-5.484-33.814c-2.711-15.547-5.173-31.136-7.964-46.668c-5.304-29.528-12.069-58.835-25.036-86.054\n\t\t\tc-13.076-27.45-33.968-50.298-60.031-65.925c-35.528-21.3-77.931-28.766-118.632-31.984c-49.971-3.952-102.52-2.498-151.307,9.871\n\t\t\tc-33.075,8.385-65.154,23.801-88.658,49.038C61.866,114.216,55.095,178.951,45.139,237c-1.374,8.009-2.807,16.008-4.347,23.986\n\t\t\tc-0.797,4.126-1.674,8.201-1.774,12.407c-0.22,9.287,0.349,18.608,1.484,27.823c3.876,31.48,14.65,66.394,44.24,82.827\n\t\t\tc15.151,8.415,35.1,11.407,51.68,5.709c15.765-5.418,28.861-16.473,40.583-28c12.962-12.747,24.626-26.771,36.747-40.301\n\t\t\tc6.36-7.1,12.842-14.091,19.596-20.818c3.192-3.179,6.468-6.272,9.813-9.291c1.647-1.486,3.327-2.937,5.02-4.372\n\t\t\tc0.839-0.711,1.689-1.407,2.54-2.104c0.602-0.492,4.508-3.538,1.243-1.03c7.769-5.969,16.144-11.166,25.127-15.099\n\t\t\tc-3.837,1.68-0.591,0.285,0.183-0.013c1.257-0.484,2.534-0.917,3.813-1.341c2.23-0.74,4.504-1.341,6.791-1.88\n\t\t\tc0.98-0.23,1.969-0.423,2.957-0.614c0.948-0.183,5.643-0.787,1.006-0.218C294.545,264.339,297.274,264.22,300,264.2\n\t\t\tc8.176-0.06,15-6.778,15-15c0-8.132-6.822-15.06-15-15c-39.804,0.29-71.56,27.594-97.403,55.051\n\t\t\tc-12.802,13.601-24.757,27.968-37.475,41.646c-5.695,6.125-11.582,12.083-17.861,17.611c-1.389,1.222-2.81,2.406-4.246,3.572\n\t\t\tc-0.715,0.581-3.318,2.559,0.21-0.135c-0.697,0.532-1.408,1.047-2.118,1.561c-2.922,2.116-5.989,4.026-9.173,5.721\n\t\t\tc-1.122,0.597-6.311,2.844-1.364,0.792c-1.389,0.576-2.814,1.058-4.25,1.498c-1.399,0.43-2.829,0.75-4.265,1.027\n\t\t\tc-2.835,0.547,3.995-0.451,1.135-0.127c-0.95,0.107-1.907,0.148-2.862,0.178c-2.041,0.064-4.092-0.058-6.127-0.203\n\t\t\tc-0.88-0.063-4.513-0.537-0.122,0.071c-0.991-0.137-1.974-0.324-2.956-0.512c-1.894-0.362-3.756-0.869-5.6-1.427\n\t\t\tc-0.893-0.271-1.77-0.588-2.646-0.905c-2.533-0.916,3.201,1.515-0.608-0.263c-1.61-0.75-3.157-1.627-4.677-2.542\n\t\t\tc-1.022-0.615-5.85-4.166-1.955-1.142c-2.944-2.285-5.582-4.946-8.014-7.762c-0.562-0.65-1.096-1.323-1.63-1.996\n\t\t\tc2.789,3.51,0.852,1.056,0.292,0.271c-1.004-1.407-1.929-2.868-2.829-4.343c-1.965-3.218-3.642-6.607-5.166-10.053\n\t\t\tc2.034,4.598-0.348-0.968-0.766-2.085c-0.609-1.632-1.16-3.284-1.695-4.941c-1.143-3.544-2.089-7.149-2.933-10.775\n\t\t\tc-0.751-3.229-1.369-6.487-1.917-9.755c-0.263-1.566-0.493-3.137-0.713-4.709c0.786,5.608-0.048-0.665-0.195-2.03\n\t\t\tc-0.9-8.394-1.291-16.887-1.021-25.327c0.015-0.46,0.032-0.92,0.057-1.38c-0.364,6.681,0.273-0.085,0.611-1.826\n\t\t\tc0.437-2.249,0.86-4.5,1.28-6.752c1.479-7.945,2.851-15.91,4.198-23.878c2.601-15.389,5.079-30.799,8.016-46.128\n\t\t\tc2.767-14.447,5.994-28.822,10.289-42.897c2.049-6.714,4.391-13.338,7.04-19.839c1.172-2.878-1.447,3.377-0.228,0.524\n\t\t\tc0.325-0.76,0.66-1.516,0.995-2.272c0.667-1.507,1.365-3,2.074-4.487c1.527-3.205,3.174-6.35,4.904-9.449\n\t\t\tc3.317-5.942,7.073-11.634,11.193-17.049c-3.092,4.063,0.489-0.542,1.25-1.456c1.057-1.272,2.15-2.515,3.254-3.747\n\t\t\tc2.426-2.706,4.989-5.287,7.63-7.782c2.499-2.36,5.113-4.598,7.787-6.757c0.727-0.586,3.262-2.521-0.273,0.187\n\t\t\tc0.703-0.538,1.416-1.063,2.128-1.587c1.688-1.243,3.417-2.431,5.159-3.597c6.591-4.413,13.578-8.213,20.753-11.581\n\t\t\tc1.834-0.861,3.691-1.674,5.554-2.473c-4.086,1.751,2.153-0.818,3.191-1.217c4.427-1.701,8.927-3.209,13.457-4.612\n\t\t\tc9.596-2.971,19.398-5.252,29.263-7.128c5.219-0.992,10.468-1.822,15.728-2.57c4.524-0.643-3.08,0.39,1.509-0.193\n\t\t\tc1.401-0.178,2.804-0.341,4.208-0.505c3.363-0.392,6.734-0.724,10.105-1.035c13.134-1.211,26.323-1.788,39.508-2.012\n\t\t\tc13.949-0.238,27.909,0.001,41.84,0.713c6.103,0.312,12.198,0.758,18.284,1.299c2.899,0.258,5.794,0.559,8.687,0.875\n\t\t\tc1.412,0.154,2.822,0.324,4.232,0.493c0.927,0.113,1.854,0.229,2.78,0.349c-1.693-0.234-1.652-0.228,0.123,0.017\n\t\t\tc19.894,2.752,39.639,7.197,58.447,14.31c1.039,0.393,7.289,2.947,3.191,1.217c1.867,0.788,3.714,1.623,5.554,2.473\n\t\t\tc3.829,1.771,7.577,3.712,11.259,5.77c3.24,1.811,6.397,3.766,9.494,5.811c1.503,0.992,2.977,2.026,4.439,3.074\n\t\t\tc0.722,0.517,1.433,1.048,2.145,1.579c2.125,1.584-2.806-2.234,0.431,0.345c5.531,4.409,10.664,9.304,15.417,14.539\n\t\t\tc1.112,1.225,2.189,2.481,3.255,3.747c0.764,0.907,4.368,5.504,1.249,1.456c2.162,2.805,4.188,5.713,6.128,8.674\n\t\t\tc3.734,5.699,7.013,11.689,9.97,17.823c0.716,1.484,1.4,2.983,2.074,4.487c0.339,0.755,0.667,1.514,0.995,2.272\n\t\t\tc1.231,2.847-1.412-3.397-0.228-0.524c1.382,3.352,2.651,6.749,3.861,10.166c4.834,13.662,8.338,27.767,11.331,41.933\n\t\t\tc3.184,15.073,5.715,30.278,8.257,45.469c1.32,7.891,2.639,15.781,4.019,23.662c0.672,3.841,1.364,7.679,2.074,11.513\n\t\t\tc0.357,1.93,0.724,3.858,1.094,5.786c0.351,1.83,1.178,9.587,0.798,2.792c0.343,6.125,0.108,12.312-0.269,18.427\n\t\t\tc-0.171,2.765-0.411,5.525-0.696,8.28c-0.154,1.497-0.336,2.99-0.525,4.482c0.72-5.656-0.16,0.89-0.383,2.257\n\t\t\tc-1.132,6.947-2.736,13.816-4.85,20.53c-0.522,1.661-1.099,3.305-1.694,4.941c-0.406,1.114-2.762,6.708-0.766,2.085\n\t\t\tc-1.495,3.463-3.237,6.813-5.166,10.053c-0.884,1.485-1.843,2.924-2.829,4.343c-0.543,0.781-2.461,3.29,0.293-0.271\n\t\t\tc-0.525,0.68-1.078,1.338-1.631,1.996c-2.397,2.854-5.109,5.43-8.014,7.762c3.826-3.071-0.924,0.497-1.954,1.142\n\t\t\tc-1.506,0.942-3.083,1.764-4.678,2.542c-0.853,0.417-3.852,1.587,0.252-0.065c-0.859,0.346-1.737,0.646-2.613,0.945\n\t\t\tc-2.121,0.725-4.302,1.256-6.493,1.715c-0.979,0.204-1.969,0.358-2.957,0.512c4.358-0.679,0.774-0.15-0.121-0.071\n\t\t\tc-2.038,0.179-4.092,0.225-6.137,0.203c-0.728-0.008-1.454-0.062-2.179-0.114c-2.894-0.213,3.964,0.62,1.086,0.174\n\t\t\tc-1.717-0.266-3.404-0.697-5.071-1.181c-1.475-0.428-2.916-0.969-4.342-1.537c4.906,1.956-0.348-0.265-1.483-0.851\n\t\t\tc-3.29-1.697-6.404-3.726-9.423-5.86c-0.736-0.521-1.458-1.061-2.181-1.599c-2.64-1.971,2.735,2.159,0.125,0.083\n\t\t\tc-1.488-1.184-2.938-2.414-4.378-3.655c-3.29-2.836-6.444-5.827-9.546-8.866c-13.329-13.065-25.409-27.361-37.98-41.141\n\t\t\tc-25.751-28.224-55.678-58.128-95.342-63.237c-2.976-0.383-5.948-0.587-8.948-0.61c-8.177-0.063-15,6.871-15,15\n\t\t\tC285,257.425,291.824,264.138,300,264.2z"
	    }
	  })])]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
	    attrs: {
	      "fill": "#010101",
	      "d": "M423.025,127.914c0.425-2.144,0.444-2.399,0.058-0.768c0.919-1.936,0.979-2.198,0.181-0.787\n\t\t\tc0.576-1.131,1.425-1.999,2.544-2.601c-2.102,1.498,1.985-0.607,2.83-0.657c1.352,0.004,2.586,0.385,3.702,1.141\n\t\t\tc-1.375-0.824-1.166-0.614,0.628,0.627c1.22,1.792,1.397,1.997,0.531,0.614c0.236,0.554,0.474,1.108,0.71,1.662\n\t\t\tc-0.387-1.631-0.367-1.375,0.058,0.768c-0.425,2.143-0.444,2.399-0.058,0.768c-0.919,1.937-0.979,2.199-0.181,0.787\n\t\t\tc-0.578,1.132-1.427,1.999-2.548,2.601c2.097-1.498-1.999,0.607-2.843,0.657c-1.348-0.005-2.578-0.385-3.691-1.141\n\t\t\tc1.376,0.823,1.169,0.614-0.623-0.627c-1.22-1.792-1.396-1.997-0.53-0.614c-0.236-0.554-0.474-1.108-0.71-1.662\n\t\t\tC423.47,130.313,423.45,130.057,423.025,127.914c0.404,8.164,6.517,15,15,15c7.87,0,15.405-6.827,15-15\n\t\t\tc-0.69-13.923-10.308-24.366-24.388-25.188c-14.042-0.82-23.742,12.497-24.371,25.188c-0.688,13.884,11.34,24.424,24.371,25.188\n\t\t\tc14.048,0.823,23.758-12.489,24.388-25.188c0.405-8.173-7.13-15-15-15C429.542,112.914,423.43,119.75,423.025,127.914z"
	    }
	  })])]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
	    attrs: {
	      "fill": "#010101",
	      "d": "M383.417,182.615c0.452-2.357,0.49-2.739,0.113-1.146c1.008-2.12,1.12-2.492,0.337-1.116\n\t\t\tc0.666-1.264,1.625-2.239,2.877-2.928c-0.253,0.142-0.507,0.285-0.76,0.427c1.258-0.827,2.64-1.243,4.147-1.248\n\t\t\tc1.511,0.005,2.896,0.421,4.157,1.248c-1.345-0.801-1.041-0.524,0.91,0.83c1.34,1.947,1.588,2.247,0.744,0.899\n\t\t\tc0.269,0.629,0.536,1.258,0.805,1.888c-0.377-1.593-0.339-1.211,0.113,1.146c-0.452,2.357-0.49,2.739-0.113,1.146\n\t\t\tc-1.008,2.12-1.121,2.492-0.338,1.115c-0.667,1.264-1.627,2.24-2.88,2.928c0.253-0.143,0.506-0.285,0.759-0.427\n\t\t\tc-1.262,0.827-2.646,1.243-4.157,1.248c-1.508-0.005-2.89-0.421-4.147-1.248c1.345,0.801,1.043,0.524-0.906-0.83\n\t\t\tc-1.34-1.946-1.588-2.246-0.743-0.899c-0.269-0.629-0.536-1.258-0.805-1.887C383.907,185.354,383.869,184.972,383.417,182.615\n\t\t\tc0.405,8.164,6.517,15,15,15c7.87,0,15.405-6.827,15-15c-0.659-13.286-9.864-23.207-23.285-23.99\n\t\t\tc-13.386-0.782-22.67,11.876-23.271,23.99c-0.657,13.249,10.852,23.262,23.271,23.99c13.391,0.784,22.684-11.869,23.285-23.99\n\t\t\tc0.405-8.173-7.13-15-15-15C389.934,167.615,383.822,174.452,383.417,182.615z"
	    }
	  })])])])
	},staticRenderFns: []}

/***/ }),
/* 877 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('article', {
	    attrs: {
	      "id": "forums"
	    }
	  }, [(_vm.board !== undefined) ? [(!_vm.isCategorySet) ? _c('category-list', {
	    attrs: {
	      "board-id": _vm.boardId,
	      "board": _vm.board,
	      "root": "Forums",
	      "is-moderator": _vm.isModerator,
	      "can-post": _vm.canPost
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isCategorySet && !_vm.isForumSet) ? _c('forum-list', {
	    attrs: {
	      "board-id": _vm.boardId,
	      "board": _vm.board,
	      "root": "Forums",
	      "is-moderator": _vm.isModerator,
	      "can-post": _vm.canPost
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isCategorySet && _vm.isForumSet && !_vm.isThreadSet) ? _c('thread-list', {
	    attrs: {
	      "board-id": _vm.boardId,
	      "board": _vm.board,
	      "root": "Forums",
	      "is-moderator": _vm.isModerator,
	      "can-post": _vm.canPost
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isCategorySet && _vm.isForumSet && _vm.isThreadSet) ? _c('post-list', {
	    attrs: {
	      "board-id": _vm.boardId,
	      "board": _vm.board,
	      "root": "Forums",
	      "is-moderator": _vm.isModerator,
	      "can-post": _vm.canPost
	    }
	  }) : _vm._e()] : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 878 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('svg', {
	    staticClass: "dt-icon icon-devteam",
	    attrs: {
	      "version": "1.1",
	      "id": "Layer_1",
	      "xmlns": "http://www.w3.org/2000/svg",
	      "xmlns:xlink": "http://www.w3.org/1999/xlink",
	      "x": "0px",
	      "y": "0px",
	      "width": "600px",
	      "height": "400px",
	      "viewBox": "0 0 600 400",
	      "enable-background": "new 0 0 600 400",
	      "xml:space": "preserve"
	    }
	  }, [_c('g', [_c('title', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('rect', {
	    staticStyle: {
	      "fill": "white",
	      "stroke": "1px red solid"
	    },
	    attrs: {
	      "x": "0",
	      "y": "0",
	      "width": "600",
	      "height": "400"
	    }
	  })]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
	    attrs: {
	      "fill": "#010101",
	      "d": "M368.289,177.012c4.443,2.08,8.733,4.41,12.873,7.044c2.024,1.289,3.974,2.69,5.892,4.129\n\t\t\tc-2.909-2.183,0.236,0.271,0.676,0.64c1.214,1.017,2.378,2.092,3.533,3.175c1.734,1.625,3.362,3.358,4.95,5.125\n\t\t\tc0.797,0.887,1.555,1.808,2.313,2.729c2.553,3.103-1.813-2.483,0.564,0.778c3.142,4.313,5.751,8.99,8.014,13.815\n\t\t\tc1.793,3.823-1.102-2.852,0.487,1.116c0.484,1.21,0.917,2.439,1.351,3.668c0.891,2.529,1.621,5.113,2.303,7.706\n\t\t\tc0.711,2.709,1.258,5.458,1.756,8.212c0.043,0.235,0.734,4.928,0.322,1.772c0.26,1.991,0.436,3.992,0.601,5.992\n\t\t\tc0.966,11.685,0.484,23.582,0.492,35.301c0.003,4.076-0.027,8.151-0.148,12.226c-0.05,1.684-0.133,3.366-0.237,5.048\n\t\t\tc-0.09,1.455-0.838,7.728-0.027,1.725c-0.302,2.234-0.777,4.448-1.538,6.573c-0.774,2.164,1.748-3.886,0.773-1.878\n\t\t\tc-0.189,0.391-0.413,0.762-0.639,1.132c-1.37,2.25,3.211-3.218,0.252-0.597c4.063-3.599,2.239-1.609,0.688-0.847\n\t\t\tc5.086-2.501,2.344-0.94,0.698-0.54c-3.864,0.941,3.879-0.319,0.509-0.029c-1.371,0.117-2.752,0.118-4.126,0.101\n\t\t\tc-6.97-0.088-13.948-1.148-20.853-2.009c-3.801-0.474-7.603-0.947-11.406-1.401c-8.139-0.971-15,7.558-15,15\n\t\t\tc0,8.909,6.884,14.032,15,15c14.224,1.696,29.575,5.355,43.851,2.268c15.285-3.307,20.169-17.815,21.575-31.501\n\t\t\tc0.811-7.883,0.643-15.886,0.622-23.798c-0.032-12.082,0.365-24.259-0.912-36.288c-2.589-24.377-11.428-47.186-28.493-65.104\n\t\t\tc-8.869-9.313-19.962-16.752-31.574-22.187c-7.405-3.466-16.114-2.145-20.522,5.381\n\t\t\tC359.062,163.054,360.884,173.546,368.289,177.012L368.289,177.012z"
	    }
	  })])]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
	    attrs: {
	      "fill": "#010101",
	      "d": "M234.814,296.467c-15.118,1.572-30.632,4.954-45.876,4.656c-1.042-0.021-2.08-0.1-3.114-0.214\n\t\t\tc5.975,0.66,2.361,0.334,0.875-0.068c-3.468-0.937,3.473,1.762,0.985,0.479c-3.419-1.763,2.418,2.287,0.64,0.571\n\t\t\tc-2.443-2.357,2.197,3.311,0.698,0.905c-0.219-0.351-0.404-0.722-0.59-1.091c-0.983-1.954,1.619,4.053,0.825,1.951\n\t\t\tc-0.349-0.925-0.6-1.886-0.833-2.846c-0.345-1.42-1.019-6.527-0.254-0.6c-0.895-6.933-0.807-14.013-0.82-20.989\n\t\t\tc-0.021-11.021-0.245-22.115,0.283-33.124c0.144-2.999,0.435-5.989,0.783-8.971c-0.374,3.206,0.256-1.438,0.301-1.709\n\t\t\tc0.229-1.381,0.509-2.754,0.789-4.125c1.149-5.624,2.853-11.121,4.956-16.457c-1.29,3.273,0.282-0.563,0.495-1.027\n\t\t\tc0.518-1.122,1.083-2.222,1.648-3.32c1.11-2.159,2.359-4.244,3.653-6.297c0.638-1.012,1.319-1.995,2-2.978\n\t\t\tc0.332-0.479,2.76-3.651,0.496-0.761c1.692-2.161,3.538-4.197,5.437-6.176c2.166-2.257,4.503-4.343,6.903-6.346\n\t\t\tc1.304-1.042,1.215-0.99-0.266,0.157c0.627-0.476,1.26-0.943,1.899-1.402c1.6-1.166,3.258-2.248,4.928-3.31\n\t\t\tc2.711-1.724,5.537-3.265,8.397-4.725c1.454-0.743,2.937-1.428,4.422-2.106c1.561-0.682,1.503-0.668-0.173,0.042\n\t\t\tc1.153-0.483,2.321-0.93,3.488-1.377c7.627-2.924,12.805-9.986,10.477-18.452c-2.009-7.303-10.808-13.407-18.452-10.477\n\t\t\tc-21.586,8.276-39.919,20.853-53.459,39.792c-14.246,19.927-18.917,45.335-18.928,69.36c-0.007,17.128-1.296,34.786,1.733,51.743\n\t\t\tc1.057,5.914,3.774,11.588,7.952,15.928c5.075,5.273,11.761,6.906,18.713,7.806c6.093,0.788,12.476-0.159,18.53-0.853\n\t\t\tc10.158-1.163,20.29-2.532,30.46-3.59c8.13-0.846,15-6.184,15-15C249.814,303.932,242.962,295.619,234.814,296.467\n\t\t\tL234.814,296.467z"
	    }
	  })])]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
	    attrs: {
	      "fill": "#010101",
	      "d": "M379.614,111.269c-0.022,2.735-0.153,5.452-0.397,8.177c-0.398,4.45,0.521-3.043-0.16,1.345\n\t\t\tc-0.204,1.318-0.473,2.625-0.74,3.93c-0.531,2.589-1.247,5.137-2.022,7.662c-0.386,1.254-0.83,2.489-1.273,3.723\n\t\t\tc-0.302,0.818-0.616,1.631-0.943,2.439c0.674-1.576,0.66-1.573-0.04,0.008c-2.136,4.737-4.815,9.213-7.776,13.475\n\t\t\tc-0.233,0.336-2.845,3.737-0.771,1.105c-0.803,1.018-1.65,2-2.497,2.98c-1.98,2.293-4.13,4.436-6.336,6.51\n\t\t\tc-0.948,0.891-1.936,1.74-2.922,2.588c-0.297,0.255-3.688,2.923-1.043,0.908c-2.085,1.588-4.272,3.036-6.487,4.434\n\t\t\tc-2.231,1.407-4.553,2.664-6.898,3.867c-1.18,0.605-2.386,1.158-3.592,1.71c-1.59,0.7-1.623,0.714-0.098,0.043\n\t\t\tc-0.829,0.329-1.662,0.645-2.501,0.949c-5.091,1.889-10.382,3.194-15.723,4.138c-4.48,0.791,3.055-0.303-1.494,0.219\n\t\t\tc-1.39,0.159-2.784,0.255-4.179,0.351c-3.296,0.226-6.604,0.201-9.903,0.075c-1.401-0.053-2.799-0.17-4.197-0.288\n\t\t\tc-0.381-0.032-4.937-0.635-1.521-0.138c-2.71-0.395-5.39-0.972-8.052-1.61c-2.627-0.63-5.209-1.436-7.767-2.299\n\t\t\tc-1.269-0.428-2.518-0.913-3.766-1.396c3.07,1.191-1.97-0.913-2.503-1.167c-4.754-2.264-9.246-5.048-13.521-8.111\n\t\t\tc-3.512-2.516,2.257,1.863-1.094-0.85c-1.012-0.82-1.988-1.684-2.962-2.547c-2.27-2.01-4.387-4.185-6.435-6.417\n\t\t\tc-0.877-0.956-1.71-1.95-2.542-2.943c-2.755-3.287,1.719,2.387-0.833-1.059c-1.544-2.084-2.944-4.27-4.292-6.484\n\t\t\tc-1.351-2.22-2.547-4.531-3.688-6.864c-0.188-0.386-1.902-4.349-0.594-1.187c-0.667-1.613-1.246-3.262-1.811-4.914\n\t\t\tc-0.854-2.497-1.529-5.05-2.141-7.615c-0.309-1.294-0.555-2.602-0.802-3.909c-0.085-0.452-0.674-4.839-0.244-1.319\n\t\t\tc-0.718-5.871-0.669-11.816-0.143-17.698c0.205-1.783,0.19-1.791-0.045-0.022c0.184-1.324,0.431-2.638,0.679-3.951\n\t\t\tc0.49-2.603,1.167-5.167,1.904-7.708c0.73-2.52,1.639-4.983,2.603-7.421c-1.256,3.174,0.408-0.792,0.594-1.187\n\t\t\tc0.553-1.177,1.16-2.328,1.767-3.478c1.211-2.296,2.579-4.505,3.994-6.679c0.707-1.086,1.463-2.14,2.219-3.192\n\t\t\tc2.5-3.484-1.873,2.269,0.833-1.059c3.278-4.033,7.002-7.688,10.939-11.072c0.663-0.562,1.334-1.113,2.014-1.655\n\t\t\tc-2.581,2.09,0.822-0.56,1.144-0.79c2.135-1.529,4.368-2.915,6.628-4.249c2.277-1.344,4.641-2.534,7.027-3.67\n\t\t\tc0.35-0.167,4.396-1.849,1.306-0.596c1.241-0.503,2.503-0.95,3.766-1.396c5.13-1.816,10.452-3.044,15.819-3.908\n\t\t\tc-3.401,0.548,1.133-0.099,1.521-0.138c1.396-0.139,2.797-0.213,4.197-0.288c2.83-0.151,5.667-0.108,8.498,0\n\t\t\tc2.329,0.088,4.65,0.318,6.964,0.583c-3.412-0.391,1.079,0.231,1.467,0.3c1.347,0.238,2.682,0.537,4.016,0.835\n\t\t\tc2.642,0.591,5.24,1.36,7.817,2.186c1.277,0.409,2.535,0.876,3.792,1.342c4.135,1.533-2.676-1.243,1.344,0.526\n\t\t\tc4.831,2.126,9.413,4.782,13.787,7.725c1.086,0.73,2.138,1.508,3.19,2.285c-2.669-1.972,0.737,0.653,1.043,0.907\n\t\t\tc1.997,1.667,3.881,3.464,5.722,5.3c1.531,1.527,2.971,3.143,4.384,4.779c0.265,0.307,2.93,3.676,0.894,1.01\n\t\t\tc0.786,1.03,1.526,2.095,2.266,3.159c2.967,4.269,5.438,8.864,7.572,13.598c-1.404-3.115,0.294,0.853,0.448,1.26\n\t\t\tc0.463,1.227,0.868,2.476,1.273,3.723c0.815,2.515,1.45,5.084,2.022,7.663c0.289,1.302,0.515,2.616,0.74,3.93\n\t\t\tc0.752,4.377-0.311-3.097,0.16,1.346C379.504,105.807,379.592,108.54,379.614,111.269c0.066,8.176,6.772,15,15,15\n\t\t\tc8.127,0,15.066-6.823,15-15c-0.203-25.044-9.681-48.393-26.271-67.031c-16.59-18.639-40.217-29.661-64.69-32.844\n\t\t\tc-49.692-6.462-98.546,25.167-112.5,73.306c-7.006,24.172-3.552,50.257,7.748,72.502c11.089,21.829,30.953,38.303,53.402,47.399\n\t\t\tc46.813,18.97,102.278,0.061,128.396-42.863c9.181-15.087,13.771-32.877,13.914-50.469c0.066-8.177-6.873-15-15-15\n\t\t\tC386.387,96.269,379.681,103.093,379.614,111.269z"
	    }
	  })])]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
	    attrs: {
	      "fill": "#010101",
	      "d": "M359.025,235.921c1.662,23.026,2.858,46.103,3.591,69.176c0.497,15.652,0.852,31.368,0.05,47.016\n\t\t\tc-0.142,2.768-0.348,5.532-0.637,8.289c-0.47,4.475,0.521-3.276,0.012-0.01c-0.171,1.095-0.389,2.181-0.646,3.258\n\t\t\tc-0.175,0.733-0.397,1.455-0.657,2.163c1.848-5.051,1.622-3.653,1.019-2.487c-0.568,1.101-2.136,2.648,1.806-2.231\n\t\t\tc-1.32,1.634,4.141-2.682,1.61-1.305c-1.974,1.073,4.685-1.646,0.811-0.437c-2.021,0.631-4.117,1.024-6.198,1.39\n\t\t\tc-1.316,0.231-6.313,0.909-0.619,0.152c-1.742,0.231-3.49,0.421-5.239,0.6c-7.535,0.771-15.11,1.156-22.679,1.435\n\t\t\tc-17.367,0.638-34.782,0.51-52.143-0.258c-7.433-0.329-14.864-0.81-22.265-1.583c-1.464-0.152-2.926-0.328-4.387-0.515\n\t\t\tc5.721,0.73,0.798,0.09-0.53-0.129c-2.16-0.355-4.314-0.79-6.415-1.414c-3.292-0.979,1.672,0.815,1.338,0.656\n\t\t\tc-2.48-1.184,3.088,2.894,1.739,1.426c3.247,3.532,2.558,3.568,1.876,2.309c-0.862-1.593,1.743,4.356,1.083,2.564\n\t\t\tc-0.292-0.793-0.479-1.625-0.659-2.448c-0.197-0.9-0.339-1.813-0.477-2.725c0.928,6.176,0.225,1.604,0.078,0.141\n\t\t\tc-0.294-2.933-0.459-5.878-0.596-8.821c-1.796-38.597,0.795-77.681,3.212-116.211c0.512-8.169-7.211-15-15-15\n\t\t\tc-8.564,0-14.488,6.843-15,15c-1.432,22.824-2.469,45.685-3.12,68.544c-0.444,15.621-0.762,31.287-0.125,46.908\n\t\t\tc0.49,12.021,0.387,26.2,11.171,33.831c3.7,2.618,9.122,3.544,13.522,4.268c7.374,1.213,14.833,1.947,22.283,2.491\n\t\t\tc16.966,1.24,34.021,1.502,51.025,1.289c16.05-0.201,32.119-0.903,48.01-3.275c11.813-1.764,21.816-6.561,24.652-19.205\n\t\t\tc2.461-10.972,2.463-22.687,2.562-33.873c0.131-14.718-0.323-29.443-0.909-44.148c-0.755-18.954-1.782-37.908-3.147-56.829\n\t\t\tc-0.588-8.152-6.378-15-15-15C366.295,220.921,358.437,227.756,359.025,235.921L359.025,235.921z"
	    }
	  })])]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
	    attrs: {
	      "fill": "#010101",
	      "d": "M117.477,295.25c-8.678,0.903-17.323,2.064-25.99,3.059c-2.951,0.338-5.909,0.627-8.877,0.767\n\t\t\tc-1.185,0.056-2.372,0.059-3.558,0.025c-0.527-0.015-1.052-0.055-1.577-0.098c-2.377-0.191,4.353,0.671,2.082,0.278\n\t\t\tc-0.843-0.146-1.662-0.39-2.461-0.689c4.832,1.81,3.357,1.494,2.189,0.83c-1.083-0.615-2.463-2.092,1.824,1.47\n\t\t\tc-2.578-2.143,2.144,3.335,0.626,0.992c-1.949-3.01,1.271,3.725,0.246,0.824c-0.343-0.971-0.568-1.983-0.776-2.99\n\t\t\tc-0.889-4.313,0.317,3.441-0.068-0.299c-0.326-3.172-0.403-6.371-0.465-9.558c-0.189-9.647-0.039-19.314,0.022-28.964\n\t\t\tc0.019-3.089,0.212-6.174,0.475-9.251c0.02-0.236,0.629-5.076,0.167-1.834c0.2-1.402,0.461-2.796,0.724-4.188\n\t\t\tc0.984-5.227,2.542-10.328,4.506-15.265c-1.303,3.273,0.313-0.524,0.537-0.991c0.531-1.107,1.12-2.188,1.708-3.266\n\t\t\tc1.154-2.115,2.471-4.137,3.84-6.118c0.339-0.49,2.806-3.603,0.518-0.742c0.735-0.92,1.518-1.8,2.3-2.68\n\t\t\tc1.56-1.754,3.252-3.385,4.98-4.97c0.866-0.793,1.77-1.544,2.673-2.294c3.049-2.531-2.505,1.821,0.709-0.52\n\t\t\tc1.926-1.402,3.947-2.67,5.99-3.893c2.08-1.244,4.238-2.353,6.413-3.419c1.105-0.542,2.231-1.039,3.356-1.537\n\t\t\tc-3.299,1.46,0.547-0.174,1.039-0.362c7.625-2.932,12.807-9.98,10.477-18.452c-2.008-7.298-10.811-13.415-18.452-10.477\n\t\t\tc-21.413,8.233-40.08,21.788-50.902,42.483c-11.566,22.119-11.157,46.54-11.131,70.813c0.016,14.825-0.307,30.976,12.598,40.751\n\t\t\tc10.11,7.658,26.246,3.897,37.664,2.479c5.527-0.687,11.057-1.34,16.596-1.917c8.129-0.847,15-6.183,15-15\n\t\t\tC132.477,302.715,125.625,294.401,117.477,295.25L117.477,295.25z"
	    }
	  })])]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
	    attrs: {
	      "fill": "#010101",
	      "d": "M176.647,200.21c-2.369-0.022-4.721-0.129-7.082-0.326c-4.583-0.381,2.964,0.53-1.542-0.182\n\t\t\tc-1.361-0.215-2.71-0.504-4.058-0.794c-2.663-0.572-5.273-1.361-7.856-2.22c-1.278-0.425-2.532-0.919-3.785-1.413\n\t\t\tc3.078,1.212-0.958-0.505-1.301-0.67c-1.996-0.958-3.92-2.056-5.821-3.188c-1.135-0.676-2.233-1.412-3.329-2.146\n\t\t\tc-0.312-0.208-3.804-2.806-1.199-0.775c-4.129-3.218-7.811-6.975-11.151-10.995c1.962,2.361-1.765-2.537-2.26-3.285\n\t\t\tc-1.441-2.18-2.698-4.476-3.887-6.8c-0.189-0.37-1.971-4.327-0.654-1.192c-0.51-1.214-0.95-2.456-1.39-3.697\n\t\t\tc-0.887-2.503-1.557-5.077-2.149-7.663c-0.191-0.873-0.365-1.748-0.522-2.627c-0.824-4.367,0.278,3.084-0.205-1.365\n\t\t\tc-0.297-2.735-0.35-5.491-0.323-8.239c0.014-1.374,0.108-2.745,0.202-4.115c0.031-0.445,0.621-4.896,0.102-1.397\n\t\t\tc0.393-2.646,1.016-5.251,1.712-7.83c0.575-2.126,1.312-4.205,2.086-6.265c1.526-4.06-1.258,2.684,0.566-1.238\n\t\t\tc0.552-1.186,1.17-2.34,1.787-3.493c1.232-2.302,2.654-4.497,4.132-6.646c0.23-0.334,2.877-3.712,0.802-1.122\n\t\t\tc0.816-1.019,1.686-1.992,2.555-2.964c1.452-1.624,3.019-3.141,4.61-4.626c0.958-0.894,1.962-1.736,2.966-2.578\n\t\t\tc3.313-2.777-2.372,1.692,1.138-0.847c2.142-1.549,4.405-2.922,6.699-4.232c1.155-0.66,2.344-1.256,3.532-1.853\n\t\t\tc0.333-0.167,4.365-1.94,1.301-0.669c4.61-1.912,9.447-3.227,14.337-4.184c0.374-0.073,4.884-0.686,1.509-0.28\n\t\t\tc1.397-0.168,2.802-0.259,4.206-0.35c3.133-0.203,6.275-0.122,9.407,0.053c4.652,0.259,11.002,1.783,17.03,3.931\n\t\t\tc3.377,1.204,10.134,5.038,14.698,8.32c6.651,4.784,16.685,1.171,20.523-5.381c4.428-7.559,1.242-15.759-5.381-20.523\n\t\t\tc-22.961-16.513-53.746-20.824-80.519-11.927c-24.525,8.15-43.873,26.491-53.832,50.2c-9.795,23.32-7.444,50.166,4.382,72.257\n\t\t\tc11.604,21.677,33.557,37.402,57.305,42.962c6.725,1.573,13.756,2.31,20.656,2.373c8.177,0.075,15-6.88,15-15\n\t\t\tC191.647,206.976,184.823,200.286,176.647,200.21L176.647,200.21z"
	    }
	  })])]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
	    attrs: {
	      "fill": "#010101",
	      "d": "M220.808,349.358c-0.25,1.532-0.538,3.016-0.938,4.516c0.713-2.672,2.904-4.501,5.069-5.997\n\t\t\tc-2.468,1.704,4.123-1.491,1.446-0.544c-2.137,0.757-4.418,1.14-6.647,1.508c-4.617,0.761,3.048-0.34-0.826,0.121\n\t\t\tc-1.564,0.187-3.132,0.336-4.701,0.479c-3.876,0.354-7.764,0.584-11.651,0.776c-17.136,0.848-34.362,0.72-51.494-0.16\n\t\t\tc-3.621-0.186-7.238-0.432-10.851-0.734c-1.602-0.135-3.202-0.293-4.801-0.463c-0.738-0.078-1.476-0.166-2.213-0.254\n\t\t\tc-2.697-0.323,4.336,0.628,0.609,0.078c-2.122-0.313-4.239-0.702-6.309-1.269c-3.318-0.909,1.374,0.721,1.253,0.664\n\t\t\tc-0.231-0.109-0.445-0.245-0.657-0.388c2.032,1.181,3.638,2.787,4.819,4.819c-0.085-0.124-0.163-0.253-0.231-0.387\n\t\t\tc2.537,4.544,0.764,1.893,0.289-0.981c-0.387-2.341,0.559,4.398,0.252,1.933c-0.071-0.572-0.128-1.146-0.187-1.72\n\t\t\tc-0.153-1.518-0.257-3.041-0.352-4.563c-0.438-7.043-0.463-14.114-0.439-21.168c0.09-26.041,1.331-52.118,2.959-78.105\n\t\t\tc0.512-8.169-7.21-15-15-15c-8.563,0-14.489,6.843-15,15c-1.548,24.703-2.669,49.471-2.932,74.222\n\t\t\tc-0.138,13.016-0.838,27.148,2.274,39.906c3.661,15.008,19.755,16.083,32.41,17.374c20.745,2.117,41.866,2.149,62.683,1.326\n\t\t\tc9.602-0.38,19.202-1.117,28.69-2.682c11.555-1.905,19.399-8.088,21.402-20.333c1.318-8.062-1.973-16.112-10.477-18.451\n\t\t\tC232.02,336.89,222.129,341.278,220.808,349.358L220.808,349.358z"
	    }
	  })])]), _vm._v(" "), _c('g', [_c('g', [_c('g', [_c('path', {
	    attrs: {
	      "fill": "#010101",
	      "d": "M482.796,325.25c14.988,1.561,30.84,5.562,45.896,2.96c15.497-2.678,19.802-18.286,20.676-31.654\n\t\t\t\tc0.558-8.526,0.291-17.124,0.253-25.662c-0.059-13.032-0.472-25.88-3.689-38.594c-5.714-22.581-20.47-41.428-40.34-53.316\n\t\t\t\tc-5.667-3.39-11.828-5.979-17.978-8.343c-7.642-2.937-16.444,3.178-18.451,10.477c-2.33,8.471,2.852,15.521,10.477,18.452\n\t\t\t\tc0.483,0.186,4.362,1.782,1.039,0.362c1.132,0.484,2.245,1.01,3.357,1.537c2.19,1.038,4.316,2.205,6.414,3.419\n\t\t\t\tc2.063,1.194,4.045,2.521,5.992,3.893c3.251,2.291-2.38-1.962,0.711,0.52c0.916,0.735,1.795,1.516,2.674,2.294\n\t\t\t\tc1.756,1.558,3.393,3.244,4.982,4.97c0.797,0.866,1.55,1.773,2.301,2.68c-2.328-2.808,0.165,0.249,0.519,0.742\n\t\t\t\tc1.405,1.958,2.651,4.024,3.842,6.118c0.607,1.068,1.158,2.168,1.708,3.266c0.228,0.454,1.9,4.251,0.538,0.991\n\t\t\t\tc2.05,4.906,3.446,10.063,4.508,15.265c0.283,1.388,0.503,2.788,0.724,4.188c-0.509-3.229,0.143,1.593,0.167,1.834\n\t\t\t\tc0.306,3.074,0.417,6.164,0.476,9.251c0.183,9.642,0.175,19.322,0.021,28.964c-0.052,3.19-0.173,6.38-0.467,9.558\n\t\t\t\tc-0.348,3.749,0.745-4.033-0.069,0.299c-0.19,1.014-0.459,2.01-0.776,2.99c-0.953,2.941,2.083-3.918,0.244-0.824\n\t\t\t\tc-1.436,2.414,3.116-3.258,0.625-0.992c3.556-3.234,3.015-2.216,1.823-1.47c-1.021,0.64-3.17,1.407,2.188-0.83\n\t\t\t\tc-0.788,0.329-1.629,0.522-2.463,0.689c-2.259,0.453,4.454-0.518,2.082-0.278c-0.524,0.054-1.052,0.074-1.577,0.098\n\t\t\t\tc-1.186,0.053-2.374,0.018-3.559-0.025c-2.968-0.109-5.929-0.438-8.878-0.767c-8.669-0.97-17.312-2.155-25.988-3.059\n\t\t\t\tc-8.148-0.849-15,7.466-15,15C467.796,319.067,474.666,324.403,482.796,325.25L482.796,325.25z"
	    }
	  })])]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
	    attrs: {
	      "fill": "#010101",
	      "d": "M422.868,228.713c25.169-0.222,49.816-10.116,67.096-28.637c18.081-19.38,24.648-45.07,20.81-70.931\n\t\t\t\tc-3.609-24.314-20.014-45.709-40.56-58.436c-11.134-6.897-23.81-10.694-36.726-12.249c-11.153-1.343-24.229-1.457-34.823,2.698\n\t\t\t\tc-6.007,2.356-11.187,5.542-16.382,9.334c-6.591,4.81-9.831,12.928-5.382,20.523c3.817,6.516,13.904,10.212,20.522,5.381\n\t\t\t\tc3.772-2.753,7.588-5.416,11.829-7.404c-3.618,1.696-0.487,0.312,0.342,0.049c1.021-0.322,2.07-0.54,3.115-0.759\n\t\t\t\tc3.75-0.79-3.447,0.312,0.643-0.103c1.328-0.135,2.664-0.188,3.997-0.25c12.143-0.563,17.647-0.029,29.35,4.335\n\t\t\t\tc1.622,0.647,1.667,0.657,0.134,0.029c1.224,0.533,2.416,1.132,3.608,1.73c2.369,1.189,4.639,2.566,6.865,4.001\n\t\t\t\tc1.107,0.714,2.176,1.486,3.243,2.258c-2.659-1.923,0.774,0.664,1.077,0.917c2.006,1.681,3.872,3.52,5.685,5.405\n\t\t\t\tc0.602,0.625,4.603,5.388,2.71,2.935c1.595,2.066,3.016,4.259,4.373,6.486c1.361,2.235,2.534,4.579,3.637,6.949\n\t\t\t\tc-1.427-3.066,0.323,0.873,0.478,1.282c0.465,1.237,0.859,2.499,1.253,3.759c0.661,2.12,1.157,4.287,1.611,6.458\n\t\t\t\tc0.092,0.438,0.756,4.833,0.307,1.334c0.174,1.353,0.268,2.713,0.361,4.073c0.189,2.75,0.137,5.512-0.003,8.262\n\t\t\t\tc-0.068,1.356-0.219,2.707-0.369,4.055c0.393-3.515-0.235,0.834-0.325,1.297c-0.42,2.161-1.012,4.284-1.645,6.391\n\t\t\t\tc-0.377,1.252-0.828,2.481-1.278,3.709c-1.481,4.039,1.272-2.692-0.516,1.205c-1.079,2.353-2.361,4.607-3.703,6.818\n\t\t\t\tc-0.671,1.104-1.402,2.168-2.134,3.232c-2.415,3.512,1.895-2.245-0.777,1.078c-2.982,3.71-6.436,7.019-10.089,10.057\n\t\t\t\tc-3.31,2.751,2.377-1.702-1.13,0.814c-1.067,0.766-2.176,1.475-3.281,2.183c-2.231,1.428-4.571,2.676-6.938,3.86\n\t\t\t\tc-0.334,0.167-4.362,1.943-1.296,0.668c-1.243,0.517-2.513,0.969-3.781,1.42c-2.565,0.913-5.199,1.621-7.845,2.259\n\t\t\t\tc-1.34,0.324-2.695,0.576-4.049,0.829c-4.486,0.837,3.039-0.28-1.527,0.244c-2.817,0.323-5.654,0.422-8.487,0.447\n\t\t\t\tc-8.176,0.072-15,6.769-15,15C407.868,221.835,414.69,228.785,422.868,228.713L422.868,228.713z"
	    }
	  })])]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
	    attrs: {
	      "fill": "#010101",
	      "d": "M372.7,377.787c18.95,2.942,38.282,3.161,57.42,2.896c16.493-0.229,34.749,0.083,50.769-4.38\n\t\t\t\tc15.338-4.271,16.228-19.037,16.846-32.432c0.729-15.819,0.198-31.722-0.336-47.539c-0.55-16.278-1.315-32.557-2.333-48.813\n\t\t\t\tc-0.511-8.157-6.437-15-15-15c-7.79,0-15.512,6.831-15,15c1.546,24.703,2.665,49.471,2.928,74.222\n\t\t\t\tc0.078,7.376,0.055,14.759-0.259,22.13c-0.115,2.696-0.291,5.391-0.563,8.075c-0.437,4.322,0.56-3.433,0.048-0.334\n\t\t\t\tc-0.152,0.927-0.355,1.845-0.617,2.746c-0.725,2.498,2.199-4.095,0.755-1.847c0.814-1.268,4.054-4.331,4.518-4.624\n\t\t\t\tc-0.981,0.621-3.27,1.258,2.311-0.929c-2.304,0.902-4.854,1.27-7.281,1.657c-1.065,0.171-3.971,0.535,0.905-0.102\n\t\t\t\tc-0.845,0.11-1.69,0.205-2.536,0.301c-1.858,0.211-3.722,0.379-5.585,0.539c-4.65,0.401-9.313,0.66-13.975,0.874\n\t\t\t\tc-12.16,0.557-24.346,0.643-36.515,0.387c-5.694-0.119-11.386-0.352-17.069-0.711c-2.646-0.167-5.289-0.385-7.929-0.639\n\t\t\t\tc-1.183-0.114-2.363-0.25-3.544-0.39c-2.844-0.338,4.028,0.605,0.018-0.017c-8.072-1.254-16.1,1.925-18.451,10.477\n\t\t\t\tC360.245,366.527,364.608,376.531,372.7,377.787L372.7,377.787z"
	    }
	  })])])])])
	},staticRenderFns: []}

/***/ }),
/* 879 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    attrs: {
	      "id": "edit-developer-education-history"
	    }
	  }, [_c('div', {
	    staticClass: "education-history edit-container"
	  }, [_vm._l((_vm.formData.educationHistory), function(educationItem, index) {
	    return _c('div', {
	      staticClass: "container"
	    }, [_c('div', {
	      staticClass: "set"
	    }, [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (educationItem.place),
	        expression: "educationItem.place"
	      }],
	      class: [{
	        invalid: educationItem.place.trim() === ''
	      }],
	      attrs: {
	        "type": "text",
	        "placeholder": "School"
	      },
	      domProps: {
	        "value": (educationItem.place)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          educationItem.place = $event.target.value
	        }
	      }
	    }), _vm._v(" "), _c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (educationItem.title),
	        expression: "educationItem.title"
	      }],
	      attrs: {
	        "type": "text",
	        "placeholder": "Field of Study / Degree"
	      },
	      domProps: {
	        "value": (educationItem.title)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          educationItem.title = $event.target.value
	        }
	      }
	    }), _vm._v(" "), _c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (educationItem.start),
	        expression: "educationItem.start"
	      }],
	      attrs: {
	        "type": "text",
	        "placeholder": "Start Date"
	      },
	      domProps: {
	        "value": (educationItem.start)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          educationItem.start = $event.target.value
	        }
	      }
	    }), _vm._v(" "), _c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (educationItem.end),
	        expression: "educationItem.end"
	      }],
	      attrs: {
	        "type": "text",
	        "placeholder": "End Date"
	      },
	      domProps: {
	        "value": (educationItem.end)
	      },
	      on: {
	        "input": function($event) {
	          if ($event.target.composing) { return; }
	          educationItem.end = $event.target.value
	        }
	      }
	    }), _vm._v(" "), _c('button', {
	      staticClass: "button small-button",
	      on: {
	        "click": function($event) {
	          $event.preventDefault();
	          _vm.removeEducationHistory(index)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa-trash fas"
	    })]), _vm._v(" "), (index > 0) ? _c('button', {
	      staticClass: "button small-button",
	      on: {
	        "click": function($event) {
	          $event.preventDefault();
	          _vm.moveEducationUp(index)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa-arrow-up fas"
	    })]) : _vm._e(), _vm._v(" "), (index !== _vm.formData.educationHistory.length - 1) ? _c('button', {
	      staticClass: "button small-button",
	      on: {
	        "click": function($event) {
	          $event.preventDefault();
	          _vm.moveEducationDown(index)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fa-arrow-down fas"
	    })]) : _vm._e()])])
	  }), _vm._v(" "), _c('div', {
	    staticClass: "set container"
	  }, [_c('button', {
	    staticClass: "button small-button",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.addEducationHistory($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-plus"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "buttons"
	  }, [_c('button', {
	    staticClass: "button minor",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.cancelChanges($event)
	      }
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
	    staticClass: "button",
	    attrs: {
	      "disabled": !_vm.validateAllEntries()
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.submitChanges($event)
	      }
	    }
	  }, [_vm._v("Save")])])], 2)])
	},staticRenderFns: []}

/***/ }),
/* 880 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "forum-container"
	  }, [(!_vm.editMode) ? [_c('router-link', {
	    staticClass: "forum",
	    attrs: {
	      "to": ("/" + _vm.root + "/" + (_vm.category.stringUrl) + "/" + (_vm.forum.stringUrl))
	    }
	  }, [_c('div', {
	    staticClass: "details"
	  }, [_c('h3', [_vm._v("\n                    " + _vm._s(_vm.forum.title) + "\n                ")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.forum.description))])]), _vm._v(" "), (_vm.forum.lastReply) ? _c('div', {
	    staticClass: "last-reply"
	  }, [_c('h4', [_vm._v("Last Reply")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("formatDate")(_vm.forum.lastReply)))])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "data"
	  }, [_c('h4', [_vm._v(_vm._s(_vm.forum.views) + " Views")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.forum.totalThreads) + " Threads - " + _vm._s(_vm.forum.totalPosts) + " Posts")])])]), _vm._v(" "), _c('div', {
	    staticClass: "moderator-controls"
	  }, [_c('div', {
	    staticClass: "control",
	    on: {
	      "click": function($event) {
	        _vm.editMode = true
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-pencil-alt"
	  })])])] : _vm._e(), _vm._v(" "), (_vm.editMode) ? [_c('div', {
	    staticClass: "edit-forum-form"
	  }, [(_vm.editForumErrorMessage) ? _c('div', {
	    staticClass: "validation-messages error"
	  }, [_vm._v(_vm._s(_vm.editForumErrorMessage))]) : _vm._e(), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.editForumTitle),
	      expression: "editForumTitle"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "Forum Title"
	    },
	    domProps: {
	      "value": (_vm.editForumTitle)
	    },
	    on: {
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.editForumTitle = $event.target.value
	      }, function($event) {
	        _vm.editForumErrorMessage = ''
	      }]
	    }
	  }), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.editForumDescription),
	      expression: "editForumDescription"
	    }],
	    domProps: {
	      "value": (_vm.editForumDescription)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.editForumDescription = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "button minor",
	    on: {
	      "click": function($event) {
	        _vm.editMode = false
	      }
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
	    staticClass: "button",
	    on: {
	      "click": _vm.saveForum
	    }
	  }, [_vm._v("Save")])])] : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 881 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    attrs: {
	      "id": "develteam-announcements"
	    }
	  }, [_c('h1', [_vm._v("Develteam Announcements")]), _vm._v(" "), _vm._l((_vm.announcements), function(announcement) {
	    return _c('div', [_c('h2', [_vm._v(_vm._s(announcement.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(announcement.text))]), _vm._v(" "), (announcement.link) ? _c('p', [_vm._v("\n            Go to the "), _c('router-link', {
	      attrs: {
	        "to": announcement.link
	      }
	    }, [_vm._v(_vm._s(announcement.linkText))])], 1) : _vm._e()])
	  })], 2)
	},staticRenderFns: []}

/***/ }),
/* 882 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('article', {
	    staticClass: "feed-post"
	  }, [_c('section', {
	    staticClass: "header"
	  }, [(_vm.data.subPosterType === 'developer' && _vm.data.posterDetails.hasBanner) ? _c('div', {
	    staticClass: "banner",
	    style: (("background-image:url('https://www.develteam.com/userdata/banners/" + (_vm.data.posterDetails.id) + ".png');"))
	  }) : _vm._e(), _vm._v(" "), (_vm.data.subPosterType === 'game' && _vm.data.subPosterDetails.hasBanner) ? _c('div', {
	    staticClass: "banner",
	    style: (("background-image:url('https://www.develteam.com/userdata/banners/" + (_vm.data.subPosterDetails.id) + ".png');"))
	  }) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "head-group"
	  }, [_c('div', {
	    staticClass: "headline"
	  }, [(_vm.data.subPosterType === 'developer') ? _c('div', {
	    staticClass: "avatar-container"
	  }, [_c('avatar', {
	    attrs: {
	      "profile-data": _vm.data.posterDetails,
	      "profile-type": _vm.data.subPosterType,
	      "size": "large",
	      "show-xp-info": true
	    }
	  })], 1) : _vm._e(), _vm._v(" "), (_vm.data.subPosterType === 'game') ? _c('div', {
	    staticClass: "avatar-container"
	  }, [_c('avatar', {
	    attrs: {
	      "profile-data": _vm.data.subPosterDetails,
	      "profile-type": _vm.data.subPosterType,
	      "size": "large",
	      "show-xp-info": true
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('h1', {
	    staticClass: "title"
	  }, [(_vm.data.subPosterType === 'developer') ? _c('span', [_c('i', {
	    staticClass: "fas fa-user fa-fw"
	  }), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "to": ("/Developer/" + (_vm.data.posterDetails.stringUrl)),
	      "data-router-link": "true"
	    }
	  }, [_vm._v(_vm._s(_vm.data.posterDetails.alias))])], 1) : _vm._e(), _vm._v(" "), (_vm.data.subPosterType === 'game') ? _c('span', [_c('i', {
	    staticClass: "fas fa-gamepad fa-fw"
	  }), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "to": ("/Game/" + (_vm.data.subPosterDetails.stringUrl)),
	      "data-router-link": "true"
	    }
	  }, [_vm._v(_vm._s(_vm.data.subPosterDetails.alias))])], 1) : _vm._e(), _vm._v(" "), (_vm.data.subPosterType === 'game') ? _c('span', [_c('i', {
	    staticClass: "fas fa-user fa-fw"
	  }), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "to": ("/Developer/" + (_vm.data.posterDetails.stringUrl)),
	      "data-router-link": "true"
	    }
	  }, [_vm._v(_vm._s(_vm.data.posterDetails.alias))])], 1) : _vm._e(), _vm._v(" "), (_vm.data.type === 'status' || _vm.data.type === 'classifieds') ? _c('span', {
	    staticClass: "sub-title"
	  }, [_c('router-link', {
	    attrs: {
	      "to": _vm.linkToPiece
	    }
	  }, [_vm._v(_vm._s(_vm.data.title))])], 1) : _vm._e(), _vm._v(" "), (_vm.data.type === 'media') ? _c('span', {
	    staticClass: "sub-title"
	  }, [_c('router-link', {
	    attrs: {
	      "to": _vm.linkToPiece
	    }
	  }, [(_vm.data.mediaData.mediaType === 'Image') ? _c('i', {
	    staticClass: "fas fa-image fa-fw portfolio-icon"
	  }) : _vm._e(), _vm._v(" "), (_vm.data.mediaData.mediaType === 'External') ? _c('i', {
	    staticClass: "fas fa-link fa-fw portfolio-icon"
	  }) : _vm._e(), _vm._v(" "), (_vm.data.mediaData.mediaType === 'Archive') ? _c('i', {
	    staticClass: "fas fa-archive fa-fw portfolio-icon"
	  }) : _vm._e(), _vm._v(" "), (_vm.data.mediaData.mediaType === 'Audio') ? _c('i', {
	    staticClass: "fas fa-volume-up fa-fw portfolio-icon"
	  }) : _vm._e(), _vm._v(" "), (_vm.data.mediaData.mediaType === 'Flash') ? _c('i', {
	    staticClass: "fas fa-rocket fa-fw portfolio-icon"
	  }) : _vm._e(), _vm._v(" "), (_vm.data.mediaData.mediaType === 'Text') ? _c('i', {
	    staticClass: "fas fa-book fa-fw portfolio-icon"
	  }) : _vm._e(), _vm._v(" "), (_vm.data.mediaData.mediaType === 'Video') ? _c('i', {
	    staticClass: "fas fa-video fa-fw portfolio-icon"
	  }) : _vm._e(), _vm._v(" "), (_vm.data.mediaData.mediaType === 'Youtube') ? _c('i', {
	    staticClass: "fab fa-youtube fa-fw portfolio-icon"
	  }) : _vm._e(), _vm._v("\n                            " + _vm._s(_vm.data.mediaData.title) + "\n                        ")])], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "post-date"
	  }, [_c('span', [_vm._v(_vm._s(_vm._f("formatDateWithoutTimeRelative")(_vm.data.postDate)))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("formatDateWithJustTime")(_vm.data.postDate)))])]), _vm._v(" "), (_vm.data.isPinned) ? _c('div', {
	    staticClass: "pinned-icon"
	  }, [_c('i', {
	    staticClass: "fa fas fa-thumbtack"
	  })]) : _vm._e()])]), _vm._v(" "), (!_vm.isMedia && !_vm.editMode) ? _c('markdown-content', {
	    attrs: {
	      "classes": "content",
	      "content": _vm.data.content
	    }
	  }) : _vm._e(), _vm._v(" "), (!_vm.isMedia && _vm.editMode && !_vm.deleteMode) ? _c('form', {
	    staticClass: "content"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.editPostTitle),
	      expression: "editPostTitle"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "Subject (optional)"
	    },
	    domProps: {
	      "value": (_vm.editPostTitle)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.editPostTitle = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('markdown-editor', {
	    attrs: {
	      "placeholder": "Add a new post"
	    },
	    model: {
	      value: (_vm.editPostContent),
	      callback: function($$v) {
	        _vm.editPostContent = $$v
	      },
	      expression: "editPostContent"
	    }
	  }), _vm._v(" "), _c('button', {
	    staticClass: "button minor",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.cancelEditPost($event)
	      }
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.enterDeleteMode($event)
	      }
	    }
	  }, [_vm._v("Delete Post")]), _vm._v(" "), _c('button', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.saveEditPost($event)
	      }
	    }
	  }, [_vm._v("Save")])], 1) : _vm._e(), _vm._v(" "), (!_vm.isMedia && _vm.editMode && _vm.deleteMode) ? _c('form', {
	    staticClass: "content"
	  }, [_c('h1', [_vm._v("Delete this post?")]), _vm._v(" "), _c('button', {
	    staticClass: "button minor",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.exitDeleteMode($event)
	      }
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.deletePost($event)
	      }
	    }
	  }, [_vm._v("Delete")])]) : _vm._e(), _vm._v(" "), (_vm.isMediaImage) ? _c('media-item-image', {
	    attrs: {
	      "data": _vm.data.mediaData
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isMediaImage && _vm.data.mediaData.description.length > 0) ? _c('markdown-content', {
	    attrs: {
	      "classes": "content",
	      "content": _vm.data.mediaData.description
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isMediaVideo) ? _c('media-item-video', {
	    attrs: {
	      "data": _vm.data.mediaData
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isMediaVideo && _vm.data.mediaData.description.length > 0) ? _c('markdown-content', {
	    attrs: {
	      "classes": "content",
	      "content": _vm.data.mediaData.description
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isMediaLink) ? _c('media-item-link', {
	    attrs: {
	      "data": _vm.data.mediaData
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isMediaLink && _vm.data.mediaData.description.length > 0) ? _c('markdown-content', {
	    attrs: {
	      "classes": "content",
	      "content": _vm.data.mediaData.description
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isMediaAudio) ? _c('media-item-audio', {
	    attrs: {
	      "data": _vm.data.mediaData
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isMediaAudio && _vm.data.mediaData.description.length > 0) ? _c('markdown-content', {
	    attrs: {
	      "classes": "content",
	      "content": _vm.data.mediaData.description
	    }
	  }) : _vm._e(), _vm._v(" "), _c('footer', [_c('ul', [_c('li', [(!_vm.isMedia) ? _c('voting-widget', {
	    attrs: {
	      "parent-type": "post",
	      "parent-id": _vm.data.id,
	      "initial-points": "0"
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isMedia) ? _c('voting-widget', {
	    attrs: {
	      "parent-type": "media",
	      "parent-id": _vm.data.mediaData.id,
	      "initial-points": "0"
	    }
	  }) : _vm._e()], 1), _vm._v(" "), _c('li', {
	    staticClass: "comments-link-container"
	  }, [_c('a', {
	    class: ['show-comments', {
	      selected: _vm.commentsVisible
	    }],
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.toggleComments($event)
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.commentCount) + "\n                comments")])]), _vm._v(" "), _c('li', {
	    staticClass: "social-sharing"
	  }, [_c('i', {
	    staticClass: "fab fa-facebook-f",
	    on: {
	      "click": function($event) {
	        _vm.socialShare('facebook')
	      }
	    }
	  }), _vm._v(" "), _c('i', {
	    staticClass: "fab fa-twitter",
	    on: {
	      "click": function($event) {
	        _vm.socialShare('twitter')
	      }
	    }
	  }), _vm._v(" "), _c('i', {
	    staticClass: "fab fa-linkedin-in",
	    on: {
	      "click": function($event) {
	        _vm.socialShare('linkedin')
	      }
	    }
	  })]), _vm._v(" "), (_vm.canEdit && !_vm.editMode) ? _c('li', {
	    staticClass: "edit-button-container",
	    on: {
	      "click": _vm.enterEditMode
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-pencil-alt edit-button"
	  })]) : _vm._e(), _vm._v(" "), (_vm.canEdit && !_vm.editMode) ? _c('li', {
	    staticClass: "edit-button-container",
	    on: {
	      "click": _vm.togglePin
	    }
	  }, [_c('i', {
	    class: ['fas', 'fa-thumbtack', 'edit-button', {
	      tilted: _vm.data.isPinned
	    }]
	  })]) : _vm._e()])]), _vm._v(" "), (_vm.commentsVisible) ? _c('section', {
	    staticClass: "comments"
	  }, [(Object.keys(_vm.data.comments || {}).length > 0) ? _c('ul', {
	    staticClass: "post-comments"
	  }, _vm._l((_vm.data.comments), function(comment) {
	    return _c('post-comment', {
	      attrs: {
	        "comment": comment
	      }
	    })
	  })) : _vm._e(), _vm._v(" "), (_vm.isLoggedIn) ? _c('form', {
	    staticClass: "new-comment"
	  }, [_c('markdown-editor', {
	    attrs: {
	      "placeholder": "Add a comment"
	    },
	    model: {
	      value: (_vm.newCommentContent),
	      callback: function($$v) {
	        _vm.newCommentContent = $$v
	      },
	      expression: "newCommentContent"
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "submit-row"
	  }, [(_vm.postAsOptions.length > 1) ? _c('label', [_c('span', [_vm._v("Post as ")]), _vm._v(" "), _c('span', [_c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.postAs),
	      expression: "postAs"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.postAs = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm.postAsOptions), function(postAsOption) {
	    return _c('option', {
	      domProps: {
	        "value": postAsOption.value
	      }
	    }, [_vm._v(_vm._s(postAsOption.text))])
	  }))])]) : _vm._e(), _vm._v(" "), _c('span', [_c('button', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.submitComment($event)
	      }
	    }
	  }, [_vm._v("Submit")])])])], 1) : _c('div', [_c('h1', [_c('router-link', {
	    attrs: {
	      "to": "/Login"
	    }
	  }, [_vm._v("Log in")]), _vm._v("\n                to reply\n            ")], 1)])]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 883 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    attrs: {
	      "id": "media-pieces"
	    }
	  }, [(!_vm.singlePieceMode) ? [_c('vue-masonry', {
	    attrs: {
	      "min-width": 450,
	      "horizontal-gutter": 40,
	      "vertical-gutter": 40
	    }
	  }, [(_vm.canEdit && !_vm.editAlbumMode && !_vm.addPieceMode && !_vm.fetchingPieces && _vm.album) ? [_c('div', {
	    staticClass: "media-post",
	    attrs: {
	      "id": "edit-album"
	    },
	    on: {
	      "click": _vm.enterEditAlbumMode
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-pencil-alt"
	  }), _c('span', [_vm._v("Edit Album")])]), _vm._v(" "), _c('div', {
	    staticClass: "media-post",
	    attrs: {
	      "id": "add-media"
	    },
	    on: {
	      "click": _vm.enterAddPieceMode
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-image"
	  }), _c('span', [_vm._v("Add a Piece")])])] : _vm._e(), _vm._v(" "), _vm._l((_vm.pieces), function(piece) {
	    return (!_vm.editAlbumMode && !_vm.addPieceMode && !_vm.fetchingPieces && _vm.album) ? _c('media-post', {
	      attrs: {
	        "piece": piece,
	        "medias-id": _vm.mediasId,
	        "can-edit": _vm.canEdit
	      }
	    }) : _vm._e()
	  }), _vm._v(" "), (_vm.piecesCount === 0 && !_vm.editAlbumMode && !_vm.addPieceMode && !_vm.fetchingPieces && _vm.album) ? _c('div', {
	    staticClass: "media-post no-media-message"
	  }, [_vm._v("This Album is empty")]) : _vm._e(), _vm._v(" "), (_vm.fetchingPieces && _vm.album) ? _c('div', [_c('loader-large')], 1) : _vm._e(), _vm._v(" "), (_vm.editAlbumMode) ? _c('edit-album-form', {
	    attrs: {
	      "album": _vm.album,
	      "mediasId": _vm.mediasId
	    }
	  }) : _vm._e()], 2), _vm._v(" "), (_vm.addPieceMode) ? _c('new-piece-form', {
	    attrs: {
	      "album": _vm.album,
	      "page-type": _vm.pageType,
	      "page-id": _vm.pageId
	    },
	    on: {
	      "doneEditing": function($event) {
	        _vm.addPieceMode = false
	      }
	    }
	  }) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.singlePieceMode) ? _c('single-piece-listing', {
	    attrs: {
	      "album": _vm.album,
	      "pieces": _vm.pieces,
	      "medias-id": _vm.mediasId,
	      "can-edit": _vm.canEdit
	    }
	  }) : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 884 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('article', {
	    attrs: {
	      "id": "home-dashboard"
	    }
	  }, [_c('div', {
	    staticClass: "teamup-upsell"
	  }, [_c('h1', [_vm._v("Are you looking for a game development team?")]), _vm._v(" "), _c('div', {
	    staticClass: "button-container"
	  }, [_c('router-link', {
	    staticClass: "button",
	    attrs: {
	      "to": "/Browse/Developers?seeking=true"
	    }
	  }, [_vm._v("View Available Developers")]), _vm._v(" "), _c('router-link', {
	    staticClass: "button",
	    attrs: {
	      "to": "/Browse/Games?seeking=true"
	    }
	  }, [_vm._v("View Recruiting Game Projects")])], 1)]), _vm._v(" "), _c('top-content'), _vm._v(" "), ((!_vm.isLoggedIn && _vm.gotInitialLoggedUserInfo) || !_vm.hasLoginCookies) ? _c('pitch', {
	    attrs: {
	      "depth": "both"
	    }
	  }) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 885 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "media-item-link"
	  }, [(_vm.data.previewImageUrl && _vm.data.mediaType !== 'External') ? _c('div', {
	    staticClass: "image-wrapper"
	  }, [_c('a', {
	    attrs: {
	      "href": ("https://www.develteam.com/userdata/media/" + (_vm.data.mediaUrl)),
	      "target": "_blank"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": ("https://www.develteam.com/userdata/media/" + (_vm.data.previewImageUrl)),
	      "alt": _vm.altText,
	      "title": _vm.altText
	    }
	  })])]) : _vm._e(), _vm._v(" "), (_vm.data.previewImageUrl && _vm.data.mediaType === 'External') ? _c('div', {
	    staticClass: "image-wrapper"
	  }, [_c('a', {
	    attrs: {
	      "href": _vm.data.mediaUrl,
	      "target": "_blank"
	    }
	  }, [_c('img', {
	    attrs: {
	      "src": ("https://www.develteam.com/userdata/media/" + (_vm.data.previewImageUrl)),
	      "alt": _vm.altText,
	      "title": _vm.altText
	    }
	  })])]) : _vm._e(), _vm._v(" "), (_vm.data.mediaType === 'Archive') ? _c('span', {
	    staticClass: "download"
	  }, [_c('a', {
	    attrs: {
	      "href": ("https://www.develteam.com/userdata/media/" + (_vm.data.mediaUrl)),
	      "target": "_blank"
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-download"
	  }), _vm._v("Download Archive")])]) : _vm._e(), _vm._v(" "), (_vm.data.mediaType === 'External') ? _c('span', {
	    staticClass: "download"
	  }, [_c('a', {
	    attrs: {
	      "href": _vm.data.mediaUrl,
	      "target": "_blank"
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-external-link-alt"
	  }), _vm._v("Visit External Link")])]) : _vm._e(), _vm._v(" "), (_vm.data.mediaType === 'Flash') ? _c('span', {
	    staticClass: "download"
	  }, [_c('a', {
	    attrs: {
	      "href": ("https://www.develteam.com/userdata/media/" + (_vm.data.mediaUrl)),
	      "target": "_blank"
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-play-circle"
	  }), _vm._v("Play Flash Game")])]) : _vm._e(), _vm._v(" "), (_vm.data.mediaType === 'Text') ? _c('span', {
	    staticClass: "download"
	  }, [_c('a', {
	    attrs: {
	      "href": ("https://www.develteam.com/userdata/media/" + (_vm.data.mediaUrl)),
	      "target": "_blank"
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-download"
	  }), _vm._v(" Download Document")])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 886 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    attrs: {
	      "id": "game-content-members"
	    }
	  }, [(!_vm.hasData) ? _c('loader-large') : _vm._e(), _vm._v(" "), (!_vm.editMembersMode) ? [(_vm.hasCurrentMembers) ? _c('h2', [_c('span', {
	    staticClass: "label"
	  }, [_vm._v("Active Members")]), _vm._v(" "), (_vm.isOwner) ? _c('span', {
	    staticClass: "enter-edit-mode"
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.editMembersMode = true
	      }
	    }
	  }, [_vm._v("Manage Members")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._l((_vm.organizedMembers.current), function(group, key) {
	    return (group.members.length > 0) ? _c('div', {
	      staticClass: "member-list"
	    }, [_c('h3', [_vm._v(_vm._s(key))]), _vm._v(" "), _vm._l((group.members), function(member) {
	      return _c('router-link', {
	        staticClass: "member-item",
	        attrs: {
	          "to": ("/Developer/" + (member.stringUrl))
	        }
	      }, [_c('div', {
	        staticClass: "avatar-container"
	      }, [_c('avatar', {
	        attrs: {
	          "profile-data": member,
	          "profile-type": "developer",
	          "size": "large",
	          "show-xp-info": true
	        }
	      })], 1), _vm._v(" "), _c('span', {
	        staticClass: "details"
	      }, [_c('h3', [_vm._v(_vm._s(member.alias))]), _vm._v(" "), (member.modLevel === 'owner') ? _c('span', {
	        staticClass: "mod-status"
	      }, [_c('i', {
	        staticClass: "fas fa-star"
	      }), _vm._v(" Project Owner")]) : _vm._e(), _vm._v(" "), (member.modLevel === 'mod') ? _c('span', {
	        staticClass: "mod-status"
	      }, [_c('i', {
	        staticClass: "fas fa-star"
	      }), _vm._v(" Project Moderator")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(member.positionTitle))]), _vm._v(" "), _c('span', {
	        staticClass: "time"
	      }, [_vm._v("Joined " + _vm._s(_vm._f("formatDateWithoutTime")(member.joinDate)))])])])
	    })], 2) : _vm._e()
	  }), _vm._v(" "), (_vm.hasFormerMembers) ? [_c('h2', [_vm._v("Former Members")]), _vm._v(" "), _vm._l((_vm.organizedMembers.former), function(group, key) {
	    return (group.members.length > 0) ? _c('div', {
	      staticClass: "member-list"
	    }, [_c('h3', [_vm._v(_vm._s(key))]), _vm._v(" "), _vm._l((group.members), function(member) {
	      return _c('router-link', {
	        staticClass: "member-item",
	        attrs: {
	          "to": ("/Developer/" + (member.stringUrl))
	        }
	      }, [_c('div', {
	        staticClass: "avatar-container"
	      }, [_c('avatar', {
	        attrs: {
	          "profile-data": member,
	          "profile-type": "developer",
	          "size": "large",
	          "show-xp-info": true
	        }
	      })], 1), _vm._v(" "), _c('span', {
	        staticClass: "details"
	      }, [_c('h3', [_vm._v(_vm._s(member.alias))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(member.positionTitle))]), _vm._v(" "), _c('span', {
	        staticClass: "time"
	      }, [_vm._v("From " + _vm._s(_vm._f("formatDateWithoutTime")(member.joinDate)))]), _vm._v(" "), _c('span', {
	        staticClass: "time"
	      }, [_vm._v("To " + _vm._s(_vm._f("formatDateWithoutTime")(member.endDate)))])])])
	    })], 2) : _vm._e()
	  })] : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.editMembersMode) ? _c('edit-page', {
	    attrs: {
	      "members": _vm.members,
	      "game-id": _vm.gameId
	    },
	    on: {
	      "exitEditMode": function($event) {
	        _vm.editMembersMode = false
	      }
	    }
	  }) : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 887 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('article', {
	    attrs: {
	      "id": "classifieds-new"
	    }
	  }, [_c('div', {
	    staticClass: "new-post-form"
	  }, [_c('h1', [_vm._v("Submit a new Classifieds Post")]), _vm._v(" "), (_vm.GamesOwned && _vm.GamesOwned.length > 0) ? _c('div', [_c('label', [_vm._v("Post as")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.selectedGameId),
	      expression: "selectedGameId"
	    }],
	    attrs: {
	      "id": "selected-game",
	      "disabled": _vm.isSaving
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.selectedGameId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "selected": "",
	      "value": "0"
	    }
	  }, [_vm._v(_vm._s(_vm.ownAlias))]), _vm._v(" "), _vm._l((_vm.GamesOwned), function(game) {
	    return _c('option', {
	      domProps: {
	        "value": game.id
	      }
	    }, [_vm._v("Game Project: " + _vm._s(game.alias))])
	  })], 2)]) : _vm._e(), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newPostTitle),
	      expression: "newPostTitle"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "Post Title",
	      "disabled": _vm.isSaving
	    },
	    domProps: {
	      "value": (_vm.newPostTitle)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newPostTitle = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('markdown-editor', {
	    attrs: {
	      "placeholder": "Post Content",
	      "disabled": _vm.isSaving
	    },
	    model: {
	      value: (_vm.newPostContent),
	      callback: function($$v) {
	        _vm.newPostContent = $$v
	      },
	      expression: "newPostContent"
	    }
	  }), _vm._v(" "), (!_vm.helpShown) ? _c('div', {
	    staticClass: "help-button",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        _vm.showHelpRollout()
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-fw fa-question-circle"
	  }), _vm._v(" Help submitting a Classifieds Post\n        ")]) : _c('div', {
	    staticClass: "help-rollout"
	  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
	    staticClass: "help-button",
	    on: {
	      "click": function($event) {
	        $event.stopPropagation();
	        _vm.hideHelpRollout()
	      }
	    }
	  }, [_vm._v("Hide Help")])]), _vm._v(" "), _vm._l((_vm.errors), function(error) {
	    return _c('div', {
	      staticClass: "validation-messages error"
	    }, [_vm._v(_vm._s(error))])
	  }), _vm._v(" "), _c('button', {
	    staticClass: "button",
	    on: {
	      "click": _vm.submitPost
	    }
	  }, [_vm._v("Submit")])], 2)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_c('em', [_vm._v("Classifieds")]), _vm._v(" are like adverts in a newspaper. When you are looking for people to join you or a\n                project to join, Classifieds are an important tool at your disposal.\n            ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_vm._v("There are two kinds of classifieds: "), _c('em', [_vm._v("Game Projects")]), _vm._v(" and "), _c('em', [_vm._v("Developers")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_c('em', [_vm._v("Game Project")]), _vm._v(" classifieds are for people that want to recruit others to join their project or for\n                people that are looking for an existing project to join. Anyone can see these classified posts on\n                the Classifieds page, making sure the \"Game Projects\" type filter is selected (which is the default\n                selection type), but in order to submit a Game Project classified post first you have to create a\n                project. Any recruitment roles shown in a Game Project classified are automatically taken from the\n                game project it is linked to.\n            ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('p', [_c('em', [_vm._v("Developer")]), _vm._v(" classifieds are for an individual developer to advertise themselves, letting others\n                know that they're available, the skills they have, what they're looking for, and any\n                conditions/requirements that may apply. Any skills tags listed at the top of a Developer classified\n                are automatically taken from those listed in the developer's profile. To browse the developer\n                classifieds, make sure the \"Developers\" type filter is selected on the classifieds page (by default\n                it is set to \"Game Projects\" and not \"Developers\")\n            ")])
	}]}

/***/ }),
/* 888 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('article', {
	    attrs: {
	      "id": "forums"
	    }
	  }, [(_vm.board !== undefined) ? [(!_vm.isCategorySet) ? _c('category-list', {
	    attrs: {
	      "board-id": _vm.boardId,
	      "board": _vm.board,
	      "root": _vm.root,
	      "is-moderator": _vm.isModerator,
	      "can-post": _vm.canPost
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isCategorySet && !_vm.isForumSet) ? _c('forum-list', {
	    attrs: {
	      "board-id": _vm.boardId,
	      "board": _vm.board,
	      "root": _vm.root,
	      "is-moderator": _vm.isModerator,
	      "can-post": _vm.canPost
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isCategorySet && _vm.isForumSet && !_vm.isThreadSet) ? _c('thread-list', {
	    attrs: {
	      "board-id": _vm.boardId,
	      "board": _vm.board,
	      "root": _vm.root,
	      "is-moderator": _vm.isModerator,
	      "can-post": _vm.canPost
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isCategorySet && _vm.isForumSet && _vm.isThreadSet) ? _c('post-list', {
	    attrs: {
	      "board-id": _vm.boardId,
	      "board": _vm.board,
	      "root": _vm.root,
	      "is-moderator": _vm.isModerator,
	      "can-post": _vm.canPost
	    }
	  }) : _vm._e()] : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 889 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    attrs: {
	      "id": "inbox-compose"
	    }
	  }, [_c('h1', [_vm._v("Compose New Message")]), _vm._v(" "), _c('form', {
	    staticClass: "participants",
	    attrs: {
	      "autocomplete": "off"
	    },
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	      }
	    }
	  }, [_c('p', [_vm._v("To:\n            "), _vm._l((_vm.addedParticipants), function(participant) {
	    return _c('span', {
	      staticClass: "participant",
	      on: {
	        "click": function($event) {
	          _vm.removeParticipant(participant)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fas fa-minus-circle"
	    }), _vm._v("  " + _vm._s(participant.alias))])
	  })], 2), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.addedParticipantName),
	      expression: "addedParticipantName"
	    }],
	    attrs: {
	      "id": "newParticipant",
	      "type": "text",
	      "placeholder": "Search for a Developer",
	      "disabled": _vm.formSubmitted
	    },
	    domProps: {
	      "value": (_vm.addedParticipantName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.addedParticipantName = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _vm._l((_vm.matchingDevsResponse), function(dev) {
	    return (_vm.shouldShowDev(dev)) ? _c('p', {
	      staticClass: "new-participant",
	      on: {
	        "click": function($event) {
	          _vm.addParticipant(dev)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fas fa-plus-circle"
	    }), _vm._v(" " + _vm._s(dev.alias))]) : _vm._e()
	  })], 2), _vm._v(" "), (_vm.validationMessage) ? _c('div', {
	    staticClass: "validation-messages error"
	  }, [_vm._v(_vm._s(_vm.validationMessage))]) : _vm._e(), _vm._v(" "), _c('form', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newMessageSubject),
	      expression: "newMessageSubject"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "Subject",
	      "disabled": _vm.formSubmitted,
	      "maxlength": "64"
	    },
	    domProps: {
	      "value": (_vm.newMessageSubject)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newMessageSubject = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('markdown-editor', {
	    attrs: {
	      "placeholder": "Enter a reply",
	      "disabled": _vm.formSubmitted
	    },
	    model: {
	      value: (_vm.newMessageContent),
	      callback: function($$v) {
	        _vm.newMessageContent = $$v
	      },
	      expression: "newMessageContent"
	    }
	  }), _vm._v(" "), _c('input', {
	    attrs: {
	      "type": "submit",
	      "value": "Send Message",
	      "disabled": _vm.formSubmitted
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.submitNewConversation($event)
	      }
	    }
	  })], 1)])
	},staticRenderFns: []}

/***/ }),
/* 890 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "media-edit-album"
	    }
	  }, [_c('h2', [_vm._v("Edit Album Details")]), _vm._v(" "), (!_vm.savingAlbum && !_vm.deleteMode) ? _c('form', [_c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.albumName),
	      expression: "albumName"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "Album Name"
	    },
	    domProps: {
	      "value": (_vm.albumName)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.albumName = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('label', [_vm._v("\n            Album Cover Art "), _c('input', {
	    attrs: {
	      "type": "file",
	      "name": "avatar",
	      "accept": "image/*"
	    },
	    on: {
	      "change": _vm.updateUploadedAlbumName
	    }
	  }), _vm._v(" "), (_vm.uploadedImageSrc) ? _c('div', {
	    staticClass: "albumPreview",
	    style: (("background-image: url('" + _vm.uploadedImageSrc + "')"))
	  }) : _vm._e(), _vm._v(" "), (_vm.albumImageTooBig) ? _c('div', {
	    staticClass: "validation-messages error"
	  }, [_vm._v("Maximum filesize of an Album Icon is 10Mb")]) : _vm._e()]), _vm._v(" "), _c('button', {
	    staticClass: "button minor",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.editAlbum($event)
	      }
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.enterDeleteMode($event)
	      }
	    }
	  }, [_vm._v("Delete Album")]), _vm._v(" "), _c('button', {
	    staticClass: "button",
	    attrs: {
	      "disabled": !_vm.isValidated()
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.editAlbum($event)
	      }
	    }
	  }, [_vm._v("Save Changes")])]) : _vm._e(), _vm._v(" "), (_vm.deleteMode) ? [_c('h1', [_vm._v("Are you sure you want to delete this album and all the media pieces inside it?")]), _vm._v(" "), _c('button', {
	    staticClass: "button minor",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.exitDeleteMode($event)
	      }
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.deleteAlbum($event)
	      }
	    }
	  }, [_vm._v("Delete Album")])] : _vm._e(), _vm._v(" "), (_vm.savingAlbum) ? _c('saver-large') : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 891 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "media-item-image"
	  }, [_c('div', {
	    staticClass: "image-wrapper"
	  }, [_c('img', {
	    attrs: {
	      "src": ("https://www.develteam.com/userdata/media/" + (_vm.data.mediaUrl)),
	      "alt": _vm.altText,
	      "title": _vm.altText
	    },
	    on: {
	      "click": _vm.showInModal
	    }
	  })])])
	},staticRenderFns: []}

/***/ }),
/* 892 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "home-feed"
	    }
	  }, [(_vm.gotInitialLoggedUserInfo) ? _c('article', {
	    attrs: {
	      "id": "feed-posts-page"
	    }
	  }, [_c('div', {
	    attrs: {
	      "id": "feed-post-collection"
	    }
	  }, [(_vm.layout === 'masonry') ? _c('vue-masonry', {
	    attrs: {
	      "min-width": 450,
	      "horizontal-gutter": 40,
	      "vertical-gutter": 40
	    }
	  }, [(Object.keys(_vm.feedPosts || {}).length > 0) ? [_vm._l((_vm.feedPosts), function(feedPost) {
	    return [(feedPost.type === 'singlePost') ? _c('feed-status-post', {
	      key: feedPost.post.id,
	      attrs: {
	        "data": feedPost.post
	      }
	    }) : _vm._e(), _vm._v(" "), (feedPost.type === 'groupPost') ? _c('group-post', {
	      attrs: {
	        "posts": feedPost.posts
	      }
	    }) : _vm._e()]
	  })] : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.layout === 'single') ? _c('div', {
	    staticClass: "single-column-container"
	  }, [(Object.keys(_vm.feedPosts || {}).length > 0) ? [_vm._l((_vm.feedPosts), function(feedPost) {
	    return [(feedPost.type === 'singlePost') ? _c('feed-status-post', {
	      key: feedPost.id,
	      attrs: {
	        "data": feedPost.post
	      }
	    }) : _vm._e(), _vm._v(" "), (feedPost.type === 'groupPost') ? _c('group-post', {
	      attrs: {
	        "posts": feedPost.posts
	      }
	    }) : _vm._e()]
	  })] : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.layout === 'double') ? _c('div', {
	    staticClass: "double-column-container"
	  }, [_c('vue-masonry', {
	    attrs: {
	      "min-width": 500,
	      "horizontal-gutter": 40,
	      "vertical-gutter": 40
	    }
	  }, [(Object.keys(_vm.feedPosts || {}).length > 0) ? [_vm._l((_vm.feedPosts), function(feedPost) {
	    return [(feedPost.type === 'singlePost') ? _c('feed-status-post', {
	      key: feedPost.id,
	      attrs: {
	        "data": feedPost.post
	      }
	    }) : _vm._e(), _vm._v(" "), (feedPost.type === 'groupPost') ? _c('group-post', {
	      attrs: {
	        "posts": feedPost.posts
	      }
	    }) : _vm._e()]
	  })] : _vm._e()], 2)], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "load-more-button-container"
	  }, [(_vm.fetchingStatus === 'fetched' && Object.keys(_vm.feedPosts || {}).length > 0 && !_vm.hasFetchedAll) ? _c('button', {
	    attrs: {
	      "id": "feed-fetch-more"
	    },
	    on: {
	      "click": _vm.getPosts
	    }
	  }, [_vm._v("Load more posts")]) : _vm._e(), _vm._v(" "), (_vm.fetchingStatus === 'fetching') ? _c('loader-large') : _vm._e()], 1)], 1)]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 893 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    attrs: {
	      "id": "leave-game-widget"
	    }
	  }, [_c('div', {
	    staticClass: "edit-container"
	  }, [(_vm.isSaving) ? _c('saver-large') : _vm._e(), _vm._v(" "), (!_vm.isSaving) ? [_c('h1', [_vm._v("Are you sure you want to leave this Game Project?")]), _vm._v(" "), (_vm.members.length === 1) ? [_c('div', {
	    staticClass: "validation-messages error"
	  }, [_vm._v("You're the only member on this project. If you leave, the Game Project and all content created by it will be Deleted.")])] : _vm._e(), _vm._v(" "), (_vm.isOwner && _vm.members.length > 1) ? [_c('div', {
	    staticClass: "validation-messages error"
	  }, [_vm._v("You're the owner of this project so you will have to choose another member to take that responsibility.")]), _vm._v(" "), _c('label', [_c('span', [_vm._v("New Owner")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newOwnerId),
	      expression: "newOwnerId"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.newOwnerId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, _vm._l((_vm.members), function(member) {
	    return (member.id !== _vm.myId) ? _c('option', {
	      domProps: {
	        "value": member.id
	      }
	    }, [_vm._v(_vm._s(member.alias))]) : _vm._e()
	  }))])] : _vm._e(), _vm._v(" "), (_vm.formErrors.length > 0) ? _c('div', {
	    staticClass: "validation-messages error"
	  }, _vm._l((_vm.formErrors), function(error) {
	    return _c('span', [_vm._v(_vm._s(error))])
	  })) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "button-container"
	  }, [_c('span', [_c('button', {
	    staticClass: "button minor",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.cancelLeaving($event)
	      }
	    }
	  }, [_vm._v("Cancel")])]), _vm._v(" "), (_vm.members.length > 1) ? _c('span', [_c('button', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.leaveProject($event)
	      }
	    }
	  }, [_vm._v("Yes, leave Project")])]) : _vm._e(), _vm._v(" "), (_vm.members.length === 1) ? _c('span', [_c('button', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.leaveProject($event)
	      }
	    }
	  }, [_vm._v("Yes, Delete Project")])]) : _vm._e()])] : _vm._e()], 2)])
	},staticRenderFns: []}

/***/ }),
/* 894 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "request"
	  }, [(_vm.isSaving) ? _c('saver-large') : _vm._e(), _vm._v(" "), (!_vm.isSaving && !_vm.serverResponse) ? [_c('div', {
	    staticClass: "avatar-container"
	  }, [_c('avatar', {
	    attrs: {
	      "profile-data": _vm.request.devDetails,
	      "profile-type": "developer",
	      "size": "large",
	      "show-xp-info": false
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "details"
	  }, [_c('span', [_c('router-link', {
	    attrs: {
	      "to": ("/Developer/" + (_vm.request.devDetails.stringUrl))
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-user"
	  }), _vm._v(" " + _vm._s(_vm.request.devDetails.alias))]), _vm._v("\n                Requesting to Join\n                "), _c('router-link', {
	    attrs: {
	      "to": ("/Game/" + (_vm.request.gameDetails.stringUrl))
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-gamepad"
	  }), _vm._v(" " + _vm._s(_vm.request.gameDetails.alias))])], 1), _vm._v(" "), _c('span', [_vm._v("Requesting to be "), _c('span', {
	    staticClass: "position-titles"
	  }, [_vm._v(_vm._s(_vm.request.positionTitles))])]), _vm._v(" "), _c('ul', _vm._l((_vm.request.positions), function(position) {
	    return _c('li', [_vm._v(_vm._s(position))])
	  })), _vm._v(" "), _c('button', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.sendResponse('decline')
	      }
	    }
	  }, [_vm._v("Decline")]), _vm._v(" "), _c('button', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.sendResponse('accept')
	      }
	    }
	  }, [_vm._v("Accept")]), _vm._v(" "), _c('router-link', {
	    staticClass: "button",
	    attrs: {
	      "tag": "button",
	      "to": ("/Inbox/Compose?toId=" + (_vm.request.devDetails.id) + "&toAlias=" + (_vm.request.devDetails.alias))
	    }
	  }, [_vm._v("\n                Contact Developer\n            ")]), _vm._v(" "), (_vm.formErrors.length > 0) ? _c('div', {
	    staticClass: "validation-messages error"
	  }, _vm._l((_vm.formErrors), function(error) {
	    return _c('span', [_vm._v(_vm._s(error))])
	  })) : _vm._e()], 1)] : _vm._e(), _vm._v(" "), (_vm.serverResponse) ? [_c('div', {
	    staticClass: "validation-messages friendly"
	  }, [_vm._v(_vm._s(_vm.serverResponse))])] : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 895 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "media-reorder-album"
	    }
	  }, [_c('h2', [_vm._v("Reorder Albums")]), _vm._v(" "), (!_vm.isSaving) ? _c('form', [_c('ul', _vm._l((_vm.albums), function(album, index) {
	    return _c('li', [_c('div', {
	      staticClass: "reorder-buttons"
	    }, [(index > 0) ? _c('button', {
	      staticClass: "button",
	      on: {
	        "click": function($event) {
	          $event.preventDefault();
	          _vm.moveUp(index)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fas fa-arrow-up"
	    })]) : _vm._e(), _vm._v(" "), (index < _vm.albums.length - 1) ? _c('button', {
	      staticClass: "button",
	      on: {
	        "click": function($event) {
	          $event.preventDefault();
	          _vm.moveDown(index)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "fas fa-arrow-down"
	    })]) : _vm._e()]), _vm._v(" "), _c('div', {
	      staticClass: "avatar-container"
	    }, [(album.hasAvatar) ? _c('img', {
	      staticClass: "media-avatar",
	      attrs: {
	        "src": ("https://www.develteam.com/userdata/avatars/media_" + (album.id) + ".jpg?v=" + (album.avatarId)),
	        "alt": album.title + ' album',
	        "title": album.title + ' album'
	      }
	    }) : _c('img', {
	      staticClass: "media-avatar",
	      attrs: {
	        "src": "https://www.develteam.com/userdata/avatar_blank_100.jpg",
	        "alt": album.title + ' album',
	        "title": album.title + ' album'
	      }
	    })]), _vm._v(" "), _c('div', {
	      staticClass: "title-container"
	    }, [_c('span', {
	      staticClass: "title"
	    }, [_vm._v(_vm._s(album.title))])])])
	  })), _vm._v(" "), _c('button', {
	    staticClass: "button minor",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.cancel($event)
	      }
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.save($event)
	      }
	    }
	  }, [_vm._v("Save")])]) : _vm._e(), _vm._v(" "), (_vm.isSaving) ? _c('saver-large') : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 896 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('article', {
	    staticClass: "browse-item"
	  }, [_c('section', {
	    staticClass: "avatar-container"
	  }, [_c('avatar', {
	    attrs: {
	      "profile-data": _vm.details,
	      "profile-type": "developer",
	      "size": "large",
	      "show-xp-info": true
	    }
	  })], 1), _vm._v(" "), _c('section', {
	    staticClass: "overview"
	  }, [_c('span', {
	    staticClass: "name"
	  }, [_c('router-link', {
	    attrs: {
	      "to": '/Developer/' + _vm.details.stringUrl
	    }
	  }, [_c('i', {
	    class: [{
	      'fas fa-user': true,
	      'online': _vm.developerIsOnline
	    }]
	  }), _vm._v(" " + _vm._s(_vm.details.alias))])], 1), _vm._v(" "), _c('span', {
	    staticClass: "last-online"
	  }, [_vm._v("Last Online: " + _vm._s(_vm._f("formatDate")(_vm.details.lastOnline)))]), _vm._v(" "), _c('span', {
	    staticClass: "last-online"
	  }, [_vm._v("Registered: " + _vm._s(_vm._f("formatDate")(_vm.details.registrationDate)))]), _vm._v(" "), _c('span', {
	    staticClass: "location"
	  }, [_vm._v(_vm._s(_vm.details.location))]), _vm._v(" "), (_vm.isLoggedIn) ? _c('span', {
	    staticClass: "proximity"
	  }, [_vm._v(_vm._s(_vm.details.proximity) + " miles away")]) : _vm._e(), _vm._v(" "), (_vm.details.lookingForGame) ? _c('span', {
	    staticClass: "wants-to-collab"
	  }, [_vm._v("Wants to Join a Game Project")]) : _vm._e()]), _vm._v(" "), _c('section', {
	    staticClass: "about"
	  }, [_c('span', {
	    staticClass: "text-roles"
	  }, [_vm._v(_vm._s(_vm.details.role))]), _vm._v(" "), _c('ul', {
	    staticClass: "official-roles"
	  }, [(_vm.details.isDesigner) ? _c('li', [_vm._v("Designer")]) : _vm._e(), _vm._v(" "), (_vm.details.isArtist) ? _c('li', [_vm._v("Artist")]) : _vm._e(), _vm._v(" "), (_vm.details.isProgrammer) ? _c('li', [_vm._v("Programmer")]) : _vm._e(), _vm._v(" "), (_vm.details.isWriter) ? _c('li', [_vm._v("Writer")]) : _vm._e(), _vm._v(" "), (_vm.details.isMusician) ? _c('li', [_vm._v("Musician")]) : _vm._e(), _vm._v(" "), (_vm.details.isSfxArtist) ? _c('li', [_vm._v("SFX Artist")]) : _vm._e(), _vm._v(" "), (_vm.details.isTester) ? _c('li', [_vm._v("Tester")]) : _vm._e(), _vm._v(" "), (_vm.details.isProducer) ? _c('li', [_vm._v("Producer")]) : _vm._e()]), _vm._v(" "), _c('ul', {
	    staticClass: "skills"
	  }, _vm._l((_vm.details.skills), function(skill) {
	    return (_vm.skillList[skill]) ? _c('router-link', {
	      staticClass: "role-or-skill-item",
	      attrs: {
	        "to": '/Browse/Developers?seekingSkill=' + _vm.skillList[skill].id
	      }
	    }, [_vm._v("\n                " + _vm._s(_vm.skillList[skill].skill) + "\n            ")]) : _vm._e()
	  }))])])
	},staticRenderFns: []}

/***/ }),
/* 897 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "layout",
	    attrs: {
	      "id": "layout-full-width"
	    }
	  }, [_c('div', {
	    attrs: {
	      "id": "tooltip-container"
	    }
	  }), _vm._v(" "), _c('header', {
	    attrs: {
	      "id": "nav-container"
	    }
	  }, [_c('main-nav')], 1), _vm._v(" "), _c('main', {
	    attrs: {
	      "id": "content-container"
	    }
	  }, [_c('div', {
	    class: {
	      'is-open': _vm.chatRoomOpen
	    },
	    attrs: {
	      "id": "chat-room-toggle"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.toggleChatRoom($event)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "far fa-comment-alt"
	  })]), _vm._v(" "), _c('sub-nav'), _vm._v(" "), _c('article', {
	    attrs: {
	      "id": "content"
	    }
	  }, [_c('router-view'), _vm._v(" "), _c('layout-footer')], 1), _vm._v(" "), _c('chat-companion')], 1)])
	},staticRenderFns: []}

/***/ }),
/* 898 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('article', {
	    attrs: {
	      "id": "media-piece-edit-form"
	    }
	  }, [_c('h2', [_vm._v("Edit Piece")]), _vm._v(" "), _c('form', [(!_vm.savingForm) ? [(!_vm.deleteMode) ? [_c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.title),
	      expression: "title"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "Piece Title"
	    },
	    domProps: {
	      "value": (_vm.title)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.title = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('label', [_c('span', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.selectedMediaData.usesUploadFile),
	      expression: "selectedMediaData.usesUploadFile"
	    }]
	  }, [_vm._v("You cannot edit media or preview image. Instead, delete this piece and create a new one.")])]), _vm._v(" "), _c('label', [_c('markdown-editor', {
	    attrs: {
	      "placeholder": "Description (Optional)"
	    },
	    model: {
	      value: (_vm.description),
	      callback: function($$v) {
	        _vm.description = $$v
	      },
	      expression: "description"
	    }
	  })], 1), _vm._v(" "), _c('fieldset', [_c('label', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.selectedMediaData.usesExternalUrl),
	      expression: "selectedMediaData.usesExternalUrl"
	    }]
	  }, [_vm._v("\n                        Media (External Url) "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.mediaText),
	      expression: "mediaText"
	    }],
	    attrs: {
	      "type": "text",
	      "name": "mediaPieceText",
	      "placeholder": "http://..."
	    },
	    domProps: {
	      "value": (_vm.mediaText)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.mediaText = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('label', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.selectedMediaData.usesYoutubeLink),
	      expression: "selectedMediaData.usesYoutubeLink"
	    }]
	  }, [_vm._v("\n                        Youtube Link "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.mediaText),
	      expression: "mediaText"
	    }],
	    attrs: {
	      "type": "text",
	      "name": "mediaPieceText",
	      "placeholder": "http://..."
	    },
	    domProps: {
	      "value": (_vm.mediaText)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.mediaText = $event.target.value
	      }
	    }
	  })])]), _vm._v(" "), _c('fieldset', [_c('button', {
	    staticClass: "button minor",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.exitEditMode($event)
	      }
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.enterDeleteMode($event)
	      }
	    }
	  }, [_vm._v("Delete")]), _vm._v(" "), _c('button', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.submitEditedPiece($event)
	      }
	    }
	  }, [_vm._v("Save")])]), _vm._v(" "), (_vm.formErrors.length > 0) ? _c('fieldset', [_c('ul', {
	    staticClass: "validation-messages error"
	  }, _vm._l((_vm.formErrors), function(formError) {
	    return _c('li', [_vm._v(_vm._s(formError))])
	  }))]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.deleteMode) ? [_c('fieldset', [_c('h1', [_vm._v("Are you sure you want to delete this piece?")]), _vm._v(" "), _c('button', {
	    staticClass: "button minor",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.exitDeleteMode($event)
	      }
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.deletePiece($event)
	      }
	    }
	  }, [_vm._v("Delete")])])] : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.savingForm) ? [_c('saver-large')] : _vm._e()], 2)])
	},staticRenderFns: []}

/***/ }),
/* 899 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('article', {
	    attrs: {
	      "id": "chatroom"
	    }
	  }, [(_vm.isLoggedIn && !_vm.selectedHistoryDate && !_vm.showingHistoryDates) ? _c('div', {
	    attrs: {
	      "id": "chatroom-room-selector"
	    }
	  }, [_c('label', {
	    attrs: {
	      "for": "room-selector-input"
	    }
	  }, [_vm._v("Room: ")]), _vm._v(" "), _c('select', {
	    attrs: {
	      "id": "room-selector-input"
	    },
	    on: {
	      "change": _vm.chooseNewRoom
	    }
	  }, _vm._l((_vm.rooms), function(room) {
	    return _c('option', {
	      domProps: {
	        "value": room.id,
	        "selected": _vm.selectedRoom.id === room.id
	      }
	    }, [_vm._v(_vm._s(room.name))])
	  }))]) : _vm._e(), _vm._v(" "), (_vm.showingHistoryDates) ? [_c('ul', {
	    attrs: {
	      "id": "chatroom-history-dates"
	    }
	  }, [(_vm.showHistoryDatesLoader || _vm.showHistoryMessagesLoader) ? _c('li', {
	    staticClass: "loader-container"
	  }, [_c('loader-small')], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.historyDates), function(historyDate) {
	    return (!_vm.showHistoryMessagesLoader && !_vm.showHistoryMessagesLoader) ? _c('li', {
	      staticClass: "history-date-item",
	      on: {
	        "click": function($event) {
	          _vm.selectHistoryDate(historyDate)
	        }
	      }
	    }, [_c('span', [_vm._v(_vm._s(historyDate.messageCount))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("formatDateWithoutTime")(historyDate.day)))])]) : _vm._e()
	  })], 2)] : _vm._e(), _vm._v(" "), (!_vm.showingHistoryDates) ? [(_vm.selectedHistoryDate) ? _c('span', {
	    attrs: {
	      "id": "chatroom-history-header"
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-fw fa-arrow-left",
	    on: {
	      "click": _vm.showHistoryDates
	    }
	  }), _vm._v("\n                History: " + _vm._s(_vm._f("formatDateWithoutTime")(_vm.selectedHistoryDate.day)) + "\n            ")]) : _vm._e(), _vm._v(" "), _c('ul', {
	    ref: "chatMessages",
	    attrs: {
	      "id": "chatroom-messages"
	    }
	  }, [(_vm.showHistoryMessagesLoader) ? _c('li', {
	    staticClass: "loader-container"
	  }, [_c('loader-small')], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.messages), function(message) {
	    return _c('li', [(!message.isSystemMessage) ? _c('div', {
	      staticClass: "avatar-container"
	    }, [_c('avatar', {
	      attrs: {
	        "profile-data": message.from,
	        "profile-type": "developer",
	        "size": "very-small",
	        "show-xp-info": false
	      }
	    })], 1) : _vm._e(), _vm._v(" "), (!message.isSystemMessage) ? _c('div', {
	      staticClass: "message-details"
	    }, [_c('span', {
	      staticClass: "message-from"
	    }, [_c('router-link', {
	      attrs: {
	        "to": '/Developer/' + message.from.stringUrl
	      }
	    }, [(message.from.isModerator) ? _c('i', {
	      staticClass: "fas fa-crown mod-icon"
	    }) : _vm._e(), _vm._v(" "), (message.from.donatedAmount > 0 && message.from.donatedAmount < 40) ? _c('i', {
	      staticClass: "fas fa-heartbeat donor-icon"
	    }) : _vm._e(), _vm._v(" "), (message.from.donatedAmount >= 40) ? _c('i', {
	      staticClass: "fas fa-heartbeat donor-icon gold"
	    }) : _vm._e(), _vm._v("\n                                        " + _vm._s(message.from.alias) + "\n                                    ")])], 1), _vm._v(" "), _vm._l((message.messages), function(individualMessage) {
	      return _c('div', {
	        staticClass: "individual-message"
	      }, [_c('markdown-content', {
	        attrs: {
	          "classes": "message-message",
	          "content": individualMessage.message
	        }
	      }), _vm._v(" "), _c('span', {
	        staticClass: "message-date"
	      }, [_vm._v(_vm._s(_vm._f("formatDateCondensed")(individualMessage.timestamp)))])], 1)
	    })], 2) : _vm._e(), _vm._v(" "), (message.isSystemMessage) ? _c('div', {
	      staticClass: "message-details"
	    }, _vm._l((message.messages), function(individualMessage) {
	      return (message.isSystemMessage) ? _c('div', {
	        staticClass: "individual-message"
	      }, [(message.systemMessageType === 'registeredDeveloper') ? _c('section', {
	        staticClass: "message-message system-message"
	      }, [_c('i', {
	        staticClass: "fas fa-user"
	      }), _vm._v(" "), _c('router-link', {
	        attrs: {
	          "to": message.targetUrl
	        }
	      }, [_vm._v(_vm._s(message.targetAlias))]), _vm._v("\n                                just registered\n                            ")], 1) : _vm._e(), _vm._v(" "), (message.systemMessageType === 'createdGame') ? _c('section', {
	        staticClass: "message-message system-message"
	      }, [_c('i', {
	        staticClass: "fas fa-gamepad"
	      }), _vm._v(" "), _c('router-link', {
	        attrs: {
	          "to": message.targetUrl
	        }
	      }, [_vm._v(_vm._s(message.targetAlias))]), _vm._v("\n                                just created\n                            ")], 1) : _vm._e(), _vm._v(" "), (message.systemMessageType === 'message') ? _c('section', {
	        staticClass: "message-message system-message"
	      }, [_c('markdown-content', {
	        attrs: {
	          "classes": "message-message",
	          "content": individualMessage.message
	        }
	      })], 1) : _vm._e()]) : _vm._e()
	    })) : _vm._e()])
	  })], 2)] : _vm._e(), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "chatroom-options"
	    }
	  }, [_c('div', {
	    class: ['option', {
	      selected: _vm.showingHistoryDates || _vm.showingHistoryDateMessages
	    }],
	    attrs: {
	      "title": "History"
	    },
	    on: {
	      "click": _vm.toggleHistoryDates
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-fw fa-history"
	  })]), _vm._v(" "), (_vm.audioNotificationsEnabled) ? _c('div', {
	    staticClass: "option",
	    attrs: {
	      "title": "Turn off Audio Notifications"
	    },
	    on: {
	      "click": function($event) {
	        _vm.toggleAudioNotifications('off')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-fw fa-volume-up"
	  })]) : _vm._e(), _vm._v(" "), (!_vm.audioNotificationsEnabled) ? _c('div', {
	    staticClass: "option",
	    attrs: {
	      "title": "Turn on Audio Notifications"
	    },
	    on: {
	      "click": function($event) {
	        _vm.toggleAudioNotifications('on')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-fw fa-volume-off"
	  })]) : _vm._e()]), _vm._v(" "), (_vm.isLoggedIn && !_vm.selectedHistoryDate && !_vm.showingHistoryDates) ? _c('form', {
	    attrs: {
	      "id": "chatroom-input"
	    }
	  }, [(_vm.isLoggedIn) ? [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newMessage),
	      expression: "newMessage"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "Type to chat...",
	      "maxlength": "450"
	    },
	    domProps: {
	      "value": (_vm.newMessage)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newMessage = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('input', {
	    attrs: {
	      "type": "submit",
	      "value": "Send"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.sendMessage($event)
	      }
	    }
	  })] : _vm._e()], 2) : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 900 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(_vm.isLoggedIn) ? _c('div', {
	    staticClass: "validation-messages friendly"
	  }, [_vm._v("You are Logged In")]) : _vm._e(), _vm._v(" "), (!_vm.isLoggedIn) ? _c('div', {
	    attrs: {
	      "id": "login-form"
	    }
	  }, [_c('h2', [_vm._v("Log In")]), _vm._v(" "), _c('form', {
	    attrs: {
	      "name": "login"
	    }
	  }, [(_vm.validationMessage) ? _c('div', {
	    staticClass: "validation-messages error"
	  }, [_vm._v(_vm._s(_vm.validationMessage))]) : _vm._e(), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.email),
	      expression: "email"
	    }],
	    attrs: {
	      "type": "text",
	      "id": "login-email",
	      "name": "email",
	      "placeholder": "Email"
	    },
	    domProps: {
	      "value": (_vm.email)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.email = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.password),
	      expression: "password"
	    }],
	    attrs: {
	      "type": "password",
	      "id": "login-password",
	      "name": "password",
	      "size": "20",
	      "placeholder": "Password"
	    },
	    domProps: {
	      "value": (_vm.password)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.password = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('label', {
	    staticClass: "remember-me",
	    attrs: {
	      "for": "remember"
	    }
	  }, [_c('input', _vm._b({
	    attrs: {
	      "type": "checkbox",
	      "name": "remember",
	      "id": "remember",
	      "value": "Yes",
	      "checked": ""
	    }
	  }, 'input', _vm.rememberMe, false)), _vm._v("Remember me")]), _vm._v(" "), _c('div', {
	    staticClass: "button-container"
	  }, [_c('button', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.submit($event)
	      }
	    }
	  }, [_vm._v("Log In")])]), _vm._v(" "), _c('div', {
	    staticClass: "options"
	  }, [_c('span', [_c('router-link', {
	    staticClass: "forgot-password",
	    attrs: {
	      "to": "/Login/Forgot"
	    }
	  }, [_vm._v("I forgot my password!")])], 1), _vm._v(" "), _c('span', [_c('router-link', {
	    staticClass: "register-link",
	    attrs: {
	      "to": "/Register"
	    }
	  }, [_vm._v("Register new account")])], 1)])])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 901 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    attrs: {
	      "id": "edit-game-properties"
	    }
	  }, [_c('div', {
	    staticClass: "edit-container"
	  }, [(_vm.isSaving) ? _c('saver-large') : _vm._e(), _vm._v(" "), (!_vm.isSaving) ? [_c('h1', [_vm._v("Game Details")]), _vm._v(" "), _c('div', {
	    staticClass: "edit-platforms"
	  }, [_c('label', {
	    staticClass: "toggleable",
	    on: {
	      "click": _vm.togglePlatforms
	    }
	  }, [_vm._v("\n                    Platform\n                    "), (_vm.platformsOpen) ? _c('i', {
	    staticClass: "fas fa-chevron-circle-up"
	  }) : _vm._e(), _vm._v(" "), (!_vm.platformsOpen) ? _c('i', {
	    staticClass: "fas fa-chevron-circle-down"
	  }) : _vm._e()]), _vm._v(" "), _vm._l((_vm.platforms), function(category) {
	    return (_vm.platformsOpen) ? _c('div', {
	      staticClass: "platform-group"
	    }, [_c('h3', [_vm._v(_vm._s(category.label))]), _vm._v(" "), _c('div', {
	      staticClass: "options"
	    }, _vm._l((category.platforms), function(platform) {
	      return _c('label', {
	        directives: [{
	          name: "show",
	          rawName: "v-show",
	          value: (!platform.initiallyHidden || category.showHidden),
	          expression: "!platform.initiallyHidden || category.showHidden"
	        }]
	      }, [_c('input', {
	        directives: [{
	          name: "model",
	          rawName: "v-model",
	          value: (platform.checked),
	          expression: "platform.checked"
	        }],
	        attrs: {
	          "type": "checkbox"
	        },
	        domProps: {
	          "checked": Array.isArray(platform.checked) ? _vm._i(platform.checked, null) > -1 : (platform.checked)
	        },
	        on: {
	          "change": _vm.clearErrorMessage,
	          "__c": function($event) {
	            var $$a = platform.checked,
	              $$el = $event.target,
	              $$c = $$el.checked ? (true) : (false);
	            if (Array.isArray($$a)) {
	              var $$v = null,
	                $$i = _vm._i($$a, $$v);
	              if ($$el.checked) {
	                $$i < 0 && (platform.checked = $$a.concat($$v))
	              } else {
	                $$i > -1 && (platform.checked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	              }
	            } else {
	              platform.checked = $$c
	            }
	          }
	        }
	      }), _c('span', [_vm._v(_vm._s(platform.label))])])
	    })), _vm._v(" "), _c('span', {
	      staticClass: "show-all"
	    }, [(!category.showHidden && category.hasHidden) ? _c('a', {
	      on: {
	        "click": function($event) {
	          $event.preventDefault();
	          _vm.showHidden(category)
	        }
	      }
	    }, [_vm._v("Show All " + _vm._s(category.label))]) : _vm._e()])]) : _vm._e()
	  })], 2), _vm._v(" "), _c('div', {
	    staticClass: "edit-genres"
	  }, [_c('label', {
	    staticClass: "toggleable",
	    on: {
	      "click": _vm.toggleGenres
	    }
	  }, [_vm._v("\n                    Genre\n                    "), (_vm.genresOpen) ? _c('i', {
	    staticClass: "fas fa-chevron-circle-up"
	  }) : _vm._e(), _vm._v(" "), (!_vm.genresOpen) ? _c('i', {
	    staticClass: "fas fa-chevron-circle-down"
	  }) : _vm._e()]), _vm._v(" "), (_vm.genresOpen) ? _c('div', {
	    staticClass: "options"
	  }, _vm._l((_vm.genres), function(genre) {
	    return _c('label', [_c('input', {
	      directives: [{
	        name: "model",
	        rawName: "v-model",
	        value: (genre.checked),
	        expression: "genre.checked"
	      }],
	      attrs: {
	        "type": "checkbox"
	      },
	      domProps: {
	        "checked": Array.isArray(genre.checked) ? _vm._i(genre.checked, null) > -1 : (genre.checked)
	      },
	      on: {
	        "change": _vm.clearErrorMessage,
	        "__c": function($event) {
	          var $$a = genre.checked,
	            $$el = $event.target,
	            $$c = $$el.checked ? (true) : (false);
	          if (Array.isArray($$a)) {
	            var $$v = null,
	              $$i = _vm._i($$a, $$v);
	            if ($$el.checked) {
	              $$i < 0 && (genre.checked = $$a.concat($$v))
	            } else {
	              $$i > -1 && (genre.checked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	            }
	          } else {
	            genre.checked = $$c
	          }
	        }
	      }
	    }), _c('span', [_vm._v(_vm._s(genre.label))])])
	  })) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "edit-rated"
	  }, [_c('label', [_vm._v("Rated")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.rating),
	      expression: "rating"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.rating = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "everyone"
	    }
	  }, [_vm._v("Everyone")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "teen"
	    }
	  }, [_vm._v("Teen")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "mature"
	    }
	  }, [_vm._v("Mature")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "adult"
	    }
	  }, [_vm._v("Adult")])])]), _vm._v(" "), _c('div', {
	    staticClass: "edit-release-date"
	  }, [_c('label', [_vm._v("Release Date")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.releaseDate),
	      expression: "releaseDate"
	    }],
	    attrs: {
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.releaseDate)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.releaseDate = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "edit-rated"
	  }, [_c('label', [_vm._v("Dev Status")]), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.devStatus),
	      expression: "devStatus"
	    }],
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.devStatus = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "indevelopment"
	    }
	  }, [_vm._v("In Development")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "abandoned"
	    }
	  }, [_vm._v("Abandoned")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "completed"
	    }
	  }, [_vm._v("Completed")])])]), _vm._v(" "), (_vm.errorMessage) ? _c('div', {
	    staticClass: "validation-messages error"
	  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "companion-content-subsection buttons"
	  }, [_c('button', {
	    staticClass: "button minor",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.cancelChanges($event)
	      }
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.saveChanges($event)
	      }
	    }
	  }, [_vm._v("Save")])])] : _vm._e()], 2)])
	},staticRenderFns: []}

/***/ }),
/* 902 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.$store.state.gamePageModel.retrievedInformation) ? _c('section', {
	    attrs: {
	      "id": "game-companion-content"
	    }
	  }, [_c('div', {
	    staticClass: "main-details"
	  }, [_c('div', {
	    staticClass: "avatar-container"
	  }, [_c('avatar', {
	    attrs: {
	      "profile-data": _vm.game,
	      "profile-type": "game",
	      "size": "super-large",
	      "show-xp-info": true
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "details-container"
	  }, [_c('h1', {
	    staticClass: "game-alias"
	  }, [_c('i', {
	    staticClass: "fas fa-gamepad"
	  }), _vm._v("\n                " + _vm._s(_vm.game.alias) + "\n            ")]), _vm._v(" "), _c('div', {
	    staticClass: "platform"
	  }, [_c('h3', [_vm._v("Platform")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.game.platforms))])]), _vm._v(" "), _c('div', {
	    staticClass: "genre"
	  }, [_c('h3', [_vm._v("Genre")]), _vm._v(" "), _c('span', {
	    staticClass: "info"
	  }, [_vm._v(_vm._s(_vm.game.genres))])]), _vm._v(" "), _c('div', {
	    staticClass: "rating"
	  }, [_c('h3', [_vm._v("Rating")]), _vm._v(" "), _c('span', {
	    staticClass: "info"
	  }, [_vm._v(_vm._s(_vm._f("capitalizeFirstLetter")(_vm.game.rating)))])]), _vm._v(" "), _c('div', {
	    staticClass: "dev-status"
	  }, [_c('h3', [_vm._v("Dev Status")]), _vm._v(" "), _c('span', {
	    staticClass: "info"
	  }, [_vm._v(_vm._s(_vm.getDevStatus(_vm.game.devStatus)))])]), _vm._v(" "), (_vm.game.releaseDate) ? _c('div', {
	    staticClass: "release-date"
	  }, [_c('h3', [_vm._v("Release Date")]), _vm._v(" "), _c('span', {
	    staticClass: "info"
	  }, [_vm._v(_vm._s(_vm.game.releaseDate))])]) : _vm._e(), _vm._v(" "), (_vm.showContactOptions) ? _c('div', {
	    staticClass: "connect-options"
	  }, [(_vm.showRequestOption) ? _c('span', {
	    on: {
	      "click": _vm.sendRequestToJoin
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-user"
	  }), _vm._v(" Request to Join")]) : _vm._e(), _vm._v(" "), (!_vm.isFollowing && _vm.showFollowOption && !_vm.savingFollowingChange) ? _c('span', {
	    on: {
	      "click": _vm.updateFollowStatus
	    }
	  }, [_c('i', {
	    staticClass: "far fa-paper-plane"
	  }), _vm._v(" Follow")]) : _vm._e(), _vm._v(" "), (_vm.isFollowing && _vm.showFollowOption && !_vm.savingFollowingChange) ? _c('span', {
	    on: {
	      "click": _vm.updateFollowStatus
	    }
	  }, [_c('i', {
	    staticClass: "far fa-times-circle"
	  }), _vm._v(" Un follow")]) : _vm._e(), _vm._v(" "), (_vm.savingFollowingChange) ? _c('span', [_c('i', {
	    staticClass: "fas fa-sync fa-spin"
	  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isSeeking) ? _c('div', {
	    staticClass: "currently-recruiting"
	  }, [(_vm.isSeeking) ? _c('div', {
	    staticClass: "wants-to-collab"
	  }, [_vm._v("Actively Recruiting")]) : _vm._e(), _vm._v(" "), _c('h3', [_vm._v("Roles")]), _vm._v(" "), (_vm.game.seekingRoles) ? _c('span', {
	    staticClass: "info"
	  }, [_vm._v(_vm._s(_vm.game.seekingRoles))]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "role-list"
	  }, [(_vm.game.seekingProducers) ? _c('router-link', {
	    staticClass: "role-tag",
	    attrs: {
	      "to": '/Browse/Developers?seekingRole=producers'
	    }
	  }, [_c('span', [_vm._v("Producers")])]) : _vm._e(), _vm._v(" "), (_vm.game.seekingDesigners) ? _c('router-link', {
	    staticClass: "role-tag",
	    attrs: {
	      "to": '/Browse/Developers?seekingRole=designers'
	    }
	  }, [_c('span', [_vm._v("Designers")])]) : _vm._e(), _vm._v(" "), (_vm.game.seekingArtists) ? _c('router-link', {
	    staticClass: "role-tag",
	    attrs: {
	      "to": '/Browse/Developers?seekingRole=artists'
	    }
	  }, [_c('span', [_vm._v("Artists")])]) : _vm._e(), _vm._v(" "), (_vm.game.seekingProgrammers) ? _c('router-link', {
	    staticClass: "role-tag",
	    attrs: {
	      "to": '/Browse/Developers?seekingRole=programmers'
	    }
	  }, [_c('span', [_vm._v("Programmers")])]) : _vm._e(), _vm._v(" "), (_vm.game.seekingWriters) ? _c('router-link', {
	    staticClass: "role-tag",
	    attrs: {
	      "to": '/Browse/Developers?seekingRole=writers'
	    }
	  }, [_c('span', [_vm._v("Writers")])]) : _vm._e(), _vm._v(" "), (_vm.game.seekingMusicians) ? _c('router-link', {
	    staticClass: "role-tag",
	    attrs: {
	      "to": '/Browse/Developers?seekingRole=musicians'
	    }
	  }, [_c('span', [_vm._v("Musicians")])]) : _vm._e(), _vm._v(" "), (_vm.game.seekingSfxArtists) ? _c('router-link', {
	    staticClass: "role-tag",
	    attrs: {
	      "to": '/Browse/Developers?seekingRole=sfx'
	    }
	  }, [_c('span', [_vm._v("SFX Artists")])]) : _vm._e(), _vm._v(" "), (_vm.game.seekingTesters) ? _c('router-link', {
	    staticClass: "role-tag",
	    attrs: {
	      "to": '/Browse/Developers?seekingRole=testers'
	    }
	  }, [_c('span', [_vm._v("Testers")])]) : _vm._e()], 1), _vm._v(" "), (_vm.game.skills.length > 0) ? [_c('h3', [_vm._v("Skills")]), _vm._v(" "), (_vm.showSkillTags) ? _c('div', {
	    staticClass: "skills"
	  }, [(_vm.game.skills) ? _c('div', {
	    staticClass: "skill-list"
	  }, _vm._l((_vm.game.skills), function(skillId) {
	    return _c('router-link', {
	      staticClass: "skill-tag",
	      attrs: {
	        "to": '/Browse/Developers?seekingSkill=' + skillId
	      }
	    }, [_vm._v("\n                                " + _vm._s(_vm.getSkill(skillId)) + "\n                            ")])
	  })) : _vm._e()]) : _vm._e()] : _vm._e()], 2) : _vm._e()]), _vm._v(" "), (!_vm.editDetailsMode && !_vm.editVitalsMode && !_vm.editRecruitmentMode && !_vm.leaveGameMode) ? _c('div', {
	    staticClass: "edit-options"
	  }, [(_vm.isModerator) ? _c('button', {
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.editVitalsMode = true
	      }
	    }
	  }, [_vm._v("Edit Title and Avatar")]) : _vm._e(), _vm._v(" "), (_vm.isModerator) ? _c('button', {
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.editDetailsMode = true
	      }
	    }
	  }, [_vm._v("Edit Game Details")]) : _vm._e(), _vm._v(" "), (_vm.isModerator) ? _c('button', {
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.editRecruitmentMode = true
	      }
	    }
	  }, [_vm._v("Edit Recruitment Details")]) : _vm._e(), _vm._v(" "), (_vm.isMember) ? _c('button', {
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.leaveGameMode = true
	      }
	    }
	  }, [_vm._v("Leave Game Project")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.editVitalsMode) ? _c('edit-game-vitals', {
	    attrs: {
	      "game": _vm.game
	    },
	    on: {
	      "doneEditing": function($event) {
	        _vm.editVitalsMode = false
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.editDetailsMode) ? _c('edit-game', {
	    on: {
	      "doneEditing": function($event) {
	        _vm.editDetailsMode = false
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.editRecruitmentMode) ? _c('edit-game-recruitment', {
	    attrs: {
	      "game": _vm.game
	    },
	    on: {
	      "doneEditing": function($event) {
	        _vm.editRecruitmentMode = false
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.leaveGameMode) ? _c('leave-game', {
	    attrs: {
	      "game": _vm.game,
	      "is-owner": _vm.isOwner
	    },
	    on: {
	      "doneEditing": function($event) {
	        _vm.leaveGameMode = false
	      }
	    }
	  }) : _vm._e()], 1)]) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 903 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('svg', {
	    staticClass: "dt-icon icon-developer",
	    attrs: {
	      "version": "1.1",
	      "id": "Layer_1",
	      "xmlns": "http://www.w3.org/2000/svg",
	      "xmlns:xlink": "http://www.w3.org/1999/xlink",
	      "x": "0px",
	      "y": "0px",
	      "width": "600px",
	      "height": "400px",
	      "viewBox": "0 0 600 400",
	      "enable-background": "new 0 0 600 400",
	      "xml:space": "preserve"
	    }
	  }, [_c('g', [_c('g', [_c('path', {
	    attrs: {
	      "fill": "#010101",
	      "d": "M368.289,177.012c4.443,2.08,8.733,4.41,12.873,7.044c2.024,1.289,3.974,2.69,5.892,4.129\n\t\t\tc-2.909-2.183,0.236,0.271,0.676,0.64c1.214,1.017,2.378,2.092,3.533,3.175c1.734,1.625,3.362,3.358,4.95,5.125\n\t\t\tc0.797,0.887,1.555,1.808,2.313,2.729c2.553,3.103-1.813-2.483,0.564,0.778c3.142,4.313,5.751,8.99,8.014,13.815\n\t\t\tc1.793,3.823-1.102-2.852,0.487,1.116c0.484,1.21,0.917,2.439,1.351,3.668c0.891,2.529,1.621,5.113,2.303,7.706\n\t\t\tc0.711,2.709,1.258,5.458,1.756,8.212c0.043,0.235,0.734,4.928,0.322,1.772c0.26,1.991,0.436,3.992,0.601,5.992\n\t\t\tc0.966,11.685,0.484,23.582,0.492,35.301c0.003,4.076-0.027,8.151-0.148,12.226c-0.05,1.684-0.133,3.366-0.237,5.048\n\t\t\tc-0.09,1.455-0.838,7.728-0.027,1.725c-0.302,2.234-0.777,4.448-1.538,6.573c-0.774,2.164,1.748-3.886,0.773-1.878\n\t\t\tc-0.189,0.391-0.413,0.762-0.639,1.132c-1.37,2.25,3.211-3.218,0.252-0.597c4.063-3.599,2.239-1.609,0.688-0.847\n\t\t\tc5.086-2.501,2.344-0.94,0.698-0.54c-3.864,0.941,3.879-0.319,0.509-0.029c-1.371,0.117-2.752,0.118-4.126,0.101\n\t\t\tc-6.97-0.088-13.948-1.148-20.853-2.009c-3.801-0.474-7.603-0.947-11.406-1.401c-8.139-0.971-15,7.558-15,15\n\t\t\tc0,8.909,6.884,14.032,15,15c14.224,1.696,29.575,5.355,43.851,2.268c15.285-3.307,20.169-17.815,21.575-31.501\n\t\t\tc0.811-7.883,0.643-15.886,0.622-23.798c-0.032-12.082,0.365-24.259-0.912-36.288c-2.589-24.377-11.428-47.186-28.493-65.104\n\t\t\tc-8.869-9.313-19.962-16.752-31.574-22.187c-7.405-3.466-16.114-2.145-20.522,5.381\n\t\t\tC359.062,163.054,360.884,173.546,368.289,177.012L368.289,177.012z"
	    }
	  })])]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
	    attrs: {
	      "fill": "#010101",
	      "d": "M234.814,296.467c-15.118,1.572-30.632,4.954-45.876,4.656c-1.042-0.021-2.08-0.1-3.114-0.214\n\t\t\tc5.975,0.66,2.361,0.334,0.875-0.068c-3.468-0.937,3.473,1.762,0.985,0.479c-3.419-1.763,2.418,2.287,0.64,0.571\n\t\t\tc-2.443-2.357,2.197,3.311,0.698,0.905c-0.219-0.351-0.404-0.722-0.59-1.091c-0.983-1.954,1.619,4.053,0.825,1.951\n\t\t\tc-0.349-0.925-0.6-1.886-0.833-2.846c-0.345-1.42-1.019-6.527-0.254-0.6c-0.895-6.933-0.807-14.013-0.82-20.989\n\t\t\tc-0.021-11.021-0.245-22.115,0.283-33.124c0.144-2.999,0.435-5.989,0.783-8.971c-0.374,3.206,0.256-1.438,0.301-1.709\n\t\t\tc0.229-1.381,0.509-2.754,0.789-4.125c1.149-5.624,2.853-11.121,4.956-16.457c-1.29,3.273,0.282-0.563,0.495-1.027\n\t\t\tc0.518-1.122,1.083-2.222,1.648-3.32c1.11-2.159,2.359-4.244,3.653-6.297c0.638-1.012,1.319-1.995,2-2.978\n\t\t\tc0.332-0.479,2.76-3.651,0.496-0.761c1.692-2.161,3.538-4.197,5.437-6.176c2.166-2.257,4.503-4.343,6.903-6.346\n\t\t\tc1.304-1.042,1.215-0.99-0.266,0.157c0.627-0.476,1.26-0.943,1.899-1.402c1.6-1.166,3.258-2.248,4.928-3.31\n\t\t\tc2.711-1.724,5.537-3.265,8.397-4.725c1.454-0.743,2.937-1.428,4.422-2.106c1.561-0.682,1.503-0.668-0.173,0.042\n\t\t\tc1.153-0.483,2.321-0.93,3.488-1.377c7.627-2.924,12.805-9.986,10.477-18.452c-2.009-7.303-10.808-13.407-18.452-10.477\n\t\t\tc-21.586,8.276-39.919,20.853-53.459,39.792c-14.246,19.927-18.917,45.335-18.928,69.36c-0.007,17.128-1.296,34.786,1.733,51.743\n\t\t\tc1.057,5.914,3.774,11.588,7.952,15.928c5.075,5.273,11.761,6.906,18.713,7.806c6.093,0.788,12.476-0.159,18.53-0.853\n\t\t\tc10.158-1.163,20.29-2.532,30.46-3.59c8.13-0.846,15-6.184,15-15C249.814,303.932,242.962,295.619,234.814,296.467\n\t\t\tL234.814,296.467z"
	    }
	  })])]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
	    attrs: {
	      "fill": "#010101",
	      "d": "M379.614,111.269c-0.022,2.735-0.153,5.452-0.397,8.177c-0.398,4.45,0.521-3.043-0.16,1.345\n\t\t\tc-0.204,1.318-0.473,2.625-0.74,3.93c-0.531,2.589-1.247,5.137-2.022,7.662c-0.386,1.254-0.83,2.489-1.273,3.723\n\t\t\tc-0.302,0.818-0.616,1.631-0.943,2.439c0.674-1.576,0.66-1.573-0.04,0.008c-2.136,4.737-4.815,9.213-7.776,13.475\n\t\t\tc-0.233,0.336-2.845,3.737-0.771,1.105c-0.803,1.018-1.65,2-2.497,2.98c-1.98,2.293-4.13,4.436-6.336,6.51\n\t\t\tc-0.948,0.891-1.936,1.74-2.922,2.588c-0.297,0.255-3.688,2.923-1.043,0.908c-2.085,1.588-4.272,3.036-6.487,4.434\n\t\t\tc-2.231,1.407-4.553,2.664-6.898,3.867c-1.18,0.605-2.386,1.158-3.592,1.71c-1.59,0.7-1.623,0.714-0.098,0.043\n\t\t\tc-0.829,0.329-1.662,0.645-2.501,0.949c-5.091,1.889-10.382,3.194-15.723,4.138c-4.48,0.791,3.055-0.303-1.494,0.219\n\t\t\tc-1.39,0.159-2.784,0.255-4.179,0.351c-3.296,0.226-6.604,0.201-9.903,0.075c-1.401-0.053-2.799-0.17-4.197-0.288\n\t\t\tc-0.381-0.032-4.937-0.635-1.521-0.138c-2.71-0.395-5.39-0.972-8.052-1.61c-2.627-0.63-5.209-1.436-7.767-2.299\n\t\t\tc-1.269-0.428-2.518-0.913-3.766-1.396c3.07,1.191-1.97-0.913-2.503-1.167c-4.754-2.264-9.246-5.048-13.521-8.111\n\t\t\tc-3.512-2.516,2.257,1.863-1.094-0.85c-1.012-0.82-1.988-1.684-2.962-2.547c-2.27-2.01-4.387-4.185-6.435-6.417\n\t\t\tc-0.877-0.956-1.71-1.95-2.542-2.943c-2.755-3.287,1.719,2.387-0.833-1.059c-1.544-2.084-2.944-4.27-4.292-6.484\n\t\t\tc-1.351-2.22-2.547-4.531-3.688-6.864c-0.188-0.386-1.902-4.349-0.594-1.187c-0.667-1.613-1.246-3.262-1.811-4.914\n\t\t\tc-0.854-2.497-1.529-5.05-2.141-7.615c-0.309-1.294-0.555-2.602-0.802-3.909c-0.085-0.452-0.674-4.839-0.244-1.319\n\t\t\tc-0.718-5.871-0.669-11.816-0.143-17.698c0.205-1.783,0.19-1.791-0.045-0.022c0.184-1.324,0.431-2.638,0.679-3.951\n\t\t\tc0.49-2.603,1.167-5.167,1.904-7.708c0.73-2.52,1.639-4.983,2.603-7.421c-1.256,3.174,0.408-0.792,0.594-1.187\n\t\t\tc0.553-1.177,1.16-2.328,1.767-3.478c1.211-2.296,2.579-4.505,3.994-6.679c0.707-1.086,1.463-2.14,2.219-3.192\n\t\t\tc2.5-3.484-1.873,2.269,0.833-1.059c3.278-4.033,7.002-7.688,10.939-11.072c0.663-0.562,1.334-1.113,2.014-1.655\n\t\t\tc-2.581,2.09,0.822-0.56,1.144-0.79c2.135-1.529,4.368-2.915,6.628-4.249c2.277-1.344,4.641-2.534,7.027-3.67\n\t\t\tc0.35-0.167,4.396-1.849,1.306-0.596c1.241-0.503,2.503-0.95,3.766-1.396c5.13-1.816,10.452-3.044,15.819-3.908\n\t\t\tc-3.401,0.548,1.133-0.099,1.521-0.138c1.396-0.139,2.797-0.213,4.197-0.288c2.83-0.151,5.667-0.108,8.498,0\n\t\t\tc2.329,0.088,4.65,0.318,6.964,0.583c-3.412-0.391,1.079,0.231,1.467,0.3c1.347,0.238,2.682,0.537,4.016,0.835\n\t\t\tc2.642,0.591,5.24,1.36,7.817,2.186c1.277,0.409,2.535,0.876,3.792,1.342c4.135,1.533-2.676-1.243,1.344,0.526\n\t\t\tc4.831,2.126,9.413,4.782,13.787,7.725c1.086,0.73,2.138,1.508,3.19,2.285c-2.669-1.972,0.737,0.653,1.043,0.907\n\t\t\tc1.997,1.667,3.881,3.464,5.722,5.3c1.531,1.527,2.971,3.143,4.384,4.779c0.265,0.307,2.93,3.676,0.894,1.01\n\t\t\tc0.786,1.03,1.526,2.095,2.266,3.159c2.967,4.269,5.438,8.864,7.572,13.598c-1.404-3.115,0.294,0.853,0.448,1.26\n\t\t\tc0.463,1.227,0.868,2.476,1.273,3.723c0.815,2.515,1.45,5.084,2.022,7.663c0.289,1.302,0.515,2.616,0.74,3.93\n\t\t\tc0.752,4.377-0.311-3.097,0.16,1.346C379.504,105.807,379.592,108.54,379.614,111.269c0.066,8.176,6.772,15,15,15\n\t\t\tc8.127,0,15.066-6.823,15-15c-0.203-25.044-9.681-48.393-26.271-67.031c-16.59-18.639-40.217-29.661-64.69-32.844\n\t\t\tc-49.692-6.462-98.546,25.167-112.5,73.306c-7.006,24.172-3.552,50.257,7.748,72.502c11.089,21.829,30.953,38.303,53.402,47.399\n\t\t\tc46.813,18.97,102.278,0.061,128.396-42.863c9.181-15.087,13.771-32.877,13.914-50.469c0.066-8.177-6.873-15-15-15\n\t\t\tC386.387,96.269,379.681,103.093,379.614,111.269z"
	    }
	  })])]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
	    attrs: {
	      "fill": "#010101",
	      "d": "M359.025,235.921c1.662,23.026,2.858,46.103,3.591,69.176c0.497,15.652,0.852,31.368,0.05,47.016\n\t\t\tc-0.142,2.768-0.348,5.532-0.637,8.289c-0.47,4.475,0.521-3.276,0.012-0.01c-0.171,1.095-0.389,2.181-0.646,3.258\n\t\t\tc-0.175,0.733-0.397,1.455-0.657,2.163c1.848-5.051,1.622-3.653,1.019-2.487c-0.568,1.101-2.136,2.648,1.806-2.231\n\t\t\tc-1.32,1.634,4.141-2.682,1.61-1.305c-1.974,1.073,4.685-1.646,0.811-0.437c-2.021,0.631-4.117,1.024-6.198,1.39\n\t\t\tc-1.316,0.231-6.313,0.909-0.619,0.152c-1.742,0.231-3.49,0.421-5.239,0.6c-7.535,0.771-15.11,1.156-22.679,1.435\n\t\t\tc-17.367,0.638-34.782,0.51-52.143-0.258c-7.433-0.329-14.864-0.81-22.265-1.583c-1.464-0.152-2.926-0.328-4.387-0.515\n\t\t\tc5.721,0.73,0.798,0.09-0.53-0.129c-2.16-0.355-4.314-0.79-6.415-1.414c-3.292-0.979,1.672,0.815,1.338,0.656\n\t\t\tc-2.48-1.184,3.088,2.894,1.739,1.426c3.247,3.532,2.558,3.568,1.876,2.309c-0.862-1.593,1.743,4.356,1.083,2.564\n\t\t\tc-0.292-0.793-0.479-1.625-0.659-2.448c-0.197-0.9-0.339-1.813-0.477-2.725c0.928,6.176,0.225,1.604,0.078,0.141\n\t\t\tc-0.294-2.933-0.459-5.878-0.596-8.821c-1.796-38.597,0.795-77.681,3.212-116.211c0.512-8.169-7.211-15-15-15\n\t\t\tc-8.564,0-14.488,6.843-15,15c-1.432,22.824-2.469,45.685-3.12,68.544c-0.444,15.621-0.762,31.287-0.125,46.908\n\t\t\tc0.49,12.021,0.387,26.2,11.171,33.831c3.7,2.618,9.122,3.544,13.522,4.268c7.374,1.213,14.833,1.947,22.283,2.491\n\t\t\tc16.966,1.24,34.021,1.502,51.025,1.289c16.05-0.201,32.119-0.903,48.01-3.275c11.813-1.764,21.816-6.561,24.652-19.205\n\t\t\tc2.461-10.972,2.463-22.687,2.562-33.873c0.131-14.718-0.323-29.443-0.909-44.148c-0.755-18.954-1.782-37.908-3.147-56.829\n\t\t\tc-0.588-8.152-6.378-15-15-15C366.295,220.921,358.437,227.756,359.025,235.921L359.025,235.921z"
	    }
	  })])])])
	},staticRenderFns: []}

/***/ }),
/* 904 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "connections",
	    attrs: {
	      "id": "game-content-connections"
	    }
	  }, [(_vm.hasData) ? _c('section', {
	    staticClass: "panels"
	  }, [_c('section', {
	    staticClass: "panel"
	  }, [(_vm.profileConnections.followers && _vm.profileConnections.followers.length > 0) ? _c('ul', {
	    staticClass: "follows-list"
	  }, _vm._l((_vm.profileConnections.followers), function(follower) {
	    return _c('li', [_c('avatar', {
	      attrs: {
	        "profile-data": follower,
	        "profile-type": "developer",
	        "size": "small",
	        "show-xp-info": true
	      }
	    }), _vm._v(" "), _c('router-link', {
	      attrs: {
	        "to": ("/Developer/" + (follower.stringUrl))
	      }
	    }, [_vm._v(_vm._s(follower.alias))])], 1)
	  })) : _c('span', [_vm._v("No one is following " + _vm._s(_vm.profileAlias) + " yet.")])])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 905 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('div', {
	    staticClass: "post-selector"
	  }, _vm._l((_vm.posts.length), function(n) {
	    return _c('div', {
	      class: ['item', {
	        'selected': n - 1 === _vm.selectedPost
	      }],
	      on: {
	        "click": function($event) {
	          _vm.selectPost(n)
	        }
	      }
	    }, [(_vm.posts[n - 1].mediaData.mediaType === 'Image') ? _c('div', {
	      staticClass: "icon-button",
	      style: (("background-image:url('https://www.develteam.com/userdata/mediaThumbs/" + (_vm.posts[n-1].mediaData.mediaUrl) + "');"))
	    }) : _vm._e(), _vm._v(" "), (_vm.posts[n - 1].mediaData.mediaType === 'Video') ? _c('div', {
	      staticClass: "icon-button"
	    }, [_c('i', {
	      staticClass: "fas fa-video-camera"
	    })]) : _vm._e(), _vm._v(" "), (_vm.posts[n - 1].mediaData.mediaType === 'Youtube') ? _c('div', {
	      staticClass: "icon-button",
	      style: (_vm.generateYoutubeBackgroundImageStyle(_vm.posts[n - 1].mediaData.mediaUrl))
	    }, [_c('i', {
	      staticClass: "fab fa-youtube"
	    })]) : _vm._e(), _vm._v(" "), (_vm.posts[n - 1].mediaData.mediaType === 'External' && !_vm.posts[n - 1].mediaData.previewImageUrl) ? _c('div', {
	      staticClass: "icon-button"
	    }, [_c('i', {
	      staticClass: "fas fa-link xo"
	    })]) : _vm._e(), _vm._v(" "), (_vm.posts[n - 1].mediaData.mediaType === 'Archive' && !_vm.posts[n - 1].mediaData.previewImageUrl) ? _c('div', {
	      staticClass: "icon-button"
	    }, [_c('i', {
	      staticClass: "fas fa-archive xo"
	    })]) : _vm._e(), _vm._v(" "), (_vm.posts[n - 1].mediaData.mediaType === 'Audio' && !_vm.posts[n - 1].mediaData.previewImageUrl) ? _c('div', {
	      staticClass: "icon-button"
	    }, [_c('i', {
	      staticClass: "fas fa-volume-up xo"
	    })]) : _vm._e(), _vm._v(" "), (_vm.posts[n - 1].mediaData.mediaType === 'Flash' && !_vm.posts[n - 1].mediaData.previewImageUrl) ? _c('div', {
	      staticClass: "icon-button"
	    }, [_c('i', {
	      staticClass: "fas fa-rocket xo"
	    })]) : _vm._e(), _vm._v(" "), (_vm.posts[n - 1].mediaData.mediaType === 'Text' && !_vm.posts[n - 1].mediaData.previewImageUrl) ? _c('div', {
	      staticClass: "icon-button"
	    }, [_c('i', {
	      staticClass: "fas fa-book xo"
	    })]) : _vm._e(), _vm._v(" "), (_vm.posts[n - 1].mediaData.mediaType === 'External' && _vm.posts[n - 1].mediaData.previewImageUrl) ? _c('div', {
	      staticClass: "icon-button",
	      style: (("background-image:url('https://www.develteam.com/userdata/mediaThumbs/" + (_vm.posts[n-1].mediaData.previewImageUrl) + "');"))
	    }, [_c('i', {
	      staticClass: "fas fa-link"
	    })]) : _vm._e(), _vm._v(" "), (_vm.posts[n - 1].mediaData.mediaType === 'Archive' && _vm.posts[n - 1].mediaData.previewImageUrl) ? _c('div', {
	      staticClass: "icon-button",
	      style: (("background-image:url('https://www.develteam.com/userdata/mediaThumbs/" + (_vm.posts[n-1].mediaData.previewImageUrl) + "');"))
	    }, [_c('i', {
	      staticClass: "fas fa-archive"
	    })]) : _vm._e(), _vm._v(" "), (_vm.posts[n - 1].mediaData.mediaType === 'Audio' && _vm.posts[n - 1].mediaData.previewImageUrl) ? _c('div', {
	      staticClass: "icon-button",
	      style: (("background-image:url('https://www.develteam.com/userdata/mediaThumbs/" + (_vm.posts[n-1].mediaData.previewImageUrl) + "');"))
	    }, [_c('i', {
	      staticClass: "fas fa-volume-up xy"
	    })]) : _vm._e(), _vm._v(" "), (_vm.posts[n - 1].mediaData.mediaType === 'Flash' && _vm.posts[n - 1].mediaData.previewImageUrl) ? _c('div', {
	      staticClass: "icon-button",
	      style: (("background-image:url('https://www.develteam.com/userdata/mediaThumbs/" + (_vm.posts[n-1].mediaData.previewImageUrl) + "');"))
	    }, [_c('i', {
	      staticClass: "fas fa-rocket"
	    })]) : _vm._e(), _vm._v(" "), (_vm.posts[n - 1].mediaData.mediaType === 'Text' && _vm.posts[n - 1].mediaData.previewImageUrl) ? _c('div', {
	      staticClass: "icon-button",
	      style: (("background-image:url('https://www.develteam.com/userdata/mediaThumbs/" + (_vm.posts[n-1].mediaData.previewImageUrl) + "');"))
	    }, [_c('i', {
	      staticClass: "fas fa-book"
	    })]) : _vm._e()])
	  })), _vm._v(" "), _c('feed-status-post', {
	    key: _vm.posts[_vm.selectedPost].id,
	    attrs: {
	      "data": _vm.posts[_vm.selectedPost]
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),
/* 906 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: ['markdown-editor', _vm.classes]
	  }, [_c('div', {
	    staticClass: "options"
	  }, [_c('i', {
	    class: ['fa fa-eye', {
	      selected: _vm.previewVisible
	    }],
	    on: {
	      "click": function($event) {
	        _vm.togglePreview()
	      }
	    }
	  }), _vm._v(" "), _c('i', {
	    class: ['fa fa-question-circle', {
	      selected: _vm.formattingHelpVisible
	    }],
	    on: {
	      "click": function($event) {
	        _vm.toggleHelp()
	      }
	    }
	  })]), _vm._v(" "), _c('textarea', {
	    attrs: {
	      "title": "content",
	      "placeholder": _vm.placeholder,
	      "disabled": _vm.disabled
	    },
	    domProps: {
	      "value": _vm.value
	    },
	    on: {
	      "input": _vm.updateContent
	    }
	  }), _vm._v(" "), (_vm.formattingHelpVisible) ? _c('div', {
	    staticClass: "formatting-help"
	  }, [_c('h1', [_vm._v("Formatting Help")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15)]) : _vm._e(), _vm._v(" "), (_vm.previewVisible) ? _c('div', {
	    staticClass: "preview"
	  }, [_c('h1', [_vm._v("Preview")]), _vm._v(" "), _c('markdown-content', {
	    attrs: {
	      "classes": "preview-content",
	      "content": _vm.value
	    }
	  })], 1) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "rule"
	  }, [_c('span', {
	    staticClass: "description"
	  }, [_vm._v("Description")]), _vm._v(" "), _c('span', {
	    staticClass: "syntax"
	  }, [_vm._v("Syntax")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "rule"
	  }, [_c('span', {
	    staticClass: "description"
	  }, [_vm._v("Headlines")]), _vm._v(" "), _c('span', {
	    staticClass: "syntax"
	  }, [_vm._v("# Largest Headline"), _c('br'), _vm._v("## Next Largest Headline"), _c('br'), _vm._v("###### Smallest Headline")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "rule"
	  }, [_c('span', {
	    staticClass: "description"
	  }, [_vm._v("Italics")]), _vm._v(" "), _c('span', {
	    staticClass: "syntax"
	  }, [_vm._v("*text*, _text_")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "rule"
	  }, [_c('span', {
	    staticClass: "description"
	  }, [_vm._v("Bold")]), _vm._v(" "), _c('span', {
	    staticClass: "syntax"
	  }, [_vm._v("**text**, __text__")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "rule"
	  }, [_c('span', {
	    staticClass: "description"
	  }, [_vm._v("Link")]), _vm._v(" "), _c('span', {
	    staticClass: "syntax"
	  }, [_vm._v("[Link Text](http://google.com)")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "rule"
	  }, [_c('span', {
	    staticClass: "description"
	  }, [_vm._v("Image")]), _vm._v(" "), _c('span', {
	    staticClass: "syntax"
	  }, [_vm._v("![Alt Text](http://image.jpg)")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "rule"
	  }, [_c('span', {
	    staticClass: "description"
	  }, [_vm._v("Linked Image")]), _vm._v(" "), _c('span', {
	    staticClass: "syntax"
	  }, [_vm._v("[Above Syntax for Image](http://google.com)")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "rule"
	  }, [_c('span', {
	    staticClass: "description"
	  }, [_vm._v("Youtube Clip")]), _vm._v(" "), _c('span', {
	    staticClass: "syntax"
	  }, [_vm._v("[youtube:VIDEO_ID]")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "rule"
	  }, [_c('span', {
	    staticClass: "description"
	  }, [_vm._v("Font Awesome Icon")]), _vm._v(" "), _c('span', {
	    staticClass: "syntax"
	  }, [_vm._v("[icon:icon-name]")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "rule"
	  }, [_c('span', {
	    staticClass: "description"
	  }, [_vm._v("Bullet List")]), _vm._v(" "), _c('span', {
	    staticClass: "syntax"
	  }, [_vm._v("* Item 1"), _c('br'), _vm._v("* Item 2")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "rule"
	  }, [_c('span', {
	    staticClass: "description"
	  }, [_vm._v("Numbered List")]), _vm._v(" "), _c('span', {
	    staticClass: "syntax"
	  }, [_vm._v("1. Item 1"), _c('br'), _vm._v("2. Item 2")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "rule"
	  }, [_c('span', {
	    staticClass: "description"
	  }, [_vm._v("Quote")]), _vm._v(" "), _c('span', {
	    staticClass: "syntax"
	  }, [_vm._v("> Some text")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "rule"
	  }, [_c('span', {
	    staticClass: "description"
	  }, [_vm._v("Code Line")]), _vm._v(" "), _c('span', {
	    staticClass: "syntax"
	  }, [_vm._v("`let x = 7;`")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "rule"
	  }, [_c('span', {
	    staticClass: "description"
	  }, [_vm._v("Code Block")]), _vm._v(" "), _c('span', {
	    staticClass: "syntax"
	  }, [_vm._v("``` js|csharp|html"), _c('br'), _vm._v("let x = function({"), _c('br'), _vm._v("     return 10;"), _c('br'), _vm._v("});"), _c('br'), _vm._v("```")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "rule"
	  }, [_c('span', {
	    staticClass: "description"
	  }, [_vm._v("Horizontal Line")]), _vm._v(" "), _c('span', {
	    staticClass: "syntax"
	  }, [_vm._v("---, ___, or *** on its own line")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', {
	    staticClass: "rule"
	  }, [_c('span', {
	    staticClass: "description"
	  }, [_vm._v("View more at: ")]), _vm._v(" "), _c('span', {
	    staticClass: "syntax"
	  }, [_c('a', {
	    attrs: {
	      "href": "http://assemble.io/docs/Cheatsheet-Markdown.html",
	      "target": "_blank"
	    }
	  }, [_vm._v("http://assemble.io/docs/Cheatsheet-Markdown.html")])])])
	}]}

/***/ }),
/* 907 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "loading large"
	  }, [_c('i', {
	    staticClass: "fas fa-sync fa-spin"
	  }), _vm._v(" "), _c('p', [_vm._v("Saving")])])
	}]}

/***/ }),
/* 908 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [(_vm.fetchingStatus === 'fetching') ? _c('loader-large') : _vm._e(), _vm._v(" "), (_vm.postData && _vm.fetchingStatus === 'fetched') ? _c('feed-status-post', {
	    key: _vm.postData.id,
	    attrs: {
	      "data": _vm.postData
	    }
	  }) : _vm._e(), _vm._v(" "), (!_vm.postData && _vm.fetchingStatus === 'fetched') ? _c('div', {
	    staticClass: "validation-messages error"
	  }, [_vm._v("This post doesn't exist")]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 909 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "home-feed"
	    }
	  }, [(_vm.gotInitialLoggedUserInfo) ? _c('article', {
	    attrs: {
	      "id": "feed-posts-page"
	    }
	  }, [_c('div', {
	    attrs: {
	      "id": "feed-post-collection"
	    }
	  }, [_c('div', {
	    staticClass: "single-column-container"
	  }, [(_vm.fetchingStatus === 'fetched' && _vm.isLoggedIn) ? _c('new-post-form') : _vm._e(), _vm._v(" "), (Object.keys(_vm.feedPosts || {}).length > 0) ? [_vm._l((_vm.feedPosts), function(feedPost) {
	    return [_c('feed-status-post', {
	      key: feedPost.id,
	      attrs: {
	        "data": feedPost.post
	      }
	    })]
	  })] : _vm._e()], 2), _vm._v(" "), _c('div', {
	    staticClass: "load-more-button-container"
	  }, [(_vm.fetchingStatus === 'fetched' && Object.keys(_vm.feedPosts || {}).length > 0 && !_vm.hasFetchedAll) ? _c('button', {
	    attrs: {
	      "id": "feed-fetch-more"
	    },
	    on: {
	      "click": _vm.getPosts
	    }
	  }, [_vm._v("Load more posts")]) : _vm._e(), _vm._v(" "), (_vm.fetchingStatus === 'fetching') ? _c('loader-large') : _vm._e()], 1)])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 910 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('article', {
	    attrs: {
	      "id": "media-page"
	    }
	  }, [(!_vm.$route.params.piece) ? _c('section', {
	    attrs: {
	      "id": "media-albums"
	    }
	  }, [_c('transition', {
	    attrs: {
	      "name": "fade",
	      "mode": "out-in"
	    }
	  }, [(_vm.fetchingAlbumStatus === 'fetching') ? _c('div', {
	    staticClass: "loader-container"
	  }, [_c('loader-large')], 1) : _vm._e(), _vm._v(" "), (_vm.fetchingAlbumStatus !== 'fetching' && !_vm.reorderAlbumMode && !_vm.addAlbumMode) ? _c('ul', {
	    staticClass: "album-list"
	  }, [_vm._l((_vm.albums), function(album) {
	    return _c('router-link', {
	      class: {
	        selected: album.stringUrl === _vm.$route.params.album
	      },
	      attrs: {
	        "tag": "li",
	        "to": ("/Game/" + (_vm.$route.params.game) + "/Media/" + (album.stringUrl))
	      }
	    }, [(album.hasAvatar) ? _c('img', {
	      staticClass: "media-avatar",
	      attrs: {
	        "src": ("https://www.develteam.com/userdata/avatars/media_" + (album.id) + ".jpg"),
	        "alt": album.title + ' album',
	        "title": album.title + ' album'
	      }
	    }) : _c('img', {
	      staticClass: "media-avatar",
	      attrs: {
	        "src": "https://www.develteam.com/userdata/avatar_blank_100.jpg",
	        "alt": album.title + ' album',
	        "title": album.title + ' album'
	      }
	    }), _vm._v(" "), _c('span', {
	      staticClass: "title"
	    }, [_vm._v(_vm._s(album.title))])])
	  }), _vm._v(" "), (Object.keys(_vm.albums).length === 0 && !_vm.canEdit) ? _c('div', {
	    staticClass: "no-albums"
	  }, [_vm._v("\n                    This Game Project has not Uploaded any Media\n                ")]) : _vm._e(), _vm._v(" "), (_vm.canEdit) ? _c('li', {
	    class: [{
	      selected: _vm.addAlbumMode
	    }, 'add-album-container'],
	    on: {
	      "click": _vm.enterAddAlbumMode
	    }
	  }, [_c('div', {
	    staticClass: "media-avatar add-album"
	  }, [_c('i', {
	    staticClass: "fas fa-plus"
	  })]), _vm._v(" "), _c('span', {
	    staticClass: "title"
	  }, [_vm._v("Add Album")])]) : _vm._e(), _vm._v(" "), (_vm.canEdit) ? _c('li', {
	    class: [{
	      selected: _vm.reorderAlbumMode
	    }, 'reorder-album-container'],
	    on: {
	      "click": _vm.enterReorderAlbumMode
	    }
	  }, [_c('div', {
	    staticClass: "media-avatar reorder-album"
	  }, [_c('i', {
	    staticClass: "fas fa-pencil-alt"
	  })]), _vm._v(" "), _c('span', {
	    staticClass: "title"
	  }, [_vm._v("Reorder Albums")])]) : _vm._e()], 2) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.addAlbumMode) ? _c('new-album-form', {
	    attrs: {
	      "page-type": "game",
	      "page-id": _vm.gameId
	    },
	    on: {
	      "doneEditing": function($event) {
	        _vm.addAlbumMode = false
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.reorderAlbumMode) ? _c('reorder-album-form', {
	    attrs: {
	      "page-type": "game",
	      "page-id": _vm.gameId
	    },
	    on: {
	      "doneEditing": function($event) {
	        _vm.reorderAlbumMode = false
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.$route.params.album) ? _c('media-piece-list', {
	    attrs: {
	      "page-type": "game",
	      "page-id": _vm.gameId,
	      "medias-id": _vm.mediasId,
	      "can-edit": _vm.canEdit
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.$route.params.piece) ? _c('button', {
	    staticClass: "button",
	    on: {
	      "click": _vm.exitSinglePieceView
	    }
	  }, [_vm._v("View Entire Portfolio")]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 911 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "voting-widget"
	  }, [_c('a', {
	    class: [{
	      'logged-voted': _vm.loggedVote === 1
	    }, 'upvote', 'vote-button', {
	      disabled: !_vm.isLoggedIn
	    }],
	    on: {
	      "click": function($event) {
	        _vm.vote('up')
	      }
	    }
	  }, [_c('i', {
	    class: ['fa', 'fa-arrow-up']
	  })]), _vm._v(" "), _c('a', {
	    class: [{
	      'logged-voted': _vm.loggedVote === -1
	    }, 'downvote', 'vote-button', {
	      disabled: !_vm.isLoggedIn
	    }],
	    on: {
	      "click": function($event) {
	        _vm.vote('down')
	      }
	    }
	  }, [_c('i', {
	    class: ['fa', 'fa-arrow-down']
	  })]), _vm._v(" "), _c('span', {
	    staticClass: "points",
	    on: {
	      "mouseenter": function($event) {
	        _vm.showTooltip = true
	      },
	      "click": function($event) {
	        _vm.showTooltip = true
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.points) + " points")]), _vm._v(" "), (_vm.showTooltip) ? _c('div', {
	    staticClass: "tooltip",
	    on: {
	      "mouseleave": function($event) {
	        _vm.showTooltip = false
	      }
	    }
	  }, [_c('div', {
	    staticClass: "content"
	  }, [(_vm.upVoters.length === 0) ? [_vm._v("\n                No Upvotes Yet\n            ")] : _vm._e(), _vm._v(" "), (_vm.upVoters.length > 0) ? [_vm._v("\n                Upvoted by:\n                "), _vm._l((_vm.upVoters), function(upVoter) {
	    return _c('span', [_c('router-link', {
	      attrs: {
	        "to": ("/Developer/" + (upVoter.stringUrl))
	      }
	    }, [_vm._v(_vm._s(upVoter.alias))])], 1)
	  })] : _vm._e()], 2)]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 912 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('article', {
	    attrs: {
	      "id": "media-page"
	    }
	  }, [(!_vm.$route.params.piece) ? _c('section', {
	    attrs: {
	      "id": "media-albums"
	    }
	  }, [_c('transition', {
	    attrs: {
	      "name": "fade",
	      "mode": "out-in"
	    }
	  }, [(_vm.fetchingAlbumStatus === 'fetching') ? _c('div', {
	    staticClass: "loader-container"
	  }, [_c('loader-large')], 1) : _vm._e(), _vm._v(" "), (_vm.fetchingAlbumStatus !== 'fetching' && !_vm.reorderAlbumMode && !_vm.addAlbumMode) ? _c('ul', {
	    staticClass: "album-list"
	  }, [_vm._l((_vm.albums), function(album) {
	    return _c('router-link', {
	      class: {
	        selected: album.stringUrl === _vm.$route.params.album
	      },
	      attrs: {
	        "tag": "li",
	        "to": ("/Developer/" + (_vm.$route.params.developer) + "/Portfolio/" + (album.stringUrl))
	      }
	    }, [(album.hasAvatar) ? _c('img', {
	      staticClass: "media-avatar",
	      attrs: {
	        "src": ("https://www.develteam.com/userdata/avatars/media_" + (album.id) + ".jpg"),
	        "alt": album.title + ' album',
	        "title": album.title + ' album'
	      }
	    }) : _c('img', {
	      staticClass: "media-avatar",
	      attrs: {
	        "src": "https://www.develteam.com/userdata/avatar_blank_100.jpg",
	        "alt": album.title + ' album',
	        "title": album.title + ' album'
	      }
	    }), _vm._v(" "), _c('span', {
	      staticClass: "title"
	    }, [_vm._v(_vm._s(album.title))])])
	  }), _vm._v(" "), (Object.keys(_vm.albums).length === 0 && !_vm.canEdit) ? _c('div', {
	    staticClass: "no-albums"
	  }, [_vm._v("This Developer has not Uploaded any Portfolio Pieces")]) : _vm._e(), _vm._v(" "), (_vm.canEdit) ? _c('li', {
	    class: [{
	      selected: _vm.addAlbumMode
	    }, 'add-album-container'],
	    on: {
	      "click": _vm.enterAddAlbumMode
	    }
	  }, [_c('div', {
	    staticClass: "media-avatar add-album"
	  }, [_c('i', {
	    staticClass: "fas fa-plus"
	  })]), _vm._v(" "), _c('span', {
	    staticClass: "title"
	  }, [_vm._v("Add Album")])]) : _vm._e(), _vm._v(" "), (_vm.canEdit) ? _c('li', {
	    class: [{
	      selected: _vm.reorderAlbumMode
	    }, 'reorder-album-container'],
	    on: {
	      "click": _vm.enterReorderAlbumMode
	    }
	  }, [_c('div', {
	    staticClass: "media-avatar reorder-album"
	  }, [_c('i', {
	    staticClass: "fas fa-pencil-alt"
	  })]), _vm._v(" "), _c('span', {
	    staticClass: "title"
	  }, [_vm._v("Reorder Albums")])]) : _vm._e()], 2) : _vm._e()])], 1) : _vm._e(), _vm._v(" "), (_vm.addAlbumMode) ? _c('new-album-form', {
	    attrs: {
	      "page-type": "developer",
	      "page-id": _vm.developerId
	    },
	    on: {
	      "doneEditing": function($event) {
	        _vm.addAlbumMode = false
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.reorderAlbumMode) ? _c('reorder-album-form', {
	    attrs: {
	      "page-type": "developer",
	      "page-id": _vm.developerId
	    },
	    on: {
	      "doneEditing": function($event) {
	        _vm.reorderAlbumMode = false
	      }
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.$route.params.album) ? _c('media-piece-list', {
	    attrs: {
	      "page-type": "developer",
	      "page-id": _vm.developerId,
	      "medias-id": _vm.mediasId,
	      "can-edit": _vm.canEdit
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.$route.params.piece) ? _c('button', {
	    staticClass: "button",
	    on: {
	      "click": _vm.exitSinglePieceView
	    }
	  }, [_vm._v("View Entire Portfolio")]) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 913 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('nav', {
	    attrs: {
	      "id": "main-nav"
	    }
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    attrs: {
	      "id": "site-details"
	    }
	  }, [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('h1', {
	    attrs: {
	      "id": "logo"
	    }
	  }, [_vm._v("Develteam")])])], 1), _vm._v(" "), _c('search-widget'), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "logged-in-user-details"
	    }
	  }, [(!_vm.isLoggedIn && _vm.showUserPanel) ? _c('div', {
	    staticClass: "unlogged"
	  }, [_c('router-link', {
	    staticClass: "log-in",
	    attrs: {
	      "to": "/Login"
	    }
	  }, [_vm._v("Log In")]), _vm._v(" "), _c('router-link', {
	    staticClass: "sign-up",
	    attrs: {
	      "to": "/Register"
	    }
	  }, [_vm._v("Sign Up")])], 1) : _vm._e(), _vm._v(" "), (_vm.isLoggedIn && _vm.showUserPanel) ? _c('div', {
	    staticClass: "logged"
	  }, [_c('div', {
	    staticClass: "log-out",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.logOut($event)
	      }
	    }
	  }, [_vm._v("Log out")]), _vm._v(" "), _c('div', {
	    staticClass: "avatar-container"
	  }, [_c('avatar', {
	    attrs: {
	      "profile-data": _vm.loggedUserDetails.info,
	      "profile-type": "developer",
	      "size": "very-small",
	      "show-xp-info": true
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    on: {
	      "click": function($event) {
	        _vm.showNotificationsList = !_vm.showNotificationsList
	      }
	    }
	  }, [_c('i', {
	    staticClass: "far fa-bell"
	  }), _vm._v(" "), (_vm.unreadNotifications > 0) ? _c('div', {
	    staticClass: "notification-count"
	  }, [_vm._v(_vm._s(_vm.unreadNotifications))]) : _vm._e()]), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "to": "/Invites",
	      "tag": "div"
	    }
	  }, [_c('i', {
	    staticClass: "far fa-user"
	  }), _vm._v(" "), (_vm.unreadInvitesNotificationCount > 0) ? _c('div', {
	    staticClass: "notification-count"
	  }, [_vm._v(_vm._s(_vm.unreadInvitesNotificationCount))]) : _vm._e()]), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "to": "/Inbox",
	      "tag": "div"
	    }
	  }, [_c('i', {
	    staticClass: "far fa-envelope"
	  }), _vm._v(" "), (_vm.unreadInboxCount > 0) ? _c('div', {
	    staticClass: "notification-count"
	  }, [_vm._v(_vm._s(_vm.unreadInboxCount))]) : _vm._e()]), _vm._v(" "), (_vm.showNotificationsList) ? _c('div', {
	    attrs: {
	      "id": "notifications-list"
	    },
	    on: {
	      "mouseleave": function($event) {
	        _vm.showNotificationsList = false
	      }
	    }
	  }, [(_vm.notificationsFetchingStatus !== 'fetched' && _vm.notifications && _vm.notifications.length == 0) ? _c('loader-small') : _vm._e(), _vm._v(" "), (_vm.notificationsFetchingStatus === 'fetched') ? [(_vm.notifications.length > 0) ? _c('div', {
	    staticClass: "notifications"
	  }, _vm._l((_vm.notifications), function(notification) {
	    return (notification.text && notification.link) ? _c('router-link', {
	      class: {
	        new: notification.hasBeenRead === 0
	      },
	      attrs: {
	        "to": notification.link
	      }
	    }, [_c('span', {
	      staticClass: "text"
	    }, [(!notification.hasBeenRead) ? _c('i', {
	      staticClass: "fas fa-bell"
	    }) : _vm._e(), _vm._v(" " + _vm._s(notification.text))]), _vm._v(" "), _c('span', {
	      staticClass: "time-stamp"
	    }, [_vm._v(_vm._s(_vm._f("formatDate")(notification.created)))])]) : _vm._e()
	  })) : _vm._e(), _vm._v(" "), (_vm.notifications.length === 0) ? _c('div', {
	    staticClass: "notifications"
	  }, [_c('span', {
	    staticClass: "no-notifications-message"
	  }, [_vm._v("You don't have any notifications")])]) : _vm._e(), _vm._v(" "), _c('router-link', {
	    attrs: {
	      "to": "/Notifications"
	    }
	  }, [_c('span', [_vm._v("View all...")])])] : _vm._e()], 2) : _vm._e()], 1) : _vm._e()])], 1)])
	},staticRenderFns: []}

/***/ }),
/* 914 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return (_vm.maxPage) ? _c('ul', [_c('li', {
	    on: {
	      "click": function($event) {
	        _vm.switchToPage(1)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "fas fa-angle-double-left"
	  })]), _vm._v(" "), _c('li', {
	    on: {
	      "click": function($event) {
	        _vm.switchToPage(_vm.currentPage - 1)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "fas fa-angle-left"
	  })]), _vm._v(" "), (_vm.showLeftEllipses) ? _c('li', [_vm._v("...")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.maxPage), function(pageNumber) {
	    return (pageNumber >= _vm.minPageToShow && pageNumber <= _vm.maxPageToShow) ? _c('li', {
	      class: {
	        selected: pageNumber === _vm.currentPage
	      },
	      on: {
	        "click": function($event) {
	          _vm.switchToPage(pageNumber)
	        }
	      }
	    }, [_vm._v(_vm._s(pageNumber))]) : _vm._e()
	  }), _vm._v(" "), (_vm.showRightEllipses) ? _c('li', [_vm._v("...")]) : _vm._e(), _vm._v(" "), _c('li', {
	    on: {
	      "click": function($event) {
	        _vm.switchToPage(_vm.currentPage + 1)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "fas fa-angle-right"
	  })]), _vm._v(" "), _c('li', {
	    on: {
	      "click": function($event) {
	        _vm.switchToPage(_vm.maxPage)
	      }
	    }
	  }, [_c('span', {
	    staticClass: "fas fa-angle-double-right"
	  })])], 2) : _vm._e()
	},staticRenderFns: []}

/***/ }),
/* 915 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('article', {
	    attrs: {
	      "id": "classifieds"
	    }
	  }, [_c('div', {
	    staticClass: "button-container"
	  }, [(_vm.isLoggedIn) ? _c('router-link', {
	    staticClass: "button",
	    attrs: {
	      "to": "/Classifieds/New"
	    }
	  }, [_vm._v("Submit a Classifieds Post")]) : _vm._e()], 1), _vm._v(" "), _c('section', {
	    class: {
	      'filter-controls': true, 'disabled': _vm.isFetching
	    }
	  }, [_c('div', {
	    staticClass: "filter-control"
	  }, [_c('div', {
	    staticClass: "filter-group"
	  }, [_c('label', [_vm._v("Type")]), _vm._v(" "), _c('ul', _vm._l((_vm.postTypes), function(role, index) {
	    return _c('li', {
	      class: [{
	        selected: index === _vm.selectedPostTypeId
	      }],
	      on: {
	        "click": function($event) {
	          _vm.setPostTypeId(index)
	        }
	      }
	    }, [_vm._v("\n                        " + _vm._s(role) + "\n                    ")])
	  }))]), _vm._v(" "), _c('div', {
	    staticClass: "filter-group"
	  }, [_c('label', [_vm._v("Roles")]), _vm._v(" "), _c('ul', _vm._l((_vm.roles), function(role, index) {
	    return _c('li', {
	      class: [{
	        selected: index === _vm.selectedRoleId
	      }],
	      on: {
	        "click": function($event) {
	          _vm.setRoleId(index)
	        }
	      }
	    }, [_vm._v("\n                        " + _vm._s(role) + "\n                    ")])
	  }))]), _vm._v(" "), (_vm.skillFilterId === 0) ? [_c('div', {
	    staticClass: "filter-group"
	  }, [_c('label', [_vm._v("Skill")]), _vm._v(" "), _c('div', {
	    staticClass: "skill-input"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.skillSearchText),
	      expression: "skillSearchText"
	    }],
	    attrs: {
	      "type": "text",
	      "disabled": _vm.isFetching
	    },
	    domProps: {
	      "value": (_vm.skillSearchText)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.skillSearchText = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (_vm.skillSearchText.length > 0) ? _c('button', {
	    staticClass: "button"
	  }, [_vm._v("X")]) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "filter-group"
	  }, [(_vm.matchingSkills.length === 0) ? _c('span', [_vm._v("\n                    No matching tags... Search by skill name, or type a category\n                    to see all entries. Categories: Art, Software, Development, Engine, Writing, Production, Testing\n                ")]) : _vm._e(), _vm._v(" "), _c('ul', {
	    staticClass: "skills"
	  }, _vm._l((_vm.matchingSkills), function(skill) {
	    return _c('li', {
	      on: {
	        "click": function($event) {
	          _vm.setSkillId(skill.id)
	        }
	      }
	    }, [_vm._v("\n                            " + _vm._s(skill.skill) + "\n                        ")])
	  }))])] : _vm._e(), _vm._v(" "), (_vm.skillFilterId > 0) ? [_c('div', {
	    staticClass: "filter-group"
	  }, [_c('label', [_vm._v("Skill")]), _vm._v(" "), _c('ul', {
	    staticClass: "skills"
	  }, [_c('li', {
	    staticClass: "selected",
	    on: {
	      "click": function($event) {
	        _vm.setSkillId(0)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-minus-circle"
	  }), _vm._v(_vm._s(_vm.getSkill(_vm.skillFilterId)) + "\n                        ")])])])] : _vm._e()], 2)]), _vm._v(" "), (_vm.isFetching) ? _c('section', {
	    staticClass: "loader"
	  }, [_c('loader-large')], 1) : _vm._e(), _vm._v(" "), (!_vm.isFetching && _vm.posts.length === 0) ? _c('section', {
	    staticClass: "no-posts"
	  }, [_c('div', {
	    staticClass: "validation-messages friendly"
	  }, [_vm._v("\n            No matching results!\n            "), (_vm.selectedPostTypeId === 0) ? [_vm._v("Skill tags are still new for Game Projects. Try removing the\n                Skill filter.\n            ")] : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), (!_vm.isFetching && _vm.posts.length > 0) ? _c('section', {
	    staticClass: "classifieds-posts"
	  }, _vm._l((_vm.posts), function(post) {
	    return _c('div', {
	      staticClass: "classifieds-post"
	    }, [_c('header', [_c('div', {
	      staticClass: "avatar-container"
	    }, [_c('avatar', {
	      attrs: {
	        "profile-data": post.posterDetails,
	        "profile-type": post.posterType,
	        "size": "large",
	        "show-xp-info": true
	      }
	    })], 1), _vm._v(" "), _c('div', {
	      staticClass: "text-container"
	    }, [(post.posterType === 'developer') ? _c('h1', {
	      staticClass: "title"
	    }, [_c('i', {
	      staticClass: "fas fa-user fa-fw"
	    }), _vm._v(" "), _c('router-link', {
	      attrs: {
	        "to": ("/Developer/" + (post.posterDetails.stringUrl)),
	        "data-router-link": "true"
	      }
	    }, [_vm._v("\n                            " + _vm._s(post.posterDetails.alias) + "\n                        ")])], 1) : _vm._e(), _vm._v(" "), (post.posterType === 'game') ? _c('h1', {
	      staticClass: "title"
	    }, [_c('i', {
	      staticClass: "fas fa-gamepad fa-fw"
	    }), _vm._v(" "), _c('router-link', {
	      attrs: {
	        "to": ("/Game/" + (post.posterDetails.stringUrl)),
	        "data-router-link": "true"
	      }
	    }, [_vm._v("\n                            " + _vm._s(post.posterDetails.alias) + "\n                        ")])], 1) : _vm._e(), _vm._v(" "), _c('h1', {
	      staticClass: "title"
	    }, [_vm._v(_vm._s(post.title))])]), _vm._v(" "), _c('div', {
	      staticClass: "post-date"
	    }, [_c('span', [_vm._v(_vm._s(_vm._f("formatDateWithoutTimeRelative")(post.postDate)))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("formatDateWithJustTime")(post.postDate)))])])]), _vm._v(" "), _c('div', {
	      staticClass: "sub-header"
	    }, [(post.posterType === 'game') ? _c('span', [_vm._v("Recruiting")]) : _vm._e(), _vm._v(" "), _c('div', {
	      staticClass: "role-list"
	    }, [(post.roleDesigner) ? _c('router-link', {
	      staticClass: "role-tag",
	      attrs: {
	        "to": '/Browse/Developers?seekingRole=designers'
	      }
	    }, [(post.posterType === 'game') ? [_vm._v("Designers")] : [_vm._v("Designer")]], 2) : _vm._e(), _vm._v(" "), (post.roleArtist) ? _c('router-link', {
	      staticClass: "role-tag",
	      attrs: {
	        "to": '/Browse/Developers?seekingRole=artists'
	      }
	    }, [(post.posterType === 'game') ? [_vm._v("Artists")] : [_vm._v("Artist")]], 2) : _vm._e(), _vm._v(" "), (post.roleProgrammer) ? _c('router-link', {
	      staticClass: "role-tag",
	      attrs: {
	        "to": '/Browse/Developers?seekingRole=programmers'
	      }
	    }, [(post.posterType === 'game') ? [_vm._v("Programmers")] : [_vm._v("Programmer")]], 2) : _vm._e(), _vm._v(" "), (post.roleWriter) ? _c('router-link', {
	      staticClass: "role-tag",
	      attrs: {
	        "to": '/Browse/Developers?seekingRole=writers'
	      }
	    }, [(post.posterType === 'game') ? [_vm._v("Writers")] : [_vm._v("Writer")]], 2) : _vm._e(), _vm._v(" "), (post.roleMusician) ? _c('router-link', {
	      staticClass: "role-tag",
	      attrs: {
	        "to": '/Browse/Developers?seekingRole=musicians'
	      }
	    }, [(post.posterType === 'game') ? [_vm._v("Musicians")] : [_vm._v("Musician")]], 2) : _vm._e(), _vm._v(" "), (post.roleSfxArtist) ? _c('router-link', {
	      staticClass: "role-tag",
	      attrs: {
	        "to": '/Browse/Developers?seekingRole=sfx'
	      }
	    }, [(post.posterType === 'game') ? [_vm._v("Sfx Artists")] : [_vm._v("Sfx Artist")]], 2) : _vm._e(), _vm._v(" "), (post.roleTester) ? _c('router-link', {
	      staticClass: "role-tag",
	      attrs: {
	        "to": '/Browse/Developers?seekingRole=testers'
	      }
	    }, [(post.posterType === 'game') ? [_vm._v("Testers")] : [_vm._v("Tester")]], 2) : _vm._e(), _vm._v(" "), (post.roleProducer) ? _c('router-link', {
	      staticClass: "role-tag",
	      attrs: {
	        "to": '/Browse/Developers?seekingRole=producers'
	      }
	    }, [(post.posterType === 'game') ? [_vm._v("Producers")] : [_vm._v("Producer")]], 2) : _vm._e()], 1), _vm._v(" "), _c('div', {
	      staticClass: "skill-list"
	    }, _vm._l((post.skills), function(skillId) {
	      return _c('router-link', {
	        staticClass: "skill-tag",
	        attrs: {
	          "to": '/Browse/Developers?seekingSkill=' + skillId
	        }
	      }, [_vm._v("\n                        " + _vm._s(_vm.getSkill(skillId)) + "\n                    ")])
	    }))]), _vm._v(" "), (!_vm.editMode) ? _c('markdown-content', {
	      attrs: {
	        "classes": "content",
	        "content": post.pitch
	      }
	    }) : _vm._e(), _vm._v(" "), (!_vm.canEdit(post)) ? _c('div', {
	      staticClass: "contact-container"
	    }, [_c('span', {
	      on: {
	        "click": function($event) {
	          _vm.sendMail(post)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "far fa-envelope"
	    }), _vm._v(" Mail")]), _vm._v(" "), _c('span', {
	      on: {
	        "click": function($event) {
	          _vm.openConversation(post)
	        }
	      }
	    }, [_c('i', {
	      staticClass: "far fa-comment-alt"
	    }), _vm._v(" Chat")])]) : _vm._e(), _vm._v(" "), (_vm.canEdit(post)) ? _c('div', {
	      staticClass: "edit-container"
	    }, [(_vm.isLoggedIn) ? _c('router-link', {
	      staticClass: "button",
	      attrs: {
	        "to": '/Classifieds/Edit/' + post.id
	      }
	    }, [_c('i', {
	      staticClass: "fas fa-pencil-alt"
	    }), _vm._v(" Edit\n                ")]) : _vm._e()], 1) : _vm._e()], 1)
	  })) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 916 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('svg', {
	    staticClass: "dt-icon icon-eye",
	    attrs: {
	      "version": "1.1",
	      "id": "Layer_1",
	      "xmlns": "http://www.w3.org/2000/svg",
	      "xmlns:xlink": "http://www.w3.org/1999/xlink",
	      "x": "0px",
	      "y": "0px",
	      "width": "600px",
	      "height": "400px",
	      "viewBox": "0 0 600 400",
	      "enable-background": "new 0 0 600 400",
	      "xml:space": "preserve"
	    }
	  }, [_c('g', [_c('title', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('rect', {
	    staticStyle: {
	      "fill": "white",
	      "stroke": "1px red solid"
	    },
	    attrs: {
	      "x": "0",
	      "y": "0",
	      "width": "600",
	      "height": "400"
	    }
	  })]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
	    attrs: {
	      "d": "M556.405,203.491c-0.053,2.847,0.819-4.632,0.315-2.103c-0.13,0.649-0.328,1.284-0.535,1.912\n\t\t\tc-1.139,3.457,1.012-2.193,0.494-1.023c-0.437,0.984-0.929,1.942-1.433,2.893c-2.379,4.488-5.317,8.685-8.331,12.763\n\t\t\tc-0.437,0.59-0.88,1.174-1.322,1.758c-1.753,2.312,2.303-2.953,0.479-0.625c-0.988,1.264-1.998,2.511-3.014,3.752\n\t\t\tc-2.397,2.934-4.876,5.801-7.39,8.634c-5.545,6.251-11.353,12.268-17.297,18.138c-6.771,6.688-13.78,13.131-20.942,19.396\n\t\t\tc-3.684,3.223-7.427,6.377-11.203,9.491c-1.938,1.598-3.895,3.175-5.856,4.744c-0.992,0.794-1.991,1.58-2.989,2.367\n\t\t\tc-0.67,0.526-1.342,1.051-2.015,1.574c1.344-1.035,1.338-1.032-0.02,0.011c-17.705,13.584-36.362,25.946-55.855,36.813\n\t\t\tc-9.976,5.561-20.213,10.646-30.66,15.258c-0.281,0.125-4.441,1.911-1.442,0.646c-1.259,0.53-2.523,1.046-3.788,1.561\n\t\t\tc-2.524,1.027-5.069,2.006-7.62,2.966c-5.496,2.069-11.066,3.938-16.68,5.663c-10.645,3.271-21.516,5.792-32.512,7.552\n\t\t\tc-1.305,0.209-2.613,0.394-3.921,0.578c3.599-0.508-0.761,0.061-1.244,0.116c-2.609,0.3-5.228,0.522-7.848,0.717\n\t\t\tc-5.717,0.426-11.451,0.526-17.182,0.427c-5.512-0.096-11.017-0.473-16.502-1.003c-1.378-0.133-2.753-0.292-4.127-0.451\n\t\t\tc-0.368-0.042-4.919-0.662-1.514-0.185c-3.217-0.451-6.419-0.998-9.615-1.58c-11.527-2.1-22.878-5.11-34.033-8.68\n\t\t\tc-5.404-1.729-10.746-3.647-16.047-5.666c-2.657-1.012-5.294-2.075-7.925-3.154c-4.334-1.777,2.647,1.148-1.658-0.701\n\t\t\tc-1.743-0.748-3.475-1.521-5.205-2.297c-10.772-4.831-21.278-10.246-31.562-16.039c-10.079-5.678-19.891-11.825-29.478-18.297\n\t\t\tc-4.475-3.02-8.88-6.142-13.241-9.323c-2.14-1.561-4.259-3.15-6.371-4.749c-0.301-0.228-3.753-2.893-1.114-0.845\n\t\t\tc-1.364-1.059-2.717-2.131-4.069-3.206c-15.317-12.177-29.849-25.421-43.073-39.854c-2.703-2.949-5.327-5.97-7.892-9.04\n\t\t\tc-1.203-1.441-2.379-2.904-3.545-4.375c-2.046-2.582,2.103,2.759,0.135,0.182c-0.706-0.925-1.397-1.861-2.085-2.8\n\t\t\tc-3.731-5.091-7.178-10.417-10.038-16.049c-0.57-1.122-1.096-2.266-1.602-3.418c2.294,5.226,0.508,1.134,0.06-0.159\n\t\t\tc-0.34-0.98-0.624-1.979-0.879-2.982c-0.119-0.467-0.215-0.939-0.311-1.41c-0.617-3.051,0.443,3.975,0.213,1.764\n\t\t\tc-0.085-0.824-0.09-1.652-0.06-2.479c0.136-3.736-0.726,4.035-0.153,0.92c0.41-2.229,1.146-4.392,1.964-6.499\n\t\t\tc0.916-2.357-1.629,3.756-0.589,1.39c0.251-0.572,0.52-1.137,0.788-1.701c0.568-1.199,1.187-2.373,1.816-3.54\n\t\t\tc1.527-2.832,3.236-5.563,5.008-8.247c1.856-2.811,3.837-5.538,5.868-8.224c1.955-2.587-2.17,2.772-0.135,0.182\n\t\t\tc0.573-0.73,1.156-1.452,1.739-2.174c1.411-1.749,2.86-3.467,4.321-5.175c12.276-14.347,26.117-27.354,40.565-39.483\n\t\t\tc3.922-3.292,7.918-6.497,11.954-9.648c-2.633,2.056,0.813-0.616,1.114-0.845c1.05-0.8,2.107-1.59,3.164-2.381\n\t\t\tc2.494-1.865,5.016-3.693,7.549-5.506c9.306-6.66,18.895-12.92,28.69-18.833c10.063-6.075,20.405-11.683,30.957-16.86\n\t\t\tc5.105-2.505,10.28-4.865,15.496-7.131c4.297-1.866-2.669,1.095,1.658-0.701c1.313-0.545,2.633-1.074,3.954-1.603\n\t\t\tc3.077-1.232,6.18-2.4,9.293-3.539c11.05-4.043,22.346-7.401,33.803-10.079c5.442-1.272,10.933-2.326,16.447-3.232\n\t\t\tc1.372-0.226,2.747-0.427,4.123-0.628c-3.401,0.498,1.145-0.14,1.514-0.185c3.202-0.39,6.415-0.681,9.631-0.93\n\t\t\tc11.129-0.861,22.304-0.708,33.412,0.346c1.311,0.124,2.617,0.274,3.924,0.424c4.372,0.502-3.121-0.465,1.243,0.15\n\t\t\tc2.622,0.369,5.233,0.813,7.84,1.279c5.691,1.018,11.331,2.307,16.93,3.744c10.924,2.803,21.627,6.427,32.122,10.54\n\t\t\tc1.271,0.498,2.534,1.012,3.798,1.527c0.288,0.117,4.448,1.879,1.458,0.602c2.518,1.075,5.015,2.196,7.506,3.333\n\t\t\tc5.405,2.465,10.731,5.101,16.009,7.829c19.989,10.334,39.02,22.497,57.181,35.765c3.147,2.3,6.259,4.649,9.352,7.022\n\t\t\tc-1.34-1.036-1.338-1.032,0.007,0.013c1.004,0.783,2.003,1.574,3.002,2.365c1.648,1.305,3.283,2.626,4.915,3.952\n\t\t\tc6.289,5.108,12.437,10.389,18.47,15.796c10.61,9.51,20.798,19.509,30.404,30.035c3.762,4.123,7.408,8.351,10.925,12.684\n\t\t\tc0.83,1.022,1.646,2.057,2.458,3.094c-3.169-4.049-0.322-0.398,0.365,0.524c1.35,1.812,2.652,3.658,3.918,5.529\n\t\t\tc2.021,2.99,3.909,6.084,5.478,9.336c1.53,3.172-1.129-2.837-0.511-1.283c0.225,0.564,0.418,1.141,0.598,1.722\n\t\t\tc0.157,0.505,0.277,1.021,0.381,1.538C557.147,207.734,556.354,200.736,556.405,203.491c0.15,8.174,6.709,15,15,15\n\t\t\tc8.063,0,15.15-6.822,15-15c-0.186-10.066-6.285-19.391-11.927-27.315c-9.043-12.7-19.477-24.397-30.39-35.505\n\t\t\tc-29.614-30.142-63.632-56.629-99.971-78.161C404.031,38.757,359.303,21,312.471,17.834\n\t\t\tc-48.198-3.258-96.418,11.943-139.208,32.936c-40.147,19.697-77.556,46.378-109.695,77.448\n\t\t\tc-12.549,12.131-24.264,25.274-34.221,39.632c-7.121,10.269-13.224,21.771-14.262,34.405c-0.946,11.511,5.689,23.55,11.622,32.901\n\t\t\tc8.978,14.151,20.295,26.955,32.049,38.844c31.028,31.386,67.847,57.932,106.919,78.354\n\t\t\tc42.609,22.271,90.429,37.999,138.956,37.115c46.75-0.851,92.088-18.27,132.392-40.916\n\t\t\tc37.366-20.996,72.015-47.727,102.565-77.751c11.636-11.437,22.5-23.56,32.358-36.562c5.507-7.262,12.214-16.252,13.812-25.454\n\t\t\tc0.301-1.733,0.616-3.521,0.648-5.296c0.15-8.177-6.938-15-15-15C563.114,188.491,556.556,195.317,556.405,203.491z"
	    }
	  })])]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
	    attrs: {
	      "d": "M395.028,203.491c-0.018,2.788-0.121,5.564-0.313,8.346c-0.096,1.373-0.242,2.741-0.389,4.109\n\t\t\tc-0.482,4.508,0.489-3.034-0.215,1.421c-0.909,5.755-2.387,11.407-4.205,16.937c-0.415,1.262-0.876,2.508-1.337,3.753\n\t\t\tc-0.137,0.369-1.802,4.433-0.474,1.319c-1.033,2.422-2.198,4.785-3.403,7.124c-2.598,5.039-5.674,9.819-9.018,14.392\n\t\t\tc-2.55,3.485,1.855-2.28-0.854,1.078c-0.818,1.013-1.671,1.997-2.524,2.98c-1.705,1.966-3.515,3.84-5.354,5.68\n\t\t\tc-1.841,1.841-3.778,3.581-5.744,5.286c-0.984,0.854-1.998,1.671-3.012,2.488c2.578-2.079-1.706,1.227-2.179,1.563\n\t\t\tc-4.265,3.04-8.795,5.693-13.447,8.09c-1.169,0.603-2.36,1.163-3.551,1.723c-0.361,0.17-4.382,1.875-1.26,0.588\n\t\t\tc-2.866,1.181-5.801,2.186-8.756,3.117c-5.142,1.621-10.425,2.759-15.746,3.6c3.457-0.546-1.026,0.104-1.441,0.148\n\t\t\tc-1.372,0.146-2.749,0.242-4.125,0.337c-3.25,0.226-6.51,0.245-9.765,0.184c-2.77-0.052-5.534-0.26-8.291-0.521\n\t\t\tc-0.411-0.039-4.911-0.652-1.442-0.148c-1.344-0.195-2.68-0.44-4.016-0.686c-5.711-1.049-11.308-2.66-16.774-4.606\n\t\t\tc-1.248-0.445-2.479-0.935-3.709-1.425c3.133,1.247-0.892-0.421-1.26-0.588c-2.392-1.09-4.723-2.309-7.028-3.567\n\t\t\tc-2.297-1.255-4.525-2.633-6.725-4.049c-1.098-0.706-2.17-1.451-3.242-2.196c-0.473-0.329-4.785-3.615-2.179-1.563\n\t\t\tc-4.091-3.221-7.89-6.801-11.481-10.566c-1.797-1.884-3.492-3.862-5.15-5.868c-2.749-3.326,1.736,2.377-0.854-1.078\n\t\t\tc-1.043-1.392-2.028-2.826-3.004-4.267c-2.942-4.34-5.488-8.938-7.775-13.651c-0.575-1.186-1.107-2.393-1.639-3.598\n\t\t\tc1.364,3.093-0.331-0.948-0.474-1.319c-1.114-2.901-2.048-5.867-2.909-8.852c-0.745-2.584-1.345-5.207-1.896-7.839\n\t\t\tc-0.278-1.326-0.506-2.663-0.734-3.999c-0.759-4.446,0.324,3.08-0.215-1.421c-0.716-5.981-0.826-12.023-0.562-18.037\n\t\t\tc0.121-2.754,0.397-5.499,0.725-8.234c-0.416,3.469,0.21-0.987,0.28-1.399c0.228-1.334,0.505-2.659,0.783-3.982\n\t\t\tc1.187-5.667,2.93-11.206,5.004-16.606c1.57-4.09-1.232,2.709,0.531-1.291c0.531-1.205,1.106-2.39,1.681-3.575\n\t\t\tc1.145-2.361,2.417-4.659,3.73-6.931c1.308-2.264,2.737-4.456,4.203-6.62c0.732-1.08,1.502-2.134,2.271-3.187\n\t\t\tc1.031-1.369,1.042-1.391,0.036-0.064c0.541-0.679,1.09-1.352,1.647-2.018c3.317-4.014,6.985-7.727,10.834-11.229\n\t\t\tc0.963-0.876,1.957-1.717,2.95-2.559c0.297-0.252,3.684-2.935,1.038-0.902c2.415-1.856,4.938-3.566,7.499-5.214\n\t\t\tc4.415-2.842,9.079-5.281,13.854-7.456c3.978-1.813-2.78,1.089,1.29-0.532c1.232-0.491,2.482-0.936,3.731-1.381\n\t\t\tc2.936-1.046,5.932-1.91,8.945-2.699c2.611-0.684,5.258-1.221,7.911-1.708c0.407-0.075,4.868-0.74,1.399-0.281\n\t\t\tc1.361-0.18,2.729-0.309,4.095-0.438c6.004-0.567,12.054-0.528,18.066-0.112c1.373,0.095,2.742,0.242,4.11,0.388\n\t\t\tc4.507,0.482-3.035-0.489,1.421,0.215c2.671,0.422,5.315,0.993,7.946,1.613c2.605,0.614,5.175,1.372,7.727,2.176\n\t\t\tc1.269,0.4,2.521,0.846,3.774,1.292c0.547,0.195,5.658,2.255,2.563,0.935c4.433,1.891,8.697,4.154,12.838,6.613\n\t\t\tc2.247,1.334,4.421,2.789,6.566,4.28c1.07,0.745,2.114,1.527,3.157,2.31c-2.666-1.999,0.736,0.651,1.039,0.902\n\t\t\tc3.68,3.042,7.102,6.383,10.353,9.874c1.775,1.906,3.447,3.905,5.082,5.931c-2.091-2.592,0.572,0.797,0.807,1.117\n\t\t\tc0.771,1.054,1.503,2.134,2.235,3.214c2.695,3.978,5.054,8.175,7.202,12.47c0.589,1.178,1.136,2.376,1.682,3.575\n\t\t\tc1.812,3.978-1.089-2.78,0.531,1.291c0.983,2.47,1.829,4.991,2.629,7.526c1.484,4.708,2.557,9.538,3.388,14.401\n\t\t\tc0.76,4.447-0.324-3.079,0.215,1.421c0.164,1.367,0.276,2.739,0.389,4.11C394.941,197.921,395.011,200.707,395.028,203.491\n\t\t\tc0.121,19.34,30.121,19.352,30,0c-0.303-48.206-28.896-93.709-73.284-113.284c-46.074-20.319-99.748-11.204-136.589,23.117\n\t\t\tc-35.618,33.181-48.06,87.169-31.209,132.707c17.247,46.611,60.427,78.124,109.804,81.539\n\t\t\tc33.987,2.352,67.795-10.883,92.533-33.92c24.778-23.075,38.534-56.488,38.746-90.159\n\t\t\tC425.149,184.14,395.149,184.152,395.028,203.491z"
	    }
	  })])]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
	    attrs: {
	      "d": "M343.028,203.488c-0.278,23.34-18.971,42.022-42.31,42.301c-8.175,0.098-15,6.75-15,15c0,8.104,6.823,15.098,15,15\n\t\t\tc39.692-0.473,71.837-32.606,72.31-72.301c0.098-8.178-6.896-15-15-15C349.777,188.488,343.126,195.313,343.028,203.488\n\t\t\tL343.028,203.488z"
	    }
	  })])]), _vm._v(" "), _c('g', [_c('g', [_c('path', {
	    attrs: {
	      "d": "M258.686,197.854c0.354-1.939,0.777-3.845,1.28-5.75c0.26-0.938,0.544-1.867,0.853-2.79\n\t\t\tc0.055-0.172,1.8-4.564,0.597-1.805c0.766-1.756,1.684-3.439,2.621-5.107c0.478-0.825,0.975-1.638,1.493-2.438\n\t\t\tc0.091-0.145,2.81-3.937,0.984-1.59c2.624-3.373,5.733-6.337,9.027-9.042c-1.151,0.902-1.019,0.835,0.397-0.2\n\t\t\tc1.169-0.823,2.397-1.557,3.623-2.289c2.057-1.229,4.231-2.248,6.423-3.208c7.493-3.283,9.149-14.091,5.381-20.523\n\t\t\tc-4.484-7.655-13.033-8.662-20.523-5.381c-21.092,9.24-36.958,29.525-41.085,52.149c-1.466,8.036,2.08,16.143,10.477,18.452\n\t\t\tC247.583,210.353,257.217,205.904,258.686,197.854L258.686,197.854z"
	    }
	  })])])])
	},staticRenderFns: []}

/***/ }),
/* 917 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('article', {
	    attrs: {
	      "id": "invite-to-game"
	    }
	  }, [_c('form', [(_vm.fetchingGame) ? _c('loader-large') : _vm._e(), _vm._v(" "), (_vm.showSuccessMessage) ? [_c('div', {
	    staticClass: "validation-messages friendly"
	  }, [_vm._v("Invitation Successfully Sent")])] : _vm._e(), _vm._v(" "), (!_vm.fetchingGame && !_vm.showSuccessMessage) ? [(_vm.gameFound && _vm.isLoggedIn) ? _c('div', [_c('h2', [_vm._v("\n                    Request to Join\n                    "), _c('router-link', {
	    attrs: {
	      "to": ("/Game/" + (_vm.foundGame.stringUrl))
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-gamepad"
	  }), _vm._v(" " + _vm._s(_vm.foundGame.alias))])], 1), _vm._v(" "), _c('div', {
	    staticClass: "field"
	  }, [_c('label', {
	    attrs: {
	      "for": "position-titles"
	    }
	  }, [_vm._v("Position Title(s)")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formData.positionTitles),
	      expression: "formData.positionTitles"
	    }],
	    attrs: {
	      "id": "position-titles",
	      "type": "text",
	      "disabled": _vm.isSaving
	    },
	    domProps: {
	      "value": (_vm.formData.positionTitles)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.formData.positionTitles = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "field"
	  }, [_c('span', [_vm._v("Position Types")]), _vm._v(" "), _c('div', {
	    staticClass: "checkbox-container"
	  }, [_c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formData.selectedPositions),
	      expression: "formData.selectedPositions"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "value": "Designer",
	      "disabled": _vm.isSaving
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.formData.selectedPositions) ? _vm._i(_vm.formData.selectedPositions, "Designer") > -1 : (_vm.formData.selectedPositions)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.formData.selectedPositions,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = "Designer",
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.formData.selectedPositions = $$a.concat($$v))
	          } else {
	            $$i > -1 && (_vm.formData.selectedPositions = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.formData.selectedPositions = $$c
	        }
	      }
	    }
	  }), _c('span', [_vm._v("Designer")])]), _vm._v(" "), _c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formData.selectedPositions),
	      expression: "formData.selectedPositions"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "value": "Artist",
	      "disabled": _vm.isSaving
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.formData.selectedPositions) ? _vm._i(_vm.formData.selectedPositions, "Artist") > -1 : (_vm.formData.selectedPositions)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.formData.selectedPositions,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = "Artist",
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.formData.selectedPositions = $$a.concat($$v))
	          } else {
	            $$i > -1 && (_vm.formData.selectedPositions = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.formData.selectedPositions = $$c
	        }
	      }
	    }
	  }), _c('span', [_vm._v("Artist")])]), _vm._v(" "), _c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formData.selectedPositions),
	      expression: "formData.selectedPositions"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "value": "Programmer",
	      "disabled": _vm.isSaving
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.formData.selectedPositions) ? _vm._i(_vm.formData.selectedPositions, "Programmer") > -1 : (_vm.formData.selectedPositions)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.formData.selectedPositions,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = "Programmer",
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.formData.selectedPositions = $$a.concat($$v))
	          } else {
	            $$i > -1 && (_vm.formData.selectedPositions = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.formData.selectedPositions = $$c
	        }
	      }
	    }
	  }), _c('span', [_vm._v("Programmer")])]), _vm._v(" "), _c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formData.selectedPositions),
	      expression: "formData.selectedPositions"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "value": "Musician",
	      "disabled": _vm.isSaving
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.formData.selectedPositions) ? _vm._i(_vm.formData.selectedPositions, "Musician") > -1 : (_vm.formData.selectedPositions)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.formData.selectedPositions,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = "Musician",
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.formData.selectedPositions = $$a.concat($$v))
	          } else {
	            $$i > -1 && (_vm.formData.selectedPositions = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.formData.selectedPositions = $$c
	        }
	      }
	    }
	  }), _c('span', [_vm._v("Musician")])]), _vm._v(" "), _c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formData.selectedPositions),
	      expression: "formData.selectedPositions"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "value": "SFX Artist",
	      "disabled": _vm.isSaving
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.formData.selectedPositions) ? _vm._i(_vm.formData.selectedPositions, "SFX Artist") > -1 : (_vm.formData.selectedPositions)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.formData.selectedPositions,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = "SFX Artist",
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.formData.selectedPositions = $$a.concat($$v))
	          } else {
	            $$i > -1 && (_vm.formData.selectedPositions = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.formData.selectedPositions = $$c
	        }
	      }
	    }
	  }), _c('span', [_vm._v("SFX Artist")])]), _vm._v(" "), _c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formData.selectedPositions),
	      expression: "formData.selectedPositions"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "value": "Writer",
	      "disabled": _vm.isSaving
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.formData.selectedPositions) ? _vm._i(_vm.formData.selectedPositions, "Writer") > -1 : (_vm.formData.selectedPositions)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.formData.selectedPositions,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = "Writer",
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.formData.selectedPositions = $$a.concat($$v))
	          } else {
	            $$i > -1 && (_vm.formData.selectedPositions = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.formData.selectedPositions = $$c
	        }
	      }
	    }
	  }), _c('span', [_vm._v("Writer")])]), _vm._v(" "), _c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formData.selectedPositions),
	      expression: "formData.selectedPositions"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "value": "Producer",
	      "disabled": _vm.isSaving
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.formData.selectedPositions) ? _vm._i(_vm.formData.selectedPositions, "Producer") > -1 : (_vm.formData.selectedPositions)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.formData.selectedPositions,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = "Producer",
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.formData.selectedPositions = $$a.concat($$v))
	          } else {
	            $$i > -1 && (_vm.formData.selectedPositions = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.formData.selectedPositions = $$c
	        }
	      }
	    }
	  }), _c('span', [_vm._v("Producer")])]), _vm._v(" "), _c('label', [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.formData.selectedPositions),
	      expression: "formData.selectedPositions"
	    }],
	    attrs: {
	      "type": "checkbox",
	      "value": "Tester",
	      "disabled": _vm.isSaving
	    },
	    domProps: {
	      "checked": Array.isArray(_vm.formData.selectedPositions) ? _vm._i(_vm.formData.selectedPositions, "Tester") > -1 : (_vm.formData.selectedPositions)
	    },
	    on: {
	      "__c": function($event) {
	        var $$a = _vm.formData.selectedPositions,
	          $$el = $event.target,
	          $$c = $$el.checked ? (true) : (false);
	        if (Array.isArray($$a)) {
	          var $$v = "Tester",
	            $$i = _vm._i($$a, $$v);
	          if ($$el.checked) {
	            $$i < 0 && (_vm.formData.selectedPositions = $$a.concat($$v))
	          } else {
	            $$i > -1 && (_vm.formData.selectedPositions = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
	          }
	        } else {
	          _vm.formData.selectedPositions = $$c
	        }
	      }
	    }
	  }), _c('span', [_vm._v("Tester")])])])]), _vm._v(" "), (_vm.formErrors.length > 0) ? _c('div', {
	    staticClass: "validation-messages error"
	  }, _vm._l((_vm.formErrors), function(error) {
	    return _c('span', [_vm._v(_vm._s(error))])
	  })) : _vm._e(), _vm._v(" "), (_vm.isSaving) ? _c('saver-large') : _vm._e(), _vm._v(" "), (!_vm.isSaving) ? _c('div', {
	    staticClass: "button-container"
	  }, [_c('button', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.submitRequest($event)
	      }
	    }
	  }, [_vm._v("Send Request")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.gameFound || !_vm.isLoggedIn) ? _c('div', [_c('h2', [_vm._v("Error")]), _vm._v(" "), (!_vm.gameFound && _vm.isLoggedIn) ? _c('span', [_vm._v("Game Project Not found")]) : _vm._e(), _vm._v(" "), (!_vm.isLoggedIn) ? _c('span', [_vm._v("You must be logged in to do this")]) : _vm._e()]) : _vm._e()] : _vm._e()], 2)])
	},staticRenderFns: []}

/***/ }),
/* 918 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "sub-nav-container"
	    }
	  }, [_c('nav', {
	    attrs: {
	      "id": "sub-nav"
	    }
	  }, [_c('div', {
	    staticClass: "container"
	  }, _vm._l((_vm.links), function(link) {
	    return _c('router-link', {
	      class: [{
	        selected: link.selected
	      }, link.style],
	      attrs: {
	        "to": link.to,
	        "title": link.text
	      }
	    }, [_c('span', {
	      staticClass: "label"
	    }, [_vm._v(_vm._s(link.text))]), _vm._v(" "), (_vm.isLoggedIn && link.showBadge && !link.selected) ? _c('span', {
	      staticClass: "badge"
	    }, [_c('i', {
	      staticClass: "fas fa-circle"
	    })]) : _vm._e()])
	  }))])])
	},staticRenderFns: []}

/***/ }),
/* 919 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('article', {
	    attrs: {
	      "id": "invites-page"
	    }
	  }, [(_vm.isLoading) ? _c('loader-large') : _vm._e(), _vm._v(" "), (_vm.noPendingInvitations) ? _c('section', {
	    staticClass: "validation-messages friendly"
	  }, [_vm._v("\n        You have no pending Invitations\n    ")]) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.invitationsToGames.length > 0) ? _c('section', {
	    staticClass: "invite-list"
	  }, [_c('h2', [_vm._v("Invitations to Game Projects")]), _vm._v(" "), _vm._l((_vm.invitationsToGames), function(invitation) {
	    return _c('invitation-to-game', {
	      attrs: {
	        "invitation": invitation
	      }
	    })
	  })], 2) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.requestsToJoin.length > 0) ? _c('section', {
	    staticClass: "invite-list"
	  }, [_c('h2', [_vm._v("Requests to Join your Game Projects")]), _vm._v(" "), _vm._l((_vm.requestsToJoin), function(request) {
	    return _c('request-to-join', {
	      attrs: {
	        "request": request
	      }
	    })
	  })], 2) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.sentInvitationsToGames.length > 0) ? _c('section', {
	    staticClass: "invite-list"
	  }, [_c('h2', [_vm._v("Sent Invitations to Game Projects")]), _vm._v(" "), _vm._l((_vm.sentInvitationsToGames), function(invitation) {
	    return _c('sent-invitation-to-game', {
	      attrs: {
	        "invitation": invitation
	      }
	    })
	  })], 2) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.sentRequestsToJoin.length > 0) ? _c('section', {
	    staticClass: "invite-list"
	  }, [_c('h2', [_vm._v("Sent Requests to Join Game Projects")]), _vm._v(" "), _vm._l((_vm.sentRequestsToJoin), function(request) {
	    return _c('sent-request-join', {
	      attrs: {
	        "request": request
	      }
	    })
	  })], 2) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),
/* 920 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('h1', [_vm._v("404 Page Not Found!")])
	},staticRenderFns: []}

/***/ }),
/* 921 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "connections",
	    attrs: {
	      "id": "developer-content-connections"
	    }
	  }, [(_vm.hasData) ? _c('section', {
	    staticClass: "panels"
	  }, [_c('section', {
	    staticClass: "panel"
	  }, [_c('h3', [_vm._v("Friends")]), _vm._v(" "), (_vm.profileConnections.friends && _vm.profileConnections.friends.length > 0) ? _c('ul', {
	    staticClass: "follows-list"
	  }, _vm._l((_vm.profileConnections.friends), function(friend) {
	    return _c('li', [_c('avatar', {
	      attrs: {
	        "profile-data": friend,
	        "profile-type": "developer",
	        "size": "small",
	        "show-xp-info": true
	      }
	    }), _vm._v(" "), _c('router-link', {
	      attrs: {
	        "to": ("/Developer/" + (friend.stringUrl))
	      }
	    }, [_vm._v(_vm._s(friend.alias))])], 1)
	  })) : _c('span', [_vm._v(_vm._s(_vm.profileAlias) + " hasn't made any friends yet")])]), _vm._v(" "), _c('section', {
	    staticClass: "panel"
	  }, [_c('h3', [_vm._v("Followers")]), _vm._v(" "), (_vm.profileConnections.followers && _vm.profileConnections.followers.length > 0) ? _c('ul', {
	    staticClass: "follows-list"
	  }, _vm._l((_vm.profileConnections.followers), function(follower) {
	    return _c('li', [_c('avatar', {
	      attrs: {
	        "profile-data": follower,
	        "profile-type": "developer",
	        "size": "small",
	        "show-xp-info": true
	      }
	    }), _vm._v(" "), _c('router-link', {
	      attrs: {
	        "to": ("/Developer/" + (follower.stringUrl))
	      }
	    }, [_vm._v(_vm._s(follower.alias))])], 1)
	  })) : _c('span', [_vm._v("No one is following " + _vm._s(_vm.profileAlias) + " yet.")])]), _vm._v(" "), _c('section', {
	    staticClass: "panel"
	  }, [_c('h3', [_vm._v("Following")]), _vm._v(" "), _c('nav', {
	    staticClass: "switcher-options"
	  }, [_c('ul', [_c('li', {
	    class: {
	      selected: _vm.selectedFollowingCategory === 'developers'
	    },
	    on: {
	      "click": function($event) {
	        _vm.switchSelectedFollowingCategory('developers')
	      }
	    }
	  }, [_vm._v("Developers\n                    ")]), _vm._v(" "), _c('li', {
	    class: {
	      selected: _vm.selectedFollowingCategory === 'games'
	    },
	    on: {
	      "click": function($event) {
	        _vm.switchSelectedFollowingCategory('games')
	      }
	    }
	  }, [_vm._v("Games\n                    ")])])]), _vm._v(" "), (_vm.selectedFollowingCategory === 'developers') ? _c('section', {
	    staticClass: "switcher-panel",
	    staticStyle: {
	      "display": "block"
	    }
	  }, [(_vm.profileConnections.followingDevelopers && _vm.profileConnections.followingDevelopers.length > 0) ? _c('ul', {
	    staticClass: "follows-list"
	  }, _vm._l((_vm.profileConnections.followingDevelopers), function(developer) {
	    return _c('li', [_c('avatar', {
	      attrs: {
	        "profile-data": developer,
	        "profile-type": "developer",
	        "size": "small",
	        "show-xp-info": true
	      }
	    }), _vm._v(" "), _c('router-link', {
	      attrs: {
	        "to": ("/Developer/" + (developer.stringUrl))
	      }
	    }, [_vm._v(_vm._s(developer.alias))])], 1)
	  })) : _c('span', [_vm._v(_vm._s(_vm.profileAlias) + " is not following any other Developers yet.")])]) : _vm._e(), _vm._v(" "), (_vm.selectedFollowingCategory === 'games') ? _c('section', {
	    staticClass: "switcher-panel",
	    staticStyle: {
	      "display": "block"
	    }
	  }, [(_vm.profileConnections.followingGames && _vm.profileConnections.followingGames.length > 0) ? _c('ul', {
	    staticClass: "follows-list"
	  }, _vm._l((_vm.profileConnections.followingGames), function(game) {
	    return _c('li', [_c('avatar', {
	      attrs: {
	        "profile-data": game,
	        "profile-type": "game",
	        "size": "small",
	        "show-xp-info": true
	      }
	    }), _vm._v(" "), _c('router-link', {
	      attrs: {
	        "to": ("/Game/" + (game.stringUrl))
	      }
	    }, [_vm._v(_vm._s(game.alias))])], 1)
	  })) : _c('span', [_vm._v(_vm._s(_vm.profileAlias) + " is not following any Game Projects yet.")])]) : _vm._e()])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),
/* 922 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('footer', {
	    attrs: {
	      "id": "site-footer"
	    }
	  }, [_c('div', {
	    staticClass: "site-links"
	  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('span', [_c('router-link', {
	    attrs: {
	      "to": "/TermsAndConditions"
	    }
	  }, [_vm._v("Terms")])], 1), _vm._v(" "), _c('span', [_c('router-link', {
	    attrs: {
	      "to": "/PrivacyPolicy"
	    }
	  }, [_vm._v("Privacy")])], 1)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('a', {
	    attrs: {
	      "href": "https://www.stormgardenstudio.com",
	      "target": "_blank"
	    }
	  }, [_vm._v("Copyright © 2020 Storm Garden Studio")])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('a', {
	    attrs: {
	      "href": "https://www.facebook.com/Develteam/"
	    }
	  }, [_c('i', {
	    staticClass: "fab fa-facebook"
	  })])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('span', [_c('a', {
	    attrs: {
	      "href": "https://twitter.com/Develteam"
	    }
	  }, [_c('i', {
	    staticClass: "fab fa-twitter"
	  })])])
	}]}

/***/ }),
/* 923 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "loading large"
	  }, [_c('i', {
	    staticClass: "fas fa-sync fa-spin"
	  }), _vm._v(" "), _c('p', [_vm._v("Loading")])])
	}]}

/***/ }),
/* 924 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('article', {
	    attrs: {
	      "id": "browse-page"
	    }
	  }, [(_vm.pageId === 'games' && _vm.isLoggedIn) ? _c('div', {
	    staticClass: "option-row"
	  }, [_c('router-link', {
	    staticClass: "button",
	    attrs: {
	      "to": "/CreateNewGameProject"
	    }
	  }, [_vm._v("Create a Game Project")])], 1) : _vm._e(), _vm._v(" "), _c('section', {
	    attrs: {
	      "id": "browse-results"
	    }
	  }, [(_vm.filterControls) ? _c('section', {
	    attrs: {
	      "id": "browse-filter-controls"
	    }
	  }, [(_vm.filterControls.showOptions.length > 0) ? _c('div', {
	    staticClass: "filter-control"
	  }, [_c('label', [_vm._v("Show")]), _vm._v(" "), _c('ul', _vm._l((_vm.filterControls.showOptions), function(option) {
	    return _c('li', {
	      class: {
	        selected: option.selected
	      },
	      on: {
	        "click": function($event) {
	          _vm.setOption(option.id)
	        }
	      }
	    }, [_vm._v("\n                        " + _vm._s(option.label) + "\n                    ")])
	  }))]) : _vm._e(), _vm._v(" "), (_vm.filterControls.filterOptions.length > 0) ? _c('div', {
	    staticClass: "filter-control"
	  }, [_c('label', [_vm._v("Filter By")]), _vm._v(" "), _c('ul', _vm._l((_vm.filterControls.filterOptions), function(option) {
	    return _c('li', {
	      class: {
	        selected: option.selected
	      },
	      on: {
	        "click": function($event) {
	          _vm.setOption(option.id)
	        }
	      }
	    }, [_vm._v("\n                        " + _vm._s(option.label) + "\n                    ")])
	  }))]) : _vm._e(), _vm._v(" "), (_vm.showRecruitingOptions && _vm.filterControls.recruitingOptions.length > 0) ? _c('div', {
	    staticClass: "filter-control"
	  }, [_c('label', [_vm._v("Recruiting")]), _vm._v(" "), _c('ul', _vm._l((_vm.filterControls.recruitingOptions), function(option) {
	    return _c('li', {
	      class: {
	        selected: option.selected
	      },
	      on: {
	        "click": function($event) {
	          _vm.setOption(option.id)
	        }
	      }
	    }, [_vm._v("\n                        " + _vm._s(option.label) + "\n                    ")])
	  }))]) : _vm._e(), _vm._v(" "), (_vm.filterControls.sortOptions.length > 0) ? _c('div', {
	    staticClass: "filter-control"
	  }, [_c('label', [_vm._v("Sort By")]), _vm._v(" "), _c('ul', _vm._l((_vm.filterControls.sortOptions), function(option) {
	    return _c('li', {
	      class: {
	        selected: option.selected
	      },
	      on: {
	        "click": function($event) {
	          _vm.setOption(option.id)
	        }
	      }
	    }, [_vm._v("\n                        " + _vm._s(option.label) + "\n                    ")])
	  }))]) : _vm._e(), _vm._v(" "), (_vm.filterControls.showSkills) ? [(_vm.skillFilterId === 0) ? [_c('div', {
	    staticClass: "filter-control"
	  }, [_c('label', [_vm._v("Skill")]), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.enteredSkill),
	      expression: "enteredSkill"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "Search for Skill Tags..."
	    },
	    domProps: {
	      "value": (_vm.enteredSkill)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.enteredSkill = $event.target.value
	      }
	    }
	  }), _vm._v(" "), (_vm.enteredSkill.length > 0) ? _c('button', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        _vm.enteredSkill = ''
	      }
	    }
	  }, [_vm._v("X")]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "filter-control"
	  }, [(_vm.matchingSkills.length === 0) ? _c('span', [_vm._v("\n                            No matching tags... Search by skill name, or type a category\n                            to see all entries. Categories: Art, Software, Development, Engine, Writing, Production, Testing\n                        ")]) : _vm._e(), _vm._v(" "), _c('ul', {
	    staticClass: "skills"
	  }, _vm._l((_vm.matchingSkills), function(skill) {
	    return _c('li', {
	      on: {
	        "click": function($event) {
	          _vm.setSkillId(skill.id)
	        }
	      }
	    }, [_vm._v("\n                                " + _vm._s(skill.skill) + "\n                            ")])
	  }))])] : _vm._e(), _vm._v(" "), (_vm.skillFilterId > 0) ? [_c('div', {
	    staticClass: "filter-control"
	  }, [_c('label', [_vm._v("Skill")]), _vm._v(" "), _c('ul', {
	    staticClass: "skills"
	  }, [_c('li', {
	    staticClass: "selected",
	    on: {
	      "click": function($event) {
	        _vm.setSkillId(0)
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-minus-circle"
	  }), _vm._v(_vm._s(_vm.skillList[_vm.skillFilterId].skill) + "\n                            ")])])])] : _vm._e()] : _vm._e()], 2) : _vm._e(), _vm._v(" "), (_vm.browseResults.length > 0 && !_vm.isFetching) ? _c('section', {
	    staticClass: "pagination",
	    attrs: {
	      "id": "browse-pagination-top"
	    }
	  }, [_c('label', [_vm._v("page")]), _vm._v(" "), _c('pagination', {
	    attrs: {
	      "max-page": _vm.resultsPageTotal,
	      "current-page": _vm.resultsPageCurrent,
	      "spread": 5
	    },
	    on: {
	      "switchToPage": _vm.switchToResultsPage
	    }
	  })], 1) : _vm._e(), _vm._v(" "), _c('section', {
	    attrs: {
	      "id": "browse-items"
	    }
	  }, [(_vm.isFetching) ? _c('div', [_c('loader-large')], 1) : _vm._e(), _vm._v(" "), (!_vm.isFetching) ? _c('div', [(_vm.browseResults.length > 0) ? [_vm._l((_vm.browseResults), function(result) {
	    return (_vm.pageId === 'developers') ? _c('browsePageDeveloperItem', {
	      attrs: {
	        "details": result
	      }
	    }) : _vm._e()
	  }), _vm._v(" "), _vm._l((_vm.browseResults), function(result) {
	    return (_vm.pageId === 'games') ? _c('browsePageGameItem', {
	      attrs: {
	        "details": result
	      }
	    }) : _vm._e()
	  })] : _vm._e(), _vm._v(" "), (_vm.browseResults.length === 0) ? [_c('div', {
	    staticClass: "validation-messages friendly"
	  }, [_vm._v("\n                        Sorry, no matching results were found.\n                        "), (_vm.pageId === 'games') ? [_vm._v("Skill tags are still new for Game Projects. Try removing the\n                            Skill filter.\n                        ")] : _vm._e()], 2)] : _vm._e()], 2) : _vm._e()]), _vm._v(" "), (_vm.browseResults.length > 0 && !_vm.isFetching) ? _c('section', {
	    staticClass: "pagination",
	    attrs: {
	      "id": "browse-pagination-bottom"
	    }
	  }, [_c('label', [_vm._v("page")]), _vm._v(" "), _c('pagination', {
	    attrs: {
	      "max-page": _vm.resultsPageTotal,
	      "current-page": _vm.resultsPageCurrent,
	      "spread": 5
	    },
	    on: {
	      "switchToPage": _vm.switchToResultsPage
	    }
	  })], 1) : _vm._e()])])
	},staticRenderFns: []}

/***/ }),
/* 925 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('section', {
	    staticClass: "request"
	  }, [(_vm.isSaving) ? _c('saver-large') : _vm._e(), _vm._v(" "), (!_vm.isSaving && !_vm.serverResponse) ? [_c('div', {
	    staticClass: "avatar-container"
	  }, [_c('avatar', {
	    attrs: {
	      "profile-data": _vm.request.gameDetails,
	      "profile-type": "game",
	      "size": "large",
	      "show-xp-info": false
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "details"
	  }, [_c('span', [_vm._v("\n                Requested to Join\n                "), _c('router-link', {
	    attrs: {
	      "to": ("/Game/" + (_vm.request.gameDetails.stringUrl))
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-gamepad"
	  }), _vm._v(" " + _vm._s(_vm.request.gameDetails.alias))])], 1), _vm._v(" "), _c('span', [_vm._v("Requesting to be "), _c('span', {
	    staticClass: "position-titles"
	  }, [_vm._v(_vm._s(_vm.request.positionTitles))])]), _vm._v(" "), _c('ul', _vm._l((_vm.request.positions), function(position) {
	    return _c('li', [_vm._v(_vm._s(position))])
	  })), _vm._v(" "), (_vm.request.response === 'noResponse') ? _c('span', [_vm._v("Request is pending.")]) : _vm._e(), _vm._v(" "), (_vm.request.response === 'accept') ? _c('span', [_vm._v("Your Request has been Accepted!")]) : _vm._e(), _vm._v(" "), (_vm.request.response === 'decline') ? _c('span', [_vm._v("Your Request has been Declined.")]) : _vm._e(), _vm._v(" "), (_vm.request.response === 'noResponse') ? _c('button', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.deleteRequest('retract')
	      }
	    }
	  }, [_vm._v("Retract Request")]) : _vm._e(), _vm._v(" "), (_vm.request.response !== 'noResponse') ? _c('button', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.deleteRequest('dismiss')
	      }
	    }
	  }, [_vm._v("Dismiss")]) : _vm._e(), _vm._v(" "), (_vm.request.response === 'noResponse') ? _c('router-link', {
	    staticClass: "button",
	    attrs: {
	      "tag": "button",
	      "to": ("/Inbox/Compose?toId=" + (_vm.request.devDetails.id) + "&toAlias=" + (_vm.request.devDetails.alias))
	    }
	  }, [_vm._v("\n                Contact Game Project Owner\n            ")]) : _vm._e(), _vm._v(" "), (_vm.formErrors.length > 0) ? _c('div', {
	    staticClass: "validation-messages error"
	  }, _vm._l((_vm.formErrors), function(error) {
	    return _c('span', [_vm._v(_vm._s(error))])
	  })) : _vm._e()], 1)] : _vm._e(), _vm._v(" "), (_vm.serverResponse) ? [_c('div', {
	    staticClass: "validation-messages friendly"
	  }, [_vm._v(_vm._s(_vm.serverResponse))])] : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 926 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('article', {
	    attrs: {
	      "id": "private-chat"
	    }
	  }, [(!_vm.newConversationMode) ? [_c('h2', [_vm._v("Conversations")]), _vm._v(" "), _c('ul', {
	    class: [{
	      'shrunk': _vm.selectedConversation
	    }],
	    attrs: {
	      "id": "private-chat-conversations"
	    }
	  }, _vm._l((_vm.conversations), function(conversation) {
	    return _c('li', {
	      class: [{
	        'selected': _vm.selectedConversation && _vm.selectedConversation.chatId === conversation.chatId
	      }],
	      on: {
	        "click": function($event) {
	          _vm.selectConversation(conversation)
	        }
	      }
	    }, [_c('span', {
	      staticClass: "partner-alias"
	    }, [(_vm.showNotification(conversation)) ? _c('i', {
	      staticClass: "fas fa-bell new-message-notification"
	    }) : _vm._e(), _vm._v("\n                    " + _vm._s(conversation.partnerAlias) + "\n                ")]), _vm._v(" "), _c('span', {
	      staticClass: "timestamp"
	    }, [_vm._v(_vm._s(_vm._f("formatDateWithoutTime")(conversation.lastMessageTime)))])])
	  })), _vm._v(" "), (_vm.selectedConversation) ? _c('h2', {
	    attrs: {
	      "id": "private-chat-conversation-header"
	    }
	  }, [_vm._v("Chat with " + _vm._s(_vm.selectedConversation.partnerAlias))]) : _vm._e(), _vm._v(" "), (_vm.selectedConversation && _vm.showingHistoryDates) ? [_c('ul', {
	    attrs: {
	      "id": "private-chat-history-dates"
	    }
	  }, _vm._l((_vm.historyDates), function(historyDate) {
	    return _c('li', {
	      staticClass: "history-date-item",
	      on: {
	        "click": function($event) {
	          _vm.selectHistoryDate(historyDate)
	        }
	      }
	    }, [_c('span', [_vm._v(_vm._s(historyDate.messageCount))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("formatDateWithoutTime")(historyDate.day)))])])
	  }))] : _vm._e(), _vm._v(" "), (_vm.selectedConversation && !_vm.showingHistoryDates) ? [(_vm.selectedHistoryDate) ? _c('span', {
	    attrs: {
	      "id": "private-chat-history-header"
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-fw fa-arrow-left",
	    on: {
	      "click": _vm.showHistoryDates
	    }
	  }), _vm._v("\n            History: " + _vm._s(_vm._f("formatDateWithoutTime")(_vm.selectedHistoryDate.day)) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('ul', {
	    ref: "chatMessages",
	    attrs: {
	      "id": "private-chat-messages"
	    }
	  }, _vm._l((_vm.messages), function(message) {
	    return _c('li', [_c('div', {
	      staticClass: "avatar-container"
	    }, [_c('avatar', {
	      attrs: {
	        "profile-data": message.from,
	        "profile-type": "developer",
	        "size": "very-small",
	        "show-xp-info": false
	      }
	    })], 1), _vm._v(" "), _c('div', {
	      staticClass: "message-details"
	    }, [_c('span', {
	      staticClass: "message-from"
	    }, [_c('router-link', {
	      attrs: {
	        "to": '/Developer/' + message.from.stringUrl
	      }
	    }, [_vm._v(_vm._s(message.from.alias))])], 1), _vm._v(" "), _vm._l((message.messages), function(individualMessage) {
	      return _c('div', {
	        staticClass: "individual-message"
	      }, [_c('markdown-content', {
	        attrs: {
	          "classes": "message-message",
	          "content": individualMessage.message
	        }
	      }), _vm._v(" "), _c('span', {
	        staticClass: "message-date"
	      }, [_vm._v(_vm._s(_vm._f("formatDateCondensed")(message.timestamp)))])], 1)
	    })], 2)])
	  }))] : _vm._e(), _vm._v(" "), (_vm.selectedConversation) ? _c('div', {
	    attrs: {
	      "id": "private-chat-options"
	    }
	  }, [_c('div', {
	    class: ['option', {
	      selected: _vm.showingHistoryDates || _vm.showingHistoryDateMessages
	    }],
	    attrs: {
	      "title": "History"
	    },
	    on: {
	      "click": _vm.toggleHistoryDates
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-fw fa-history"
	  })]), _vm._v(" "), (_vm.audioNotificationsEnabled) ? _c('div', {
	    staticClass: "option",
	    attrs: {
	      "title": "Turn off Audio Notifications"
	    },
	    on: {
	      "click": function($event) {
	        _vm.toggleAudioNotifications('off')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-fw fa-volume-up"
	  })]) : _vm._e(), _vm._v(" "), (!_vm.audioNotificationsEnabled) ? _c('div', {
	    staticClass: "option",
	    attrs: {
	      "title": "Turn on Audio Notifications"
	    },
	    on: {
	      "click": function($event) {
	        _vm.toggleAudioNotifications('on')
	      }
	    }
	  }, [_c('i', {
	    staticClass: "fas fa-fw fa-volume-off"
	  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.selectedConversation && !_vm.showingHistoryDates && !_vm.showingHistoryDateMessages) ? _c('form', {
	    attrs: {
	      "id": "private-chat-input"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newMessage),
	      expression: "newMessage"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "Type to chat...",
	      "maxlength": "450"
	    },
	    domProps: {
	      "value": (_vm.newMessage)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newMessage = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('input', {
	    attrs: {
	      "type": "submit",
	      "value": "Send"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.sendMessage($event)
	      }
	    }
	  })]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.newConversationMode) ? [_c('h2', {
	    attrs: {
	      "id": "private-chat-conversation-header-new-conversation"
	    }
	  }, [_vm._v("Chat with " + _vm._s(_vm.newConversationAlias))]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "private-chat-messages-new-conversation"
	    }
	  }), _vm._v(" "), _c('form', {
	    attrs: {
	      "id": "private-chat-input-new-conversation"
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.newMessage),
	      expression: "newMessage"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "Type to chat...",
	      "maxlength": "450"
	    },
	    domProps: {
	      "value": (_vm.newMessage)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.newMessage = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('input', {
	    attrs: {
	      "type": "submit",
	      "value": "Send"
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.sendNewConversationMessage($event)
	      }
	    }
	  })])] : _vm._e()], 2)
	},staticRenderFns: []}

/***/ }),
/* 927 */
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('article', {
	    attrs: {
	      "id": "bugs-and-suggestions"
	    }
	  }, [_c('div', {
	    staticClass: "button-container"
	  }, [(_vm.isLoggedIn && !_vm.showSubmitForm && !_vm.showThankYouForm) ? _c('button', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.showSubmitForm = true
	      }
	    }
	  }, [_vm._v("Submit a Bug or Suggestion")]) : _vm._e()]), _vm._v(" "), (_vm.isLoggedIn && _vm.showSubmitForm && !_vm.showThankYouForm) ? _c('section', {
	    attrs: {
	      "id": "submit-work-item"
	    }
	  }, [_c('h2', [_vm._v("Submit a Bug or Suggestion")]), _vm._v(" "), (_vm.submitFormErrors.length > 0) ? _c('div', {
	    staticClass: "validation-messages error"
	  }, _vm._l((_vm.submitFormErrors), function(error) {
	    return _c('span', [_vm._v(_vm._s(error))])
	  })) : _vm._e(), _vm._v(" "), _c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.submitTitle),
	      expression: "submitTitle"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "Title",
	      "disable": _vm.submitIsSaving
	    },
	    domProps: {
	      "value": (_vm.submitTitle)
	    },
	    on: {
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.submitTitle = $event.target.value
	      }, function($event) {
	        _vm.submitFormErrors = []
	      }]
	    }
	  }), _vm._v(" "), _c('markdown-editor', {
	    attrs: {
	      "placeholder": "Description",
	      "disable": _vm.submitIsSaving
	    },
	    model: {
	      value: (_vm.submitDescription),
	      callback: function($$v) {
	        _vm.submitDescription = $$v
	      },
	      expression: "submitDescription"
	    }
	  }), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.submitType),
	      expression: "submitType"
	    }],
	    attrs: {
	      "disable": _vm.submitIsSaving
	    },
	    on: {
	      "change": function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.submitType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "bug"
	    }
	  }, [_vm._v("Bug")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "suggestion"
	    }
	  }, [_vm._v("Suggestion")])]), _vm._v(" "), _c('button', {
	    staticClass: "button minor",
	    attrs: {
	      "disable": _vm.submitIsSaving
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.showSubmitForm = false
	      }
	    }
	  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
	    staticClass: "button",
	    attrs: {
	      "disable": _vm.submitIsSaving
	    },
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.submitWorkItem($event)
	      }
	    }
	  }, [_vm._v("Submit")])], 1) : _vm._e(), _vm._v(" "), (_vm.showThankYouForm) ? _c('section', {
	    attrs: {
	      "id": "submit-thank-you"
	    }
	  }, [_c('h1', [_vm._v("Thank you for your Submission!")]), _vm._v(" "), _c('div', {
	    staticClass: "button-container"
	  }, [_c('button', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.showSubmitForm = false;
	        _vm.showThankYouForm = false;
	      }
	    }
	  }, [_vm._v("Close")]), _vm._v(" "), _c('button', {
	    staticClass: "button",
	    on: {
	      "click": function($event) {
	        $event.preventDefault();
	        _vm.showSubmitForm = true;
	        _vm.showThankYouForm = false
	      }
	    }
	  }, [_vm._v("Submit Another")])])]) : _vm._e(), _vm._v(" "), _c('section', {
	    attrs: {
	      "id": "task-board"
	    }
	  }, [_c('section', {
	    attrs: {
	      "id": "bugs"
	    }
	  }, [_c('h1', [_vm._v("Bugs")]), _vm._v(" "), _vm._l((_vm.bugs), function(item) {
	    return _c('div', [_c('h3', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('markdown-content', {
	      staticClass: "description",
	      attrs: {
	        "content": item.description
	      }
	    }), _vm._v(" "), _c('span', [_vm._v("Submitted By: "), _c('router-link', {
	      attrs: {
	        "to": ("/Developer/" + (item.poster.stringUrl))
	      }
	    }, [_vm._v(_vm._s(item.poster.alias))])], 1), _vm._v(" "), (_vm.isModerator) ? [_c('span', {
	      staticClass: "mod-controls"
	    }, [_vm._v("\n                        Move to:\n                        "), _c('span', {
	      on: {
	        "click": function($event) {
	          _vm.moveTo(item, 'inProgress')
	        }
	      }
	    }, [_vm._v("In-Progress")])])] : _vm._e()], 2)
	  })], 2), _vm._v(" "), _c('section', {
	    attrs: {
	      "id": "suggestions"
	    }
	  }, [_c('h1', [_vm._v("Suggestions")]), _vm._v(" "), _vm._l((_vm.suggestions), function(item) {
	    return _c('div', [_c('h3', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('markdown-content', {
	      staticClass: "description",
	      attrs: {
	        "content": item.description
	      }
	    }), _vm._v(" "), _c('span', [_vm._v("Submitted By: "), _c('router-link', {
	      attrs: {
	        "to": ("/Developer/" + (item.poster.stringUrl))
	      }
	    }, [_vm._v(_vm._s(item.poster.alias))])], 1), _vm._v(" "), (_vm.isModerator) ? [_c('span', {
	      staticClass: "mod-controls"
	    }, [_vm._v("\n                        Move to:\n                        "), _c('span', {
	      on: {
	        "click": function($event) {
	          _vm.moveTo(item, 'inProgress')
	        }
	      }
	    }, [_vm._v("In-Progress")])])] : _vm._e()], 2)
	  })], 2), _vm._v(" "), _c('section', {
	    attrs: {
	      "id": "in-progress"
	    }
	  }, [_c('h1', [_vm._v("In-Progress")]), _vm._v(" "), _vm._l((_vm.inProgress), function(item) {
	    return _c('div', [_c('h3', [_vm._v("[" + _vm._s(item.type) + "] " + _vm._s(item.title))]), _vm._v(" "), _c('markdown-content', {
	      staticClass: "description",
	      attrs: {
	        "content": item.description
	      }
	    }), _vm._v(" "), _c('span', [_vm._v("Submitted By: "), _c('router-link', {
	      attrs: {
	        "to": ("/Developer/" + (item.poster.stringUrl))
	      }
	    }, [_vm._v(_vm._s(item.poster.alias))])], 1), _vm._v(" "), (_vm.isModerator) ? [_c('span', {
	      staticClass: "mod-controls"
	    }, [_vm._v("\n                        Move to:\n                        "), _c('span', {
	      on: {
	        "click": function($event) {
	          _vm.moveTo(item, 'done')
	        }
	      }
	    }, [_vm._v("Done")]), _vm._v("\n                        |\n                        "), _c('span', {
	      on: {
	        "click": function($event) {
	          _vm.moveTo(item, 'backlog')
	        }
	      }
	    }, [_vm._v("Backlog")])])] : _vm._e()], 2)
	  })], 2), _vm._v(" "), _c('section', {
	    attrs: {
	      "id": "done"
	    }
	  }, [_c('h1', [_vm._v("Done")]), _vm._v(" "), _vm._l((_vm.done), function(item) {
	    return _c('div', [_c('h3', [_vm._v("[" + _vm._s(item.type) + "] " + _vm._s(item.title))]), _vm._v(" "), (item.description) ? _c('div', [_vm._v(_vm._s(item.description))]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("Submitted By: "), _c('router-link', {
	      attrs: {
	        "to": ("/Developer/" + (item.poster.stringUrl))
	      }
	    }, [_vm._v(_vm._s(item.poster.alias))])], 1), _vm._v(" "), (_vm.isModerator) ? [_c('span', {
	      staticClass: "mod-controls"
	    }, [_vm._v("\n                        Move to:\n                        "), _c('span', {
	      on: {
	        "click": function($event) {
	          _vm.moveTo(item, 'inProgress')
	        }
	      }
	    }, [_vm._v("In-Progress")]), _vm._v("\n                        |\n                        "), _c('span', {
	      on: {
	        "click": function($event) {
	          _vm.moveTo(item, 'backlog')
	        }
	      }
	    }, [_vm._v("Backlog")])])] : _vm._e()], 2)
	  })], 2)])])
	},staticRenderFns: []}

/***/ }),
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 934 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 935 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 936 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })
]);


// WEBPACK FOOTER //
// src/js/app.fb43d57adc092008ff74.js